/*! jQuery v3.7.1 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(ie,e){"use strict";var oe=[],r=Object.getPrototypeOf,ae=oe.slice,g=oe.flat?function(e){return oe.flat.call(e)}:function(e){return oe.concat.apply([],e)},s=oe.push,se=oe.indexOf,n={},i=n.toString,ue=n.hasOwnProperty,o=ue.toString,a=o.call(Object),le={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function(e){return null!=e&&e===e.window},C=ie.document,u={type:!0,src:!0,nonce:!0,noModule:!0};function m(e,t,n){var r,i,o=(n=n||C).createElement("script");if(o.text=e,t)for(r in u)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[i.call(e)]||"object":typeof e}var t="3.7.1",l=/HTML$/i,ce=function(e,t){return new ce.fn.init(e,t)};function c(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!v(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}function fe(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}ce.fn=ce.prototype={jquery:t,constructor:ce,length:0,toArray:function(){return ae.call(this)},get:function(e){return null==e?ae.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=ce.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return ce.each(this,e)},map:function(n){return this.pushStack(ce.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(ae.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(ce.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(ce.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:oe.sort,splice:oe.splice},ce.extend=ce.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||v(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(ce.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||ce.isPlainObject(n)?n:{},i=!1,a[t]=ce.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},ce.extend({expando:"jQuery"+(t+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==i.call(e))&&(!(t=r(e))||"function"==typeof(n=ue.call(t,"constructor")&&t.constructor)&&o.call(n)===a)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){m(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(c(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},text:function(e){var t,n="",r=0,i=e.nodeType;if(!i)while(t=e[r++])n+=ce.text(t);return 1===i||11===i?e.textContent:9===i?e.documentElement.textContent:3===i||4===i?e.nodeValue:n},makeArray:function(e,t){var n=t||[];return null!=e&&(c(Object(e))?ce.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:se.call(t,e,n)},isXMLDoc:function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!l.test(t||n&&n.nodeName||"HTML")},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(c(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:le}),"function"==typeof Symbol&&(ce.fn[Symbol.iterator]=oe[Symbol.iterator]),ce.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var pe=oe.pop,de=oe.sort,he=oe.splice,ge="[\\x20\\t\\r\\n\\f]",ve=new RegExp("^"+ge+"+|((?:^|[^\\\\])(?:\\\\.)*)"+ge+"+$","g");ce.contains=function(e,t){var n=t&&t.parentNode;return e===n||!(!n||1!==n.nodeType||!(e.contains?e.contains(n):e.compareDocumentPosition&&16&e.compareDocumentPosition(n)))};var f=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;function p(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e}ce.escapeSelector=function(e){return(e+"").replace(f,p)};var ye=C,me=s;!function(){var e,b,w,o,a,T,r,C,d,i,k=me,S=ce.expando,E=0,n=0,s=W(),c=W(),u=W(),h=W(),l=function(e,t){return e===t&&(a=!0),0},f="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",t="(?:\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",p="\\["+ge+"*("+t+")(?:"+ge+"*([*^$|!~]?=)"+ge+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+t+"))|)"+ge+"*\\]",g=":("+t+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+p+")*)|.*)\\)|)",v=new RegExp(ge+"+","g"),y=new RegExp("^"+ge+"*,"+ge+"*"),m=new RegExp("^"+ge+"*([>+~]|"+ge+")"+ge+"*"),x=new RegExp(ge+"|>"),j=new RegExp(g),A=new RegExp("^"+t+"$"),D={ID:new RegExp("^#("+t+")"),CLASS:new RegExp("^\\.("+t+")"),TAG:new RegExp("^("+t+"|[*])"),ATTR:new RegExp("^"+p),PSEUDO:new RegExp("^"+g),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+ge+"*(even|odd|(([+-]|)(\\d*)n|)"+ge+"*(?:([+-]|)"+ge+"*(\\d+)|))"+ge+"*\\)|)","i"),bool:new RegExp("^(?:"+f+")$","i"),needsContext:new RegExp("^"+ge+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+ge+"*((?:-\\d)?\\d*)"+ge+"*\\)|)(?=[^-]|$)","i")},N=/^(?:input|select|textarea|button)$/i,q=/^h\d$/i,L=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,H=/[+~]/,O=new RegExp("\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\([^\\r\\n\\f])","g"),P=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},M=function(){V()},R=J(function(e){return!0===e.disabled&&fe(e,"fieldset")},{dir:"parentNode",next:"legend"});try{k.apply(oe=ae.call(ye.childNodes),ye.childNodes),oe[ye.childNodes.length].nodeType}catch(e){k={apply:function(e,t){me.apply(e,ae.call(t))},call:function(e){me.apply(e,ae.call(arguments,1))}}}function I(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(V(e),e=e||T,C)){if(11!==p&&(u=L.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return k.call(n,a),n}else if(f&&(a=f.getElementById(i))&&I.contains(e,a)&&a.id===i)return k.call(n,a),n}else{if(u[2])return k.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&e.getElementsByClassName)return k.apply(n,e.getElementsByClassName(i)),n}if(!(h[t+" "]||d&&d.test(t))){if(c=t,f=e,1===p&&(x.test(t)||m.test(t))){(f=H.test(t)&&U(e.parentNode)||e)==e&&le.scope||((s=e.getAttribute("id"))?s=ce.escapeSelector(s):e.setAttribute("id",s=S)),o=(l=Y(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+Q(l[o]);c=l.join(",")}try{return k.apply(n,f.querySelectorAll(c)),n}catch(e){h(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return re(t.replace(ve,"$1"),e,n,r)}function W(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function F(e){return e[S]=!0,e}function $(e){var t=T.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function B(t){return function(e){return fe(e,"input")&&e.type===t}}function _(t){return function(e){return(fe(e,"input")||fe(e,"button"))&&e.type===t}}function z(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&R(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function X(a){return F(function(o){return o=+o,F(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function U(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}function V(e){var t,n=e?e.ownerDocument||e:ye;return n!=T&&9===n.nodeType&&n.documentElement&&(r=(T=n).documentElement,C=!ce.isXMLDoc(T),i=r.matches||r.webkitMatchesSelector||r.msMatchesSelector,r.msMatchesSelector&&ye!=T&&(t=T.defaultView)&&t.top!==t&&t.addEventListener("unload",M),le.getById=$(function(e){return r.appendChild(e).id=ce.expando,!T.getElementsByName||!T.getElementsByName(ce.expando).length}),le.disconnectedMatch=$(function(e){return i.call(e,"*")}),le.scope=$(function(){return T.querySelectorAll(":scope")}),le.cssHas=$(function(){try{return T.querySelector(":has(*,:jqfake)"),!1}catch(e){return!0}}),le.getById?(b.filter.ID=function(e){var t=e.replace(O,P);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(O,P);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):t.querySelectorAll(e)},b.find.CLASS=function(e,t){if("undefined"!=typeof t.getElementsByClassName&&C)return t.getElementsByClassName(e)},d=[],$(function(e){var t;r.appendChild(e).innerHTML="<a id='"+S+"' href='' disabled='disabled'></a><select id='"+S+"-\r\\' disabled='disabled'><option selected=''></option></select>",e.querySelectorAll("[selected]").length||d.push("\\["+ge+"*(?:value|"+f+")"),e.querySelectorAll("[id~="+S+"-]").length||d.push("~="),e.querySelectorAll("a#"+S+"+*").length||d.push(".#.+[+~]"),e.querySelectorAll(":checked").length||d.push(":checked"),(t=T.createElement("input")).setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),r.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&d.push(":enabled",":disabled"),(t=T.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||d.push("\\["+ge+"*name"+ge+"*="+ge+"*(?:''|\"\")")}),le.cssHas||d.push(":has"),d=d.length&&new RegExp(d.join("|")),l=function(e,t){if(e===t)return a=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!le.sortDetached&&t.compareDocumentPosition(e)===n?e===T||e.ownerDocument==ye&&I.contains(ye,e)?-1:t===T||t.ownerDocument==ye&&I.contains(ye,t)?1:o?se.call(o,e)-se.call(o,t):0:4&n?-1:1)}),T}for(e in I.matches=function(e,t){return I(e,null,null,t)},I.matchesSelector=function(e,t){if(V(e),C&&!h[t+" "]&&(!d||!d.test(t)))try{var n=i.call(e,t);if(n||le.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){h(t,!0)}return 0<I(t,T,null,[e]).length},I.contains=function(e,t){return(e.ownerDocument||e)!=T&&V(e),ce.contains(e,t)},I.attr=function(e,t){(e.ownerDocument||e)!=T&&V(e);var n=b.attrHandle[t.toLowerCase()],r=n&&ue.call(b.attrHandle,t.toLowerCase())?n(e,t,!C):void 0;return void 0!==r?r:e.getAttribute(t)},I.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ce.uniqueSort=function(e){var t,n=[],r=0,i=0;if(a=!le.sortStable,o=!le.sortStable&&ae.call(e,0),de.call(e,l),a){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)he.call(e,n[r],1)}return o=null,e},ce.fn.uniqueSort=function(){return this.pushStack(ce.uniqueSort(ae.apply(this)))},(b=ce.expr={cacheLength:50,createPseudo:F,match:D,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(O,P),e[3]=(e[3]||e[4]||e[5]||"").replace(O,P),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||I.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&I.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return D.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&j.test(n)&&(t=Y(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(O,P).toLowerCase();return"*"===e?function(){return!0}:function(e){return fe(e,t)}},CLASS:function(e){var t=s[e+" "];return t||(t=new RegExp("(^|"+ge+")"+e+"("+ge+"|$)"))&&s(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=I.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(v," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(d,e,t,h,g){var v="nth"!==d.slice(0,3),y="last"!==d.slice(-4),m="of-type"===e;return 1===h&&0===g?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u=v!==y?"nextSibling":"previousSibling",l=e.parentNode,c=m&&e.nodeName.toLowerCase(),f=!n&&!m,p=!1;if(l){if(v){while(u){o=e;while(o=o[u])if(m?fe(o,c):1===o.nodeType)return!1;s=u="only"===d&&!s&&"nextSibling"}return!0}if(s=[y?l.firstChild:l.lastChild],y&&f){p=(a=(r=(i=l[S]||(l[S]={}))[d]||[])[0]===E&&r[1])&&r[2],o=a&&l.childNodes[a];while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if(1===o.nodeType&&++p&&o===e){i[d]=[E,a,p];break}}else if(f&&(p=a=(r=(i=e[S]||(e[S]={}))[d]||[])[0]===E&&r[1]),!1===p)while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if((m?fe(o,c):1===o.nodeType)&&++p&&(f&&((i=o[S]||(o[S]={}))[d]=[E,p]),o===e))break;return(p-=g)===h||p%h==0&&0<=p/h}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||I.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?F(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=se.call(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:F(function(e){var r=[],i=[],s=ne(e.replace(ve,"$1"));return s[S]?F(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:F(function(t){return function(e){return 0<I(t,e).length}}),contains:F(function(t){return t=t.replace(O,P),function(e){return-1<(e.textContent||ce.text(e)).indexOf(t)}}),lang:F(function(n){return A.test(n||"")||I.error("unsupported lang: "+n),n=n.replace(O,P).toLowerCase(),function(e){var t;do{if(t=C?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=ie.location&&ie.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===r},focus:function(e){return e===function(){try{return T.activeElement}catch(e){}}()&&T.hasFocus()&&!!(e.type||e.href||~e.tabIndex)},enabled:z(!1),disabled:z(!0),checked:function(e){return fe(e,"input")&&!!e.checked||fe(e,"option")&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return q.test(e.nodeName)},input:function(e){return N.test(e.nodeName)},button:function(e){return fe(e,"input")&&"button"===e.type||fe(e,"button")},text:function(e){var t;return fe(e,"input")&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:X(function(){return[0]}),last:X(function(e,t){return[t-1]}),eq:X(function(e,t,n){return[n<0?n+t:n]}),even:X(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:X(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:X(function(e,t,n){var r;for(r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:X(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=B(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=_(e);function G(){}function Y(e,t){var n,r,i,o,a,s,u,l=c[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=y.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=m.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(ve," ")}),a=a.slice(n.length)),b.filter)!(r=D[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?I.error(e):c(e,s).slice(0)}function Q(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function J(a,e,t){var s=e.dir,u=e.next,l=u||s,c=t&&"parentNode"===l,f=n++;return e.first?function(e,t,n){while(e=e[s])if(1===e.nodeType||c)return a(e,t,n);return!1}:function(e,t,n){var r,i,o=[E,f];if(n){while(e=e[s])if((1===e.nodeType||c)&&a(e,t,n))return!0}else while(e=e[s])if(1===e.nodeType||c)if(i=e[S]||(e[S]={}),u&&fe(e,u))e=e[s]||e;else{if((r=i[l])&&r[0]===E&&r[1]===f)return o[2]=r[2];if((i[l]=o)[2]=a(e,t,n))return!0}return!1}}function K(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Z(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function ee(d,h,g,v,y,e){return v&&!v[S]&&(v=ee(v)),y&&!y[S]&&(y=ee(y,e)),F(function(e,t,n,r){var i,o,a,s,u=[],l=[],c=t.length,f=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)I(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),p=!d||!e&&h?f:Z(f,u,d,n,r);if(g?g(p,s=y||(e?d:c||v)?[]:t,n,r):s=p,v){i=Z(s,l),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(s[l[o]]=!(p[l[o]]=a))}if(e){if(y||d){if(y){i=[],o=s.length;while(o--)(a=s[o])&&i.push(p[o]=a);y(null,s=[],i,r)}o=s.length;while(o--)(a=s[o])&&-1<(i=y?se.call(e,a):u[o])&&(e[i]=!(t[i]=a))}}else s=Z(s===t?s.splice(c,s.length):s),y?y(null,t,s,r):k.apply(t,s)})}function te(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=J(function(e){return e===i},a,!0),l=J(function(e){return-1<se.call(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!=w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[J(K(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return ee(1<s&&K(c),1<s&&Q(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(ve,"$1"),t,s<n&&te(e.slice(s,n)),n<r&&te(e=e.slice(n)),n<r&&Q(e))}c.push(t)}return K(c)}function ne(e,t){var n,v,y,m,x,r,i=[],o=[],a=u[e+" "];if(!a){t||(t=Y(e)),n=t.length;while(n--)(a=te(t[n]))[S]?i.push(a):o.push(a);(a=u(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=E+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==T||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==T||(V(o),n=!C);while(s=v[a++])if(s(o,t||T,n)){k.call(r,o);break}i&&(E=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=pe.call(r));f=Z(f)}k.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&ce.uniqueSort(r)}return i&&(E=h,w=p),c},m?F(r):r))).selector=e}return a}function re(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&Y(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&C&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(O,P),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=D.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(O,P),H.test(o[0].type)&&U(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&Q(o)))return k.apply(n,r),n;break}}}return(l||ne(e,c))(r,t,!C,n,!t||H.test(e)&&U(t.parentNode)||t),n}G.prototype=b.filters=b.pseudos,b.setFilters=new G,le.sortStable=S.split("").sort(l).join("")===S,V(),le.sortDetached=$(function(e){return 1&e.compareDocumentPosition(T.createElement("fieldset"))}),ce.find=I,ce.expr[":"]=ce.expr.pseudos,ce.unique=ce.uniqueSort,I.compile=ne,I.select=re,I.setDocument=V,I.tokenize=Y,I.escape=ce.escapeSelector,I.getText=ce.text,I.isXML=ce.isXMLDoc,I.selectors=ce.expr,I.support=ce.support,I.uniqueSort=ce.uniqueSort}();var d=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&ce(e).is(n))break;r.push(e)}return r},h=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},b=ce.expr.match.needsContext,w=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function T(e,n,r){return v(n)?ce.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?ce.grep(e,function(e){return e===n!==r}):"string"!=typeof n?ce.grep(e,function(e){return-1<se.call(n,e)!==r}):ce.filter(n,e,r)}ce.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?ce.find.matchesSelector(r,e)?[r]:[]:ce.find.matches(e,ce.grep(t,function(e){return 1===e.nodeType}))},ce.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(ce(e).filter(function(){for(t=0;t<r;t++)if(ce.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)ce.find(e,i[t],n);return 1<r?ce.uniqueSort(n):n},filter:function(e){return this.pushStack(T(this,e||[],!1))},not:function(e){return this.pushStack(T(this,e||[],!0))},is:function(e){return!!T(this,"string"==typeof e&&b.test(e)?ce(e):e||[],!1).length}});var k,S=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(ce.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:S.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof ce?t[0]:t,ce.merge(this,ce.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:C,!0)),w.test(r[1])&&ce.isPlainObject(t))for(r in t)v(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=C.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(ce):ce.makeArray(e,this)}).prototype=ce.fn,k=ce(C);var E=/^(?:parents|prev(?:Until|All))/,j={children:!0,contents:!0,next:!0,prev:!0};function A(e,t){while((e=e[t])&&1!==e.nodeType);return e}ce.fn.extend({has:function(e){var t=ce(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(ce.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&ce(e);if(!b.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&ce.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?ce.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?se.call(ce(e),this[0]):se.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(ce.uniqueSort(ce.merge(this.get(),ce(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),ce.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return d(e,"parentNode")},parentsUntil:function(e,t,n){return d(e,"parentNode",n)},next:function(e){return A(e,"nextSibling")},prev:function(e){return A(e,"previousSibling")},nextAll:function(e){return d(e,"nextSibling")},prevAll:function(e){return d(e,"previousSibling")},nextUntil:function(e,t,n){return d(e,"nextSibling",n)},prevUntil:function(e,t,n){return d(e,"previousSibling",n)},siblings:function(e){return h((e.parentNode||{}).firstChild,e)},children:function(e){return h(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(fe(e,"template")&&(e=e.content||e),ce.merge([],e.childNodes))}},function(r,i){ce.fn[r]=function(e,t){var n=ce.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=ce.filter(t,n)),1<this.length&&(j[r]||ce.uniqueSort(n),E.test(r)&&n.reverse()),this.pushStack(n)}});var D=/[^\x20\t\r\n\f]+/g;function N(e){return e}function q(e){throw e}function L(e,t,n,r){var i;try{e&&v(i=e.promise)?i.call(e).done(t).fail(n):e&&v(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}ce.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},ce.each(e.match(D)||[],function(e,t){n[t]=!0}),n):ce.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){ce.each(e,function(e,t){v(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==x(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return ce.each(arguments,function(e,t){var n;while(-1<(n=ce.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<ce.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},ce.extend({Deferred:function(e){var o=[["notify","progress",ce.Callbacks("memory"),ce.Callbacks("memory"),2],["resolve","done",ce.Callbacks("once memory"),ce.Callbacks("once memory"),0,"resolved"],["reject","fail",ce.Callbacks("once memory"),ce.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return ce.Deferred(function(r){ce.each(o,function(e,t){var n=v(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&v(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,v(t)?s?t.call(e,l(u,o,N,s),l(u,o,q,s)):(u++,t.call(e,l(u,o,N,s),l(u,o,q,s),l(u,o,N,o.notifyWith))):(a!==N&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){ce.Deferred.exceptionHook&&ce.Deferred.exceptionHook(e,t.error),u<=i+1&&(a!==q&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(ce.Deferred.getErrorHook?t.error=ce.Deferred.getErrorHook():ce.Deferred.getStackHook&&(t.error=ce.Deferred.getStackHook()),ie.setTimeout(t))}}return ce.Deferred(function(e){o[0][3].add(l(0,e,v(r)?r:N,e.notifyWith)),o[1][3].add(l(0,e,v(t)?t:N)),o[2][3].add(l(0,e,v(n)?n:q))}).promise()},promise:function(e){return null!=e?ce.extend(e,a):a}},s={};return ce.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=ae.call(arguments),o=ce.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?ae.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(L(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||v(i[t]&&i[t].then)))return o.then();while(t--)L(i[t],a(t),o.reject);return o.promise()}});var H=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;ce.Deferred.exceptionHook=function(e,t){ie.console&&ie.console.warn&&e&&H.test(e.name)&&ie.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},ce.readyException=function(e){ie.setTimeout(function(){throw e})};var O=ce.Deferred();function P(){C.removeEventListener("DOMContentLoaded",P),ie.removeEventListener("load",P),ce.ready()}ce.fn.ready=function(e){return O.then(e)["catch"](function(e){ce.readyException(e)}),this},ce.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--ce.readyWait:ce.isReady)||(ce.isReady=!0)!==e&&0<--ce.readyWait||O.resolveWith(C,[ce])}}),ce.ready.then=O.then,"complete"===C.readyState||"loading"!==C.readyState&&!C.documentElement.doScroll?ie.setTimeout(ce.ready):(C.addEventListener("DOMContentLoaded",P),ie.addEventListener("load",P));var M=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n))for(s in i=!0,n)M(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,v(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(ce(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},R=/^-ms-/,I=/-([a-z])/g;function W(e,t){return t.toUpperCase()}function F(e){return e.replace(R,"ms-").replace(I,W)}var $=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function B(){this.expando=ce.expando+B.uid++}B.uid=1,B.prototype={cache:function(e){var t=e[this.expando];return t||(t={},$(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[F(t)]=n;else for(r in t)i[F(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][F(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(F):(t=F(t))in r?[t]:t.match(D)||[]).length;while(n--)delete r[t[n]]}(void 0===t||ce.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!ce.isEmptyObject(t)}};var _=new B,z=new B,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,U=/[A-Z]/g;function V(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(U,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:X.test(i)?JSON.parse(i):i)}catch(e){}z.set(e,t,n)}else n=void 0;return n}ce.extend({hasData:function(e){return z.hasData(e)||_.hasData(e)},data:function(e,t,n){return z.access(e,t,n)},removeData:function(e,t){z.remove(e,t)},_data:function(e,t,n){return _.access(e,t,n)},_removeData:function(e,t){_.remove(e,t)}}),ce.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=z.get(o),1===o.nodeType&&!_.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=F(r.slice(5)),V(o,r,i[r]));_.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){z.set(this,n)}):M(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=z.get(o,n))?t:void 0!==(t=V(o,n))?t:void 0;this.each(function(){z.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){z.remove(this,e)})}}),ce.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=_.get(e,t),n&&(!r||Array.isArray(n)?r=_.access(e,t,ce.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=ce.queue(e,t),r=n.length,i=n.shift(),o=ce._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){ce.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return _.get(e,n)||_.access(e,n,{empty:ce.Callbacks("once memory").add(function(){_.remove(e,[t+"queue",n])})})}}),ce.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?ce.queue(this[0],t):void 0===n?this:this.each(function(){var e=ce.queue(this,t,n);ce._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&ce.dequeue(this,t)})},dequeue:function(e){return this.each(function(){ce.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=ce.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=_.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var G=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Y=new RegExp("^(?:([+-])=|)("+G+")([a-z%]*)$","i"),Q=["Top","Right","Bottom","Left"],J=C.documentElement,K=function(e){return ce.contains(e.ownerDocument,e)},Z={composed:!0};J.getRootNode&&(K=function(e){return ce.contains(e.ownerDocument,e)||e.getRootNode(Z)===e.ownerDocument});var ee=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&K(e)&&"none"===ce.css(e,"display")};function te(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return ce.css(e,t,"")},u=s(),l=n&&n[3]||(ce.cssNumber[t]?"":"px"),c=e.nodeType&&(ce.cssNumber[t]||"px"!==l&&+u)&&Y.exec(ce.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)ce.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,ce.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ne={};function re(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=_.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ee(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ne[s])||(o=a.body.appendChild(a.createElement(s)),u=ce.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ne[s]=u)))):"none"!==n&&(l[c]="none",_.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}ce.fn.extend({show:function(){return re(this,!0)},hide:function(){return re(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ee(this)?ce(this).show():ce(this).hide()})}});var xe,be,we=/^(?:checkbox|radio)$/i,Te=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Ce=/^$|^module$|\/(?:java|ecma)script/i;xe=C.createDocumentFragment().appendChild(C.createElement("div")),(be=C.createElement("input")).setAttribute("type","radio"),be.setAttribute("checked","checked"),be.setAttribute("name","t"),xe.appendChild(be),le.checkClone=xe.cloneNode(!0).cloneNode(!0).lastChild.checked,xe.innerHTML="<textarea>x</textarea>",le.noCloneChecked=!!xe.cloneNode(!0).lastChild.defaultValue,xe.innerHTML="<option></option>",le.option=!!xe.lastChild;var ke={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function Se(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&fe(e,t)?ce.merge([e],n):n}function Ee(e,t){for(var n=0,r=e.length;n<r;n++)_.set(e[n],"globalEval",!t||_.get(t[n],"globalEval"))}ke.tbody=ke.tfoot=ke.colgroup=ke.caption=ke.thead,ke.th=ke.td,le.option||(ke.optgroup=ke.option=[1,"<select multiple='multiple'>","</select>"]);var je=/<|&#?\w+;/;function Ae(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))ce.merge(p,o.nodeType?[o]:o);else if(je.test(o)){a=a||f.appendChild(t.createElement("div")),s=(Te.exec(o)||["",""])[1].toLowerCase(),u=ke[s]||ke._default,a.innerHTML=u[1]+ce.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;ce.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<ce.inArray(o,r))i&&i.push(o);else if(l=K(o),a=Se(f.appendChild(o),"script"),l&&Ee(a),n){c=0;while(o=a[c++])Ce.test(o.type||"")&&n.push(o)}return f}var De=/^([^.]*)(?:\.(.+)|)/;function Ne(){return!0}function qe(){return!1}function Le(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Le(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=qe;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return ce().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=ce.guid++)),e.each(function(){ce.event.add(this,t,i,r,n)})}function He(e,r,t){t?(_.set(e,r,!1),ce.event.add(e,r,{namespace:!1,handler:function(e){var t,n=_.get(this,r);if(1&e.isTrigger&&this[r]){if(n)(ce.event.special[r]||{}).delegateType&&e.stopPropagation();else if(n=ae.call(arguments),_.set(this,r,n),this[r](),t=_.get(this,r),_.set(this,r,!1),n!==t)return e.stopImmediatePropagation(),e.preventDefault(),t}else n&&(_.set(this,r,ce.event.trigger(n[0],n.slice(1),this)),e.stopPropagation(),e.isImmediatePropagationStopped=Ne)}})):void 0===_.get(e,r)&&ce.event.add(e,r,Ne)}ce.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.get(t);if($(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&ce.find.matchesSelector(J,i),n.guid||(n.guid=ce.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof ce&&ce.event.triggered!==e.type?ce.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(D)||[""]).length;while(l--)d=g=(s=De.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=ce.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=ce.event.special[d]||{},c=ce.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&ce.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),ce.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.hasData(e)&&_.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(D)||[""]).length;while(l--)if(d=g=(s=De.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=ce.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||ce.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)ce.event.remove(e,d+t[l],n,r,!0);ce.isEmptyObject(u)&&_.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=ce.event.fix(e),l=(_.get(this,"events")||Object.create(null))[u.type]||[],c=ce.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=ce.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((ce.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<ce(i,this).index(l):ce.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(ce.Event.prototype,t,{enumerable:!0,configurable:!0,get:v(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[ce.expando]?e:new ce.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click",!0),!1},trigger:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click"),!0},_default:function(e){var t=e.target;return we.test(t.type)&&t.click&&fe(t,"input")&&_.get(t,"click")||fe(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},ce.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},ce.Event=function(e,t){if(!(this instanceof ce.Event))return new ce.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ne:qe,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&ce.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[ce.expando]=!0},ce.Event.prototype={constructor:ce.Event,isDefaultPrevented:qe,isPropagationStopped:qe,isImmediatePropagationStopped:qe,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ne,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ne,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ne,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},ce.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},ce.event.addProp),ce.each({focus:"focusin",blur:"focusout"},function(r,i){function o(e){if(C.documentMode){var t=_.get(this,"handle"),n=ce.event.fix(e);n.type="focusin"===e.type?"focus":"blur",n.isSimulated=!0,t(e),n.target===n.currentTarget&&t(n)}else ce.event.simulate(i,e.target,ce.event.fix(e))}ce.event.special[r]={setup:function(){var e;if(He(this,r,!0),!C.documentMode)return!1;(e=_.get(this,i))||this.addEventListener(i,o),_.set(this,i,(e||0)+1)},trigger:function(){return He(this,r),!0},teardown:function(){var e;if(!C.documentMode)return!1;(e=_.get(this,i)-1)?_.set(this,i,e):(this.removeEventListener(i,o),_.remove(this,i))},_default:function(e){return _.get(e.target,r)},delegateType:i},ce.event.special[i]={setup:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i);n||(C.documentMode?this.addEventListener(i,o):e.addEventListener(r,o,!0)),_.set(t,i,(n||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i)-1;n?_.set(t,i,n):(C.documentMode?this.removeEventListener(i,o):e.removeEventListener(r,o,!0),_.remove(t,i))}}}),ce.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){ce.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||ce.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),ce.fn.extend({on:function(e,t,n,r){return Le(this,e,t,n,r)},one:function(e,t,n,r){return Le(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,ce(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=qe),this.each(function(){ce.event.remove(this,e,n,t)})}});var Oe=/<script|<style|<link/i,Pe=/checked\s*(?:[^=]|=\s*.checked.)/i,Me=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function Re(e,t){return fe(e,"table")&&fe(11!==t.nodeType?t:t.firstChild,"tr")&&ce(e).children("tbody")[0]||e}function Ie(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function We(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Fe(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(_.hasData(e)&&(s=_.get(e).events))for(i in _.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)ce.event.add(t,i,s[i][n]);z.hasData(e)&&(o=z.access(e),a=ce.extend({},o),z.set(t,a))}}function $e(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=v(d);if(h||1<f&&"string"==typeof d&&!le.checkClone&&Pe.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),$e(t,r,i,o)});if(f&&(t=(e=Ae(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=ce.map(Se(e,"script"),Ie)).length;c<f;c++)u=e,c!==p&&(u=ce.clone(u,!0,!0),s&&ce.merge(a,Se(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,ce.map(a,We),c=0;c<s;c++)u=a[c],Ce.test(u.type||"")&&!_.access(u,"globalEval")&&ce.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?ce._evalUrl&&!u.noModule&&ce._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):m(u.textContent.replace(Me,""),u,l))}return n}function Be(e,t,n){for(var r,i=t?ce.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||ce.cleanData(Se(r)),r.parentNode&&(n&&K(r)&&Ee(Se(r,"script")),r.parentNode.removeChild(r));return e}ce.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=K(e);if(!(le.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||ce.isXMLDoc(e)))for(a=Se(c),r=0,i=(o=Se(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&we.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||Se(e),a=a||Se(c),r=0,i=o.length;r<i;r++)Fe(o[r],a[r]);else Fe(e,c);return 0<(a=Se(c,"script")).length&&Ee(a,!f&&Se(e,"script")),c},cleanData:function(e){for(var t,n,r,i=ce.event.special,o=0;void 0!==(n=e[o]);o++)if($(n)){if(t=n[_.expando]){if(t.events)for(r in t.events)i[r]?ce.event.remove(n,r):ce.removeEvent(n,r,t.handle);n[_.expando]=void 0}n[z.expando]&&(n[z.expando]=void 0)}}}),ce.fn.extend({detach:function(e){return Be(this,e,!0)},remove:function(e){return Be(this,e)},text:function(e){return M(this,function(e){return void 0===e?ce.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return $e(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Re(this,e).appendChild(e)})},prepend:function(){return $e(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Re(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(ce.cleanData(Se(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return ce.clone(this,e,t)})},html:function(e){return M(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Oe.test(e)&&!ke[(Te.exec(e)||["",""])[1].toLowerCase()]){e=ce.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(ce.cleanData(Se(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return $e(this,arguments,function(e){var t=this.parentNode;ce.inArray(this,n)<0&&(ce.cleanData(Se(this)),t&&t.replaceChild(e,this))},n)}}),ce.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){ce.fn[e]=function(e){for(var t,n=[],r=ce(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),ce(r[o])[a](t),s.apply(n,t.get());return this.pushStack(n)}});var _e=new RegExp("^("+G+")(?!px)[a-z%]+$","i"),ze=/^--/,Xe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=ie),t.getComputedStyle(e)},Ue=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ve=new RegExp(Q.join("|"),"i");function Ge(e,t,n){var r,i,o,a,s=ze.test(t),u=e.style;return(n=n||Xe(e))&&(a=n.getPropertyValue(t)||n[t],s&&a&&(a=a.replace(ve,"$1")||void 0),""!==a||K(e)||(a=ce.style(e,t)),!le.pixelBoxStyles()&&_e.test(a)&&Ve.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function Ye(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",J.appendChild(u).appendChild(l);var e=ie.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),J.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=C.createElement("div"),l=C.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",le.clearCloneStyle="content-box"===l.style.backgroundClip,ce.extend(le,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=C.createElement("table"),t=C.createElement("tr"),n=C.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="box-sizing:content-box;border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",J.appendChild(e).appendChild(t).appendChild(n),r=ie.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,J.removeChild(e)),a}}))}();var Qe=["Webkit","Moz","ms"],Je=C.createElement("div").style,Ke={};function Ze(e){var t=ce.cssProps[e]||Ke[e];return t||(e in Je?e:Ke[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Qe.length;while(n--)if((e=Qe[n]+t)in Je)return e}(e)||e)}var et=/^(none|table(?!-c[ea]).+)/,tt={position:"absolute",visibility:"hidden",display:"block"},nt={letterSpacing:"0",fontWeight:"400"};function rt(e,t,n){var r=Y.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function it(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=ce.css(e,n+Q[a],!0,i)),r?("content"===n&&(u-=ce.css(e,"padding"+Q[a],!0,i)),"margin"!==n&&(u-=ce.css(e,"border"+Q[a]+"Width",!0,i))):(u+=ce.css(e,"padding"+Q[a],!0,i),"padding"!==n?u+=ce.css(e,"border"+Q[a]+"Width",!0,i):s+=ce.css(e,"border"+Q[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u+l}function ot(e,t,n){var r=Xe(e),i=(!le.boxSizingReliable()||n)&&"border-box"===ce.css(e,"boxSizing",!1,r),o=i,a=Ge(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(_e.test(a)){if(!n)return a;a="auto"}return(!le.boxSizingReliable()&&i||!le.reliableTrDimensions()&&fe(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===ce.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===ce.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+it(e,t,n||(i?"border":"content"),o,r,a)+"px"}function at(e,t,n,r,i){return new at.prototype.init(e,t,n,r,i)}ce.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ge(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,aspectRatio:!0,borderImageSlice:!0,columnCount:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,scale:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeMiterlimit:!0,strokeOpacity:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=F(t),u=ze.test(t),l=e.style;if(u||(t=Ze(s)),a=ce.cssHooks[t]||ce.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=Y.exec(n))&&i[1]&&(n=te(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(ce.cssNumber[s]?"":"px")),le.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=F(t);return ze.test(t)||(t=Ze(s)),(a=ce.cssHooks[t]||ce.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Ge(e,t,r)),"normal"===i&&t in nt&&(i=nt[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),ce.each(["height","width"],function(e,u){ce.cssHooks[u]={get:function(e,t,n){if(t)return!et.test(ce.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?ot(e,u,n):Ue(e,tt,function(){return ot(e,u,n)})},set:function(e,t,n){var r,i=Xe(e),o=!le.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===ce.css(e,"boxSizing",!1,i),s=n?it(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-it(e,u,"border",!1,i)-.5)),s&&(r=Y.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=ce.css(e,u)),rt(0,t,s)}}}),ce.cssHooks.marginLeft=Ye(le.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Ge(e,"marginLeft"))||e.getBoundingClientRect().left-Ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),ce.each({margin:"",padding:"",border:"Width"},function(i,o){ce.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+Q[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(ce.cssHooks[i+o].set=rt)}),ce.fn.extend({css:function(e,t){return M(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Xe(e),i=t.length;a<i;a++)o[t[a]]=ce.css(e,t[a],!1,r);return o}return void 0!==n?ce.style(e,t,n):ce.css(e,t)},e,t,1<arguments.length)}}),((ce.Tween=at).prototype={constructor:at,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||ce.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(ce.cssNumber[n]?"":"px")},cur:function(){var e=at.propHooks[this.prop];return e&&e.get?e.get(this):at.propHooks._default.get(this)},run:function(e){var t,n=at.propHooks[this.prop];return this.options.duration?this.pos=t=ce.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):at.propHooks._default.set(this),this}}).init.prototype=at.prototype,(at.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=ce.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){ce.fx.step[e.prop]?ce.fx.step[e.prop](e):1!==e.elem.nodeType||!ce.cssHooks[e.prop]&&null==e.elem.style[Ze(e.prop)]?e.elem[e.prop]=e.now:ce.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=at.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},ce.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},ce.fx=at.prototype.init,ce.fx.step={};var st,ut,lt,ct,ft=/^(?:toggle|show|hide)$/,pt=/queueHooks$/;function dt(){ut&&(!1===C.hidden&&ie.requestAnimationFrame?ie.requestAnimationFrame(dt):ie.setTimeout(dt,ce.fx.interval),ce.fx.tick())}function ht(){return ie.setTimeout(function(){st=void 0}),st=Date.now()}function gt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=Q[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function vt(e,t,n){for(var r,i=(yt.tweeners[t]||[]).concat(yt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function yt(o,e,t){var n,a,r=0,i=yt.prefilters.length,s=ce.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=st||ht(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:ce.extend({},e),opts:ce.extend(!0,{specialEasing:{},easing:ce.easing._default},t),originalProperties:e,originalOptions:t,startTime:st||ht(),duration:t.duration,tweens:[],createTween:function(e,t){var n=ce.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=F(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=ce.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=yt.prefilters[r].call(l,o,c,l.opts))return v(n.stop)&&(ce._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return ce.map(c,vt,l),v(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),ce.fx.timer(ce.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}ce.Animation=ce.extend(yt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return te(n.elem,e,Y.exec(t),n),n}]},tweener:function(e,t){v(e)?(t=e,e=["*"]):e=e.match(D);for(var n,r=0,i=e.length;r<i;r++)n=e[r],yt.tweeners[n]=yt.tweeners[n]||[],yt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ee(e),v=_.get(e,"fxshow");for(r in n.queue||(null==(a=ce._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,ce.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ft.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||ce.style(e,r)}if((u=!ce.isEmptyObject(t))||!ce.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=_.get(e,"display")),"none"===(c=ce.css(e,"display"))&&(l?c=l:(re([e],!0),l=e.style.display||l,c=ce.css(e,"display"),re([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===ce.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=_.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&re([e],!0),p.done(function(){for(r in g||re([e]),_.remove(e,"fxshow"),d)ce.style(e,r,d[r])})),u=vt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?yt.prefilters.unshift(e):yt.prefilters.push(e)}}),ce.speed=function(e,t,n){var r=e&&"object"==typeof e?ce.extend({},e):{complete:n||!n&&t||v(e)&&e,duration:e,easing:n&&t||t&&!v(t)&&t};return ce.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in ce.fx.speeds?r.duration=ce.fx.speeds[r.duration]:r.duration=ce.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){v(r.old)&&r.old.call(this),r.queue&&ce.dequeue(this,r.queue)},r},ce.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ee).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=ce.isEmptyObject(t),o=ce.speed(e,n,r),a=function(){var e=yt(this,ce.extend({},t),o);(i||_.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=ce.timers,r=_.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&pt.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||ce.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=_.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=ce.timers,o=n?n.length:0;for(t.finish=!0,ce.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),ce.each(["toggle","show","hide"],function(e,r){var i=ce.fn[r];ce.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(gt(r,!0),e,t,n)}}),ce.each({slideDown:gt("show"),slideUp:gt("hide"),slideToggle:gt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){ce.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),ce.timers=[],ce.fx.tick=function(){var e,t=0,n=ce.timers;for(st=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||ce.fx.stop(),st=void 0},ce.fx.timer=function(e){ce.timers.push(e),ce.fx.start()},ce.fx.interval=13,ce.fx.start=function(){ut||(ut=!0,dt())},ce.fx.stop=function(){ut=null},ce.fx.speeds={slow:600,fast:200,_default:400},ce.fn.delay=function(r,e){return r=ce.fx&&ce.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=ie.setTimeout(e,r);t.stop=function(){ie.clearTimeout(n)}})},lt=C.createElement("input"),ct=C.createElement("select").appendChild(C.createElement("option")),lt.type="checkbox",le.checkOn=""!==lt.value,le.optSelected=ct.selected,(lt=C.createElement("input")).value="t",lt.type="radio",le.radioValue="t"===lt.value;var mt,xt=ce.expr.attrHandle;ce.fn.extend({attr:function(e,t){return M(this,ce.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){ce.removeAttr(this,e)})}}),ce.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?ce.prop(e,t,n):(1===o&&ce.isXMLDoc(e)||(i=ce.attrHooks[t.toLowerCase()]||(ce.expr.match.bool.test(t)?mt:void 0)),void 0!==n?null===n?void ce.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=ce.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!le.radioValue&&"radio"===t&&fe(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(D);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),mt={set:function(e,t,n){return!1===t?ce.removeAttr(e,n):e.setAttribute(n,n),n}},ce.each(ce.expr.match.bool.source.match(/\w+/g),function(e,t){var a=xt[t]||ce.find.attr;xt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=xt[o],xt[o]=r,r=null!=a(e,t,n)?o:null,xt[o]=i),r}});var bt=/^(?:input|select|textarea|button)$/i,wt=/^(?:a|area)$/i;function Tt(e){return(e.match(D)||[]).join(" ")}function Ct(e){return e.getAttribute&&e.getAttribute("class")||""}function kt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(D)||[]}ce.fn.extend({prop:function(e,t){return M(this,ce.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[ce.propFix[e]||e]})}}),ce.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&ce.isXMLDoc(e)||(t=ce.propFix[t]||t,i=ce.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=ce.find.attr(e,"tabindex");return t?parseInt(t,10):bt.test(e.nodeName)||wt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),le.optSelected||(ce.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),ce.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){ce.propFix[this.toLowerCase()]=this}),ce.fn.extend({addClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).addClass(t.call(this,e,Ct(this)))}):(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).removeClass(t.call(this,e,Ct(this)))}):arguments.length?(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return v(t)?this.each(function(e){ce(this).toggleClass(t.call(this,e,Ct(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=kt(t),this.each(function(){if(s)for(o=ce(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=Ct(this))&&_.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":_.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+Tt(Ct(n))+" ").indexOf(t))return!0;return!1}});var St=/\r/g;ce.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=v(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,ce(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=ce.map(t,function(e){return null==e?"":e+""})),(r=ce.valHooks[this.type]||ce.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=ce.valHooks[t.type]||ce.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(St,""):null==e?"":e:void 0}}),ce.extend({valHooks:{option:{get:function(e){var t=ce.find.attr(e,"value");return null!=t?t:Tt(ce.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!fe(n.parentNode,"optgroup"))){if(t=ce(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=ce.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<ce.inArray(ce.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),ce.each(["radio","checkbox"],function(){ce.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<ce.inArray(ce(e).val(),t)}},le.checkOn||(ce.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})});var Et=ie.location,jt={guid:Date.now()},At=/\?/;ce.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new ie.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||ce.error("Invalid XML: "+(n?ce.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Dt=/^(?:focusinfocus|focusoutblur)$/,Nt=function(e){e.stopPropagation()};ce.extend(ce.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||C],d=ue.call(e,"type")?e.type:e,h=ue.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||C,3!==n.nodeType&&8!==n.nodeType&&!Dt.test(d+ce.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[ce.expando]?e:new ce.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:ce.makeArray(t,[e]),c=ce.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!y(n)){for(s=c.delegateType||d,Dt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||C)&&p.push(a.defaultView||a.parentWindow||ie)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(_.get(o,"events")||Object.create(null))[e.type]&&_.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&$(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!$(n)||u&&v(n[d])&&!y(n)&&((a=n[u])&&(n[u]=null),ce.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Nt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Nt),ce.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=ce.extend(new ce.Event,n,{type:e,isSimulated:!0});ce.event.trigger(r,null,t)}}),ce.fn.extend({trigger:function(e,t){return this.each(function(){ce.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return ce.event.trigger(e,t,n,!0)}});var qt=/\[\]$/,Lt=/\r?\n/g,Ht=/^(?:submit|button|image|reset|file)$/i,Ot=/^(?:input|select|textarea|keygen)/i;function Pt(n,e,r,i){var t;if(Array.isArray(e))ce.each(e,function(e,t){r||qt.test(n)?i(n,t):Pt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==x(e))i(n,e);else for(t in e)Pt(n+"["+t+"]",e[t],r,i)}ce.param=function(e,t){var n,r=[],i=function(e,t){var n=v(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!ce.isPlainObject(e))ce.each(e,function(){i(this.name,this.value)});else for(n in e)Pt(n,e[n],t,i);return r.join("&")},ce.fn.extend({serialize:function(){return ce.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=ce.prop(this,"elements");return e?ce.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!ce(this).is(":disabled")&&Ot.test(this.nodeName)&&!Ht.test(e)&&(this.checked||!we.test(e))}).map(function(e,t){var n=ce(this).val();return null==n?null:Array.isArray(n)?ce.map(n,function(e){return{name:t.name,value:e.replace(Lt,"\r\n")}}):{name:t.name,value:n.replace(Lt,"\r\n")}}).get()}});var Mt=/%20/g,Rt=/#.*$/,It=/([?&])_=[^&]*/,Wt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ft=/^(?:GET|HEAD)$/,$t=/^\/\//,Bt={},_t={},zt="*/".concat("*"),Xt=C.createElement("a");function Ut(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(D)||[];if(v(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Vt(t,i,o,a){var s={},u=t===_t;function l(e){var r;return s[e]=!0,ce.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Gt(e,t){var n,r,i=ce.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&ce.extend(!0,e,r),e}Xt.href=Et.href,ce.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":zt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":ce.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Gt(Gt(e,ce.ajaxSettings),t):Gt(ce.ajaxSettings,e)},ajaxPrefilter:Ut(Bt),ajaxTransport:Ut(_t),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=ce.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?ce(y):ce.event,x=ce.Deferred(),b=ce.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Wt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace($t,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(D)||[""],null==v.crossDomain){r=C.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Xt.protocol+"//"+Xt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=ce.param(v.data,v.traditional)),Vt(Bt,v,t,T),h)return T;for(i in(g=ce.event&&v.global)&&0==ce.active++&&ce.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Ft.test(v.type),f=v.url.replace(Rt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Mt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(At.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(It,"$1"),o=(At.test(f)?"&":"?")+"_="+jt.guid+++o),v.url=f+o),v.ifModified&&(ce.lastModified[f]&&T.setRequestHeader("If-Modified-Since",ce.lastModified[f]),ce.etag[f]&&T.setRequestHeader("If-None-Match",ce.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+zt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Vt(_t,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=ie.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&ie.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<ce.inArray("script",v.dataTypes)&&ce.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(ce.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(ce.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--ce.active||ce.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return ce.get(e,t,n,"json")},getScript:function(e,t){return ce.get(e,void 0,t,"script")}}),ce.each(["get","post"],function(e,i){ce[i]=function(e,t,n,r){return v(t)&&(r=r||n,n=t,t=void 0),ce.ajax(ce.extend({url:e,type:i,dataType:r,data:t,success:n},ce.isPlainObject(e)&&e))}}),ce.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),ce._evalUrl=function(e,t,n){return ce.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){ce.globalEval(e,t,n)}})},ce.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=ce(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return v(n)?this.each(function(e){ce(this).wrapInner(n.call(this,e))}):this.each(function(){var e=ce(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=v(t);return this.each(function(e){ce(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){ce(this).replaceWith(this.childNodes)}),this}}),ce.expr.pseudos.hidden=function(e){return!ce.expr.pseudos.visible(e)},ce.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},ce.ajaxSettings.xhr=function(){try{return new ie.XMLHttpRequest}catch(e){}};var Yt={0:200,1223:204},Qt=ce.ajaxSettings.xhr();le.cors=!!Qt&&"withCredentials"in Qt,le.ajax=Qt=!!Qt,ce.ajaxTransport(function(i){var o,a;if(le.cors||Qt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Yt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&ie.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),ce.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),ce.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return ce.globalEval(e),e}}}),ce.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),ce.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=ce("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),C.head.appendChild(r[0])},abort:function(){i&&i()}}});var Jt,Kt=[],Zt=/(=)\?(?=&|$)|\?\?/;ce.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Kt.pop()||ce.expando+"_"+jt.guid++;return this[e]=!0,e}}),ce.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Zt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Zt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=v(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Zt,"$1"+r):!1!==e.jsonp&&(e.url+=(At.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||ce.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=ie[r],ie[r]=function(){o=arguments},n.always(function(){void 0===i?ce(ie).removeProp(r):ie[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Kt.push(r)),o&&v(i)&&i(o[0]),o=i=void 0}),"script"}),le.createHTMLDocument=((Jt=C.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Jt.childNodes.length),ce.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(le.createHTMLDocument?((r=(t=C.implementation.createHTMLDocument("")).createElement("base")).href=C.location.href,t.head.appendChild(r)):t=C),o=!n&&[],(i=w.exec(e))?[t.createElement(i[1])]:(i=Ae([e],t,o),o&&o.length&&ce(o).remove(),ce.merge([],i.childNodes)));var r,i,o},ce.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=Tt(e.slice(s)),e=e.slice(0,s)),v(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&ce.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?ce("<div>").append(ce.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},ce.expr.pseudos.animated=function(t){return ce.grep(ce.timers,function(e){return t===e.elem}).length},ce.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=ce.css(e,"position"),c=ce(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=ce.css(e,"top"),u=ce.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),v(t)&&(t=t.call(e,n,ce.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},ce.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){ce.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===ce.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===ce.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=ce(e).offset()).top+=ce.css(e,"borderTopWidth",!0),i.left+=ce.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-ce.css(r,"marginTop",!0),left:t.left-i.left-ce.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===ce.css(e,"position"))e=e.offsetParent;return e||J})}}),ce.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;ce.fn[t]=function(e){return M(this,function(e,t,n){var r;if(y(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),ce.each(["top","left"],function(e,n){ce.cssHooks[n]=Ye(le.pixelPosition,function(e,t){if(t)return t=Ge(e,n),_e.test(t)?ce(e).position()[n]+"px":t})}),ce.each({Height:"height",Width:"width"},function(a,s){ce.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){ce.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return M(this,function(e,t,n){var r;return y(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?ce.css(e,t,i):ce.style(e,t,n,i)},s,n?e:void 0,n)}})}),ce.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){ce.fn[t]=function(e){return this.on(t,e)}}),ce.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.on("mouseenter",e).on("mouseleave",t||e)}}),ce.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){ce.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var en=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;ce.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return r=ae.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(ae.call(arguments)))}).guid=e.guid=e.guid||ce.guid++,i},ce.holdReady=function(e){e?ce.readyWait++:ce.ready(!0)},ce.isArray=Array.isArray,ce.parseJSON=JSON.parse,ce.nodeName=fe,ce.isFunction=v,ce.isWindow=y,ce.camelCase=F,ce.type=x,ce.now=Date.now,ce.isNumeric=function(e){var t=ce.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},ce.trim=function(e){return null==e?"":(e+"").replace(en,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return ce});var tn=ie.jQuery,nn=ie.$;return ce.noConflict=function(e){return ie.$===ce&&(ie.$=nn),e&&ie.jQuery===ce&&(ie.jQuery=tn),ce},"undefined"==typeof e&&(ie.jQuery=ie.$=ce),ce});
// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.3.5 2016-11-14*/
/*global module:false, define:false*/
/*jshint latedef:false*/
/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
(function (define, undefined) {
define(function () {
    'use strict';

    var impl = {};

    impl.mobileDetectRules = {
    "phones": {
        "iPhone": "\\biPhone\\b|\\biPod\\b",
        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+",
        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m",
        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
        "Dell": "Dell.*Streak|Dell.*Aero|Dell.*Venue|DELL.*Venue Pro|Dell Flash|Dell Smoke|Dell Mini 3iX|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b",
        "Samsung": "\\bSamsung\\b|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F",
        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323)",
        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
        "NokiaLumia": "Lumia [0-9]{3,4}",
        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
        "Palm": "PalmSource|Palm",
        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
        "Alcatel": "Alcatel",
        "Nintendo": "Nintendo 3DS",
        "Amoi": "Amoi",
        "INQ": "INQ",
        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
    },
    "tablets": {
        "iPad": "iPad|iPad.*Mobile",
        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y|SM-T280",
        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI)\\b",
        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z",
        "BlackBerryTablet": "PlayBook|RIM Tablet",
        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)",
        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
        "IRUTablet": "M702pro",
        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
        "NokiaLumiaTablet": "Lumia 2520",
        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP612|SOT31",
        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
        "FlyTablet": "IQ310|Fly Vision",
        "bqTablet": "Android.*(bq)?.*(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris [E|M]10)|Maxwell.*Lite|Maxwell.*Plus",
        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim",
        "NecTablet": "\\bN-06D|\\bN-08D",
        "PantechTablet": "Pantech.*P4100",
        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
        "ZyncTablet": "z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900",
        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
        "NabiTablet": "Android.*\\bNabi",
        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
        "PlaystationTablet": "Playstation.*(Portable|Vita)",
        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
        "GalapadTablet": "Android.*\\bG1\\b",
        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)",
        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
        "DPSTablet": "DPS Dream 9|DPS Dual 7",
        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497",
        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
        "iMobileTablet": "i-mobile i-note",
        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
        "AMPETablet": "Android.* A78 ",
        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
        "TecnoTablet": "TECNO P9",
        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
        "CaptivaTablet": "CAPTIVA PAD",
        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+",
        "JaytechTablet": "TPC-PA762",
        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
        "UbislateTablet": "UbiSlate[\\s]?7C",
        "PocketBookTablet": "Pocketbook",
        "KocasoTablet": "\\b(TB-1207)\\b",
        "HisenseTablet": "\\b(F5281|E2371)\\b",
        "Hudl": "Hudl HT7S3|Hudl 2",
        "TelstraTablet": "T-Hub2",
        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b"
    },
    "oss": {
        "AndroidOS": "Android",
        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;",
        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad",
        "MeeGoOS": "MeeGo",
        "MaemoOS": "Maemo",
        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
        "webOS": "webOS|hpwOS",
        "badaOS": "\\bBada\\b",
        "BREWOS": "BREW"
    },
    "uas": {
        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
        "Dolfin": "\\bDolfin\\b",
        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+|Coast\/[0-9.]+",
        "Skyfire": "Skyfire",
        "Edge": "Mobile Safari\/[.0-9]* Edge",
        "IE": "IEMobile|MSIEMobile",
        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
        "Bolt": "bolt",
        "TeaShark": "teashark",
        "Blazer": "Blazer",
        "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
        "UCBrowser": "UC.*Browser|UCWEB",
        "baiduboxapp": "baiduboxapp",
        "baidubrowser": "baidubrowser",
        "DiigoBrowser": "DiigoBrowser",
        "Puffin": "Puffin",
        "Mercury": "\\bMercury\\b",
        "ObigoBrowser": "Obigo",
        "NetFront": "NF-Browser",
        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
    },
    "props": {
        "Mobile": "Mobile\/[VER]",
        "Build": "Build\/[VER]",
        "Version": "Version\/[VER]",
        "VendorID": "VendorID\/[VER]",
        "iPad": "iPad.*CPU[a-z ]+[VER]",
        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
        "iPod": "iPod.*CPU[a-z ]+[VER]",
        "Kindle": "Kindle\/[VER]",
        "Chrome": [
            "Chrome\/[VER]",
            "CriOS\/[VER]",
            "CrMo\/[VER]"
        ],
        "Coast": [
            "Coast\/[VER]"
        ],
        "Dolfin": "Dolfin\/[VER]",
        "Firefox": [
            "Firefox\/[VER]",
            "FxiOS\/[VER]"
        ],
        "Fennec": "Fennec\/[VER]",
        "Edge": "Edge\/[VER]",
        "IE": [
            "IEMobile\/[VER];",
            "IEMobile [VER]",
            "MSIE [VER];",
            "Trident\/[0-9.]+;.*rv:[VER]"
        ],
        "NetFront": "NetFront\/[VER]",
        "NokiaBrowser": "NokiaBrowser\/[VER]",
        "Opera": [
            " OPR\/[VER]",
            "Opera Mini\/[VER]",
            "Version\/[VER]"
        ],
        "Opera Mini": "Opera Mini\/[VER]",
        "Opera Mobi": "Version\/[VER]",
        "UC Browser": "UC Browser[VER]",
        "MQQBrowser": "MQQBrowser\/[VER]",
        "MicroMessenger": "MicroMessenger\/[VER]",
        "baiduboxapp": "baiduboxapp\/[VER]",
        "baidubrowser": "baidubrowser\/[VER]",
        "SamsungBrowser": "SamsungBrowser\/[VER]",
        "Iron": "Iron\/[VER]",
        "Safari": [
            "Version\/[VER]",
            "Safari\/[VER]"
        ],
        "Skyfire": "Skyfire\/[VER]",
        "Tizen": "Tizen\/[VER]",
        "Webkit": "webkit[ \/][VER]",
        "PaleMoon": "PaleMoon\/[VER]",
        "Gecko": "Gecko\/[VER]",
        "Trident": "Trident\/[VER]",
        "Presto": "Presto\/[VER]",
        "Goanna": "Goanna\/[VER]",
        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
        "Android": "Android [VER]",
        "BlackBerry": [
            "BlackBerry[\\w]+\/[VER]",
            "BlackBerry.*Version\/[VER]",
            "Version\/[VER]"
        ],
        "BREW": "BREW [VER]",
        "Java": "Java\/[VER]",
        "Windows Phone OS": [
            "Windows Phone OS [VER]",
            "Windows Phone [VER]"
        ],
        "Windows Phone": "Windows Phone [VER]",
        "Windows CE": "Windows CE\/[VER]",
        "Windows NT": "Windows NT [VER]",
        "Symbian": [
            "SymbianOS\/[VER]",
            "Symbian\/[VER]"
        ],
        "webOS": [
            "webOS\/[VER]",
            "hpwOS\/[VER];"
        ]
    },
    "utils": {
        "Bot": "Googlebot|facebookexternalhit|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom",
        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
        "DesktopMode": "WPDesktop",
        "TV": "SonyDTV|HbbTV",
        "WebKit": "(webkit)[ \/]([\\w.]+)",
        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|PLAYSTATION|Xbox)\\b",
        "Watch": "SM-V700"
    }
};

    // following patterns come from http://detectmobilebrowsers.com/
    impl.detectMobileBrowsers = {
        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        tabletPattern: /android|ipad|playbook|silk/i
    };

    var hasOwnProp = Object.prototype.hasOwnProperty,
        isArray;

    impl.FALLBACK_PHONE = 'UnknownPhone';
    impl.FALLBACK_TABLET = 'UnknownTablet';
    impl.FALLBACK_MOBILE = 'UnknownMobile';

    isArray = ('isArray' in Array) ?
        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };

    function equalIC(a, b) {
        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
    }

    function containsIC(array, value) {
        var valueLC, i, len = array.length;
        if (!len || !value) {
            return false;
        }
        valueLC = value.toLowerCase();
        for (i = 0; i < len; ++i) {
            if (valueLC === array[i].toLowerCase()) {
                return true;
            }
        }
        return false;
    }

    function convertPropsToRegExp(object) {
        for (var key in object) {
            if (hasOwnProp.call(object, key)) {
                object[key] = new RegExp(object[key], 'i');
            }
        }
    }

    (function init() {
        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
        for (key in mobileDetectRules.props) {
            if (hasOwnProp.call(mobileDetectRules.props, key)) {
                values = mobileDetectRules.props[key];
                if (!isArray(values)) {
                    values = [values];
                }
                len = values.length;
                for (i = 0; i < len; ++i) {
                    value = values[i];
                    verPos = value.indexOf('[VER]');
                    if (verPos >= 0) {
                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
                    }
                    values[i] = new RegExp(value, 'i');
                }
                mobileDetectRules.props[key] = values;
            }
        }
        convertPropsToRegExp(mobileDetectRules.oss);
        convertPropsToRegExp(mobileDetectRules.phones);
        convertPropsToRegExp(mobileDetectRules.tablets);
        convertPropsToRegExp(mobileDetectRules.uas);
        convertPropsToRegExp(mobileDetectRules.utils);

        // copy some patterns to oss0 which are tested first (see issue#15)
        mobileDetectRules.oss0 = {
            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
        };
    }());

    /*
     * Test userAgent string against a set of rules and find the first matched key.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
     * @private
     */
    impl.findMatch = function(rules, userAgent) {
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    return key;
                }
            }
        }
        return null;
    };

    /*
     * Test userAgent string against a set of rules and return an array of matched keys.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
     * @private
     */
    impl.findMatches = function(rules, userAgent) {
        var result = [];
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    result.push(key);
                }
            }
        }
        return result;
    };

    /*
     * Check the version of the given property in the User-Agent.
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {String} version or <tt>null</tt> if version not found
     * @private
     */
    impl.getVersionStr = function (propertyName, userAgent) {
        var props = impl.mobileDetectRules.props, patterns, i, len, match;
        if (hasOwnProp.call(props, propertyName)) {
            patterns = props[propertyName];
            len = patterns.length;
            for (i = 0; i < len; ++i) {
                match = patterns[i].exec(userAgent);
                if (match !== null) {
                    return match[1];
                }
            }
        }
        return null;
    };

    /*
     * Check the version of the given property in the User-Agent.
     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {Number} version or <tt>NaN</tt> if version not found
     * @private
     */
    impl.getVersion = function (propertyName, userAgent) {
        var version = impl.getVersionStr(propertyName, userAgent);
        return version ? impl.prepareVersionNo(version) : NaN;
    };

    /*
     * Prepare the version number.
     *
     * @param {String} version
     * @return {Number} the version number as a floating number
     * @private
     */
    impl.prepareVersionNo = function (version) {
        var numbers;

        numbers = version.split(/[a-z._ \/\-]/i);
        if (numbers.length === 1) {
            version = numbers[0];
        }
        if (numbers.length > 1) {
            version = numbers[0] + '.';
            numbers.shift();
            version += numbers.join('');
        }
        return Number(version);
    };

    impl.isMobileFallback = function (userAgent) {
        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
    };

    impl.isTabletFallback = function (userAgent) {
        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
    };

    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
        if (cache.mobile !== undefined) {
            return;
        }
        var phone, tablet, phoneSized;

        // first check for stronger tablet rules, then phone (see issue#5)
        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
        if (tablet) {
            cache.mobile = cache.tablet = tablet;
            cache.phone = null;
            return; // unambiguously identified as tablet
        }

        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
        if (phone) {
            cache.mobile = cache.phone = phone;
            cache.tablet = null;
            return; // unambiguously identified as phone
        }

        // our rules haven't found a match -> try more general fallback rules
        if (impl.isMobileFallback(userAgent)) {
            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
            if (phoneSized === undefined) {
                cache.mobile = impl.FALLBACK_MOBILE;
                cache.tablet = cache.phone = null;
            } else if (phoneSized) {
                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                cache.tablet = null;
            } else {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            }
        } else if (impl.isTabletFallback(userAgent)) {
            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
            cache.phone = null;
        } else {
            // not mobile at all!
            cache.mobile = cache.tablet = cache.phone = null;
        }
    };

    // t is a reference to a MobileDetect instance
    impl.mobileGrade = function (t) {
        // impl note:
        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
        // When changes are made in Mobile_Detect.php, copy this method and replace:
        //     $this-> / t.
        //     self::MOBILE_GRADE_(.) / '$1'
        //     , self::VERSION_TYPE_FLOAT / (nothing)
        //     isIOS() / os('iOS')
        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
        var $isMobile = t.mobile() !== null;

        if (
            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os('iOS') && t.version('iPad')>=4.3 ||
            t.os('iOS') && t.version('iPhone')>=3.1 ||
            t.os('iOS') && t.version('iPod')>=3.1 ||

            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            ( t.version('Android')>2.1 && t.is('Webkit') ) ||

            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version('Windows Phone OS')>=7.0 ||

            // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match('Playbook.*Tablet') ||

            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
            // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match('hp.*TouchPad') ||

            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||

            // Chrome for Android - Tested on Android 4.0, 4.1 device
            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||

            // Skyfire 4.1 - Tested on Android 2.3 device
            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||

            // Opera Mobile 11.5-12: Tested on Android 2.3
            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||

            // Meego 1.2 - Tested on Nokia 950 and N9
            t.is('MeeGoOS') ||

            // Tizen (pre-release) - Tested on early hardware
            t.is('Tizen') ||

            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is('Dolfin') && t.version('Bada')>=2.0 ||

            // UC Browser - Tested on Android 2.3 device
            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||

            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            ( t.match('Kindle Fire') ||
                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||

            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is('AndroidOS') && t.is('NookTablet') ||

            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version('Chrome')>=11 && !$isMobile ||

            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version('Safari')>=5.0 && !$isMobile ||

            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version('Firefox')>=4.0 && !$isMobile ||

            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version('MSIE')>=7.0 && !$isMobile ||

            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version('Opera')>=10 && !$isMobile

            ){
            return 'A';
        }

        if (
            t.os('iOS') && t.version('iPad')<4.3 ||
            t.os('iOS') && t.version('iPhone')<3.1 ||
            t.os('iOS') && t.version('iPod')<3.1 ||

            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||

            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
                (t.version('Android')>=2.3 || t.is('iOS')) ) ||

            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||

            // @todo: report this (tested on Nokia N71)
            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
            ){
            return 'B';
        }

        if (
        // Blackberry 4.x - Tested on the Curve 8330
            t.version('BlackBerry')<5.0 ||
            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2

            ){
            return 'C';
        }

        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
        //will receive the basic, C grade experience.
        return 'C';
    };

    impl.detectOS = function (ua) {
        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
            impl.findMatch(impl.mobileDetectRules.oss, ua);
    };

    impl.getDeviceSmallerSide = function () {
        return window.screen.width < window.screen.height ?
            window.screen.width :
            window.screen.height;
    };

    /*
     * Constructor for MobileDetect object.
     * <br>
     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
     *     <strong>Find information how to download and install:</strong>
     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
     * </div>
     *
     * @example <pre>
     *     var md = new MobileDetect(window.navigator.userAgent);
     *     if (md.mobile()) {
     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
     *     }
     * </pre>
     *
     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
     *        as phone.
     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
     *        for Android</a>.<br>
     *        If you provide a value < 0, then this "fuzzy" check is disabled.
     * @constructor
     * @global
     */
    function MobileDetect(userAgent, maxPhoneWidth) {
        this.ua = userAgent || '';
        this._cache = {};
        //600dp is typical 7" tablet minimum width
        this.maxPhoneWidth = maxPhoneWidth || 600;
    }

    MobileDetect.prototype = {
        constructor: MobileDetect,

        /*
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */
        mobile: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.mobile;
        },

        /*
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
         * Wolfgang, Alcatel, Nintendo, Amoi, INQ, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */
        phone: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.phone;
        },

        /*
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, SamsungTablet, Kindle, SurfaceTablet, HPTablet, AsusTablet,
         * BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet, AcerTablet,
         * ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet, LenovoTablet,
         * DellTablet, YarvikTablet, MedionTablet, ArnovaTablet, IntensoTablet, IRUTablet,
         * MegafonTablet, EbodaTablet, AllViewTablet, ArchosTablet, AinolTablet,
         * NokiaLumiaTablet, SonyTablet, PhilipsTablet, CubeTablet, CobyTablet, MIDTablet,
         * MSITablet, SMiTTablet, RockChipTablet, FlyTablet, bqTablet, HuaweiTablet,
         * NecTablet, PantechTablet, BronchoTablet, VersusTablet, ZyncTablet,
         * PositivoTablet, NabiTablet, KoboTablet, DanewTablet, TexetTablet,
         * PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet, OndaTablet,
         * JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet, LavaTablet,
         * AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MiTablet, NibiruTablet,
         * NexoTablet, LeaderTablet, UbislateTablet, PocketBookTablet, KocasoTablet,
         * HisenseTablet, Hudl, TelstraTablet, GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */
        tablet: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.tablet;
        },

        /*
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */
        userAgent: function () {
            if (this._cache.userAgent === undefined) {
                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgent;
        },

        /*
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */
        userAgents: function () {
            if (this._cache.userAgents === undefined) {
                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgents;
        },

        /*
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */
        os: function () {
            if (this._cache.os === undefined) {
                this._cache.os = impl.detectOS(this.ua);
            }
            return this._cache.os;
        },

        /*
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */
        version: function (key) {
            return impl.getVersion(key, this.ua);
        },

        /*
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */
        versionStr: function (key) {
            return impl.getVersionStr(key, this.ua);
        },

        /*
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */
        is: function (key) {
            return containsIC(this.userAgents(), key) ||
                   equalIC(key, this.os()) ||
                   equalIC(key, this.phone()) ||
                   equalIC(key, this.tablet()) ||
                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
        },

        /*
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */
        match: function (pattern) {
            if (!(pattern instanceof RegExp)) {
                pattern = new RegExp(pattern, 'i');
            }
            return pattern.test(this.ua);
        },

        /*
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */
        isPhoneSized: function (maxPhoneWidth) {
            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
        },

        /*
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */
        mobileGrade: function () {
            if (this._cache.grade === undefined) {
                this._cache.grade = impl.mobileGrade(this);
            }
            return this._cache.grade;
        }
    };

    // environment-dependent
    if (typeof window !== 'undefined' && window.screen) {
        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
        };
    } else {
        MobileDetect.isPhoneSized = function () {};
    }

    // should not be replaced by a completely new object - just overwrite existing methods
    MobileDetect._impl = impl;
    
    MobileDetect.version = '1.3.5 2016-11-14';

    return MobileDetect;
}); // end of call of define()
})((function (undefined) {
    if (typeof module !== 'undefined' && module.exports) {
        return function (factory) { module.exports = factory(); };
    } else if (typeof define === 'function' && define.amd) {
        return define;
    } else if (typeof window !== 'undefined') {
        return function (factory) { window.MobileDetect = factory(); };
    } else {
        // please file a bug if you get this error!
        throw new Error('unknown environment');
    }
})());/*
 * @author Alexander Manzyuk <admsev@gmail.com>
 * Copyright (c) 2012 Alexander Manzyuk - released under MIT License
 * https://github.com/admsev/jquery-play-sound
 * Usage: $.playSound('http://example.org/sound.mp3');
**/

(function($){

  $.extend({
    playSound: function(){
      return $(
        '<audio autoplay="autoplay" style="display:none;">'
          + '<source src="' + arguments[0] + '.mp3" />'
          + '<source src="' + arguments[0] + '.ogg" />'
          + '<embed src="' + arguments[0] + '.mp3" hidden="true" autostart="true" loop="false" class="playSound" />'
        + '</audio>'
      ).appendTo('body');
    }
  });

})(jQuery);
/*! device.js 0.2.7 */
(function(){var a,b,c,d,e,f,g,h,i,j;b=window.device,a={},window.device=a,d=window.document.documentElement,j=window.navigator.userAgent.toLowerCase(),a.ios=function(){return a.iphone()||a.ipod()||a.ipad()},a.iphone=function(){return!a.windows()&&e("iphone")},a.ipod=function(){return e("ipod")},a.ipad=function(){return e("ipad")},a.android=function(){return!a.windows()&&e("android")},a.androidPhone=function(){return a.android()&&e("mobile")},a.androidTablet=function(){return a.android()&&!e("mobile")},a.blackberry=function(){return e("blackberry")||e("bb10")||e("rim")},a.blackberryPhone=function(){return a.blackberry()&&!e("tablet")},a.blackberryTablet=function(){return a.blackberry()&&e("tablet")},a.windows=function(){return e("windows")},a.windowsPhone=function(){return a.windows()&&e("phone")},a.windowsTablet=function(){return a.windows()&&e("touch")&&!a.windowsPhone()},a.fxos=function(){return(e("(mobile;")||e("(tablet;"))&&e("; rv:")},a.fxosPhone=function(){return a.fxos()&&e("mobile")},a.fxosTablet=function(){return a.fxos()&&e("tablet")},a.meego=function(){return e("meego")},a.cordova=function(){return window.cordova&&"file:"===location.protocol},a.nodeWebkit=function(){return"object"==typeof window.process},a.mobile=function(){return a.androidPhone()||a.iphone()||a.ipod()||a.windowsPhone()||a.blackberryPhone()||a.fxosPhone()||a.meego()},a.tablet=function(){return a.ipad()||a.androidTablet()||a.blackberryTablet()||a.windowsTablet()||a.fxosTablet()},a.desktop=function(){return!a.tablet()&&!a.mobile()},a.television=function(){var a;for(television=["googletv","viera","smarttv","internet.tv","netcast","nettv","appletv","boxee","kylo","roku","dlnadoc","roku","pov_tv","hbbtv","ce-html"],a=0;a<television.length;){if(e(television[a]))return!0;a++}return!1},a.portrait=function(){return window.innerHeight/window.innerWidth>1},a.landscape=function(){return window.innerHeight/window.innerWidth<1},a.noConflict=function(){return window.device=b,this},e=function(a){return-1!==j.indexOf(a)},g=function(a){var b;return b=new RegExp(a,"i"),d.className.match(b)},c=function(a){var b=null;g(a)||(b=d.className.replace(/^\s+|\s+$/g,""),d.className=b+" "+a)},i=function(a){g(a)&&(d.className=d.className.replace(" "+a,""))},a.ios()?a.ipad()?c("ios ipad tablet"):a.iphone()?c("ios iphone mobile"):a.ipod()&&c("ios ipod mobile"):a.android()?c(a.androidTablet()?"android tablet":"android mobile"):a.blackberry()?c(a.blackberryTablet()?"blackberry tablet":"blackberry mobile"):a.windows()?c(a.windowsTablet()?"windows tablet":a.windowsPhone()?"windows mobile":"desktop"):a.fxos()?c(a.fxosTablet()?"fxos tablet":"fxos mobile"):a.meego()?c("meego mobile"):a.nodeWebkit()?c("node-webkit"):a.television()?c("television"):a.desktop()&&c("desktop"),a.cordova()&&c("cordova"),f=function(){a.landscape()?(i("portrait"),c("landscape")):(i("landscape"),c("portrait"))},h=Object.prototype.hasOwnProperty.call(window,"onorientationchange")?"orientationchange":"resize",window.addEventListener?window.addEventListener(h,f,!1):window.attachEvent?window.attachEvent(h,f):window[h]=f,f(),"function"==typeof define&&"object"==typeof define.amd&&define.amd?define(function(){return a}):"undefined"!=typeof module&&module.exports?module.exports=a:window.device=a}).call(this);
/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (typeof define == 'function' && define.amd) define(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /*
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)os/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /*
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /*
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /*
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /*
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /*
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});
/* Detect-zoom
 * -----------
 * Cross Browser Zoom and Pixel Ratio Detector
 * Version 1.0.4 | Apr 1 2013
 * dual-licensed under the WTFPL and MIT license
 * Maintained by https://github/tombigel
 * Original developer https://github.com/yonran
 */

//AMD and CommonJS initialization copied from https://github.com/zohararad/audio5js
(function (root, ns, factory) {
    "use strict";

    if (typeof (module) !== 'undefined' && module.exports) { // CommonJS
        module.exports = factory(ns, root);
    } else if (typeof (define) === 'function' && define.amd) { // AMD
        define("detect-zoom", function () {
            return factory(ns, root);
        });
    } else {
        root[ns] = factory(ns, root);
    }

}(window, 'detectZoom', function () {

    /*
     * Use devicePixelRatio if supported by the browser
     * @return {Number}
     * @private
     */
    var devicePixelRatio = function () {
        return window.devicePixelRatio || 1;
    };

    /*
     * Fallback function to set default values
     * @return {Object}
     * @private
     */
    var fallback = function () {
        return {
            zoom: 1,
            devicePxPerCssPx: 1
        };
    };
    /*
     * IE 8 and 9: no trick needed!
     * TODO: Test on IE10 and Windows 8 RT
     * @return {Object}
     * @private
     **/
    var ie8 = function () {
        var zoom = Math.round((screen.deviceXDPI / screen.logicalXDPI) * 100) / 100;
        return {
            zoom: zoom,
            devicePxPerCssPx: zoom * devicePixelRatio()
        };
    };

    /*
     * For IE10 we need to change our technique again...
     * thanks https://github.com/stefanvanburen
     * @return {Object}
     * @private
     */
    var ie10 = function () {
        var zoom = Math.round((document.documentElement.offsetHeight / window.innerHeight) * 100) / 100;
        return {
            zoom: zoom,
            devicePxPerCssPx: zoom * devicePixelRatio()
        };
    };

	/*
	* For chrome
	*
	*/
    var chrome = function()
    {
    	var zoom = Math.round(((window.outerWidth) / window.innerWidth)*100) / 100;
        return {
            zoom: zoom,
            devicePxPerCssPx: zoom * devicePixelRatio()
        };	    
    }

	/*
	* For safari (same as chrome)
	*
	*/
    var safari= function()
    {
    	var zoom = Math.round(((window.outerWidth) / window.innerWidth)*100) / 100;
        return {
            zoom: zoom,
            devicePxPerCssPx: zoom * devicePixelRatio()
        };	    
    }
	

    /*
     * Mobile WebKit
     * the trick: window.innerWIdth is in CSS pixels, while
     * screen.width and screen.height are in system pixels.
     * And there are no scrollbars to mess up the measurement.
     * @return {Object}
     * @private
     */
    var webkitMobile = function () {
        var deviceWidth = (Math.abs(window.orientation) == 90) ? screen.height : screen.width;
        var zoom = deviceWidth / window.innerWidth;
        return {
            zoom: zoom,
            devicePxPerCssPx: zoom * devicePixelRatio()
        };
    };

    /*
     * Desktop Webkit
     * the trick: an element's clientHeight is in CSS pixels, while you can
     * set its line-height in system pixels using font-size and
     * -webkit-text-size-adjust:none.
     * device-pixel-ratio: http://www.webkit.org/blog/55/high-dpi-web-sites/
     *
     * Previous trick (used before http://trac.webkit.org/changeset/100847):
     * documentElement.scrollWidth is in CSS pixels, while
     * document.width was in system pixels. Note that this is the
     * layout width of the document, which is slightly different from viewport
     * because document width does not include scrollbars and might be wider
     * due to big elements.
     * @return {Object}
     * @private
     */
    var webkit = function () {
        var important = function (str) {
            return str.replace(/;/g, " !important;");
        };

        var div = document.createElement('div');
        div.innerHTML = "1<br>2<br>3<br>4<br>5<br>6<br>7<br>8<br>9<br>0";
        div.setAttribute('style', important('font: 100px/1em sans-serif; -webkit-text-size-adjust: none; text-size-adjust: none; height: auto; width: 1em; padding: 0; overflow: visible;'));

        // The container exists so that the div will be laid out in its own flow
        // while not impacting the layout, viewport size, or display of the
        // webpage as a whole.
        // Add !important and relevant CSS rule resets
        // so that other rules cannot affect the results.
        var container = document.createElement('div');
        container.setAttribute('style', important('width:0; height:0; overflow:hidden; visibility:hidden; position: absolute;'));
        container.appendChild(div);

        document.body.appendChild(container);
        var zoom = 1000 / div.clientHeight;
        zoom = Math.round(zoom * 100) / 100;
        document.body.removeChild(container);

        return{
            zoom: zoom,
            devicePxPerCssPx: zoom * devicePixelRatio()
        };
    };

    /*
     * no real trick; device-pixel-ratio is the ratio of device dpi / css dpi.
     * (Note that this is a different interpretation than Webkit's device
     * pixel ratio, which is the ratio device dpi / system dpi).
     *
     * Also, for Mozilla, there is no difference between the zoom factor and the device ratio.
     *
     * @return {Object}
     * @private
     */
    var firefox4 = function () {
        var zoom = mediaQueryBinarySearch('min--moz-device-pixel-ratio', '', 0, 10, 20, 0.0001);
        zoom = Math.round(zoom * 100) / 100;
        return {
            zoom: zoom,
            devicePxPerCssPx: zoom
        };
    };

    /*
     * Firefox 18.x
     * Mozilla added support for devicePixelRatio to Firefox 18,
     * but it is affected by the zoom level, so, like in older
     * Firefox we can't tell if we are in zoom mode or in a device
     * with a different pixel ratio
     * @return {Object}
     * @private
     */
    var firefox18 = function () {
        return {
            zoom: firefox4().zoom,
            devicePxPerCssPx: devicePixelRatio()
        };
    };

    /*
     * works starting Opera 11.11
     * the trick: outerWidth is the viewport width including scrollbars in
     * system px, while innerWidth is the viewport width including scrollbars
     * in CSS px
     * @return {Object}
     * @private
     */
    var opera11 = function () {
        var zoom = window.top.outerWidth / window.top.innerWidth;
        zoom = Math.round(zoom * 100) / 100;
        return {
            zoom: zoom,
            devicePxPerCssPx: zoom * devicePixelRatio()
        };
    };

    /*
     * Use a binary search through media queries to find zoom level in Firefox
     * @param property
     * @param unit
     * @param a
     * @param b
     * @param maxIter
     * @param epsilon
     * @return {Number}
     */
    var mediaQueryBinarySearch = function (property, unit, a, b, maxIter, epsilon) {
        var matchMedia;
        var head, style, div;
        if (window.matchMedia) {
            matchMedia = window.matchMedia;
        } else {
            head = document.getElementsByTagName('head')[0];
            style = document.createElement('style');
            head.appendChild(style);

            div = document.createElement('div');
            div.className = 'mediaQueryBinarySearch';
            div.style.display = 'none';
            document.body.appendChild(div);

            matchMedia = function (query) {
                style.sheet.insertRule('@media ' + query + '{.mediaQueryBinarySearch ' + '{text-decoration: underline} }', 0);
                var matched = getComputedStyle(div, null).textDecoration == 'underline';
                style.sheet.deleteRule(0);
                return {matches: matched};
            };
        }
        var ratio = binarySearch(a, b, maxIter);
        if (div) {
            head.removeChild(style);
            document.body.removeChild(div);
        }
        return ratio;

        function binarySearch(a, b, maxIter) {
            var mid = (a + b) / 2;
            if (maxIter <= 0 || b - a < epsilon) {
                return mid;
            }
            var query = "(" + property + ":" + mid + unit + ")";
            if (matchMedia(query).matches) {
                return binarySearch(mid, b, maxIter - 1);
            } else {
                return binarySearch(a, mid, maxIter - 1);
            }
        }
    };

    /*
     * Generate detection function
     * @private
     */
    var detectFunction = (function () {
        var func = fallback;
        //IE8+
        if (!isNaN(screen.logicalXDPI) && !isNaN(screen.systemXDPI)) {
            func = ie8;
        }
        // IE10+ / Touch
        else if (window.navigator.msMaxTouchPoints) {
            func = ie10;
        }
		//chrome
		else if(!!window.chrome && !(!!window.opera || navigator.userAgent.indexOf(' Opera') >= 0)){
			func = chrome;
		}
		//safari
		else if(Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0){
			func = safari;
		}	
        //Mobile Webkit
        else if ('orientation' in window && 'webkitRequestAnimationFrame' in window) {
            func = webkitMobile;
        }
        //WebKit
        else if ('webkitRequestAnimationFrame' in window) {
            func = webkit;
        }
        //Opera
        else if (navigator.userAgent.indexOf('Opera') >= 0) {
            func = opera11;
        }
        //Last one is Firefox
        //FF 18.x
        else if (window.devicePixelRatio) {
            func = firefox18;
        }
        //FF 4.0 - 17.x
        else if (firefox4().zoom > 0.001) {
            func = firefox4;
        }

        return func;
    }());


    return ({

        /*
         * Ratios.zoom shorthand
         * @return {Number} Zoom level
         */
        zoom: function () {
            return detectFunction().zoom;
        },

        /*
         * Ratios.devicePxPerCssPx shorthand
         * @return {Number} devicePxPerCssPx level
         */
        device: function () {
            return detectFunction().devicePxPerCssPx;
        }
    });
}));
/*! jQuery UI - v1.14.2 - 2026-01-29
* https://jqueryui.com
* Includes: widget.js, position.js, data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-patch.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js
* Copyright OpenJS Foundation and other contributors; Licensed MIT */

( function( factory ) {
	"use strict";

	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [ "jquery" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
} )( function( $ ) {
"use strict";

$.ui = $.ui || {};

var version = $.ui.version = "1.14.2";


/*!
 * jQuery UI Widget 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: https://api.jqueryui.com/jQuery.widget/
//>>demos: https://jqueryui.com/widget/


var widgetUuid = 0;
var widgetHasOwnProperty = Array.prototype.hasOwnProperty;
var widgetSlice = Array.prototype.slice;

$.cleanData = ( function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {

			// Only trigger remove when necessary to save time
			events = $._data( elem, "events" );
			if ( events && events.remove ) {
				$( elem ).triggerHandler( "remove" );
			}
		}
		orig( elems );
	};
} )( $.cleanData );

$.widget = function( name, base, prototype ) {
	var existingConstructor, constructor, basePrototype;

	// ProxiedPrototype allows the provided prototype to remain unmodified
	// so that it can be used as a mixin for multiple widgets (#8876)
	var proxiedPrototype = {};

	var namespace = name.split( "." )[ 0 ];
	name = name.split( "." )[ 1 ];
	if ( name === "__proto__" || name === "constructor" ) {
		return $.error( "Invalid widget name: " + name );
	}
	var fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	if ( Array.isArray( prototype ) ) {
		prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
	}

	// Create selector for plugin
	$.expr.pseudos[ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {

		// Allow instantiation without "new" keyword
		if ( !this || !this._createWidget ) {
			return new constructor( options, element );
		}

		// Allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	// Extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,

		// Copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),

		// Track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	} );

	basePrototype = new base();

	// We need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( typeof value !== "function" ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = ( function() {
			function _super() {
				return base.prototype[ prop ].apply( this, arguments );
			}

			function _superApply( args ) {
				return base.prototype[ prop ].apply( this, args );
			}

			return function() {
				var __super = this._super;
				var __superApply = this._superApply;
				var returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		} )();
	} );
	constructor.prototype = $.widget.extend( basePrototype, {

		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	} );

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// Redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
				child._proto );
		} );

		// Remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widgetSlice.call( arguments, 1 );
	var inputIndex = 0;
	var inputLength = input.length;
	var key;
	var value;

	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( widgetHasOwnProperty.call( input[ inputIndex ], key ) && value !== undefined ) {

				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :

						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );

				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string";
		var args = widgetSlice.call( arguments, 1 );
		var returnValue = this;

		if ( isMethodCall ) {

			// If this is an empty collection, we need to have the instance method
			// return undefined instead of the jQuery instance
			if ( !this.length && options === "instance" ) {
				returnValue = undefined;
			} else {
				this.each( function() {
					var methodValue;
					var instance = $.data( this, fullName );

					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}

					if ( !instance ) {
						return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}

					if ( typeof instance[ options ] !== "function" ||
						options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
					}

					methodValue = instance[ options ].apply( instance, args );

					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				} );
			}
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat( args ) );
			}

			this.each( function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			} );
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",

	options: {
		classes: {},
		disabled: false,

		// Callbacks
		create: null
	},

	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widgetUuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();
		this.classesElementLookup = {};

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			} );
			this.document = $( element.style ?

				// Element within the document
				element.ownerDocument :

				// Element is window or document
				element.document || element );
			this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();

		if ( this.options.disabled ) {
			this._setOptionDisabled( this.options.disabled );
		}

		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},

	_getCreateOptions: function() {
		return {};
	},

	_getCreateEventData: $.noop,

	_create: $.noop,

	_init: $.noop,

	destroy: function() {
		var that = this;

		this._destroy();
		$.each( this.classesElementLookup, function( key, value ) {
			that._removeClass( value, key );
		} );

		// We can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.off( this.eventNamespace )
			.removeData( this.widgetFullName );
		this.widget()
			.off( this.eventNamespace )
			.removeAttr( "aria-disabled" );

		// Clean up events and states
		this.bindings.off( this.eventNamespace );
	},

	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;
		var parts;
		var curOption;
		var i;

		if ( arguments.length === 0 ) {

			// Don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {

			// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},

	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},

	_setOption: function( key, value ) {
		if ( key === "classes" ) {
			this._setOptionClasses( value );
		}

		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this._setOptionDisabled( value );
		}

		return this;
	},

	_setOptionClasses: function( value ) {
		var classKey, elements, currentElements;

		for ( classKey in value ) {
			currentElements = this.classesElementLookup[ classKey ];
			if ( value[ classKey ] === this.options.classes[ classKey ] ||
					!currentElements ||
					!currentElements.length ) {
				continue;
			}

			// We are doing this to create a new jQuery object because the _removeClass() call
			// on the next line is going to destroy the reference to the current elements being
			// tracked. We need to save a copy of this collection so that we can add the new classes
			// below.
			elements = $( currentElements.get() );
			this._removeClass( currentElements, classKey );

			// We don't use _addClass() here, because that uses this.options.classes
			// for generating the string of classes. We want to use the value passed in from
			// _setOption(), this is the new value of the classes option which was passed to
			// _setOption(). We pass this value directly to _classes().
			elements.addClass( this._classes( {
				element: elements,
				keys: classKey,
				classes: value,
				add: true
			} ) );
		}
	},

	_setOptionDisabled: function( value ) {
		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

		// If the widget is becoming disabled, then nothing is interactive
		if ( value ) {
			this._removeClass( this.hoverable, null, "ui-state-hover" );
			this._removeClass( this.focusable, null, "ui-state-focus" );
		}
	},

	enable: function() {
		return this._setOptions( { disabled: false } );
	},

	disable: function() {
		return this._setOptions( { disabled: true } );
	},

	_classes: function( options ) {
		var full = [];
		var that = this;

		options = $.extend( {
			element: this.element,
			classes: this.options.classes || {}
		}, options );

		function bindRemoveEvent() {
			var nodesToBind = [];

			options.element.each( function( _, element ) {
				var isTracked = $.map( that.classesElementLookup, function( elements ) {
					return elements;
				} )
					.some( function( elements ) {
						return elements.is( element );
					} );

				if ( !isTracked ) {
					nodesToBind.push( element );
				}
			} );

			that._on( $( nodesToBind ), {
				remove: "_untrackClassesElement"
			} );
		}

		function processClassString( classes, checkOption ) {
			var current, i;
			for ( i = 0; i < classes.length; i++ ) {
				current = that.classesElementLookup[ classes[ i ] ] || $();
				if ( options.add ) {
					bindRemoveEvent();
					current = $( $.uniqueSort( current.get().concat( options.element.get() ) ) );
				} else {
					current = $( current.not( options.element ).get() );
				}
				that.classesElementLookup[ classes[ i ] ] = current;
				full.push( classes[ i ] );
				if ( checkOption && options.classes[ classes[ i ] ] ) {
					full.push( options.classes[ classes[ i ] ] );
				}
			}
		}

		if ( options.keys ) {
			processClassString( options.keys.match( /\S+/g ) || [], true );
		}
		if ( options.extra ) {
			processClassString( options.extra.match( /\S+/g ) || [] );
		}

		return full.join( " " );
	},

	_untrackClassesElement: function( event ) {
		var that = this;
		$.each( that.classesElementLookup, function( key, value ) {
			if ( $.inArray( event.target, value ) !== -1 ) {
				that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
			}
		} );

		this._off( $( event.target ) );
	},

	_removeClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, false );
	},

	_addClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, true );
	},

	_toggleClass: function( element, keys, extra, add ) {
		add = ( typeof add === "boolean" ) ? add : extra;
		var shift = ( typeof element === "string" || element === null ),
			options = {
				extra: shift ? keys : extra,
				keys: shift ? element : keys,
				element: shift ? this.element : element,
				add: add
			};
		options.element.toggleClass( this._classes( options ), add );
		return this;
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement;
		var instance = this;

		// No suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// No element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {

				// Allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
						$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// Copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ );
			var eventName = match[ 1 ] + instance.eventNamespace;
			var selector = match[ 2 ];

			if ( selector ) {
				delegateElement.on( eventName, selector, handlerProxy );
			} else {
				element.on( eventName, handlerProxy );
			}
		} );
	},

	_off: function( element, eventName ) {
		eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.off( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
			},
			mouseleave: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
			}
		} );
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
			},
			focusout: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
			}
		} );
	},

	_trigger: function( type, event, data ) {
		var prop, orig;
		var callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();

		// The original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// Copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( typeof callback === "function" &&
			callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}

		var hasOptions;
		var effectName = !options ?
			method :
			options === true || typeof options === "number" ?
				defaultEffect :
				options.effect || defaultEffect;

		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		} else if ( options === true ) {
			options = {};
		}

		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;

		if ( options.delay ) {
			element.delay( options.delay );
		}

		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue( function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			} );
		}
	};
} );

var widget = $.widget;


/*!
 * jQuery UI Position 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 *
 * https://api.jqueryui.com/position/
 */

//>>label: Position
//>>group: Core
//>>description: Positions elements relative to other elements.
//>>docs: https://api.jqueryui.com/position/
//>>demos: https://jqueryui.com/position/


( function() {
var cachedScrollbarWidth,
	max = Math.max,
	abs = Math.abs,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+(\.[\d]+)?%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function isWindow( obj ) {
	return obj != null && obj === obj.window;
}

function getDimensions( elem ) {
	var raw = elem[ 0 ];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div style=" +
				"'display:block;position:absolute;width:200px;height:200px;overflow:hidden;'>" +
				"<div style='height:300px;width:auto;'></div></div>" ),
			innerDiv = div.children()[ 0 ];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[ 0 ].clientWidth;
		}

		div.remove();

		return ( cachedScrollbarWidth = w1 - w2 );
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-x" ),
			overflowY = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[ 0 ].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[ 0 ].scrollHeight );
		return {
			width: hasOverflowY ? $.position.scrollbarWidth() : 0,
			height: hasOverflowX ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isElemWindow = isWindow( withinElement[ 0 ] ),
			isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9,
			hasOffset = !isElemWindow && !isDocument;
		return {
			element: withinElement,
			isWindow: isElemWindow,
			isDocument: isDocument,
			offset: hasOffset ? $( element ).offset() : { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),
			width: withinElement.outerWidth(),
			height: withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// Make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,

		// Make sure string options are treated as CSS selectors
		target = typeof options.of === "string" ?
			$( document ).find( options.of ) :
			$( options.of ),

		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[ 0 ].preventDefault ) {

		// Force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;

	// Clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// Force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1 ) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// Calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// Reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	} );

	// Normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each( function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) +
				scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) +
				scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem: elem
				} );
			}
		} );

		if ( options.using ) {

			// Adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	} );
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// Element is wider than within
			if ( data.collisionWidth > outerWidth ) {

				// Element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth -
						withinOffset;
					position.left += overLeft - newOverRight;

				// Element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;

				// Element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}

			// Too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;

			// Too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;

			// Adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// Element is taller than within
			if ( data.collisionHeight > outerHeight ) {

				// Element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight -
						withinOffset;
					position.top += overTop - newOverBottom;

				// Element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;

				// Element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}

			// Too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;

			// Too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;

			// Adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth -
					outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			} else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset +
					atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight -
					outerHeight - withinOffset;
				if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
					position.top += myOffset + atOffset + offset;
				}
			} else if ( overBottom > 0 ) {
				newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset +
					offset - offsetTop;
				if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

} )();

var position = $.ui.position;


/*!
 * jQuery UI :data 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: :data Selector
//>>group: Core
//>>description: Selects elements which have data stored under the specified key.
//>>docs: https://api.jqueryui.com/data-selector/


var data = $.extend( $.expr.pseudos, {
	data: $.expr.createPseudo( function( dataName ) {
		return function( elem ) {
			return !!$.data( elem, dataName );
		};
	} )
} );

/*!
 * jQuery UI Disable Selection 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: disableSelection
//>>group: Core
//>>description: Disable selection of text content within the set of matched elements.
//>>docs: https://api.jqueryui.com/disableSelection/

// This file is deprecated

var disableSelection = $.fn.extend( {
	disableSelection: ( function() {
		var eventType = "onselectstart" in document.createElement( "div" ) ?
			"selectstart" :
			"mousedown";

		return function() {
			return this.on( eventType + ".ui-disableSelection", function( event ) {
				event.preventDefault();
			} );
		};
	} )(),

	enableSelection: function() {
		return this.off( ".ui-disableSelection" );
	}
} );



// Create a local jQuery because jQuery Color relies on it and the
// global may not exist with AMD and a custom build (#10199).
// This module is a noop if used as a regular AMD module.
// eslint-disable-next-line no-unused-vars
var jQuery = $;


/*!
 * jQuery Color Animations v3.0.0
 * https://github.com/jquery/jquery-color
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 *
 * Date: Wed May 15 16:49:44 2024 +0200
 */


	var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor " +
		"borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",

	class2type = {},
	toString = class2type.toString,

	// plusequals test for += 100 -= 100
	rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,

	// a set of RE's that can match strings and generate color tuples.
	stringParsers = [ {
			re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ],
					execResult[ 3 ],
					execResult[ 4 ]
				];
			}
		}, {
			re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ] * 2.55,
					execResult[ 2 ] * 2.55,
					execResult[ 3 ] * 2.55,
					execResult[ 4 ]
				];
			}
		}, {

			// this regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})?/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ], 16 ),
					execResult[ 4 ] ?
						( parseInt( execResult[ 4 ], 16 ) / 255 ).toFixed( 2 ) :
						1
				];
			}
		}, {

			// this regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9])([a-f0-9])([a-f0-9])([a-f0-9])?/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ] + execResult[ 3 ], 16 ),
					execResult[ 4 ] ?
						( parseInt( execResult[ 4 ] + execResult[ 4 ], 16 ) / 255 )
							.toFixed( 2 ) :
						1
				];
			}
		}, {
			re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			space: "hsla",
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ] / 100,
					execResult[ 3 ] / 100,
					execResult[ 4 ]
				];
			}
		} ],

	// jQuery.Color( )
	color = jQuery.Color = function( color, green, blue, alpha ) {
		return new jQuery.Color.fn.parse( color, green, blue, alpha );
	},
	spaces = {
		rgba: {
			props: {
				red: {
					idx: 0,
					type: "byte"
				},
				green: {
					idx: 1,
					type: "byte"
				},
				blue: {
					idx: 2,
					type: "byte"
				}
			}
		},

		hsla: {
			props: {
				hue: {
					idx: 0,
					type: "degrees"
				},
				saturation: {
					idx: 1,
					type: "percent"
				},
				lightness: {
					idx: 2,
					type: "percent"
				}
			}
		}
	},
	propTypes = {
		"byte": {
			floor: true,
			max: 255
		},
		"percent": {
			max: 1
		},
		"degrees": {
			mod: 360,
			floor: true
		}
	},

	// colors = jQuery.Color.names
	colors,

	// local aliases of functions called often
	each = jQuery.each;

// define cache name and alpha properties
// for rgba and hsla spaces
each( spaces, function( spaceName, space ) {
	space.cache = "_" + spaceName;
	space.props.alpha = {
		idx: 3,
		type: "percent",
		def: 1
	};
} );

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function getType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	return typeof obj === "object" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}

function clamp( value, prop, allowEmpty ) {
	var type = propTypes[ prop.type ] || {};

	if ( value == null ) {
		return ( allowEmpty || !prop.def ) ? null : prop.def;
	}

	// ~~ is an short way of doing floor for positive numbers
	value = type.floor ? ~~value : parseFloat( value );

	if ( type.mod ) {

		// we add mod before modding to make sure that negatives values
		// get converted properly: -10 -> 350
		return ( value + type.mod ) % type.mod;
	}

	// for now all property types without mod have min and max
	return Math.min( type.max, Math.max( 0, value ) );
}

function stringParse( string ) {
	var inst = color(),
		rgba = inst._rgba = [];

	string = string.toLowerCase();

	each( stringParsers, function( _i, parser ) {
		var parsed,
			match = parser.re.exec( string ),
			values = match && parser.parse( match ),
			spaceName = parser.space || "rgba";

		if ( values ) {
			parsed = inst[ spaceName ]( values );

			// if this was an rgba parse the assignment might happen twice
			// oh well....
			inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
			rgba = inst._rgba = parsed._rgba;

			// exit each( stringParsers ) here because we matched
			return false;
		}
	} );

	// Found a stringParser that handled it
	if ( rgba.length ) {

		// if this came from a parsed string, force "transparent" when alpha is 0
		// chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
		if ( rgba.join() === "0,0,0,0" ) {
			jQuery.extend( rgba, colors.transparent );
		}
		return inst;
	}

	// named colors
	return colors[ string ];
}

color.fn = jQuery.extend( color.prototype, {
	parse: function( red, green, blue, alpha ) {
		if ( red === undefined ) {
			this._rgba = [ null, null, null, null ];
			return this;
		}
		if ( red.jquery || red.nodeType ) {
			red = jQuery( red ).css( green );
			green = undefined;
		}

		var inst = this,
			type = getType( red ),
			rgba = this._rgba = [];

		// more than 1 argument specified - assume ( red, green, blue, alpha )
		if ( green !== undefined ) {
			red = [ red, green, blue, alpha ];
			type = "array";
		}

		if ( type === "string" ) {
			return this.parse( stringParse( red ) || colors._default );
		}

		if ( type === "array" ) {
			each( spaces.rgba.props, function( _key, prop ) {
				rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
			} );
			return this;
		}

		if ( type === "object" ) {
			if ( red instanceof color ) {
				each( spaces, function( _spaceName, space ) {
					if ( red[ space.cache ] ) {
						inst[ space.cache ] = red[ space.cache ].slice();
					}
				} );
			} else {
				each( spaces, function( _spaceName, space ) {
					var cache = space.cache;
					each( space.props, function( key, prop ) {

						// if the cache doesn't exist, and we know how to convert
						if ( !inst[ cache ] && space.to ) {

							// if the value was null, we don't need to copy it
							// if the key was alpha, we don't need to copy it either
							if ( key === "alpha" || red[ key ] == null ) {
								return;
							}
							inst[ cache ] = space.to( inst._rgba );
						}

						// this is the only case where we allow nulls for ALL properties.
						// call clamp with alwaysAllowEmpty
						inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
					} );

					// everything defined but alpha?
					if ( inst[ cache ] && jQuery.inArray(
						null,
						inst[ cache ].slice( 0, 3 )
					) < 0 ) {

						// use the default of 1
						if ( inst[ cache ][ 3 ] == null ) {
							inst[ cache ][ 3 ] = 1;
						}

						if ( space.from ) {
							inst._rgba = space.from( inst[ cache ] );
						}
					}
				} );
			}
			return this;
		}
	},
	is: function( compare ) {
		var is = color( compare ),
			same = true,
			inst = this;

		each( spaces, function( _, space ) {
			var localCache,
				isCache = is[ space.cache ];
			if ( isCache ) {
				localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
				each( space.props, function( _, prop ) {
					if ( isCache[ prop.idx ] != null ) {
						same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
						return same;
					}
				} );
			}
			return same;
		} );
		return same;
	},
	_space: function() {
		var used = [],
			inst = this;
		each( spaces, function( spaceName, space ) {
			if ( inst[ space.cache ] ) {
				used.push( spaceName );
			}
		} );
		return used.pop();
	},
	transition: function( other, distance ) {
		var end = color( other ),
			spaceName = end._space(),
			space = spaces[ spaceName ],
			startColor = this.alpha() === 0 ? color( "transparent" ) : this,
			start = startColor[ space.cache ] || space.to( startColor._rgba ),
			result = start.slice();

		end = end[ space.cache ];
		each( space.props, function( _key, prop ) {
			var index = prop.idx,
				startValue = start[ index ],
				endValue = end[ index ],
				type = propTypes[ prop.type ] || {};

			// if null, don't override start value
			if ( endValue === null ) {
				return;
			}

			// if null - use end
			if ( startValue === null ) {
				result[ index ] = endValue;
			} else {
				if ( type.mod ) {
					if ( endValue - startValue > type.mod / 2 ) {
						startValue += type.mod;
					} else if ( startValue - endValue > type.mod / 2 ) {
						startValue -= type.mod;
					}
				}
				result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
			}
		} );
		return this[ spaceName ]( result );
	},
	blend: function( opaque ) {

		// if we are already opaque - return ourself
		if ( this._rgba[ 3 ] === 1 ) {
			return this;
		}

		var rgb = this._rgba.slice(),
			a = rgb.pop(),
			blend = color( opaque )._rgba;

		return color( jQuery.map( rgb, function( v, i ) {
			return ( 1 - a ) * blend[ i ] + a * v;
		} ) );
	},
	toRgbaString: function() {
		var prefix = "rgba(",
			rgba = jQuery.map( this._rgba, function( v, i ) {
				if ( v != null ) {
					return v;
				}
				return i > 2 ? 1 : 0;
			} );

		if ( rgba[ 3 ] === 1 ) {
			rgba.pop();
			prefix = "rgb(";
		}

		return prefix + rgba.join( ", " ) + ")";
	},
	toHslaString: function() {
		var prefix = "hsla(",
			hsla = jQuery.map( this.hsla(), function( v, i ) {
				if ( v == null ) {
					v = i > 2 ? 1 : 0;
				}

				// catch 1 and 2
				if ( i && i < 3 ) {
					v = Math.round( v * 100 ) + "%";
				}
				return v;
			} );

		if ( hsla[ 3 ] === 1 ) {
			hsla.pop();
			prefix = "hsl(";
		}
		return prefix + hsla.join( ", " ) + ")";
	},
	toHexString: function( includeAlpha ) {
		var rgba = this._rgba.slice(),
			alpha = rgba.pop();

		if ( includeAlpha ) {
			rgba.push( ~~( alpha * 255 ) );
		}

		return "#" + jQuery.map( rgba, function( v ) {

			// default to 0 when nulls exist
			return ( "0" + ( v || 0 ).toString( 16 ) ).substr( -2 );
		} ).join( "" );
	},
	toString: function() {
		return this.toRgbaString();
	}
} );
color.fn.parse.prototype = color.fn;

// hsla conversions adapted from:
// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021

function hue2rgb( p, q, h ) {
	h = ( h + 1 ) % 1;
	if ( h * 6 < 1 ) {
		return p + ( q - p ) * h * 6;
	}
	if ( h * 2 < 1 ) {
		return q;
	}
	if ( h * 3 < 2 ) {
		return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
	}
	return p;
}

spaces.hsla.to = function( rgba ) {
	if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
		return [ null, null, null, rgba[ 3 ] ];
	}
	var r = rgba[ 0 ] / 255,
		g = rgba[ 1 ] / 255,
		b = rgba[ 2 ] / 255,
		a = rgba[ 3 ],
		max = Math.max( r, g, b ),
		min = Math.min( r, g, b ),
		diff = max - min,
		add = max + min,
		l = add * 0.5,
		h, s;

	if ( min === max ) {
		h = 0;
	} else if ( r === max ) {
		h = ( 60 * ( g - b ) / diff ) + 360;
	} else if ( g === max ) {
		h = ( 60 * ( b - r ) / diff ) + 120;
	} else {
		h = ( 60 * ( r - g ) / diff ) + 240;
	}

	// chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
	// otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
	if ( diff === 0 ) {
		s = 0;
	} else if ( l <= 0.5 ) {
		s = diff / add;
	} else {
		s = diff / ( 2 - add );
	}
	return [ Math.round( h ) % 360, s, l, a == null ? 1 : a ];
};

spaces.hsla.from = function( hsla ) {
	if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
		return [ null, null, null, hsla[ 3 ] ];
	}
	var h = hsla[ 0 ] / 360,
		s = hsla[ 1 ],
		l = hsla[ 2 ],
		a = hsla[ 3 ],
		q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
		p = 2 * l - q;

	return [
		Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
		Math.round( hue2rgb( p, q, h ) * 255 ),
		Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
		a
	];
};


each( spaces, function( spaceName, space ) {
	var props = space.props,
		cache = space.cache,
		to = space.to,
		from = space.from;

	// makes rgba() and hsla()
	color.fn[ spaceName ] = function( value ) {

		// generate a cache for this space if it doesn't exist
		if ( to && !this[ cache ] ) {
			this[ cache ] = to( this._rgba );
		}
		if ( value === undefined ) {
			return this[ cache ].slice();
		}

		var ret,
			type = getType( value ),
			arr = ( type === "array" || type === "object" ) ? value : arguments,
			local = this[ cache ].slice();

		each( props, function( key, prop ) {
			var val = arr[ type === "object" ? key : prop.idx ];
			if ( val == null ) {
				val = local[ prop.idx ];
			}
			local[ prop.idx ] = clamp( val, prop );
		} );

		if ( from ) {
			ret = color( from( local ) );
			ret[ cache ] = local;
			return ret;
		} else {
			return color( local );
		}
	};

	// makes red() green() blue() alpha() hue() saturation() lightness()
	each( props, function( key, prop ) {

		// alpha is included in more than one space
		if ( color.fn[ key ] ) {
			return;
		}
		color.fn[ key ] = function( value ) {
			var local, cur, match, fn,
				vtype = getType( value );

			if ( key === "alpha" ) {
				fn = this._hsla ? "hsla" : "rgba";
			} else {
				fn = spaceName;
			}
			local = this[ fn ]();
			cur = local[ prop.idx ];

			if ( vtype === "undefined" ) {
				return cur;
			}

			if ( vtype === "function" ) {
				value = value.call( this, cur );
				vtype = getType( value );
			}
			if ( value == null && prop.empty ) {
				return this;
			}
			if ( vtype === "string" ) {
				match = rplusequals.exec( value );
				if ( match ) {
					value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
				}
			}
			local[ prop.idx ] = value;
			return this[ fn ]( local );
		};
	} );
} );

// add cssHook and .fx.step function for each named hook.
// accept a space separated string of properties
color.hook = function( hook ) {
	var hooks = hook.split( " " );
	each( hooks, function( _i, hook ) {
		jQuery.cssHooks[ hook ] = {
			set: function( elem, value ) {
				var parsed;

				if ( value !== "transparent" &&
					( getType( value ) !== "string" ||
						( parsed = stringParse( value ) ) ) ) {
					value = color( parsed || value );
					value = value.toRgbaString();
				}
				elem.style[ hook ] = value;
			}
		};
		jQuery.fx.step[ hook ] = function( fx ) {
			if ( !fx.colorInit ) {
				fx.start = color( fx.elem, hook );
				fx.end = color( fx.end );
				fx.colorInit = true;
			}
			jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
		};
	} );

};

color.hook( stepHooks );

jQuery.cssHooks.borderColor = {
	expand: function( value ) {
		var expanded = {};

		each( [ "Top", "Right", "Bottom", "Left" ], function( _i, part ) {
			expanded[ "border" + part + "Color" ] = value;
		} );
		return expanded;
	}
};

// Basic color names only.
// Usage of any of the other color names requires adding yourself or including
// jquery.color.svg-names.js.
colors = jQuery.Color.names = {

	// 4.1. Basic color keywords
	aqua: "#00ffff",
	black: "#000000",
	blue: "#0000ff",
	fuchsia: "#ff00ff",
	gray: "#808080",
	green: "#008000",
	lime: "#00ff00",
	maroon: "#800000",
	navy: "#000080",
	olive: "#808000",
	purple: "#800080",
	red: "#ff0000",
	silver: "#c0c0c0",
	teal: "#008080",
	white: "#ffffff",
	yellow: "#ffff00",

	// 4.2.3. "transparent" color keyword
	transparent: [ null, null, null, 0 ],

	_default: "#ffffff"
};


/*!
 * jQuery UI Effects 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Effects Core
//>>group: Effects
//>>description: Extends the internal jQuery effects. Includes morphing and easing. Required by all other effects.
//>>docs: https://api.jqueryui.com/category/effects-core/
//>>demos: https://jqueryui.com/effect/


var dataSpace = "ui-effects-",
	dataSpaceStyle = "ui-effects-style",
	dataSpaceAnimated = "ui-effects-animated";

$.effects = {
	effect: {}
};

/******************************************************************************/
/****************************** CLASS ANIMATIONS ******************************/
/******************************************************************************/
( function() {

var classAnimationActions = [ "add", "remove", "toggle" ],
	shorthandStyles = {
		border: 1,
		borderBottom: 1,
		borderColor: 1,
		borderLeft: 1,
		borderRight: 1,
		borderTop: 1,
		borderWidth: 1,
		margin: 1,
		padding: 1
	};

$.each(
	[ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ],
	function( _, prop ) {
		$.fx.step[ prop ] = function( fx ) {
			if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
				jQuery.style( fx.elem, prop, fx.end );
				fx.setAttr = true;
			}
		};
	}
);

function camelCase( string ) {
	return string.replace( /-([\da-z])/gi, function( all, letter ) {
		return letter.toUpperCase();
	} );
}

function getElementStyles( elem ) {
	var key, len,
		style = elem.ownerDocument.defaultView.getComputedStyle( elem ),
		styles = {};

	len = style.length;
	while ( len-- ) {
		key = style[ len ];
		if ( typeof style[ key ] === "string" ) {
			styles[ camelCase( key ) ] = style[ key ];
		}
	}

	return styles;
}

function styleDifference( oldStyle, newStyle ) {
	var diff = {},
		name, value;

	for ( name in newStyle ) {
		value = newStyle[ name ];
		if ( oldStyle[ name ] !== value ) {
			if ( !shorthandStyles[ name ] ) {
				if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
					diff[ name ] = value;
				}
			}
		}
	}

	return diff;
}

$.effects.animateClass = function( value, duration, easing, callback ) {
	var o = $.speed( duration, easing, callback );

	return this.queue( function() {
		var animated = $( this ),
			baseClass = animated.attr( "class" ) || "",
			applyClassChange,
			allAnimations = o.children ? animated.find( "*" ).addBack() : animated;

		// Map the animated objects to store the original styles.
		allAnimations = allAnimations.map( function() {
			var el = $( this );
			return {
				el: el,
				start: getElementStyles( this )
			};
		} );

		// Apply class change
		applyClassChange = function() {
			$.each( classAnimationActions, function( i, action ) {
				if ( value[ action ] ) {
					animated[ action + "Class" ]( value[ action ] );
				}
			} );
		};
		applyClassChange();

		// Map all animated objects again - calculate new styles and diff
		allAnimations = allAnimations.map( function() {
			this.end = getElementStyles( this.el[ 0 ] );
			this.diff = styleDifference( this.start, this.end );
			return this;
		} );

		// Apply original class
		animated.attr( "class", baseClass );

		// Map all animated objects again - this time collecting a promise
		allAnimations = allAnimations.map( function() {
			var styleInfo = this,
				dfd = $.Deferred(),
				opts = $.extend( {}, o, {
					queue: false,
					complete: function() {
						dfd.resolve( styleInfo );
					}
				} );

			this.el.animate( this.diff, opts );
			return dfd.promise();
		} );

		// Once all animations have completed:
		$.when.apply( $, allAnimations.get() ).done( function() {

			// Set the final class
			applyClassChange();

			// For each animated element,
			// clear all css properties that were animated
			$.each( arguments, function() {
				var el = this.el;
				$.each( this.diff, function( key ) {
					el.css( key, "" );
				} );
			} );

			// This is guarnteed to be there if you use jQuery.speed()
			// it also handles dequeuing the next anim...
			o.complete.call( animated[ 0 ] );
		} );
	} );
};

$.fn.extend( {
	addClass: ( function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return speed ?
				$.effects.animateClass.call( this,
					{ add: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	} )( $.fn.addClass ),

	removeClass: ( function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return arguments.length > 1 ?
				$.effects.animateClass.call( this,
					{ remove: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	} )( $.fn.removeClass ),

	toggleClass: ( function( orig ) {
		return function( classNames, force, speed, easing, callback ) {
			if ( typeof force === "boolean" || force === undefined ) {
				if ( !speed ) {

					// Without speed parameter
					return orig.apply( this, arguments );
				} else {
					return $.effects.animateClass.call( this,
						( force ? { add: classNames } : { remove: classNames } ),
						speed, easing, callback );
				}
			} else {

				// Without force parameter
				return $.effects.animateClass.call( this,
					{ toggle: classNames }, force, speed, easing );
			}
		};
	} )( $.fn.toggleClass ),

	switchClass: function( remove, add, speed, easing, callback ) {
		return $.effects.animateClass.call( this, {
			add: add,
			remove: remove
		}, speed, easing, callback );
	}
} );

} )();

/******************************************************************************/
/*********************************** EFFECTS **********************************/
/******************************************************************************/

( function() {

if ( $.expr && $.expr.pseudos && $.expr.pseudos.animated ) {
	$.expr.pseudos.animated = ( function( orig ) {
		return function( elem ) {
			return !!$( elem ).data( dataSpaceAnimated ) || orig( elem );
		};
	} )( $.expr.pseudos.animated );
}

if ( $.uiBackCompat === true ) {
	$.extend( $.effects, {

		// Saves a set of properties in a data storage
		save: function( element, set ) {
			var i = 0, length = set.length;
			for ( ; i < length; i++ ) {
				if ( set[ i ] !== null ) {
					element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
				}
			}
		},

		// Restores a set of previously saved properties from a data storage
		restore: function( element, set ) {
			var val, i = 0, length = set.length;
			for ( ; i < length; i++ ) {
				if ( set[ i ] !== null ) {
					val = element.data( dataSpace + set[ i ] );
					element.css( set[ i ], val );
				}
			}
		},

		setMode: function( el, mode ) {
			if ( mode === "toggle" ) {
				mode = el.is( ":hidden" ) ? "show" : "hide";
			}
			return mode;
		},

		// Wraps the element around a wrapper that copies position properties
		createWrapper: function( element ) {

			// If the element is already wrapped, return it
			if ( element.parent().is( ".ui-effects-wrapper" ) ) {
				return element.parent();
			}

			// Wrap the element
			var props = {
					width: element.outerWidth( true ),
					height: element.outerHeight( true ),
					"float": element.css( "float" )
				},
				wrapper = $( "<div></div>" )
					.addClass( "ui-effects-wrapper" )
					.css( {
						fontSize: "100%",
						background: "transparent",
						border: "none",
						margin: 0,
						padding: 0
					} ),

				// Store the size in case width/height are defined in % - Fixes #5245
				size = {
					width: element.width(),
					height: element.height()
				},
				active = document.activeElement;

			// Support: Firefox
			// Firefox incorrectly exposes anonymous content
			// https://bugzilla.mozilla.org/show_bug.cgi?id=561664
			try {
				// eslint-disable-next-line no-unused-expressions
				active.id;
			} catch ( _e ) {
				active = document.body;
			}

			element.wrap( wrapper );

			// Fixes #7595 - Elements lose focus when wrapped.
			if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
				$( active ).trigger( "focus" );
			}

			// Hotfix for jQuery 1.4 since some change in wrap() seems to actually
			// lose the reference to the wrapped element
			wrapper = element.parent();

			// Transfer positioning properties to the wrapper
			if ( element.css( "position" ) === "static" ) {
				wrapper.css( { position: "relative" } );
				element.css( { position: "relative" } );
			} else {
				$.extend( props, {
					position: element.css( "position" ),
					zIndex: element.css( "z-index" )
				} );
				$.each( [ "top", "left", "bottom", "right" ], function( i, pos ) {
					props[ pos ] = element.css( pos );
					if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
						props[ pos ] = "auto";
					}
				} );
				element.css( {
					position: "relative",
					top: 0,
					left: 0,
					right: "auto",
					bottom: "auto"
				} );
			}
			element.css( size );

			return wrapper.css( props ).show();
		},

		removeWrapper: function( element ) {
			var active = document.activeElement;

			if ( element.parent().is( ".ui-effects-wrapper" ) ) {
				element.parent().replaceWith( element );

				// Fixes #7595 - Elements lose focus when wrapped.
				if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
					$( active ).trigger( "focus" );
				}
			}

			return element;
		}
	} );
}

$.extend( $.effects, {
	version: "1.14.2",

	define: function( name, mode, effect ) {
		if ( !effect ) {
			effect = mode;
			mode = "effect";
		}

		$.effects.effect[ name ] = effect;
		$.effects.effect[ name ].mode = mode;

		return effect;
	},

	scaledDimensions: function( element, percent, direction ) {
		if ( percent === 0 ) {
			return {
				height: 0,
				width: 0,
				outerHeight: 0,
				outerWidth: 0
			};
		}

		var x = direction !== "horizontal" ? ( ( percent || 100 ) / 100 ) : 1,
			y = direction !== "vertical" ? ( ( percent || 100 ) / 100 ) : 1;

		return {
			height: element.height() * y,
			width: element.width() * x,
			outerHeight: element.outerHeight() * y,
			outerWidth: element.outerWidth() * x
		};

	},

	clipToBox: function( animation ) {
		return {
			width: animation.clip.right - animation.clip.left,
			height: animation.clip.bottom - animation.clip.top,
			left: animation.clip.left,
			top: animation.clip.top
		};
	},

	// Injects recently queued functions to be first in line (after "inprogress")
	unshift: function( element, queueLength, count ) {
		var queue = element.queue();

		if ( queueLength > 1 ) {
			queue.splice.apply( queue,
				[ 1, 0 ].concat( queue.splice( queueLength, count ) ) );
		}
		element.dequeue();
	},

	saveStyle: function( element ) {
		element.data( dataSpaceStyle, element[ 0 ].style.cssText );
	},

	restoreStyle: function( element ) {
		element[ 0 ].style.cssText = element.data( dataSpaceStyle ) || "";
		element.removeData( dataSpaceStyle );
	},

	mode: function( element, mode ) {
		var hidden = element.is( ":hidden" );

		if ( mode === "toggle" ) {
			mode = hidden ? "show" : "hide";
		}
		if ( hidden ? mode === "hide" : mode === "show" ) {
			mode = "none";
		}
		return mode;
	},

	// Translates a [top,left] array into a baseline value
	getBaseline: function( origin, original ) {
		var y, x;

		switch ( origin[ 0 ] ) {
		case "top":
			y = 0;
			break;
		case "middle":
			y = 0.5;
			break;
		case "bottom":
			y = 1;
			break;
		default:
			y = origin[ 0 ] / original.height;
		}

		switch ( origin[ 1 ] ) {
		case "left":
			x = 0;
			break;
		case "center":
			x = 0.5;
			break;
		case "right":
			x = 1;
			break;
		default:
			x = origin[ 1 ] / original.width;
		}

		return {
			x: x,
			y: y
		};
	},

	// Creates a placeholder element so that the original element can be made absolute
	createPlaceholder: function( element ) {
		var placeholder,
			cssPosition = element.css( "position" ),
			position = element.position();

		// Lock in margins first to account for form elements, which
		// will change margin if you explicitly set height
		// see: https://jsfiddle.net/JZSMt/3/ https://bugs.webkit.org/show_bug.cgi?id=107380
		// Support: Safari
		element.css( {
			marginTop: element.css( "marginTop" ),
			marginBottom: element.css( "marginBottom" ),
			marginLeft: element.css( "marginLeft" ),
			marginRight: element.css( "marginRight" )
		} )
		.outerWidth( element.outerWidth() )
		.outerHeight( element.outerHeight() );

		if ( /^(static|relative)/.test( cssPosition ) ) {
			cssPosition = "absolute";

			placeholder = $( "<" + element[ 0 ].nodeName + ">" ).insertAfter( element ).css( {

				// Convert inline to inline block to account for inline elements
				// that turn to inline block based on content (like img)
				display: /^(inline|ruby)/.test( element.css( "display" ) ) ?
					"inline-block" :
					"block",
				visibility: "hidden",

				// Margins need to be set to account for margin collapse
				marginTop: element.css( "marginTop" ),
				marginBottom: element.css( "marginBottom" ),
				marginLeft: element.css( "marginLeft" ),
				marginRight: element.css( "marginRight" ),
				"float": element.css( "float" )
			} )
			.outerWidth( element.outerWidth() )
			.outerHeight( element.outerHeight() )
			.addClass( "ui-effects-placeholder" );

			element.data( dataSpace + "placeholder", placeholder );
		}

		element.css( {
			position: cssPosition,
			left: position.left,
			top: position.top
		} );

		return placeholder;
	},

	removePlaceholder: function( element ) {
		var dataKey = dataSpace + "placeholder",
				placeholder = element.data( dataKey );

		if ( placeholder ) {
			placeholder.remove();
			element.removeData( dataKey );
		}
	},

	// Removes a placeholder if it exists and restores
	// properties that were modified during placeholder creation
	cleanUp: function( element ) {
		$.effects.restoreStyle( element );
		$.effects.removePlaceholder( element );
	},

	setTransition: function( element, list, factor, value ) {
		value = value || {};
		$.each( list, function( i, x ) {
			var unit = element.cssUnit( x );
			if ( unit[ 0 ] > 0 ) {
				value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
			}
		} );
		return value;
	}
} );

// Return an effect options object for the given parameters:
function _normalizeArguments( effect, options, speed, callback ) {

	// Allow passing all options as the first parameter
	if ( $.isPlainObject( effect ) ) {
		options = effect;
		effect = effect.effect;
	}

	// Convert to an object
	effect = { effect: effect };

	// Catch (effect, null, ...)
	if ( options == null ) {
		options = {};
	}

	// Catch (effect, callback)
	if ( typeof options === "function" ) {
		callback = options;
		speed = null;
		options = {};
	}

	// Catch (effect, speed, ?)
	if ( typeof options === "number" || $.fx.speeds[ options ] ) {
		callback = speed;
		speed = options;
		options = {};
	}

	// Catch (effect, options, callback)
	if ( typeof speed === "function" ) {
		callback = speed;
		speed = null;
	}

	// Add options to effect
	if ( options ) {
		$.extend( effect, options );
	}

	speed = speed || options.duration;
	effect.duration = $.fx.off ? 0 :
		typeof speed === "number" ? speed :
		speed in $.fx.speeds ? $.fx.speeds[ speed ] :
		$.fx.speeds._default;

	effect.complete = callback || options.complete;

	return effect;
}

function standardAnimationOption( option ) {

	// Valid standard speeds (nothing, number, named speed)
	if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
		return true;
	}

	// Invalid strings - treat as "normal" speed
	if ( typeof option === "string" && !$.effects.effect[ option ] ) {
		return true;
	}

	// Complete callback
	if ( typeof option === "function" ) {
		return true;
	}

	// Options hash (but not naming an effect)
	if ( typeof option === "object" && !option.effect ) {
		return true;
	}

	// Didn't match any standard API
	return false;
}

$.fn.extend( {
	effect: function( /* effect, options, speed, callback */ ) {
		var args = _normalizeArguments.apply( this, arguments ),
			effectMethod = $.effects.effect[ args.effect ],
			defaultMode = effectMethod.mode,
			queue = args.queue,
			queueName = queue || "fx",
			complete = args.complete,
			mode = args.mode,
			modes = [],
			prefilter = function( next ) {
				var el = $( this ),
					normalizedMode = $.effects.mode( el, mode ) || defaultMode;

				// Sentinel for duck-punching the :animated pseudo-selector
				el.data( dataSpaceAnimated, true );

				// Save effect mode for later use,
				// we can't just call $.effects.mode again later,
				// as the .show() below destroys the initial state
				modes.push( normalizedMode );

				// See $.uiBackCompat inside of run() for removal of defaultMode in 1.14
				if ( defaultMode && ( normalizedMode === "show" ||
						( normalizedMode === defaultMode && normalizedMode === "hide" ) ) ) {
					el.show();
				}

				if ( !defaultMode || normalizedMode !== "none" ) {
					$.effects.saveStyle( el );
				}

				if ( typeof next === "function" ) {
					next();
				}
			};

		if ( $.fx.off || !effectMethod ) {

			// Delegate to the original method (e.g., .show()) if possible
			if ( mode ) {
				return this[ mode ]( args.duration, complete );
			} else {
				return this.each( function() {
					if ( complete ) {
						complete.call( this );
					}
				} );
			}
		}

		function run( next ) {
			var elem = $( this );

			function cleanup() {
				elem.removeData( dataSpaceAnimated );

				$.effects.cleanUp( elem );

				if ( args.mode === "hide" ) {
					elem.hide();
				}

				done();
			}

			function done() {
				if ( typeof complete === "function" ) {
					complete.call( elem[ 0 ] );
				}

				if ( typeof next === "function" ) {
					next();
				}
			}

			// Override mode option on a per element basis,
			// as toggle can be either show or hide depending on element state
			args.mode = modes.shift();

			if ( $.uiBackCompat === true && !defaultMode ) {
				if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {

					// Call the core method to track "olddisplay" properly
					elem[ mode ]();
					done();
				} else {
					effectMethod.call( elem[ 0 ], args, done );
				}
			} else {
				if ( args.mode === "none" ) {

					// Call the core method to track "olddisplay" properly
					elem[ mode ]();
					done();
				} else {
					effectMethod.call( elem[ 0 ], args, cleanup );
				}
			}
		}

		// Run prefilter on all elements first to ensure that
		// any showing or hiding happens before placeholder creation,
		// which ensures that any layout changes are correctly captured.
		return queue === false ?
			this.each( prefilter ).each( run ) :
			this.queue( queueName, prefilter ).queue( queueName, run );
	},

	show: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "show";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.show ),

	hide: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "hide";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.hide ),

	toggle: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "toggle";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.toggle ),

	cssUnit: function( key ) {
		var style = this.css( key ),
			val = [];

		$.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
			if ( style.indexOf( unit ) > 0 ) {
				val = [ parseFloat( style ), unit ];
			}
		} );
		return val;
	},

	cssClip: function( clipObj ) {
		if ( clipObj ) {
			return this.css( "clip", "rect(" + clipObj.top + "px " + clipObj.right + "px " +
				clipObj.bottom + "px " + clipObj.left + "px)" );
		}
		return parseClip( this.css( "clip" ), this );
	},

	transfer: function( options, done ) {
		var element = $( this ),
			target = $( options.to ),
			targetFixed = target.css( "position" ) === "fixed",
			body = $( "body" ),
			fixTop = targetFixed ? body.scrollTop() : 0,
			fixLeft = targetFixed ? body.scrollLeft() : 0,
			endPosition = target.offset(),
			animation = {
				top: endPosition.top - fixTop,
				left: endPosition.left - fixLeft,
				height: target.innerHeight(),
				width: target.innerWidth()
			},
			startPosition = element.offset(),
			transfer = $( "<div class='ui-effects-transfer'></div>" );

		transfer
			.appendTo( "body" )
			.addClass( options.className )
			.css( {
				top: startPosition.top - fixTop,
				left: startPosition.left - fixLeft,
				height: element.innerHeight(),
				width: element.innerWidth(),
				position: targetFixed ? "fixed" : "absolute"
			} )
			.animate( animation, options.duration, options.easing, function() {
				transfer.remove();
				if ( typeof done === "function" ) {
					done();
				}
			} );
	}
} );

function parseClip( str, element ) {
		var outerWidth = element.outerWidth(),
			outerHeight = element.outerHeight(),
			clipRegex = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
			values = clipRegex.exec( str ) || [ "", 0, outerWidth, outerHeight, 0 ];

		return {
			top: parseFloat( values[ 1 ] ) || 0,
			right: values[ 2 ] === "auto" ? outerWidth : parseFloat( values[ 2 ] ),
			bottom: values[ 3 ] === "auto" ? outerHeight : parseFloat( values[ 3 ] ),
			left: parseFloat( values[ 4 ] ) || 0
		};
}

$.fx.step.clip = function( fx ) {
	if ( !fx.clipInit ) {
		fx.start = $( fx.elem ).cssClip();
		if ( typeof fx.end === "string" ) {
			fx.end = parseClip( fx.end, fx.elem );
		}
		fx.clipInit = true;
	}

	$( fx.elem ).cssClip( {
		top: fx.pos * ( fx.end.top - fx.start.top ) + fx.start.top,
		right: fx.pos * ( fx.end.right - fx.start.right ) + fx.start.right,
		bottom: fx.pos * ( fx.end.bottom - fx.start.bottom ) + fx.start.bottom,
		left: fx.pos * ( fx.end.left - fx.start.left ) + fx.start.left
	} );
};

} )();

/******************************************************************************/
/*********************************** EASING ***********************************/
/******************************************************************************/

( function() {

// Based on easing equations from Robert Penner (http://robertpenner.com/easing)

var baseEasings = {};

$.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
	baseEasings[ name ] = function( p ) {
		return Math.pow( p, i + 2 );
	};
} );

$.extend( baseEasings, {
	Sine: function( p ) {
		return 1 - Math.cos( p * Math.PI / 2 );
	},
	Circ: function( p ) {
		return 1 - Math.sqrt( 1 - p * p );
	},
	Elastic: function( p ) {
		return p === 0 || p === 1 ? p :
			-Math.pow( 2, 8 * ( p - 1 ) ) * Math.sin( ( ( p - 1 ) * 80 - 7.5 ) * Math.PI / 15 );
	},
	Back: function( p ) {
		return p * p * ( 3 * p - 2 );
	},
	Bounce: function( p ) {
		var pow2,
			bounce = 4;

		while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
		return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
	}
} );

$.each( baseEasings, function( name, easeIn ) {
	$.easing[ "easeIn" + name ] = easeIn;
	$.easing[ "easeOut" + name ] = function( p ) {
		return 1 - easeIn( 1 - p );
	};
	$.easing[ "easeInOut" + name ] = function( p ) {
		return p < 0.5 ?
			easeIn( p * 2 ) / 2 :
			1 - easeIn( p * -2 + 2 ) / 2;
	};
} );

} )();

var effect = $.effects;


/*!
 * jQuery UI Effects Blind 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Blind Effect
//>>group: Effects
//>>description: Blinds the element.
//>>docs: https://api.jqueryui.com/blind-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectBlind = $.effects.define( "blind", "hide", function( options, done ) {
	var map = {
			up: [ "bottom", "top" ],
			vertical: [ "bottom", "top" ],
			down: [ "top", "bottom" ],
			left: [ "right", "left" ],
			horizontal: [ "right", "left" ],
			right: [ "left", "right" ]
		},
		element = $( this ),
		direction = options.direction || "up",
		start = element.cssClip(),
		animate = { clip: $.extend( {}, start ) },
		placeholder = $.effects.createPlaceholder( element );

	animate.clip[ map[ direction ][ 0 ] ] = animate.clip[ map[ direction ][ 1 ] ];

	if ( options.mode === "show" ) {
		element.cssClip( animate.clip );
		if ( placeholder ) {
			placeholder.css( $.effects.clipToBox( animate ) );
		}

		animate.clip = start;
	}

	if ( placeholder ) {
		placeholder.animate( $.effects.clipToBox( animate ), options.duration, options.easing );
	}

	element.animate( animate, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Bounce 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Bounce Effect
//>>group: Effects
//>>description: Bounces an element horizontally or vertically n times.
//>>docs: https://api.jqueryui.com/bounce-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectBounce = $.effects.define( "bounce", function( options, done ) {
	var upAnim, downAnim, refValue,
		element = $( this ),

		// Defaults:
		mode = options.mode,
		hide = mode === "hide",
		show = mode === "show",
		direction = options.direction || "up",
		distance = options.distance,
		times = options.times || 5,

		// Number of internal animations
		anims = times * 2 + ( show || hide ? 1 : 0 ),
		speed = options.duration / anims,
		easing = options.easing,

		// Utility:
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ),
		i = 0,

		queuelen = element.queue().length;

	$.effects.createPlaceholder( element );

	refValue = element.css( ref );

	// Default distance for the BIGGEST bounce is the outer Distance / 3
	if ( !distance ) {
		distance = element[ ref === "top" ? "outerHeight" : "outerWidth" ]() / 3;
	}

	if ( show ) {
		downAnim = { opacity: 1 };
		downAnim[ ref ] = refValue;

		// If we are showing, force opacity 0 and set the initial position
		// then do the "first" animation
		element
			.css( "opacity", 0 )
			.css( ref, motion ? -distance * 2 : distance * 2 )
			.animate( downAnim, speed, easing );
	}

	// Start at the smallest distance if we are hiding
	if ( hide ) {
		distance = distance / Math.pow( 2, times - 1 );
	}

	downAnim = {};
	downAnim[ ref ] = refValue;

	// Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
	for ( ; i < times; i++ ) {
		upAnim = {};
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		element
			.animate( upAnim, speed, easing )
			.animate( downAnim, speed, easing );

		distance = hide ? distance * 2 : distance / 2;
	}

	// Last Bounce when Hiding
	if ( hide ) {
		upAnim = { opacity: 0 };
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		element.animate( upAnim, speed, easing );
	}

	element.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Clip 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Clip Effect
//>>group: Effects
//>>description: Clips the element on and off like an old TV.
//>>docs: https://api.jqueryui.com/clip-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectClip = $.effects.define( "clip", "hide", function( options, done ) {
	var start,
		animate = {},
		element = $( this ),
		direction = options.direction || "vertical",
		both = direction === "both",
		horizontal = both || direction === "horizontal",
		vertical = both || direction === "vertical";

	start = element.cssClip();
	animate.clip = {
		top: vertical ? ( start.bottom - start.top ) / 2 : start.top,
		right: horizontal ? ( start.right - start.left ) / 2 : start.right,
		bottom: vertical ? ( start.bottom - start.top ) / 2 : start.bottom,
		left: horizontal ? ( start.right - start.left ) / 2 : start.left
	};

	$.effects.createPlaceholder( element );

	if ( options.mode === "show" ) {
		element.cssClip( animate.clip );
		animate.clip = start;
	}

	element.animate( animate, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );

} );


/*!
 * jQuery UI Effects Drop 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Drop Effect
//>>group: Effects
//>>description: Moves an element in one direction and hides it at the same time.
//>>docs: https://api.jqueryui.com/drop-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectDrop = $.effects.define( "drop", "hide", function( options, done ) {

	var distance,
		element = $( this ),
		mode = options.mode,
		show = mode === "show",
		direction = options.direction || "left",
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ) ? "-=" : "+=",
		oppositeMotion = ( motion === "+=" ) ? "-=" : "+=",
		animation = {
			opacity: 0
		};

	$.effects.createPlaceholder( element );

	distance = options.distance ||
		element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ) / 2;

	animation[ ref ] = motion + distance;

	if ( show ) {
		element.css( animation );

		animation[ ref ] = oppositeMotion + distance;
		animation.opacity = 1;
	}

	// Animate
	element.animate( animation, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Explode 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Explode Effect
//>>group: Effects
//>>description: Explodes an element in all directions into n pieces. Implodes an element to its original wholeness.
//>>docs: https://api.jqueryui.com/explode-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectExplode = $.effects.define( "explode", "hide", function( options, done ) {

	var i, j, left, top, mx, my,
		rows = options.pieces ? Math.round( Math.sqrt( options.pieces ) ) : 3,
		cells = rows,
		element = $( this ),
		mode = options.mode,
		show = mode === "show",

		// Show and then visibility:hidden the element before calculating offset
		offset = element.show().css( "visibility", "hidden" ).offset(),

		// Width and height of a piece
		width = Math.ceil( element.outerWidth() / cells ),
		height = Math.ceil( element.outerHeight() / rows ),
		pieces = [];

	// Children animate complete:
	function childComplete() {
		pieces.push( this );
		if ( pieces.length === rows * cells ) {
			animComplete();
		}
	}

	// Clone the element for each row and cell.
	for ( i = 0; i < rows; i++ ) { // ===>
		top = offset.top + i * height;
		my = i - ( rows - 1 ) / 2;

		for ( j = 0; j < cells; j++ ) { // |||
			left = offset.left + j * width;
			mx = j - ( cells - 1 ) / 2;

			// Create a clone of the now hidden main element that will be absolute positioned
			// within a wrapper div off the -left and -top equal to size of our pieces
			element
				.clone()
				.appendTo( "body" )
				.wrap( "<div></div>" )
				.css( {
					position: "absolute",
					visibility: "visible",
					left: -j * width,
					top: -i * height
				} )

				// Select the wrapper - make it overflow: hidden and absolute positioned based on
				// where the original was located +left and +top equal to the size of pieces
				.parent()
					.addClass( "ui-effects-explode" )
					.css( {
						position: "absolute",
						overflow: "hidden",
						width: width,
						height: height,
						left: left + ( show ? mx * width : 0 ),
						top: top + ( show ? my * height : 0 ),
						opacity: show ? 0 : 1
					} )
					.animate( {
						left: left + ( show ? 0 : mx * width ),
						top: top + ( show ? 0 : my * height ),
						opacity: show ? 1 : 0
					}, options.duration || 500, options.easing, childComplete );
		}
	}

	function animComplete() {
		element.css( {
			visibility: "visible"
		} );
		$( pieces ).remove();
		done();
	}
} );


/*!
 * jQuery UI Effects Fade 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Fade Effect
//>>group: Effects
//>>description: Fades the element.
//>>docs: https://api.jqueryui.com/fade-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectFade = $.effects.define( "fade", "toggle", function( options, done ) {
	var show = options.mode === "show";

	$( this )
		.css( "opacity", show ? 0 : 1 )
		.animate( {
			opacity: show ? 1 : 0
		}, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
} );


/*!
 * jQuery UI Effects Fold 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Fold Effect
//>>group: Effects
//>>description: Folds an element first horizontally and then vertically.
//>>docs: https://api.jqueryui.com/fold-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectFold = $.effects.define( "fold", "hide", function( options, done ) {

	// Create element
	var element = $( this ),
		mode = options.mode,
		show = mode === "show",
		hide = mode === "hide",
		size = options.size || 15,
		percent = /([0-9]+)%/.exec( size ),
		horizFirst = !!options.horizFirst,
		ref = horizFirst ? [ "right", "bottom" ] : [ "bottom", "right" ],
		duration = options.duration / 2,

		placeholder = $.effects.createPlaceholder( element ),

		start = element.cssClip(),
		animation1 = { clip: $.extend( {}, start ) },
		animation2 = { clip: $.extend( {}, start ) },

		distance = [ start[ ref[ 0 ] ], start[ ref[ 1 ] ] ],

		queuelen = element.queue().length;

	if ( percent ) {
		size = parseInt( percent[ 1 ], 10 ) / 100 * distance[ hide ? 0 : 1 ];
	}
	animation1.clip[ ref[ 0 ] ] = size;
	animation2.clip[ ref[ 0 ] ] = size;
	animation2.clip[ ref[ 1 ] ] = 0;

	if ( show ) {
		element.cssClip( animation2.clip );
		if ( placeholder ) {
			placeholder.css( $.effects.clipToBox( animation2 ) );
		}

		animation2.clip = start;
	}

	// Animate
	element
		.queue( function( next ) {
			if ( placeholder ) {
				placeholder
					.animate( $.effects.clipToBox( animation1 ), duration, options.easing )
					.animate( $.effects.clipToBox( animation2 ), duration, options.easing );
			}

			next();
		} )
		.animate( animation1, duration, options.easing )
		.animate( animation2, duration, options.easing )
		.queue( done );

	$.effects.unshift( element, queuelen, 4 );
} );


/*!
 * jQuery UI Effects Highlight 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Highlight Effect
//>>group: Effects
//>>description: Highlights the background of an element in a defined color for a custom duration.
//>>docs: https://api.jqueryui.com/highlight-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectHighlight = $.effects.define( "highlight", "show", function( options, done ) {
	var element = $( this ),
		animation = {
			backgroundColor: element.css( "backgroundColor" )
		};

	if ( options.mode === "hide" ) {
		animation.opacity = 0;
	}

	$.effects.saveStyle( element );

	element
		.css( {
			backgroundImage: "none",
			backgroundColor: options.color || "#ffff99"
		} )
		.animate( animation, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
} );


/*!
 * jQuery UI Effects Size 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Size Effect
//>>group: Effects
//>>description: Resize an element to a specified width and height.
//>>docs: https://api.jqueryui.com/size-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectSize = $.effects.define( "size", function( options, done ) {

	// Create element
	var baseline, factor, temp,
		element = $( this ),

		// Copy for children
		cProps = [ "fontSize" ],
		vProps = [ "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom" ],
		hProps = [ "borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight" ],

		// Set options
		mode = options.mode,
		restore = mode !== "effect",
		scale = options.scale || "both",
		origin = options.origin || [ "middle", "center" ],
		position = element.css( "position" ),
		pos = element.position(),
		original = $.effects.scaledDimensions( element ),
		from = options.from || original,
		to = options.to || $.effects.scaledDimensions( element, 0 );

	$.effects.createPlaceholder( element );

	if ( mode === "show" ) {
		temp = from;
		from = to;
		to = temp;
	}

	// Set scaling factor
	factor = {
		from: {
			y: from.height / original.height,
			x: from.width / original.width
		},
		to: {
			y: to.height / original.height,
			x: to.width / original.width
		}
	};

	// Scale the css box
	if ( scale === "box" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			from = $.effects.setTransition( element, vProps, factor.from.y, from );
			to = $.effects.setTransition( element, vProps, factor.to.y, to );
		}

		// Horizontal props scaling
		if ( factor.from.x !== factor.to.x ) {
			from = $.effects.setTransition( element, hProps, factor.from.x, from );
			to = $.effects.setTransition( element, hProps, factor.to.x, to );
		}
	}

	// Scale the content
	if ( scale === "content" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			from = $.effects.setTransition( element, cProps, factor.from.y, from );
			to = $.effects.setTransition( element, cProps, factor.to.y, to );
		}
	}

	// Adjust the position properties based on the provided origin points
	if ( origin ) {
		baseline = $.effects.getBaseline( origin, original );
		from.top = ( original.outerHeight - from.outerHeight ) * baseline.y + pos.top;
		from.left = ( original.outerWidth - from.outerWidth ) * baseline.x + pos.left;
		to.top = ( original.outerHeight - to.outerHeight ) * baseline.y + pos.top;
		to.left = ( original.outerWidth - to.outerWidth ) * baseline.x + pos.left;
	}
	delete from.outerHeight;
	delete from.outerWidth;
	element.css( from );

	// Animate the children if desired
	if ( scale === "content" || scale === "both" ) {

		vProps = vProps.concat( [ "marginTop", "marginBottom" ] ).concat( cProps );
		hProps = hProps.concat( [ "marginLeft", "marginRight" ] );

		// Only animate children with width attributes specified
		// TODO: is this right? should we include anything with css width specified as well
		element.find( "*[width]" ).each( function() {
			var child = $( this ),
				childOriginal = $.effects.scaledDimensions( child ),
				childFrom = {
					height: childOriginal.height * factor.from.y,
					width: childOriginal.width * factor.from.x,
					outerHeight: childOriginal.outerHeight * factor.from.y,
					outerWidth: childOriginal.outerWidth * factor.from.x
				},
				childTo = {
					height: childOriginal.height * factor.to.y,
					width: childOriginal.width * factor.to.x,
					outerHeight: childOriginal.height * factor.to.y,
					outerWidth: childOriginal.width * factor.to.x
				};

			// Vertical props scaling
			if ( factor.from.y !== factor.to.y ) {
				childFrom = $.effects.setTransition( child, vProps, factor.from.y, childFrom );
				childTo = $.effects.setTransition( child, vProps, factor.to.y, childTo );
			}

			// Horizontal props scaling
			if ( factor.from.x !== factor.to.x ) {
				childFrom = $.effects.setTransition( child, hProps, factor.from.x, childFrom );
				childTo = $.effects.setTransition( child, hProps, factor.to.x, childTo );
			}

			if ( restore ) {
				$.effects.saveStyle( child );
			}

			// Animate children
			child.css( childFrom );
			child.animate( childTo, options.duration, options.easing, function() {

				// Restore children
				if ( restore ) {
					$.effects.restoreStyle( child );
				}
			} );
		} );
	}

	// Animate
	element.animate( to, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: function() {

			var offset = element.offset();

			if ( to.opacity === 0 ) {
				element.css( "opacity", from.opacity );
			}

			if ( !restore ) {
				element
					.css( "position", position === "static" ? "relative" : position )
					.offset( offset );

				// Need to save style here so that automatic style restoration
				// doesn't restore to the original styles from before the animation.
				$.effects.saveStyle( element );
			}

			done();
		}
	} );

} );


/*!
 * jQuery UI Effects Scale 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Scale Effect
//>>group: Effects
//>>description: Grows or shrinks an element and its content.
//>>docs: https://api.jqueryui.com/scale-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectScale = $.effects.define( "scale", function( options, done ) {

	// Create element
	var el = $( this ),
		mode = options.mode,
		percent = parseInt( options.percent, 10 ) ||
			( parseInt( options.percent, 10 ) === 0 ? 0 : ( mode !== "effect" ? 0 : 100 ) ),

		newOptions = $.extend( true, {
			from: $.effects.scaledDimensions( el ),
			to: $.effects.scaledDimensions( el, percent, options.direction || "both" ),
			origin: options.origin || [ "middle", "center" ]
		}, options );

	// Fade option to support puff
	if ( options.fade ) {
		newOptions.from.opacity = 1;
		newOptions.to.opacity = 0;
	}

	$.effects.effect.size.call( this, newOptions, done );
} );


/*!
 * jQuery UI Effects Puff 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Puff Effect
//>>group: Effects
//>>description: Creates a puff effect by scaling the element up and hiding it at the same time.
//>>docs: https://api.jqueryui.com/puff-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectPuff = $.effects.define( "puff", "hide", function( options, done ) {
	var newOptions = $.extend( true, {}, options, {
		fade: true,
		percent: parseInt( options.percent, 10 ) || 150
	} );

	$.effects.effect.scale.call( this, newOptions, done );
} );


/*!
 * jQuery UI Effects Pulsate 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Pulsate Effect
//>>group: Effects
//>>description: Pulsates an element n times by changing the opacity to zero and back.
//>>docs: https://api.jqueryui.com/pulsate-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectPulsate = $.effects.define( "pulsate", "show", function( options, done ) {
	var element = $( this ),
		mode = options.mode,
		show = mode === "show",
		hide = mode === "hide",
		showhide = show || hide,

		// Showing or hiding leaves off the "last" animation
		anims = ( ( options.times || 5 ) * 2 ) + ( showhide ? 1 : 0 ),
		duration = options.duration / anims,
		animateTo = 0,
		i = 1,
		queuelen = element.queue().length;

	if ( show || !element.is( ":visible" ) ) {
		element.css( "opacity", 0 ).show();
		animateTo = 1;
	}

	// Anims - 1 opacity "toggles"
	for ( ; i < anims; i++ ) {
		element.animate( { opacity: animateTo }, duration, options.easing );
		animateTo = 1 - animateTo;
	}

	element.animate( { opacity: animateTo }, duration, options.easing );

	element.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Shake 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Shake Effect
//>>group: Effects
//>>description: Shakes an element horizontally or vertically n times.
//>>docs: https://api.jqueryui.com/shake-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectShake = $.effects.define( "shake", function( options, done ) {

	var i = 1,
		element = $( this ),
		direction = options.direction || "left",
		distance = options.distance || 20,
		times = options.times || 3,
		anims = times * 2 + 1,
		speed = Math.round( options.duration / anims ),
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		positiveMotion = ( direction === "up" || direction === "left" ),
		animation = {},
		animation1 = {},
		animation2 = {},

		queuelen = element.queue().length;

	$.effects.createPlaceholder( element );

	// Animation
	animation[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance;
	animation1[ ref ] = ( positiveMotion ? "+=" : "-=" ) + distance * 2;
	animation2[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance * 2;

	// Animate
	element.animate( animation, speed, options.easing );

	// Shakes
	for ( ; i < times; i++ ) {
		element
			.animate( animation1, speed, options.easing )
			.animate( animation2, speed, options.easing );
	}

	element
		.animate( animation1, speed, options.easing )
		.animate( animation, speed / 2, options.easing )
		.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Slide 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Slide Effect
//>>group: Effects
//>>description: Slides an element in and out of the viewport.
//>>docs: https://api.jqueryui.com/slide-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectSlide = $.effects.define( "slide", "show", function( options, done ) {
	var startClip, startRef,
		element = $( this ),
		map = {
			up: [ "bottom", "top" ],
			down: [ "top", "bottom" ],
			left: [ "right", "left" ],
			right: [ "left", "right" ]
		},
		mode = options.mode,
		direction = options.direction || "left",
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		positiveMotion = ( direction === "up" || direction === "left" ),
		distance = options.distance ||
			element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ),
		animation = {};

	$.effects.createPlaceholder( element );

	startClip = element.cssClip();
	startRef = element.position()[ ref ];

	// Define hide animation
	animation[ ref ] = ( positiveMotion ? -1 : 1 ) * distance + startRef;
	animation.clip = element.cssClip();
	animation.clip[ map[ direction ][ 1 ] ] = animation.clip[ map[ direction ][ 0 ] ];

	// Reverse the animation if we're showing
	if ( mode === "show" ) {
		element.cssClip( animation.clip );
		element.css( ref, animation[ ref ] );
		animation.clip = startClip;
		animation[ ref ] = startRef;
	}

	// Actually animate
	element.animate( animation, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Transfer 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Transfer Effect
//>>group: Effects
//>>description: Displays a transfer effect from one element to another.
//>>docs: https://api.jqueryui.com/transfer-effect/
//>>demos: https://jqueryui.com/effect/


var effect;
if ( $.uiBackCompat === true ) {
	effect = $.effects.define( "transfer", function( options, done ) {
		$( this ).transfer( options, done );
	} );
}
var effectsEffectTransfer = effect;


/*!
 * jQuery UI Focusable 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: :focusable Selector
//>>group: Core
//>>description: Selects elements which can be focused.
//>>docs: https://api.jqueryui.com/focusable-selector/


// Selectors
$.ui.focusable = function( element, hasTabindex ) {
	var map, mapName, img, focusableIfVisible, fieldset,
		nodeName = element.nodeName.toLowerCase();

	if ( "area" === nodeName ) {
		map = element.parentNode;
		mapName = map.name;
		if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
			return false;
		}
		img = $( "img[usemap='#" + mapName + "']" );
		return img.length > 0 && img.is( ":visible" );
	}

	if ( /^(input|select|textarea|button|object)$/.test( nodeName ) ) {
		focusableIfVisible = !element.disabled;

		if ( focusableIfVisible ) {

			// Form controls within a disabled fieldset are disabled.
			// However, controls within the fieldset's legend do not get disabled.
			// Since controls generally aren't placed inside legends, we skip
			// this portion of the check.
			fieldset = $( element ).closest( "fieldset" )[ 0 ];
			if ( fieldset ) {
				focusableIfVisible = !fieldset.disabled;
			}
		}
	} else if ( "a" === nodeName ) {
		focusableIfVisible = element.href || hasTabindex;
	} else {
		focusableIfVisible = hasTabindex;
	}

	return focusableIfVisible && $( element ).is( ":visible" ) &&
		$( element ).css( "visibility" ) === "visible";
};

$.extend( $.expr.pseudos, {
	focusable: function( element ) {
		return $.ui.focusable( element, $.attr( element, "tabindex" ) != null );
	}
} );

var focusable = $.ui.focusable;


/*!
 * jQuery UI Form Reset Mixin 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Form Reset Mixin
//>>group: Core
//>>description: Refresh input widgets when their form is reset
//>>docs: https://api.jqueryui.com/form-reset-mixin/


var formResetMixin = $.ui.formResetMixin = {
	_formResetHandler: function() {
		var form = $( this );

		// Wait for the form reset to actually happen before refreshing
		setTimeout( function() {
			var instances = form.data( "ui-form-reset-instances" );
			$.each( instances, function() {
				this.refresh();
			} );
		} );
	},

	_bindFormResetHandler: function() {
		this.form = $( this.element.prop( "form" ) );
		if ( !this.form.length ) {
			return;
		}

		var instances = this.form.data( "ui-form-reset-instances" ) || [];
		if ( !instances.length ) {

			// We don't use _on() here because we use a single event handler per form
			this.form.on( "reset.ui-form-reset", this._formResetHandler );
		}
		instances.push( this );
		this.form.data( "ui-form-reset-instances", instances );
	},

	_unbindFormResetHandler: function() {
		if ( !this.form.length ) {
			return;
		}

		var instances = this.form.data( "ui-form-reset-instances" );
		instances.splice( $.inArray( this, instances ), 1 );
		if ( instances.length ) {
			this.form.data( "ui-form-reset-instances", instances );
		} else {
			this.form
				.removeData( "ui-form-reset-instances" )
				.off( "reset.ui-form-reset" );
		}
	}
};


/*!
 * jQuery UI Legacy jQuery Core patches 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 *
 */

//>>label: Legacy jQuery Core patches
//>>group: Core
//>>description: Backport `.even()`, `.odd()` and `$.escapeSelector` to older jQuery Core versions (deprecated)


// Support: jQuery 2.2.x or older.
// This method has been defined in jQuery 3.0.0.
// Code from https://github.com/jquery/jquery/blob/e539bac79e666bba95bba86d690b4e609dca2286/src/selector/escapeSelector.js
if ( !$.escapeSelector ) {
	$.escapeSelector = function( id ) {
		return CSS.escape( id + "" );
	};
}

// Support: jQuery 3.4.x or older
// These methods have been defined in jQuery 3.5.0.
if ( !$.fn.even || !$.fn.odd ) {
	$.fn.extend( {
		even: function() {
			return this.filter( function( i ) {
				return i % 2 === 0;
			} );
		},
		odd: function() {
			return this.filter( function( i ) {
				return i % 2 === 1;
			} );
		}
	} );
}

;
/*!
 * jQuery UI Keycode 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Keycode
//>>group: Core
//>>description: Provide keycodes as keynames
//>>docs: https://api.jqueryui.com/jQuery.ui.keyCode/


var keycode = $.ui.keyCode = {
	BACKSPACE: 8,
	COMMA: 188,
	DELETE: 46,
	DOWN: 40,
	END: 35,
	ENTER: 13,
	ESCAPE: 27,
	HOME: 36,
	LEFT: 37,
	PAGE_DOWN: 34,
	PAGE_UP: 33,
	PERIOD: 190,
	RIGHT: 39,
	SPACE: 32,
	TAB: 9,
	UP: 38
};


/*!
 * jQuery UI Labels 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: labels
//>>group: Core
//>>description: Find all the labels associated with a given input
//>>docs: https://api.jqueryui.com/labels/


var labels = $.fn.labels = function() {
	var ancestor, selector, id, labels, ancestors;

	if ( !this.length ) {
		return this.pushStack( [] );
	}

	// Check control.labels first
	if ( this[ 0 ].labels && this[ 0 ].labels.length ) {
		return this.pushStack( this[ 0 ].labels );
	}

	// If `control.labels` is empty - e.g. inside of document fragments - find
	// the labels manually
	labels = this.eq( 0 ).parents( "label" );

	// Look for the label based on the id
	id = this.attr( "id" );
	if ( id ) {

		// We don't search against the document in case the element
		// is disconnected from the DOM
		ancestor = this.eq( 0 ).parents().last();

		// Get a full set of top level ancestors
		ancestors = ancestor.add( ancestor.length ? ancestor.siblings() : this.siblings() );

		// Create a selector for the label based on the id
		selector = "label[for='" + CSS.escape( id ) + "']";

		labels = labels.add( ancestors.find( selector ).addBack( selector ) );

	}

	// Return whatever we have found for labels
	return this.pushStack( labels );
};


/*!
 * jQuery UI Scroll Parent 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: scrollParent
//>>group: Core
//>>description: Get the closest ancestor element that is scrollable.
//>>docs: https://api.jqueryui.com/scrollParent/


var scrollParent = $.fn.scrollParent = function( includeHidden ) {
	var position = this.css( "position" ),
		excludeStaticParent = position === "absolute",
		overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
		scrollParent = this.parents().filter( function() {
			var parent = $( this );
			if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
				return false;
			}
			return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
				parent.css( "overflow-x" ) );
		} ).eq( 0 );

	return position === "fixed" || !scrollParent.length ?
		$( this[ 0 ].ownerDocument || document ) :
		scrollParent;
};


/*!
 * jQuery UI Tabbable 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: :tabbable Selector
//>>group: Core
//>>description: Selects elements which can be tabbed to.
//>>docs: https://api.jqueryui.com/tabbable-selector/


var tabbable = $.extend( $.expr.pseudos, {
	tabbable: function( element ) {
		var tabIndex = $.attr( element, "tabindex" ),
			hasTabindex = tabIndex != null;
		return ( !hasTabindex || tabIndex >= 0 ) && $.ui.focusable( element, hasTabindex );
	}
} );


/*!
 * jQuery UI Unique ID 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: uniqueId
//>>group: Core
//>>description: Functions to generate and remove uniqueId's
//>>docs: https://api.jqueryui.com/uniqueId/


var uniqueId = $.fn.extend( {
	uniqueId: ( function() {
		var uuid = 0;

		return function() {
			return this.each( function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			} );
		};
	} )(),

	removeUniqueId: function() {
		return this.each( function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		} );
	}
} );


/*!
 * jQuery UI Accordion 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Accordion
//>>group: Widgets
//>>description: Displays collapsible content panels for presenting information in a limited amount of space.
//>>docs: https://api.jqueryui.com/accordion/
//>>demos: https://jqueryui.com/accordion/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/accordion.css
//>>css.theme: ../../themes/base/theme.css


var widgetsAccordion = $.widget( "ui.accordion", {
	version: "1.14.2",
	options: {
		active: 0,
		animate: {},
		classes: {
			"ui-accordion-header": "ui-corner-top",
			"ui-accordion-header-collapsed": "ui-corner-all",
			"ui-accordion-content": "ui-corner-bottom"
		},
		collapsible: false,
		event: "click",
		header: function( elem ) {
			return elem
				.find( "> li > :first-child" )
				.add(
					elem.find( "> :not(li)" )

						// Support: jQuery <3.5 only
						// We could use `.even()` but that's unavailable in older jQuery.
						.filter( function( i ) {
							return i % 2 === 0;
						} )
				);
		},
		heightStyle: "auto",
		icons: {
			activeHeader: "ui-icon-triangle-1-s",
			header: "ui-icon-triangle-1-e"
		},

		// Callbacks
		activate: null,
		beforeActivate: null
	},

	hideProps: {
		borderTopWidth: "hide",
		borderBottomWidth: "hide",
		paddingTop: "hide",
		paddingBottom: "hide",
		height: "hide"
	},

	showProps: {
		borderTopWidth: "show",
		borderBottomWidth: "show",
		paddingTop: "show",
		paddingBottom: "show",
		height: "show"
	},

	_create: function() {
		var options = this.options;

		this.prevShow = this.prevHide = $();
		this._addClass( "ui-accordion", "ui-widget ui-helper-reset" );
		this.element.attr( "role", "tablist" );

		// Don't allow collapsible: false and active: false / null
		if ( !options.collapsible && ( options.active === false || options.active == null ) ) {
			options.active = 0;
		}

		this._processPanels();

		// handle negative values
		if ( options.active < 0 ) {
			options.active += this.headers.length;
		}
		this._refresh();
	},

	_getCreateEventData: function() {
		return {
			header: this.active,
			panel: !this.active.length ? $() : this.active.next()
		};
	},

	_createIcons: function() {
		var icon, children,
			icons = this.options.icons;

		if ( icons ) {
			icon = $( "<span>" );
			this._addClass( icon, "ui-accordion-header-icon", "ui-icon " + icons.header );
			icon.prependTo( this.headers );
			children = this.active.children( ".ui-accordion-header-icon" );
			this._removeClass( children, icons.header )
				._addClass( children, null, icons.activeHeader )
				._addClass( this.headers, "ui-accordion-icons" );
		}
	},

	_destroyIcons: function() {
		this._removeClass( this.headers, "ui-accordion-icons" );
		this.headers.children( ".ui-accordion-header-icon" ).remove();
	},

	_destroy: function() {
		var contents;

		// Clean up main element
		this.element.removeAttr( "role" );

		// Clean up headers
		this.headers
			.removeAttr( "role aria-expanded aria-selected aria-controls tabIndex" )
			.removeUniqueId();

		this._destroyIcons();

		// Clean up content panels
		contents = this.headers.next()
			.css( "display", "" )
			.removeAttr( "role aria-hidden aria-labelledby" )
			.removeUniqueId();

		if ( this.options.heightStyle !== "content" ) {
			contents.css( "height", "" );
		}
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {

			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		if ( key === "event" ) {
			if ( this.options.event ) {
				this._off( this.headers, this.options.event );
			}
			this._setupEvents( value );
		}

		this._super( key, value );

		// Setting collapsible: false while collapsed; open first panel
		if ( key === "collapsible" && !value && this.options.active === false ) {
			this._activate( 0 );
		}

		if ( key === "icons" ) {
			this._destroyIcons();
			if ( value ) {
				this._createIcons();
			}
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", value );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	_keydown: function( event ) {
		if ( event.altKey || event.ctrlKey ) {
			return;
		}

		var keyCode = $.ui.keyCode,
			length = this.headers.length,
			currentIndex = this.headers.index( event.target ),
			toFocus = false;

		switch ( event.keyCode ) {
		case keyCode.RIGHT:
		case keyCode.DOWN:
			toFocus = this.headers[ ( currentIndex + 1 ) % length ];
			break;
		case keyCode.LEFT:
		case keyCode.UP:
			toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
			break;
		case keyCode.SPACE:
		case keyCode.ENTER:
			this._eventHandler( event );
			break;
		case keyCode.HOME:
			toFocus = this.headers[ 0 ];
			break;
		case keyCode.END:
			toFocus = this.headers[ length - 1 ];
			break;
		}

		if ( toFocus ) {
			$( event.target ).attr( "tabIndex", -1 );
			$( toFocus ).attr( "tabIndex", 0 );
			$( toFocus ).trigger( "focus" );
			event.preventDefault();
		}
	},

	_panelKeyDown: function( event ) {
		if ( event.keyCode === $.ui.keyCode.UP && event.ctrlKey ) {
			$( event.currentTarget ).prev().trigger( "focus" );
		}
	},

	refresh: function() {
		var options = this.options;
		this._processPanels();

		// Was collapsed or no panel
		if ( ( options.active === false && options.collapsible === true ) ||
				!this.headers.length ) {
			options.active = false;
			this.active = $();

		// active false only when collapsible is true
		} else if ( options.active === false ) {
			this._activate( 0 );

		// was active, but active panel is gone
		} else if ( this.active.length && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {

			// all remaining panel are disabled
			if ( this.headers.length === this.headers.find( ".ui-state-disabled" ).length ) {
				options.active = false;
				this.active = $();

			// activate previous panel
			} else {
				this._activate( Math.max( 0, options.active - 1 ) );
			}

		// was active, active panel still exists
		} else {

			// make sure active index is correct
			options.active = this.headers.index( this.active );
		}

		this._destroyIcons();

		this._refresh();
	},

	_processPanels: function() {
		var prevHeaders = this.headers,
			prevPanels = this.panels;

		if ( typeof this.options.header === "function" ) {
			this.headers = this.options.header( this.element );
		} else {
			this.headers = this.element.find( this.options.header );
		}
		this._addClass( this.headers, "ui-accordion-header ui-accordion-header-collapsed",
			"ui-state-default" );

		this.panels = this.headers.next().filter( ":not(.ui-accordion-content-active)" ).hide();
		this._addClass( this.panels, "ui-accordion-content", "ui-helper-reset ui-widget-content" );

		// Avoid memory leaks (#10056)
		if ( prevPanels ) {
			this._off( prevHeaders.not( this.headers ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	_refresh: function() {
		var maxHeight,
			options = this.options,
			heightStyle = options.heightStyle,
			parent = this.element.parent();

		this.active = this._findActive( options.active );
		this._addClass( this.active, "ui-accordion-header-active", "ui-state-active" )
			._removeClass( this.active, "ui-accordion-header-collapsed" );
		this._addClass( this.active.next(), "ui-accordion-content-active" );
		this.active.next().show();

		this.headers
			.attr( "role", "tab" )
			.each( function() {
				var header = $( this ),
					headerId = header.uniqueId().attr( "id" ),
					panel = header.next(),
					panelId = panel.uniqueId().attr( "id" );
				header.attr( "aria-controls", panelId );
				panel.attr( "aria-labelledby", headerId );
			} )
			.next()
				.attr( "role", "tabpanel" );

		this.headers
			.not( this.active )
				.attr( {
					"aria-selected": "false",
					"aria-expanded": "false",
					tabIndex: -1
				} )
				.next()
					.attr( {
						"aria-hidden": "true"
					} )
					.hide();

		// Make sure at least one header is in the tab order
		if ( !this.active.length ) {
			this.headers.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active.attr( {
				"aria-selected": "true",
				"aria-expanded": "true",
				tabIndex: 0
			} )
				.next()
					.attr( {
						"aria-hidden": "false"
					} );
		}

		this._createIcons();

		this._setupEvents( options.event );

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			this.element.siblings( ":visible" ).each( function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			} );

			this.headers.each( function() {
				maxHeight -= $( this ).outerHeight( true );
			} );

			this.headers.next()
				.each( function() {
					$( this ).height( Math.max( 0, maxHeight -
						$( this ).innerHeight() + $( this ).height() ) );
				} )
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.headers.next()
				.each( function() {
					var isVisible = $( this ).is( ":visible" );
					if ( !isVisible ) {
						$( this ).show();
					}
					maxHeight = Math.max( maxHeight, $( this ).css( "height", "" ).height() );
					if ( !isVisible ) {
						$( this ).hide();
					}
				} )
				.height( maxHeight );
		}
	},

	_activate: function( index ) {
		var active = this._findActive( index )[ 0 ];

		// Trying to activate the already active panel
		if ( active === this.active[ 0 ] ) {
			return;
		}

		// Trying to collapse, simulate a click on the currently active header
		active = active || this.active[ 0 ];

		this._eventHandler( {
			target: active,
			currentTarget: active,
			preventDefault: $.noop
		} );
	},

	_findActive: function( selector ) {
		return typeof selector === "number" ? this.headers.eq( selector ) : $();
	},

	_setupEvents: function( event ) {
		var events = {
			keydown: "_keydown"
		};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			} );
		}

		this._off( this.headers.add( this.headers.next() ) );
		this._on( this.headers, events );
		this._on( this.headers.next(), { keydown: "_panelKeyDown" } );
		this._hoverable( this.headers );
		this._focusable( this.headers );
	},

	_eventHandler: function( event ) {
		var activeChildren, clickedChildren,
			options = this.options,
			active = this.active,
			clicked = $( event.currentTarget ),
			clickedIsActive = clicked[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : clicked.next(),
			toHide = active.next(),
			eventData = {
				oldHeader: active,
				oldPanel: toHide,
				newHeader: collapsing ? $() : clicked,
				newPanel: toShow
			};

		event.preventDefault();

		if (

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.headers.index( clicked );

		// When the call to ._toggle() comes after the class changes
		// it causes a very odd bug in IE 8 (see #6720)
		this.active = clickedIsActive ? $() : clicked;
		this._toggle( eventData );

		// Switch classes
		// corner classes on the previously active header stay after the animation
		this._removeClass( active, "ui-accordion-header-active", "ui-state-active" );
		if ( options.icons ) {
			activeChildren = active.children( ".ui-accordion-header-icon" );
			this._removeClass( activeChildren, null, options.icons.activeHeader )
				._addClass( activeChildren, null, options.icons.header );
		}

		if ( !clickedIsActive ) {
			this._removeClass( clicked, "ui-accordion-header-collapsed" )
				._addClass( clicked, "ui-accordion-header-active", "ui-state-active" );
			if ( options.icons ) {
				clickedChildren = clicked.children( ".ui-accordion-header-icon" );
				this._removeClass( clickedChildren, null, options.icons.header )
					._addClass( clickedChildren, null, options.icons.activeHeader );
			}

			this._addClass( clicked.next(), "ui-accordion-content-active" );
		}
	},

	_toggle: function( data ) {
		var toShow = data.newPanel,
			toHide = this.prevShow.length ? this.prevShow : data.oldPanel;

		// Handle activating a panel during the animation for another activation
		this.prevShow.add( this.prevHide ).stop( true, true );
		this.prevShow = toShow;
		this.prevHide = toHide;

		if ( this.options.animate ) {
			this._animate( toShow, toHide, data );
		} else {
			toHide.hide();
			toShow.show();
			this._toggleComplete( data );
		}

		toHide.attr( {
			"aria-hidden": "true"
		} );
		toHide.prev().attr( {
			"aria-selected": "false",
			"aria-expanded": "false"
		} );

		// if we're switching panels, remove the old header from the tab order
		// if we're opening from collapsed state, remove the previous header from the tab order
		// if we're collapsing, then keep the collapsing header in the tab order
		if ( toShow.length && toHide.length ) {
			toHide.prev().attr( {
				"tabIndex": -1,
				"aria-expanded": "false"
			} );
		} else if ( toShow.length ) {
			this.headers.filter( function() {
				return parseInt( $( this ).attr( "tabIndex" ), 10 ) === 0;
			} )
				.attr( "tabIndex", -1 );
		}

		toShow
			.attr( "aria-hidden", "false" )
			.prev()
				.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} );
	},

	_animate: function( toShow, toHide, data ) {
		var total, easing, duration,
			that = this,
			adjust = 0,
			boxSizing = toShow.css( "box-sizing" ),
			down = toShow.length &&
				( !toHide.length || ( toShow.index() < toHide.index() ) ),
			animate = this.options.animate || {},
			options = down && animate.down || animate,
			complete = function() {
				that._toggleComplete( data );
			};

		if ( typeof options === "number" ) {
			duration = options;
		}
		if ( typeof options === "string" ) {
			easing = options;
		}

		// fall back from options to animation in case of partial down settings
		easing = easing || options.easing || animate.easing;
		duration = duration || options.duration || animate.duration;

		if ( !toHide.length ) {
			return toShow.animate( this.showProps, duration, easing, complete );
		}
		if ( !toShow.length ) {
			return toHide.animate( this.hideProps, duration, easing, complete );
		}

		total = toShow.show().outerHeight();
		toHide.animate( this.hideProps, {
			duration: duration,
			easing: easing,
			step: function( now, fx ) {
				fx.now = Math.round( now );
			}
		} );
		toShow
			.hide()
			.animate( this.showProps, {
				duration: duration,
				easing: easing,
				complete: complete,
				step: function( now, fx ) {
					fx.now = Math.round( now );
					if ( fx.prop !== "height" ) {
						if ( boxSizing === "content-box" ) {
							adjust += fx.now;
						}
					} else if ( that.options.heightStyle !== "content" ) {
						fx.now = Math.round( total - toHide.outerHeight() - adjust );
						adjust = 0;
					}
				}
			} );
	},

	_toggleComplete: function( data ) {
		var toHide = data.oldPanel,
			prev = toHide.prev();

		this._removeClass( toHide, "ui-accordion-content-active" );
		this._removeClass( prev, "ui-accordion-header-active" )
			._addClass( prev, "ui-accordion-header-collapsed" );

		this._trigger( "activate", null, data );
	}
} );


/*!
 * jQuery UI Menu 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Menu
//>>group: Widgets
//>>description: Creates nestable menus.
//>>docs: https://api.jqueryui.com/menu/
//>>demos: https://jqueryui.com/menu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/menu.css
//>>css.theme: ../../themes/base/theme.css


var widgetsMenu = $.widget( "ui.menu", {
	version: "1.14.2",
	defaultElement: "<ul>",
	delay: 300,
	options: {
		icons: {
			submenu: "ui-icon-caret-1-e"
		},
		items: "> *",
		menus: "ul",
		position: {
			my: "left top",
			at: "right top"
		},
		role: "menu",

		// Callbacks
		blur: null,
		focus: null,
		select: null
	},

	_create: function() {
		this.activeMenu = this.element;

		// Flag used to prevent firing of the click handler
		// as the event bubbles up through nested menus
		this.mouseHandled = false;
		this.lastMousePosition = { x: null, y: null };
		this.element
			.uniqueId()
			.attr( {
				role: this.options.role,
				tabIndex: 0
			} );

		this._addClass( "ui-menu", "ui-widget ui-widget-content" );
		this._on( {

			// Prevent focus from sticking to links inside menu after clicking
			// them (focus should always stay on UL during navigation).
			"mousedown .ui-menu-item": function( event ) {
				event.preventDefault();

				this._activateItem( event );
			},
			"click .ui-menu-item": function( event ) {
				var target = $( event.target );
				var active = $( this.document[ 0 ].activeElement );
				if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
					this.select( event );

					// Only set the mouseHandled flag if the event will bubble, see #9469.
					if ( !event.isPropagationStopped() ) {
						this.mouseHandled = true;
					}

					// Open submenu on click
					if ( target.has( ".ui-menu" ).length ) {
						this.expand( event );
					} else if ( !this.element.is( ":focus" ) &&
							active.closest( ".ui-menu" ).length ) {

						// Redirect focus to the menu
						this.element.trigger( "focus", [ true ] );

						// If the active item is on the top level, let it stay active.
						// Otherwise, blur the active item since it is no longer visible.
						if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
							clearTimeout( this.timer );
						}
					}
				}
			},
			"mouseenter .ui-menu-item": "_activateItem",
			"mousemove .ui-menu-item": "_activateItem",
			mouseleave: "collapseAll",
			"mouseleave .ui-menu": "collapseAll",
			focus: function( event, keepActiveItem ) {

				// If there's already an active item, keep it active
				// If not, activate the first item
				var item = this.active || this._menuItems().first();

				if ( !keepActiveItem ) {
					this.focus( event, item );
				}
			},
			blur: function( event ) {
				this._delay( function() {
					var notContained = !$.contains(
						this.element[ 0 ],
						this.document[ 0 ].activeElement
					);
					if ( notContained ) {
						this.collapseAll( event );
					}
				} );
			},
			keydown: "_keydown"
		} );

		this.refresh();

		// Clicks outside of a menu collapse any open menus
		this._on( this.document, {
			click: function( event ) {
				if ( this._closeOnDocumentClick( event ) ) {
					this.collapseAll( event, true );
				}

				// Reset the mouseHandled flag
				this.mouseHandled = false;
			}
		} );
	},

	_activateItem: function( event ) {

		// Ignore mouse events while typeahead is active, see #10458.
		// Prevents focusing the wrong item when typeahead causes a scroll while the mouse
		// is over an item in the menu
		if ( this.previousFilter ) {
			return;
		}

		// If the mouse didn't actually move, but the page was scrolled, ignore the event (#9356)
		if ( event.clientX === this.lastMousePosition.x &&
				event.clientY === this.lastMousePosition.y ) {
			return;
		}

		this.lastMousePosition = {
			x: event.clientX,
			y: event.clientY
		};

		var actualTarget = $( event.target ).closest( ".ui-menu-item" ),
			target = $( event.currentTarget );

		// Ignore bubbled events on parent items, see #11641
		if ( actualTarget[ 0 ] !== target[ 0 ] ) {
			return;
		}

		// If the item is already active, there's nothing to do
		if ( target.is( ".ui-state-active" ) ) {
			return;
		}

		// Remove ui-state-active class from siblings of the newly focused menu item
		// to avoid a jump caused by adjacent elements both having a class with a border
		this._removeClass( target.siblings().children( ".ui-state-active" ),
			null, "ui-state-active" );
		this.focus( event, target );
	},

	_destroy: function() {
		var items = this.element.find( ".ui-menu-item" )
				.removeAttr( "role aria-disabled" ),
			submenus = items.children( ".ui-menu-item-wrapper" )
				.removeUniqueId()
				.removeAttr( "tabIndex role aria-haspopup" );

		// Destroy (sub)menus
		this.element
			.removeAttr( "aria-activedescendant" )
			.find( ".ui-menu" ).addBack()
				.removeAttr( "role aria-labelledby aria-expanded aria-hidden aria-disabled " +
					"tabIndex" )
				.removeUniqueId()
				.show();

		submenus.children().each( function() {
			var elem = $( this );
			if ( elem.data( "ui-menu-submenu-caret" ) ) {
				elem.remove();
			}
		} );
	},

	_keydown: function( event ) {
		var match, prev, character, skip,
			preventDefault = true;

		switch ( event.keyCode ) {
		case $.ui.keyCode.PAGE_UP:
			this.previousPage( event );
			break;
		case $.ui.keyCode.PAGE_DOWN:
			this.nextPage( event );
			break;
		case $.ui.keyCode.HOME:
			this._move( "first", "first", event );
			break;
		case $.ui.keyCode.END:
			this._move( "last", "last", event );
			break;
		case $.ui.keyCode.UP:
			this.previous( event );
			break;
		case $.ui.keyCode.DOWN:
			this.next( event );
			break;
		case $.ui.keyCode.LEFT:
			this.collapse( event );
			break;
		case $.ui.keyCode.RIGHT:
			if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
				this.expand( event );
			}
			break;
		case $.ui.keyCode.ENTER:
		case $.ui.keyCode.SPACE:
			this._activate( event );
			break;
		case $.ui.keyCode.ESCAPE:
			this.collapse( event );
			break;
		default:
			preventDefault = false;
			prev = this.previousFilter || "";
			skip = false;

			// Support number pad values
			character = event.keyCode >= 96 && event.keyCode <= 105 ?
				( event.keyCode - 96 ).toString() : String.fromCharCode( event.keyCode );

			clearTimeout( this.filterTimer );

			if ( character === prev ) {
				skip = true;
			} else {
				character = prev + character;
			}

			match = this._filterMenuItems( character );
			match = skip && match.index( this.active.next() ) !== -1 ?
				this.active.nextAll( ".ui-menu-item" ) :
				match;

			// If no matches on the current filter, reset to the last character pressed
			// to move down the menu to the first item that starts with that character
			if ( !match.length ) {
				character = String.fromCharCode( event.keyCode );
				match = this._filterMenuItems( character );
			}

			if ( match.length ) {
				this.focus( event, match );
				this.previousFilter = character;
				this.filterTimer = this._delay( function() {
					delete this.previousFilter;
				}, 1000 );
			} else {
				delete this.previousFilter;
			}
		}

		if ( preventDefault ) {
			event.preventDefault();
		}
	},

	_activate: function( event ) {
		if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
			if ( this.active.children( "[aria-haspopup='true']" ).length ) {
				this.expand( event );
			} else {
				this.select( event );
			}
		}
	},

	refresh: function() {
		var menus, items, newSubmenus, newItems, newWrappers,
			that = this,
			icon = this.options.icons.submenu,
			submenus = this.element.find( this.options.menus );

		this._toggleClass( "ui-menu-icons", null, !!this.element.find( ".ui-icon" ).length );

		// Initialize nested menus
		newSubmenus = submenus.filter( ":not(.ui-menu)" )
			.hide()
			.attr( {
				role: this.options.role,
				"aria-hidden": "true",
				"aria-expanded": "false"
			} )
			.each( function() {
				var menu = $( this ),
					item = menu.prev(),
					submenuCaret = $( "<span>" ).data( "ui-menu-submenu-caret", true );

				that._addClass( submenuCaret, "ui-menu-icon", "ui-icon " + icon );
				item
					.attr( "aria-haspopup", "true" )
					.prepend( submenuCaret );
				menu.attr( "aria-labelledby", item.attr( "id" ) );
			} );

		this._addClass( newSubmenus, "ui-menu", "ui-widget ui-widget-content ui-front" );

		menus = submenus.add( this.element );
		items = menus.find( this.options.items );

		// Initialize menu-items containing spaces and/or dashes only as dividers
		items.not( ".ui-menu-item" ).each( function() {
			var item = $( this );
			if ( that._isDivider( item ) ) {
				that._addClass( item, "ui-menu-divider", "ui-widget-content" );
			}
		} );

		// Don't refresh list items that are already adapted
		newItems = items.not( ".ui-menu-item, .ui-menu-divider" );
		newWrappers = newItems.children()
			.not( ".ui-menu" )
				.uniqueId()
				.attr( {
					tabIndex: -1,
					role: this._itemRole()
				} );
		this._addClass( newItems, "ui-menu-item" )
			._addClass( newWrappers, "ui-menu-item-wrapper" );

		// Add aria-disabled attribute to any disabled menu item
		items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );

		// If the active item has been removed, blur the menu
		if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
			this.blur();
		}
	},

	_itemRole: function() {
		return {
			menu: "menuitem",
			listbox: "option"
		}[ this.options.role ];
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			var icons = this.element.find( ".ui-menu-icon" );
			this._removeClass( icons, null, this.options.icons.submenu )
				._addClass( icons, null, value.submenu );
		}
		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", String( value ) );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	focus: function( event, item ) {
		var nested, focused, activeParent;
		this.blur( event, event && event.type === "focus" );

		this._scrollIntoView( item );

		this.active = item.first();

		focused = this.active.children( ".ui-menu-item-wrapper" );
		this._addClass( focused, null, "ui-state-active" );

		// Only update aria-activedescendant if there's a role
		// otherwise we assume focus is managed elsewhere
		if ( this.options.role ) {
			this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
		}

		// Highlight active parent menu item, if any
		activeParent = this.active
			.parent()
				.closest( ".ui-menu-item" )
					.children( ".ui-menu-item-wrapper" );
		this._addClass( activeParent, null, "ui-state-active" );

		if ( event && event.type === "keydown" ) {
			this._close();
		} else {
			this.timer = this._delay( function() {
				this._close();
			}, this.delay );
		}

		nested = item.children( ".ui-menu" );
		if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
			this._startOpening( nested );
		}
		this.activeMenu = item.parent();

		this._trigger( "focus", event, { item: item } );
	},

	_scrollIntoView: function( item ) {
		var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
		if ( this._hasScroll() ) {
			borderTop = parseFloat( $.css( this.activeMenu[ 0 ], "borderTopWidth" ) ) || 0;
			paddingTop = parseFloat( $.css( this.activeMenu[ 0 ], "paddingTop" ) ) || 0;
			offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
			scroll = this.activeMenu.scrollTop();
			elementHeight = this.activeMenu.height();
			itemHeight = item.outerHeight();

			if ( offset < 0 ) {
				this.activeMenu.scrollTop( scroll + offset );
			} else if ( offset + itemHeight > elementHeight ) {
				this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
			}
		}
	},

	blur: function( event, fromFocus ) {
		if ( !fromFocus ) {
			clearTimeout( this.timer );
		}

		if ( !this.active ) {
			return;
		}

		this._removeClass( this.active.children( ".ui-menu-item-wrapper" ),
			null, "ui-state-active" );

		this._trigger( "blur", event, { item: this.active } );
		this.active = null;
	},

	_startOpening: function( submenu ) {
		clearTimeout( this.timer );

		// Don't open if already open fixes a Firefox bug that caused a .5 pixel
		// shift in the submenu position when mousing over the caret icon
		if ( submenu.attr( "aria-hidden" ) !== "true" ) {
			return;
		}

		this.timer = this._delay( function() {
			this._close();
			this._open( submenu );
		}, this.delay );
	},

	_open: function( submenu ) {
		var position = $.extend( {
			of: this.active
		}, this.options.position );

		clearTimeout( this.timer );
		this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
			.hide()
			.attr( "aria-hidden", "true" );

		submenu
			.show()
			.removeAttr( "aria-hidden" )
			.attr( "aria-expanded", "true" )
			.position( position );
	},

	collapseAll: function( event, all ) {
		clearTimeout( this.timer );
		this.timer = this._delay( function() {

			// If we were passed an event, look for the submenu that contains the event
			var currentMenu = all ? this.element :
				$( event && event.target ).closest( this.element.find( ".ui-menu" ) );

			// If we found no valid submenu ancestor, use the main menu to close all
			// sub menus anyway
			if ( !currentMenu.length ) {
				currentMenu = this.element;
			}

			this._close( currentMenu );

			this.blur( event );

			// Work around active item staying active after menu is blurred
			this._removeClass( currentMenu.find( ".ui-state-active" ), null, "ui-state-active" );

			this.activeMenu = currentMenu;
		}, all ? 0 : this.delay );
	},

	// With no arguments, closes the currently active menu - if nothing is active
	// it closes all menus.  If passed an argument, it will search for menus BELOW
	_close: function( startMenu ) {
		if ( !startMenu ) {
			startMenu = this.active ? this.active.parent() : this.element;
		}

		startMenu.find( ".ui-menu" )
			.hide()
			.attr( "aria-hidden", "true" )
			.attr( "aria-expanded", "false" );
	},

	_closeOnDocumentClick: function( event ) {
		return !$( event.target ).closest( ".ui-menu" ).length;
	},

	_isDivider: function( item ) {

		// Match hyphen, em dash, en dash
		return !/[^\-\u2014\u2013\s]/.test( item.text() );
	},

	collapse: function( event ) {
		var newItem = this.active &&
			this.active.parent().closest( ".ui-menu-item", this.element );
		if ( newItem && newItem.length ) {
			this._close();
			this.focus( event, newItem );
		}
	},

	expand: function( event ) {
		var newItem = this.active && this._menuItems( this.active.children( ".ui-menu" ) ).first();

		if ( newItem && newItem.length ) {
			this._open( newItem.parent() );

			// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
			this._delay( function() {
				this.focus( event, newItem );
			} );
		}
	},

	next: function( event ) {
		this._move( "next", "first", event );
	},

	previous: function( event ) {
		this._move( "prev", "last", event );
	},

	isFirstItem: function() {
		return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
	},

	isLastItem: function() {
		return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
	},

	_menuItems: function( menu ) {
		return ( menu || this.element )
			.find( this.options.items )
			.filter( ".ui-menu-item" );
	},

	_move: function( direction, filter, event ) {
		var next;
		if ( this.active ) {
			if ( direction === "first" || direction === "last" ) {
				next = this.active
					[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
					.last();
			} else {
				next = this.active
					[ direction + "All" ]( ".ui-menu-item" )
					.first();
			}
		}
		if ( !next || !next.length || !this.active ) {
			next = this._menuItems( this.activeMenu )[ filter ]();
		}

		this.focus( event, next );
	},

	nextPage: function( event ) {
		var item, base, height;

		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isLastItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.innerHeight();

			// jQuery 3.2 doesn't include scrollbars in innerHeight, add it back.
			if ( $.fn.jquery.indexOf( "3.2." ) === 0 ) {
				height += this.element[ 0 ].offsetHeight - this.element.outerHeight();
			}

			this.active.nextAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base - height < 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this._menuItems( this.activeMenu )
				[ !this.active ? "first" : "last" ]() );
		}
	},

	previousPage: function( event ) {
		var item, base, height;
		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isFirstItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.innerHeight();

			// jQuery 3.2 doesn't include scrollbars in innerHeight, add it back.
			if ( $.fn.jquery.indexOf( "3.2." ) === 0 ) {
				height += this.element[ 0 ].offsetHeight - this.element.outerHeight();
			}

			this.active.prevAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base + height > 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this._menuItems( this.activeMenu ).first() );
		}
	},

	_hasScroll: function() {
		return this.element.outerHeight() < this.element.prop( "scrollHeight" );
	},

	select: function( event ) {

		// TODO: It should never be possible to not have an active item at this
		// point, but the tests don't trigger mouseenter before click.
		this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
		var ui = { item: this.active };
		if ( !this.active.has( ".ui-menu" ).length ) {
			this.collapseAll( event, true );
		}
		this._trigger( "select", event, ui );
	},

	_filterMenuItems: function( character ) {
		var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
			regex = new RegExp( "^" + escapedCharacter, "i" );

		return this.activeMenu
			.find( this.options.items )

				// Only match on items, not dividers or other content (#10571)
				.filter( ".ui-menu-item" )
					.filter( function() {
						return regex.test(
							String.prototype.trim.call(
								$( this ).children( ".ui-menu-item-wrapper" ).text() ) );
					} );
	}
} );


/*!
 * jQuery UI Autocomplete 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Autocomplete
//>>group: Widgets
//>>description: Lists suggested words as the user is typing.
//>>docs: https://api.jqueryui.com/autocomplete/
//>>demos: https://jqueryui.com/autocomplete/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/autocomplete.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.autocomplete", {
	version: "1.14.2",
	defaultElement: "<input>",
	options: {
		appendTo: null,
		autoFocus: false,
		delay: 300,
		minLength: 1,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		source: null,

		// Callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		response: null,
		search: null,
		select: null
	},

	requestIndex: 0,
	pending: 0,
	liveRegionTimer: null,

	_create: function() {

		// Some browsers only repeat keydown events, not keypress events,
		// so we use the suppressKeyPress flag to determine if we've already
		// handled the keydown event. #7269
		// Unfortunately the code for & in keypress is the same as the up arrow,
		// so we use the suppressKeyPressRepeat flag to avoid handling keypress
		// events when we know the keydown event was used to modify the
		// search term. #7799
		var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
			nodeName = this.element[ 0 ].nodeName.toLowerCase(),
			isTextarea = nodeName === "textarea",
			isInput = nodeName === "input";

		// Textareas are always multi-line
		// Inputs are always single-line, even if inside a contentEditable element
		// All other element types are determined by whether they're contentEditable
		this.isMultiLine = isTextarea ||
			!isInput && this.element.prop( "contentEditable" ) === "true";

		this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
		this.isNewMenu = true;

		this._addClass( "ui-autocomplete-input" );
		this.element.attr( "autocomplete", "off" );

		this._on( this.element, {
			keydown: function( event ) {
				if ( this.element.prop( "readOnly" ) ) {
					suppressKeyPress = true;
					suppressInput = true;
					suppressKeyPressRepeat = true;
					return;
				}

				suppressKeyPress = false;
				suppressInput = false;
				suppressKeyPressRepeat = false;
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					suppressKeyPress = true;
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					suppressKeyPress = true;
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					suppressKeyPress = true;
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					suppressKeyPress = true;
					this._keyEvent( "next", event );
					break;
				case keyCode.ENTER:

					// when menu is open and has focus
					if ( this.menu.active ) {

						// #6055 - Opera still allows the keypress to occur
						// which causes forms to submit
						suppressKeyPress = true;
						event.preventDefault();
						this.menu.select( event );
					}
					break;
				case keyCode.TAB:
					if ( this.menu.active ) {
						this.menu.select( event );
					}
					break;
				case keyCode.ESCAPE:
					if ( this.menu.element.is( ":visible" ) ) {
						if ( !this.isMultiLine ) {
							this._value( this.term );
						}
						this.close( event );

						// Different browsers have different default behavior for escape
						// Single press can mean undo or clear
						event.preventDefault();
					}
					break;
				default:
					suppressKeyPressRepeat = true;

					// search timeout should be triggered before the input value is changed
					this._searchTimeout( event );
					break;
				}
			},
			keypress: function( event ) {
				if ( suppressKeyPress ) {
					suppressKeyPress = false;
					if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
						event.preventDefault();
					}
					return;
				}
				if ( suppressKeyPressRepeat ) {
					return;
				}

				// Replicate some key handlers to allow them to repeat in Firefox and Opera
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					this._keyEvent( "next", event );
					break;
				}
			},
			input: function( event ) {
				if ( suppressInput ) {
					suppressInput = false;
					event.preventDefault();
					return;
				}
				this._searchTimeout( event );
			},
			focus: function() {
				this.selectedItem = null;
				this.previous = this._value();
			},
			blur: function( event ) {
				clearTimeout( this.searching );
				this.close( event );
				this._change( event );
			}
		} );

		this._initSource();
		this.menu = $( "<ul>" )
			.appendTo( this._appendTo() )
			.menu( {

				// disable ARIA support, the live region takes care of that
				role: null
			} )
			.hide()
			.menu( "instance" );

		this._addClass( this.menu.element, "ui-autocomplete", "ui-front" );
		this._on( this.menu.element, {
			mousedown: function( event ) {

				// Prevent moving focus out of the text field
				event.preventDefault();
			},
			menufocus: function( event, ui ) {
				var label, item;

				// Support: Firefox
				// Prevent accidental activation of menu items in Firefox (#7024 #9118)
				if ( this.isNewMenu ) {
					this.isNewMenu = false;
					if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
						this.menu.blur();

						this.document.one( "mousemove", function() {
							$( event.target ).trigger( event.originalEvent );
						} );

						return;
					}
				}

				item = ui.item.data( "ui-autocomplete-item" );
				if ( false !== this._trigger( "focus", event, { item: item } ) ) {

					// use value to match what will end up in the input, if it was a key event
					if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
						this._value( item.value );
					}
				}

				// Announce the value in the liveRegion
				label = ui.item.attr( "aria-label" ) || item.value;
				if ( label && String.prototype.trim.call( label ).length ) {
					clearTimeout( this.liveRegionTimer );
					this.liveRegionTimer = this._delay( function() {
						this.liveRegion.html( $( "<div>" ).text( label ) );
					}, 100 );
				}
			},
			menuselect: function( event, ui ) {
				var item = ui.item.data( "ui-autocomplete-item" ),
					previous = this.previous;

				// Only trigger when focus was lost (click on menu)
				if ( this.element[ 0 ] !== this.document[ 0 ].activeElement ) {
					this.element.trigger( "focus" );
					this.previous = previous;
				}

				if ( false !== this._trigger( "select", event, { item: item } ) ) {
					this._value( item.value );
				}

				// reset the term after the select event
				// this allows custom select handling to work properly
				this.term = this._value();

				this.close( event );
				this.selectedItem = item;
			}
		} );

		this.liveRegion = $( "<div>", {
			role: "status",
			"aria-live": "assertive",
			"aria-relevant": "additions"
		} )
			.appendTo( this.document[ 0 ].body );

		this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

		// Turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		} );
	},

	_destroy: function() {
		clearTimeout( this.searching );
		this.element.removeAttr( "autocomplete" );
		this.menu.element.remove();
		this.liveRegion.remove();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "source" ) {
			this._initSource();
		}
		if ( key === "appendTo" ) {
			this.menu.element.appendTo( this._appendTo() );
		}
		if ( key === "disabled" && value && this.xhr ) {
			this.xhr.abort();
		}
	},

	_isEventTargetInWidget: function( event ) {
		var menuElement = this.menu.element[ 0 ];

		return event.target === this.element[ 0 ] ||
			event.target === menuElement ||
			$.contains( menuElement, event.target );
	},

	_closeOnClickOutside: function( event ) {
		if ( !this._isEventTargetInWidget( event ) ) {
			this.close();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front, dialog" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_initSource: function() {
		var array, url,
			that = this;
		if ( Array.isArray( this.options.source ) ) {
			array = this.options.source;
			this.source = function( request, response ) {
				response( $.ui.autocomplete.filter( array, request.term ) );
			};
		} else if ( typeof this.options.source === "string" ) {
			url = this.options.source;
			this.source = function( request, response ) {
				if ( that.xhr ) {
					that.xhr.abort();
				}
				that.xhr = $.ajax( {
					url: url,
					data: request,
					dataType: "json",
					success: function( data ) {
						response( data );
					},
					error: function() {
						response( [] );
					}
				} );
			};
		} else {
			this.source = this.options.source;
		}
	},

	_searchTimeout: function( event ) {
		clearTimeout( this.searching );
		this.searching = this._delay( function() {

			// Search if the value has changed, or if the user retypes the same value (see #7434)
			var equalValues = this.term === this._value(),
				menuVisible = this.menu.element.is( ":visible" ),
				modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;

			if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
				this.selectedItem = null;
				this.search( null, event );
			}
		}, this.options.delay );
	},

	search: function( value, event ) {
		value = value != null ? value : this._value();

		// Always save the actual value, not the one passed as an argument
		this.term = this._value();

		if ( value.length < this.options.minLength ) {
			return this.close( event );
		}

		if ( this._trigger( "search", event ) === false ) {
			return;
		}

		return this._search( value );
	},

	_search: function( value ) {
		this.pending++;
		this._addClass( "ui-autocomplete-loading" );
		this.cancelSearch = false;

		this.source( { term: value }, this._response() );
	},

	_response: function() {
		var index = ++this.requestIndex;

		return function( content ) {
			if ( index === this.requestIndex ) {
				this.__response( content );
			}

			this.pending--;
			if ( !this.pending ) {
				this._removeClass( "ui-autocomplete-loading" );
			}
		}.bind( this );
	},

	__response: function( content ) {
		if ( content ) {
			content = this._normalize( content );
		}
		this._trigger( "response", null, { content: content } );
		if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
			this._suggest( content );
			this._trigger( "open" );
		} else {

			// use ._close() instead of .close() so we don't cancel future searches
			this._close();
		}
	},

	close: function( event ) {
		this.cancelSearch = true;
		this._close( event );
	},

	_close: function( event ) {

		// Remove the handler that closes the menu on outside clicks
		this._off( this.document, "mousedown" );

		if ( this.menu.element.is( ":visible" ) ) {
			this.menu.element.hide();
			this.menu.blur();
			this.isNewMenu = true;
			this._trigger( "close", event );
		}
	},

	_change: function( event ) {
		if ( this.previous !== this._value() ) {
			this._trigger( "change", event, { item: this.selectedItem } );
		}
	},

	_normalize: function( items ) {

		// assume all items have the right format when the first item is complete
		if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
			return items;
		}
		return $.map( items, function( item ) {
			if ( typeof item === "string" ) {
				return {
					label: item,
					value: item
				};
			}
			return $.extend( {}, item, {
				label: item.label || item.value,
				value: item.value || item.label
			} );
		} );
	},

	_suggest: function( items ) {
		var ul = this.menu.element.empty();
		this._renderMenu( ul, items );
		this.isNewMenu = true;
		this.menu.refresh();

		// Size and position menu
		ul.show();
		this._resizeMenu();
		ul.position( $.extend( {
			of: this.element
		}, this.options.position ) );

		if ( this.options.autoFocus ) {
			this.menu.next();
		}

		// Listen for interactions outside of the widget (#6642)
		this._on( this.document, {
			mousedown: "_closeOnClickOutside"
		} );
	},

	_resizeMenu: function() {
		var ul = this.menu.element;
		ul.outerWidth( Math.max(

			// Firefox wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping (#7513)
			ul.width( "" ).outerWidth() + 1,
			this.element.outerWidth()
		) );
	},

	_renderMenu: function( ul, items ) {
		var that = this;
		$.each( items, function( index, item ) {
			that._renderItemData( ul, item );
		} );
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
	},

	_renderItem: function( ul, item ) {
		return $( "<li>" )
			.append( $( "<div>" ).text( item.label ) )
			.appendTo( ul );
	},

	_move: function( direction, event ) {
		if ( !this.menu.element.is( ":visible" ) ) {
			this.search( null, event );
			return;
		}
		if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
				this.menu.isLastItem() && /^next/.test( direction ) ) {

			if ( !this.isMultiLine ) {
				this._value( this.term );
			}

			this.menu.blur();
			return;
		}
		this.menu[ direction ]( event );
	},

	widget: function() {
		return this.menu.element;
	},

	_value: function() {
		return this.valueMethod.apply( this.element, arguments );
	},

	_keyEvent: function( keyEvent, event ) {
		if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
			this._move( keyEvent, event );

			// Prevents moving cursor to beginning/end of the text field in some browsers
			event.preventDefault();
		}
	}
} );

$.extend( $.ui.autocomplete, {
	escapeRegex: function( value ) {
		return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
	},
	filter: function( array, term ) {
		var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
		return $.grep( array, function( value ) {
			return matcher.test( value.label || value.value || value );
		} );
	}
} );

// Live region extension, adding a `messages` option
// NOTE: This is an experimental API. We are still investigating
// a full solution for string manipulation and internationalization.
$.widget( "ui.autocomplete", $.ui.autocomplete, {
	options: {
		messages: {
			noResults: "No search results.",
			results: function( amount ) {
				return amount + ( amount > 1 ? " results are" : " result is" ) +
					" available, use up and down arrow keys to navigate.";
			}
		}
	},

	__response: function( content ) {
		var message;
		this._superApply( arguments );
		if ( this.options.disabled || this.cancelSearch ) {
			return;
		}
		if ( content && content.length ) {
			message = this.options.messages.results( content.length );
		} else {
			message = this.options.messages.noResults;
		}
		clearTimeout( this.liveRegionTimer );
		this.liveRegionTimer = this._delay( function() {
			this.liveRegion.html( $( "<div>" ).text( message ) );
		}, 100 );
	}
} );

var widgetsAutocomplete = $.ui.autocomplete;


/*!
 * jQuery UI Controlgroup 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Controlgroup
//>>group: Widgets
//>>description: Visually groups form control widgets
//>>docs: https://api.jqueryui.com/controlgroup/
//>>demos: https://jqueryui.com/controlgroup/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/controlgroup.css
//>>css.theme: ../../themes/base/theme.css


var controlgroupCornerRegex = /ui-corner-([a-z]){2,6}/g;

var widgetsControlgroup = $.widget( "ui.controlgroup", {
	version: "1.14.2",
	defaultElement: "<div>",
	options: {
		direction: "horizontal",
		disabled: null,
		onlyVisible: true,
		items: {
			"button": "input[type=button], input[type=submit], input[type=reset], button, a",
			"controlgroupLabel": ".ui-controlgroup-label",
			"checkboxradio": "input[type='checkbox'], input[type='radio']",
			"selectmenu": "select",
			"spinner": ".ui-spinner-input"
		}
	},

	_create: function() {
		this._enhance();
	},

	// To support the enhanced option in jQuery Mobile, we isolate DOM manipulation
	_enhance: function() {
		this.element.attr( "role", "toolbar" );
		this.refresh();
	},

	_destroy: function() {
		this._callChildMethod( "destroy" );
		this.childWidgets.removeData( "ui-controlgroup-data" );
		this.element.removeAttr( "role" );
		if ( this.options.items.controlgroupLabel ) {
			this.element
				.find( this.options.items.controlgroupLabel )
				.find( ".ui-controlgroup-label-contents" )
				.contents().unwrap();
		}
	},

	_initWidgets: function() {
		var that = this,
			childWidgets = [];

		// First we iterate over each of the items options
		$.each( this.options.items, function( widget, selector ) {
			var labels;
			var options = {};

			// Make sure the widget has a selector set
			if ( !selector ) {
				return;
			}

			if ( widget === "controlgroupLabel" ) {
				labels = that.element.find( selector );
				labels.each( function() {
					var element = $( this );

					if ( element.children( ".ui-controlgroup-label-contents" ).length ) {
						return;
					}
					element.contents()
						.wrapAll( "<span class='ui-controlgroup-label-contents'></span>" );
				} );
				that._addClass( labels, null, "ui-widget ui-widget-content ui-state-default" );
				childWidgets = childWidgets.concat( labels.get() );
				return;
			}

			// Make sure the widget actually exists
			if ( !$.fn[ widget ] ) {
				return;
			}

			// We assume everything is in the middle to start because we can't determine
			// first / last elements until all enhancments are done.
			if ( that[ "_" + widget + "Options" ] ) {
				options = that[ "_" + widget + "Options" ]( "middle" );
			} else {
				options = { classes: {} };
			}

			// Find instances of this widget inside controlgroup and init them
			that.element
				.find( selector )
				.each( function() {
					var element = $( this );
					var instance = element[ widget ]( "instance" );

					// We need to clone the default options for this type of widget to avoid
					// polluting the variable options which has a wider scope than a single widget.
					var instanceOptions = $.widget.extend( {}, options );

					// If the button is the child of a spinner ignore it
					// TODO: Find a more generic solution
					if ( widget === "button" && element.parent( ".ui-spinner" ).length ) {
						return;
					}

					// Create the widget if it doesn't exist
					if ( !instance ) {
						instance = element[ widget ]()[ widget ]( "instance" );
					}
					if ( instance ) {
						instanceOptions.classes =
							that._resolveClassesValues( instanceOptions.classes, instance );
					}
					element[ widget ]( instanceOptions );

					// Store an instance of the controlgroup to be able to reference
					// from the outermost element for changing options and refresh
					var widgetElement = element[ widget ]( "widget" );
					$.data( widgetElement[ 0 ], "ui-controlgroup-data",
						instance ? instance : element[ widget ]( "instance" ) );

					childWidgets.push( widgetElement[ 0 ] );
				} );
		} );

		this.childWidgets = $( $.uniqueSort( childWidgets ) );
		this._addClass( this.childWidgets, "ui-controlgroup-item" );
	},

	_callChildMethod: function( method ) {
		this.childWidgets.each( function() {
			var element = $( this ),
				data = element.data( "ui-controlgroup-data" );
			if ( data && data[ method ] ) {
				data[ method ]();
			}
		} );
	},

	_updateCornerClass: function( element, position ) {
		var remove = "ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all";
		var add = this._buildSimpleOptions( position, "label" ).classes.label;

		this._removeClass( element, null, remove );
		this._addClass( element, null, add );
	},

	_buildSimpleOptions: function( position, key ) {
		var direction = this.options.direction === "vertical";
		var result = {
			classes: {}
		};
		result.classes[ key ] = {
			"middle": "",
			"first": "ui-corner-" + ( direction ? "top" : "left" ),
			"last": "ui-corner-" + ( direction ? "bottom" : "right" ),
			"only": "ui-corner-all"
		}[ position ];

		return result;
	},

	_spinnerOptions: function( position ) {
		var options = this._buildSimpleOptions( position, "ui-spinner" );

		options.classes[ "ui-spinner-up" ] = "";
		options.classes[ "ui-spinner-down" ] = "";

		return options;
	},

	_buttonOptions: function( position ) {
		return this._buildSimpleOptions( position, "ui-button" );
	},

	_checkboxradioOptions: function( position ) {
		return this._buildSimpleOptions( position, "ui-checkboxradio-label" );
	},

	_selectmenuOptions: function( position ) {
		var direction = this.options.direction === "vertical";
		return {
			width: direction ? "auto" : false,
			classes: {
				middle: {
					"ui-selectmenu-button-open": "",
					"ui-selectmenu-button-closed": ""
				},
				first: {
					"ui-selectmenu-button-open": "ui-corner-" + ( direction ? "top" : "tl" ),
					"ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "top" : "left" )
				},
				last: {
					"ui-selectmenu-button-open": direction ? "" : "ui-corner-tr",
					"ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "bottom" : "right" )
				},
				only: {
					"ui-selectmenu-button-open": "ui-corner-top",
					"ui-selectmenu-button-closed": "ui-corner-all"
				}

			}[ position ]
		};
	},

	_resolveClassesValues: function( classes, instance ) {
		var result = {};
		$.each( classes, function( key ) {
			var current = instance.options.classes[ key ] || "";
			current = String.prototype.trim.call( current.replace( controlgroupCornerRegex, "" ) );
			result[ key ] = ( current + " " + classes[ key ] ).replace( /\s+/g, " " );
		} );
		return result;
	},

	_setOption: function( key, value ) {
		if ( key === "direction" ) {
			this._removeClass( "ui-controlgroup-" + this.options.direction );
		}

		this._super( key, value );
		if ( key === "disabled" ) {
			this._callChildMethod( value ? "disable" : "enable" );
			return;
		}

		this.refresh();
	},

	refresh: function() {
		var children,
			that = this;

		this._addClass( "ui-controlgroup ui-controlgroup-" + this.options.direction );

		if ( this.options.direction === "horizontal" ) {
			this._addClass( null, "ui-helper-clearfix" );
		}
		this._initWidgets();

		children = this.childWidgets;

		// We filter here because we need to track all childWidgets not just the visible ones
		if ( this.options.onlyVisible ) {
			children = children.filter( ":visible" );
		}

		if ( children.length ) {

			// We do this last because we need to make sure all enhancment is done
			// before determining first and last
			$.each( [ "first", "last" ], function( index, value ) {
				var instance = children[ value ]().data( "ui-controlgroup-data" );

				if ( instance && that[ "_" + instance.widgetName + "Options" ] ) {
					var options = that[ "_" + instance.widgetName + "Options" ](
						children.length === 1 ? "only" : value
					);
					options.classes = that._resolveClassesValues( options.classes, instance );
					instance.element[ instance.widgetName ]( options );
				} else {
					that._updateCornerClass( children[ value ](), value );
				}
			} );

			// Finally call the refresh method on each of the child widgets.
			this._callChildMethod( "refresh" );
		}
	}
} );

/*!
 * jQuery UI Checkboxradio 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Checkboxradio
//>>group: Widgets
//>>description: Enhances a form with multiple themeable checkboxes or radio buttons.
//>>docs: https://api.jqueryui.com/checkboxradio/
//>>demos: https://jqueryui.com/checkboxradio/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/button.css
//>>css.structure: ../../themes/base/checkboxradio.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.checkboxradio", [ $.ui.formResetMixin, {
	version: "1.14.2",
	options: {
		disabled: null,
		label: null,
		icon: true,
		classes: {
			"ui-checkboxradio-label": "ui-corner-all",
			"ui-checkboxradio-icon": "ui-corner-all"
		}
	},

	_getCreateOptions: function() {
		var disabled, labels, labelContents;
		var options = this._super() || {};

		// We read the type here, because it makes more sense to throw a element type error first,
		// rather then the error for lack of a label. Often if its the wrong type, it
		// won't have a label (e.g. calling on a div, btn, etc)
		this._readType();

		labels = this.element.labels();

		// If there are multiple labels, use the last one
		this.label = $( labels[ labels.length - 1 ] );
		if ( !this.label.length ) {
			$.error( "No label found for checkboxradio widget" );
		}

		this.originalLabel = "";

		// We need to get the label text but this may also need to make sure it does not contain the
		// input itself.
		// The label contents could be text, html, or a mix. We wrap all elements
		// and read the wrapper's `innerHTML` to get a string representation of
		// the label, without the input as part of it.
		labelContents = this.label.contents().not( this.element[ 0 ] );

		if ( labelContents.length ) {
			this.originalLabel += labelContents
				.clone()
				.wrapAll( "<div></div>" )
				.parent()
				.html();
		}

		// Set the label option if we found label text
		if ( this.originalLabel ) {
			options.label = this.originalLabel;
		}

		disabled = this.element[ 0 ].disabled;
		if ( disabled != null ) {
			options.disabled = disabled;
		}
		return options;
	},

	_create: function() {
		var checked = this.element[ 0 ].checked;

		this._bindFormResetHandler();

		if ( this.options.disabled == null ) {
			this.options.disabled = this.element[ 0 ].disabled;
		}

		this._setOption( "disabled", this.options.disabled );
		this._addClass( "ui-checkboxradio", "ui-helper-hidden-accessible" );
		this._addClass( this.label, "ui-checkboxradio-label", "ui-button ui-widget" );

		if ( this.type === "radio" ) {
			this._addClass( this.label, "ui-checkboxradio-radio-label" );
		}

		if ( this.options.label && this.options.label !== this.originalLabel ) {
			this._updateLabel();
		} else if ( this.originalLabel ) {
			this.options.label = this.originalLabel;
		}

		this._enhance();

		if ( checked ) {
			this._addClass( this.label, "ui-checkboxradio-checked", "ui-state-active" );
		}

		this._on( {
			change: "_toggleClasses",
			focus: function() {
				this._addClass( this.label, null, "ui-state-focus ui-visual-focus" );
			},
			blur: function() {
				this._removeClass( this.label, null, "ui-state-focus ui-visual-focus" );
			}
		} );
	},

	_readType: function() {
		var nodeName = this.element[ 0 ].nodeName.toLowerCase();
		this.type = this.element[ 0 ].type;
		if ( nodeName !== "input" || !/radio|checkbox/.test( this.type ) ) {
			$.error( "Can't create checkboxradio on element.nodeName=" + nodeName +
				" and element.type=" + this.type );
		}
	},

	// Support jQuery Mobile enhanced option
	_enhance: function() {
		this._updateIcon( this.element[ 0 ].checked );
	},

	widget: function() {
		return this.label;
	},

	_getRadioGroup: function() {
		var group;
		var name = this.element[ 0 ].name;
		var nameSelector = "input[name='" + CSS.escape( name ) + "']";

		if ( !name ) {
			return $( [] );
		}

		if ( this.form.length ) {
			group = $( this.form[ 0 ].elements ).filter( nameSelector );
		} else {

			// Not inside a form, check all inputs that also are not inside a form
			group = $( nameSelector ).filter( function() {
				return $( $( this ).prop( "form" ) ).length === 0;
			} );
		}

		return group.not( this.element );
	},

	_toggleClasses: function() {
		var checked = this.element[ 0 ].checked;
		this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );

		if ( this.options.icon && this.type === "checkbox" ) {
			this._toggleClass( this.icon, null, "ui-icon-check ui-state-checked", checked )
				._toggleClass( this.icon, null, "ui-icon-blank", !checked );
		}

		if ( this.type === "radio" ) {
			this._getRadioGroup()
				.each( function() {
					var instance = $( this ).checkboxradio( "instance" );

					if ( instance ) {
						instance._removeClass( instance.label,
							"ui-checkboxradio-checked", "ui-state-active" );
					}
				} );
		}
	},

	_destroy: function() {
		this._unbindFormResetHandler();

		if ( this.icon ) {
			this.icon.remove();
			this.iconSpace.remove();
		}
	},

	_setOption: function( key, value ) {

		// We don't allow the value to be set to nothing
		if ( key === "label" && !value ) {
			return;
		}

		this._super( key, value );

		if ( key === "disabled" ) {
			this._toggleClass( this.label, null, "ui-state-disabled", value );
			this.element[ 0 ].disabled = value;

			// Don't refresh when setting disabled
			return;
		}
		this.refresh();
	},

	_updateIcon: function( checked ) {
		var toAdd = "ui-icon ui-icon-background ";

		if ( this.options.icon ) {
			if ( !this.icon ) {
				this.icon = $( "<span>" );
				this.iconSpace = $( "<span> </span>" );
				this._addClass( this.iconSpace, "ui-checkboxradio-icon-space" );
			}

			if ( this.type === "checkbox" ) {
				toAdd += checked ? "ui-icon-check ui-state-checked" : "ui-icon-blank";
				this._removeClass( this.icon, null, checked ? "ui-icon-blank" : "ui-icon-check" );
			} else {
				toAdd += "ui-icon-blank";
			}
			this._addClass( this.icon, "ui-checkboxradio-icon", toAdd );
			if ( !checked ) {
				this._removeClass( this.icon, null, "ui-icon-check ui-state-checked" );
			}
			this.icon.prependTo( this.label ).after( this.iconSpace );
		} else if ( this.icon !== undefined ) {
			this.icon.remove();
			this.iconSpace.remove();
			delete this.icon;
		}
	},

	_updateLabel: function() {

		// Remove the contents of the label ( minus the icon, icon space, and input )
		var contents = this.label.contents().not( this.element[ 0 ] );
		if ( this.icon ) {
			contents = contents.not( this.icon[ 0 ] );
		}
		if ( this.iconSpace ) {
			contents = contents.not( this.iconSpace[ 0 ] );
		}
		contents.remove();

		this.label.append( this.options.label );
	},

	refresh: function() {
		var checked = this.element[ 0 ].checked,
			isDisabled = this.element[ 0 ].disabled;

		this._updateIcon( checked );
		this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );
		if ( this.options.label !== null ) {
			this._updateLabel();
		}

		if ( isDisabled !== this.options.disabled ) {
			this._setOptions( { "disabled": isDisabled } );
		}
	}

} ] );

var widgetsCheckboxradio = $.ui.checkboxradio;


/*!
 * jQuery UI Button 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Button
//>>group: Widgets
//>>description: Enhances a form with themeable buttons.
//>>docs: https://api.jqueryui.com/button/
//>>demos: https://jqueryui.com/button/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/button.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.button", {
	version: "1.14.2",
	defaultElement: "<button>",
	options: {
		classes: {
			"ui-button": "ui-corner-all"
		},
		disabled: null,
		icon: null,
		iconPosition: "beginning",
		label: null,
		showLabel: true
	},

	_getCreateOptions: function() {
		var disabled,

			// This is to support cases like in jQuery Mobile where the base widget does have
			// an implementation of _getCreateOptions
			options = this._super() || {};

		this.isInput = this.element.is( "input" );

		disabled = this.element[ 0 ].disabled;
		if ( disabled != null ) {
			options.disabled = disabled;
		}

		this.originalLabel = this.isInput ? this.element.val() : this.element.html();
		if ( this.originalLabel ) {
			options.label = this.originalLabel;
		}

		return options;
	},

	_create: function() {
		if ( !this.option.showLabel & !this.options.icon ) {
			this.options.showLabel = true;
		}

		// We have to check the option again here even though we did in _getCreateOptions,
		// because null may have been passed on init which would override what was set in
		// _getCreateOptions
		if ( this.options.disabled == null ) {
			this.options.disabled = this.element[ 0 ].disabled || false;
		}

		this.hasTitle = !!this.element.attr( "title" );

		// Check to see if the label needs to be set or if its already correct
		if ( this.options.label && this.options.label !== this.originalLabel ) {
			if ( this.isInput ) {
				this.element.val( this.options.label );
			} else {
				this.element.html( this.options.label );
			}
		}
		this._addClass( "ui-button", "ui-widget" );
		this._setOption( "disabled", this.options.disabled );
		this._enhance();

		if ( this.element.is( "a" ) ) {
			this._on( {
				"keyup": function( event ) {
					if ( event.keyCode === $.ui.keyCode.SPACE ) {
						event.preventDefault();

						// If a native click is available use it, so we
						// actually cause navigation. Otherwise, just trigger
						// a click event.
						if ( this.element[ 0 ].click ) {
							this.element[ 0 ].click();
						} else {
							this.element.trigger( "click" );
						}
					}
				}
			} );
		}
	},

	_enhance: function() {
		if ( !this.element.is( "button" ) ) {
			this.element.attr( "role", "button" );
		}

		if ( this.options.icon ) {
			this._updateIcon( "icon", this.options.icon );
			this._updateTooltip();
		}
	},

	_updateTooltip: function() {
		this.title = this.element.attr( "title" );

		if ( !this.options.showLabel && !this.title ) {
			this.element.attr( "title", this.options.label );
		}
	},

	_updateIcon: function( option, value ) {
		var icon = option !== "iconPosition",
			position = icon ? this.options.iconPosition : value,
			displayBlock = position === "top" || position === "bottom";

		// Create icon
		if ( !this.icon ) {
			this.icon = $( "<span>" );

			this._addClass( this.icon, "ui-button-icon", "ui-icon" );

			if ( !this.options.showLabel ) {
				this._addClass( "ui-button-icon-only" );
			}
		} else if ( icon ) {

			// If we are updating the icon remove the old icon class
			this._removeClass( this.icon, null, this.options.icon );
		}

		// If we are updating the icon add the new icon class
		if ( icon ) {
			this._addClass( this.icon, null, value );
		}

		this._attachIcon( position );

		// If the icon is on top or bottom we need to add the ui-widget-icon-block class and remove
		// the iconSpace if there is one.
		if ( displayBlock ) {
			this._addClass( this.icon, null, "ui-widget-icon-block" );
			if ( this.iconSpace ) {
				this.iconSpace.remove();
			}
		} else {

			// Position is beginning or end so remove the ui-widget-icon-block class and add the
			// space if it does not exist
			if ( !this.iconSpace ) {
				this.iconSpace = $( "<span> </span>" );
				this._addClass( this.iconSpace, "ui-button-icon-space" );
			}
			this._removeClass( this.icon, null, "ui-wiget-icon-block" );
			this._attachIconSpace( position );
		}
	},

	_destroy: function() {
		this.element.removeAttr( "role" );

		if ( this.icon ) {
			this.icon.remove();
		}
		if ( this.iconSpace ) {
			this.iconSpace.remove();
		}
		if ( !this.hasTitle ) {
			this.element.removeAttr( "title" );
		}
	},

	_attachIconSpace: function( iconPosition ) {
		this.icon[ /^(?:end|bottom)/.test( iconPosition ) ? "before" : "after" ]( this.iconSpace );
	},

	_attachIcon: function( iconPosition ) {
		this.element[ /^(?:end|bottom)/.test( iconPosition ) ? "append" : "prepend" ]( this.icon );
	},

	_setOptions: function( options ) {
		var newShowLabel = options.showLabel === undefined ?
				this.options.showLabel :
				options.showLabel,
			newIcon = options.icon === undefined ? this.options.icon : options.icon;

		if ( !newShowLabel && !newIcon ) {
			options.showLabel = true;
		}
		this._super( options );
	},

	_setOption: function( key, value ) {
		if ( key === "icon" ) {
			if ( value ) {
				this._updateIcon( key, value );
			} else if ( this.icon ) {
				this.icon.remove();
				if ( this.iconSpace ) {
					this.iconSpace.remove();
				}
			}
		}

		if ( key === "iconPosition" ) {
			this._updateIcon( key, value );
		}

		// Make sure we can't end up with a button that has neither text nor icon
		if ( key === "showLabel" ) {
				this._toggleClass( "ui-button-icon-only", null, !value );
				this._updateTooltip();
		}

		if ( key === "label" ) {
			if ( this.isInput ) {
				this.element.val( value );
			} else {

				// If there is an icon, append it, else nothing then append the value
				// this avoids removal of the icon when setting label text
				this.element.html( value );
				if ( this.icon ) {
					this._attachIcon( this.options.iconPosition );
					this._attachIconSpace( this.options.iconPosition );
				}
			}
		}

		this._super( key, value );

		if ( key === "disabled" ) {
			this._toggleClass( null, "ui-state-disabled", value );
			this.element[ 0 ].disabled = value;
			if ( value ) {
				this.element.trigger( "blur" );
			}
		}
	},

	refresh: function() {

		// Make sure to only check disabled if its an element that supports this otherwise
		// check for the disabled class to determine state
		var isDisabled = this.element.is( "input, button" ) ?
			this.element[ 0 ].disabled : this.element.hasClass( "ui-button-disabled" );

		if ( isDisabled !== this.options.disabled ) {
			this._setOptions( { disabled: isDisabled } );
		}

		this._updateTooltip();
	}
} );

// DEPRECATED
if ( $.uiBackCompat === true ) {

	// Text and Icons options
	$.widget( "ui.button", $.ui.button, {
		options: {
			text: true,
			icons: {
				primary: null,
				secondary: null
			}
		},

		_create: function() {
			if ( this.options.showLabel && !this.options.text ) {
				this.options.showLabel = this.options.text;
			}
			if ( !this.options.showLabel && this.options.text ) {
				this.options.text = this.options.showLabel;
			}
			if ( !this.options.icon && ( this.options.icons.primary ||
					this.options.icons.secondary ) ) {
				if ( this.options.icons.primary ) {
					this.options.icon = this.options.icons.primary;
				} else {
					this.options.icon = this.options.icons.secondary;
					this.options.iconPosition = "end";
				}
			} else if ( this.options.icon ) {
				this.options.icons.primary = this.options.icon;
			}
			this._super();
		},

		_setOption: function( key, value ) {
			if ( key === "text" ) {
				this._super( "showLabel", value );
				return;
			}
			if ( key === "showLabel" ) {
				this.options.text = value;
			}
			if ( key === "icon" ) {
				this.options.icons.primary = value;
			}
			if ( key === "icons" ) {
				if ( value.primary ) {
					this._super( "icon", value.primary );
					this._super( "iconPosition", "beginning" );
				} else if ( value.secondary ) {
					this._super( "icon", value.secondary );
					this._super( "iconPosition", "end" );
				}
			}
			this._superApply( arguments );
		}
	} );

	$.fn.button = ( function( orig ) {
		return function( options ) {
			var isMethodCall = typeof options === "string";
			var args = Array.prototype.slice.call( arguments, 1 );
			var returnValue = this;

			if ( isMethodCall ) {

				// If this is an empty collection, we need to have the instance method
				// return undefined instead of the jQuery instance
				if ( !this.length && options === "instance" ) {
					returnValue = undefined;
				} else {
					this.each( function() {
						var methodValue;
						var type = $( this ).attr( "type" );
						var name = type !== "checkbox" && type !== "radio" ?
							"button" :
							"checkboxradio";
						var instance = $.data( this, "ui-" + name );

						if ( options === "instance" ) {
							returnValue = instance;
							return false;
						}

						if ( !instance ) {
							return $.error( "cannot call methods on button" +
								" prior to initialization; " +
								"attempted to call method '" + options + "'" );
						}

						if ( typeof instance[ options ] !== "function" ||
							options.charAt( 0 ) === "_" ) {
							return $.error( "no such method '" + options + "' for button" +
								" widget instance" );
						}

						methodValue = instance[ options ].apply( instance, args );

						if ( methodValue !== instance && methodValue !== undefined ) {
							returnValue = methodValue && methodValue.jquery ?
								returnValue.pushStack( methodValue.get() ) :
								methodValue;
							return false;
						}
					} );
				}
			} else {

				// Allow multiple hashes to be passed on init
				if ( args.length ) {
					options = $.widget.extend.apply( null, [ options ].concat( args ) );
				}

				this.each( function() {
					var type = $( this ).attr( "type" );
					var name = type !== "checkbox" && type !== "radio" ? "button" : "checkboxradio";
					var instance = $.data( this, "ui-" + name );

					if ( instance ) {
						instance.option( options || {} );
						if ( instance._init ) {
							instance._init();
						}
					} else {
						if ( name === "button" ) {
							orig.call( $( this ), options );
							return;
						}

						$( this ).checkboxradio( $.extend( { icon: false }, options ) );
					}
				} );
			}

			return returnValue;
		};
	} )( $.fn.button );

	$.fn.buttonset = function() {
		if ( !$.ui.controlgroup ) {
			$.error( "Controlgroup widget missing" );
		}
		if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" && arguments[ 2 ] ) {
			return this.controlgroup.apply( this,
				[ arguments[ 0 ], "items.button", arguments[ 2 ] ] );
		}
		if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" ) {
			return this.controlgroup.apply( this, [ arguments[ 0 ], "items.button" ] );
		}
		if ( typeof arguments[ 0 ] === "object" && arguments[ 0 ].items ) {
			arguments[ 0 ].items = {
				button: arguments[ 0 ].items
			};
		}
		return this.controlgroup.apply( this, arguments );
	};
}

var widgetsButton = $.ui.button;


/* eslint-disable max-len */
/*!
 * jQuery UI Datepicker 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Datepicker
//>>group: Widgets
//>>description: Displays a calendar from an input or inline for selecting dates.
//>>docs: https://api.jqueryui.com/datepicker/
//>>demos: https://jqueryui.com/datepicker/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/datepicker.css
//>>css.theme: ../../themes/base/theme.css


$.extend( $.ui, { datepicker: { version: "1.14.2" } } );

var datepicker_instActive;

function datepicker_getZindex( elem ) {
	var position, value;
	while ( elem.length && elem[ 0 ] !== document ) {

		// Ignore z-index if position is set to a value where z-index is ignored by the browser
		// This makes behavior of this function consistent across browsers
		// WebKit always returns auto if the element is positioned
		position = elem.css( "position" );
		if ( position === "absolute" || position === "relative" || position === "fixed" ) {

			// IE returns 0 when zIndex is not specified
			// other browsers return a string
			// we ignore the case of nested elements with an explicit value of 0
			// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
			value = parseInt( elem.css( "zIndex" ), 10 );
			if ( !isNaN( value ) && value !== 0 ) {
				return value;
			}
		}
		elem = elem.parent();
	}

	return 0;
}

/* Date picker manager.
   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
   Settings for (groups of) date pickers are maintained in an instance object,
   allowing multiple different settings on the same page. */

function Datepicker() {
	this._curInst = null; // The current instance in use
	this._keyEvent = false; // If the last event was a key event
	this._disabledInputs = []; // List of date picker inputs that have been disabled
	this._datepickerShowing = false; // True if the popup picker is showing , false if not
	this._inDialog = false; // True if showing within a "dialog", false if not
	this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
	this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
	this._appendClass = "ui-datepicker-append"; // The name of the append marker class
	this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
	this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
	this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
	this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
	this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
	this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
	this.regional = []; // Available regional settings, indexed by language code
	this.regional[ "" ] = { // Default regional settings
		closeText: "Done", // Display text for close link
		prevText: "Prev", // Display text for previous month link
		nextText: "Next", // Display text for next month link
		currentText: "Today", // Display text for current month link
		monthNames: [ "January", "February", "March", "April", "May", "June",
			"July", "August", "September", "October", "November", "December" ], // Names of months for drop-down and formatting
		monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ], // For formatting
		dayNames: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ], // For formatting
		dayNamesShort: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ], // For formatting
		dayNamesMin: [ "Su", "Mo", "Tu", "We", "Th", "Fr", "Sa" ], // Column headings for days starting at Sunday
		weekHeader: "Wk", // Column header for week of the year
		dateFormat: "mm/dd/yy", // See format options on parseDate
		firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
		isRTL: false, // True if right-to-left language, false if left-to-right
		showMonthAfterYear: false, // True if the year select precedes month, false for month then year
		yearSuffix: "", // Additional text to append to the year in the month headers,
		selectMonthLabel: "Select month", // Invisible label for month selector
		selectYearLabel: "Select year" // Invisible label for year selector
	};
	this._defaults = { // Global defaults for all the date picker instances
		showOn: "focus", // "focus" for popup on focus,
			// "button" for trigger button, or "both" for either
		showAnim: "fadeIn", // Name of jQuery animation for popup
		showOptions: {}, // Options for enhanced animations
		defaultDate: null, // Used when field is blank: actual date,
			// +/-number for offset from today, null for today
		appendText: "", // Display text following the input box, e.g. showing the format
		buttonText: "...", // Text for trigger button
		buttonImage: "", // URL for trigger button image
		buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
		hideIfNoPrevNext: false, // True to hide next/previous month links
			// if not applicable, false to just disable them
		navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
		gotoCurrent: false, // True if today link goes back to current selection instead
		changeMonth: false, // True if month can be selected directly, false if only prev/next
		changeYear: false, // True if year can be selected directly, false if only prev/next
		yearRange: "c-10:c+10", // Range of years to display in drop-down,
			// either relative to today's year (-nn:+nn), relative to currently displayed year
			// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
		showOtherMonths: false, // True to show dates in other months, false to leave blank
		selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
		showWeek: false, // True to show week of the year, false to not show it
		calculateWeek: this.iso8601Week, // How to calculate the week of the year,
			// takes a Date and returns the number of the week for it
		shortYearCutoff: "+10", // Short year values < this are in the current century,
			// > this are in the previous century,
			// string value starting with "+" for current year + value
		minDate: null, // The earliest selectable date, or null for no limit
		maxDate: null, // The latest selectable date, or null for no limit
		duration: "fast", // Duration of display/closure
		beforeShowDay: null, // Function that takes a date and returns an array with
			// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
			// [2] = cell title (optional), e.g. $.datepicker.noWeekends
		beforeShow: null, // Function that takes an input field and
			// returns a set of custom settings for the date picker
		onSelect: null, // Define a callback function when a date is selected
		onChangeMonthYear: null, // Define a callback function when the month or year is changed
		onClose: null, // Define a callback function when the datepicker is closed
		onUpdateDatepicker: null, // Define a callback function when the datepicker is updated
		numberOfMonths: 1, // Number of months to show at a time
		showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
		stepMonths: 1, // Number of months to step back/forward
		stepBigMonths: 12, // Number of months to step back/forward for the big links
		altField: "", // Selector for an alternate field to store selected dates into
		altFormat: "", // The date format to use for the alternate field
		constrainInput: true, // The input is constrained by the current date format
		showButtonPanel: false, // True to show button panel, false to not show it
		autoSize: false, // True to size the input for the date format, false to leave as is
		disabled: false // The initial disabled state
	};
	$.extend( this._defaults, this.regional[ "" ] );
	this.regional.en = $.extend( true, {}, this.regional[ "" ] );
	this.regional[ "en-US" ] = $.extend( true, {}, this.regional.en );
	this.dpDiv = datepicker_bindHover( $( "<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) );
}

$.extend( Datepicker.prototype, {

	/* Class name added to elements to indicate already configured with a date picker. */
	markerClassName: "hasDatepicker",

	//Keep track of the maximum number of rows displayed (see #7043)
	maxRows: 4,

	// TODO rename to "widget" when switching to widget factory
	_widgetDatepicker: function() {
		return this.dpDiv;
	},

	/* Override the default settings for all instances of the date picker.
	 * @param  settings  object - the new settings to use as defaults (anonymous object)
	 * @return the manager object
	 */
	setDefaults: function( settings ) {
		datepicker_extendRemove( this._defaults, settings || {} );
		return this;
	},

	/* Attach the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
	 */
	_attachDatepicker: function( target, settings ) {
		var nodeName, inline, inst;
		nodeName = target.nodeName.toLowerCase();
		inline = ( nodeName === "div" || nodeName === "span" );
		if ( !target.id ) {
			this.uuid += 1;
			target.id = "dp" + this.uuid;
		}
		inst = this._newInst( $( target ), inline );
		inst.settings = $.extend( {}, settings || {} );
		if ( nodeName === "input" ) {
			this._connectDatepicker( target, inst );
		} else if ( inline ) {
			this._inlineDatepicker( target, inst );
		}
	},

	/* Create a new instance object. */
	_newInst: function( target, inline ) {
		var id = target[ 0 ].id.replace( /([^A-Za-z0-9_\-])/g, "\\\\$1" ); // escape jQuery meta chars
		return { id: id, input: target, // associated target
			selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
			drawMonth: 0, drawYear: 0, // month being drawn
			inline: inline, // is datepicker inline or not
			dpDiv: ( !inline ? this.dpDiv : // presentation div
			datepicker_bindHover( $( "<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) ) ) };
	},

	/* Attach the date picker to an input field. */
	_connectDatepicker: function( target, inst ) {
		var input = $( target );
		inst.append = $( [] );
		inst.trigger = $( [] );
		if ( input.hasClass( this.markerClassName ) ) {
			return;
		}
		this._attachments( input, inst );
		input.addClass( this.markerClassName ).on( "keydown", this._doKeyDown ).
			on( "keypress", this._doKeyPress ).on( "keyup", this._doKeyUp );
		this._autoSize( inst );
		$.data( target, "datepicker", inst );

		//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
		if ( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
	},

	/* Make attachments based on settings. */
	_attachments: function( input, inst ) {
		var showOn, buttonText, buttonImage,
			appendText = this._get( inst, "appendText" ),
			isRTL = this._get( inst, "isRTL" );

		if ( inst.append ) {
			inst.append.remove();
		}
		if ( appendText ) {
			inst.append = $( "<span>" )
				.addClass( this._appendClass )
				.text( appendText );
			input[ isRTL ? "before" : "after" ]( inst.append );
		}

		input.off( "focus", this._showDatepicker );

		if ( inst.trigger ) {
			inst.trigger.remove();
		}

		showOn = this._get( inst, "showOn" );
		if ( showOn === "focus" || showOn === "both" ) { // pop-up date picker when in the marked field
			input.on( "focus", this._showDatepicker );
		}
		if ( showOn === "button" || showOn === "both" ) { // pop-up date picker when button clicked
			buttonText = this._get( inst, "buttonText" );
			buttonImage = this._get( inst, "buttonImage" );

			if ( this._get( inst, "buttonImageOnly" ) ) {
				inst.trigger = $( "<img>" )
					.addClass( this._triggerClass )
					.attr( {
						src: buttonImage,
						alt: buttonText,
						title: buttonText
					} );
			} else {
				inst.trigger = $( "<button type='button'>" )
					.addClass( this._triggerClass );
				if ( buttonImage ) {
					inst.trigger.html(
						$( "<img>" )
							.attr( {
								src: buttonImage,
								alt: buttonText,
								title: buttonText
							} )
					);
				} else {
					inst.trigger.text( buttonText );
				}
			}

			input[ isRTL ? "before" : "after" ]( inst.trigger );
			inst.trigger.on( "click", function() {
				if ( $.datepicker._datepickerShowing && $.datepicker._lastInput === input[ 0 ] ) {
					$.datepicker._hideDatepicker();
				} else if ( $.datepicker._datepickerShowing && $.datepicker._lastInput !== input[ 0 ] ) {
					$.datepicker._hideDatepicker();
					$.datepicker._showDatepicker( input[ 0 ] );
				} else {
					$.datepicker._showDatepicker( input[ 0 ] );
				}
				return false;
			} );
		}
	},

	/* Apply the maximum length for the date format. */
	_autoSize: function( inst ) {
		if ( this._get( inst, "autoSize" ) && !inst.inline ) {
			var findMax, max, maxI, i,
				date = new Date( 2009, 12 - 1, 20 ), // Ensure double digits
				dateFormat = this._get( inst, "dateFormat" );

			if ( dateFormat.match( /[DM]/ ) ) {
				findMax = function( names ) {
					max = 0;
					maxI = 0;
					for ( i = 0; i < names.length; i++ ) {
						if ( names[ i ].length > max ) {
							max = names[ i ].length;
							maxI = i;
						}
					}
					return maxI;
				};
				date.setMonth( findMax( this._get( inst, ( dateFormat.match( /MM/ ) ?
					"monthNames" : "monthNamesShort" ) ) ) );
				date.setDate( findMax( this._get( inst, ( dateFormat.match( /DD/ ) ?
					"dayNames" : "dayNamesShort" ) ) ) + 20 - date.getDay() );
			}
			inst.input.attr( "size", this._formatDate( inst, date ).length );
		}
	},

	/* Attach an inline date picker to a div. */
	_inlineDatepicker: function( target, inst ) {
		var divSpan = $( target );
		if ( divSpan.hasClass( this.markerClassName ) ) {
			return;
		}
		divSpan.addClass( this.markerClassName ).append( inst.dpDiv );
		$.data( target, "datepicker", inst );
		this._setDate( inst, this._getDefaultDate( inst ), true );
		this._updateDatepicker( inst );
		this._updateAlternate( inst );

		//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
		if ( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}

		// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
		// https://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
		inst.dpDiv.css( "display", "block" );
	},

	/* Pop-up the date picker in a "dialog" box.
	 * @param  input element - ignored
	 * @param  date	string or Date - the initial date to display
	 * @param  onSelect  function - the function to call when a date is selected
	 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
	 * @param  pos int[2] - coordinates for the dialog's position within the screen or
	 *					event - with x/y coordinates or
	 *					leave empty for default (screen centre)
	 * @return the manager object
	 */
	_dialogDatepicker: function( input, date, onSelect, settings, pos ) {
		var id, browserWidth, browserHeight, scrollX, scrollY,
			inst = this._dialogInst; // internal instance

		if ( !inst ) {
			this.uuid += 1;
			id = "dp" + this.uuid;
			this._dialogInput = $( "<input type='text' id='" + id +
				"' style='position: absolute; top: -100px; width: 0px;'/>" );
			this._dialogInput.on( "keydown", this._doKeyDown );
			$( "body" ).append( this._dialogInput );
			inst = this._dialogInst = this._newInst( this._dialogInput, false );
			inst.settings = {};
			$.data( this._dialogInput[ 0 ], "datepicker", inst );
		}
		datepicker_extendRemove( inst.settings, settings || {} );
		date = ( date && date.constructor === Date ? this._formatDate( inst, date ) : date );
		this._dialogInput.val( date );

		this._pos = ( pos ? ( pos.length ? pos : [ pos.pageX, pos.pageY ] ) : null );
		if ( !this._pos ) {
			browserWidth = document.documentElement.clientWidth;
			browserHeight = document.documentElement.clientHeight;
			scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
			scrollY = document.documentElement.scrollTop || document.body.scrollTop;
			this._pos = // should use actual width/height below
				[ ( browserWidth / 2 ) - 100 + scrollX, ( browserHeight / 2 ) - 150 + scrollY ];
		}

		// Move input on screen for focus, but hidden behind dialog
		this._dialogInput.css( "left", ( this._pos[ 0 ] + 20 ) + "px" ).css( "top", this._pos[ 1 ] + "px" );
		inst.settings.onSelect = onSelect;
		this._inDialog = true;
		this.dpDiv.addClass( this._dialogClass );
		this._showDatepicker( this._dialogInput[ 0 ] );
		if ( $.blockUI ) {
			$.blockUI( this.dpDiv );
		}
		$.data( this._dialogInput[ 0 ], "datepicker", inst );
		return this;
	},

	/* Detach a datepicker from its control.
	 * @param  target	element - the target input field or division or span
	 */
	_destroyDatepicker: function( target ) {
		var nodeName,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		$.removeData( target, "datepicker" );
		if ( nodeName === "input" ) {
			inst.append.remove();
			inst.trigger.remove();
			$target.removeClass( this.markerClassName ).
				off( "focus", this._showDatepicker ).
				off( "keydown", this._doKeyDown ).
				off( "keypress", this._doKeyPress ).
				off( "keyup", this._doKeyUp );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			$target.removeClass( this.markerClassName ).empty();
		}

		$.datepicker._hideDatepicker();
		if ( datepicker_instActive === inst ) {
			datepicker_instActive = null;
			this._curInst = null;
		}
	},

	/* Enable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_enableDatepicker: function( target ) {
		var nodeName, inline,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if ( nodeName === "input" ) {
			target.disabled = false;
			inst.trigger.filter( "button" ).
				each( function() {
					this.disabled = false;
				} ).end().
				filter( "img" ).css( { opacity: "1.0", cursor: "" } );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			inline = $target.children( "." + this._inlineClass );
			inline.children().removeClass( "ui-state-disabled" );
			inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
				prop( "disabled", false );
		}
		this._disabledInputs = $.map( this._disabledInputs,

			// Delete entry
			function( value ) {
				return ( value === target ? null : value );
			} );
	},

	/* Disable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_disableDatepicker: function( target ) {
		var nodeName, inline,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if ( nodeName === "input" ) {
			target.disabled = true;
			inst.trigger.filter( "button" ).
				each( function() {
					this.disabled = true;
				} ).end().
				filter( "img" ).css( { opacity: "0.5", cursor: "default" } );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			inline = $target.children( "." + this._inlineClass );
			inline.children().addClass( "ui-state-disabled" );
			inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
				prop( "disabled", true );
		}
		this._disabledInputs = $.map( this._disabledInputs,

			// Delete entry
			function( value ) {
				return ( value === target ? null : value );
			} );
		this._disabledInputs[ this._disabledInputs.length ] = target;
	},

	/* Is the first field in a jQuery collection disabled as a datepicker?
	 * @param  target	element - the target input field or division or span
	 * @return boolean - true if disabled, false if enabled
	 */
	_isDisabledDatepicker: function( target ) {
		if ( !target ) {
			return false;
		}
		for ( var i = 0; i < this._disabledInputs.length; i++ ) {
			if ( this._disabledInputs[ i ] === target ) {
				return true;
			}
		}
		return false;
	},

	/* Retrieve the instance data for the target control.
	 * @param  target  element - the target input field or division or span
	 * @return  object - the associated instance data
	 * @throws  error if a jQuery problem getting data
	 */
	_getInst: function( target ) {
		try {
			return $.data( target, "datepicker" );
		} catch ( _err ) {
			throw "Missing instance data for this datepicker";
		}
	},

	/* Update or retrieve the settings for a date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 * @param  name	object - the new settings to update or
	 *				string - the name of the setting to change or retrieve,
	 *				when retrieving also "all" for all instance settings or
	 *				"defaults" for all global defaults
	 * @param  value   any - the new value for the setting
	 *				(omit if above is an object or to retrieve a value)
	 */
	_optionDatepicker: function( target, name, value ) {
		var settings, date, minDate, maxDate,
			inst = this._getInst( target );

		if ( arguments.length === 2 && typeof name === "string" ) {
			return ( name === "defaults" ? $.extend( {}, $.datepicker._defaults ) :
				( inst ? ( name === "all" ? $.extend( {}, inst.settings ) :
				this._get( inst, name ) ) : null ) );
		}

		settings = name || {};
		if ( typeof name === "string" ) {
			settings = {};
			settings[ name ] = value;
		}

		if ( inst ) {
			if ( this._curInst === inst ) {
				this._hideDatepicker();
			}

			date = this._getDateDatepicker( target, true );
			minDate = this._getMinMaxDate( inst, "min" );
			maxDate = this._getMinMaxDate( inst, "max" );
			datepicker_extendRemove( inst.settings, settings );

			// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
			if ( minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined ) {
				inst.settings.minDate = this._formatDate( inst, minDate );
			}
			if ( maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined ) {
				inst.settings.maxDate = this._formatDate( inst, maxDate );
			}
			if ( "disabled" in settings ) {
				if ( settings.disabled ) {
					this._disableDatepicker( target );
				} else {
					this._enableDatepicker( target );
				}
			}
			this._attachments( $( target ), inst );
			this._autoSize( inst );
			this._setDate( inst, date );
			this._updateAlternate( inst );
			this._updateDatepicker( inst );
		}
	},

	// Change method deprecated
	_changeDatepicker: function( target, name, value ) {
		this._optionDatepicker( target, name, value );
	},

	/* Redraw the date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 */
	_refreshDatepicker: function( target ) {
		var inst = this._getInst( target );
		if ( inst ) {
			this._updateDatepicker( inst );
		}
	},

	/* Set the dates for a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  date	Date - the new date
	 */
	_setDateDatepicker: function( target, date ) {
		var inst = this._getInst( target );
		if ( inst ) {
			this._setDate( inst, date );
			this._updateDatepicker( inst );
			this._updateAlternate( inst );
		}
	},

	/* Get the date(s) for the first entry in a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  noDefault boolean - true if no default date is to be used
	 * @return Date - the current date
	 */
	_getDateDatepicker: function( target, noDefault ) {
		var inst = this._getInst( target );
		if ( inst && !inst.inline ) {
			this._setDateFromField( inst, noDefault );
		}
		return ( inst ? this._getDate( inst ) : null );
	},

	/* Handle keystrokes. */
	_doKeyDown: function( event ) {
		var onSelect, dateStr, sel,
			inst = $.datepicker._getInst( event.target ),
			handled = true,
			isRTL = inst.dpDiv.is( ".ui-datepicker-rtl" );

		inst._keyEvent = true;
		if ( $.datepicker._datepickerShowing ) {
			switch ( event.keyCode ) {
				case 9: $.datepicker._hideDatepicker();
						handled = false;
						break; // hide on tab out
				case 13: sel = $( "td." + $.datepicker._dayOverClass + ":not(." +
									$.datepicker._currentClass + ")", inst.dpDiv );
						if ( sel[ 0 ] ) {
							$.datepicker._selectDay( event.target, inst.selectedMonth, inst.selectedYear, sel[ 0 ] );
						}

						onSelect = $.datepicker._get( inst, "onSelect" );
						if ( onSelect ) {
							dateStr = $.datepicker._formatDate( inst );

							// Trigger custom callback
							onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );
						} else {
							$.datepicker._hideDatepicker();
						}

						return false; // don't submit the form
				case 27: $.datepicker._hideDatepicker();
						break; // hide on escape
				case 33: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
							-$.datepicker._get( inst, "stepBigMonths" ) :
							-$.datepicker._get( inst, "stepMonths" ) ), "M" );
						break; // previous month/year on page up/+ ctrl
				case 34: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
							+$.datepicker._get( inst, "stepBigMonths" ) :
							+$.datepicker._get( inst, "stepMonths" ) ), "M" );
						break; // next month/year on page down/+ ctrl
				case 35: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._clearDate( event.target );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // clear on ctrl or command +end
				case 36: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._gotoToday( event.target );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // current on ctrl or command +home
				case 37: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, ( isRTL ? +1 : -1 ), "D" );
						}
						handled = event.ctrlKey || event.metaKey;

						// -1 day on ctrl or command +left
						if ( event.originalEvent.altKey ) {
							$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								-$.datepicker._get( inst, "stepBigMonths" ) :
								-$.datepicker._get( inst, "stepMonths" ) ), "M" );
						}

						// next month/year on alt +left on Mac
						break;
				case 38: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, -7, "D" );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // -1 week on ctrl or command +up
				case 39: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, ( isRTL ? -1 : +1 ), "D" );
						}
						handled = event.ctrlKey || event.metaKey;

						// +1 day on ctrl or command +right
						if ( event.originalEvent.altKey ) {
							$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								+$.datepicker._get( inst, "stepBigMonths" ) :
								+$.datepicker._get( inst, "stepMonths" ) ), "M" );
						}

						// next month/year on alt +right
						break;
				case 40: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, +7, "D" );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // +1 week on ctrl or command +down
				default: handled = false;
			}
		} else if ( event.keyCode === 36 && event.ctrlKey ) { // display the date picker on ctrl+home
			$.datepicker._showDatepicker( this );
		} else {
			handled = false;
		}

		if ( handled ) {
			event.preventDefault();
			event.stopPropagation();
		}
	},

	/* Filter entered characters - based on date format. */
	_doKeyPress: function( event ) {
		var chars, chr,
			inst = $.datepicker._getInst( event.target );

		if ( $.datepicker._get( inst, "constrainInput" ) ) {
			chars = $.datepicker._possibleChars( $.datepicker._get( inst, "dateFormat" ) );
			chr = String.fromCharCode( event.charCode == null ? event.keyCode : event.charCode );
			return event.ctrlKey || event.metaKey || ( chr < " " || !chars || chars.indexOf( chr ) > -1 );
		}
	},

	/* Synchronise manual entry and field/alternate field. */
	_doKeyUp: function( event ) {
		var date,
			inst = $.datepicker._getInst( event.target );

		if ( inst.input.val() !== inst.lastVal ) {
			try {
				date = $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
					( inst.input ? inst.input.val() : null ),
					$.datepicker._getFormatConfig( inst ) );

				if ( date ) { // only if valid
					$.datepicker._setDateFromField( inst );
					$.datepicker._updateAlternate( inst );
					$.datepicker._updateDatepicker( inst );
				}
			} catch ( _err ) {
			}
		}
		return true;
	},

	/* Pop-up the date picker for a given input field.
	 * If false returned from beforeShow event handler do not show.
	 * @param  input  element - the input field attached to the date picker or
	 *					event - if triggered by focus
	 */
	_showDatepicker: function( input ) {
		input = input.target || input;
		if ( input.nodeName.toLowerCase() !== "input" ) { // find from button/image trigger
			input = $( "input", input.parentNode )[ 0 ];
		}

		if ( $.datepicker._isDisabledDatepicker( input ) || $.datepicker._lastInput === input ) { // already here
			return;
		}

		var inst, beforeShow, beforeShowSettings, isFixed,
			offset, showAnim, duration;

		inst = $.datepicker._getInst( input );
		if ( $.datepicker._curInst && $.datepicker._curInst !== inst ) {
			$.datepicker._curInst.dpDiv.stop( true, true );
			if ( inst && $.datepicker._datepickerShowing ) {
				$.datepicker._hideDatepicker( $.datepicker._curInst.input[ 0 ] );
			}
		}

		beforeShow = $.datepicker._get( inst, "beforeShow" );
		beforeShowSettings = beforeShow ? beforeShow.apply( input, [ input, inst ] ) : {};
		if ( beforeShowSettings === false ) {
			return;
		}
		datepicker_extendRemove( inst.settings, beforeShowSettings );

		inst.lastVal = null;
		$.datepicker._lastInput = input;
		$.datepicker._setDateFromField( inst );

		if ( $.datepicker._inDialog ) { // hide cursor
			input.value = "";
		}
		if ( !$.datepicker._pos ) { // position below input
			$.datepicker._pos = $.datepicker._findPos( input );
			$.datepicker._pos[ 1 ] += input.offsetHeight; // add the height
		}

		isFixed = false;
		$( input ).parents().each( function() {
			isFixed |= $( this ).css( "position" ) === "fixed";
			return !isFixed;
		} );

		offset = { left: $.datepicker._pos[ 0 ], top: $.datepicker._pos[ 1 ] };
		$.datepicker._pos = null;

		//to avoid flashes on Firefox
		inst.dpDiv.empty();

		// determine sizing offscreen
		inst.dpDiv.css( { position: "absolute", display: "block", top: "-1000px" } );
		$.datepicker._updateDatepicker( inst );

		// fix width for dynamic number of date pickers
		// and adjust position before showing
		offset = $.datepicker._checkOffset( inst, offset, isFixed );
		inst.dpDiv.css( { position: ( $.datepicker._inDialog && $.blockUI ?
			"static" : ( isFixed ? "fixed" : "absolute" ) ), display: "none",
			left: offset.left + "px", top: offset.top + "px" } );

		if ( !inst.inline ) {
			showAnim = $.datepicker._get( inst, "showAnim" );
			duration = $.datepicker._get( inst, "duration" );
			inst.dpDiv.css( "z-index", datepicker_getZindex( $( input ) ) + 1 );
			$.datepicker._datepickerShowing = true;

			if ( $.effects && $.effects.effect[ showAnim ] ) {
				inst.dpDiv.show( showAnim, $.datepicker._get( inst, "showOptions" ), duration );
			} else {
				inst.dpDiv[ showAnim || "show" ]( showAnim ? duration : null );
			}

			if ( $.datepicker._shouldFocusInput( inst ) ) {
				inst.input.trigger( "focus" );
			}

			$.datepicker._curInst = inst;
		}
	},

	/* Generate the date picker content. */
	_updateDatepicker: function( inst ) {
		this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
		datepicker_instActive = inst; // for delegate hover events
		inst.dpDiv.empty().append( this._generateHTML( inst ) );
		this._attachHandlers( inst );

		var origyearshtml,
			numMonths = this._getNumberOfMonths( inst ),
			cols = numMonths[ 1 ],
			width = 17,
			activeCell = inst.dpDiv.find( "." + this._dayOverClass + " a" ),
			onUpdateDatepicker = $.datepicker._get( inst, "onUpdateDatepicker" );

		if ( activeCell.length > 0 ) {
			datepicker_handleMouseover.apply( activeCell.get( 0 ) );
		}

		inst.dpDiv.removeClass( "ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4" ).width( "" );
		if ( cols > 1 ) {
			inst.dpDiv.addClass( "ui-datepicker-multi-" + cols ).css( "width", ( width * cols ) + "em" );
		}
		inst.dpDiv[ ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ? "add" : "remove" ) +
			"Class" ]( "ui-datepicker-multi" );
		inst.dpDiv[ ( this._get( inst, "isRTL" ) ? "add" : "remove" ) +
			"Class" ]( "ui-datepicker-rtl" );

		if ( inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput( inst ) ) {
			inst.input.trigger( "focus" );
		}

		// Deffered render of the years select (to avoid flashes on Firefox)
		if ( inst.yearshtml ) {
			origyearshtml = inst.yearshtml;
			setTimeout( function() {

				//assure that inst.yearshtml didn't change.
				if ( origyearshtml === inst.yearshtml && inst.yearshtml ) {
					inst.dpDiv.find( "select.ui-datepicker-year" ).first().replaceWith( inst.yearshtml );
				}
				origyearshtml = inst.yearshtml = null;
			}, 0 );
		}

		if ( onUpdateDatepicker ) {
			onUpdateDatepicker.apply( ( inst.input ? inst.input[ 0 ] : null ), [ inst ] );
		}
	},

	_shouldFocusInput: function( inst ) {
		return inst.input && inst.input.is( ":visible" ) && !inst.input.is( ":disabled" );
	},

	/* Check positioning to remain on screen. */
	_checkOffset: function( inst, offset, isFixed ) {
		var dpWidth = inst.dpDiv.outerWidth(),
			dpHeight = inst.dpDiv.outerHeight(),
			inputWidth = inst.input ? inst.input.outerWidth() : 0,
			inputHeight = inst.input ? inst.input.outerHeight() : 0,
			viewWidth = document.documentElement.clientWidth + ( isFixed ? 0 : $( document ).scrollLeft() ),
			viewHeight = document.documentElement.clientHeight + ( isFixed ? 0 : $( document ).scrollTop() );

		offset.left -= ( this._get( inst, "isRTL" ) ? ( dpWidth - inputWidth ) : 0 );
		offset.left -= ( isFixed && offset.left === inst.input.offset().left ) ? $( document ).scrollLeft() : 0;
		offset.top -= ( isFixed && offset.top === ( inst.input.offset().top + inputHeight ) ) ? $( document ).scrollTop() : 0;

		// Now check if datepicker is showing outside window viewport - move to a better place if so.
		offset.left -= Math.min( offset.left, ( offset.left + dpWidth > viewWidth && viewWidth > dpWidth ) ?
			Math.abs( offset.left + dpWidth - viewWidth ) : 0 );
		offset.top -= Math.min( offset.top, ( offset.top + dpHeight > viewHeight && viewHeight > dpHeight ) ?
			Math.abs( dpHeight + inputHeight ) : 0 );

		return offset;
	},

	/* Find an object's position on the screen. */
	_findPos: function( obj ) {
		var position,
			inst = this._getInst( obj ),
			isRTL = this._get( inst, "isRTL" );

		while ( obj && ( obj.type === "hidden" || obj.nodeType !== 1 || $.expr.pseudos.hidden( obj ) ) ) {
			obj = obj[ isRTL ? "previousSibling" : "nextSibling" ];
		}

		position = $( obj ).offset();
		return [ position.left, position.top ];
	},

	/* Hide the date picker from view.
	 * @param  input  element - the input field attached to the date picker
	 */
	_hideDatepicker: function( input ) {
		var showAnim, duration, postProcess, onClose,
			inst = this._curInst;

		if ( !inst || ( input && inst !== $.data( input, "datepicker" ) ) ) {
			return;
		}

		if ( this._datepickerShowing ) {
			showAnim = this._get( inst, "showAnim" );
			duration = this._get( inst, "duration" );
			postProcess = function() {
				$.datepicker._tidyDialog( inst );
			};

			if ( $.effects && ( $.effects.effect[ showAnim ] ) ) {
				inst.dpDiv.hide( showAnim, $.datepicker._get( inst, "showOptions" ), duration, postProcess );
			} else {
				inst.dpDiv[ ( showAnim === "slideDown" ? "slideUp" :
					( showAnim === "fadeIn" ? "fadeOut" : "hide" ) ) ]( ( showAnim ? duration : null ), postProcess );
			}

			if ( !showAnim ) {
				postProcess();
			}
			this._datepickerShowing = false;

			onClose = this._get( inst, "onClose" );
			if ( onClose ) {
				onClose.apply( ( inst.input ? inst.input[ 0 ] : null ), [ ( inst.input ? inst.input.val() : "" ), inst ] );
			}

			this._lastInput = null;
			if ( this._inDialog ) {
				this._dialogInput.css( { position: "absolute", left: "0", top: "-100px" } );
				if ( $.blockUI ) {
					$.unblockUI();
					$( "body" ).append( this.dpDiv );
				}
			}
			this._inDialog = false;
		}
	},

	/* Tidy up after a dialog display. */
	_tidyDialog: function( inst ) {
		inst.dpDiv.removeClass( this._dialogClass ).off( ".ui-datepicker-calendar" );
	},

	/* Close date picker if clicked elsewhere. */
	_checkExternalClick: function( event ) {
		if ( !$.datepicker._curInst ) {
			return;
		}

		var $target = $( event.target ),
			inst = $.datepicker._getInst( $target[ 0 ] );

		if ( ( ( $target[ 0 ].id !== $.datepicker._mainDivId &&
				$target.parents( "#" + $.datepicker._mainDivId ).length === 0 &&
				!$target.hasClass( $.datepicker.markerClassName ) &&
				!$target.closest( "." + $.datepicker._triggerClass ).length &&
				$.datepicker._datepickerShowing && !( $.datepicker._inDialog && $.blockUI ) ) ) ||
			( $target.hasClass( $.datepicker.markerClassName ) && $.datepicker._curInst !== inst ) ) {
				$.datepicker._hideDatepicker();
		}
	},

	/* Adjust one of the date sub-fields. */
	_adjustDate: function( id, offset, period ) {
		var target = $( id ),
			inst = this._getInst( target[ 0 ] );

		if ( this._isDisabledDatepicker( target[ 0 ] ) ) {
			return;
		}
		this._adjustInstDate( inst, offset, period );
		this._updateDatepicker( inst );
	},

	/* Action for current link. */
	_gotoToday: function( id ) {
		var date,
			target = $( id ),
			inst = this._getInst( target[ 0 ] );

		if ( this._get( inst, "gotoCurrent" ) && inst.currentDay ) {
			inst.selectedDay = inst.currentDay;
			inst.drawMonth = inst.selectedMonth = inst.currentMonth;
			inst.drawYear = inst.selectedYear = inst.currentYear;
		} else {
			date = new Date();
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
		}
		this._notifyChange( inst );
		this._adjustDate( target );
	},

	/* Action for selecting a new month/year. */
	_selectMonthYear: function( id, select, period ) {
		var target = $( id ),
			inst = this._getInst( target[ 0 ] );

		inst[ "selected" + ( period === "M" ? "Month" : "Year" ) ] =
		inst[ "draw" + ( period === "M" ? "Month" : "Year" ) ] =
			parseInt( select.options[ select.selectedIndex ].value, 10 );

		this._notifyChange( inst );
		this._adjustDate( target );
	},

	/* Action for selecting a day. */
	_selectDay: function( id, month, year, td ) {
		var inst,
			target = $( id );

		if ( $( td ).hasClass( this._unselectableClass ) || this._isDisabledDatepicker( target[ 0 ] ) ) {
			return;
		}

		inst = this._getInst( target[ 0 ] );
		inst.selectedDay = inst.currentDay = parseInt( $( "a", td ).attr( "data-date" ) );
		inst.selectedMonth = inst.currentMonth = month;
		inst.selectedYear = inst.currentYear = year;
		this._selectDate( id, this._formatDate( inst,
			inst.currentDay, inst.currentMonth, inst.currentYear ) );
	},

	/* Erase the input field and hide the date picker. */
	_clearDate: function( id ) {
		var target = $( id );
		this._selectDate( target, "" );
	},

	/* Update the input field with the selected date. */
	_selectDate: function( id, dateStr ) {
		var onSelect,
			target = $( id ),
			inst = this._getInst( target[ 0 ] );

		dateStr = ( dateStr != null ? dateStr : this._formatDate( inst ) );
		if ( inst.input ) {
			inst.input.val( dateStr );
		}
		this._updateAlternate( inst );

		onSelect = this._get( inst, "onSelect" );
		if ( onSelect ) {
			onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );  // trigger custom callback
		} else if ( inst.input ) {
			inst.input.trigger( "change" ); // fire the change event
		}

		if ( inst.inline ) {
			this._updateDatepicker( inst );
		} else {
			this._hideDatepicker();
			this._lastInput = inst.input[ 0 ];
			if ( typeof( inst.input[ 0 ] ) !== "object" ) {
				inst.input.trigger( "focus" ); // restore focus
			}
			this._lastInput = null;
		}
	},

	/* Update any alternate field to synchronise with the main field. */
	_updateAlternate: function( inst ) {
		var altFormat, date, dateStr,
			altField = this._get( inst, "altField" );

		if ( altField ) { // update alternate field too
			altFormat = this._get( inst, "altFormat" ) || this._get( inst, "dateFormat" );
			date = this._getDate( inst );
			dateStr = this.formatDate( altFormat, date, this._getFormatConfig( inst ) );
			$( document ).find( altField ).val( dateStr );
		}
	},

	/* Set as beforeShowDay function to prevent selection of weekends.
	 * @param  date  Date - the date to customise
	 * @return [boolean, string] - is this date selectable?, what is its CSS class?
	 */
	noWeekends: function( date ) {
		var day = date.getDay();
		return [ ( day > 0 && day < 6 ), "" ];
	},

	/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
	 * @param  date  Date - the date to get the week for
	 * @return  number - the number of the week within the year that contains this date
	 */
	iso8601Week: function( date ) {
		var time,
			checkDate = new Date( date.getTime() );

		// Find Thursday of this week starting on Monday
		checkDate.setDate( checkDate.getDate() + 4 - ( checkDate.getDay() || 7 ) );

		time = checkDate.getTime();
		checkDate.setMonth( 0 ); // Compare with Jan 1
		checkDate.setDate( 1 );
		return Math.floor( Math.round( ( time - checkDate ) / 86400000 ) / 7 ) + 1;
	},

	/* Parse a string value into a date object.
	 * See formatDate below for the possible formats.
	 *
	 * @param  format string - the expected format of the date
	 * @param  value string - the date in the above format
	 * @param  settings Object - attributes include:
	 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  Date - the extracted date value or null if value is blank
	 */
	parseDate: function( format, value, settings ) {
		if ( format == null || value == null ) {
			throw "Invalid arguments";
		}

		value = ( typeof value === "object" ? value.toString() : value + "" );
		if ( value === "" ) {
			return null;
		}

		var iFormat, dim, extra,
			iValue = 0,
			shortYearCutoffTemp = ( settings ? settings.shortYearCutoff : null ) || this._defaults.shortYearCutoff,
			shortYearCutoff = ( typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
				new Date().getFullYear() % 100 + parseInt( shortYearCutoffTemp, 10 ) ),
			dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
			dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
			monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
			monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,
			year = -1,
			month = -1,
			day = -1,
			doy = -1,
			literal = false,
			date,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			},

			// Extract a number from the string value
			getNumber = function( match ) {
				var isDoubled = lookAhead( match ),
					size = ( match === "@" ? 14 : ( match === "!" ? 20 :
					( match === "y" && isDoubled ? 4 : ( match === "o" ? 3 : 2 ) ) ) ),
					minSize = ( match === "y" ? size : 1 ),
					digits = new RegExp( "^\\d{" + minSize + "," + size + "}" ),
					num = value.substring( iValue ).match( digits );
				if ( !num ) {
					throw "Missing number at position " + iValue;
				}
				iValue += num[ 0 ].length;
				return parseInt( num[ 0 ], 10 );
			},

			// Extract a name from the string value and convert to an index
			getName = function( match, shortNames, longNames ) {
				var index = -1,
					names = $.map( lookAhead( match ) ? longNames : shortNames, function( v, k ) {
						return [ [ k, v ] ];
					} ).sort( function( a, b ) {
						return -( a[ 1 ].length - b[ 1 ].length );
					} );

				$.each( names, function( i, pair ) {
					var name = pair[ 1 ];
					if ( value.substr( iValue, name.length ).toLowerCase() === name.toLowerCase() ) {
						index = pair[ 0 ];
						iValue += name.length;
						return false;
					}
				} );
				if ( index !== -1 ) {
					return index + 1;
				} else {
					throw "Unknown name at position " + iValue;
				}
			},

			// Confirm that a literal character matches the string value
			checkLiteral = function() {
				if ( value.charAt( iValue ) !== format.charAt( iFormat ) ) {
					throw "Unexpected literal at position " + iValue;
				}
				iValue++;
			};

		for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
			if ( literal ) {
				if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
					literal = false;
				} else {
					checkLiteral();
				}
			} else {
				switch ( format.charAt( iFormat ) ) {
					case "d":
						day = getNumber( "d" );
						break;
					case "D":
						getName( "D", dayNamesShort, dayNames );
						break;
					case "o":
						doy = getNumber( "o" );
						break;
					case "m":
						month = getNumber( "m" );
						break;
					case "M":
						month = getName( "M", monthNamesShort, monthNames );
						break;
					case "y":
						year = getNumber( "y" );
						break;
					case "@":
						date = new Date( getNumber( "@" ) );
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "!":
						date = new Date( ( getNumber( "!" ) - this._ticksTo1970 ) / 10000 );
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "'":
						if ( lookAhead( "'" ) ) {
							checkLiteral();
						} else {
							literal = true;
						}
						break;
					default:
						checkLiteral();
				}
			}
		}

		if ( iValue < value.length ) {
			extra = value.substr( iValue );
			if ( !/^\s+/.test( extra ) ) {
				throw "Extra/unparsed characters found in date: " + extra;
			}
		}

		if ( year === -1 ) {
			year = new Date().getFullYear();
		} else if ( year < 100 ) {
			year += new Date().getFullYear() - new Date().getFullYear() % 100 +
				( year <= shortYearCutoff ? 0 : -100 );
		}

		if ( doy > -1 ) {
			month = 1;
			day = doy;
			do {
				dim = this._getDaysInMonth( year, month - 1 );
				if ( day <= dim ) {
					break;
				}
				month++;
				day -= dim;
			} while ( true );
		}

		date = this._daylightSavingAdjust( new Date( year, month - 1, day ) );
		if ( date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day ) {
			throw "Invalid date"; // E.g. 31/02/00
		}
		return date;
	},

	/* Standard date formats. */
	ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
	COOKIE: "D, dd M yy",
	ISO_8601: "yy-mm-dd",
	RFC_822: "D, d M y",
	RFC_850: "DD, dd-M-y",
	RFC_1036: "D, d M y",
	RFC_1123: "D, d M yy",
	RFC_2822: "D, d M yy",
	RSS: "D, d M y", // RFC 822
	TICKS: "!",
	TIMESTAMP: "@",
	W3C: "yy-mm-dd", // ISO 8601

	_ticksTo1970: ( ( ( 1970 - 1 ) * 365 + Math.floor( 1970 / 4 ) - Math.floor( 1970 / 100 ) +
		Math.floor( 1970 / 400 ) ) * 24 * 60 * 60 * 10000000 ),

	/* Format a date object into a string value.
	 * The format can be combinations of the following:
	 * d  - day of month (no leading zero)
	 * dd - day of month (two digit)
	 * o  - day of year (no leading zeros)
	 * oo - day of year (three digit)
	 * D  - day name short
	 * DD - day name long
	 * m  - month of year (no leading zero)
	 * mm - month of year (two digit)
	 * M  - month name short
	 * MM - month name long
	 * y  - year (two digit)
	 * yy - year (four digit)
	 * @ - Unix timestamp (ms since 01/01/1970)
	 * ! - Windows ticks (100ns since 01/01/0001)
	 * "..." - literal text
	 * '' - single quote
	 *
	 * @param  format string - the desired format of the date
	 * @param  date Date - the date value to format
	 * @param  settings Object - attributes include:
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  string - the date in the above format
	 */
	formatDate: function( format, date, settings ) {
		if ( !date ) {
			return "";
		}

		var iFormat,
			dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
			dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
			monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
			monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			},

			// Format a number, with leading zero if necessary
			formatNumber = function( match, value, len ) {
				var num = "" + value;
				if ( lookAhead( match ) ) {
					while ( num.length < len ) {
						num = "0" + num;
					}
				}
				return num;
			},

			// Format a name, short or long as requested
			formatName = function( match, value, shortNames, longNames ) {
				return ( lookAhead( match ) ? longNames[ value ] : shortNames[ value ] );
			},
			output = "",
			literal = false;

		if ( date ) {
			for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
				if ( literal ) {
					if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
						literal = false;
					} else {
						output += format.charAt( iFormat );
					}
				} else {
					switch ( format.charAt( iFormat ) ) {
						case "d":
							output += formatNumber( "d", date.getDate(), 2 );
							break;
						case "D":
							output += formatName( "D", date.getDay(), dayNamesShort, dayNames );
							break;
						case "o":
							output += formatNumber( "o",
								Math.round( ( new Date( date.getFullYear(), date.getMonth(), date.getDate() ).getTime() - new Date( date.getFullYear(), 0, 0 ).getTime() ) / 86400000 ), 3 );
							break;
						case "m":
							output += formatNumber( "m", date.getMonth() + 1, 2 );
							break;
						case "M":
							output += formatName( "M", date.getMonth(), monthNamesShort, monthNames );
							break;
						case "y":
							output += ( lookAhead( "y" ) ? date.getFullYear() :
								( date.getFullYear() % 100 < 10 ? "0" : "" ) + date.getFullYear() % 100 );
							break;
						case "@":
							output += date.getTime();
							break;
						case "!":
							output += date.getTime() * 10000 + this._ticksTo1970;
							break;
						case "'":
							if ( lookAhead( "'" ) ) {
								output += "'";
							} else {
								literal = true;
							}
							break;
						default:
							output += format.charAt( iFormat );
					}
				}
			}
		}
		return output;
	},

	/* Extract all possible characters from the date format. */
	_possibleChars: function( format ) {
		var iFormat,
			chars = "",
			literal = false,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			};

		for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
			if ( literal ) {
				if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
					literal = false;
				} else {
					chars += format.charAt( iFormat );
				}
			} else {
				switch ( format.charAt( iFormat ) ) {
					case "d": case "m": case "y": case "@":
						chars += "0123456789";
						break;
					case "D": case "M":
						return null; // Accept anything
					case "'":
						if ( lookAhead( "'" ) ) {
							chars += "'";
						} else {
							literal = true;
						}
						break;
					default:
						chars += format.charAt( iFormat );
				}
			}
		}
		return chars;
	},

	/* Get a setting value, defaulting if necessary. */
	_get: function( inst, name ) {
		return inst.settings[ name ] !== undefined ?
			inst.settings[ name ] : this._defaults[ name ];
	},

	/* Parse existing date and initialise date picker. */
	_setDateFromField: function( inst, noDefault ) {
		if ( inst.input.val() === inst.lastVal ) {
			return;
		}

		var dateFormat = this._get( inst, "dateFormat" ),
			dates = inst.lastVal = inst.input ? inst.input.val() : null,
			defaultDate = this._getDefaultDate( inst ),
			date = defaultDate,
			settings = this._getFormatConfig( inst );

		try {
			date = this.parseDate( dateFormat, dates, settings ) || defaultDate;
		} catch ( _err ) {
			dates = ( noDefault ? "" : dates );
		}
		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		inst.currentDay = ( dates ? date.getDate() : 0 );
		inst.currentMonth = ( dates ? date.getMonth() : 0 );
		inst.currentYear = ( dates ? date.getFullYear() : 0 );
		this._adjustInstDate( inst );
	},

	/* Retrieve the default date shown on opening. */
	_getDefaultDate: function( inst ) {
		return this._restrictMinMax( inst,
			this._determineDate( inst, this._get( inst, "defaultDate" ), new Date() ) );
	},

	/* A date may be specified as an exact value or a relative one. */
	_determineDate: function( inst, date, defaultDate ) {
		var offsetNumeric = function( offset ) {
				var date = new Date();
				date.setDate( date.getDate() + offset );
				return date;
			},
			offsetString = function( offset ) {
				try {
					return $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
						offset, $.datepicker._getFormatConfig( inst ) );
				} catch ( _e ) {

					// Ignore
				}

				var date = ( offset.toLowerCase().match( /^c/ ) ?
					$.datepicker._getDate( inst ) : null ) || new Date(),
					year = date.getFullYear(),
					month = date.getMonth(),
					day = date.getDate(),
					pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
					matches = pattern.exec( offset );

				while ( matches ) {
					switch ( matches[ 2 ] || "d" ) {
						case "d" : case "D" :
							day += parseInt( matches[ 1 ], 10 ); break;
						case "w" : case "W" :
							day += parseInt( matches[ 1 ], 10 ) * 7; break;
						case "m" : case "M" :
							month += parseInt( matches[ 1 ], 10 );
							day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
							break;
						case "y": case "Y" :
							year += parseInt( matches[ 1 ], 10 );
							day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
							break;
					}
					matches = pattern.exec( offset );
				}
				return new Date( year, month, day );
			},
			newDate = ( date == null || date === "" ? defaultDate : ( typeof date === "string" ? offsetString( date ) :
				( typeof date === "number" ? ( isNaN( date ) ? defaultDate : offsetNumeric( date ) ) : new Date( date.getTime() ) ) ) );

		newDate = ( newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate );
		if ( newDate ) {
			newDate.setHours( 0 );
			newDate.setMinutes( 0 );
			newDate.setSeconds( 0 );
			newDate.setMilliseconds( 0 );
		}
		return this._daylightSavingAdjust( newDate );
	},

	/* Handle switch to/from daylight saving.
	 * Hours may be non-zero on daylight saving cut-over:
	 * > 12 when midnight changeover, but then cannot generate
	 * midnight datetime, so jump to 1AM, otherwise reset.
	 * @param  date  (Date) the date to check
	 * @return  (Date) the corrected date
	 */
	_daylightSavingAdjust: function( date ) {
		if ( !date ) {
			return null;
		}
		date.setHours( date.getHours() > 12 ? date.getHours() + 2 : 0 );
		return date;
	},

	/* Set the date(s) directly. */
	_setDate: function( inst, date, noChange ) {
		var clear = !date,
			origMonth = inst.selectedMonth,
			origYear = inst.selectedYear,
			newDate = this._restrictMinMax( inst, this._determineDate( inst, date, new Date() ) );

		inst.selectedDay = inst.currentDay = newDate.getDate();
		inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
		inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
		if ( ( origMonth !== inst.selectedMonth || origYear !== inst.selectedYear ) && !noChange ) {
			this._notifyChange( inst );
		}
		this._adjustInstDate( inst );
		if ( inst.input ) {
			inst.input.val( clear ? "" : this._formatDate( inst ) );
		}
	},

	/* Retrieve the date(s) directly. */
	_getDate: function( inst ) {
		var startDate = ( !inst.currentYear || ( inst.input && inst.input.val() === "" ) ? null :
			this._daylightSavingAdjust( new Date(
			inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
			return startDate;
	},

	/* Attach the onxxx handlers.  These are declared statically so
	 * they work with static code transformers like Caja.
	 */
	_attachHandlers: function( inst ) {
		var stepMonths = this._get( inst, "stepMonths" ),
			id = "#" + inst.id.replace( /\\\\/g, "\\" );
		inst.dpDiv.find( "[data-handler]" ).map( function() {
			var handler = {
				prev: function() {
					$.datepicker._adjustDate( id, -stepMonths, "M" );
				},
				next: function() {
					$.datepicker._adjustDate( id, +stepMonths, "M" );
				},
				hide: function() {
					$.datepicker._hideDatepicker();
				},
				today: function() {
					$.datepicker._gotoToday( id );
				},
				selectDay: function() {
					$.datepicker._selectDay( id, +this.getAttribute( "data-month" ), +this.getAttribute( "data-year" ), this );
					return false;
				},
				selectMonth: function() {
					$.datepicker._selectMonthYear( id, this, "M" );
					return false;
				},
				selectYear: function() {
					$.datepicker._selectMonthYear( id, this, "Y" );
					return false;
				}
			};
			$( this ).on( this.getAttribute( "data-event" ), handler[ this.getAttribute( "data-handler" ) ] );
		} );
	},

	/* Generate the HTML for the current state of the date picker. */
	_generateHTML: function( inst ) {
		var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
			controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
			monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
			selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
			cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
			printDate, dRow, tbody, daySettings, otherMonth, unselectable,
			tempDate = new Date(),
			today = this._daylightSavingAdjust(
				new Date( tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate() ) ), // clear time
			isRTL = this._get( inst, "isRTL" ),
			showButtonPanel = this._get( inst, "showButtonPanel" ),
			hideIfNoPrevNext = this._get( inst, "hideIfNoPrevNext" ),
			navigationAsDateFormat = this._get( inst, "navigationAsDateFormat" ),
			numMonths = this._getNumberOfMonths( inst ),
			showCurrentAtPos = this._get( inst, "showCurrentAtPos" ),
			stepMonths = this._get( inst, "stepMonths" ),
			isMultiMonth = ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ),
			currentDate = this._daylightSavingAdjust( ( !inst.currentDay ? new Date( 9999, 9, 9 ) :
				new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) ),
			minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			drawMonth = inst.drawMonth - showCurrentAtPos,
			drawYear = inst.drawYear;

		if ( drawMonth < 0 ) {
			drawMonth += 12;
			drawYear--;
		}
		if ( maxDate ) {
			maxDraw = this._daylightSavingAdjust( new Date( maxDate.getFullYear(),
				maxDate.getMonth() - ( numMonths[ 0 ] * numMonths[ 1 ] ) + 1, maxDate.getDate() ) );
			maxDraw = ( minDate && maxDraw < minDate ? minDate : maxDraw );
			while ( this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 ) ) > maxDraw ) {
				drawMonth--;
				if ( drawMonth < 0 ) {
					drawMonth = 11;
					drawYear--;
				}
			}
		}
		inst.drawMonth = drawMonth;
		inst.drawYear = drawYear;

		prevText = this._get( inst, "prevText" );
		prevText = ( !navigationAsDateFormat ? prevText : this.formatDate( prevText,
			this._daylightSavingAdjust( new Date( drawYear, drawMonth - stepMonths, 1 ) ),
			this._getFormatConfig( inst ) ) );

		if ( this._canAdjustMonth( inst, -1, drawYear, drawMonth ) ) {
			prev = $( "<a>" )
				.attr( {
					"class": "ui-datepicker-prev ui-corner-all",
					"data-handler": "prev",
					"data-event": "click",
					title: prevText
				} )
				.append(
					$( "<span>" )
						.addClass( "ui-icon ui-icon-circle-triangle-" +
							( isRTL ? "e" : "w" ) )
						.text( prevText )
				)[ 0 ].outerHTML;
		} else if ( hideIfNoPrevNext ) {
			prev = "";
		} else {
			prev = $( "<a>" )
				.attr( {
					"class": "ui-datepicker-prev ui-corner-all ui-state-disabled",
					title: prevText
				} )
				.append(
					$( "<span>" )
						.addClass( "ui-icon ui-icon-circle-triangle-" +
							( isRTL ? "e" : "w" ) )
						.text( prevText )
				)[ 0 ].outerHTML;
		}

		nextText = this._get( inst, "nextText" );
		nextText = ( !navigationAsDateFormat ? nextText : this.formatDate( nextText,
			this._daylightSavingAdjust( new Date( drawYear, drawMonth + stepMonths, 1 ) ),
			this._getFormatConfig( inst ) ) );

		if ( this._canAdjustMonth( inst, +1, drawYear, drawMonth ) ) {
			next = $( "<a>" )
				.attr( {
					"class": "ui-datepicker-next ui-corner-all",
					"data-handler": "next",
					"data-event": "click",
					title: nextText
				} )
				.append(
					$( "<span>" )
						.addClass( "ui-icon ui-icon-circle-triangle-" +
							( isRTL ? "w" : "e" ) )
						.text( nextText )
				)[ 0 ].outerHTML;
		} else if ( hideIfNoPrevNext ) {
			next = "";
		} else {
			next = $( "<a>" )
				.attr( {
					"class": "ui-datepicker-next ui-corner-all ui-state-disabled",
					title: nextText
				} )
				.append(
					$( "<span>" )
						.attr( "class", "ui-icon ui-icon-circle-triangle-" +
							( isRTL ? "w" : "e" ) )
						.text( nextText )
				)[ 0 ].outerHTML;
		}

		currentText = this._get( inst, "currentText" );
		gotoDate = ( this._get( inst, "gotoCurrent" ) && inst.currentDay ? currentDate : today );
		currentText = ( !navigationAsDateFormat ? currentText :
			this.formatDate( currentText, gotoDate, this._getFormatConfig( inst ) ) );

		controls = "";
		if ( !inst.inline ) {
			controls = $( "<button>" )
				.attr( {
					type: "button",
					"class": "ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all",
					"data-handler": "hide",
					"data-event": "click"
				} )
				.text( this._get( inst, "closeText" ) )[ 0 ].outerHTML;
		}

		buttonPanel = "";
		if ( showButtonPanel ) {
			buttonPanel = $( "<div class='ui-datepicker-buttonpane ui-widget-content'>" )
				.append( isRTL ? controls : "" )
				.append( this._isInRange( inst, gotoDate ) ?
					$( "<button>" )
						.attr( {
							type: "button",
							"class": "ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all",
							"data-handler": "today",
							"data-event": "click"
						} )
						.text( currentText ) :
					"" )
				.append( isRTL ? "" : controls )[ 0 ].outerHTML;
		}

		firstDay = parseInt( this._get( inst, "firstDay" ), 10 );
		firstDay = ( isNaN( firstDay ) ? 0 : firstDay );

		showWeek = this._get( inst, "showWeek" );
		dayNames = this._get( inst, "dayNames" );
		dayNamesMin = this._get( inst, "dayNamesMin" );
		monthNames = this._get( inst, "monthNames" );
		monthNamesShort = this._get( inst, "monthNamesShort" );
		beforeShowDay = this._get( inst, "beforeShowDay" );
		showOtherMonths = this._get( inst, "showOtherMonths" );
		selectOtherMonths = this._get( inst, "selectOtherMonths" );
		defaultDate = this._getDefaultDate( inst );
		html = "";

		for ( row = 0; row < numMonths[ 0 ]; row++ ) {
			group = "";
			this.maxRows = 4;
			for ( col = 0; col < numMonths[ 1 ]; col++ ) {
				selectedDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, inst.selectedDay ) );
				cornerClass = " ui-corner-all";
				calender = "";
				if ( isMultiMonth ) {
					calender += "<div class='ui-datepicker-group";
					if ( numMonths[ 1 ] > 1 ) {
						switch ( col ) {
							case 0: calender += " ui-datepicker-group-first";
								cornerClass = " ui-corner-" + ( isRTL ? "right" : "left" ); break;
							case numMonths[ 1 ] - 1: calender += " ui-datepicker-group-last";
								cornerClass = " ui-corner-" + ( isRTL ? "left" : "right" ); break;
							default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
						}
					}
					calender += "'>";
				}
				calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
					( /all|left/.test( cornerClass ) && row === 0 ? ( isRTL ? next : prev ) : "" ) +
					( /all|right/.test( cornerClass ) && row === 0 ? ( isRTL ? prev : next ) : "" ) +
					this._generateMonthYearHeader( inst, drawMonth, drawYear, minDate, maxDate,
					row > 0 || col > 0, monthNames, monthNamesShort ) + // draw month headers
					"</div><table class='ui-datepicker-calendar'><thead>" +
					"<tr>";
				thead = ( showWeek ? "<th class='ui-datepicker-week-col'>" + this._get( inst, "weekHeader" ) + "</th>" : "" );
				for ( dow = 0; dow < 7; dow++ ) { // days of the week
					day = ( dow + firstDay ) % 7;
					thead += "<th scope='col'" + ( ( dow + firstDay + 6 ) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "" ) + ">" +
						"<span title='" + dayNames[ day ] + "'>" + dayNamesMin[ day ] + "</span></th>";
				}
				calender += thead + "</tr></thead><tbody>";
				daysInMonth = this._getDaysInMonth( drawYear, drawMonth );
				if ( drawYear === inst.selectedYear && drawMonth === inst.selectedMonth ) {
					inst.selectedDay = Math.min( inst.selectedDay, daysInMonth );
				}
				leadDays = ( this._getFirstDayOfMonth( drawYear, drawMonth ) - firstDay + 7 ) % 7;
				curRows = Math.ceil( ( leadDays + daysInMonth ) / 7 ); // calculate the number of rows to generate
				numRows = ( isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows ); //If multiple months, use the higher number of rows (see #7043)
				this.maxRows = numRows;
				printDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 - leadDays ) );
				for ( dRow = 0; dRow < numRows; dRow++ ) { // create date picker rows
					calender += "<tr>";
					tbody = ( !showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
						this._get( inst, "calculateWeek" )( printDate ) + "</td>" );
					for ( dow = 0; dow < 7; dow++ ) { // create date picker days
						daySettings = ( beforeShowDay ?
							beforeShowDay.apply( ( inst.input ? inst.input[ 0 ] : null ), [ printDate ] ) : [ true, "" ] );
						otherMonth = ( printDate.getMonth() !== drawMonth );
						unselectable = ( otherMonth && !selectOtherMonths ) || !daySettings[ 0 ] ||
							( minDate && printDate < minDate ) || ( maxDate && printDate > maxDate );
						tbody += "<td class='" +
							( ( dow + firstDay + 6 ) % 7 >= 5 ? " ui-datepicker-week-end" : "" ) + // highlight weekends
							( otherMonth ? " ui-datepicker-other-month" : "" ) + // highlight days from other months
							( ( printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent ) || // user pressed key
							( defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime() ) ?

							// or defaultDate is current printedDate and defaultDate is selectedDate
							" " + this._dayOverClass : "" ) + // highlight selected day
							( unselectable ? " " + this._unselectableClass + " ui-state-disabled" : "" ) +  // highlight unselectable days
							( otherMonth && !showOtherMonths ? "" : " " + daySettings[ 1 ] + // highlight custom dates
							( printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "" ) + // highlight selected day
							( printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "" ) ) + "'" + // highlight today (if different)
							( ( !otherMonth || showOtherMonths ) && daySettings[ 2 ] ? " title='" + daySettings[ 2 ].replace( /'/g, "&#39;" ) + "'" : "" ) + // cell title
							( unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'" ) + ">" + // actions
							( otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
							( unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
							( printDate.getTime() === today.getTime() ? " ui-state-highlight" : "" ) +
							( printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "" ) + // highlight selected day
							( otherMonth ? " ui-priority-secondary" : "" ) + // distinguish dates from other months
							"' href='#' aria-current='" + ( printDate.getTime() === currentDate.getTime() ? "true" : "false" ) + // mark date as selected for screen reader
							"' data-date='" + printDate.getDate() + // store date as data
							"'>" + printDate.getDate() + "</a>" ) ) + "</td>"; // display selectable date
						printDate.setDate( printDate.getDate() + 1 );
						printDate = this._daylightSavingAdjust( printDate );
					}
					calender += tbody + "</tr>";
				}
				drawMonth++;
				if ( drawMonth > 11 ) {
					drawMonth = 0;
					drawYear++;
				}
				calender += "</tbody></table>" + ( isMultiMonth ? "</div>" +
							( ( numMonths[ 0 ] > 0 && col === numMonths[ 1 ] - 1 ) ? "<div class='ui-datepicker-row-break'></div>" : "" ) : "" );
				group += calender;
			}
			html += group;
		}
		html += buttonPanel;
		inst._keyEvent = false;
		return html;
	},

	/* Generate the month and year header. */
	_generateMonthYearHeader: function( inst, drawMonth, drawYear, minDate, maxDate,
			secondary, monthNames, monthNamesShort ) {

		var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
			changeMonth = this._get( inst, "changeMonth" ),
			changeYear = this._get( inst, "changeYear" ),
			showMonthAfterYear = this._get( inst, "showMonthAfterYear" ),
			selectMonthLabel = this._get( inst, "selectMonthLabel" ),
			selectYearLabel = this._get( inst, "selectYearLabel" ),
			html = "<div class='ui-datepicker-title'>",
			monthHtml = "";

		// Month selection
		if ( secondary || !changeMonth ) {
			monthHtml += "<span class='ui-datepicker-month'>" + monthNames[ drawMonth ] + "</span>";
		} else {
			inMinYear = ( minDate && minDate.getFullYear() === drawYear );
			inMaxYear = ( maxDate && maxDate.getFullYear() === drawYear );
			monthHtml += "<select class='ui-datepicker-month' aria-label='" + selectMonthLabel + "' data-handler='selectMonth' data-event='change'>";
			for ( month = 0; month < 12; month++ ) {
				if ( ( !inMinYear || month >= minDate.getMonth() ) && ( !inMaxYear || month <= maxDate.getMonth() ) ) {
					monthHtml += "<option value='" + month + "'" +
						( month === drawMonth ? " selected='selected'" : "" ) +
						">" + monthNamesShort[ month ] + "</option>";
				}
			}
			monthHtml += "</select>";
		}

		if ( !showMonthAfterYear ) {
			html += monthHtml + ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" );
		}

		// Year selection
		if ( !inst.yearshtml ) {
			inst.yearshtml = "";
			if ( secondary || !changeYear ) {
				html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
			} else {

				// determine range of years to display
				years = this._get( inst, "yearRange" ).split( ":" );
				thisYear = new Date().getFullYear();
				determineYear = function( value ) {
					var year = ( value.match( /c[+\-].*/ ) ? drawYear + parseInt( value.substring( 1 ), 10 ) :
						( value.match( /[+\-].*/ ) ? thisYear + parseInt( value, 10 ) :
						parseInt( value, 10 ) ) );
					return ( isNaN( year ) ? thisYear : year );
				};
				year = determineYear( years[ 0 ] );
				endYear = Math.max( year, determineYear( years[ 1 ] || "" ) );
				year = ( minDate ? Math.max( year, minDate.getFullYear() ) : year );
				endYear = ( maxDate ? Math.min( endYear, maxDate.getFullYear() ) : endYear );
				inst.yearshtml += "<select class='ui-datepicker-year' aria-label='" + selectYearLabel + "' data-handler='selectYear' data-event='change'>";
				for ( ; year <= endYear; year++ ) {
					inst.yearshtml += "<option value='" + year + "'" +
						( year === drawYear ? " selected='selected'" : "" ) +
						">" + year + "</option>";
				}
				inst.yearshtml += "</select>";

				html += inst.yearshtml;
				inst.yearshtml = null;
			}
		}

		html += this._get( inst, "yearSuffix" );
		if ( showMonthAfterYear ) {
			html += ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" ) + monthHtml;
		}
		html += "</div>"; // Close datepicker_header
		return html;
	},

	/* Adjust one of the date sub-fields. */
	_adjustInstDate: function( inst, offset, period ) {
		var year = inst.selectedYear + ( period === "Y" ? offset : 0 ),
			month = inst.selectedMonth + ( period === "M" ? offset : 0 ),
			day = Math.min( inst.selectedDay, this._getDaysInMonth( year, month ) ) + ( period === "D" ? offset : 0 ),
			date = this._restrictMinMax( inst, this._daylightSavingAdjust( new Date( year, month, day ) ) );

		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		if ( period === "M" || period === "Y" ) {
			this._notifyChange( inst );
		}
	},

	/* Ensure a date is within any min/max bounds. */
	_restrictMinMax: function( inst, date ) {
		var minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			newDate = ( minDate && date < minDate ? minDate : date );
		return ( maxDate && newDate > maxDate ? maxDate : newDate );
	},

	/* Notify change of month/year. */
	_notifyChange: function( inst ) {
		var onChange = this._get( inst, "onChangeMonthYear" );
		if ( onChange ) {
			onChange.apply( ( inst.input ? inst.input[ 0 ] : null ),
				[ inst.selectedYear, inst.selectedMonth + 1, inst ] );
		}
	},

	/* Determine the number of months to show. */
	_getNumberOfMonths: function( inst ) {
		var numMonths = this._get( inst, "numberOfMonths" );
		return ( numMonths == null ? [ 1, 1 ] : ( typeof numMonths === "number" ? [ 1, numMonths ] : numMonths ) );
	},

	/* Determine the current maximum date - ensure no time components are set. */
	_getMinMaxDate: function( inst, minMax ) {
		return this._determineDate( inst, this._get( inst, minMax + "Date" ), null );
	},

	/* Find the number of days in a given month. */
	_getDaysInMonth: function( year, month ) {
		return 32 - this._daylightSavingAdjust( new Date( year, month, 32 ) ).getDate();
	},

	/* Find the day of the week of the first of a month. */
	_getFirstDayOfMonth: function( year, month ) {
		return new Date( year, month, 1 ).getDay();
	},

	/* Determines if we should allow a "next/prev" month display change. */
	_canAdjustMonth: function( inst, offset, curYear, curMonth ) {
		var numMonths = this._getNumberOfMonths( inst ),
			date = this._daylightSavingAdjust( new Date( curYear,
			curMonth + ( offset < 0 ? offset : numMonths[ 0 ] * numMonths[ 1 ] ), 1 ) );

		if ( offset < 0 ) {
			date.setDate( this._getDaysInMonth( date.getFullYear(), date.getMonth() ) );
		}
		return this._isInRange( inst, date );
	},

	/* Is the given date in the accepted range? */
	_isInRange: function( inst, date ) {
		var yearSplit, currentYear,
			minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			minYear = null,
			maxYear = null,
			years = this._get( inst, "yearRange" );
			if ( years ) {
				yearSplit = years.split( ":" );
				currentYear = new Date().getFullYear();
				minYear = parseInt( yearSplit[ 0 ], 10 );
				maxYear = parseInt( yearSplit[ 1 ], 10 );
				if ( yearSplit[ 0 ].match( /[+\-].*/ ) ) {
					minYear += currentYear;
				}
				if ( yearSplit[ 1 ].match( /[+\-].*/ ) ) {
					maxYear += currentYear;
				}
			}

		return ( ( !minDate || date.getTime() >= minDate.getTime() ) &&
			( !maxDate || date.getTime() <= maxDate.getTime() ) &&
			( !minYear || date.getFullYear() >= minYear ) &&
			( !maxYear || date.getFullYear() <= maxYear ) );
	},

	/* Provide the configuration settings for formatting/parsing. */
	_getFormatConfig: function( inst ) {
		var shortYearCutoff = this._get( inst, "shortYearCutoff" );
		shortYearCutoff = ( typeof shortYearCutoff !== "string" ? shortYearCutoff :
			new Date().getFullYear() % 100 + parseInt( shortYearCutoff, 10 ) );
		return { shortYearCutoff: shortYearCutoff,
			dayNamesShort: this._get( inst, "dayNamesShort" ), dayNames: this._get( inst, "dayNames" ),
			monthNamesShort: this._get( inst, "monthNamesShort" ), monthNames: this._get( inst, "monthNames" ) };
	},

	/* Format the given date for display. */
	_formatDate: function( inst, day, month, year ) {
		if ( !day ) {
			inst.currentDay = inst.selectedDay;
			inst.currentMonth = inst.selectedMonth;
			inst.currentYear = inst.selectedYear;
		}
		var date = ( day ? ( typeof day === "object" ? day :
			this._daylightSavingAdjust( new Date( year, month, day ) ) ) :
			this._daylightSavingAdjust( new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
		return this.formatDate( this._get( inst, "dateFormat" ), date, this._getFormatConfig( inst ) );
	}
} );

/*
 * Bind hover events for datepicker elements.
 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
 */
function datepicker_bindHover( dpDiv ) {
	var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
	return dpDiv.on( "mouseout", selector, function() {
			$( this ).removeClass( "ui-state-hover" );
			if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
				$( this ).removeClass( "ui-datepicker-prev-hover" );
			}
			if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
				$( this ).removeClass( "ui-datepicker-next-hover" );
			}
		} )
		.on( "mouseover", selector, datepicker_handleMouseover );
}

function datepicker_handleMouseover() {
	if ( !$.datepicker._isDisabledDatepicker( datepicker_instActive.inline ? datepicker_instActive.dpDiv.parent()[ 0 ] : datepicker_instActive.input[ 0 ] ) ) {
		$( this ).parents( ".ui-datepicker-calendar" ).find( "a" ).removeClass( "ui-state-hover" );
		$( this ).addClass( "ui-state-hover" );
		if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
			$( this ).addClass( "ui-datepicker-prev-hover" );
		}
		if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
			$( this ).addClass( "ui-datepicker-next-hover" );
		}
	}
}

/* jQuery extend now ignores nulls! */
function datepicker_extendRemove( target, props ) {
	$.extend( target, props );
	for ( var name in props ) {
		if ( props[ name ] == null ) {
			target[ name ] = props[ name ];
		}
	}
	return target;
}

/* Invoke the datepicker functionality.
   @param  options  string - a command, optionally followed by additional parameters or
					Object - settings for attaching new datepicker functionality
   @return  jQuery object */
$.fn.datepicker = function( options ) {

	/* Verify an empty collection wasn't passed - Fixes #6976 */
	if ( !this.length ) {
		return this;
	}

	/* Initialise the date picker. */
	if ( !$.datepicker.initialized ) {
		$( document ).on( "mousedown", $.datepicker._checkExternalClick );
		$.datepicker.initialized = true;
	}

	/* Append datepicker main container to body if not exist. */
	if ( $( "#" + $.datepicker._mainDivId ).length === 0 ) {
		$( "body" ).append( $.datepicker.dpDiv );
	}

	var otherArgs = Array.prototype.slice.call( arguments, 1 );
	if ( typeof options === "string" && ( options === "isDisabled" || options === "getDate" || options === "widget" ) ) {
		return $.datepicker[ "_" + options + "Datepicker" ].
			apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
	}
	if ( options === "option" && arguments.length === 2 && typeof arguments[ 1 ] === "string" ) {
		return $.datepicker[ "_" + options + "Datepicker" ].
			apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
	}
	return this.each( function() {
		if ( typeof options === "string" ) {
			$.datepicker[ "_" + options + "Datepicker" ]
				.apply( $.datepicker, [ this ].concat( otherArgs ) );
		} else {
			$.datepicker._attachDatepicker( this, options );
		}
	} );
};

$.datepicker = new Datepicker(); // singleton instance
$.datepicker.initialized = false;
$.datepicker.uuid = new Date().getTime();
$.datepicker.version = "1.14.2";

var widgetsDatepicker = $.datepicker;


/*!
 * jQuery UI Mouse 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Mouse
//>>group: Widgets
//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
//>>docs: https://api.jqueryui.com/mouse/


var mouseHandled = false;
$( document ).on( "mouseup", function() {
	mouseHandled = false;
} );

var widgetsMouse = $.widget( "ui.mouse", {
	version: "1.14.2",
	options: {
		cancel: "input, textarea, button, select, option",
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var that = this;

		this.element
			.on( "mousedown." + this.widgetName, function( event ) {
				return that._mouseDown( event );
			} )
			.on( "click." + this.widgetName, function( event ) {
				if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
					$.removeData( event.target, that.widgetName + ".preventClickEvent" );
					event.stopImmediatePropagation();
					return false;
				}
			} );

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.off( "." + this.widgetName );
		if ( this._mouseMoveDelegate ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
		}
	},

	_mouseDown: function( event ) {

		// don't let more than one widget handle mouseStart
		if ( mouseHandled ) {
			return;
		}

		this._mouseMoved = false;

		// We may have missed mouseup (out of window)
		if ( this._mouseStarted ) {
			this._mouseUp( event );
		}

		this._mouseDownEvent = event;

		var that = this,
			btnIsLeft = event.which === 1,
			elIsCancel = typeof this.options.cancel === "string" ?
				$( event.target ).closest( this.options.cancel ).length :
				false;
		if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if ( !this.mouseDelayMet ) {
			this._mouseDelayTimer = setTimeout( function() {
				that.mouseDelayMet = true;
			}, this.options.delay );
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted = ( this._mouseStart( event ) !== false );
			if ( !this._mouseStarted ) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
			$.removeData( event.target, this.widgetName + ".preventClickEvent" );
		}

		// These delegates are required to keep context
		this._mouseMoveDelegate = function( event ) {
			return that._mouseMove( event );
		};
		this._mouseUpDelegate = function( event ) {
			return that._mouseUp( event );
		};

		this.document
			.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.on( "mouseup." + this.widgetName, this._mouseUpDelegate );

		event.preventDefault();

		mouseHandled = true;
		return true;
	},

	_mouseMove: function( event ) {

		// Only check for mouseups outside the document if you've moved inside the document
		// at least once.
		if ( this._mouseMoved && !event.which ) {

			// Support: Safari <=8 - 9
			// Safari sets which to 0 if you press any of the following keys
			// during a drag (#14461)
			if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
					event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
				this.ignoreMissingWhich = true;
			} else if ( !this.ignoreMissingWhich ) {
				return this._mouseUp( event );
			}
		}

		if ( event.which || event.button ) {
			this._mouseMoved = true;
		}

		if ( this._mouseStarted ) {
			this._mouseDrag( event );
			return event.preventDefault();
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted =
				( this._mouseStart( this._mouseDownEvent, event ) !== false );
			if ( this._mouseStarted ) {
				this._mouseDrag( event );
			} else {
				this._mouseUp( event );
			}
		}

		return !this._mouseStarted;
	},

	_mouseUp: function( event ) {
		this.document
			.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.off( "mouseup." + this.widgetName, this._mouseUpDelegate );

		if ( this._mouseStarted ) {
			this._mouseStarted = false;

			if ( event.target === this._mouseDownEvent.target ) {
				$.data( event.target, this.widgetName + ".preventClickEvent", true );
			}

			this._mouseStop( event );
		}

		if ( this._mouseDelayTimer ) {
			clearTimeout( this._mouseDelayTimer );
			delete this._mouseDelayTimer;
		}

		this.ignoreMissingWhich = false;
		mouseHandled = false;
		event.preventDefault();
	},

	_mouseDistanceMet: function( event ) {
		return ( Math.max(
				Math.abs( this._mouseDownEvent.pageX - event.pageX ),
				Math.abs( this._mouseDownEvent.pageY - event.pageY )
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function( /* event */ ) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function( /* event */ ) {},
	_mouseDrag: function( /* event */ ) {},
	_mouseStop: function( /* event */ ) {},
	_mouseCapture: function( /* event */ ) {
		return true;
	}
} );



// $.ui.plugin is deprecated. Use $.widget() extensions instead.
var plugin = $.ui.plugin = {
	add: function( module, option, set ) {
		var i,
			proto = $.ui[ module ].prototype;
		for ( i in set ) {
			proto.plugins[ i ] = proto.plugins[ i ] || [];
			proto.plugins[ i ].push( [ option, set[ i ] ] );
		}
	},
	call: function( instance, name, args, allowDisconnected ) {
		var i,
			set = instance.plugins[ name ];

		if ( !set ) {
			return;
		}

		if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode ||
				instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
			return;
		}

		for ( i = 0; i < set.length; i++ ) {
			if ( instance.options[ set[ i ][ 0 ] ] ) {
				set[ i ][ 1 ].apply( instance.element, args );
			}
		}
	}
};


/*!
 * jQuery UI Draggable 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Draggable
//>>group: Interactions
//>>description: Enables dragging functionality for any element.
//>>docs: https://api.jqueryui.com/draggable/
//>>demos: https://jqueryui.com/draggable/
//>>css.structure: ../../themes/base/draggable.css


$.widget( "ui.draggable", $.ui.mouse, {
	version: "1.14.2",
	widgetEventPrefix: "drag",
	options: {
		addClasses: true,
		appendTo: "parent",
		axis: false,
		connectToSortable: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		grid: false,
		handle: false,
		helper: "original",
		iframeFix: false,
		opacity: false,
		refreshPositions: false,
		revert: false,
		revertDuration: 500,
		scope: "default",
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		snap: false,
		snapMode: "both",
		snapTolerance: 20,
		stack: false,
		zIndex: false,

		// Callbacks
		drag: null,
		start: null,
		stop: null
	},
	_create: function() {

		if ( this.options.helper === "original" ) {
			this._setPositionRelative();
		}
		if ( this.options.addClasses ) {
			this._addClass( "ui-draggable" );
		}
		this._setHandleClassName();

		this._mouseInit();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "handle" ) {
			this._removeHandleClassName();
			this._setHandleClassName();
		}
	},

	_destroy: function() {
		if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
			this.destroyOnClear = true;
			return;
		}
		this._removeHandleClassName();
		this._mouseDestroy();
	},

	_mouseCapture: function( event ) {
		var o = this.options;

		// Among others, prevent a drag on a resizable-handle
		if ( this.helper || o.disabled ||
				$( event.target ).closest( ".ui-resizable-handle" ).length > 0 ) {
			return false;
		}

		//Quit if we're not on a valid handle
		this.handle = this._getHandle( event );
		if ( !this.handle ) {
			return false;
		}

		this._blurActiveElement( event );

		this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );

		return true;

	},

	_blockFrames: function( selector ) {
		this.iframeBlocks = this.document.find( selector ).map( function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( "position", "absolute" )
				.appendTo( iframe.parent() )
				.outerWidth( iframe.outerWidth() )
				.outerHeight( iframe.outerHeight() )
				.offset( iframe.offset() )[ 0 ];
		} );
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_blurActiveElement: function( event ) {
		var activeElement = this.document[ 0 ].activeElement,
			target = $( event.target );

		// Don't blur if the event occurred on an element that is within
		// the currently focused element
		// See #10527, #12472
		if ( target.closest( activeElement ).length ) {
			return;
		}

		// Blur any element that currently has focus, see #4261
		$( activeElement ).trigger( "blur" );
	},

	_mouseStart: function( event ) {

		var o = this.options;

		//Create and append the visible helper
		this.helper = this._createHelper( event );

		this._addClass( this.helper, "ui-draggable-dragging" );

		//Cache the helper size
		this._cacheHelperProportions();

		//If ddmanager is used for droppables, set the global draggable
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.current = this;
		}

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Store the helper's css position
		this.cssPosition = this.helper.css( "position" );
		this.scrollParent = this.helper.scrollParent( true );
		this.offsetParent = this.helper.offsetParent();
		this.hasFixedAncestor = this.helper.parents().filter( function() {
				return $( this ).css( "position" ) === "fixed";
			} ).length > 0;

		//The element's absolute position on the page minus margins
		this.positionAbs = this.element.offset();
		this._refreshOffsets( event );

		//Generate the original position
		this.originalPosition = this.position = this._generatePosition( event, false );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		if ( o.cursorAt ) {
			this._adjustOffsetFromHelper( o.cursorAt );
		}

		//Set a containment if given in the options
		this._setContainment();

		//Trigger event + callbacks
		if ( this._trigger( "start", event ) === false ) {
			this._clear();
			return false;
		}

		//Recache the helper size
		this._cacheHelperProportions();

		//Prepare the droppable offsets
		if ( $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( this, event );
		}

		// Execute the drag once - this causes the helper not to be visible before getting its
		// correct position
		this._mouseDrag( event, true );

		// If the ddmanager is used for droppables, inform the manager that dragging has started
		// (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStart( this, event );
		}

		return true;
	},

	_refreshOffsets: function( event ) {
		this.offset = {
			top: this.positionAbs.top - this.margins.top,
			left: this.positionAbs.left - this.margins.left,
			scroll: false,
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset()
		};

		this.offset.click = {
			left: event.pageX - this.offset.left,
			top: event.pageY - this.offset.top
		};
	},

	_mouseDrag: function( event, noPropagation ) {

		// reset any necessary cached properties (see #5009)
		if ( this.hasFixedAncestor ) {
			this.offset.parent = this._getParentOffset();
		}

		//Compute the helpers position
		this.position = this._generatePosition( event, true );
		this.positionAbs = this._convertPositionTo( "absolute" );

		//Call plugins and callbacks and use the resulting position if something is returned
		if ( !noPropagation ) {
			var ui = this._uiHash();
			if ( this._trigger( "drag", event, ui ) === false ) {
				this._mouseUp( new $.Event( "mouseup", event ) );
				return false;
			}
			this.position = ui.position;
		}

		this.helper[ 0 ].style.left = this.position.left + "px";
		this.helper[ 0 ].style.top = this.position.top + "px";

		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.drag( this, event );
		}

		return false;
	},

	_mouseStop: function( event ) {

		//If we are using droppables, inform the manager about the drop
		var that = this,
			dropped = false;
		if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
			dropped = $.ui.ddmanager.drop( this, event );
		}

		//if a drop comes from outside (a sortable)
		if ( this.dropped ) {
			dropped = this.dropped;
			this.dropped = false;
		}

		if ( ( this.options.revert === "invalid" && !dropped ) ||
				( this.options.revert === "valid" && dropped ) ||
				this.options.revert === true || ( typeof this.options.revert === "function" &&
				this.options.revert.call( this.element, dropped ) )
		) {
			$( this.helper ).animate(
				this.originalPosition,
				parseInt( this.options.revertDuration, 10 ),
				function() {
					if ( that._trigger( "stop", event ) !== false ) {
						that._clear();
					}
				}
			);
		} else {
			if ( this._trigger( "stop", event ) !== false ) {
				this._clear();
			}
		}

		return false;
	},

	_mouseUp: function( event ) {
		this._unblockFrames();

		// If the ddmanager is used for droppables, inform the manager that dragging has stopped
		// (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStop( this, event );
		}

		// Only need to focus if the event occurred on the draggable itself, see #10527
		if ( this.handleElement.is( event.target ) ) {

			// The interaction is over; whether or not the click resulted in a drag,
			// focus the element
			this.element.trigger( "focus" );
		}

		return $.ui.mouse.prototype._mouseUp.call( this, event );
	},

	cancel: function() {

		if ( this.helper.is( ".ui-draggable-dragging" ) ) {
			this._mouseUp( new $.Event( "mouseup", { target: this.element[ 0 ] } ) );
		} else {
			this._clear();
		}

		return this;

	},

	_getHandle: function( event ) {
		return this.options.handle ?
			!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
			true;
	},

	_setHandleClassName: function() {
		this.handleElement = this.options.handle ?
			this.element.find( this.options.handle ) : this.element;
		this._addClass( this.handleElement, "ui-draggable-handle" );
	},

	_removeHandleClassName: function() {
		this._removeClass( this.handleElement, "ui-draggable-handle" );
	},

	_createHelper: function( event ) {

		var o = this.options,
			helperIsFunction = typeof o.helper === "function",
			helper = helperIsFunction ?
				$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
				( o.helper === "clone" ?
					this.element.clone().removeAttr( "id" ) :
					this.element );

		if ( !helper.parents( "body" ).length ) {
			helper.appendTo( ( o.appendTo === "parent" ?
				this.element[ 0 ].parentNode :
				o.appendTo ) );
		}

		// https://bugs.jqueryui.com/ticket/9446
		// a helper function can return the original element
		// which wouldn't have been set to relative in _create
		if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
			this._setPositionRelative();
		}

		if ( helper[ 0 ] !== this.element[ 0 ] &&
				!( /(fixed|absolute)/ ).test( helper.css( "position" ) ) ) {
			helper.css( "position", "absolute" );
		}

		return helper;

	},

	_setPositionRelative: function() {
		if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
			this.element[ 0 ].style.position = "relative";
		}
	},

	_adjustOffsetFromHelper: function( obj ) {
		if ( typeof obj === "string" ) {
			obj = obj.split( " " );
		}
		if ( Array.isArray( obj ) ) {
			obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
		}
		if ( "left" in obj ) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ( "right" in obj ) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ( "top" in obj ) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ( "bottom" in obj ) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_isRootNode: function( element ) {
		return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		var po = this.offsetParent.offset(),
			document = this.document[ 0 ];

		// This is a special case where we need to modify a offset calculated on start, since the
		// following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the
		// next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
		// the document, which means that the scroll is included in the initial calculation of the
		// offset of the parent, and never recalculated upon drag
		if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== document &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
			left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
		};

	},

	_getRelativeOffset: function() {
		if ( this.cssPosition !== "relative" ) {
			return { top: 0, left: 0 };
		}

		var p = this.element.position(),
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
				( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
			left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
				( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
		};

	},

	_cacheMargins: function() {
		this.margins = {
			left: ( parseInt( this.element.css( "marginLeft" ), 10 ) || 0 ),
			top: ( parseInt( this.element.css( "marginTop" ), 10 ) || 0 ),
			right: ( parseInt( this.element.css( "marginRight" ), 10 ) || 0 ),
			bottom: ( parseInt( this.element.css( "marginBottom" ), 10 ) || 0 )
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var isUserScrollable, c, ce,
			o = this.options,
			document = this.document[ 0 ];

		this.relativeContainer = null;

		if ( !o.containment ) {
			this.containment = null;
			return;
		}

		if ( o.containment === "window" ) {
			this.containment = [
				$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
				$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
				$( window ).scrollLeft() + $( window ).width() -
					this.helperProportions.width - this.margins.left,
				$( window ).scrollTop() +
					( $( window ).height() || document.body.parentNode.scrollHeight ) -
					this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment === "document" ) {
			this.containment = [
				0,
				0,
				$( document ).width() - this.helperProportions.width - this.margins.left,
				( $( document ).height() || document.body.parentNode.scrollHeight ) -
					this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment.constructor === Array ) {
			this.containment = o.containment;
			return;
		}

		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}

		c = $( o.containment );
		ce = c[ 0 ];

		if ( !ce ) {
			return;
		}

		isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );

		this.containment = [
			( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) +
				( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
			( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) +
				( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
			( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
				( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
				this.helperProportions.width -
				this.margins.left -
				this.margins.right,
			( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
				( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
				this.helperProportions.height -
				this.margins.top -
				this.margins.bottom
		];
		this.relativeContainer = c;
	},

	_convertPositionTo: function( d, pos ) {

		if ( !pos ) {
			pos = this.position;
		}

		var mod = d === "absolute" ? 1 : -1,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: (

				// The absolute mouse position
				pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
					-this.offset.scroll.top :
					( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod )
			),
			left: (

				// The absolute mouse position
				pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
					-this.offset.scroll.left :
					( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod )
			)
		};

	},

	_generatePosition: function( event, constrainPosition ) {

		var containment, co, top, left,
			o = this.options,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
			pageX = event.pageX,
			pageY = event.pageY;

		// Cache the scroll
		if ( !scrollIsRootNode || !this.offset.scroll ) {
			this.offset.scroll = {
				top: this.scrollParent.scrollTop(),
				left: this.scrollParent.scrollLeft()
			};
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		// If we are not dragging yet, we won't check for options
		if ( constrainPosition ) {
			if ( this.containment ) {
				if ( this.relativeContainer ) {
					co = this.relativeContainer.offset();
					containment = [
						this.containment[ 0 ] + co.left,
						this.containment[ 1 ] + co.top,
						this.containment[ 2 ] + co.left,
						this.containment[ 3 ] + co.top
					];
				} else {
					containment = this.containment;
				}

				if ( event.pageX - this.offset.click.left < containment[ 0 ] ) {
					pageX = containment[ 0 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top < containment[ 1 ] ) {
					pageY = containment[ 1 ] + this.offset.click.top;
				}
				if ( event.pageX - this.offset.click.left > containment[ 2 ] ) {
					pageX = containment[ 2 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top > containment[ 3 ] ) {
					pageY = containment[ 3 ] + this.offset.click.top;
				}
			}

			if ( o.grid ) {

				//Check for grid elements set to 0 to prevent divide by 0 error causing invalid
				// argument errors in IE (see ticket #6950)
				top = o.grid[ 1 ] ? this.originalPageY + Math.round( ( pageY -
					this.originalPageY ) / o.grid[ 1 ] ) * o.grid[ 1 ] : this.originalPageY;
				pageY = containment ? ( ( top - this.offset.click.top >= containment[ 1 ] ||
					top - this.offset.click.top > containment[ 3 ] ) ?
						top :
						( ( top - this.offset.click.top >= containment[ 1 ] ) ?
							top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) : top;

				left = o.grid[ 0 ] ? this.originalPageX +
					Math.round( ( pageX - this.originalPageX ) / o.grid[ 0 ] ) * o.grid[ 0 ] :
					this.originalPageX;
				pageX = containment ? ( ( left - this.offset.click.left >= containment[ 0 ] ||
					left - this.offset.click.left > containment[ 2 ] ) ?
						left :
						( ( left - this.offset.click.left >= containment[ 0 ] ) ?
							left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) : left;
			}

			if ( o.axis === "y" ) {
				pageX = this.originalPageX;
			}

			if ( o.axis === "x" ) {
				pageY = this.originalPageY;
			}
		}

		return {
			top: (

				// The absolute mouse position
				pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( this.cssPosition === "fixed" ?
					-this.offset.scroll.top :
					( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
			),
			left: (

				// The absolute mouse position
				pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( this.cssPosition === "fixed" ?
					-this.offset.scroll.left :
					( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
			)
		};

	},

	_clear: function() {
		this._removeClass( this.helper, "ui-draggable-dragging" );
		if ( this.helper[ 0 ] !== this.element[ 0 ] && !this.cancelHelperRemoval ) {
			this.helper.remove();
		}
		this.helper = null;
		this.cancelHelperRemoval = false;
		if ( this.destroyOnClear ) {
			this.destroy();
		}
	},

	// From now on bulk stuff - mainly helpers

	_trigger: function( type, event, ui ) {
		ui = ui || this._uiHash();
		$.ui.plugin.call( this, type, [ event, ui, this ], true );

		// Absolute position and offset (see #6884 ) have to be recalculated after plugins
		if ( /^(drag|start|stop)/.test( type ) ) {
			this.positionAbs = this._convertPositionTo( "absolute" );
			ui.offset = this.positionAbs;
		}
		return $.Widget.prototype._trigger.call( this, type, event, ui );
	},

	plugins: {},

	_uiHash: function() {
		return {
			helper: this.helper,
			position: this.position,
			originalPosition: this.originalPosition,
			offset: this.positionAbs
		};
	}

} );

$.ui.plugin.add( "draggable", "connectToSortable", {
	start: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		} );

		draggable.sortables = [];
		$( draggable.options.connectToSortable ).each( function() {
			var sortable = $( this ).sortable( "instance" );

			if ( sortable && !sortable.options.disabled ) {
				draggable.sortables.push( sortable );

				// RefreshPositions is called at drag start to refresh the containerCache
				// which is used in drag. This ensures it's initialized and synchronized
				// with any changes that might have happened on the page since initialization.
				sortable.refreshPositions();
				sortable._trigger( "activate", event, uiSortable );
			}
		} );
	},
	stop: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		} );

		draggable.cancelHelperRemoval = false;

		$.each( draggable.sortables, function() {
			var sortable = this;

			if ( sortable.isOver ) {
				sortable.isOver = 0;

				// Allow this sortable to handle removing the helper
				draggable.cancelHelperRemoval = true;
				sortable.cancelHelperRemoval = false;

				// Use _storedCSS To restore properties in the sortable,
				// as this also handles revert (#9675) since the draggable
				// may have modified them in unexpected ways (#8809)
				sortable._storedCSS = {
					position: sortable.placeholder.css( "position" ),
					top: sortable.placeholder.css( "top" ),
					left: sortable.placeholder.css( "left" )
				};

				sortable._mouseStop( event );

				// Once drag has ended, the sortable should return to using
				// its original helper, not the shared helper from draggable
				sortable.options.helper = sortable.options._helper;
			} else {

				// Prevent this Sortable from removing the helper.
				// However, don't set the draggable to remove the helper
				// either as another connected Sortable may yet handle the removal.
				sortable.cancelHelperRemoval = true;

				sortable._trigger( "deactivate", event, uiSortable );
			}
		} );
	},
	drag: function( event, ui, draggable ) {
		$.each( draggable.sortables, function() {
			var innermostIntersecting = false,
				sortable = this;

			// Copy over variables that sortable's _intersectsWith uses
			sortable.positionAbs = draggable.positionAbs;
			sortable.helperProportions = draggable.helperProportions;
			sortable.offset.click = draggable.offset.click;

			if ( sortable._intersectsWith( sortable.containerCache ) ) {
				innermostIntersecting = true;

				$.each( draggable.sortables, function() {

					// Copy over variables that sortable's _intersectsWith uses
					this.positionAbs = draggable.positionAbs;
					this.helperProportions = draggable.helperProportions;
					this.offset.click = draggable.offset.click;

					if ( this !== sortable &&
							this._intersectsWith( this.containerCache ) &&
							$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
						innermostIntersecting = false;
					}

					return innermostIntersecting;
				} );
			}

			if ( innermostIntersecting ) {

				// If it intersects, we use a little isOver variable and set it once,
				// so that the move-in stuff gets fired only once.
				if ( !sortable.isOver ) {
					sortable.isOver = 1;

					// Store draggable's parent in case we need to reappend to it later.
					draggable._parent = ui.helper.parent();

					sortable.currentItem = ui.helper
						.appendTo( sortable.element )
						.data( "ui-sortable-item", true );

					// Store helper option to later restore it
					sortable.options._helper = sortable.options.helper;

					sortable.options.helper = function() {
						return ui.helper[ 0 ];
					};

					// Fire the start events of the sortable with our passed browser event,
					// and our own helper (so it doesn't create a new one)
					event.target = sortable.currentItem[ 0 ];
					sortable._mouseCapture( event, true );
					sortable._mouseStart( event, true, true );

					// Because the browser event is way off the new appended portlet,
					// modify necessary variables to reflect the changes
					sortable.offset.click.top = draggable.offset.click.top;
					sortable.offset.click.left = draggable.offset.click.left;
					sortable.offset.parent.left -= draggable.offset.parent.left -
						sortable.offset.parent.left;
					sortable.offset.parent.top -= draggable.offset.parent.top -
						sortable.offset.parent.top;

					draggable._trigger( "toSortable", event );

					// Inform draggable that the helper is in a valid drop zone,
					// used solely in the revert option to handle "valid/invalid".
					draggable.dropped = sortable.element;

					// Need to refreshPositions of all sortables in the case that
					// adding to one sortable changes the location of the other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					} );

					// Hack so receive/update callbacks work (mostly)
					draggable.currentItem = draggable.element;
					sortable.fromOutside = draggable;
				}

				if ( sortable.currentItem ) {
					sortable._mouseDrag( event );

					// Copy the sortable's position because the draggable's can potentially reflect
					// a relative position, while sortable is always absolute, which the dragged
					// element has now become. (#8809)
					ui.position = sortable.position;
				}
			} else {

				// If it doesn't intersect with the sortable, and it intersected before,
				// we fake the drag stop of the sortable, but make sure it doesn't remove
				// the helper by using cancelHelperRemoval.
				if ( sortable.isOver ) {

					sortable.isOver = 0;
					sortable.cancelHelperRemoval = true;

					// Calling sortable's mouseStop would trigger a revert,
					// so revert must be temporarily false until after mouseStop is called.
					sortable.options._revert = sortable.options.revert;
					sortable.options.revert = false;

					sortable._trigger( "out", event, sortable._uiHash( sortable ) );
					sortable._mouseStop( event, true );

					// Restore sortable behaviors that were modfied
					// when the draggable entered the sortable area (#9481)
					sortable.options.revert = sortable.options._revert;
					sortable.options.helper = sortable.options._helper;

					if ( sortable.placeholder ) {
						sortable.placeholder.remove();
					}

					// Restore and recalculate the draggable's offset considering the sortable
					// may have modified them in unexpected ways. (#8809, #10669)
					ui.helper.appendTo( draggable._parent );
					draggable._refreshOffsets( event );
					ui.position = draggable._generatePosition( event, true );

					draggable._trigger( "fromSortable", event );

					// Inform draggable that the helper is no longer in a valid drop zone
					draggable.dropped = false;

					// Need to refreshPositions of all sortables just in case removing
					// from one sortable changes the location of other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					} );
				}
			}
		} );
	}
} );

$.ui.plugin.add( "draggable", "cursor", {
	start: function( event, ui, instance ) {
		var t = $( "body" ),
			o = instance.options;

		if ( t.css( "cursor" ) ) {
			o._cursor = t.css( "cursor" );
		}
		t.css( "cursor", o.cursor );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if ( o._cursor ) {
			$( "body" ).css( "cursor", o._cursor );
		}
	}
} );

$.ui.plugin.add( "draggable", "opacity", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;
		if ( t.css( "opacity" ) ) {
			o._opacity = t.css( "opacity" );
		}
		t.css( "opacity", o.opacity );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if ( o._opacity ) {
			$( ui.helper ).css( "opacity", o._opacity );
		}
	}
} );

$.ui.plugin.add( "draggable", "scroll", {
	start: function( event, ui, i ) {
		if ( !i.scrollParentNotHidden ) {
			i.scrollParentNotHidden = i.helper.scrollParent( false );
		}

		if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] &&
				i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
			i.overflowOffset = i.scrollParentNotHidden.offset();
		}
	},
	drag: function( event, ui, i  ) {

		var o = i.options,
			scrolled = false,
			scrollParent = i.scrollParentNotHidden[ 0 ],
			document = i.document[ 0 ];

		if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
			if ( !o.axis || o.axis !== "x" ) {
				if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY <
						o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
				} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX <
						o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
				}
			}

		} else {

			if ( !o.axis || o.axis !== "x" ) {
				if ( event.pageY - $( document ).scrollTop() < o.scrollSensitivity ) {
					scrolled = $( document ).scrollTop( $( document ).scrollTop() - o.scrollSpeed );
				} else if ( $( window ).height() - ( event.pageY - $( document ).scrollTop() ) <
						o.scrollSensitivity ) {
					scrolled = $( document ).scrollTop( $( document ).scrollTop() + o.scrollSpeed );
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( event.pageX - $( document ).scrollLeft() < o.scrollSensitivity ) {
					scrolled = $( document ).scrollLeft(
						$( document ).scrollLeft() - o.scrollSpeed
					);
				} else if ( $( window ).width() - ( event.pageX - $( document ).scrollLeft() ) <
						o.scrollSensitivity ) {
					scrolled = $( document ).scrollLeft(
						$( document ).scrollLeft() + o.scrollSpeed
					);
				}
			}

		}

		if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( i, event );
		}

	}
} );

$.ui.plugin.add( "draggable", "snap", {
	start: function( event, ui, i ) {

		var o = i.options;

		i.snapElements = [];

		$( o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap )
			.each( function() {
				var $t = $( this ),
					$o = $t.offset();
				if ( this !== i.element[ 0 ] ) {
					i.snapElements.push( {
						item: this,
						width: $t.outerWidth(), height: $t.outerHeight(),
						top: $o.top, left: $o.left
					} );
				}
			} );

	},
	drag: function( event, ui, inst ) {

		var ts, bs, ls, rs, l, r, t, b, i, first,
			o = inst.options,
			d = o.snapTolerance,
			x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
			y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

		for ( i = inst.snapElements.length - 1; i >= 0; i-- ) {

			l = inst.snapElements[ i ].left - inst.margins.left;
			r = l + inst.snapElements[ i ].width;
			t = inst.snapElements[ i ].top - inst.margins.top;
			b = t + inst.snapElements[ i ].height;

			if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d ||
					!$.contains( inst.snapElements[ i ].item.ownerDocument,
					inst.snapElements[ i ].item ) ) {
				if ( inst.snapElements[ i ].snapping ) {
					if ( inst.options.snap.release ) {
						inst.options.snap.release.call(
							inst.element,
							event,
							$.extend( inst._uiHash(), { snapItem: inst.snapElements[ i ].item } )
						);
					}
				}
				inst.snapElements[ i ].snapping = false;
				continue;
			}

			if ( o.snapMode !== "inner" ) {
				ts = Math.abs( t - y2 ) <= d;
				bs = Math.abs( b - y1 ) <= d;
				ls = Math.abs( l - x2 ) <= d;
				rs = Math.abs( r - x1 ) <= d;
				if ( ts ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: t - inst.helperProportions.height,
						left: 0
					} ).top;
				}
				if ( bs ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: b,
						left: 0
					} ).top;
				}
				if ( ls ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: l - inst.helperProportions.width
					} ).left;
				}
				if ( rs ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: r
					} ).left;
				}
			}

			first = ( ts || bs || ls || rs );

			if ( o.snapMode !== "outer" ) {
				ts = Math.abs( t - y1 ) <= d;
				bs = Math.abs( b - y2 ) <= d;
				ls = Math.abs( l - x1 ) <= d;
				rs = Math.abs( r - x2 ) <= d;
				if ( ts ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: t,
						left: 0
					} ).top;
				}
				if ( bs ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: b - inst.helperProportions.height,
						left: 0
					} ).top;
				}
				if ( ls ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: l
					} ).left;
				}
				if ( rs ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: r - inst.helperProportions.width
					} ).left;
				}
			}

			if ( !inst.snapElements[ i ].snapping && ( ts || bs || ls || rs || first ) ) {
				if ( inst.options.snap.snap ) {
					inst.options.snap.snap.call(
						inst.element,
						event,
						$.extend( inst._uiHash(), {
							snapItem: inst.snapElements[ i ].item
						} ) );
				}
			}
			inst.snapElements[ i ].snapping = ( ts || bs || ls || rs || first );

		}

	}
} );

$.ui.plugin.add( "draggable", "stack", {
	start: function( event, ui, instance ) {
		var min,
			o = instance.options,
			group = $.makeArray( $( o.stack ) ).sort( function( a, b ) {
				return ( parseInt( $( a ).css( "zIndex" ), 10 ) || 0 ) -
					( parseInt( $( b ).css( "zIndex" ), 10 ) || 0 );
			} );

		if ( !group.length ) {
			return;
		}

		min = parseInt( $( group[ 0 ] ).css( "zIndex" ), 10 ) || 0;
		$( group ).each( function( i ) {
			$( this ).css( "zIndex", min + i );
		} );
		this.css( "zIndex", ( min + group.length ) );
	}
} );

$.ui.plugin.add( "draggable", "zIndex", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;

		if ( t.css( "zIndex" ) ) {
			o._zIndex = t.css( "zIndex" );
		}
		t.css( "zIndex", o.zIndex );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;

		if ( o._zIndex ) {
			$( ui.helper ).css( "zIndex", o._zIndex );
		}
	}
} );

var widgetsDraggable = $.ui.draggable;


/*!
 * jQuery UI Resizable 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Resizable
//>>group: Interactions
//>>description: Enables resize functionality for any element.
//>>docs: https://api.jqueryui.com/resizable/
//>>demos: https://jqueryui.com/resizable/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/resizable.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.resizable", $.ui.mouse, {
	version: "1.14.2",
	widgetEventPrefix: "resize",
	options: {
		alsoResize: false,
		animate: false,
		animateDuration: "slow",
		animateEasing: "swing",
		aspectRatio: false,
		autoHide: false,
		classes: {
			"ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se"
		},
		containment: false,
		ghost: false,
		grid: false,
		handles: "e,s,se",
		helper: false,
		maxHeight: null,
		maxWidth: null,
		minHeight: 10,
		minWidth: 10,

		// See #7960
		zIndex: 90,

		// Callbacks
		resize: null,
		start: null,
		stop: null
	},

	_num: function( value ) {
		return parseFloat( value ) || 0;
	},

	_isNumber: function( value ) {
		return !isNaN( parseFloat( value ) );
	},

	_hasScroll: function( el, a ) {

		var scroll,
			has = false,
			overflow = $( el ).css( "overflow" );

		if ( overflow === "hidden" ) {
			return false;
		}
		if ( overflow === "scroll" ) {
			return true;
		}

		scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop";

		if ( el[ scroll ] > 0 ) {
			return true;
		}

		// TODO: determine which cases actually cause this to happen
		// if the element doesn't have the scroll set, see if it's possible to
		// set the scroll
		try {
			el[ scroll ] = 1;
			has = ( el[ scroll ] > 0 );
			el[ scroll ] = 0;
		} catch ( _e ) {

			// `el` might be a string, then setting `scroll` will throw
			// an error in strict mode; ignore it.
		}
		return has;
	},

	_create: function() {

		var margins,
			o = this.options,
			that = this;
		this._addClass( "ui-resizable" );

		$.extend( this, {
			_aspectRatio: !!( o.aspectRatio ),
			aspectRatio: o.aspectRatio,
			originalElement: this.element,
			_proportionallyResizeElements: [],
			_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
		} );

		// Wrap the element if it cannot hold child nodes
		if ( this.element[ 0 ].nodeName.match( /^(canvas|textarea|input|select|button|img)$/i ) ) {

			this.element.wrap(
				$( "<div class='ui-wrapper'></div>" ).css( {
					overflow: "hidden",
					position: this.element.css( "position" ),
					width: this.element.outerWidth(),
					height: this.element.outerHeight(),
					top: this.element.css( "top" ),
					left: this.element.css( "left" )
				} )
			);

			this.element = this.element.parent().data(
				"ui-resizable", this.element.resizable( "instance" )
			);

			this.elementIsWrapper = true;

			margins = {
				marginTop: this.originalElement.css( "marginTop" ),
				marginRight: this.originalElement.css( "marginRight" ),
				marginBottom: this.originalElement.css( "marginBottom" ),
				marginLeft: this.originalElement.css( "marginLeft" )
			};

			this.element.css( margins );

			// Support: Safari
			// Prevent Safari textarea resize
			this.originalResizeStyle = this.originalElement.css( "resize" );
			this.originalElement.css( "resize", "none" );

			this._proportionallyResizeElements.push( this.originalElement.css( {
				position: "static",
				zoom: 1,
				display: "block"
			} ) );

			this._proportionallyResize();
		}

		this._setupHandles();

		if ( o.autoHide ) {
			$( this.element )
				.on( "mouseenter", function() {
					if ( o.disabled ) {
						return;
					}
					that._removeClass( "ui-resizable-autohide" );
					that._handles.show();
				} )
				.on( "mouseleave", function() {
					if ( o.disabled ) {
						return;
					}
					if ( !that.resizing ) {
						that._addClass( "ui-resizable-autohide" );
						that._handles.hide();
					}
				} );
		}

		this._mouseInit();
	},

	_destroy: function() {

		this._mouseDestroy();
		this._addedHandles.remove();

		var wrapper,
			_destroy = function( exp ) {
				$( exp )
					.removeData( "resizable" )
					.removeData( "ui-resizable" )
					.off( ".resizable" );
			};

		// TODO: Unwrap at same DOM position
		if ( this.elementIsWrapper ) {
			_destroy( this.element );
			wrapper = this.element;
			this.originalElement.css( {
				position: wrapper.css( "position" ),
				width: wrapper.outerWidth(),
				height: wrapper.outerHeight(),
				top: wrapper.css( "top" ),
				left: wrapper.css( "left" )
			} ).insertAfter( wrapper );
			wrapper.remove();
		}

		this.originalElement.css( "resize", this.originalResizeStyle );
		_destroy( this.originalElement );

		return this;
	},

	_setOption: function( key, value ) {
		this._super( key, value );

		switch ( key ) {
		case "handles":
			this._removeHandles();
			this._setupHandles();
			break;
		case "aspectRatio":
			this._aspectRatio = !!value;
			break;
		default:
			break;
		}
	},

	_setupHandles: function() {
		var o = this.options, handle, i, n, hname, axis, that = this;
		this.handles = o.handles ||
			( !$( ".ui-resizable-handle", this.element ).length ?
				"e,s,se" : {
					n: ".ui-resizable-n",
					e: ".ui-resizable-e",
					s: ".ui-resizable-s",
					w: ".ui-resizable-w",
					se: ".ui-resizable-se",
					sw: ".ui-resizable-sw",
					ne: ".ui-resizable-ne",
					nw: ".ui-resizable-nw"
				} );

		this._handles = $();
		this._addedHandles = $();
		if ( this.handles.constructor === String ) {

			if ( this.handles === "all" ) {
				this.handles = "n,e,s,w,se,sw,ne,nw";
			}

			n = this.handles.split( "," );
			this.handles = {};

			for ( i = 0; i < n.length; i++ ) {

				handle = String.prototype.trim.call( n[ i ] );
				hname = "ui-resizable-" + handle;
				axis = $( "<div>" );
				this._addClass( axis, "ui-resizable-handle " + hname );

				axis.css( { zIndex: o.zIndex } );

				this.handles[ handle ] = ".ui-resizable-" + handle;
				if ( !this.element.children( this.handles[ handle ] ).length ) {
					this.element.append( axis );
					this._addedHandles = this._addedHandles.add( axis );
				}
			}

		}

		this._renderAxis = function( target ) {

			var i, axis, padPos, padWrapper;

			target = target || this.element;

			for ( i in this.handles ) {

				if ( this.handles[ i ].constructor === String ) {
					this.handles[ i ] = this.element.children( this.handles[ i ] ).first().show();
				} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
					this.handles[ i ] = $( this.handles[ i ] );
					this._on( this.handles[ i ], { "mousedown": that._mouseDown } );
				}

				if ( this.elementIsWrapper &&
						this.originalElement[ 0 ]
							.nodeName
							.match( /^(textarea|input|select|button)$/i ) ) {
					axis = $( this.handles[ i ], this.element );

					padWrapper = /sw|ne|nw|se|n|s/.test( i ) ?
						axis.outerHeight() :
						axis.outerWidth();

					padPos = [ "padding",
						/ne|nw|n/.test( i ) ? "Top" :
						/se|sw|s/.test( i ) ? "Bottom" :
						/^e$/.test( i ) ? "Right" : "Left" ].join( "" );

					target.css( padPos, padWrapper );

					this._proportionallyResize();
				}

				this._handles = this._handles.add( this.handles[ i ] );
			}
		};

		// TODO: make renderAxis a prototype function
		this._renderAxis( this.element );

		this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
		this._handles.disableSelection();

		this._handles.on( "mouseover", function() {
			if ( !that.resizing ) {
				if ( this.className ) {
					axis = this.className.match( /ui-resizable-(se|sw|ne|nw|n|e|s|w)/i );
				}
				that.axis = axis && axis[ 1 ] ? axis[ 1 ] : "se";
			}
		} );

		if ( o.autoHide ) {
			this._handles.hide();
			this._addClass( "ui-resizable-autohide" );
		}
	},

	_removeHandles: function() {
		this._addedHandles.remove();
	},

	_mouseCapture: function( event ) {
		var i, handle,
			capture = false;

		for ( i in this.handles ) {
			handle = $( this.handles[ i ] )[ 0 ];
			if ( handle === event.target || $.contains( handle, event.target ) ) {
				capture = true;
			}
		}

		return !this.options.disabled && capture;
	},

	_mouseStart: function( event ) {

		var curleft, curtop, cursor, calculatedSize,
			o = this.options,
			el = this.element;

		this.resizing = true;

		this._renderProxy();

		curleft = this._num( this.helper.css( "left" ) );
		curtop = this._num( this.helper.css( "top" ) );

		if ( o.containment ) {
			curleft += $( o.containment ).scrollLeft() || 0;
			curtop += $( o.containment ).scrollTop() || 0;
		}

		this.offset = this.helper.offset();
		this.position = { left: curleft, top: curtop };

		if ( !this._helper ) {
			calculatedSize = this._calculateAdjustedElementDimensions( el );
		}

		this.size = this._helper ? {
				width: this.helper.width(),
				height: this.helper.height()
			} : {
				width: calculatedSize.width,
				height: calculatedSize.height
			};

		this.originalSize = this._helper ? {
				width: el.outerWidth(),
				height: el.outerHeight()
			} : {
				width: calculatedSize.width,
				height: calculatedSize.height
			};

		this.sizeDiff = {
			width: el.outerWidth() - el.width(),
			height: el.outerHeight() - el.height()
		};

		this.originalPosition = { left: curleft, top: curtop };
		this.originalMousePosition = { left: event.pageX, top: event.pageY };

		this.aspectRatio = ( typeof o.aspectRatio === "number" ) ?
			o.aspectRatio :
			( ( this.originalSize.width / this.originalSize.height ) || 1 );

		cursor = $( ".ui-resizable-" + this.axis ).css( "cursor" );
		$( "body" ).css( "cursor", cursor === "auto" ? this.axis + "-resize" : cursor );

		this._addClass( "ui-resizable-resizing" );
		this._propagate( "start", event );
		return true;
	},

	_mouseDrag: function( event ) {

		var data, props,
			smp = this.originalMousePosition,
			a = this.axis,
			dx = ( event.pageX - smp.left ) || 0,
			dy = ( event.pageY - smp.top ) || 0,
			trigger = this._change[ a ];

		this._updatePrevProperties();

		if ( !trigger ) {
			return false;
		}

		data = trigger.apply( this, [ event, dx, dy ] );

		this._updateVirtualBoundaries( event.shiftKey );
		if ( this._aspectRatio || event.shiftKey ) {
			data = this._updateRatio( data, event );
		}

		data = this._respectSize( data, event );

		this._updateCache( data );

		this._propagate( "resize", event );

		props = this._applyChanges();

		if ( !this._helper && this._proportionallyResizeElements.length ) {
			this._proportionallyResize();
		}

		if ( !$.isEmptyObject( props ) ) {
			this._updatePrevProperties();
			this._trigger( "resize", event, this.ui() );
			this._applyChanges();
		}

		return false;
	},

	_mouseStop: function( event ) {

		this.resizing = false;
		var pr, ista, soffseth, soffsetw, s, left, top,
			o = this.options, that = this;

		if ( this._helper ) {

			pr = this._proportionallyResizeElements;
			ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName );
			soffseth = ista && this._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height;
			soffsetw = ista ? 0 : that.sizeDiff.width;

			s = {
				width: ( that.helper.width()  - soffsetw ),
				height: ( that.helper.height() - soffseth )
			};
			left = ( parseFloat( that.element.css( "left" ) ) +
				( that.position.left - that.originalPosition.left ) ) || null;
			top = ( parseFloat( that.element.css( "top" ) ) +
				( that.position.top - that.originalPosition.top ) ) || null;

			if ( !o.animate ) {
				this.element.css( $.extend( s, { top: top, left: left } ) );
			}

			that.helper.height( that.size.height );
			that.helper.width( that.size.width );

			if ( this._helper && !o.animate ) {
				this._proportionallyResize();
			}
		}

		$( "body" ).css( "cursor", "auto" );

		this._removeClass( "ui-resizable-resizing" );

		this._propagate( "stop", event );

		if ( this._helper ) {
			this.helper.remove();
		}

		return false;

	},

	_updatePrevProperties: function() {
		this.prevPosition = {
			top: this.position.top,
			left: this.position.left
		};
		this.prevSize = {
			width: this.size.width,
			height: this.size.height
		};
	},

	_applyChanges: function() {
		var props = {};

		if ( this.position.top !== this.prevPosition.top ) {
			props.top = this.position.top + "px";
		}
		if ( this.position.left !== this.prevPosition.left ) {
			props.left = this.position.left + "px";
		}

		this.helper.css( props );

		if ( this.size.width !== this.prevSize.width ) {
			props.width = this.size.width + "px";
			this.helper.width( props.width );
		}
		if ( this.size.height !== this.prevSize.height ) {
			props.height = this.size.height + "px";
			this.helper.height( props.height );
		}

		return props;
	},

	_updateVirtualBoundaries: function( forceAspectRatio ) {
		var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
			o = this.options;

		b = {
			minWidth: this._isNumber( o.minWidth ) ? o.minWidth : 0,
			maxWidth: this._isNumber( o.maxWidth ) ? o.maxWidth : Infinity,
			minHeight: this._isNumber( o.minHeight ) ? o.minHeight : 0,
			maxHeight: this._isNumber( o.maxHeight ) ? o.maxHeight : Infinity
		};

		if ( this._aspectRatio || forceAspectRatio ) {
			pMinWidth = b.minHeight * this.aspectRatio;
			pMinHeight = b.minWidth / this.aspectRatio;
			pMaxWidth = b.maxHeight * this.aspectRatio;
			pMaxHeight = b.maxWidth / this.aspectRatio;

			if ( pMinWidth > b.minWidth ) {
				b.minWidth = pMinWidth;
			}
			if ( pMinHeight > b.minHeight ) {
				b.minHeight = pMinHeight;
			}
			if ( pMaxWidth < b.maxWidth ) {
				b.maxWidth = pMaxWidth;
			}
			if ( pMaxHeight < b.maxHeight ) {
				b.maxHeight = pMaxHeight;
			}
		}
		this._vBoundaries = b;
	},

	_updateCache: function( data ) {
		this.offset = this.helper.offset();
		if ( this._isNumber( data.left ) ) {
			this.position.left = data.left;
		}
		if ( this._isNumber( data.top ) ) {
			this.position.top = data.top;
		}
		if ( this._isNumber( data.height ) ) {
			this.size.height = data.height;
		}
		if ( this._isNumber( data.width ) ) {
			this.size.width = data.width;
		}
	},

	_updateRatio: function( data ) {

		var cpos = this.position,
			csize = this.size,
			a = this.axis;

		if ( this._isNumber( data.height ) ) {
			data.width = ( data.height * this.aspectRatio );
		} else if ( this._isNumber( data.width ) ) {
			data.height = ( data.width / this.aspectRatio );
		}

		if ( a === "sw" ) {
			data.left = cpos.left + ( csize.width - data.width );
			data.top = null;
		}
		if ( a === "nw" ) {
			data.top = cpos.top + ( csize.height - data.height );
			data.left = cpos.left + ( csize.width - data.width );
		}

		return data;
	},

	_respectSize: function( data ) {

		var o = this._vBoundaries,
			a = this.axis,
			ismaxw = this._isNumber( data.width ) && o.maxWidth && ( o.maxWidth < data.width ),
			ismaxh = this._isNumber( data.height ) && o.maxHeight && ( o.maxHeight < data.height ),
			isminw = this._isNumber( data.width ) && o.minWidth && ( o.minWidth > data.width ),
			isminh = this._isNumber( data.height ) && o.minHeight && ( o.minHeight > data.height ),
			dw = this.originalPosition.left + this.originalSize.width,
			dh = this.originalPosition.top + this.originalSize.height,
			cw = /sw|nw|w/.test( a ), ch = /nw|ne|n/.test( a );
		if ( isminw ) {
			data.width = o.minWidth;
		}
		if ( isminh ) {
			data.height = o.minHeight;
		}
		if ( ismaxw ) {
			data.width = o.maxWidth;
		}
		if ( ismaxh ) {
			data.height = o.maxHeight;
		}

		if ( isminw && cw ) {
			data.left = dw - o.minWidth;
		}
		if ( ismaxw && cw ) {
			data.left = dw - o.maxWidth;
		}
		if ( isminh && ch ) {
			data.top = dh - o.minHeight;
		}
		if ( ismaxh && ch ) {
			data.top = dh - o.maxHeight;
		}

		// Fixing jump error on top/left - bug #2330
		if ( !data.width && !data.height && !data.left && data.top ) {
			data.top = null;
		} else if ( !data.width && !data.height && !data.top && data.left ) {
			data.left = null;
		}

		return data;
	},

	_getPaddingPlusBorderDimensions: function( element ) {
		var i = 0,
			widths = [],
			borders = [
				element.css( "borderTopWidth" ),
				element.css( "borderRightWidth" ),
				element.css( "borderBottomWidth" ),
				element.css( "borderLeftWidth" )
			],
			paddings = [
				element.css( "paddingTop" ),
				element.css( "paddingRight" ),
				element.css( "paddingBottom" ),
				element.css( "paddingLeft" )
			];

		for ( ; i < 4; i++ ) {
			widths[ i ] = ( parseFloat( borders[ i ] ) || 0 );
			widths[ i ] += ( parseFloat( paddings[ i ] ) || 0 );
		}

		return {
			height: widths[ 0 ] + widths[ 2 ],
			width: widths[ 1 ] + widths[ 3 ]
		};
	},

	_calculateAdjustedElementDimensions: function( element ) {
		var elWidth, elHeight, paddingBorder,
			ce = element.get( 0 );

		if ( element.css( "box-sizing" ) !== "content-box" ||
			( !this._hasScroll( ce ) && !this._hasScroll( ce, "left" ) ) ) {
				return {
					height: parseFloat( element.css( "height" ) ),
					width: parseFloat( element.css( "width" ) )
				};
		}

		// Check if CSS inline styles are set and use those (usually from previous resizes)
		elWidth = parseFloat( ce.style.width );
		elHeight = parseFloat( ce.style.height );

		paddingBorder = this._getPaddingPlusBorderDimensions( element );
		elWidth = isNaN( elWidth ) ?
			this._getElementTheoreticalSize( element, paddingBorder, "width" ) :
			elWidth;
		elHeight = isNaN( elHeight ) ?
			this._getElementTheoreticalSize( element, paddingBorder, "height" ) :
			elHeight;

		return {
			height: elHeight,
			width: elWidth
		};
	},

	_getElementTheoreticalSize: function( element, extraSize, dimension ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		var size = Math.max( 0, Math.ceil(
			element.get( 0 )[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			extraSize[ dimension ] -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine theoretical size.
		// Use an explicit zero to avoid NaN.
		// See https://github.com/jquery/jquery/issues/3964
		) ) || 0;

		return size;
	},

	_proportionallyResize: function() {

		if ( !this._proportionallyResizeElements.length ) {
			return;
		}

		var prel,
			i = 0,
			element = this.helper || this.element;

		for ( ; i < this._proportionallyResizeElements.length; i++ ) {

			prel = this._proportionallyResizeElements[ i ];

			// TODO: Seems like a bug to cache this.outerDimensions
			// considering that we are in a loop.
			if ( !this.outerDimensions ) {
				this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
			}

			prel.css( {
				height: ( element.height() - this.outerDimensions.height ) || 0,
				width: ( element.width() - this.outerDimensions.width ) || 0
			} );

		}

	},

	_renderProxy: function() {

		var el = this.element, o = this.options;
		this.elementOffset = el.offset();

		if ( this._helper ) {

			this.helper = this.helper || $( "<div></div>" ).css( { overflow: "hidden" } );

			this._addClass( this.helper, this._helper );
			this.helper.css( {
				width: this.element.outerWidth(),
				height: this.element.outerHeight(),
				position: "absolute",
				left: this.elementOffset.left + "px",
				top: this.elementOffset.top + "px",
				zIndex: ++o.zIndex //TODO: Don't modify option
			} );

			this.helper
				.appendTo( "body" )
				.disableSelection();

		} else {
			this.helper = this.element;
		}

	},

	_change: {
		e: function( event, dx ) {
			return { width: this.originalSize.width + dx };
		},
		w: function( event, dx ) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { left: sp.left + dx, width: cs.width - dx };
		},
		n: function( event, dx, dy ) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { top: sp.top + dy, height: cs.height - dy };
		},
		s: function( event, dx, dy ) {
			return { height: this.originalSize.height + dy };
		},
		se: function( event, dx, dy ) {
			return $.extend( this._change.s.apply( this, arguments ),
				this._change.e.apply( this, [ event, dx, dy ] ) );
		},
		sw: function( event, dx, dy ) {
			return $.extend( this._change.s.apply( this, arguments ),
				this._change.w.apply( this, [ event, dx, dy ] ) );
		},
		ne: function( event, dx, dy ) {
			return $.extend( this._change.n.apply( this, arguments ),
				this._change.e.apply( this, [ event, dx, dy ] ) );
		},
		nw: function( event, dx, dy ) {
			return $.extend( this._change.n.apply( this, arguments ),
				this._change.w.apply( this, [ event, dx, dy ] ) );
		}
	},

	_propagate: function( n, event ) {
		$.ui.plugin.call( this, n, [ event, this.ui() ] );
		if ( n !== "resize" ) {
			this._trigger( n, event, this.ui() );
		}
	},

	plugins: {},

	ui: function() {
		return {
			originalElement: this.originalElement,
			element: this.element,
			helper: this.helper,
			position: this.position,
			size: this.size,
			originalSize: this.originalSize,
			originalPosition: this.originalPosition
		};
	}

} );

/*
 * Resizable Extensions
 */

$.ui.plugin.add( "resizable", "animate", {

	stop: function( event ) {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			pr = that._proportionallyResizeElements,
			ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName ),
			soffseth = ista && that._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height,
			soffsetw = ista ? 0 : that.sizeDiff.width,
			style = {
				width: ( that.size.width - soffsetw ),
				height: ( that.size.height - soffseth )
			},
			left = ( parseFloat( that.element.css( "left" ) ) +
				( that.position.left - that.originalPosition.left ) ) || null,
			top = ( parseFloat( that.element.css( "top" ) ) +
				( that.position.top - that.originalPosition.top ) ) || null;

		that.element.animate(
			$.extend( style, top && left ? { top: top, left: left } : {} ), {
				duration: o.animateDuration,
				easing: o.animateEasing,
				step: function() {

					var data = {
						width: parseFloat( that.element.css( "width" ) ),
						height: parseFloat( that.element.css( "height" ) ),
						top: parseFloat( that.element.css( "top" ) ),
						left: parseFloat( that.element.css( "left" ) )
					};

					if ( pr && pr.length ) {
						$( pr[ 0 ] ).css( { width: data.width, height: data.height } );
					}

					// Propagating resize, and updating values for each animation step
					that._updateCache( data );
					that._propagate( "resize", event );

				}
			}
		);
	}

} );

$.ui.plugin.add( "resizable", "containment", {

	start: function() {
		var element, p, co, ch, cw, width, height,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			el = that.element,
			oc = o.containment,
			ce = ( oc instanceof $ ) ?
				oc.get( 0 ) :
				( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;

		if ( !ce ) {
			return;
		}

		that.containerElement = $( ce );

		if ( /document/.test( oc ) || oc === document ) {
			that.containerOffset = {
				left: 0,
				top: 0
			};
			that.containerPosition = {
				left: 0,
				top: 0
			};

			that.parentData = {
				element: $( document ),
				left: 0,
				top: 0,
				width: $( document ).width(),
				height: $( document ).height() || document.body.parentNode.scrollHeight
			};
		} else {
			element = $( ce );
			p = [];
			$( [ "Top", "Right", "Left", "Bottom" ] ).each( function( i, name ) {
				p[ i ] = that._num( element.css( "padding" + name ) );
			} );

			that.containerOffset = element.offset();
			that.containerPosition = element.position();
			that.containerSize = {
				height: ( element.innerHeight() - p[ 3 ] ),
				width: ( element.innerWidth() - p[ 1 ] )
			};

			co = that.containerOffset;
			ch = that.containerSize.height;
			cw = that.containerSize.width;
			width = ( that._hasScroll( ce, "left" ) ? ce.scrollWidth : cw );
			height = ( that._hasScroll( ce ) ? ce.scrollHeight : ch );

			that.parentData = {
				element: ce,
				left: co.left,
				top: co.top,
				width: width,
				height: height
			};
		}
	},

	resize: function( event ) {
		var woset, hoset, isParent, isOffsetRelative,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cp = that.position,
			pRatio = that._aspectRatio || event.shiftKey,
			cop = {
				top: 0,
				left: 0
			},
			ce = that.containerElement,
			continueResize = true;

		if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
			cop = co;
		}

		if ( cp.left < ( that._helper ? co.left : 0 ) ) {
			that.size.width = that.size.width +
				( that._helper ?
					( that.position.left - co.left ) :
					( that.position.left - cop.left ) );

			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
			that.position.left = o.helper ? co.left : 0;
		}

		if ( cp.top < ( that._helper ? co.top : 0 ) ) {
			that.size.height = that.size.height +
				( that._helper ?
					( that.position.top - co.top ) :
					that.position.top );

			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
			that.position.top = that._helper ? co.top : 0;
		}

		isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
		isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );

		if ( isParent && isOffsetRelative ) {
			that.offset.left = that.parentData.left + that.position.left;
			that.offset.top = that.parentData.top + that.position.top;
		} else {
			that.offset.left = that.element.offset().left;
			that.offset.top = that.element.offset().top;
		}

		woset = Math.abs( that.sizeDiff.width +
			( that._helper ?
				that.offset.left - cop.left :
				( that.offset.left - co.left ) ) );

		hoset = Math.abs( that.sizeDiff.height +
			( that._helper ?
				that.offset.top - cop.top :
				( that.offset.top - co.top ) ) );

		if ( woset + that.size.width >= that.parentData.width ) {
			that.size.width = that.parentData.width - woset;
			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
		}

		if ( hoset + that.size.height >= that.parentData.height ) {
			that.size.height = that.parentData.height - hoset;
			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
		}

		if ( !continueResize ) {
			that.position.left = that.prevPosition.left;
			that.position.top = that.prevPosition.top;
			that.size.width = that.prevSize.width;
			that.size.height = that.prevSize.height;
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cop = that.containerPosition,
			ce = that.containerElement,
			helper = $( that.helper ),
			ho = helper.offset(),
			w = helper.outerWidth() - that.sizeDiff.width,
			h = helper.outerHeight() - that.sizeDiff.height;

		if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
			$( this ).css( {
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			} );
		}

		if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
			$( this ).css( {
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			} );
		}
	}
} );

$.ui.plugin.add( "resizable", "alsoResize", {

	start: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options;

		$( o.alsoResize ).each( function() {
			var el = $( this ),
				elSize = that._calculateAdjustedElementDimensions( el );

			el.data( "ui-resizable-alsoresize", {
				width: elSize.width, height: elSize.height,
				left: parseFloat( el.css( "left" ) ), top: parseFloat( el.css( "top" ) )
			} );
		} );
	},

	resize: function( event, ui ) {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			os = that.originalSize,
			op = that.originalPosition,
			delta = {
				height: ( that.size.height - os.height ) || 0,
				width: ( that.size.width - os.width ) || 0,
				top: ( that.position.top - op.top ) || 0,
				left: ( that.position.left - op.left ) || 0
			};

			$( o.alsoResize ).each( function() {
				var el = $( this ), start = $( this ).data( "ui-resizable-alsoresize" ), style = {},
					css = el.parents( ui.originalElement[ 0 ] ).length ?
							[ "width", "height" ] :
							[ "width", "height", "top", "left" ];

				$.each( css, function( i, prop ) {
					var sum = ( start[ prop ] || 0 ) + ( delta[ prop ] || 0 );
					if ( sum && sum >= 0 ) {
						style[ prop ] = sum || null;
					}
				} );

				el.css( style );
			} );
	},

	stop: function() {
		$( this ).removeData( "ui-resizable-alsoresize" );
	}
} );

$.ui.plugin.add( "resizable", "ghost", {

	start: function() {

		var that = $( this ).resizable( "instance" ), cs = that.size;

		that.ghost = that.originalElement.clone();
		that.ghost.css( {
			opacity: 0.25,
			display: "block",
			position: "relative",
			height: cs.height,
			width: cs.width,
			margin: 0,
			left: 0,
			top: 0
		} );

		that._addClass( that.ghost, "ui-resizable-ghost" );

		// DEPRECATED
		// TODO: remove after 1.12
		if ( $.uiBackCompat === true && typeof that.options.ghost === "string" ) {

			// Ghost option
			that.ghost.addClass( this.options.ghost );
		}

		that.ghost.appendTo( that.helper );

	},

	resize: function() {
		var that = $( this ).resizable( "instance" );
		if ( that.ghost ) {
			that.ghost.css( {
				position: "relative",
				height: that.size.height,
				width: that.size.width
			} );
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" );
		if ( that.ghost && that.helper ) {
			that.helper.get( 0 ).removeChild( that.ghost.get( 0 ) );
		}
	}

} );

$.ui.plugin.add( "resizable", "grid", {

	resize: function() {
		var outerDimensions,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			cs = that.size,
			os = that.originalSize,
			op = that.originalPosition,
			a = that.axis,
			grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
			gridX = ( grid[ 0 ] || 1 ),
			gridY = ( grid[ 1 ] || 1 ),
			ox = Math.round( ( cs.width - os.width ) / gridX ) * gridX,
			oy = Math.round( ( cs.height - os.height ) / gridY ) * gridY,
			newWidth = os.width + ox,
			newHeight = os.height + oy,
			isMaxWidth = o.maxWidth && ( o.maxWidth < newWidth ),
			isMaxHeight = o.maxHeight && ( o.maxHeight < newHeight ),
			isMinWidth = o.minWidth && ( o.minWidth > newWidth ),
			isMinHeight = o.minHeight && ( o.minHeight > newHeight );

		o.grid = grid;

		if ( isMinWidth ) {
			newWidth += gridX;
		}
		if ( isMinHeight ) {
			newHeight += gridY;
		}
		if ( isMaxWidth ) {
			newWidth -= gridX;
		}
		if ( isMaxHeight ) {
			newHeight -= gridY;
		}

		if ( /^(se|s|e)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
		} else if ( /^(ne)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.top = op.top - oy;
		} else if ( /^(sw)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.left = op.left - ox;
		} else {
			if ( newHeight - gridY <= 0 || newWidth - gridX <= 0 ) {
				outerDimensions = that._getPaddingPlusBorderDimensions( this );
			}

			if ( newHeight - gridY > 0 ) {
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else {
				newHeight = gridY - outerDimensions.height;
				that.size.height = newHeight;
				that.position.top = op.top + os.height - newHeight;
			}
			if ( newWidth - gridX > 0 ) {
				that.size.width = newWidth;
				that.position.left = op.left - ox;
			} else {
				newWidth = gridX - outerDimensions.width;
				that.size.width = newWidth;
				that.position.left = op.left + os.width - newWidth;
			}
		}
	}

} );

var widgetsResizable = $.ui.resizable;


/*!
 * jQuery UI Dialog 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Dialog
//>>group: Widgets
//>>description: Displays customizable dialog windows.
//>>docs: https://api.jqueryui.com/dialog/
//>>demos: https://jqueryui.com/dialog/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/dialog.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.dialog", {
	version: "1.14.2",
	options: {
		appendTo: "body",
		autoOpen: true,
		buttons: [],
		classes: {
			"ui-dialog": "ui-corner-all",
			"ui-dialog-titlebar": "ui-corner-all"
		},
		closeOnEscape: true,
		closeText: "Close",
		draggable: true,
		hide: null,
		height: "auto",
		maxHeight: null,
		maxWidth: null,
		minHeight: 150,
		minWidth: 150,
		modal: false,
		position: {
			my: "center",
			at: "center",
			of: window,
			collision: "fit",

			// Ensure the titlebar is always visible
			using: function( pos ) {
				var topOffset = $( this ).css( pos ).offset().top;
				if ( topOffset < 0 ) {
					$( this ).css( "top", pos.top - topOffset );
				}
			}
		},
		resizable: true,
		show: null,
		title: null,
		uiDialogTitleHeadingLevel: 0,
		width: 300,

		// Callbacks
		beforeClose: null,
		close: null,
		drag: null,
		dragStart: null,
		dragStop: null,
		focus: null,
		open: null,
		resize: null,
		resizeStart: null,
		resizeStop: null
	},

	sizeRelatedOptions: {
		buttons: true,
		height: true,
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true,
		width: true
	},

	resizableRelatedOptions: {
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true
	},

	_create: function() {
		this.originalCss = {
			display: this.element[ 0 ].style.display,
			width: this.element[ 0 ].style.width,
			minHeight: this.element[ 0 ].style.minHeight,
			maxHeight: this.element[ 0 ].style.maxHeight,
			height: this.element[ 0 ].style.height
		};
		this.originalPosition = {
			parent: this.element.parent(),
			index: this.element.parent().children().index( this.element )
		};
		this.originalTitle = this.element.attr( "title" );
		if ( this.options.title == null && this.originalTitle != null ) {
			this.options.title = this.originalTitle;
		}

		// Dialogs can't be disabled
		if ( this.options.disabled ) {
			this.options.disabled = false;
		}

		this._createWrapper();

		this.element
			.show()
			.removeAttr( "title" )
			.appendTo( this.uiDialog );

		this._addClass( "ui-dialog-content", "ui-widget-content" );

		this._createTitlebar();
		this._createButtonPane();

		if ( this.options.draggable && $.fn.draggable ) {
			this._makeDraggable();
		}
		if ( this.options.resizable && $.fn.resizable ) {
			this._makeResizable();
		}

		this._isOpen = false;

		this._trackFocus();
	},

	_init: function() {
		if ( this.options.autoOpen ) {
			this.open();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;
		if ( element && ( element.jquery || element.nodeType ) ) {
			return $( element );
		}
		return this.document.find( element || "body" ).eq( 0 );
	},

	_destroy: function() {
		var next,
			originalPosition = this.originalPosition;

		this._untrackInstance();
		this._destroyOverlay();

		this.element
			.removeUniqueId()
			.css( this.originalCss )

			// Without detaching first, the following becomes really slow
			.detach();

		this.uiDialog.remove();

		if ( this.originalTitle ) {
			this.element.attr( "title", this.originalTitle );
		}

		next = originalPosition.parent.children().eq( originalPosition.index );

		// Don't try to place the dialog next to itself (#8613)
		if ( next.length && next[ 0 ] !== this.element[ 0 ] ) {
			next.before( this.element );
		} else {
			originalPosition.parent.append( this.element );
		}
	},

	widget: function() {
		return this.uiDialog;
	},

	disable: $.noop,
	enable: $.noop,

	close: function( event ) {
		var that = this;

		if ( !this._isOpen || this._trigger( "beforeClose", event ) === false ) {
			return;
		}

		this._isOpen = false;
		this._focusedElement = null;
		this._destroyOverlay();
		this._untrackInstance();

		if ( !this.opener.filter( ":focusable" ).trigger( "focus" ).length ) {

			// Hiding a focused element doesn't trigger blur in WebKit
			// so in case we have nothing to focus on, explicitly blur the active element
			// https://bugs.webkit.org/show_bug.cgi?id=47182
			$( this.document[ 0 ].activeElement ).trigger( "blur" );
		}

		this._hide( this.uiDialog, this.options.hide, function() {
			that._trigger( "close", event );
		} );
	},

	isOpen: function() {
		return this._isOpen;
	},

	moveToTop: function() {
		this._moveToTop();
	},

	_moveToTop: function( event, silent ) {
		var moved = false,
			zIndices = this.uiDialog.siblings( ".ui-front:visible" ).map( function() {
				return +$( this ).css( "z-index" );
			} ).get(),
			zIndexMax = Math.max.apply( null, zIndices );

		if ( zIndexMax >= +this.uiDialog.css( "z-index" ) ) {
			this.uiDialog.css( "z-index", zIndexMax + 1 );
			moved = true;
		}

		if ( moved && !silent ) {
			this._trigger( "focus", event );
		}
		return moved;
	},

	open: function() {
		var that = this;
		if ( this._isOpen ) {
			if ( this._moveToTop() ) {
				this._focusTabbable();
			}
			return;
		}

		this._isOpen = true;
		this.opener = $( this.document[ 0 ].activeElement );

		this._size();
		this._position();
		this._createOverlay();
		this._moveToTop( null, true );

		// Ensure the overlay is moved to the top with the dialog, but only when
		// opening. The overlay shouldn't move after the dialog is open so that
		// modeless dialogs opened after the modal dialog stack properly.
		if ( this.overlay ) {
			this.overlay.css( "z-index", this.uiDialog.css( "z-index" ) - 1 );
		}

		this._show( this.uiDialog, this.options.show, function() {
			that._focusTabbable();
			that._trigger( "focus" );
		} );

		// Track the dialog immediately upon opening in case a focus event
		// somehow occurs outside of the dialog before an element inside the
		// dialog is focused (#10152)
		this._makeFocusTarget();

		this._trigger( "open" );
	},

	_focusTabbable: function() {

		// Set focus to the first match:
		// 1. An element that was focused previously
		// 2. First element inside the dialog matching [autofocus]
		// 3. Tabbable element inside the content element
		// 4. Tabbable element inside the buttonpane
		// 5. The close button
		// 6. The dialog itself
		var hasFocus = this._focusedElement;
		if ( !hasFocus ) {
			hasFocus = this.element.find( "[autofocus]" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.element.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogButtonPane.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogTitlebarClose.filter( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialog;
		}
		hasFocus.eq( 0 ).trigger( "focus" );
	},

	_restoreTabbableFocus: function() {
		var activeElement = this.document[ 0 ].activeElement,
			isActive = this.uiDialog[ 0 ] === activeElement ||
				$.contains( this.uiDialog[ 0 ], activeElement );
		if ( !isActive ) {
			this._focusTabbable();
		}
	},

	_keepFocus: function( event ) {
		event.preventDefault();
		this._restoreTabbableFocus();
	},

	_createWrapper: function() {
		this.uiDialog = $( "<div>" )
			.hide()
			.attr( {

				// Setting tabIndex makes the div focusable
				tabIndex: -1,
				role: "dialog",
				"aria-modal": this.options.modal ? "true" : null
			} )
			.appendTo( this._appendTo() );

		this._addClass( this.uiDialog, "ui-dialog", "ui-widget ui-widget-content ui-front" );
		this._on( this.uiDialog, {
			keydown: function( event ) {
				if ( this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
						event.keyCode === $.ui.keyCode.ESCAPE ) {
					event.preventDefault();
					this.close( event );
					return;
				}

				// Prevent tabbing out of dialogs
				if ( event.keyCode !== $.ui.keyCode.TAB || event.isDefaultPrevented() ) {
					return;
				}
				var tabbables = this.uiDialog.find( ":tabbable" ),
					first = tabbables.first(),
					last = tabbables.last();

				if ( ( event.target === last[ 0 ] || event.target === this.uiDialog[ 0 ] ) &&
						!event.shiftKey ) {
					this._delay( function() {
						first.trigger( "focus" );
					} );
					event.preventDefault();
				} else if ( ( event.target === first[ 0 ] ||
						event.target === this.uiDialog[ 0 ] ) && event.shiftKey ) {
					this._delay( function() {
						last.trigger( "focus" );
					} );
					event.preventDefault();
				}
			},
			mousedown: function( event ) {
				if ( this._moveToTop( event ) ) {
					this._focusTabbable();
				}
			}
		} );

		// We assume that any existing aria-describedby attribute means
		// that the dialog content is marked up properly
		// otherwise we brute force the content as the description
		if ( !this.element.find( "[aria-describedby]" ).length ) {
			this.uiDialog.attr( {
				"aria-describedby": this.element.uniqueId().attr( "id" )
			} );
		}
	},

	_createTitlebar: function() {
		var uiDialogTitle;

		this.uiDialogTitlebar = $( "<div>" );
		this._addClass( this.uiDialogTitlebar,
			"ui-dialog-titlebar", "ui-widget-header ui-helper-clearfix" );
		this._on( this.uiDialogTitlebar, {
			mousedown: function( event ) {

				// Don't prevent click on close button (#8838)
				// Focusing a dialog that is partially scrolled out of view
				// causes the browser to scroll it into view, preventing the click event
				if ( !$( event.target ).closest( ".ui-dialog-titlebar-close" ) ) {

					// Dialog isn't getting focus when dragging (#8063)
					this.uiDialog.trigger( "focus" );
				}
			}
		} );

		this.uiDialogTitlebarClose = $( "<button type='button'></button>" )
			.button( {
				label: $( "<a>" ).text( this.options.closeText ).html(),
				icon: "ui-icon-closethick",
				showLabel: false
			} )
			.appendTo( this.uiDialogTitlebar );

		this._addClass( this.uiDialogTitlebarClose, "ui-dialog-titlebar-close" );
		this._on( this.uiDialogTitlebarClose, {
			click: function( event ) {
				event.preventDefault();
				this.close( event );
			}
		} );

		var uiDialogHeadingLevel = Number.isInteger( this.options.uiDialogTitleHeadingLevel ) &&
			this.options.uiDialogTitleHeadingLevel > 0 &&
			this.options.uiDialogTitleHeadingLevel <= 6 ?
			"h" + this.options.uiDialogTitleHeadingLevel : "span";

		uiDialogTitle = $( "<" + uiDialogHeadingLevel + ">" )
			.uniqueId().prependTo( this.uiDialogTitlebar );
		this._addClass( uiDialogTitle, "ui-dialog-title" );
		this._title( uiDialogTitle );

		this.uiDialogTitlebar.prependTo( this.uiDialog );

		this.uiDialog.attr( {
			"aria-labelledby": uiDialogTitle.attr( "id" )
		} );
	},

	_title: function( title ) {
		if ( this.options.title ) {
			title.text( this.options.title );
		} else {
			title.html( "&#160;" );
		}
	},

	_createButtonPane: function() {
		this.uiDialogButtonPane = $( "<div>" );
		this._addClass( this.uiDialogButtonPane, "ui-dialog-buttonpane",
			"ui-widget-content ui-helper-clearfix" );

		this.uiButtonSet = $( "<div>" )
			.appendTo( this.uiDialogButtonPane );
		this._addClass( this.uiButtonSet, "ui-dialog-buttonset" );

		this._createButtons();
	},

	_createButtons: function() {
		var that = this,
			buttons = this.options.buttons;

		// If we already have a button pane, remove it
		this.uiDialogButtonPane.remove();
		this.uiButtonSet.empty();

		if ( $.isEmptyObject( buttons ) || ( Array.isArray( buttons ) && !buttons.length ) ) {
			this._removeClass( this.uiDialog, "ui-dialog-buttons" );
			return;
		}

		$.each( buttons, function( name, props ) {
			var click, buttonOptions;
			props = typeof props === "function" ?
				{ click: props, text: name } :
				props;

			// Default to a non-submitting button
			props = $.extend( { type: "button" }, props );

			// Change the context for the click callback to be the main element
			click = props.click;
			buttonOptions = {
				icon: props.icon,
				iconPosition: props.iconPosition,
				showLabel: props.showLabel,

				// Deprecated options
				icons: props.icons,
				text: props.text
			};

			delete props.click;
			delete props.icon;
			delete props.iconPosition;
			delete props.showLabel;

			// Deprecated options
			delete props.icons;
			if ( typeof props.text === "boolean" ) {
				delete props.text;
			}

			$( "<button></button>", props )
				.button( buttonOptions )
				.appendTo( that.uiButtonSet )
				.on( "click", function() {
					click.apply( that.element[ 0 ], arguments );
				} );
		} );
		this._addClass( this.uiDialog, "ui-dialog-buttons" );
		this.uiDialogButtonPane.appendTo( this.uiDialog );
	},

	_makeDraggable: function() {
		var that = this,
			options = this.options;

		function filteredUi( ui ) {
			return {
				position: ui.position,
				offset: ui.offset
			};
		}

		this.uiDialog.draggable( {
			cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
			handle: ".ui-dialog-titlebar",
			containment: "document",
			start: function( event, ui ) {
				that._addClass( $( this ), "ui-dialog-dragging" );
				that._blockFrames();
				that._trigger( "dragStart", event, filteredUi( ui ) );
			},
			drag: function( event, ui ) {
				that._trigger( "drag", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var left = ui.offset.left - that.document.scrollLeft(),
					top = ui.offset.top - that.document.scrollTop();

				options.position = {
					my: "left top",
					at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
						"top" + ( top >= 0 ? "+" : "" ) + top,
					of: that.window
				};
				that._removeClass( $( this ), "ui-dialog-dragging" );
				that._unblockFrames();
				that._trigger( "dragStop", event, filteredUi( ui ) );
			}
		} );
	},

	_makeResizable: function() {
		var that = this,
			options = this.options,
			handles = options.resizable,

			// .ui-resizable has position: relative defined in the stylesheet
			// but dialogs have to use absolute or fixed positioning
			position = this.uiDialog.css( "position" ),
			resizeHandles = typeof handles === "string" ?
				handles :
				"n,e,s,w,se,sw,ne,nw";

		function filteredUi( ui ) {
			return {
				originalPosition: ui.originalPosition,
				originalSize: ui.originalSize,
				position: ui.position,
				size: ui.size
			};
		}

		this.uiDialog.resizable( {
			cancel: ".ui-dialog-content",
			containment: "document",
			alsoResize: this.element,
			maxWidth: options.maxWidth,
			maxHeight: options.maxHeight,
			minWidth: options.minWidth,
			minHeight: this._minHeight(),
			handles: resizeHandles,
			start: function( event, ui ) {
				that._addClass( $( this ), "ui-dialog-resizing" );
				that._blockFrames();
				that._trigger( "resizeStart", event, filteredUi( ui ) );
			},
			resize: function( event, ui ) {
				that._trigger( "resize", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var offset = that.uiDialog.offset(),
					left = offset.left - that.document.scrollLeft(),
					top = offset.top - that.document.scrollTop();

				options.height = that.uiDialog.height();
				options.width = that.uiDialog.width();
				options.position = {
					my: "left top",
					at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
						"top" + ( top >= 0 ? "+" : "" ) + top,
					of: that.window
				};
				that._removeClass( $( this ), "ui-dialog-resizing" );
				that._unblockFrames();
				that._trigger( "resizeStop", event, filteredUi( ui ) );
			}
		} )
			.css( "position", position );
	},

	_trackFocus: function() {
		this._on( this.widget(), {
			focusin: function( event ) {
				this._makeFocusTarget();
				this._focusedElement = $( event.target );
			}
		} );
	},

	_makeFocusTarget: function() {
		this._untrackInstance();
		this._trackingInstances().unshift( this );
	},

	_untrackInstance: function() {
		var instances = this._trackingInstances(),
			exists = $.inArray( this, instances );
		if ( exists !== -1 ) {
			instances.splice( exists, 1 );
		}
	},

	_trackingInstances: function() {
		var instances = this.document.data( "ui-dialog-instances" );
		if ( !instances ) {
			instances = [];
			this.document.data( "ui-dialog-instances", instances );
		}
		return instances;
	},

	_minHeight: function() {
		var options = this.options;

		return options.height === "auto" ?
			options.minHeight :
			Math.min( options.minHeight, options.height );
	},

	_position: function() {

		// Need to show the dialog to get the actual offset in the position plugin
		var isVisible = this.uiDialog.is( ":visible" );
		if ( !isVisible ) {
			this.uiDialog.show();
		}
		this.uiDialog.position( this.options.position );
		if ( !isVisible ) {
			this.uiDialog.hide();
		}
	},

	_setOptions: function( options ) {
		var that = this,
			resize = false,
			resizableOptions = {};

		$.each( options, function( key, value ) {
			that._setOption( key, value );

			if ( key in that.sizeRelatedOptions ) {
				resize = true;
			}
			if ( key in that.resizableRelatedOptions ) {
				resizableOptions[ key ] = value;
			}
		} );

		if ( resize ) {
			this._size();
			this._position();
		}
		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", resizableOptions );
		}
	},

	_setOption: function( key, value ) {
		var isDraggable, isResizable,
			uiDialog = this.uiDialog;

		if ( key === "disabled" ) {
			return;
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.uiDialog.appendTo( this._appendTo() );
		}

		if ( key === "buttons" ) {
			this._createButtons();
		}

		if ( key === "closeText" ) {
			this.uiDialogTitlebarClose.button( {

				// Ensure that we always pass a string
				label: $( "<a>" ).text( "" + this.options.closeText ).html()
			} );
		}

		if ( key === "draggable" ) {
			isDraggable = uiDialog.is( ":data(ui-draggable)" );
			if ( isDraggable && !value ) {
				uiDialog.draggable( "destroy" );
			}

			if ( !isDraggable && value ) {
				this._makeDraggable();
			}
		}

		if ( key === "position" ) {
			this._position();
		}

		if ( key === "resizable" ) {

			// currently resizable, becoming non-resizable
			isResizable = uiDialog.is( ":data(ui-resizable)" );
			if ( isResizable && !value ) {
				uiDialog.resizable( "destroy" );
			}

			// Currently resizable, changing handles
			if ( isResizable && typeof value === "string" ) {
				uiDialog.resizable( "option", "handles", value );
			}

			// Currently non-resizable, becoming resizable
			if ( !isResizable && value !== false ) {
				this._makeResizable();
			}
		}

		if ( key === "title" ) {
			this._title( this.uiDialogTitlebar.find( ".ui-dialog-title" ) );
		}

		if ( key === "modal" ) {
			uiDialog.attr( "aria-modal", value ? "true" : null );
		}
	},

	_size: function() {

		// If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
		// divs will both have width and height set, so we need to reset them
		var nonContentHeight, minContentHeight, maxContentHeight,
			options = this.options;

		// Reset content sizing
		this.element.show().css( {
			width: "auto",
			minHeight: 0,
			maxHeight: "none",
			height: 0
		} );

		if ( options.minWidth > options.width ) {
			options.width = options.minWidth;
		}

		// Reset wrapper sizing
		// determine the height of all the non-content elements
		nonContentHeight = this.uiDialog.css( {
			height: "auto",
			width: options.width
		} )
			.outerHeight();
		minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
		maxContentHeight = typeof options.maxHeight === "number" ?
			Math.max( 0, options.maxHeight - nonContentHeight ) :
			"none";

		if ( options.height === "auto" ) {
			this.element.css( {
				minHeight: minContentHeight,
				maxHeight: maxContentHeight,
				height: "auto"
			} );
		} else {
			this.element.height( Math.max( 0, options.height - nonContentHeight ) );
		}

		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", "minHeight", this._minHeight() );
		}
	},

	_blockFrames: function() {
		this.iframeBlocks = this.document.find( "iframe" ).map( function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( {
					position: "absolute",
					width: iframe.outerWidth(),
					height: iframe.outerHeight()
				} )
				.appendTo( iframe.parent() )
				.offset( iframe.offset() )[ 0 ];
		} );
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_allowInteraction: function( event ) {
		if ( $( event.target ).closest( ".ui-dialog" ).length ) {
			return true;
		}

		// TODO: Remove hack when datepicker implements
		// the .ui-front logic (#8989)
		return !!$( event.target ).closest( ".ui-datepicker" ).length;
	},

	_createOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		// We use a delay in case the overlay is created from an
		// event that we're going to be cancelling (#2804)
		var isOpening = true;
		this._delay( function() {
			isOpening = false;
		} );

		if ( !this.document.data( "ui-dialog-overlays" ) ) {

			// Prevent use of anchors and inputs
			// This doesn't use `_on()` because it is a shared event handler
			// across all open modal dialogs.
			this.document.on( "focusin.ui-dialog", function( event ) {
				if ( isOpening ) {
					return;
				}

				var instance = this._trackingInstances()[ 0 ];
				if ( !instance._allowInteraction( event ) ) {
					event.preventDefault();
					instance._focusTabbable();
				}
			}.bind( this ) );
		}

		this.overlay = $( "<div>" )
			.appendTo( this._appendTo() );

		this._addClass( this.overlay, null, "ui-widget-overlay ui-front" );
		this._on( this.overlay, {
			mousedown: "_keepFocus"
		} );
		this.document.data( "ui-dialog-overlays",
			( this.document.data( "ui-dialog-overlays" ) || 0 ) + 1 );
	},

	_destroyOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		if ( this.overlay ) {
			var overlays = this.document.data( "ui-dialog-overlays" ) - 1;

			if ( !overlays ) {
				this.document.off( "focusin.ui-dialog" );
				this.document.removeData( "ui-dialog-overlays" );
			} else {
				this.document.data( "ui-dialog-overlays", overlays );
			}

			this.overlay.remove();
			this.overlay = null;
		}
	}
} );

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat === true ) {

	// Backcompat for dialogClass option
	$.widget( "ui.dialog", $.ui.dialog, {
		options: {
			dialogClass: ""
		},
		_createWrapper: function() {
			this._super();
			this.uiDialog.addClass( this.options.dialogClass );
		},
		_setOption: function( key, value ) {
			if ( key === "dialogClass" ) {
				this.uiDialog
					.removeClass( this.options.dialogClass )
					.addClass( value );
			}
			this._superApply( arguments );
		}
	} );
}

var widgetsDialog = $.ui.dialog;


/*!
 * jQuery UI Droppable 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Droppable
//>>group: Interactions
//>>description: Enables drop targets for draggable elements.
//>>docs: https://api.jqueryui.com/droppable/
//>>demos: https://jqueryui.com/droppable/


$.widget( "ui.droppable", {
	version: "1.14.2",
	widgetEventPrefix: "drop",
	options: {
		accept: "*",
		addClasses: true,
		greedy: false,
		scope: "default",
		tolerance: "intersect",

		// Callbacks
		activate: null,
		deactivate: null,
		drop: null,
		out: null,
		over: null
	},
	_create: function() {

		var proportions,
			o = this.options,
			accept = o.accept;

		this.isover = false;
		this.isout = true;

		this.accept = typeof accept === "function" ? accept : function( d ) {
			return d.is( accept );
		};

		this.proportions = function( /* valueToWrite */ ) {
			if ( arguments.length ) {

				// Store the droppable's proportions
				proportions = arguments[ 0 ];
			} else {

				// Retrieve or derive the droppable's proportions
				return proportions ?
					proportions :
					proportions = {
						width: this.element[ 0 ].offsetWidth,
						height: this.element[ 0 ].offsetHeight
					};
			}
		};

		this._addToManager( o.scope );

		if ( o.addClasses ) {
			this._addClass( "ui-droppable" );
		}

	},

	_addToManager: function( scope ) {

		// Add the reference and positions to the manager
		$.ui.ddmanager.droppables[ scope ] = $.ui.ddmanager.droppables[ scope ] || [];
		$.ui.ddmanager.droppables[ scope ].push( this );
	},

	_splice: function( drop ) {
		var i = 0;
		for ( ; i < drop.length; i++ ) {
			if ( drop[ i ] === this ) {
				drop.splice( i, 1 );
			}
		}
	},

	_destroy: function() {
		var drop = $.ui.ddmanager.droppables[ this.options.scope ];

		this._splice( drop );
	},

	_setOption: function( key, value ) {

		if ( key === "accept" ) {
			this.accept = typeof value === "function" ? value : function( d ) {
				return d.is( value );
			};
		} else if ( key === "scope" ) {
			var drop = $.ui.ddmanager.droppables[ this.options.scope ];

			this._splice( drop );
			this._addToManager( value );
		}

		this._super( key, value );
	},

	_activate: function( event ) {
		var draggable = $.ui.ddmanager.current;

		this._addActiveClass();
		if ( draggable ) {
			this._trigger( "activate", event, this.ui( draggable ) );
		}
	},

	_deactivate: function( event ) {
		var draggable = $.ui.ddmanager.current;

		this._removeActiveClass();
		if ( draggable ) {
			this._trigger( "deactivate", event, this.ui( draggable ) );
		}
	},

	_over: function( event ) {

		var draggable = $.ui.ddmanager.current;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return;
		}

		if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
				draggable.element ) ) ) {
			this._addHoverClass();
			this._trigger( "over", event, this.ui( draggable ) );
		}

	},

	_out: function( event ) {

		var draggable = $.ui.ddmanager.current;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return;
		}

		if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
				draggable.element ) ) ) {
			this._removeHoverClass();
			this._trigger( "out", event, this.ui( draggable ) );
		}

	},

	_drop: function( event, custom ) {

		var draggable = custom || $.ui.ddmanager.current,
			childrenIntersection = false;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return false;
		}

		this.element
			.find( ":data(ui-droppable)" )
			.not( ".ui-draggable-dragging" )
			.each( function() {
				var inst = $( this ).droppable( "instance" );
				if (
					inst.options.greedy &&
					!inst.options.disabled &&
					inst.options.scope === draggable.options.scope &&
					inst.accept.call(
						inst.element[ 0 ], ( draggable.currentItem || draggable.element )
					) &&
					$.ui.intersect(
						draggable,
						$.extend( inst, { offset: inst.element.offset() } ),
						inst.options.tolerance, event
					)
				) {
					childrenIntersection = true;
					return false;
				}
			} );
		if ( childrenIntersection ) {
			return false;
		}

		if ( this.accept.call( this.element[ 0 ],
				( draggable.currentItem || draggable.element ) ) ) {
			this._removeActiveClass();
			this._removeHoverClass();

			this._trigger( "drop", event, this.ui( draggable ) );
			return this.element;
		}

		return false;

	},

	ui: function( c ) {
		return {
			draggable: ( c.currentItem || c.element ),
			helper: c.helper,
			position: c.position,
			offset: c.positionAbs
		};
	},

	// Extension points just to make backcompat sane and avoid duplicating logic
	// TODO: Remove in 1.14 along with call to it below
	_addHoverClass: function() {
		this._addClass( "ui-droppable-hover" );
	},

	_removeHoverClass: function() {
		this._removeClass( "ui-droppable-hover" );
	},

	_addActiveClass: function() {
		this._addClass( "ui-droppable-active" );
	},

	_removeActiveClass: function() {
		this._removeClass( "ui-droppable-active" );
	}
} );

$.ui.intersect = ( function() {
	function isOverAxis( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	}

	return function( draggable, droppable, toleranceMode, event ) {

		if ( !droppable.offset ) {
			return false;
		}

		var x1 = ( draggable.positionAbs ||
				draggable.position.absolute ).left + draggable.margins.left,
			y1 = ( draggable.positionAbs ||
				draggable.position.absolute ).top + draggable.margins.top,
			x2 = x1 + draggable.helperProportions.width,
			y2 = y1 + draggable.helperProportions.height,
			l = droppable.offset.left,
			t = droppable.offset.top,
			r = l + droppable.proportions().width,
			b = t + droppable.proportions().height;

		switch ( toleranceMode ) {
		case "fit":
			return ( l <= x1 && x2 <= r && t <= y1 && y2 <= b );
		case "intersect":
			return ( l < x1 + ( draggable.helperProportions.width / 2 ) && // Right Half
				x2 - ( draggable.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( draggable.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( draggable.helperProportions.height / 2 ) < b ); // Top Half
		case "pointer":
			return isOverAxis( event.pageY, t, droppable.proportions().height ) &&
				isOverAxis( event.pageX, l, droppable.proportions().width );
		case "touch":
			return (
				( y1 >= t && y1 <= b ) || // Top edge touching
				( y2 >= t && y2 <= b ) || // Bottom edge touching
				( y1 < t && y2 > b ) // Surrounded vertically
			) && (
				( x1 >= l && x1 <= r ) || // Left edge touching
				( x2 >= l && x2 <= r ) || // Right edge touching
				( x1 < l && x2 > r ) // Surrounded horizontally
			);
		default:
			return false;
		}
	};
} )();

/*
	This manager tracks offsets of draggables and droppables
*/
$.ui.ddmanager = {
	current: null,
	droppables: { "default": [] },
	prepareOffsets: function( t, event ) {

		var i, j,
			m = $.ui.ddmanager.droppables[ t.options.scope ] || [],
			type = event ? event.type : null, // workaround for #2317
			list = ( t.currentItem || t.element ).find( ":data(ui-droppable)" ).addBack();

		droppablesLoop: for ( i = 0; i < m.length; i++ ) {

			// No disabled and non-accepted
			if ( m[ i ].options.disabled || ( t && !m[ i ].accept.call( m[ i ].element[ 0 ],
					( t.currentItem || t.element ) ) ) ) {
				continue;
			}

			// Filter out elements in the current dragged item
			for ( j = 0; j < list.length; j++ ) {
				if ( list[ j ] === m[ i ].element[ 0 ] ) {
					m[ i ].proportions().height = 0;
					continue droppablesLoop;
				}
			}

			m[ i ].visible = m[ i ].element.css( "display" ) !== "none";
			if ( !m[ i ].visible ) {
				continue;
			}

			// Activate the droppable if used directly from draggables
			if ( type === "mousedown" ) {
				m[ i ]._activate.call( m[ i ], event );
			}

			m[ i ].offset = m[ i ].element.offset();
			m[ i ].proportions( {
				width: m[ i ].element[ 0 ].offsetWidth,
				height: m[ i ].element[ 0 ].offsetHeight
			} );

		}

	},
	drop: function( draggable, event ) {

		var dropped = false;

		// Create a copy of the droppables in case the list changes during the drop (#9116)
		$.each( ( $.ui.ddmanager.droppables[ draggable.options.scope ] || [] ).slice(), function() {

			if ( !this.options ) {
				return;
			}
			if ( !this.options.disabled && this.visible &&
					$.ui.intersect( draggable, this, this.options.tolerance, event ) ) {
				dropped = this._drop.call( this, event ) || dropped;
			}

			if ( !this.options.disabled && this.visible && this.accept.call( this.element[ 0 ],
					( draggable.currentItem || draggable.element ) ) ) {
				this.isout = true;
				this.isover = false;
				this._deactivate.call( this, event );
			}

		} );
		return dropped;

	},
	dragStart: function( draggable, event ) {

		// Listen for scrolling so that if the dragging causes scrolling the position of the
		// droppables can be recalculated (see #5003)
		draggable.element.parentsUntil( "body" ).on( "scroll.droppable", function() {
			if ( !draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
		} );
	},
	drag: function( draggable, event ) {

		// If you have a highly dynamic page, you might try this option. It renders positions
		// every time you move the mouse.
		if ( draggable.options.refreshPositions ) {
			$.ui.ddmanager.prepareOffsets( draggable, event );
		}

		// Run through all droppables and check their positions based on specific tolerance options
		$.each( $.ui.ddmanager.droppables[ draggable.options.scope ] || [], function() {

			if ( this.options.disabled || this.greedyChild || !this.visible ) {
				return;
			}

			var parentInstance, scope, parent,
				intersects = $.ui.intersect( draggable, this, this.options.tolerance, event ),
				c = !intersects && this.isover ?
					"isout" :
					( intersects && !this.isover ? "isover" : null );
			if ( !c ) {
				return;
			}

			if ( this.options.greedy ) {

				// find droppable parents with same scope
				scope = this.options.scope;
				parent = this.element.parents( ":data(ui-droppable)" ).filter( function() {
					return $( this ).droppable( "instance" ).options.scope === scope;
				} );

				if ( parent.length ) {
					parentInstance = $( parent[ 0 ] ).droppable( "instance" );
					parentInstance.greedyChild = ( c === "isover" );
				}
			}

			// We just moved into a greedy child
			if ( parentInstance && c === "isover" ) {
				parentInstance.isover = false;
				parentInstance.isout = true;
				parentInstance._out.call( parentInstance, event );
			}

			this[ c ] = true;
			this[ c === "isout" ? "isover" : "isout" ] = false;
			this[ c === "isover" ? "_over" : "_out" ].call( this, event );

			// We just moved out of a greedy child
			if ( parentInstance && c === "isout" ) {
				parentInstance.isout = false;
				parentInstance.isover = true;
				parentInstance._over.call( parentInstance, event );
			}
		} );

	},
	dragStop: function( draggable, event ) {
		draggable.element.parentsUntil( "body" ).off( "scroll.droppable" );

		// Call prepareOffsets one final time since IE does not fire return scroll events when
		// overflow was caused by drag (see #5003)
		if ( !draggable.options.refreshPositions ) {
			$.ui.ddmanager.prepareOffsets( draggable, event );
		}
	}
};

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat === true ) {

	// Backcompat for activeClass and hoverClass options
	$.widget( "ui.droppable", $.ui.droppable, {
		options: {
			hoverClass: false,
			activeClass: false
		},
		_addActiveClass: function() {
			this._super();
			if ( this.options.activeClass ) {
				this.element.addClass( this.options.activeClass );
			}
		},
		_removeActiveClass: function() {
			this._super();
			if ( this.options.activeClass ) {
				this.element.removeClass( this.options.activeClass );
			}
		},
		_addHoverClass: function() {
			this._super();
			if ( this.options.hoverClass ) {
				this.element.addClass( this.options.hoverClass );
			}
		},
		_removeHoverClass: function() {
			this._super();
			if ( this.options.hoverClass ) {
				this.element.removeClass( this.options.hoverClass );
			}
		}
	} );
}

var widgetsDroppable = $.ui.droppable;


/*!
 * jQuery UI Progressbar 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Progressbar
//>>group: Widgets
//>>description: Displays a status indicator for loading state, standard percentage, and other progress indicators.
//>>docs: https://api.jqueryui.com/progressbar/
//>>demos: https://jqueryui.com/progressbar/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/progressbar.css
//>>css.theme: ../../themes/base/theme.css


var widgetsProgressbar = $.widget( "ui.progressbar", {
	version: "1.14.2",
	options: {
		classes: {
			"ui-progressbar": "ui-corner-all",
			"ui-progressbar-value": "ui-corner-left",
			"ui-progressbar-complete": "ui-corner-right"
		},
		max: 100,
		value: 0,

		change: null,
		complete: null
	},

	min: 0,

	_create: function() {

		// Constrain initial value
		this.oldValue = this.options.value = this._constrainedValue();

		this.element.attr( {

			// Only set static values; aria-valuenow and aria-valuemax are
			// set inside _refreshValue()
			role: "progressbar",
			"aria-valuemin": this.min
		} );
		this._addClass( "ui-progressbar", "ui-widget ui-widget-content" );

		this.valueDiv = $( "<div>" ).appendTo( this.element );
		this._addClass( this.valueDiv, "ui-progressbar-value", "ui-widget-header" );
		this._refreshValue();
	},

	_destroy: function() {
		this.element.removeAttr( "role aria-valuemin aria-valuemax aria-valuenow" );

		this.valueDiv.remove();
	},

	value: function( newValue ) {
		if ( newValue === undefined ) {
			return this.options.value;
		}

		this.options.value = this._constrainedValue( newValue );
		this._refreshValue();
	},

	_constrainedValue: function( newValue ) {
		if ( newValue === undefined ) {
			newValue = this.options.value;
		}

		this.indeterminate = newValue === false;

		// Sanitize value
		if ( typeof newValue !== "number" ) {
			newValue = 0;
		}

		return this.indeterminate ? false :
			Math.min( this.options.max, Math.max( this.min, newValue ) );
	},

	_setOptions: function( options ) {

		// Ensure "value" option is set after other values (like max)
		var value = options.value;
		delete options.value;

		this._super( options );

		this.options.value = this._constrainedValue( value );
		this._refreshValue();
	},

	_setOption: function( key, value ) {
		if ( key === "max" ) {

			// Don't allow a max less than min
			value = Math.max( this.min, value );
		}
		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", value );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	_percentage: function() {
		return this.indeterminate ?
			100 :
			100 * ( this.options.value - this.min ) / ( this.options.max - this.min );
	},

	_refreshValue: function() {
		var value = this.options.value,
			percentage = this._percentage();

		this.valueDiv
			.toggle( this.indeterminate || value > this.min )
			.width( percentage.toFixed( 0 ) + "%" );

		this
			._toggleClass( this.valueDiv, "ui-progressbar-complete", null,
				value === this.options.max )
			._toggleClass( "ui-progressbar-indeterminate", null, this.indeterminate );

		if ( this.indeterminate ) {
			this.element.removeAttr( "aria-valuenow" );
			if ( !this.overlayDiv ) {
				this.overlayDiv = $( "<div>" ).appendTo( this.valueDiv );
				this._addClass( this.overlayDiv, "ui-progressbar-overlay" );
			}
		} else {
			this.element.attr( {
				"aria-valuemax": this.options.max,
				"aria-valuenow": value
			} );
			if ( this.overlayDiv ) {
				this.overlayDiv.remove();
				this.overlayDiv = null;
			}
		}

		if ( this.oldValue !== value ) {
			this.oldValue = value;
			this._trigger( "change" );
		}
		if ( value === this.options.max ) {
			this._trigger( "complete" );
		}
	}
} );


/*!
 * jQuery UI Selectable 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Selectable
//>>group: Interactions
//>>description: Allows groups of elements to be selected with the mouse.
//>>docs: https://api.jqueryui.com/selectable/
//>>demos: https://jqueryui.com/selectable/
//>>css.structure: ../../themes/base/selectable.css


var widgetsSelectable = $.widget( "ui.selectable", $.ui.mouse, {
	version: "1.14.2",
	options: {
		appendTo: "body",
		autoRefresh: true,
		distance: 0,
		filter: "*",
		tolerance: "touch",

		// Callbacks
		selected: null,
		selecting: null,
		start: null,
		stop: null,
		unselected: null,
		unselecting: null
	},
	_create: function() {
		var that = this;

		this._addClass( "ui-selectable" );

		this.dragged = false;

		// Cache selectee children based on filter
		this.refresh = function() {
			that.elementPos = $( that.element[ 0 ] ).offset();
			that.selectees = $( that.options.filter, that.element[ 0 ] );
			that._addClass( that.selectees, "ui-selectee" );
			that.selectees.each( function() {
				var $this = $( this ),
					selecteeOffset = $this.offset(),
					pos = {
						left: selecteeOffset.left - that.elementPos.left,
						top: selecteeOffset.top - that.elementPos.top
					};
				$.data( this, "selectable-item", {
					element: this,
					$element: $this,
					left: pos.left,
					top: pos.top,
					right: pos.left + $this.outerWidth(),
					bottom: pos.top + $this.outerHeight(),
					startselected: false,
					selected: $this.hasClass( "ui-selected" ),
					selecting: $this.hasClass( "ui-selecting" ),
					unselecting: $this.hasClass( "ui-unselecting" )
				} );
			} );
		};
		this.refresh();

		this._mouseInit();

		this.helper = $( "<div>" );
		this._addClass( this.helper, "ui-selectable-helper" );
	},

	_destroy: function() {
		this.selectees.removeData( "selectable-item" );
		this._mouseDestroy();
	},

	_mouseStart: function( event ) {
		var that = this,
			options = this.options;

		this.opos = [ event.pageX, event.pageY ];
		this.elementPos = $( this.element[ 0 ] ).offset();

		if ( this.options.disabled ) {
			return;
		}

		this.selectees = $( options.filter, this.element[ 0 ] );

		this._trigger( "start", event );

		$( options.appendTo ).append( this.helper );

		// position helper (lasso)
		this.helper.css( {
			"left": event.pageX,
			"top": event.pageY,
			"width": 0,
			"height": 0
		} );

		if ( options.autoRefresh ) {
			this.refresh();
		}

		this.selectees.filter( ".ui-selected" ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			selectee.startselected = true;
			if ( !event.metaKey && !event.ctrlKey ) {
				that._removeClass( selectee.$element, "ui-selected" );
				selectee.selected = false;
				that._addClass( selectee.$element, "ui-unselecting" );
				selectee.unselecting = true;

				// selectable UNSELECTING callback
				that._trigger( "unselecting", event, {
					unselecting: selectee.element
				} );
			}
		} );

		$( event.target ).parents().addBack().each( function() {
			var doSelect,
				selectee = $.data( this, "selectable-item" );
			if ( selectee ) {
				doSelect = ( !event.metaKey && !event.ctrlKey ) ||
					!selectee.$element.hasClass( "ui-selected" );
				that._removeClass( selectee.$element, doSelect ? "ui-unselecting" : "ui-selected" )
					._addClass( selectee.$element, doSelect ? "ui-selecting" : "ui-unselecting" );
				selectee.unselecting = !doSelect;
				selectee.selecting = doSelect;
				selectee.selected = doSelect;

				// selectable (UN)SELECTING callback
				if ( doSelect ) {
					that._trigger( "selecting", event, {
						selecting: selectee.element
					} );
				} else {
					that._trigger( "unselecting", event, {
						unselecting: selectee.element
					} );
				}
				return false;
			}
		} );

	},

	_mouseDrag: function( event ) {

		this.dragged = true;

		if ( this.options.disabled ) {
			return;
		}

		var tmp,
			that = this,
			options = this.options,
			x1 = this.opos[ 0 ],
			y1 = this.opos[ 1 ],
			x2 = event.pageX,
			y2 = event.pageY;

		if ( x1 > x2 ) {
			tmp = x2; x2 = x1; x1 = tmp;
		}
		if ( y1 > y2 ) {
			tmp = y2; y2 = y1; y1 = tmp;
		}
		this.helper.css( { left: x1, top: y1, width: x2 - x1, height: y2 - y1 } );

		this.selectees.each( function() {
			var selectee = $.data( this, "selectable-item" ),
				hit = false,
				offset = {};

			//prevent helper from being selected if appendTo: selectable
			if ( !selectee || selectee.element === that.element[ 0 ] ) {
				return;
			}

			offset.left   = selectee.left   + that.elementPos.left;
			offset.right  = selectee.right  + that.elementPos.left;
			offset.top    = selectee.top    + that.elementPos.top;
			offset.bottom = selectee.bottom + that.elementPos.top;

			if ( options.tolerance === "touch" ) {
				hit = ( !( offset.left > x2 || offset.right < x1 || offset.top > y2 ||
                    offset.bottom < y1 ) );
			} else if ( options.tolerance === "fit" ) {
				hit = ( offset.left > x1 && offset.right < x2 && offset.top > y1 &&
                    offset.bottom < y2 );
			}

			if ( hit ) {

				// SELECT
				if ( selectee.selected ) {
					that._removeClass( selectee.$element, "ui-selected" );
					selectee.selected = false;
				}
				if ( selectee.unselecting ) {
					that._removeClass( selectee.$element, "ui-unselecting" );
					selectee.unselecting = false;
				}
				if ( !selectee.selecting ) {
					that._addClass( selectee.$element, "ui-selecting" );
					selectee.selecting = true;

					// selectable SELECTING callback
					that._trigger( "selecting", event, {
						selecting: selectee.element
					} );
				}
			} else {

				// UNSELECT
				if ( selectee.selecting ) {
					if ( ( event.metaKey || event.ctrlKey ) && selectee.startselected ) {
						that._removeClass( selectee.$element, "ui-selecting" );
						selectee.selecting = false;
						that._addClass( selectee.$element, "ui-selected" );
						selectee.selected = true;
					} else {
						that._removeClass( selectee.$element, "ui-selecting" );
						selectee.selecting = false;
						if ( selectee.startselected ) {
							that._addClass( selectee.$element, "ui-unselecting" );
							selectee.unselecting = true;
						}

						// selectable UNSELECTING callback
						that._trigger( "unselecting", event, {
							unselecting: selectee.element
						} );
					}
				}
				if ( selectee.selected ) {
					if ( !event.metaKey && !event.ctrlKey && !selectee.startselected ) {
						that._removeClass( selectee.$element, "ui-selected" );
						selectee.selected = false;

						that._addClass( selectee.$element, "ui-unselecting" );
						selectee.unselecting = true;

						// selectable UNSELECTING callback
						that._trigger( "unselecting", event, {
							unselecting: selectee.element
						} );
					}
				}
			}
		} );

		return false;
	},

	_mouseStop: function( event ) {
		var that = this;

		this.dragged = false;

		$( ".ui-unselecting", this.element[ 0 ] ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			that._removeClass( selectee.$element, "ui-unselecting" );
			selectee.unselecting = false;
			selectee.startselected = false;
			that._trigger( "unselected", event, {
				unselected: selectee.element
			} );
		} );
		$( ".ui-selecting", this.element[ 0 ] ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			that._removeClass( selectee.$element, "ui-selecting" )
				._addClass( selectee.$element, "ui-selected" );
			selectee.selecting = false;
			selectee.selected = true;
			selectee.startselected = true;
			that._trigger( "selected", event, {
				selected: selectee.element
			} );
		} );
		this._trigger( "stop", event );

		this.helper.remove();

		return false;
	}

} );


/*!
 * jQuery UI Selectmenu 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Selectmenu
//>>group: Widgets
//>>description: Duplicates and extends the functionality of a native HTML select element, allowing it to be customizable in behavior and appearance far beyond the limitations of a native select.
//>>docs: https://api.jqueryui.com/selectmenu/
//>>demos: https://jqueryui.com/selectmenu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/selectmenu.css, ../../themes/base/button.css
//>>css.theme: ../../themes/base/theme.css


var widgetsSelectmenu = $.widget( "ui.selectmenu", [ $.ui.formResetMixin, {
	version: "1.14.2",
	defaultElement: "<select>",
	options: {
		appendTo: null,
		classes: {
			"ui-selectmenu-button-open": "ui-corner-top",
			"ui-selectmenu-button-closed": "ui-corner-all"
		},
		disabled: null,
		icons: {
			button: "ui-icon-triangle-1-s"
		},
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		width: false,

		// Callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		select: null
	},

	_create: function() {
		var selectmenuId = this.element.uniqueId().attr( "id" );
		this.ids = {
			element: selectmenuId,
			button: selectmenuId + "-button",
			menu: selectmenuId + "-menu"
		};

		this._drawButton();
		this._drawMenu();
		this._bindFormResetHandler();

		this._rendered = false;
		this.menuItems = $();
	},

	_drawButton: function() {
		var icon,
			that = this,
			item = this._parseOption(
				this.element.find( "option:selected" ),
				this.element[ 0 ].selectedIndex
			);

		// Associate existing label with the new button
		this.labels = this.element.labels().attr( "for", this.ids.button );
		this._on( this.labels, {
			click: function( event ) {
				this.button.trigger( "focus" );
				event.preventDefault();
			}
		} );

		// Hide original select element
		this.element.hide();

		// Create button
		this.button = $( "<span>", {
			tabindex: this.options.disabled ? -1 : 0,
			id: this.ids.button,
			role: "combobox",
			"aria-expanded": "false",
			"aria-autocomplete": "list",
			"aria-owns": this.ids.menu,
			"aria-haspopup": "true",
			title: this.element.attr( "title" )
		} )
			.insertAfter( this.element );

		this._addClass( this.button, "ui-selectmenu-button ui-selectmenu-button-closed",
			"ui-button ui-widget" );

		icon = $( "<span>" ).appendTo( this.button );
		this._addClass( icon, "ui-selectmenu-icon", "ui-icon " + this.options.icons.button );
		this.buttonItem = this._renderButtonItem( item )
			.appendTo( this.button );

		if ( this.options.width !== false ) {
			this._resizeButton();
		}

		this._on( this.button, this._buttonEvents );
		this.button.one( "focusin", function() {

			// Delay rendering the menu items until the button receives focus.
			// The menu may have already been rendered via a programmatic open.
			if ( !that._rendered ) {
				that._refreshMenu();
			}
		} );
	},

	_drawMenu: function() {
		var that = this;

		// Create menu
		this.menu = $( "<ul>", {
			"aria-hidden": "true",
			"aria-labelledby": this.ids.button,
			id: this.ids.menu
		} );

		// Wrap menu
		this.menuWrap = $( "<div>" ).append( this.menu );
		this._addClass( this.menuWrap, "ui-selectmenu-menu", "ui-front" );
		this.menuWrap.appendTo( this._appendTo() );

		// Initialize menu widget
		this.menuInstance = this.menu
			.menu( {
				classes: {
					"ui-menu": "ui-corner-bottom"
				},
				role: "listbox",
				select: function( event, ui ) {
					event.preventDefault();
					that._select( ui.item.data( "ui-selectmenu-item" ), event );
				},
				focus: function( event, ui ) {
					var item = ui.item.data( "ui-selectmenu-item" );

					// Prevent inital focus from firing and check if its a newly focused item
					if ( that.focusIndex != null && item.index !== that.focusIndex ) {
						that._trigger( "focus", event, { item: item } );
						if ( !that.isOpen ) {
							that._select( item, event );
						}
					}
					that.focusIndex = item.index;

					that.button.attr( "aria-activedescendant",
						that.menuItems.eq( item.index ).attr( "id" ) );
				}
			} )
			.menu( "instance" );

		// Don't close the menu on mouseleave
		this.menuInstance._off( this.menu, "mouseleave" );

		// Cancel the menu's collapseAll on document click
		this.menuInstance._closeOnDocumentClick = function() {
			return false;
		};

		// Selects often contain empty items, but never contain dividers
		this.menuInstance._isDivider = function() {
			return false;
		};
	},

	refresh: function() {
		this._refreshMenu();
		this.buttonItem.replaceWith(
			this.buttonItem = this._renderButtonItem(

				// Fall back to an empty object in case there are no options
				this._getSelectedItem().data( "ui-selectmenu-item" ) || {}
			)
		);
		if ( this.options.width === null ) {
			this._resizeButton();
		}
	},

	_refreshMenu: function() {
		var item,
			options = this.element.find( "option" );

		this.menu.empty();

		this._parseOptions( options );
		this._renderMenu( this.menu, this.items );

		this.menuInstance.refresh();
		this.menuItems = this.menu.find( "li" )
			.not( ".ui-selectmenu-optgroup" )
				.find( ".ui-menu-item-wrapper" );

		this._rendered = true;

		if ( !options.length ) {
			return;
		}

		item = this._getSelectedItem();

		// Update the menu to have the correct item focused
		this.menuInstance.focus( null, item );
		this._setAria( item.data( "ui-selectmenu-item" ) );

		// Set disabled state
		this._setOption( "disabled", this.element.prop( "disabled" ) );
	},

	open: function( event ) {
		if ( this.options.disabled ) {
			return;
		}

		// If this is the first time the menu is being opened, render the items
		if ( !this._rendered ) {
			this._refreshMenu();
		} else {

			// Menu clears focus on close, reset focus to selected item
			this._removeClass( this.menu.find( ".ui-state-active" ), null, "ui-state-active" );
			this.menuInstance.focus( null, this._getSelectedItem() );
		}

		// If there are no options, don't open the menu
		if ( !this.menuItems.length ) {
			return;
		}

		this.isOpen = true;
		this._toggleAttr();
		this._resizeMenu();
		this._position();

		this._on( this.document, this._documentClick );

		this._trigger( "open", event );
	},

	_position: function() {
		this.menuWrap.position( $.extend( { of: this.button }, this.options.position ) );
	},

	close: function( event ) {
		if ( !this.isOpen ) {
			return;
		}

		this.isOpen = false;
		this._toggleAttr();

		this.range = null;
		this._off( this.document );

		this._trigger( "close", event );
	},

	widget: function() {
		return this.button;
	},

	menuWidget: function() {
		return this.menu;
	},

	_renderButtonItem: function( item ) {
		var buttonItem = $( "<span>" );

		this._setText( buttonItem, item.label );
		this._addClass( buttonItem, "ui-selectmenu-text" );

		return buttonItem;
	},

	_renderMenu: function( ul, items ) {
		var that = this,
			currentOptgroup = "";

		$.each( items, function( index, item ) {
			var li;

			if ( item.optgroup !== currentOptgroup ) {
				li = $( "<li>", {
					text: item.optgroup
				} );
				that._addClass( li, "ui-selectmenu-optgroup", "ui-menu-divider" +
					( item.element.parent( "optgroup" ).prop( "disabled" ) ?
						" ui-state-disabled" :
						"" ) );

				li.appendTo( ul );

				currentOptgroup = item.optgroup;
			}

			that._renderItemData( ul, item );
		} );
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-selectmenu-item", item );
	},

	_renderItem: function( ul, item ) {
		var li = $( "<li>" ),
			wrapper = $( "<div>", {
				title: item.element.attr( "title" )
			} );

		if ( item.disabled ) {
			this._addClass( li, null, "ui-state-disabled" );
		}

		if ( item.hidden ) {
			li.prop( "hidden", true );
		} else {
			this._setText( wrapper, item.label );
		}

		return li.append( wrapper ).appendTo( ul );
	},

	_setText: function( element, value ) {
		if ( value ) {
			element.text( value );
		} else {
			element.html( "&#160;" );
		}
	},

	_move: function( direction, event ) {
		var item, next,
			filter = ".ui-menu-item";

		if ( this.isOpen ) {
			item = this.menuItems.eq( this.focusIndex ).parent( "li" );
		} else {
			item = this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
			filter += ":not(.ui-state-disabled)";
		}

		if ( direction === "first" || direction === "last" ) {
			next = item[ direction === "first" ? "prevAll" : "nextAll" ]( filter ).eq( -1 );
		} else {
			next = item[ direction + "All" ]( filter ).eq( 0 );
		}

		if ( next.length ) {
			this.menuInstance.focus( event, next );
		}
	},

	_getSelectedItem: function() {
		return this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
	},

	_toggle: function( event ) {
		this[ this.isOpen ? "close" : "open" ]( event );
	},

	_setSelection: function() {
		var selection;

		if ( !this.range ) {
			return;
		}

		selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange( this.range );
	},

	_documentClick: {
		mousedown: function( event ) {
			if ( !this.isOpen ) {
				return;
			}

			if ( !$( event.target ).closest( ".ui-selectmenu-menu, #" +
				CSS.escape( this.ids.button ) ).length ) {
				this.close( event );
			}
		}
	},

	_buttonEvents: {

		// Prevent text selection from being reset when interacting with the selectmenu (#10144)
		mousedown: function() {
			var selection = window.getSelection();
			if ( selection.rangeCount ) {
				this.range = selection.getRangeAt( 0 );
			}
		},

		click: function( event ) {
			this._setSelection();
			this._toggle( event );
		},

		keydown: function( event ) {
			var preventDefault = true;
			switch ( event.keyCode ) {
			case $.ui.keyCode.TAB:
			case $.ui.keyCode.ESCAPE:
				this.close( event );
				preventDefault = false;
				break;
			case $.ui.keyCode.ENTER:
				if ( this.isOpen ) {
					this._selectFocusedItem( event );
				}
				break;
			case $.ui.keyCode.UP:
				if ( event.altKey ) {
					this._toggle( event );
				} else {
					this._move( "prev", event );
				}
				break;
			case $.ui.keyCode.DOWN:
				if ( event.altKey ) {
					this._toggle( event );
				} else {
					this._move( "next", event );
				}
				break;
			case $.ui.keyCode.SPACE:
				if ( this.isOpen ) {
					this._selectFocusedItem( event );
				} else {
					this._toggle( event );
				}
				break;
			case $.ui.keyCode.LEFT:
				this._move( "prev", event );
				break;
			case $.ui.keyCode.RIGHT:
				this._move( "next", event );
				break;
			case $.ui.keyCode.HOME:
			case $.ui.keyCode.PAGE_UP:
				this._move( "first", event );
				break;
			case $.ui.keyCode.END:
			case $.ui.keyCode.PAGE_DOWN:
				this._move( "last", event );
				break;
			default:
				this.menu.trigger( event );
				preventDefault = false;
			}

			if ( preventDefault ) {
				event.preventDefault();
			}
		}
	},

	_selectFocusedItem: function( event ) {
		var item = this.menuItems.eq( this.focusIndex ).parent( "li" );
		if ( !item.hasClass( "ui-state-disabled" ) ) {
			this._select( item.data( "ui-selectmenu-item" ), event );
		}
	},

	_select: function( item, event ) {
		var oldIndex = this.element[ 0 ].selectedIndex;

		// Change native select element
		this.element[ 0 ].selectedIndex = item.index;
		this.buttonItem.replaceWith( this.buttonItem = this._renderButtonItem( item ) );
		this._setAria( item );
		this._trigger( "select", event, { item: item } );

		if ( item.index !== oldIndex ) {
			this._trigger( "change", event, { item: item } );
		}

		this.close( event );
	},

	_setAria: function( item ) {
		var id = this.menuItems.eq( item.index ).attr( "id" );

		this.button.attr( {
			"aria-labelledby": id,
			"aria-activedescendant": id
		} );
		this.menu.attr( "aria-activedescendant", id );
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			var icon = this.button.find( "span.ui-icon" );
			this._removeClass( icon, null, this.options.icons.button )
				._addClass( icon, null, value.button );
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.menuWrap.appendTo( this._appendTo() );
		}

		if ( key === "width" ) {
			this._resizeButton();
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.menuInstance.option( "disabled", value );
		this.button.attr( "aria-disabled", value );
		this._toggleClass( this.button, null, "ui-state-disabled", value );

		this.element.prop( "disabled", value );
		if ( value ) {
			this.button.attr( "tabindex", -1 );
			this.close();
		} else {
			this.button.attr( "tabindex", 0 );
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front, dialog" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_toggleAttr: function() {
		this.button.attr( "aria-expanded", this.isOpen );

		// We can't use two _toggleClass() calls here, because we need to make sure
		// we always remove classes first and add them second, otherwise if both classes have the
		// same theme class, it will be removed after we add it.
		this._removeClass( this.button, "ui-selectmenu-button-" +
			( this.isOpen ? "closed" : "open" ) )
			._addClass( this.button, "ui-selectmenu-button-" +
				( this.isOpen ? "open" : "closed" ) )
			._toggleClass( this.menuWrap, "ui-selectmenu-open", null, this.isOpen );

		this.menu.attr( "aria-hidden", !this.isOpen );
	},

	_resizeButton: function() {
		var width = this.options.width;

		// For `width: false`, just remove inline style and stop
		if ( width === false ) {
			this.button.css( "width", "" );
			return;
		}

		// For `width: null`, match the width of the original element
		if ( width === null ) {
			width = this.element.show().outerWidth();
			this.element.hide();
		}

		this.button.outerWidth( width );
	},

	_resizeMenu: function() {
		this.menu.outerWidth( Math.max(
			this.button.outerWidth(),
			this.menu.width( "" ).outerWidth()
		) );
	},

	_getCreateOptions: function() {
		var options = this._super();

		options.disabled = this.element.prop( "disabled" );

		return options;
	},

	_parseOptions: function( options ) {
		var that = this,
			data = [];
		options.each( function( index, item ) {
			data.push( that._parseOption( $( item ), index ) );
		} );
		this.items = data;
	},

	_parseOption: function( option, index ) {
		var optgroup = option.parent( "optgroup" );

		return {
			element: option,
			index: index,
			value: option.val(),
			label: option.text(),
			hidden: optgroup.prop( "hidden" ) || option.prop( "hidden" ),
			optgroup: optgroup.attr( "label" ) || "",
			disabled: optgroup.prop( "disabled" ) || option.prop( "disabled" )
		};
	},

	_destroy: function() {
		this._unbindFormResetHandler();
		this.menuWrap.remove();
		this.button.remove();
		this.element.show();
		this.element.removeUniqueId();
		this.labels.attr( "for", this.ids.element );
	}
} ] );


/*!
 * jQuery UI Slider 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Slider
//>>group: Widgets
//>>description: Displays a flexible slider with ranges and accessibility via keyboard.
//>>docs: https://api.jqueryui.com/slider/
//>>demos: https://jqueryui.com/slider/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/slider.css
//>>css.theme: ../../themes/base/theme.css


var widgetsSlider = $.widget( "ui.slider", $.ui.mouse, {
	version: "1.14.2",
	widgetEventPrefix: "slide",

	options: {
		animate: false,
		classes: {
			"ui-slider": "ui-corner-all",
			"ui-slider-handle": "ui-corner-all",

			// Note: ui-widget-header isn't the most fittingly semantic framework class for this
			// element, but worked best visually with a variety of themes
			"ui-slider-range": "ui-corner-all ui-widget-header"
		},
		distance: 0,
		max: 100,
		min: 0,
		orientation: "horizontal",
		range: false,
		step: 1,
		value: 0,
		values: null,

		// Callbacks
		change: null,
		slide: null,
		start: null,
		stop: null
	},

	// Number of pages in a slider
	// (how many times can you page up/down to go through the whole range)
	numPages: 5,

	_create: function() {
		this._keySliding = false;
		this._mouseSliding = false;
		this._animateOff = true;
		this._handleIndex = null;
		this._detectOrientation();
		this._mouseInit();
		this._calculateNewMax();

		this._addClass( "ui-slider ui-slider-" + this.orientation,
			"ui-widget ui-widget-content" );

		this._refresh();

		this._animateOff = false;
	},

	_refresh: function() {
		this._createRange();
		this._createHandles();
		this._setupEvents();
		this._refreshValue();
	},

	_createHandles: function() {
		var i, handleCount,
			options = this.options,
			existingHandles = this.element.find( ".ui-slider-handle" ),
			handle = "<span tabindex='0'></span>",
			handles = [];

		handleCount = ( options.values && options.values.length ) || 1;

		if ( existingHandles.length > handleCount ) {
			existingHandles.slice( handleCount ).remove();
			existingHandles = existingHandles.slice( 0, handleCount );
		}

		for ( i = existingHandles.length; i < handleCount; i++ ) {
			handles.push( handle );
		}

		this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );

		this._addClass( this.handles, "ui-slider-handle", "ui-state-default" );

		this.handle = this.handles.eq( 0 );

		this.handles.each( function( i ) {
			$( this )
				.data( "ui-slider-handle-index", i )
				.attr( "tabIndex", 0 );
		} );
	},

	_createRange: function() {
		var options = this.options;

		if ( options.range ) {
			if ( options.range === true ) {
				if ( !options.values ) {
					options.values = [ this._valueMin(), this._valueMin() ];
				} else if ( options.values.length && options.values.length !== 2 ) {
					options.values = [ options.values[ 0 ], options.values[ 0 ] ];
				} else if ( Array.isArray( options.values ) ) {
					options.values = options.values.slice( 0 );
				}
			}

			if ( !this.range || !this.range.length ) {
				this.range = $( "<div>" )
					.appendTo( this.element );

				this._addClass( this.range, "ui-slider-range" );
			} else {
				this._removeClass( this.range, "ui-slider-range-min ui-slider-range-max" );

				// Handle range switching from true to min/max
				this.range.css( {
					"left": "",
					"bottom": ""
				} );
			}
			if ( options.range === "min" || options.range === "max" ) {
				this._addClass( this.range, "ui-slider-range-" + options.range );
			}
		} else {
			if ( this.range ) {
				this.range.remove();
			}
			this.range = null;
		}
	},

	_setupEvents: function() {
		this._off( this.handles );
		this._on( this.handles, this._handleEvents );
		this._hoverable( this.handles );
		this._focusable( this.handles );
	},

	_destroy: function() {
		this.handles.remove();
		if ( this.range ) {
			this.range.remove();
		}

		this._mouseDestroy();
	},

	_mouseCapture: function( event ) {
		var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
			that = this,
			o = this.options;

		if ( o.disabled ) {
			return false;
		}

		this.elementSize = {
			width: this.element.outerWidth(),
			height: this.element.outerHeight()
		};
		this.elementOffset = this.element.offset();

		position = { x: event.pageX, y: event.pageY };
		normValue = this._normValueFromMouse( position );
		distance = this._valueMax() - this._valueMin() + 1;
		this.handles.each( function( i ) {
			var thisDistance = Math.abs( normValue - that.values( i ) );
			if ( ( distance > thisDistance ) ||
				( distance === thisDistance &&
					( i === that._lastChangedValue || that.values( i ) === o.min ) ) ) {
				distance = thisDistance;
				closestHandle = $( this );
				index = i;
			}
		} );

		allowed = this._start( event, index );
		if ( allowed === false ) {
			return false;
		}
		this._mouseSliding = true;

		this._handleIndex = index;

		this._addClass( closestHandle, null, "ui-state-active" );
		closestHandle.trigger( "focus" );

		offset = closestHandle.offset();
		mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
		this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
			left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
			top: event.pageY - offset.top -
				( closestHandle.height() / 2 ) -
				( parseInt( closestHandle.css( "borderTopWidth" ), 10 ) || 0 ) -
				( parseInt( closestHandle.css( "borderBottomWidth" ), 10 ) || 0 ) +
				( parseInt( closestHandle.css( "marginTop" ), 10 ) || 0 )
		};

		if ( !this.handles.hasClass( "ui-state-hover" ) ) {
			this._slide( event, index, normValue );
		}
		this._animateOff = true;
		return true;
	},

	_mouseStart: function() {
		return true;
	},

	_mouseDrag: function( event ) {
		var position = { x: event.pageX, y: event.pageY },
			normValue = this._normValueFromMouse( position );

		this._slide( event, this._handleIndex, normValue );

		return false;
	},

	_mouseStop: function( event ) {
		this._removeClass( this.handles, null, "ui-state-active" );
		this._mouseSliding = false;

		this._stop( event, this._handleIndex );
		this._change( event, this._handleIndex );

		this._handleIndex = null;
		this._clickOffset = null;
		this._animateOff = false;

		return false;
	},

	_detectOrientation: function() {
		this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
	},

	_normValueFromMouse: function( position ) {
		var pixelTotal,
			pixelMouse,
			percentMouse,
			valueTotal,
			valueMouse;

		if ( this.orientation === "horizontal" ) {
			pixelTotal = this.elementSize.width;
			pixelMouse = position.x - this.elementOffset.left -
				( this._clickOffset ? this._clickOffset.left : 0 );
		} else {
			pixelTotal = this.elementSize.height;
			pixelMouse = position.y - this.elementOffset.top -
				( this._clickOffset ? this._clickOffset.top : 0 );
		}

		percentMouse = ( pixelMouse / pixelTotal );
		if ( percentMouse > 1 ) {
			percentMouse = 1;
		}
		if ( percentMouse < 0 ) {
			percentMouse = 0;
		}
		if ( this.orientation === "vertical" ) {
			percentMouse = 1 - percentMouse;
		}

		valueTotal = this._valueMax() - this._valueMin();
		valueMouse = this._valueMin() + percentMouse * valueTotal;

		return this._trimAlignValue( valueMouse );
	},

	_uiHash: function( index, value, values ) {
		var uiHash = {
			handle: this.handles[ index ],
			handleIndex: index,
			value: value !== undefined ? value : this.value()
		};

		if ( this._hasMultipleValues() ) {
			uiHash.value = value !== undefined ? value : this.values( index );
			uiHash.values = values || this.values();
		}

		return uiHash;
	},

	_hasMultipleValues: function() {
		return this.options.values && this.options.values.length;
	},

	_start: function( event, index ) {
		return this._trigger( "start", event, this._uiHash( index ) );
	},

	_slide: function( event, index, newVal ) {
		var allowed, otherVal,
			currentValue = this.value(),
			newValues = this.values();

		if ( this._hasMultipleValues() ) {
			otherVal = this.values( index ? 0 : 1 );
			currentValue = this.values( index );

			if ( this.options.values.length === 2 && this.options.range === true ) {
				newVal =  index === 0 ? Math.min( otherVal, newVal ) : Math.max( otherVal, newVal );
			}

			newValues[ index ] = newVal;
		}

		if ( newVal === currentValue ) {
			return;
		}

		allowed = this._trigger( "slide", event, this._uiHash( index, newVal, newValues ) );

		// A slide can be canceled by returning false from the slide callback
		if ( allowed === false ) {
			return;
		}

		if ( this._hasMultipleValues() ) {
			this.values( index, newVal );
		} else {
			this.value( newVal );
		}
	},

	_stop: function( event, index ) {
		this._trigger( "stop", event, this._uiHash( index ) );
	},

	_change: function( event, index ) {
		if ( !this._keySliding && !this._mouseSliding ) {

			//store the last changed value index for reference when handles overlap
			this._lastChangedValue = index;
			this._trigger( "change", event, this._uiHash( index ) );
		}
	},

	value: function( newValue ) {
		if ( arguments.length ) {
			this.options.value = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, 0 );
			return;
		}

		return this._value();
	},

	values: function( index, newValue ) {
		var vals,
			newValues,
			i;

		if ( arguments.length > 1 ) {
			this.options.values[ index ] = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, index );
			return;
		}

		if ( arguments.length ) {
			if ( Array.isArray( arguments[ 0 ] ) ) {
				vals = this.options.values;
				newValues = arguments[ 0 ];
				for ( i = 0; i < vals.length; i += 1 ) {
					vals[ i ] = this._trimAlignValue( newValues[ i ] );
					this._change( null, i );
				}
				this._refreshValue();
			} else {
				if ( this._hasMultipleValues() ) {
					return this._values( index );
				} else {
					return this.value();
				}
			}
		} else {
			return this._values();
		}
	},

	_setOption: function( key, value ) {
		var i,
			valsLength = 0;

		if ( key === "range" && this.options.range === true ) {
			if ( value === "min" ) {
				this.options.value = this._values( 0 );
				this.options.values = null;
			} else if ( value === "max" ) {
				this.options.value = this._values( this.options.values.length - 1 );
				this.options.values = null;
			}
		}

		if ( Array.isArray( this.options.values ) ) {
			valsLength = this.options.values.length;
		}

		this._super( key, value );

		switch ( key ) {
			case "orientation":
				this._detectOrientation();
				this._removeClass( "ui-slider-horizontal ui-slider-vertical" )
					._addClass( "ui-slider-" + this.orientation );
				this._refreshValue();
				if ( this.options.range ) {
					this._refreshRange( value );
				}

				// Reset positioning from previous orientation
				this.handles.css( value === "horizontal" ? "bottom" : "left", "" );
				break;
			case "value":
				this._animateOff = true;
				this._refreshValue();
				this._change( null, 0 );
				this._animateOff = false;
				break;
			case "values":
				this._animateOff = true;
				this._refreshValue();

				// Start from the last handle to prevent unreachable handles (#9046)
				for ( i = valsLength - 1; i >= 0; i-- ) {
					this._change( null, i );
				}
				this._animateOff = false;
				break;
			case "step":
			case "min":
			case "max":
				this._animateOff = true;
				this._calculateNewMax();
				this._refreshValue();
				this._animateOff = false;
				break;
			case "range":
				this._animateOff = true;
				this._refresh();
				this._animateOff = false;
				break;
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	//internal value getter
	// _value() returns value trimmed by min and max, aligned by step
	_value: function() {
		var val = this.options.value;
		val = this._trimAlignValue( val );

		return val;
	},

	//internal values getter
	// _values() returns array of values trimmed by min and max, aligned by step
	// _values( index ) returns single value trimmed by min and max, aligned by step
	_values: function( index ) {
		var val,
			vals,
			i;

		if ( arguments.length ) {
			val = this.options.values[ index ];
			val = this._trimAlignValue( val );

			return val;
		} else if ( this._hasMultipleValues() ) {

			// .slice() creates a copy of the array
			// this copy gets trimmed by min and max and then returned
			vals = this.options.values.slice();
			for ( i = 0; i < vals.length; i += 1 ) {
				vals[ i ] = this._trimAlignValue( vals[ i ] );
			}

			return vals;
		} else {
			return [];
		}
	},

	// Returns the step-aligned value that val is closest to, between (inclusive) min and max
	_trimAlignValue: function( val ) {
		if ( val <= this._valueMin() ) {
			return this._valueMin();
		}
		if ( val >= this._valueMax() ) {
			return this._valueMax();
		}
		var step = ( this.options.step > 0 ) ? this.options.step : 1,
			valModStep = ( val - this._valueMin() ) % step,
			alignValue = val - valModStep;

		if ( Math.abs( valModStep ) * 2 >= step ) {
			alignValue += ( valModStep > 0 ) ? step : ( -step );
		}

		// Since JavaScript has problems with large floats, round
		// the final value to 5 digits after the decimal point (see #4124)
		return parseFloat( alignValue.toFixed( 5 ) );
	},

	_calculateNewMax: function() {
		var max = this.options.max,
			min = this._valueMin(),
			step = this.options.step,
			aboveMin = Math.round( ( max - min ) / step ) * step;
		max = aboveMin + min;
		if ( max > this.options.max ) {

			//If max is not divisible by step, rounding off may increase its value
			max -= step;
		}
		this.max = parseFloat( max.toFixed( this._precision() ) );
	},

	_precision: function() {
		var precision = this._precisionOf( this.options.step );
		if ( this.options.min !== null ) {
			precision = Math.max( precision, this._precisionOf( this.options.min ) );
		}
		return precision;
	},

	_precisionOf: function( num ) {
		var str = num.toString(),
			decimal = str.indexOf( "." );
		return decimal === -1 ? 0 : str.length - decimal - 1;
	},

	_valueMin: function() {
		return this.options.min;
	},

	_valueMax: function() {
		return this.max;
	},

	_refreshRange: function( orientation ) {
		if ( orientation === "vertical" ) {
			this.range.css( { "width": "", "left": "" } );
		}
		if ( orientation === "horizontal" ) {
			this.range.css( { "height": "", "bottom": "" } );
		}
	},

	_refreshValue: function() {
		var lastValPercent, valPercent, value, valueMin, valueMax,
			oRange = this.options.range,
			o = this.options,
			that = this,
			animate = ( !this._animateOff ) ? o.animate : false,
			_set = {};

		if ( this._hasMultipleValues() ) {
			this.handles.each( function( i ) {
				valPercent = ( that.values( i ) - that._valueMin() ) / ( that._valueMax() -
					that._valueMin() ) * 100;
				_set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
				$( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
				if ( that.options.range === true ) {
					if ( that.orientation === "horizontal" ) {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
								left: valPercent + "%"
							}, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( {
								width: ( valPercent - lastValPercent ) + "%"
							}, {
								queue: false,
								duration: o.animate
							} );
						}
					} else {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
								bottom: ( valPercent ) + "%"
							}, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( {
								height: ( valPercent - lastValPercent ) + "%"
							}, {
								queue: false,
								duration: o.animate
							} );
						}
					}
				}
				lastValPercent = valPercent;
			} );
		} else {
			value = this.value();
			valueMin = this._valueMin();
			valueMax = this._valueMax();
			valPercent = ( valueMax !== valueMin ) ?
					( value - valueMin ) / ( valueMax - valueMin ) * 100 :
					0;
			_set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
			this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

			if ( oRange === "min" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					width: valPercent + "%"
				}, o.animate );
			}
			if ( oRange === "max" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					width: ( 100 - valPercent ) + "%"
				}, o.animate );
			}
			if ( oRange === "min" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					height: valPercent + "%"
				}, o.animate );
			}
			if ( oRange === "max" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					height: ( 100 - valPercent ) + "%"
				}, o.animate );
			}
		}
	},

	_handleEvents: {
		keydown: function( event ) {
			var allowed, curVal, newVal, step,
				index = $( event.target ).data( "ui-slider-handle-index" );

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
				case $.ui.keyCode.END:
				case $.ui.keyCode.PAGE_UP:
				case $.ui.keyCode.PAGE_DOWN:
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					event.preventDefault();
					if ( !this._keySliding ) {
						this._keySliding = true;
						this._addClass( $( event.target ), null, "ui-state-active" );
						allowed = this._start( event, index );
						if ( allowed === false ) {
							return;
						}
					}
					break;
			}

			step = this.options.step;
			if ( this._hasMultipleValues() ) {
				curVal = newVal = this.values( index );
			} else {
				curVal = newVal = this.value();
			}

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
					newVal = this._valueMin();
					break;
				case $.ui.keyCode.END:
					newVal = this._valueMax();
					break;
				case $.ui.keyCode.PAGE_UP:
					newVal = this._trimAlignValue(
						curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
					);
					break;
				case $.ui.keyCode.PAGE_DOWN:
					newVal = this._trimAlignValue(
						curVal - ( ( this._valueMax() - this._valueMin() ) / this.numPages ) );
					break;
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
					if ( curVal === this._valueMax() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal + step );
					break;
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					if ( curVal === this._valueMin() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal - step );
					break;
			}

			this._slide( event, index, newVal );
		},
		keyup: function( event ) {
			var index = $( event.target ).data( "ui-slider-handle-index" );

			if ( this._keySliding ) {
				this._keySliding = false;
				this._stop( event, index );
				this._change( event, index );
				this._removeClass( $( event.target ), null, "ui-state-active" );
			}
		}
	}
} );


/*!
 * jQuery UI Sortable 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Sortable
//>>group: Interactions
//>>description: Enables items in a list to be sorted using the mouse.
//>>docs: https://api.jqueryui.com/sortable/
//>>demos: https://jqueryui.com/sortable/
//>>css.structure: ../../themes/base/sortable.css


var widgetsSortable = $.widget( "ui.sortable", $.ui.mouse, {
	version: "1.14.2",
	widgetEventPrefix: "sort",
	ready: false,
	options: {
		appendTo: "parent",
		axis: false,
		connectWith: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		dropOnEmpty: true,
		forcePlaceholderSize: false,
		forceHelperSize: false,
		grid: false,
		handle: false,
		helper: "original",
		items: "> *",
		opacity: false,
		placeholder: false,
		revert: false,
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		scope: "default",
		tolerance: "intersect",
		zIndex: 1000,

		// Callbacks
		activate: null,
		beforeStop: null,
		change: null,
		deactivate: null,
		out: null,
		over: null,
		receive: null,
		remove: null,
		sort: null,
		start: null,
		stop: null,
		update: null
	},

	_isOverAxis: function( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	},

	_isFloating: function( item ) {
		return ( /left|right/ ).test( item.css( "float" ) ) ||
			( /inline|table-cell/ ).test( item.css( "display" ) );
	},

	_create: function() {
		this.containerCache = {};
		this._addClass( "ui-sortable" );

		//Get the items
		this.refresh();

		//Let's determine the parent's offset
		this.offset = this.element.offset();

		//Initialize mouse events for interaction
		this._mouseInit();

		this._setHandleClassName();

		//We're ready to go
		this.ready = true;

	},

	_setOption: function( key, value ) {
		this._super( key, value );

		if ( key === "handle" ) {
			this._setHandleClassName();
		}
	},

	_setHandleClassName: function() {
		var that = this;
		this._removeClass( this.element.find( ".ui-sortable-handle" ), "ui-sortable-handle" );
		$.each( this.items, function() {
			that._addClass(
				this.instance.options.handle ?
					this.item.find( this.instance.options.handle ) :
					this.item,
				"ui-sortable-handle"
			);
		} );
	},

	_destroy: function() {
		this._mouseDestroy();

		for ( var i = this.items.length - 1; i >= 0; i-- ) {
			this.items[ i ].item.removeData( this.widgetName + "-item" );
		}

		return this;
	},

	_mouseCapture: function( event, overrideHandle ) {
		var currentItem = null,
			validHandle = false,
			that = this;

		if ( this.reverting ) {
			return false;
		}

		if ( this.options.disabled || this.options.type === "static" ) {
			return false;
		}

		//We have to refresh the items data once first
		this._refreshItems( event );

		//Find out if the clicked node (or one of its parents) is a actual item in this.items
		$( event.target ).parents().each( function() {
			if ( $.data( this, that.widgetName + "-item" ) === that ) {
				currentItem = $( this );
				return false;
			}
		} );
		if ( $.data( event.target, that.widgetName + "-item" ) === that ) {
			currentItem = $( event.target );
		}

		if ( !currentItem ) {
			return false;
		}
		if ( this.options.handle && !overrideHandle ) {
			$( this.options.handle, currentItem ).find( "*" ).addBack().each( function() {
				if ( this === event.target ) {
					validHandle = true;
				}
			} );
			if ( !validHandle ) {
				return false;
			}
		}

		this.currentItem = currentItem;
		this._removeCurrentsFromItems();
		return true;

	},

	_mouseStart: function( event, overrideHandle, noActivation ) {

		var i, body,
			o = this.options;

		this.currentContainer = this;

		//We only need to call refreshPositions, because the refreshItems call has been moved to
		// mouseCapture
		this.refreshPositions();

		//Prepare the dragged items parent
		this.appendTo = $( o.appendTo !== "parent" ?
				o.appendTo :
				this.currentItem.parent() );

		//Create and append the visible helper
		this.helper = this._createHelper( event );

		//Cache the helper size
		this._cacheHelperProportions();

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//The element's absolute position on the page minus margins
		this.offset = this.currentItem.offset();
		this.offset = {
			top: this.offset.top - this.margins.top,
			left: this.offset.left - this.margins.left
		};

		$.extend( this.offset, {
			click: { //Where the click happened, relative to the element
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			},

			// This is a relative to absolute position minus the actual position calculation -
			// only used for relative positioned helper
			relative: this._getRelativeOffset()
		} );

		// After we get the helper offset, but before we get the parent offset we can
		// change the helper's position to absolute
		// TODO: Still need to figure out a way to make relative sorting possible
		this.helper.css( "position", "absolute" );
		this.cssPosition = this.helper.css( "position" );

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		if ( o.cursorAt ) {
			this._adjustOffsetFromHelper( o.cursorAt );
		}

		//Cache the former DOM position
		this.domPosition = {
			prev: this.currentItem.prev()[ 0 ],
			parent: this.currentItem.parent()[ 0 ]
		};

		// If the helper is not the original, hide the original so it's not playing any role during
		// the drag, won't cause anything bad this way
		if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
			this.currentItem.hide();
		}

		//Create the placeholder
		this._createPlaceholder();

		//Get the next scrolling parent
		this.scrollParent = this.placeholder.scrollParent();

		$.extend( this.offset, {
			parent: this._getParentOffset()
		} );

		//Set a containment if given in the options
		if ( o.containment ) {
			this._setContainment();
		}

		if ( o.cursor && o.cursor !== "auto" ) { // cursor option
			body = this.document.find( "body" );

			this._storedStylesheet =
				$( "<style>*{ cursor: " + o.cursor + " !important; }</style>" ).appendTo( body );
		}

		// We need to make sure to grab the zIndex before setting the
		// opacity, because setting the opacity to anything lower than 1
		// causes the zIndex to change from "auto" to 0.
		if ( o.zIndex ) { // zIndex option
			if ( this.helper.css( "zIndex" ) ) {
				this._storedZIndex = this.helper.css( "zIndex" );
			}
			this.helper.css( "zIndex", o.zIndex );
		}

		if ( o.opacity ) { // opacity option
			if ( this.helper.css( "opacity" ) ) {
				this._storedOpacity = this.helper.css( "opacity" );
			}
			this.helper.css( "opacity", o.opacity );
		}

		//Prepare scrolling
		if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ].tagName !== "HTML" ) {
			this.overflowOffset = this.scrollParent.offset();
		}

		//Call callbacks
		this._trigger( "start", event, this._uiHash() );

		//Recache the helper size
		if ( !this._preserveHelperProportions ) {
			this._cacheHelperProportions();
		}

		//Post "activate" events to possible containers
		if ( !noActivation ) {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
			}
		}

		//Prepare possible droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.current = this;
		}

		if ( $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( this, event );
		}

		this.dragging = true;

		this._addClass( this.helper, "ui-sortable-helper" );

		//Move the helper, if needed
		if ( !this.helper.parent().is( this.appendTo ) ) {
			this.helper.detach().appendTo( this.appendTo );

			//Update position
			this.offset.parent = this._getParentOffset();
		}

		//Generate the original position
		this.position = this.originalPosition = this._generatePosition( event );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;
		this.lastPositionAbs = this.positionAbs = this._convertPositionTo( "absolute" );

		this._mouseDrag( event );

		return true;

	},

	_scroll: function( event ) {
		var o = this.options,
			scrolled = false;

		if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ].tagName !== "HTML" ) {

			if ( ( this.overflowOffset.top + this.scrollParent[ 0 ].offsetHeight ) -
					event.pageY < o.scrollSensitivity ) {
				this.scrollParent[ 0 ].scrollTop =
					scrolled = this.scrollParent[ 0 ].scrollTop + o.scrollSpeed;
			} else if ( event.pageY - this.overflowOffset.top < o.scrollSensitivity ) {
				this.scrollParent[ 0 ].scrollTop =
					scrolled = this.scrollParent[ 0 ].scrollTop - o.scrollSpeed;
			}

			if ( ( this.overflowOffset.left + this.scrollParent[ 0 ].offsetWidth ) -
					event.pageX < o.scrollSensitivity ) {
				this.scrollParent[ 0 ].scrollLeft = scrolled =
					this.scrollParent[ 0 ].scrollLeft + o.scrollSpeed;
			} else if ( event.pageX - this.overflowOffset.left < o.scrollSensitivity ) {
				this.scrollParent[ 0 ].scrollLeft = scrolled =
					this.scrollParent[ 0 ].scrollLeft - o.scrollSpeed;
			}

		} else {

			if ( event.pageY - this.document.scrollTop() < o.scrollSensitivity ) {
				scrolled = this.document.scrollTop( this.document.scrollTop() - o.scrollSpeed );
			} else if ( this.window.height() - ( event.pageY - this.document.scrollTop() ) <
					o.scrollSensitivity ) {
				scrolled = this.document.scrollTop( this.document.scrollTop() + o.scrollSpeed );
			}

			if ( event.pageX - this.document.scrollLeft() < o.scrollSensitivity ) {
				scrolled = this.document.scrollLeft(
					this.document.scrollLeft() - o.scrollSpeed
				);
			} else if ( this.window.width() - ( event.pageX - this.document.scrollLeft() ) <
					o.scrollSensitivity ) {
				scrolled = this.document.scrollLeft(
					this.document.scrollLeft() + o.scrollSpeed
				);
			}

		}

		return scrolled;
	},

	_mouseDrag: function( event ) {
		var i, item, itemElement, intersection,
			o = this.options;

		//Compute the helpers position
		this.position = this._generatePosition( event );
		this.positionAbs = this._convertPositionTo( "absolute" );

		//Set the helper position
		if ( !this.options.axis || this.options.axis !== "y" ) {
			this.helper[ 0 ].style.left = this.position.left + "px";
		}
		if ( !this.options.axis || this.options.axis !== "x" ) {
			this.helper[ 0 ].style.top = this.position.top + "px";
		}

		//Do scrolling
		if ( o.scroll ) {
			if ( this._scroll( event ) !== false ) {

				//Update item positions used in position checks
				this._refreshItemPositions( true );

				if ( $.ui.ddmanager && !o.dropBehaviour ) {
					$.ui.ddmanager.prepareOffsets( this, event );
				}
			}
		}

		this.dragDirection = {
			vertical: this._getDragVerticalDirection(),
			horizontal: this._getDragHorizontalDirection()
		};

		//Rearrange
		for ( i = this.items.length - 1; i >= 0; i-- ) {

			//Cache variables and intersection, continue if no intersection
			item = this.items[ i ];
			itemElement = item.item[ 0 ];
			intersection = this._intersectsWithPointer( item );
			if ( !intersection ) {
				continue;
			}

			// Only put the placeholder inside the current Container, skip all
			// items from other containers. This works because when moving
			// an item from one container to another the
			// currentContainer is switched before the placeholder is moved.
			//
			// Without this, moving items in "sub-sortables" can cause
			// the placeholder to jitter between the outer and inner container.
			if ( item.instance !== this.currentContainer ) {
				continue;
			}

			// Cannot intersect with itself
			// no useless actions that have been done before
			// no action if the item moved is the parent of the item checked
			if ( itemElement !== this.currentItem[ 0 ] &&
				this.placeholder[ intersection === 1 ?
				"next" : "prev" ]()[ 0 ] !== itemElement &&
				!$.contains( this.placeholder[ 0 ], itemElement ) &&
				( this.options.type === "semi-dynamic" ?
					!$.contains( this.element[ 0 ], itemElement ) :
					true
				)
			) {

				this.direction = intersection === 1 ? "down" : "up";

				if ( this.options.tolerance === "pointer" ||
						this._intersectsWithSides( item ) ) {
					this._rearrange( event, item );
				} else {
					break;
				}

				this._trigger( "change", event, this._uiHash() );
				break;
			}
		}

		//Post events to containers
		this._contactContainers( event );

		//Interconnect with droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.drag( this, event );
		}

		//Call callbacks
		this._trigger( "sort", event, this._uiHash() );

		this.lastPositionAbs = this.positionAbs;
		return false;

	},

	_mouseStop: function( event, noPropagation ) {

		if ( !event ) {
			return;
		}

		//If we are using droppables, inform the manager about the drop
		if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
			$.ui.ddmanager.drop( this, event );
		}

		if ( this.options.revert ) {
			var that = this,
				cur = this.placeholder.offset(),
				axis = this.options.axis,
				animation = {};

			if ( !axis || axis === "x" ) {
				animation.left = cur.left - this.offset.parent.left - this.margins.left +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollLeft
					);
			}
			if ( !axis || axis === "y" ) {
				animation.top = cur.top - this.offset.parent.top - this.margins.top +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollTop
					);
			}
			this.reverting = true;
			$( this.helper ).animate(
				animation,
				parseInt( this.options.revert, 10 ) || 500,
				function() {
					that._clear( event );
				}
			);
		} else {
			this._clear( event, noPropagation );
		}

		return false;

	},

	cancel: function() {

		if ( this.dragging ) {

			this._mouseUp( new $.Event( "mouseup", { target: null } ) );

			if ( this.options.helper === "original" ) {
				this.currentItem.css( this._storedCSS );
				this._removeClass( this.currentItem, "ui-sortable-helper" );
			} else {
				this.currentItem.show();
			}

			//Post deactivating events to containers
			for ( var i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "deactivate", null, this._uiHash( this ) );
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", null, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		if ( this.placeholder ) {

			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
			// it unbinds ALL events from the original node!
			if ( this.placeholder[ 0 ].parentNode ) {
				this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
			}
			if ( this.options.helper !== "original" && this.helper &&
					this.helper[ 0 ].parentNode ) {
				this.helper.remove();
			}

			$.extend( this, {
				helper: null,
				dragging: false,
				reverting: false,
				_noFinalSort: null
			} );

			if ( this.domPosition.prev ) {
				$( this.domPosition.prev ).after( this.currentItem );
			} else {
				$( this.domPosition.parent ).prepend( this.currentItem );
			}
		}

		return this;

	},

	serialize: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			str = [];
		o = o || {};

		$( items ).each( function() {
			var res = ( $( o.item || this ).attr( o.attribute || "id" ) || "" )
				.match( o.expression || ( /(.+)[\-=_](.+)/ ) );
			if ( res ) {
				str.push(
					( o.key || res[ 1 ] + "[]" ) +
					"=" + ( o.key && o.expression ? res[ 1 ] : res[ 2 ] ) );
			}
		} );

		if ( !str.length && o.key ) {
			str.push( o.key + "=" );
		}

		return str.join( "&" );

	},

	toArray: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			ret = [];

		o = o || {};

		items.each( function() {
			ret.push( $( o.item || this ).attr( o.attribute || "id" ) || "" );
		} );
		return ret;

	},

	/* Be careful with the following core functions */
	_intersectsWith: function( item ) {

		var x1 = this.positionAbs.left,
			x2 = x1 + this.helperProportions.width,
			y1 = this.positionAbs.top,
			y2 = y1 + this.helperProportions.height,
			l = item.left,
			r = l + item.width,
			t = item.top,
			b = t + item.height,
			dyClick = this.offset.click.top,
			dxClick = this.offset.click.left,
			isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t &&
				( y1 + dyClick ) < b ),
			isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l &&
				( x1 + dxClick ) < r ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( this.options.tolerance === "pointer" ||
			this.options.forcePointerForContainers ||
			( this.options.tolerance !== "pointer" &&
				this.helperProportions[ this.floating ? "width" : "height" ] >
				item[ this.floating ? "width" : "height" ] )
		) {
			return isOverElement;
		} else {

			return ( l < x1 + ( this.helperProportions.width / 2 ) && // Right Half
				x2 - ( this.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( this.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( this.helperProportions.height / 2 ) < b ); // Top Half

		}
	},

	_intersectsWithPointer: function( item ) {
		var verticalDirection, horizontalDirection,
			isOverElementHeight = ( this.options.axis === "x" ) ||
				this._isOverAxis(
					this.positionAbs.top + this.offset.click.top, item.top, item.height ),
			isOverElementWidth = ( this.options.axis === "y" ) ||
				this._isOverAxis(
					this.positionAbs.left + this.offset.click.left, item.left, item.width ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( !isOverElement ) {
			return false;
		}

		verticalDirection = this.dragDirection.vertical;
		horizontalDirection = this.dragDirection.horizontal;

		return this.floating ?
			( ( horizontalDirection === "right" || verticalDirection === "down" ) ? 2 : 1 ) :
			( verticalDirection && ( verticalDirection === "down" ? 2 : 1 ) );

	},

	_intersectsWithSides: function( item ) {

		var isOverBottomHalf = this._isOverAxis( this.positionAbs.top +
				this.offset.click.top, item.top + ( item.height / 2 ), item.height ),
			isOverRightHalf = this._isOverAxis( this.positionAbs.left +
				this.offset.click.left, item.left + ( item.width / 2 ), item.width ),
			verticalDirection = this.dragDirection.vertical,
			horizontalDirection = this.dragDirection.horizontal;

		if ( this.floating && horizontalDirection ) {
			return ( ( horizontalDirection === "right" && isOverRightHalf ) ||
				( horizontalDirection === "left" && !isOverRightHalf ) );
		} else {
			return verticalDirection && ( ( verticalDirection === "down" && isOverBottomHalf ) ||
				( verticalDirection === "up" && !isOverBottomHalf ) );
		}

	},

	_getDragVerticalDirection: function() {
		var delta = this.positionAbs.top - this.lastPositionAbs.top;
		return delta !== 0 && ( delta > 0 ? "down" : "up" );
	},

	_getDragHorizontalDirection: function() {
		var delta = this.positionAbs.left - this.lastPositionAbs.left;
		return delta !== 0 && ( delta > 0 ? "right" : "left" );
	},

	refresh: function( event ) {
		this._refreshItems( event );
		this._setHandleClassName();
		this.refreshPositions();
		return this;
	},

	_connectWith: function() {
		var options = this.options;
		return options.connectWith.constructor === String ?
			[ options.connectWith ] :
			options.connectWith;
	},

	_getItemsAsjQuery: function( connected ) {

		var i, j, cur, inst,
			items = [],
			queries = [],
			connectWith = this._connectWith();

		if ( connectWith && connected ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ typeof inst.options.items === "function" ?
							inst.options.items.call( inst.element ) :
							$( inst.options.items, inst.element )
								.not( ".ui-sortable-helper" )
								.not( ".ui-sortable-placeholder" ), inst ] );
					}
				}
			}
		}

		queries.push( [ typeof this.options.items === "function" ?
			this.options.items
				.call( this.element, null, { options: this.options, item: this.currentItem } ) :
			$( this.options.items, this.element )
				.not( ".ui-sortable-helper" )
				.not( ".ui-sortable-placeholder" ), this ] );

		function addItems() {
			items.push( this );
		}
		for ( i = queries.length - 1; i >= 0; i-- ) {
			queries[ i ][ 0 ].each( addItems );
		}

		return $( items );

	},

	_removeCurrentsFromItems: function() {

		var list = this.currentItem.find( ":data(" + this.widgetName + "-item)" );

		this.items = $.grep( this.items, function( item ) {
			for ( var j = 0; j < list.length; j++ ) {
				if ( list[ j ] === item.item[ 0 ] ) {
					return false;
				}
			}
			return true;
		} );

	},

	_refreshItems: function( event ) {

		this.items = [];
		this.containers = [ this ];

		var i, j, cur, inst, targetData, _queries, item, queriesLength,
			items = this.items,
			queries = [ [ typeof this.options.items === "function" ?
				this.options.items.call( this.element[ 0 ], event, { item: this.currentItem } ) :
				$( this.options.items, this.element ), this ] ],
			connectWith = this._connectWith();

		//Shouldn't be run the first time through due to massive slow-down
		if ( connectWith && this.ready ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ typeof inst.options.items === "function" ?
							inst.options.items
								.call( inst.element[ 0 ], event, { item: this.currentItem } ) :
							$( inst.options.items, inst.element ), inst ] );
						this.containers.push( inst );
					}
				}
			}
		}

		for ( i = queries.length - 1; i >= 0; i-- ) {
			targetData = queries[ i ][ 1 ];
			_queries = queries[ i ][ 0 ];

			for ( j = 0, queriesLength = _queries.length; j < queriesLength; j++ ) {
				item = $( _queries[ j ] );

				// Data for target checking (mouse manager)
				item.data( this.widgetName + "-item", targetData );

				items.push( {
					item: item,
					instance: targetData,
					width: 0, height: 0,
					left: 0, top: 0
				} );
			}
		}

	},

	_refreshItemPositions: function( fast ) {
		var i, item, t, p;

		for ( i = this.items.length - 1; i >= 0; i-- ) {
			item = this.items[ i ];

			//We ignore calculating positions of all connected containers when we're not over them
			if ( this.currentContainer && item.instance !== this.currentContainer &&
					item.item[ 0 ] !== this.currentItem[ 0 ] ) {
				continue;
			}

			t = this.options.toleranceElement ?
				$( this.options.toleranceElement, item.item ) :
				item.item;

			if ( !fast ) {
				item.width = t.outerWidth();
				item.height = t.outerHeight();
			}

			p = t.offset();
			item.left = p.left;
			item.top = p.top;
		}
	},

	refreshPositions: function( fast ) {

		// Determine whether items are being displayed horizontally
		this.floating = this.items.length ?
			this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
			false;

		// This has to be redone because due to the item being moved out/into the offsetParent,
		// the offsetParent's position will change
		if ( this.offsetParent && this.helper ) {
			this.offset.parent = this._getParentOffset();
		}

		this._refreshItemPositions( fast );

		var i, p;

		if ( this.options.custom && this.options.custom.refreshContainers ) {
			this.options.custom.refreshContainers.call( this );
		} else {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				p = this.containers[ i ].element.offset();
				this.containers[ i ].containerCache.left = p.left;
				this.containers[ i ].containerCache.top = p.top;
				this.containers[ i ].containerCache.width =
					this.containers[ i ].element.outerWidth();
				this.containers[ i ].containerCache.height =
					this.containers[ i ].element.outerHeight();
			}
		}

		return this;
	},

	_createPlaceholder: function( that ) {
		that = that || this;
		var className, nodeName,
			o = that.options;

		if ( !o.placeholder || o.placeholder.constructor === String ) {
			className = o.placeholder;
			nodeName = that.currentItem[ 0 ].nodeName.toLowerCase();
			o.placeholder = {
				element: function() {

					var element = $( "<" + nodeName + ">", that.document[ 0 ] );

					that._addClass( element, "ui-sortable-placeholder",
							className || that.currentItem[ 0 ].className )
						._removeClass( element, "ui-sortable-helper" );

					if ( nodeName === "tbody" ) {
						that._createTrPlaceholder(
							that.currentItem.find( "tr" ).eq( 0 ),
							$( "<tr>", that.document[ 0 ] ).appendTo( element )
						);
					} else if ( nodeName === "tr" ) {
						that._createTrPlaceholder( that.currentItem, element );
					} else if ( nodeName === "img" ) {
						element.attr( "src", that.currentItem.attr( "src" ) );
					}

					if ( !className ) {
						element.css( "visibility", "hidden" );
					}

					return element;
				},
				update: function( container, p ) {

					// 1. If a className is set as 'placeholder option, we don't force sizes -
					// the class is responsible for that
					// 2. The option 'forcePlaceholderSize can be enabled to force it even if a
					// class name is specified
					if ( className && !o.forcePlaceholderSize ) {
						return;
					}

					// If the element doesn't have a actual height or width by itself (without
					// styles coming from a stylesheet), it receives the inline height and width
					// from the dragged item. Or, if it's a tbody or tr, it's going to have a height
					// anyway since we're populating them with <td>s above, but they're unlikely to
					// be the correct height on their own if the row heights are dynamic, so we'll
					// always assign the height of the dragged item given forcePlaceholderSize
					// is true.
					if ( !p.height() || ( o.forcePlaceholderSize &&
							( nodeName === "tbody" || nodeName === "tr" ) ) ) {
						p.height(
							that.currentItem.innerHeight() -
							parseInt( that.currentItem.css( "paddingTop" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingBottom" ) || 0, 10 ) );
					}
					if ( !p.width() ) {
						p.width(
							that.currentItem.innerWidth() -
							parseInt( that.currentItem.css( "paddingLeft" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingRight" ) || 0, 10 ) );
					}
				}
			};
		}

		//Create the placeholder
		that.placeholder = $( o.placeholder.element.call( that.element, that.currentItem ) );

		//Append it after the actual current item
		that.currentItem.after( that.placeholder );

		//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
		o.placeholder.update( that, that.placeholder );

	},

	_createTrPlaceholder: function( sourceTr, targetTr ) {
		var that = this;

		sourceTr.children().each( function() {
			$( "<td>&#160;</td>", that.document[ 0 ] )
				.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
				.appendTo( targetTr );
		} );
	},

	_contactContainers: function( event ) {
		var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom,
			floating, axis,
			innermostContainer = null,
			innermostIndex = null;

		// Get innermost container that intersects with item
		for ( i = this.containers.length - 1; i >= 0; i-- ) {

			// Never consider a container that's located within the item itself
			if ( $.contains( this.currentItem[ 0 ], this.containers[ i ].element[ 0 ] ) ) {
				continue;
			}

			if ( this._intersectsWith( this.containers[ i ].containerCache ) ) {

				// If we've already found a container and it's more "inner" than this, then continue
				if ( innermostContainer &&
						$.contains(
							this.containers[ i ].element[ 0 ],
							innermostContainer.element[ 0 ] ) ) {
					continue;
				}

				innermostContainer = this.containers[ i ];
				innermostIndex = i;

			} else {

				// container doesn't intersect. trigger "out" event if necessary
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", event, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		// If no intersecting containers found, return
		if ( !innermostContainer ) {
			return;
		}

		// Move the item into the container if it's not there already
		if ( this.containers.length === 1 ) {
			if ( !this.containers[ innermostIndex ].containerCache.over ) {
				this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
				this.containers[ innermostIndex ].containerCache.over = 1;
			}
		} else {

			// When entering a new container, we will find the item with the least distance and
			// append our item near it
			dist = 10000;
			itemWithLeastDistance = null;
			floating = innermostContainer.floating || this._isFloating( this.currentItem );
			posProperty = floating ? "left" : "top";
			sizeProperty = floating ? "width" : "height";
			axis = floating ? "pageX" : "pageY";

			for ( j = this.items.length - 1; j >= 0; j-- ) {
				if ( !$.contains(
						this.containers[ innermostIndex ].element[ 0 ], this.items[ j ].item[ 0 ] )
				) {
					continue;
				}
				if ( this.items[ j ].item[ 0 ] === this.currentItem[ 0 ] ) {
					continue;
				}

				cur = this.items[ j ].item.offset()[ posProperty ];
				nearBottom = false;
				if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
					nearBottom = true;
				}

				if ( Math.abs( event[ axis ] - cur ) < dist ) {
					dist = Math.abs( event[ axis ] - cur );
					itemWithLeastDistance = this.items[ j ];
					this.direction = nearBottom ? "up" : "down";
				}
			}

			//Check if dropOnEmpty is enabled
			if ( !itemWithLeastDistance && !this.options.dropOnEmpty ) {
				return;
			}

			if ( this.currentContainer === this.containers[ innermostIndex ] ) {
				if ( !this.currentContainer.containerCache.over ) {
					this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
					this.currentContainer.containerCache.over = 1;
				}
				return;
			}

			if ( itemWithLeastDistance ) {
				this._rearrange( event, itemWithLeastDistance, null, true );
			} else {
				this._rearrange( event, null, this.containers[ innermostIndex ].element, true );
			}
			this._trigger( "change", event, this._uiHash() );
			this.containers[ innermostIndex ]._trigger( "change", event, this._uiHash( this ) );
			this.currentContainer = this.containers[ innermostIndex ];

			//Update the placeholder
			this.options.placeholder.update( this.currentContainer, this.placeholder );

			//Update scrollParent
			this.scrollParent = this.placeholder.scrollParent();

			//Update overflowOffset
			if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ].tagName !== "HTML" ) {
				this.overflowOffset = this.scrollParent.offset();
			}

			this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
			this.containers[ innermostIndex ].containerCache.over = 1;
		}

	},

	_createHelper: function( event ) {

		var o = this.options,
			helper = typeof o.helper === "function" ?
				$( o.helper.apply( this.element[ 0 ], [ event, this.currentItem ] ) ) :
				( o.helper === "clone" ? this.currentItem.clone() : this.currentItem );

		//Add the helper to the DOM if that didn't happen already
		if ( !helper.parents( "body" ).length ) {
			this.appendTo[ 0 ].appendChild( helper[ 0 ] );
		}

		if ( helper[ 0 ] === this.currentItem[ 0 ] ) {
			this._storedCSS = {
				width: this.currentItem[ 0 ].style.width,
				height: this.currentItem[ 0 ].style.height,
				position: this.currentItem.css( "position" ),
				top: this.currentItem.css( "top" ),
				left: this.currentItem.css( "left" )
			};
		}

		if ( !helper[ 0 ].style.width || o.forceHelperSize ) {
			helper.width( this.currentItem.width() );
		}
		if ( !helper[ 0 ].style.height || o.forceHelperSize ) {
			helper.height( this.currentItem.height() );
		}

		return helper;

	},

	_adjustOffsetFromHelper: function( obj ) {
		if ( typeof obj === "string" ) {
			obj = obj.split( " " );
		}
		if ( Array.isArray( obj ) ) {
			obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
		}
		if ( "left" in obj ) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ( "right" in obj ) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ( "top" in obj ) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ( "bottom" in obj ) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		this.offsetParent = this.helper.offsetParent();
		var po = this.offsetParent.offset();

		// This is a special case where we need to modify a offset calculated on start, since the
		// following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the
		// next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
		// the document, which means that the scroll is included in the initial calculation of the
		// offset of the parent, and never recalculated upon drag
		if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		// This needs to be actually done for all browsers, since pageX/pageY includes
		// this information.
		if ( this.offsetParent[ 0 ] === this.document[ 0 ].body ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
			left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
		};

	},

	_getRelativeOffset: function() {

		if ( this.cssPosition === "relative" ) {
			var p = this.currentItem.position();
			return {
				top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
					this.scrollParent.scrollTop(),
				left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
					this.scrollParent.scrollLeft()
			};
		} else {
			return { top: 0, left: 0 };
		}

	},

	_cacheMargins: function() {
		this.margins = {
			left: ( parseInt( this.currentItem.css( "marginLeft" ), 10 ) || 0 ),
			top: ( parseInt( this.currentItem.css( "marginTop" ), 10 ) || 0 )
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var ce, co, over,
			o = this.options;
		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}
		if ( o.containment === "document" || o.containment === "window" ) {
			this.containment = [
				0 - this.offset.relative.left - this.offset.parent.left,
				0 - this.offset.relative.top - this.offset.parent.top,
				o.containment === "document" ?
					this.document.width() :
					this.window.width() - this.helperProportions.width - this.margins.left,
				( o.containment === "document" ?
					( this.document.height() || document.body.parentNode.scrollHeight ) :
					this.window.height() || this.document[ 0 ].body.parentNode.scrollHeight
				) - this.helperProportions.height - this.margins.top
			];
		}

		if ( !( /^(document|window|parent)$/ ).test( o.containment ) ) {
			ce = $( o.containment )[ 0 ];
			co = $( o.containment ).offset();
			over = ( $( ce ).css( "overflow" ) !== "hidden" );

			this.containment = [
				co.left + ( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingLeft" ), 10 ) || 0 ) - this.margins.left,
				co.top + ( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingTop" ), 10 ) || 0 ) - this.margins.top,
				co.left + ( over ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width - this.margins.left,
				co.top + ( over ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height - this.margins.top
			];
		}

	},

	_convertPositionTo: function( d, pos ) {

		if ( !pos ) {
			pos = this.position;
		}
		var mod = d === "absolute" ? 1 : -1,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
			scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		return {
			top: (

				// The absolute mouse position
				pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod )
			),
			left: (

				// The absolute mouse position
				pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 :
					scroll.scrollLeft() ) * mod )
			)
		};

	},

	_generatePosition: function( event ) {

		var top, left,
			o = this.options,
			pageX = event.pageX,
			pageY = event.pageY,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
				scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		// This is another very weird special case that only happens for relative elements:
		// 1. If the css position is relative
		// 2. and the scroll parent is the document or similar to the offset parent
		// we have to refresh the relative offset during the scroll so there are no jumps
		if ( this.cssPosition === "relative" && !( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ] !== this.offsetParent[ 0 ] ) ) {
			this.offset.relative = this._getRelativeOffset();
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		if ( this.originalPosition ) { //If we are not dragging yet, we won't check for options

			if ( this.containment ) {
				if ( event.pageX - this.offset.click.left < this.containment[ 0 ] ) {
					pageX = this.containment[ 0 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top < this.containment[ 1 ] ) {
					pageY = this.containment[ 1 ] + this.offset.click.top;
				}
				if ( event.pageX - this.offset.click.left > this.containment[ 2 ] ) {
					pageX = this.containment[ 2 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top > this.containment[ 3 ] ) {
					pageY = this.containment[ 3 ] + this.offset.click.top;
				}
			}

			if ( o.grid ) {
				top = this.originalPageY + Math.round( ( pageY - this.originalPageY ) /
					o.grid[ 1 ] ) * o.grid[ 1 ];
				pageY = this.containment ?
					( ( top - this.offset.click.top >= this.containment[ 1 ] &&
						top - this.offset.click.top <= this.containment[ 3 ] ) ?
							top :
							( ( top - this.offset.click.top >= this.containment[ 1 ] ) ?
								top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) :
								top;

				left = this.originalPageX + Math.round( ( pageX - this.originalPageX ) /
					o.grid[ 0 ] ) * o.grid[ 0 ];
				pageX = this.containment ?
					( ( left - this.offset.click.left >= this.containment[ 0 ] &&
						left - this.offset.click.left <= this.containment[ 2 ] ) ?
							left :
							( ( left - this.offset.click.left >= this.containment[ 0 ] ) ?
								left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) :
								left;
			}

		}

		return {
			top: (

				// The absolute mouse position
				pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) )
			),
			left: (

				// The absolute mouse position
				pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() :
					scrollIsRootNode ? 0 : scroll.scrollLeft() ) )
			)
		};

	},

	_rearrange: function( event, i, a, hardRefresh ) {

		if ( a ) {
			a[ 0 ].appendChild( this.placeholder[ 0 ] );
		} else {
			i.item[ 0 ].parentNode.insertBefore( this.placeholder[ 0 ],
				( this.direction === "down" ? i.item[ 0 ] : i.item[ 0 ].nextSibling ) );
		}

		//Various things done here to improve the performance:
		// 1. we create a setTimeout, that calls refreshPositions
		// 2. on the instance, we have a counter variable, that get's higher after every append
		// 3. on the local scope, we copy the counter variable, and check in the timeout,
		// if it's still the same
		// 4. this lets only the last addition to the timeout stack through
		this.counter = this.counter ? ++this.counter : 1;
		var counter = this.counter;

		this._delay( function() {
			if ( counter === this.counter ) {

				//Precompute after each DOM insertion, NOT on mousemove
				this.refreshPositions( !hardRefresh );
			}
		} );

	},

	_clear: function( event, noPropagation ) {

		this.reverting = false;

		// We delay all events that have to be triggered to after the point where the placeholder
		// has been removed and everything else normalized again
		var i,
			delayedTriggers = [];

		// We first have to update the dom position of the actual currentItem
		// Note: don't do it if the current item is already removed (by a user), or it gets
		// reappended (see #4088)
		if ( !this._noFinalSort && this.currentItem.parent().length ) {
			this.placeholder.before( this.currentItem );
		}
		this._noFinalSort = null;

		if ( this.helper[ 0 ] === this.currentItem[ 0 ] ) {
			for ( i in this._storedCSS ) {
				if ( this._storedCSS[ i ] === "auto" || this._storedCSS[ i ] === "static" ) {
					this._storedCSS[ i ] = "";
				}
			}
			this.currentItem.css( this._storedCSS );
			this._removeClass( this.currentItem, "ui-sortable-helper" );
		} else {
			this.currentItem.show();
		}

		if ( this.fromOutside && !noPropagation ) {
			delayedTriggers.push( function( event ) {
				this._trigger( "receive", event, this._uiHash( this.fromOutside ) );
			} );
		}
		if ( ( this.fromOutside ||
				this.domPosition.prev !==
				this.currentItem.prev().not( ".ui-sortable-helper" )[ 0 ] ||
				this.domPosition.parent !== this.currentItem.parent()[ 0 ] ) && !noPropagation ) {

			// Trigger update callback if the DOM position has changed
			delayedTriggers.push( function( event ) {
				this._trigger( "update", event, this._uiHash() );
			} );
		}

		// Check if the items Container has Changed and trigger appropriate
		// events.
		if ( this !== this.currentContainer ) {
			if ( !noPropagation ) {
				delayedTriggers.push( function( event ) {
					this._trigger( "remove", event, this._uiHash() );
				} );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "receive", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "update", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
			}
		}

		//Post events to containers
		function delayEvent( type, instance, container ) {
			return function( event ) {
				container._trigger( type, event, instance._uiHash( instance ) );
			};
		}
		for ( i = this.containers.length - 1; i >= 0; i-- ) {
			if ( !noPropagation ) {
				delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
			}
			if ( this.containers[ i ].containerCache.over ) {
				delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
				this.containers[ i ].containerCache.over = 0;
			}
		}

		//Do what was originally in plugins
		if ( this._storedStylesheet ) {
			this._storedStylesheet.remove();
			this._storedStylesheet = null;
		}
		if ( this._storedOpacity ) {
			this.helper.css( "opacity", this._storedOpacity );
		}
		if ( this._storedZIndex ) {
			this.helper.css( "zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex );
		}

		this.dragging = false;

		if ( !noPropagation ) {
			this._trigger( "beforeStop", event, this._uiHash() );
		}

		//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
		// it unbinds ALL events from the original node!
		this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );

		if ( !this.cancelHelperRemoval ) {
			if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
				this.helper.remove();
			}
			this.helper = null;
		}

		if ( !noPropagation ) {
			for ( i = 0; i < delayedTriggers.length; i++ ) {

				// Trigger all delayed events
				delayedTriggers[ i ].call( this, event );
			}
			this._trigger( "stop", event, this._uiHash() );
		}

		this.fromOutside = false;
		return !this.cancelHelperRemoval;

	},

	_trigger: function() {
		if ( $.Widget.prototype._trigger.apply( this, arguments ) === false ) {
			this.cancel();
		}
	},

	_uiHash: function( _inst ) {
		var inst = _inst || this;
		return {
			helper: inst.helper,
			placeholder: inst.placeholder || $( [] ),
			position: inst.position,
			originalPosition: inst.originalPosition,
			offset: inst.positionAbs,
			item: inst.currentItem,
			sender: _inst ? _inst.element : null
		};
	}

} );


/*!
 * jQuery UI Spinner 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Spinner
//>>group: Widgets
//>>description: Displays buttons to easily input numbers via the keyboard or mouse.
//>>docs: https://api.jqueryui.com/spinner/
//>>demos: https://jqueryui.com/spinner/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/spinner.css
//>>css.theme: ../../themes/base/theme.css


function spinnerModifier( fn ) {
	return function() {
		var previous = this.element.val();
		fn.apply( this, arguments );
		this._refresh();
		if ( previous !== this.element.val() ) {
			this._trigger( "change" );
		}
	};
}

$.widget( "ui.spinner", {
	version: "1.14.2",
	defaultElement: "<input>",
	widgetEventPrefix: "spin",
	options: {
		classes: {
			"ui-spinner": "ui-corner-all",
			"ui-spinner-down": "ui-corner-br",
			"ui-spinner-up": "ui-corner-tr"
		},
		culture: null,
		icons: {
			down: "ui-icon-triangle-1-s",
			up: "ui-icon-triangle-1-n"
		},
		incremental: true,
		max: null,
		min: null,
		numberFormat: null,
		page: 10,
		step: 1,

		change: null,
		spin: null,
		start: null,
		stop: null
	},

	_create: function() {

		// handle string values that need to be parsed
		this._setOption( "max", this.options.max );
		this._setOption( "min", this.options.min );
		this._setOption( "step", this.options.step );

		// Only format if there is a value, prevents the field from being marked
		// as invalid in Firefox, see #9573.
		if ( this.value() !== "" ) {

			// Format the value, but don't constrain.
			this._value( this.element.val(), true );
		}

		this._draw();
		this._on( this._events );
		this._refresh();

		// Turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		} );
	},

	_getCreateOptions: function() {
		var options = this._super();
		var element = this.element;

		$.each( [ "min", "max", "step" ], function( i, option ) {
			var value = element.attr( option );
			if ( value != null && value.length ) {
				options[ option ] = value;
			}
		} );

		return options;
	},

	_events: {
		keydown: function( event ) {
			if ( this._start( event ) && this._keydown( event ) ) {
				event.preventDefault();
			}
		},
		keyup: "_stop",
		focus: function() {
			this.previous = this.element.val();
		},
		blur: function( event ) {
			this._stop();
			this._refresh();
			if ( this.previous !== this.element.val() ) {
				this._trigger( "change", event );
			}
		},
		wheel: function( event ) {
			var activeElement = this.document[ 0 ].activeElement;
			var isActive = this.element[ 0 ] === activeElement;
			var delta = event.deltaY || event.originalEvent && event.originalEvent.deltaY;

			if ( !isActive || !delta ) {
				return;
			}

			if ( !this.spinning && !this._start( event ) ) {
				return false;
			}

			this._spin( ( delta > 0 ? -1 : 1 ) * this.options.step, event );
			clearTimeout( this.mousewheelTimer );
			this.mousewheelTimer = this._delay( function() {
				if ( this.spinning ) {
					this._stop( event );
				}
			}, 100 );
			event.preventDefault();
		},

		// DEPRECATED
		// Kept for backwards compatibility. Please use the modern `wheel`
		// event. The `delta` parameter is provided by the jQuery Mousewheel
		// plugin if one is loaded.
		mousewheel: function( event, delta ) {
			if ( !event.isTrigger ) {

				// If this is not a trigger call, the `wheel` handler will
				// fire as well, let's not duplicate it.
				return;
			}

			var wheelEvent = $.Event( event );
			wheelEvent.type = "wheel";
			if ( delta ) {
				wheelEvent.deltaY = -delta;
			}
			return this._events.wheel.call( this, wheelEvent );
		},

		"mousedown .ui-spinner-button": function( event ) {
			var previous;

			// We never want the buttons to have focus; whenever the user is
			// interacting with the spinner, the focus should be on the input.
			// If the input is focused then this.previous is properly set from
			// when the input first received focus. If the input is not focused
			// then we need to set this.previous based on the value before spinning.
			previous = this.element[ 0 ] === this.document[ 0 ].activeElement ?
				this.previous : this.element.val();
			function checkFocus() {
				var isActive = this.element[ 0 ] === this.document[ 0 ].activeElement;
				if ( !isActive ) {
					this.element.trigger( "focus" );
					this.previous = previous;
				}
			}

			// Ensure focus is on (or stays on) the text field
			event.preventDefault();
			checkFocus.call( this );

			if ( this._start( event ) === false ) {
				return;
			}

			this._repeat( null, $( event.currentTarget )
				.hasClass( "ui-spinner-up" ) ? 1 : -1, event );
		},
		"mouseup .ui-spinner-button": "_stop",
		"mouseenter .ui-spinner-button": function( event ) {

			// button will add ui-state-active if mouse was down while mouseleave and kept down
			if ( !$( event.currentTarget ).hasClass( "ui-state-active" ) ) {
				return;
			}

			if ( this._start( event ) === false ) {
				return false;
			}
			this._repeat( null, $( event.currentTarget )
				.hasClass( "ui-spinner-up" ) ? 1 : -1, event );
		},

		// TODO: do we really want to consider this a stop?
		// shouldn't we just stop the repeater and wait until mouseup before
		// we trigger the stop event?
		"mouseleave .ui-spinner-button": "_stop"
	},

	// Support mobile enhanced option and make backcompat more sane
	_enhance: function() {
		this.uiSpinner = this.element
			.attr( "autocomplete", "off" )
			.wrap( "<span>" )
			.parent()

				// Add buttons
				.append(
					"<a></a><a></a>"
				);
	},

	_draw: function() {
		this._enhance();

		this._addClass( this.uiSpinner, "ui-spinner", "ui-widget ui-widget-content" );
		this._addClass( "ui-spinner-input" );

		this.element.attr( "role", "spinbutton" );

		// Button bindings
		this.buttons = this.uiSpinner.children( "a" )
			.attr( "tabIndex", -1 )
			.attr( "aria-hidden", true )
			.button( {
				classes: {
					"ui-button": ""
				}
			} );

		// TODO: Right now button does not support classes this is already updated in button PR
		this._removeClass( this.buttons, "ui-corner-all" );

		this._addClass( this.buttons.first(), "ui-spinner-button ui-spinner-up" );
		this._addClass( this.buttons.last(), "ui-spinner-button ui-spinner-down" );
		this.buttons.first().button( {
			"icon": this.options.icons.up,
			"showLabel": false
		} );
		this.buttons.last().button( {
			"icon": this.options.icons.down,
			"showLabel": false
		} );

		// IE 6 doesn't understand height: 50% for the buttons
		// unless the wrapper has an explicit height
		if ( this.buttons.height() > Math.ceil( this.uiSpinner.height() * 0.5 ) &&
				this.uiSpinner.height() > 0 ) {
			this.uiSpinner.height( this.uiSpinner.height() );
		}
	},

	_keydown: function( event ) {
		var options = this.options,
			keyCode = $.ui.keyCode;

		switch ( event.keyCode ) {
		case keyCode.UP:
			this._repeat( null, 1, event );
			return true;
		case keyCode.DOWN:
			this._repeat( null, -1, event );
			return true;
		case keyCode.PAGE_UP:
			this._repeat( null, options.page, event );
			return true;
		case keyCode.PAGE_DOWN:
			this._repeat( null, -options.page, event );
			return true;
		}

		return false;
	},

	_start: function( event ) {
		if ( !this.spinning && this._trigger( "start", event ) === false ) {
			return false;
		}

		if ( !this.counter ) {
			this.counter = 1;
		}
		this.spinning = true;
		return true;
	},

	_repeat: function( i, steps, event ) {
		i = i || 500;

		clearTimeout( this.timer );
		this.timer = this._delay( function() {
			this._repeat( 40, steps, event );
		}, i );

		this._spin( steps * this.options.step, event );
	},

	_spin: function( step, event ) {
		var value = this.value() || 0;

		if ( !this.counter ) {
			this.counter = 1;
		}

		value = this._adjustValue( value + step * this._increment( this.counter ) );

		if ( !this.spinning || this._trigger( "spin", event, { value: value } ) !== false ) {
			this._value( value );
			this.counter++;
		}
	},

	_increment: function( i ) {
		var incremental = this.options.incremental;

		if ( incremental ) {
			return typeof incremental === "function" ?
				incremental( i ) :
				Math.floor( i * i * i / 50000 - i * i / 500 + 17 * i / 200 + 1 );
		}

		return 1;
	},

	_precision: function() {
		var precision = this._precisionOf( this.options.step );
		if ( this.options.min !== null ) {
			precision = Math.max( precision, this._precisionOf( this.options.min ) );
		}
		return precision;
	},

	_precisionOf: function( num ) {
		var str = num.toString(),
			decimal = str.indexOf( "." );
		return decimal === -1 ? 0 : str.length - decimal - 1;
	},

	_adjustValue: function( value ) {
		var base, aboveMin,
			options = this.options;

		// Make sure we're at a valid step
		// - find out where we are relative to the base (min or 0)
		base = options.min !== null ? options.min : 0;
		aboveMin = value - base;

		// - round to the nearest step
		aboveMin = Math.round( aboveMin / options.step ) * options.step;

		// - rounding is based on 0, so adjust back to our base
		value = base + aboveMin;

		// Fix precision from bad JS floating point math
		value = parseFloat( value.toFixed( this._precision() ) );

		// Clamp the value
		if ( options.max !== null && value > options.max ) {
			return options.max;
		}
		if ( options.min !== null && value < options.min ) {
			return options.min;
		}

		return value;
	},

	_stop: function( event ) {
		if ( !this.spinning ) {
			return;
		}

		clearTimeout( this.timer );
		clearTimeout( this.mousewheelTimer );
		this.counter = 0;
		this.spinning = false;
		this._trigger( "stop", event );
	},

	_setOption: function( key, value ) {
		var prevValue, first, last;

		if ( key === "culture" || key === "numberFormat" ) {
			prevValue = this._parse( this.element.val() );
			this.options[ key ] = value;
			this.element.val( this._format( prevValue ) );
			return;
		}

		if ( key === "max" || key === "min" || key === "step" ) {
			if ( typeof value === "string" ) {
				value = this._parse( value );
			}
		}
		if ( key === "icons" ) {
			first = this.buttons.first().find( ".ui-icon" );
			this._removeClass( first, null, this.options.icons.up );
			this._addClass( first, null, value.up );
			last = this.buttons.last().find( ".ui-icon" );
			this._removeClass( last, null, this.options.icons.down );
			this._addClass( last, null, value.down );
		}

		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this._toggleClass( this.uiSpinner, null, "ui-state-disabled", !!value );
		this.element.prop( "disabled", !!value );
		this.buttons.button( value ? "disable" : "enable" );
	},

	_setOptions: spinnerModifier( function( options ) {
		this._super( options );
	} ),

	_parse: function( val ) {
		if ( typeof val === "string" && val !== "" ) {
			val = window.Globalize && this.options.numberFormat ?
				Globalize.parseFloat( val, 10, this.options.culture ) : +val;
		}
		return val === "" || isNaN( val ) ? null : val;
	},

	_format: function( value ) {
		if ( value === "" ) {
			return "";
		}
		return window.Globalize && this.options.numberFormat ?
			Globalize.format( value, this.options.numberFormat, this.options.culture ) :
			value;
	},

	_refresh: function() {
		this.element.attr( {
			"aria-valuemin": this.options.min,
			"aria-valuemax": this.options.max,

			// TODO: what should we do with values that can't be parsed?
			"aria-valuenow": this._parse( this.element.val() )
		} );
	},

	isValid: function() {
		var value = this.value();

		// Null is invalid
		if ( value === null ) {
			return false;
		}

		// If value gets adjusted, it's invalid
		return value === this._adjustValue( value );
	},

	// Update the value without triggering change
	_value: function( value, allowAny ) {
		var parsed;
		if ( value !== "" ) {
			parsed = this._parse( value );
			if ( parsed !== null ) {
				if ( !allowAny ) {
					parsed = this._adjustValue( parsed );
				}
				value = this._format( parsed );
			}
		}
		this.element.val( value );
		this._refresh();
	},

	_destroy: function() {
		this.element
			.prop( "disabled", false )
			.removeAttr( "autocomplete role aria-valuemin aria-valuemax aria-valuenow" );

		this.uiSpinner.replaceWith( this.element );
	},

	stepUp: spinnerModifier( function( steps ) {
		this._stepUp( steps );
	} ),
	_stepUp: function( steps ) {
		if ( this._start() ) {
			this._spin( ( steps || 1 ) * this.options.step );
			this._stop();
		}
	},

	stepDown: spinnerModifier( function( steps ) {
		this._stepDown( steps );
	} ),
	_stepDown: function( steps ) {
		if ( this._start() ) {
			this._spin( ( steps || 1 ) * -this.options.step );
			this._stop();
		}
	},

	pageUp: spinnerModifier( function( pages ) {
		this._stepUp( ( pages || 1 ) * this.options.page );
	} ),

	pageDown: spinnerModifier( function( pages ) {
		this._stepDown( ( pages || 1 ) * this.options.page );
	} ),

	value: function( newVal ) {
		if ( !arguments.length ) {
			return this._parse( this.element.val() );
		}
		spinnerModifier( this._value ).call( this, newVal );
	},

	widget: function() {
		return this.uiSpinner;
	}
} );

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat === true ) {

	// Backcompat for spinner html extension points
	$.widget( "ui.spinner", $.ui.spinner, {
		_enhance: function() {
			this.uiSpinner = this.element
				.attr( "autocomplete", "off" )
				.wrap( this._uiSpinnerHtml() )
				.parent()

					// Add buttons
					.append( this._buttonHtml() );
		},
		_uiSpinnerHtml: function() {
			return "<span>";
		},

		_buttonHtml: function() {
			return "<a></a><a></a>";
		}
	} );
}

var widgetsSpinner = $.ui.spinner;


/*!
 * jQuery UI Tabs 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Tabs
//>>group: Widgets
//>>description: Transforms a set of container elements into a tab structure.
//>>docs: https://api.jqueryui.com/tabs/
//>>demos: https://jqueryui.com/tabs/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/tabs.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.tabs", {
	version: "1.14.2",
	delay: 300,
	options: {
		active: null,
		classes: {
			"ui-tabs": "ui-corner-all",
			"ui-tabs-nav": "ui-corner-all",
			"ui-tabs-panel": "ui-corner-bottom",
			"ui-tabs-tab": "ui-corner-top"
		},
		collapsible: false,
		event: "click",
		heightStyle: "content",
		hide: null,
		show: null,

		// Callbacks
		activate: null,
		beforeActivate: null,
		beforeLoad: null,
		load: null
	},

	_isLocal: function( anchor ) {
		var anchorUrl = new URL( anchor.href ),
			locationUrl = new URL( location.href );

		return anchor.hash.length > 1 &&

			// `href` may contain a hash but also username & password;
			// we want to ignore them, so we check the three fields
			// below instead.
			anchorUrl.origin === locationUrl.origin &&
			anchorUrl.pathname === locationUrl.pathname &&
			anchorUrl.search === locationUrl.search;
	},

	_create: function() {
		var that = this,
			options = this.options;

		this.running = false;

		this._addClass( "ui-tabs", "ui-widget ui-widget-content" );
		this._toggleClass( "ui-tabs-collapsible", null, options.collapsible );

		this._processTabs();
		options.active = this._initialActive();

		// Take disabling tabs via class attribute from HTML
		// into account and update option properly.
		if ( Array.isArray( options.disabled ) ) {
			options.disabled = $.uniqueSort( options.disabled.concat(
				$.map( this.tabs.filter( ".ui-state-disabled" ), function( li ) {
					return that.tabs.index( li );
				} )
			) ).sort();
		}

		// Check for length avoids error when initializing empty list
		if ( this.options.active !== false && this.anchors.length ) {
			this.active = this._findActive( options.active );
		} else {
			this.active = $();
		}

		this._refresh();

		if ( this.active.length ) {
			this.load( options.active );
		}
	},

	_initialActive: function() {
		var active = this.options.active,
			collapsible = this.options.collapsible,
			locationHash = location.hash.substring( 1 ),
			locationHashDecoded = decodeURIComponent( locationHash );

		if ( active === null ) {

			// check the fragment identifier in the URL
			if ( locationHash ) {
				this.tabs.each( function( i, tab ) {
					if ( $( tab ).attr( "aria-controls" ) === locationHash ) {
						active = i;
						return false;
					}
				} );

				// If not found, decode the hash & try again.
				// See the comment in `_processTabs` under the `_isLocal` check
				// for more information.
				if ( active === null ) {
					this.tabs.each( function( i, tab ) {
						if ( $( tab ).attr( "aria-controls" ) === locationHashDecoded ) {
							active = i;
							return false;
						}
					} );
				}
			}

			// Check for a tab marked active via a class
			if ( active === null ) {
				active = this.tabs.index( this.tabs.filter( ".ui-tabs-active" ) );
			}

			// No active tab, set to false
			if ( active === null || active === -1 ) {
				active = this.tabs.length ? 0 : false;
			}
		}

		// Handle numbers: negative, out of range
		if ( active !== false ) {
			active = this.tabs.index( this.tabs.eq( active ) );
			if ( active === -1 ) {
				active = collapsible ? false : 0;
			}
		}

		// Don't allow collapsible: false and active: false
		if ( !collapsible && active === false && this.anchors.length ) {
			active = 0;
		}

		return active;
	},

	_getCreateEventData: function() {
		return {
			tab: this.active,
			panel: !this.active.length ? $() : this._getPanelForTab( this.active )
		};
	},

	_tabKeydown: function( event ) {
		var focusedTab = $( this.document[ 0 ].activeElement ).closest( "li" ),
			selectedIndex = this.tabs.index( focusedTab ),
			goingForward = true;

		if ( this._handlePageNav( event ) ) {
			return;
		}

		switch ( event.keyCode ) {
		case $.ui.keyCode.RIGHT:
		case $.ui.keyCode.DOWN:
			selectedIndex++;
			break;
		case $.ui.keyCode.UP:
		case $.ui.keyCode.LEFT:
			goingForward = false;
			selectedIndex--;
			break;
		case $.ui.keyCode.END:
			selectedIndex = this.anchors.length - 1;
			break;
		case $.ui.keyCode.HOME:
			selectedIndex = 0;
			break;
		case $.ui.keyCode.SPACE:

			// Activate only, no collapsing
			event.preventDefault();
			clearTimeout( this.activating );
			this._activate( selectedIndex );
			return;
		case $.ui.keyCode.ENTER:

			// Toggle (cancel delayed activation, allow collapsing)
			event.preventDefault();
			clearTimeout( this.activating );

			// Determine if we should collapse or activate
			this._activate( selectedIndex === this.options.active ? false : selectedIndex );
			return;
		default:
			return;
		}

		// Focus the appropriate tab, based on which key was pressed
		event.preventDefault();
		clearTimeout( this.activating );
		selectedIndex = this._focusNextTab( selectedIndex, goingForward );

		// Navigating with control/command key will prevent automatic activation
		if ( !event.ctrlKey && !event.metaKey ) {

			// Update aria-selected immediately so that AT think the tab is already selected.
			// Otherwise AT may confuse the user by stating that they need to activate the tab,
			// but the tab will already be activated by the time the announcement finishes.
			focusedTab.attr( "aria-selected", "false" );
			this.tabs.eq( selectedIndex ).attr( "aria-selected", "true" );

			this.activating = this._delay( function() {
				this.option( "active", selectedIndex );
			}, this.delay );
		}
	},

	_panelKeydown: function( event ) {
		if ( this._handlePageNav( event ) ) {
			return;
		}

		// Ctrl+up moves focus to the current tab
		if ( event.ctrlKey && event.keyCode === $.ui.keyCode.UP ) {
			event.preventDefault();
			this.active.trigger( "focus" );
		}
	},

	// Alt+page up/down moves focus to the previous/next tab (and activates)
	_handlePageNav: function( event ) {
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP ) {
			this._activate( this._focusNextTab( this.options.active - 1, false ) );
			return true;
		}
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN ) {
			this._activate( this._focusNextTab( this.options.active + 1, true ) );
			return true;
		}
	},

	_findNextTab: function( index, goingForward ) {
		var lastTabIndex = this.tabs.length - 1;

		function constrain() {
			if ( index > lastTabIndex ) {
				index = 0;
			}
			if ( index < 0 ) {
				index = lastTabIndex;
			}
			return index;
		}

		while ( $.inArray( constrain(), this.options.disabled ) !== -1 ) {
			index = goingForward ? index + 1 : index - 1;
		}

		return index;
	},

	_focusNextTab: function( index, goingForward ) {
		index = this._findNextTab( index, goingForward );
		this.tabs.eq( index ).trigger( "focus" );
		return index;
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {

			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		this._super( key, value );

		if ( key === "collapsible" ) {
			this._toggleClass( "ui-tabs-collapsible", null, value );

			// Setting collapsible: false while collapsed; open first panel
			if ( !value && this.options.active === false ) {
				this._activate( 0 );
			}
		}

		if ( key === "event" ) {
			this._setupEvents( value );
		}

		if ( key === "heightStyle" ) {
			this._setupHeightStyle( value );
		}
	},

	refresh: function() {
		var options = this.options,
			lis = this.tablist.children( ":has(a[href])" );

		// Get disabled tabs from class attribute from HTML
		// this will get converted to a boolean if needed in _refresh()
		options.disabled = $.map( lis.filter( ".ui-state-disabled" ), function( tab ) {
			return lis.index( tab );
		} );

		this._processTabs();

		// Was collapsed or no tabs
		if ( options.active === false || !this.anchors.length ) {
			options.active = false;
			this.active = $();

		// was active, but active tab is gone
		} else if ( this.active.length && !$.contains( this.tablist[ 0 ], this.active[ 0 ] ) ) {

			// all remaining tabs are disabled
			if ( this.tabs.length === options.disabled.length ) {
				options.active = false;
				this.active = $();

			// activate previous tab
			} else {
				this._activate( this._findNextTab( Math.max( 0, options.active - 1 ), false ) );
			}

		// was active, active tab still exists
		} else {

			// make sure active index is correct
			options.active = this.tabs.index( this.active );
		}

		this._refresh();
	},

	_refresh: function() {
		this._setOptionDisabled( this.options.disabled );
		this._setupEvents( this.options.event );
		this._setupHeightStyle( this.options.heightStyle );

		this.tabs.not( this.active ).attr( {
			"aria-selected": "false",
			"aria-expanded": "false",
			tabIndex: -1
		} );
		this.panels.not( this._getPanelForTab( this.active ) )
			.hide()
			.attr( {
				"aria-hidden": "true"
			} );

		// Make sure one tab is in the tab order
		if ( !this.active.length ) {
			this.tabs.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active
				.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} );
			this._addClass( this.active, "ui-tabs-active", "ui-state-active" );
			this._getPanelForTab( this.active )
				.show()
				.attr( {
					"aria-hidden": "false"
				} );
		}
	},

	_processTabs: function() {
		var that = this,
			prevTabs = this.tabs,
			prevAnchors = this.anchors,
			prevPanels = this.panels;

		this.tablist = this._getList().attr( "role", "tablist" );
		this._addClass( this.tablist, "ui-tabs-nav",
			"ui-helper-reset ui-helper-clearfix ui-widget-header" );

		// Prevent users from focusing disabled tabs via click
		this.tablist
			.on( "mousedown" + this.eventNamespace, "> li", function( event ) {
				if ( $( this ).is( ".ui-state-disabled" ) ) {
					event.preventDefault();
				}
			} );

		this.tabs = this.tablist.find( "> li:has(a[href])" )
			.attr( {
				role: "tab",
				tabIndex: -1
			} );
		this._addClass( this.tabs, "ui-tabs-tab", "ui-state-default" );

		this.anchors = this.tabs.map( function() {
			return $( "a", this )[ 0 ];
		} )
			.attr( {
				tabIndex: -1
			} );
		this._addClass( this.anchors, "ui-tabs-anchor" );

		this.panels = $();

		this.anchors.each( function( i, anchor ) {
			var selector, panel, panelId,
				anchorId = $( anchor ).uniqueId().attr( "id" ),
				tab = $( anchor ).closest( "li" ),
				originalAriaControls = tab.attr( "aria-controls" );

			// Inline tab
			if ( that._isLocal( anchor ) ) {

				// The "scrolling to a fragment" section of the HTML spec:
				// https://html.spec.whatwg.org/#scrolling-to-a-fragment
				// uses a concept of document's indicated part:
				// https://html.spec.whatwg.org/#the-indicated-part-of-the-document
				// Slightly below there's an algorithm to compute the indicated
				// part:
				// https://html.spec.whatwg.org/#the-indicated-part-of-the-document
				// First, the algorithm tries the hash as-is, without decoding.
				// Then, if one is not found, the same is attempted with a decoded
				// hash. Replicate this logic.
				selector = anchor.hash;
				panelId = selector.substring( 1 );
				panel = that.element.find( "#" + CSS.escape( panelId ) );
				if ( !panel.length ) {
					panelId = decodeURIComponent( panelId );
					panel = that.element.find( "#" + CSS.escape( panelId ) );
				}

			// remote tab
			} else {

				// If the tab doesn't already have aria-controls,
				// generate an id by using a throw-away element
				panelId = tab.attr( "aria-controls" ) || $( {} ).uniqueId()[ 0 ].id;
				selector = "#" + panelId;
				panel = that.element.find( selector );
				if ( !panel.length ) {
					panel = that._createPanel( panelId );
					panel.insertAfter( that.panels[ i - 1 ] || that.tablist );
				}
				panel.attr( "aria-live", "polite" );
			}

			if ( panel.length ) {
				that.panels = that.panels.add( panel );
			}
			if ( originalAriaControls ) {
				tab.data( "ui-tabs-aria-controls", originalAriaControls );
			}
			tab.attr( {
				"aria-controls": panelId,
				"aria-labelledby": anchorId
			} );
			panel.attr( "aria-labelledby", anchorId );
		} );

		this.panels.attr( "role", "tabpanel" );
		this._addClass( this.panels, "ui-tabs-panel", "ui-widget-content" );

		// Avoid memory leaks (#10056)
		if ( prevTabs ) {
			this._off( prevTabs.not( this.tabs ) );
			this._off( prevAnchors.not( this.anchors ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	// Allow overriding how to find the list for rare usage scenarios (#7715)
	_getList: function() {
		return this.tablist || this.element.find( "ol, ul" ).eq( 0 );
	},

	_createPanel: function( id ) {
		return $( "<div>" )
			.attr( "id", id )
			.data( "ui-tabs-destroy", true );
	},

	_setOptionDisabled: function( disabled ) {
		var currentItem, li, i;

		if ( Array.isArray( disabled ) ) {
			if ( !disabled.length ) {
				disabled = false;
			} else if ( disabled.length === this.anchors.length ) {
				disabled = true;
			}
		}

		// Disable tabs
		for ( i = 0; ( li = this.tabs[ i ] ); i++ ) {
			currentItem = $( li );
			if ( disabled === true || $.inArray( i, disabled ) !== -1 ) {
				currentItem.attr( "aria-disabled", "true" );
				this._addClass( currentItem, null, "ui-state-disabled" );
			} else {
				currentItem.removeAttr( "aria-disabled" );
				this._removeClass( currentItem, null, "ui-state-disabled" );
			}
		}

		this.options.disabled = disabled;

		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null,
			disabled === true );
	},

	_setupEvents: function( event ) {
		var events = {};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			} );
		}

		this._off( this.anchors.add( this.tabs ).add( this.panels ) );

		// Always prevent the default action, even when disabled
		this._on( true, this.anchors, {
			click: function( event ) {
				event.preventDefault();
			}
		} );
		this._on( this.anchors, events );
		this._on( this.tabs, { keydown: "_tabKeydown" } );
		this._on( this.panels, { keydown: "_panelKeydown" } );

		this._focusable( this.tabs );
		this._hoverable( this.tabs );
	},

	_setupHeightStyle: function( heightStyle ) {
		var maxHeight,
			parent = this.element.parent();

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			maxHeight -= this.element.outerHeight() - this.element.height();

			this.element.siblings( ":visible" ).each( function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			} );

			this.element.children().not( this.panels ).each( function() {
				maxHeight -= $( this ).outerHeight( true );
			} );

			this.panels.each( function() {
				$( this ).height( Math.max( 0, maxHeight -
					$( this ).innerHeight() + $( this ).height() ) );
			} )
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.panels.each( function() {
				maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
			} ).height( maxHeight );
		}
	},

	_eventHandler: function( event ) {
		var options = this.options,
			active = this.active,
			anchor = $( event.currentTarget ),
			tab = anchor.closest( "li" ),
			clickedIsActive = tab[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : this._getPanelForTab( tab ),
			toHide = !active.length ? $() : this._getPanelForTab( active ),
			eventData = {
				oldTab: active,
				oldPanel: toHide,
				newTab: collapsing ? $() : tab,
				newPanel: toShow
			};

		event.preventDefault();

		if ( tab.hasClass( "ui-state-disabled" ) ||

				// tab is already loading
				tab.hasClass( "ui-tabs-loading" ) ||

				// can't switch durning an animation
				this.running ||

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.tabs.index( tab );

		this.active = clickedIsActive ? $() : tab;
		if ( this.xhr ) {
			this.xhr.abort();
		}

		if ( !toHide.length && !toShow.length ) {
			$.error( "jQuery UI Tabs: Mismatching fragment identifier." );
		}

		if ( toShow.length ) {
			this.load( this.tabs.index( tab ), event );
		}
		this._toggle( event, eventData );
	},

	// Handles show/hide for selecting tabs
	_toggle: function( event, eventData ) {
		var that = this,
			toShow = eventData.newPanel,
			toHide = eventData.oldPanel;

		this.running = true;

		function complete() {
			that.running = false;
			that._trigger( "activate", event, eventData );
		}

		function show() {
			that._addClass( eventData.newTab.closest( "li" ), "ui-tabs-active", "ui-state-active" );

			if ( toShow.length && that.options.show ) {
				that._show( toShow, that.options.show, complete );
			} else {
				toShow.show();
				complete();
			}
		}

		// Start out by hiding, then showing, then completing
		if ( toHide.length && this.options.hide ) {
			this._hide( toHide, this.options.hide, function() {
				that._removeClass( eventData.oldTab.closest( "li" ),
					"ui-tabs-active", "ui-state-active" );
				show();
			} );
		} else {
			this._removeClass( eventData.oldTab.closest( "li" ),
				"ui-tabs-active", "ui-state-active" );
			toHide.hide();
			show();
		}

		toHide.attr( "aria-hidden", "true" );
		eventData.oldTab.attr( {
			"aria-selected": "false",
			"aria-expanded": "false"
		} );

		// If we're switching tabs, remove the old tab from the tab order.
		// If we're opening from collapsed state, remove the previous tab from the tab order.
		// If we're collapsing, then keep the collapsing tab in the tab order.
		if ( toShow.length && toHide.length ) {
			eventData.oldTab.attr( "tabIndex", -1 );
		} else if ( toShow.length ) {
			this.tabs.filter( function() {
				return $( this ).attr( "tabIndex" ) === 0;
			} )
				.attr( "tabIndex", -1 );
		}

		toShow.attr( "aria-hidden", "false" );
		eventData.newTab.attr( {
			"aria-selected": "true",
			"aria-expanded": "true",
			tabIndex: 0
		} );
	},

	_activate: function( index ) {
		var anchor,
			active = this._findActive( index );

		// Trying to activate the already active panel
		if ( active[ 0 ] === this.active[ 0 ] ) {
			return;
		}

		// Trying to collapse, simulate a click on the current active header
		if ( !active.length ) {
			active = this.active;
		}

		anchor = active.find( ".ui-tabs-anchor" )[ 0 ];
		this._eventHandler( {
			target: anchor,
			currentTarget: anchor,
			preventDefault: $.noop
		} );
	},

	_findActive: function( index ) {
		return index === false ? $() : this.tabs.eq( index );
	},

	_getIndex: function( index ) {

		// meta-function to give users option to provide a href string instead of a numerical index.
		if ( typeof index === "string" ) {
			index = this.anchors.index( this.anchors.filter( "[href$='" +
				CSS.escape( index ) + "']" ) );
		}

		return index;
	},

	_destroy: function() {
		if ( this.xhr ) {
			this.xhr.abort();
		}

		this.tablist
			.removeAttr( "role" )
			.off( this.eventNamespace );

		this.anchors
			.removeAttr( "role tabIndex" )
			.removeUniqueId();

		this.tabs.add( this.panels ).each( function() {
			if ( $.data( this, "ui-tabs-destroy" ) ) {
				$( this ).remove();
			} else {
				$( this ).removeAttr( "role tabIndex " +
					"aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded" );
			}
		} );

		this.tabs.each( function() {
			var li = $( this ),
				prev = li.data( "ui-tabs-aria-controls" );
			if ( prev ) {
				li
					.attr( "aria-controls", prev )
					.removeData( "ui-tabs-aria-controls" );
			} else {
				li.removeAttr( "aria-controls" );
			}
		} );

		this.panels.show();

		if ( this.options.heightStyle !== "content" ) {
			this.panels.css( "height", "" );
		}
	},

	enable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === false ) {
			return;
		}

		if ( index === undefined ) {
			disabled = false;
		} else {
			index = this._getIndex( index );
			if ( Array.isArray( disabled ) ) {
				disabled = $.map( disabled, function( num ) {
					return num !== index ? num : null;
				} );
			} else {
				disabled = $.map( this.tabs, function( li, num ) {
					return num !== index ? num : null;
				} );
			}
		}
		this._setOptionDisabled( disabled );
	},

	disable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === true ) {
			return;
		}

		if ( index === undefined ) {
			disabled = true;
		} else {
			index = this._getIndex( index );
			if ( $.inArray( index, disabled ) !== -1 ) {
				return;
			}
			if ( Array.isArray( disabled ) ) {
				disabled = $.merge( [ index ], disabled ).sort();
			} else {
				disabled = [ index ];
			}
		}
		this._setOptionDisabled( disabled );
	},

	load: function( index, event ) {
		index = this._getIndex( index );
		var that = this,
			tab = this.tabs.eq( index ),
			anchor = tab.find( ".ui-tabs-anchor" ),
			panel = this._getPanelForTab( tab ),
			eventData = {
				tab: tab,
				panel: panel
			},
			complete = function( jqXHR, status ) {
				if ( status === "abort" ) {
					that.panels.stop( false, true );
				}

				that._removeClass( tab, "ui-tabs-loading" );
				panel.removeAttr( "aria-busy" );

				if ( jqXHR === that.xhr ) {
					delete that.xhr;
				}
			};

		// Not remote
		if ( this._isLocal( anchor[ 0 ] ) ) {
			return;
		}

		this.xhr = $.ajax( this._ajaxSettings( anchor, event, eventData ) );

		if ( this.xhr.statusText !== "canceled" ) {
			this._addClass( tab, "ui-tabs-loading" );
			panel.attr( "aria-busy", "true" );

			this.xhr
				.done( function( response, status, jqXHR ) {
					panel.html( response );
					that._trigger( "load", event, eventData );

					complete( jqXHR, status );
				} )
				.fail( function( jqXHR, status ) {
					complete( jqXHR, status );
				} );
		}
	},

	_ajaxSettings: function( anchor, event, eventData ) {
		var that = this;
		return {
			url: anchor.attr( "href" ),
			beforeSend: function( jqXHR, settings ) {
				return that._trigger( "beforeLoad", event,
					$.extend( { jqXHR: jqXHR, ajaxSettings: settings }, eventData ) );
			}
		};
	},

	_getPanelForTab: function( tab ) {
		var id = $( tab ).attr( "aria-controls" );
		return this.element.find( "#" + CSS.escape( id ) );
	}
} );

// DEPRECATED
// TODO: Switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat === true ) {

	// Backcompat for ui-tab class (now ui-tabs-tab)
	$.widget( "ui.tabs", $.ui.tabs, {
		_processTabs: function() {
			this._superApply( arguments );
			this._addClass( this.tabs, "ui-tab" );
		}
	} );
}

var widgetsTabs = $.ui.tabs;


/*!
 * jQuery UI Tooltip 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Tooltip
//>>group: Widgets
//>>description: Shows additional information for any element on hover or focus.
//>>docs: https://api.jqueryui.com/tooltip/
//>>demos: https://jqueryui.com/tooltip/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/tooltip.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.tooltip", {
	version: "1.14.2",
	options: {
		classes: {
			"ui-tooltip": "ui-corner-all ui-widget-shadow"
		},
		content: function() {
			var title = $( this ).attr( "title" );

			// Escape title, since we're going from an attribute to raw HTML
			return $( "<a>" ).text( title ).html();
		},
		hide: true,

		// Disabled elements have inconsistent behavior across browsers (#8661)
		items: "[title]:not([disabled])",
		position: {
			my: "left top+15",
			at: "left bottom",
			collision: "flipfit flip"
		},
		show: true,
		track: false,

		// Callbacks
		close: null,
		open: null
	},

	_addDescribedBy: function( elem, id ) {
		var describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ );
		describedby.push( id );
		elem
			.data( "ui-tooltip-id", id )
			.attr( "aria-describedby", String.prototype.trim.call( describedby.join( " " ) ) );
	},

	_removeDescribedBy: function( elem ) {
		var id = elem.data( "ui-tooltip-id" ),
			describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ ),
			index = $.inArray( id, describedby );

		if ( index !== -1 ) {
			describedby.splice( index, 1 );
		}

		elem.removeData( "ui-tooltip-id" );
		describedby = String.prototype.trim.call( describedby.join( " " ) );
		if ( describedby ) {
			elem.attr( "aria-describedby", describedby );
		} else {
			elem.removeAttr( "aria-describedby" );
		}
	},

	_create: function() {
		this._on( {
			mouseover: "open",
			focusin: "open"
		} );

		// IDs of generated tooltips, needed for destroy
		this.tooltips = {};

		// IDs of parent tooltips where we removed the title attribute
		this.parents = {};

		// Append the aria-live region so tooltips announce correctly
		this.liveRegion = $( "<div>" )
			.attr( {
				role: "log",
				"aria-live": "assertive",
				"aria-relevant": "additions"
			} )
			.appendTo( this.document[ 0 ].body );
		this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

		this.disabledTitles = $( [] );
	},

	_setOption: function( key, value ) {
		var that = this;

		this._super( key, value );

		if ( key === "content" ) {
			$.each( this.tooltips, function( id, tooltipData ) {
				that._updateContent( tooltipData.element );
			} );
		}
	},

	_setOptionDisabled: function( value ) {
		this[ value ? "_disable" : "_enable" ]();
	},

	_disable: function() {
		var that = this;

		// Close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {
			var event = $.Event( "blur" );
			event.target = event.currentTarget = tooltipData.element[ 0 ];
			that.close( event, true );
		} );

		// Remove title attributes to prevent native tooltips
		this.disabledTitles = this.disabledTitles.add(
			this.element.find( this.options.items ).addBack()
				.filter( function() {
					var element = $( this );
					if ( element.is( "[title]" ) ) {
						return element
							.data( "ui-tooltip-title", element.attr( "title" ) )
							.removeAttr( "title" );
					}
				} )
		);
	},

	_enable: function() {

		// restore title attributes
		this.disabledTitles.each( function() {
			var element = $( this );
			if ( element.data( "ui-tooltip-title" ) ) {
				element.attr( "title", element.data( "ui-tooltip-title" ) );
			}
		} );
		this.disabledTitles = $( [] );
	},

	open: function( event ) {
		var that = this,
			target = $( event ? event.target : this.element )

				// we need closest here due to mouseover bubbling,
				// but always pointing at the same event target
				.closest( this.options.items );

		// No element to show a tooltip for or the tooltip is already open
		if ( !target.length || target.data( "ui-tooltip-id" ) ) {
			return;
		}

		if ( target.attr( "title" ) ) {
			target.data( "ui-tooltip-title", target.attr( "title" ) );
		}

		target.data( "ui-tooltip-open", true );

		// Kill parent tooltips, custom or native, for hover
		if ( event && event.type === "mouseover" ) {
			target.parents().each( function() {
				var parent = $( this ),
					blurEvent;
				if ( parent.data( "ui-tooltip-open" ) ) {
					blurEvent = $.Event( "blur" );
					blurEvent.target = blurEvent.currentTarget = this;
					that.close( blurEvent, true );
				}
				if ( parent.attr( "title" ) ) {
					parent.uniqueId();
					that.parents[ this.id ] = {
						element: this,
						title: parent.attr( "title" )
					};
					parent.attr( "title", "" );
				}
			} );
		}

		this._registerCloseHandlers( event, target );
		this._updateContent( target, event );
	},

	_updateContent: function( target, event ) {
		var content,
			contentOption = this.options.content,
			that = this,
			eventType = event ? event.type : null;

		if ( typeof contentOption === "string" || contentOption.nodeType ||
				contentOption.jquery ) {
			return this._open( event, target, contentOption );
		}

		content = contentOption.call( target[ 0 ], function( response ) {

			// Ignore async response if tooltip was closed already
			if ( !target.data( "ui-tooltip-open" ) ) {
				return;
			}

			// JQuery creates a special event for focusin when it doesn't
			// exist natively. To improve performance, the native event
			// object is reused and the type is changed. Therefore, we can't
			// rely on the type being correct after the event finished
			// bubbling, so we set it back to the previous value. (#8740)
			if ( event ) {
				event.type = eventType;
			}
			that._open( event, target, response );
		} );
		if ( content ) {
			this._open( event, target, content );
		}
	},

	_open: function( event, target, content ) {
		var tooltipData, tooltip, delayedShow, a11yContent,
			positionOption = $.extend( {}, this.options.position );

		if ( !content ) {
			return;
		}

		// Content can be updated multiple times. If the tooltip already
		// exists, then just update the content and bail.
		tooltipData = this._find( target );
		if ( tooltipData ) {
			tooltipData.tooltip.find( ".ui-tooltip-content" ).html( content );
			return;
		}

		// If we have a title, clear it to prevent the native tooltip
		// we have to check first to avoid defining a title if none exists
		// (we don't want to cause an element to start matching [title])
		//
		// We use removeAttr only for key events, to allow IE to export the correct
		// accessible attributes. For mouse events, set to empty string to avoid
		// native tooltip showing up (happens only when removing inside mouseover).
		if ( target.is( "[title]" ) ) {
			if ( event && event.type === "mouseover" ) {
				target.attr( "title", "" );
			} else {
				target.removeAttr( "title" );
			}
		}

		tooltipData = this._tooltip( target );
		tooltip = tooltipData.tooltip;
		this._addDescribedBy( target, tooltip.attr( "id" ) );
		tooltip.find( ".ui-tooltip-content" ).html( content );

		// Support: Voiceover on OS X, JAWS on IE <= 9
		// JAWS announces deletions even when aria-relevant="additions"
		// Voiceover will sometimes re-read the entire log region's contents from the beginning
		this.liveRegion.children().hide();
		a11yContent = $( "<div>" ).html( tooltip.find( ".ui-tooltip-content" ).html() );
		a11yContent.removeAttr( "name" ).find( "[name]" ).removeAttr( "name" );
		a11yContent.removeAttr( "id" ).find( "[id]" ).removeAttr( "id" );
		a11yContent.appendTo( this.liveRegion );

		function position( event ) {
			positionOption.of = event;
			if ( tooltip.is( ":hidden" ) ) {
				return;
			}
			tooltip.position( positionOption );
		}
		if ( this.options.track && event && /^mouse/.test( event.type ) ) {
			this._on( this.document, {
				mousemove: position
			} );

			// trigger once to override element-relative positioning
			position( event );
		} else {
			tooltip.position( $.extend( {
				of: target
			}, this.options.position ) );
		}

		tooltip.hide();

		this._show( tooltip, this.options.show );

		// Handle tracking tooltips that are shown with a delay (#8644). As soon
		// as the tooltip is visible, position the tooltip using the most recent
		// event.
		// Adds the check to add the timers only when both delay and track options are set (#14682)
		if ( this.options.track && this.options.show && this.options.show.delay ) {
			delayedShow = this.delayedShow = setInterval( function() {
				if ( tooltip.is( ":visible" ) ) {
					position( positionOption.of );
					clearInterval( delayedShow );
				}
			}, 13 );
		}

		this._trigger( "open", event, { tooltip: tooltip } );
	},

	_registerCloseHandlers: function( event, target ) {
		var events = {
			keyup: function( event ) {
				if ( event.keyCode === $.ui.keyCode.ESCAPE ) {
					var fakeEvent = $.Event( event );
					fakeEvent.currentTarget = target[ 0 ];
					this.close( fakeEvent, true );
				}
			}
		};

		// Only bind remove handler for delegated targets. Non-delegated
		// tooltips will handle this in destroy.
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			events.remove = function() {
				var targetElement = this._find( target );
				if ( targetElement ) {
					this._removeTooltip( targetElement.tooltip );
				}
			};
		}

		if ( !event || event.type === "mouseover" ) {
			events.mouseleave = "close";
		}
		if ( !event || event.type === "focusin" ) {
			events.focusout = "close";
		}
		this._on( true, target, events );
	},

	close: function( event ) {
		var tooltip,
			that = this,
			target = $( event ? event.currentTarget : this.element ),
			tooltipData = this._find( target );

		// The tooltip may already be closed
		if ( !tooltipData ) {

			// We set ui-tooltip-open immediately upon open (in open()), but only set the
			// additional data once there's actually content to show (in _open()). So even if the
			// tooltip doesn't have full data, we always remove ui-tooltip-open in case we're in
			// the period between open() and _open().
			target.removeData( "ui-tooltip-open" );
			return;
		}

		tooltip = tooltipData.tooltip;

		// Disabling closes the tooltip, so we need to track when we're closing
		// to avoid an infinite loop in case the tooltip becomes disabled on close
		if ( tooltipData.closing ) {
			return;
		}

		// Clear the interval for delayed tracking tooltips
		clearInterval( this.delayedShow );

		// Only set title if we had one before (see comment in _open())
		// If the title attribute has changed since open(), don't restore
		if ( target.data( "ui-tooltip-title" ) && !target.attr( "title" ) ) {
			target.attr( "title", target.data( "ui-tooltip-title" ) );
		}

		this._removeDescribedBy( target );

		tooltipData.hiding = true;
		tooltip.stop( true );
		this._hide( tooltip, this.options.hide, function() {
			that._removeTooltip( $( this ) );
		} );

		target.removeData( "ui-tooltip-open" );
		this._off( target, "mouseleave focusout keyup" );

		// Remove 'remove' binding only on delegated targets
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			this._off( target, "remove" );
		}
		this._off( this.document, "mousemove" );

		if ( event && event.type === "mouseleave" ) {
			$.each( this.parents, function( id, parent ) {
				$( parent.element ).attr( "title", parent.title );
				delete that.parents[ id ];
			} );
		}

		tooltipData.closing = true;
		this._trigger( "close", event, { tooltip: tooltip } );
		if ( !tooltipData.hiding ) {
			tooltipData.closing = false;
		}
	},

	_tooltip: function( element ) {
		var tooltip = $( "<div>" ).attr( "role", "tooltip" ),
			content = $( "<div>" ).appendTo( tooltip ),
			id = tooltip.uniqueId().attr( "id" );

		this._addClass( content, "ui-tooltip-content" );
		this._addClass( tooltip, "ui-tooltip", "ui-widget ui-widget-content" );

		tooltip.appendTo( this._appendTo( element ) );

		return this.tooltips[ id ] = {
			element: element,
			tooltip: tooltip
		};
	},

	_find: function( target ) {
		var id = target.data( "ui-tooltip-id" );
		return id ? this.tooltips[ id ] : null;
	},

	_removeTooltip: function( tooltip ) {

		// Clear the interval for delayed tracking tooltips
		clearInterval( this.delayedShow );

		tooltip.remove();
		delete this.tooltips[ tooltip.attr( "id" ) ];
	},

	_appendTo: function( target ) {
		var element = target.closest( ".ui-front, dialog" );

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_destroy: function() {
		var that = this;

		// Close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {

			// Delegate to close method to handle common cleanup
			var event = $.Event( "blur" ),
				element = tooltipData.element;
			event.target = event.currentTarget = element[ 0 ];
			that.close( event, true );

			// Remove immediately; destroying an open tooltip doesn't use the
			// hide animation
			$( "#" + id ).remove();

			// Restore the title
			if ( element.data( "ui-tooltip-title" ) ) {

				// If the title attribute has changed since open(), don't restore
				if ( !element.attr( "title" ) ) {
					element.attr( "title", element.data( "ui-tooltip-title" ) );
				}
				element.removeData( "ui-tooltip-title" );
			}
		} );
		this.liveRegion.remove();
	}
} );

// DEPRECATED
// TODO: Switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat === true ) {

	// Backcompat for tooltipClass option
	$.widget( "ui.tooltip", $.ui.tooltip, {
		options: {
			tooltipClass: null
		},
		_tooltip: function() {
			var tooltipData = this._superApply( arguments );
			if ( this.options.tooltipClass ) {
				tooltipData.tooltip.addClass( this.options.tooltipClass );
			}
			return tooltipData;
		}
	} );
}

var widgetsTooltip = $.ui.tooltip;




} );var ContextPath								= "";
var IsDebug									= "N";
//var complete_starup						= "N";

var SystemFontStyle 						= 'font-family:arial;font-size:12px;font-weight:500;color:blue;';
var SystemFontStyle_black_600_italic 		= 'font-family:arial;font-size:12px;font-weight:600;color:black;font-style:italic;';
var SystemFontStyle_white_600_italic 		= 'font-family:arial;font-size:12px;font-weight:600;color:white;font-style:italic;';

var MousePosX 								= 0;
var MousePosY 								= 0;

var MousePosX_lastDown_event 				= 0;
var MousePosY_lastDown_event 				= 0;


var MouseClientPosX 						= 0;
var MouseClientPosY 						= 0;


var LengthConversionRatioMMtoPX				= 0;
var MovingElement							= null;

var MovingTHintoTABLE_THId					= null;//The source TH (and relative column) Index position to be moved
var MovingTHintoTABLE_THIndex				= -99; //The source TH (and relative column) Index position to be moved

var MovingTHintoTABLEId						= null;//The source TH DOM id to be moved
var MovingTHintoTABLEElement				= null;//The source TH DOM element to be moved
var MovingTHintoTABLE_click_start_x			= null;//The source TH DOM id to be moved

var MovingTHintoTABLETargetIndex			= -99; //The Target Index position where the source column has to be released
var MovingTHintoTABLETargetId				= null;//The Target DOM id where the source column has to be released
var MovingTHintoTABLETargetElement			= null;//The Target Index position where the source column has to be released. The place of this element will be taken from the source one

var MovingTABLELMIdentifier					= null;

var myDropzone								= null;
//var zoom 									= 1;
var CursorTickness							= 8;

var general_uname 							= null;

var exitCounter								= 0;

var Active_Slider_H							= null;
var Active_Slider_V							= null;
var Active_Slider_TABLE						= null;

//var viewer 									= null;JsChartViewer.get('<%=viewer.getId()%>');
var t_last_wheel_event    					= 0;
var t_last_mouse_movement					= 0;
var t_last_key_event    					= 0;

var SliderCursorDragging					= false;


var Window_innerWidth						= 0;
var Window_innerHeight						= 0;

var ContentMaxRight							= 0;
var ContentMaxBottom						= 0;
var ContentMinLeft							= 0;
var ContentMinTop						    = 0;

var lastMouseOverSW							= null;

var arrayToolTips							= [];

var arrayObjectJSEmbedded					= [];

var WaintingServer							= false;


var arrayScrolls							= [];

var MyZoomRatio								= 0;
var zoom_css_component						= 1;

var isWindowResizeAttached 					= false;

/////////////////////////////////////////////////////////////////////////////////////////

function addElementTo_arrayObjectJSEmbedded(methodnameIn)
{
	if (findElementIndexIn_arrayObjectJSEmbedded(methodnameIn) == -1)
	{
		arrayObjectJSEmbedded.push(methodnameIn);
	}
}

function findElementIndexIn_arrayObjectJSEmbedded(methodnameIn)
{
	var IndexOut = -1;
		if (arrayObjectJSEmbedded!=null)
		{
			if (arrayObjectJSEmbedded.length>0)
			{
				for(var i=0;i<arrayObjectJSEmbedded.length;++i)
				{
					if (arrayObjectJSEmbedded[i]==  methodnameIn)
					{
						IndexOut = i;
					}
				}
			}
		}
		return IndexOut;
}

function generateToolTipElement(ToolTipIDIn, ContentIn) 
{
										this.ToolTipID 							= ToolTipIDIn;
										this.Content 							= ContentIn;
}

function arrayToolTips_addElement(ToolTipIDIn, ContentIn)
{
	var 								MyElement 							= new generateToolTipElement(ToolTipIDIn, ContentIn)
										arrayToolTips.push(MyElement);
}

function arrayToolTips_getIndexByIdentifier(IdentifierIn)
{
									var IndexOut = -1;
										if (arrayToolTips!=null)
										{
											if (arrayToolTips.length>0)
											{
												for(var i=0;i<arrayToolTips.length;++i)
												{
													if (arrayToolTips[i].ToolTipID ==  IdentifierIn)
													{
														IndexOut = i;
													}
												}
											}
										}
										return IndexOut;
}

function arrayToolTips_getContentByIdentifier(IdentifierIn)
{
									var IndexElement	= arrayToolTips_getIndexByIdentifier(IdentifierIn);
									var StringOut 		= "";
										//alert(" arrayToolTips_getContentByIdentifier --- IdentifierIn : "+IdentifierIn+" IndexElement :"+IndexElement);
										if (IndexElement>-1)
										{
											StringOut 		= arrayToolTips[IndexElement].Content;
										}else
										{
											StringOut 		= null;
										}
										return StringOut;
}

function getValueByParName(StringIn,ParName)
{
	var ValueOut="NULL";
		try
		{
		var ParBlockStart                    	= StringIn.indexOf('!@@PP'+ParName+'@@!');
			if (ParBlockStart!=-1)
			{
			var ParBlockEnd                      = ParBlockStart+ParName.length+8;
			var UnderTestStringValue             = StringIn.substr(ParBlockEnd);
			var PositionValueStartL              = UnderTestStringValue.indexOf('!@@VV');
			var UnderTestStringValueContent      = UnderTestStringValue.substr(PositionValueStartL+5);
		
			var PositionValueStartR              = UnderTestStringValueContent.indexOf('@@!');
			var ValueString 					 = UnderTestStringValueContent.substring(0,PositionValueStartR);
				ValueOut						 = ValueString;
			}
		}catch(e)
		{
			return "NULL";
		}
		return ValueOut;
}

function setContextPath(ContextPathIn)
{
										ContextPath = ContextPathIn;
										//alert('Just got Context Path setup :'+ContextPath);
}

function showContextPath()
{
										alert('Context Path found :'+ContextPath);
}

function setScrollElement(ScrollIDIn, ScrollSubIDIn,leftIn, topIn,containerIDin,XCursorRaceIn,YCursorRaceIn,XCursorStartIn,YCursorStartIn,XContentIn,YContentIn,CursorElementIdIn)
{
						var				arrayScrollsi = retrieveScrollElementById(ScrollIDIn,ScrollSubIDIn);
										if (arrayScrollsi>=0)
										{
											arrayScrolls[arrayScrollsi].left = parseInt(leftIn);
											arrayScrolls[arrayScrollsi].top  = parseInt(topIn);
										}else
										{
											arrayScrolls.push(new generateScrollElement(ScrollIDIn, ScrollSubIDIn,leftIn, topIn,containerIDin,XCursorRaceIn,YCursorRaceIn,XCursorStartIn,YCursorStartIn,XContentIn,YContentIn,CursorElementIdIn));
										}
}

function generateScrollElement(ScrollIDIn, ScrollSubIDIn,leftIn, topIn,containerIDin,XCursorRaceIn,YCursorRaceIn,XCursorStartIn,YCursorStartIn,XContentIn,YContentIn,CursorElementIdIn) 
{
										this.ScrollID 								= ScrollIDIn;
										this.ScrollSubID 							= ScrollSubIDIn;
										this.left 									= leftIn;			//cursor left. Relative to its container. Current Position    
										this.top 									= topIn; 

										this.containerID 							= containerIDin;

										this.XCursorRace 							= XCursorRaceIn;	//space covered by cursor
										this.YCursorRace 							= YCursorRaceIn; 

										this.XCursorStart 							= XCursorStartIn; 	// relative to BODY
										this.YCursorStart 							= YCursorStartIn; 

										this.XContent 								= XContentIn;		// Content (e.g. table data). Cursor race must be greater than XCursorRace. Otherwise scroll cursor do not make sense at all.	
										this.YContent 								= YContentIn;

										this.CursorElementId						= CursorElementIdIn; 

	// Should be useful to add: % cursor position, CursorWidth
	//CursorWidth = XContent-CursorRace. If CursorRace==XContent then CursorWidtn = 0
}

function getPercentagePositionByCursorProgressive(ProgressiveIn,XYSelector)
{
	var									CursorPercentagePosition  = null;
										if (ProgressiveIn != null)
										{
											if ((ProgressiveIn>-1)&&(ProgressiveIn<arrayScrolls.length))
											{
											var XCursorWidth 			= parseInt(arrayScrolls[ProgressiveIn].XCursorRace/arrayScrolls[ProgressiveIn].XContent);
												CursorPercentagePosition 	= parseInt((arrayScrolls[ProgressiveIn].left/(arrayScrolls[ProgressiveIn].XCursorRace -XCursorWidth))/1000);
												return CursorPercentagePosition;
											}
										}
										return null;
}

function getCursorWidthByCursorProgressive(ProgressiveIn,XYSelector)
{
										if (ProgressiveIn != null)
										{//////////
											
											if ((ProgressiveIn>-1)&&(ProgressiveIn<arrayScrolls.length))
											{
											var XCursorWidth = parseInt((arrayScrolls[ProgressiveIn].XCursorRace*arrayScrolls[ProgressiveIn].XCursorRace)/arrayScrolls[ProgressiveIn].XContent);			
												return XCursorWidth;
											}
										}
										return null;
}

function getCursorHeightByCursorProgressive(ProgressiveIn,XYSelector)
{
										if (ProgressiveIn != null)
										{//////////
											if ((ProgressiveIn>-1)&&(ProgressiveIn<arrayScrolls.length))
											{
											var YCursorHeight = parseInt((arrayScrolls[ProgressiveIn].YCursorRace*arrayScrolls[ProgressiveIn].YCursorRace)/arrayScrolls[ProgressiveIn].YContent);			
												return YCursorHeight;
											}
										}
										return null;
}

function getCursorLeftByContentAreaScollLeftAndByArrayScrollsActive(ScrollLeftIn, ArrayScrollsActiveIn) {
	var MyXContent = arrayScrolls[ArrayScrollsActiveIn].XContent;
	var MyXRace = arrayScrolls[ArrayScrollsActiveIn].XCursorRace;
	var MyLeft = parseInt(ScrollLeftIn * MyXRace / MyXContent);
	return MyLeft;
}

/*
@params ArrayScrollsActiveIn: progressive of ArrayScrolls
@params ScrollTopIn: Scroll Top of frame (frame?)
 */
function getCursorTopByContentAreaScollTopAndByArrayScrollsActive(ScrollTopIn,ArrayScrollsActiveIn)
{
	var 								MyYContent 	= arrayScrolls[ArrayScrollsActiveIn].YContent;
	var 								MyYRace 	= arrayScrolls[ArrayScrollsActiveIn].YCursorRace;
	var 								MyTop		= parseInt(ScrollTopIn*MyYRace/MyYContent);
										return MyTop;
}

function ScrollElementAdjust_generic(ControlledDIVOuterDivIdIn,SliderPositionLeftIn,SliderPositionRightIn,SliderOrientation)
{
		//console_log("ScrollElementAdjust_generic adjusting element:"+ControlledDIVOuterDivIdIn);
		if (SliderOrientation=='overflow_H')
		{
			//positions the Content on the basis of the parameters
			// **Content Area Only**

			// really really strange, but seems to work
			// the function gets the outer (frame) DIV and applies to it the srollLeft JQUERY command
			// inner (ContentArea) DIV is relative and can't be scrolled....

		var arrayScrollActive 						= retrieveScrollElementById(ControlledDIVOuterDivIdIn,'overflow_H');
		var StringOut 								= " in arrayScrolls[arrayScrollActive].left : "+arrayScrolls[arrayScrollActive].left;

		var AdjustingScrollDIVElement 				= document.getElementById(ControlledDIVOuterDivIdIn);
			//$( AdjustingScrollDIVElement ).scrollLeft( parseInt(SliderPosition));
			//$('#debuggeroutput_content').html('arrayScrollActive : '+arrayScrollActive+'position : '+SliderPositionLeftIn+' starting point :'+arrayScrolls[arrayScrollActive].XCursorStart+' slider race : '+arrayScrolls[arrayScrollActive].XCursorRace+' content width :  '+arrayScrolls[arrayScrollActive].XContent+' ');

		//var SliderXPositionRel 						= (SliderPositionLeftIn-arrayScrolls[arrayScrollActive].XCursorStart);
		var SliderXPositionRel 						= arrayScrolls[arrayScrollActive].left;
			StringOut 							   += "SliderPositionLeftIn : "+SliderPositionLeftIn+" arrayScrolls[arrayScrollActive].XCursorStart : "+arrayScrolls[arrayScrollActive].XCursorStart;
		var SliderXFreeRace    						= arrayScrolls[arrayScrollActive].XCursorRace - (SliderPositionRightIn-SliderPositionLeftIn);
		var positionPercentage						= parseInt((SliderXPositionRel/SliderXFreeRace)*1000);
			StringOut							   +='<br> adjusting....SliderXFreeRace:'+SliderXFreeRace+'; XContent: '+arrayScrolls[arrayScrollActive].XContent+';Left: '+arrayScrolls[arrayScrollActive].left+';PositionPercectage :'+positionPercentage+'<br>';
		var ScrollXAmount 							= parseInt(positionPercentage/1000*(arrayScrolls[arrayScrollActive].XContent+3-arrayScrolls[arrayScrollActive].XCursorRace));	

			//lines added lather 2015 jan 26
			//var CursorWidth								= getCursorWidthByCursorProgressive(arrayScrollActive,'')+'px';
			//AdjustingScrollDIVElement.style.width 	= CursorWidth; 

			// following element is the content area to move

			//if (positionPercentage>1900) //patch....to check positionPercentage>900 case.....  
			if (positionPercentage>900) 
			{
				//$('#debuggeroutput_content').html('positionPercentage'+positionPercentage+' above treshold')
				$( AdjustingScrollDIVElement ).scrollLeft( parseInt(14000+50));
				//AdjustingScrollDIVElement:frame
			}else
			{
				//$('#debuggeroutput_content').html('positionPercentage'+positionPercentage+' under treshold')
				$( AdjustingScrollDIVElement ).scrollLeft( parseInt(ScrollXAmount));
				//AdjustingScrollDIVElement:frame
				//console_log("AdjustingScrollDIVElement.id:"+AdjustingScrollDIVElement.id+"   ScrollXAmount:"+ScrollXAmount);
			}
			//arrayScrolls[arrayScrollActive].left 		= parseInt(parseInt(ScrollXAmount));
			StringOut 								+= " in arrayScrolls[arrayScrollActive].left : "+arrayScrolls[arrayScrollActive].left;

			StringOut 								= "elem : "+AdjustingScrollDIVElement.id;

			//$('#debuggeroutput_content').html('positionPercentage :'+positionPercentage+' SliderXPositionRel:'+SliderXPositionRel+' scrollesft absolute value : '+parseInt(ScrollXAmount)+" arrayScrollLeft : "+arrayScrolls[arrayScrollActive].left+" hhhh:");
			//$('#debuggeroutput_content').html("adjust ..... "+StringOut);
			//	$('#debuggeroutput_content').html("nnnnnnnnnnnnnn:"+AdjustingScrollDIVElement.id+" parseInt(ScrollXAmount):"+parseInt(ScrollXAmount));
			//$('#debuggeroutput_content').html('positionPercentage :'+positionPercentage);

			//console_log("vvvvvvvvvvvvvvv "+StringOut+'positionPercentage :'+positionPercentage+' SliderXPositionRel:'+SliderXPositionRel+' scrollesft absolute value : '+parseInt(ScrollXAmount)+" arrayScrollLeft : "+arrayScrolls[arrayScrollActive].left+" hhhh:");

			//console_log("elem moved left :"+AdjustingScrollDIVElement.id+"<<  ");

		var container_scroll 					= $(AdjustingScrollDIVElement).closest('.IsSW')[0];
		var dummyEventScrollX					= new customEventGenerate('SCROLL_X');
			//console_log("bbb   "+AdjustingScrollDIVElement.id+" "+container_scroll.id);
		var owner_family 						= jQuery(container_scroll).attr("owner_family").replace('-','.');
			CAclient(container_scroll.id,AdjustingScrollDIVElement,dummyEventScrollX,owner_family,'#@@PPSCROLL_TYPE@@# #@@VVSCROLL_X@@#',false);
			//CAclient(container_scroll.id,AdjustingScrollDIVElement,dummyEventScrollX,owner_family,'',false);
		}
		if (SliderOrientation=='overflow_V')
		{
		var SliderPositionTopIn 	= SliderPositionLeftIn;
		var SliderPositionBottomIn 	= SliderPositionRightIn;

			//positions the Content on the basis of the parameters
			// **Content Area Only**
			// really really strange, but seems to work
			// the function gets the outer (frame) DIV and applies to it the srollLeft JQUERY command
			// In my opinion was the inner (ContentArea) DIV the object on witch apply the srollLeft JQUERY command

		var arrayScrollActive 						= retrieveScrollElementById(ControlledDIVOuterDivIdIn,'overflow_V');
		var StringOut 								= " in arrayScrolls[arrayScrollActive].top : "+arrayScrolls[arrayScrollActive].top;

		var AdjustingScrollDIVElement 				= document.getElementById(ControlledDIVOuterDivIdIn);
			//$( AdjustingScrollDIVElement ).scrollLeft( parseInt(SliderPosition));
			//$('#debuggeroutput_content').html('arrayScrollActive : '+arrayScrollActive+'position : '+SliderPositionLeftIn+' starting point :'+arrayScrolls[arrayScrollActive].XCursorStart+' slider race : '+arrayScrolls[arrayScrollActive].XCursorRace+' content width :  '+arrayScrolls[arrayScrollActive].XContent+' ');

			//var SliderXPositionRel 						= (SliderPositionLeftIn-arrayScrolls[arrayScrollActive].XCursorStart);
		var SliderYPositionRel 						= arrayScrolls[arrayScrollActive].top;
			StringOut 							   += "SliderPositionLeftIn : "+SliderPositionTopIn+" arrayScrolls[arrayScrollActive].YCursorStart : "+arrayScrolls[arrayScrollActive].YCursorStart;
		var SliderYFreeRace							= arrayScrolls[arrayScrollActive].YCursorRace - (SliderPositionBottomIn-SliderPositionTopIn);
		var positionPercentage						= parseInt((SliderYPositionRel/SliderYFreeRace)*1000);
			StringOut							   +='<br> adjusting....SliderYFreeRace:'+SliderYFreeRace+'; YContent: '+arrayScrolls[arrayScrollActive].YContent+';top: '+arrayScrolls[arrayScrollActive].top+';PositionPercectage :'+positionPercentage+'<br>';

		var ScrollYAmount 							= parseInt(positionPercentage/1000*(arrayScrolls[arrayScrollActive].YContent+3-arrayScrolls[arrayScrollActive].YCursorRace));	

			if (positionPercentage>900) {ScrollYAmount = ScrollYAmount+10;}

			//$('#debuggeroutput_content').html('positionPercentage :'+positionPercentage);

			//lines added lather 2015 jan 26
			//var CursorWidth								= getCursorWidthByCursorProgressive(arrayScrollActive,'')+'px';
			//	AdjustingScrollDIVElement.style.width 	= CursorWidth; 
			//console_log(" adjusting V ControlledDIVOuterDivIdIn:"+ControlledDIVOuterDivIdIn+"   value:"+parseInt(ScrollYAmount)+"  positionPercentage:"+positionPercentage);
			// following element is the content area to move

			//console_log(" adjusting V ....."+SliderYFreeRace+"  delta:"+(SliderPositionBottomIn-SliderPositionTopIn)+"  viewport: "+		    	$(window).height() )
			$( AdjustingScrollDIVElement ).scrollTop( parseInt(ScrollYAmount));
			//AdjustingScrollDIVElement:frame

			//arrayScrolls[arrayScrollActive].left 		= parseInt(parseInt(ScrollXAmount));
			StringOut 							   += " in arrayScrolls[arrayScrollActive].top : "+arrayScrolls[arrayScrollActive].top;

			StringOut 								= "elem moved top : "+AdjustingScrollDIVElement.id;

			//$('#debuggeroutput_content').html('positionPercentage :'+positionPercentage+' SliderYPositionRel:'+SliderYPositionRel+' slider position YFreeRace :'+SliderYFreeRace+' . arrayScrolls[arrayScrollActive].YCursorRace : '+arrayScrolls[arrayScrollActive].YCursorRace+' scrolTop absolute value : '+parseInt(ScrollYAmount)+" arrayScrollTop : "+arrayScrolls[arrayScrollActive].top);
			//$('#debuggeroutput_content').html("adjust ..... "+StringOut);

		var container_scroll 					= $(AdjustingScrollDIVElement).closest('.IsSW')[0];
		var dummyEventScrollY					= new customEventGenerate('SCROLL_Y');
		var owner_family 						= jQuery(container_scroll).attr("owner_family").replace('-','.');
			CAclient(container_scroll.id,AdjustingScrollDIVElement,dummyEventScrollY,owner_family,'#@@PPSCROLL_TYPE@@# #@@VVSCROLL_Y@@#',false);
			//CAclient(container_scroll.id,AdjustingScrollDIVElement,dummyEventScrollY,owner_family,'',false);
		}
}

function getCoords(event) 
{
		event = event || window.event;
		if (event.pageX || event.pageY) 
		{
			return {x: event.pageX, y: event.pageY};
		}else
		{
			return {x: event.clientX + document.body.scrollLeft - document.body.clientLeft, y: event.clientY + document.body.scrollTop  - document.body.clientTop};
		}
}

function getMouseClientCoords(event)
{
	event = event || window.event;
	return {x: event.clientX ,y: event.clientY}
}

function getTextStyleByName(StyleNameIn)
{
	if (StyleNameIn.toUpperCase()=='TITLE_GREY_ITALIC')
	{
		return "font-weight:bold;font-family:arial;font-size:14px;color:rgb(230,230,230);font-style:italic;";
	}
	if (StyleNameIn.toUpperCase()=='LMSYSTEMFONTSTYLE_REGULAR')
	{
		return "font-weight:600;font-family:arial;font-size:13px;color:rgb(255,250,250);";
	}
	if (StyleNameIn.toUpperCase()=='LMSYSTEMFONTSTYLE_WHITE')
	{
		return "font-weight:bold;font-family:arial;font-size:14px;color:rgb(255,250,250);";
	}
	if (StyleNameIn.toUpperCase()=='LMSYSTEMFONTSTYLE_BLACK')
	{
		return "font-weight:bold;font-family:arial;font-size:14px;color:black;";
	}
	if (StyleNameIn.toUpperCase()=='LMSYSTEMFONTSTYLE_646464')
	{
		return "font-weight:bold;font-family:arial;font-size:14px;color:rgb(64,64,64);";
	}
	if (StyleNameIn.toUpperCase()=='LMSYSTEMFONTSTYLE_BLACK_600')
	{
		return "font-weight:600;font-family:arial;font-size:14px;color:black;";
	}
	if (StyleNameIn.toUpperCase()=='SYSTEMFONTSTYLE')
	{
		return SystemFontStyle;
	}
	if (StyleNameIn.toUpperCase()=='SYSTEMFONTSTYLE_BLAK_600_ITALIC')
	{
		return SystemFontStyle_black_600_italic;
	}
	if (StyleNameIn.toUpperCase()=='SYSTEMFONTSTYLE_WHITE_600_ITALIC')
	{
		return SystemFontStyle_white_600_italic;
	}
	if (StyleNameIn.toUpperCase()=='TABLEHEADER')
	{
		return 'font-family:arial;font-size:14px;font-weight:700;color:black;font-style:italic;';
	}
	if (StyleNameIn.toUpperCase()=='TABLEHEADER_ITALIC')
	{
		return 'font-family:arial;font-size:14px;font-weight:700;color:black;font-style:italic;';
	}
	if (StyleNameIn.toUpperCase()=='TABLEHEADER_BIG')
	{
		return 'font-family:arial;font-size:16px;font-weight:700;color:black;';
	}
	if (StyleNameIn.toUpperCase()=='TABLEHEADER_BIG_WHITE')
	{
		return 'font-family:arial;font-size:14px;font-weight:600;color:black;';
	}
	if (StyleNameIn.toUpperCase()=='TABLECONTENT')
	{
		return 'font-family:arial;font-size:12px;font-weight:700;color:black;';
	}
	if (StyleNameIn.toUpperCase()=='TABLECONTENT_ITALIC')
	{
		return 'font-family:arial;font-size:12px;font-weight:700;color:black;font-style:italic;';
	}
}

function manageZoom____(zoomMessage)
{
	//deprecated
	alert(zoomMessage);
	if (zoomMessage=='in')
	{
		alert('in pushed');
		try
		{
			document.body.style.zoom *= 1.2;
			
		}catch(err)
		{
			alert('err'+err);
		}
	}
	if (zoomMessage == 'out')
	{
		alert('out pushed');
		try
		{
			document.body.style.zoom *= 1.8;
		}catch(err)
		{
			alert('err'+err);
		}
	}
}

function inputKeyFilter(parameterCall,e) 
{
	//alert('charin');
	var textfield = e;
		$('#debuggeroutput_content').html("premuto:"+textfield.value);

	var regex = /[^a-z0-9_-]/gi;
		if(textfield.value.search(regex) > -1) 
		{
			textfield.value = textfield.value.replace(regex, "");
		}
}

function ManageZoomChange()
{
/*								    var body_zoom = parseFloat(document.body.style.zoom)/100;
								      	if (isNaN(parseFloat(document.body.style.zoom))) {body_zoom=1;}
*/
							       		//console_log("xxx ffffffffffff:"+detectZoom.zoom()+"   body_zoom:"+body_zoom);
									var	MyZoomRatio								= detectZoom.zoom();
										jQuery('.float_helper_board_zoomvalue_user').text(parseInt(MyZoomRatio*100)+"%.");
										jQuery('.float_helper_board_zoomvalue_body').text(parseInt(zoom_css_component*100)+"%.");
										jQuery('.float_helper_board_zoomvalue_global').text(parseInt(zoom_css_component*MyZoomRatio*100)+"%.");
										
										jQuery('.zoomselector').find('td').each
										(
											function( i ) 
											{
												jQuery(this).removeClass('compliant');
												if 
												(
													(parseFloat(jQuery(this).attr('zoomval'))*1.05 > (zoom_css_component*MyZoomRatio))
													&& 
		   											(parseFloat(jQuery(this).attr('zoomval'))*0.95 < (zoom_css_component*MyZoomRatio))
	   											)
	   											{
													   jQuery(this).addClass('compliant');
												}
	  										}
  										);
 
										
										console_log("Zoom Change Managing.....:"+parseInt(MyZoomRatio*100));
										console_log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ ZOOM userpreset ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
										scrollManagement();
}

function waitersRunner_____(stage) 
{
	var interval = 750;
		elem = new Array();
		// alert('stage:'+stage);

		elem[1]=document.getElementById("waitElement1");
		elem[2]=document.getElementById("waitElement2");
		elem[3]=document.getElementById("waitElement3");
		elem[4]=document.getElementById("waitElement4");

		setTimeout("waitersRunner("+(stage+1)+")",interval);

	var i=1;
		for(i=1;i<=4;++i)
		{
			if (i==stage)
			{
				elem[i].style.visibility='visible';
			}else
			{
				elem[i].style.visibility='hidden';
			}
		}
	var nextstage;
		nextstage=stage+1;
		if (nextstage==5) nextstage=1;
	var waitersEl = document.getElementById('waitershield');
		if(waitersEl.style.visibility == 'visible')
		{
			setTimeout("waitersRunner("+(nextstage)+")",interval);
		}
//     elem.style.visibility='hidden';
}

function WaiterShield_1(FunctionCall)
{
	//alert('waiter shield'+FunctionCall);
	var WaiterShieldElement 	= document.getElementById('waitershield');
	var WaiterShieldElement_up  = document.getElementById('waitershield_up');
	if ( WaiterShieldElement == null)
	{
		//var waiterIMG_HTML = "<div style='position:absolute;border-radius:8px;margin:0;padding:0;border:0;left:0;right:0;top:0;bottom:0;border-color:lime;background-image:url(\"images/reloader.gif\");background-color:rgba(204,255,255,.7);background-repeat: no-repeat;background-position:center;'>ddddddddd</div>";
		//var waiterIMG_HTML = "<div style='position:absolute;margin:0;padding:0;border:0;left:0;right:0;top:0;bottom:0;background-color:red;'></div>";
		var waitershieldHTML  = 
			//"<div id = 'waitershield' style='z-index:101;position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(100,100,100,0.3);'>" +
				"<table id ='waitershield_innertable' border='1' height='100%' width='100%' style='z-index:101;'>"+
					"<tr >" +
						"<td height='47%' width='40%'></td><td width='20%'></td><td width='40%'></td>"+
					"</tr>"+
					"<tr >"+
						"<td ></td>"+
						"<td  id = 'waitershield_innerdiv_parent' height='6%' style='position:relative;margin:0;padding:0;border:3px solid red;text-align : center;' >"+
						//"<td height='6%' style ='position:relative;margin:0;padding:0;border:0;background-color:rgb(100,100,100);filter: alpha(opacity=.5); opacity:.5;'>"+
						"<div id = 'waitershield_innerdiv' style='position:absolute;border:none;left:0;top:0;height:100%;width:100%;background-color:steelblue;border-radius:8px;filter: alpha(opacity=50); opacity:.5; '>&nbsp;</div>"+
//						"<div id ='waiterh' style='position:absolute;top:0;border:2px solid orange;margin:0 auto;height:40px;width:200px;'> "+
						" 		<img id='waitershield_gif'  style='display:block;position:absolute;margin:0 auto;padding:0;border:2px solid blue;'> "+
						//"</div>"+

//						waiterIMG_HTML+
						"</td>"+
						"<td></td>"+
					"</tr>"+
					"<tr >" +
						"<td height='47%'></td><td></td><td></td>"+
					"</tr>"+
				"</table>";
			//"</div>";
			
		var shieldContainer 					= document.createElement('div');
			shieldContainer.setAttribute('id', 'waitershield');  //set id
			shieldContainer.style.zIndex			= "102" ;
			shieldContainer.style.position			= "fixed" ;
			shieldContainer.style.top	 			= "0" ;
			shieldContainer.style.left	 			= "0" ;
			shieldContainer.style.bottom 			= "0" ;
			shieldContainer.style.right  			= "0" ;
			//shieldContainer.style.border  			= "2px solid red" ;
			
			//shieldContainer.className				= "waitershieldcontainer";
			//shieldContainer.style.backgroundColor 	= "lightblue";
			shieldContainer.style.filter			= "alpha(opacity=0)";
			shieldContainer.style.opacity			= "0";
			shieldContainer.style.backgroundColor	= "white";//"rgb(250,250,250)";
			//shieldContainer.innerHTML 				= waitershieldHTML;
			
			document.body.appendChild(shieldContainer);
			
			WaiterShieldElement 					= document.getElementById('waitershield');
		var shieldContainer_up 						= document.createElement('div');
			shieldContainer_up.setAttribute('id', 'waitershield_up');  //set id
			shieldContainer_up.style.zIndex			= "101" ;
			shieldContainer_up.style.position		= "fixed" ;
			shieldContainer_up.style.top	 		= "0" ;
			shieldContainer_up.style.left	 		= "0" ;
			shieldContainer_up.style.bottom 		= "0" ;
			shieldContainer_up.style.right  		= "0" ;
			
			//shieldContainer.className				= "waitershieldcontainer";
			//shieldContainer.style.backgroundColor 	= "lightblue";
			//shieldContainer.style.filter			= "alpha(opacity=1)";
			//shieldContainer.style.opacity			= ".01";
			shieldContainer_up.innerHTML 				= waitershieldHTML;
			document.body.appendChild(shieldContainer_up);
			WaiterShieldElement_up 					= document.getElementById('waitershield_up');
		var waitershield_innertable_element 	= document.getElementById('waitershield_innertable');
		
			fill_parent(waitershield_innertable_element);
		
		//alert('tt');
		var WaiterShield_innerdiv 				= document.getElementById('waitershield_innerdiv');
			if (WaiterShield_innerdiv!=null)		{fill_parent(WaiterShield_innerdiv);}
		//fill_parent(WaiterShieldElement);		
		/*
		WaiterShieldElement_innerdiv 				= document.getElementById('waitershield_innerdiv');
		var WaiterShieldElement_HEIGHT 				= WaiterShieldElement.offsetHeight;
		var WaiterShieldElement_WIDTH 				= WaiterShieldElement.offsetWidth;
		var WaiterShieldElement_innerdiv_HEIGHT 	= WaiterShieldElement_innerdiv.offsetHeight;
		var WaiterShieldElement_innerdiv_WIDTH 		= WaiterShieldElement_innerdiv.offsetWidth;

		var innerdiv_PosX=0;
		var innerdiv_PosY=0;
		innerdiv_PosY = WaiterShieldElement_HEIGHT/2-WaiterShieldElement_innerdiv_HEIGHT/2;
		innerdiv_PosX = WaiterShieldElement_WIDTH/2-WaiterShieldElement_innerdiv_WIDTH/2;
		WaiterShieldElement_innerdiv.style.left = innerdiv_PosX+'px';
		WaiterShieldElement_innerdiv.style.top  = innerdiv_PosY+'px';
		alert('waiter shield id : '+WaiterShieldElement.id+ " posx: "+innerdiv_PosX+ " posy : "+innerdiv_PosY);*/
	}
	// at this point '#waitershield' element is always present in the HTML body
	if (typeof FunctionCall == 'undefined')
	{
		
	}else
	{
		if (FunctionCall=='show')
		{
			WaiterShieldElement.style.visibility 	= 'visible';
			WaiterShieldElement_up.style.visibility = 'visible';
			//var waitershield_gif 					= document.getElementById('waitershield_gif');
			fill_parent(document.getElementById("waitershield_innertable"));

			///centerElementInRelativeContainer(waitershield_gif);
		}
		if (FunctionCall=='hide')
		{
			WaiterShieldElement.style.visibility 	= 'hidden';
			WaiterShieldElement_up.style.visibility = 'hidden';
			//alert('hiding : '+WaiterShieldElement.id);
		}
	}
}

function WaiterShield(FunctionCall)
{
	//alert('waiter shield'+FunctionCall);
	var waitershield 												= document.getElementById('waitershield');
	var waitershield_up  											= document.getElementById('waitershield_up');

	var over_w														= 20;//shadower overhead w
	var over_h														= 8;//shadower overhead h
	
	var img_h 														= parseInt(93*0.6);
	var img_w 														= parseInt(512*0.6);

		if ( waitershield_up == null)
		{
							
								//var waiterIMG_HTML = "<div style='position:absolute;margin:0;padding:0;border:0;left:0;right:0;top:0;bottom:0;background-color:red;'></div>";
						//		var waitershieldHTML  = 
						//			//"<div id = 'waitershield' style='z-index:101;position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(100,100,100,0.3);'>" +
						//				"<table id ='waitershield_innertable' border='1' height='100%' width='100%' style='z-index:101;'>"+
						//					"<tr >" +
						//						"<td height='47%' width='40%'></td><td width='20%'></td><td width='40%'></td>"+
						//					"</tr>"+
						//					"<tr >"+
						//						"<td ></td>"+
						//						"<td  id = 'waitershield_innerdiv_parent' height='6%' style='position:relative;margin:0;padding:0;border:3px solid red;text-align : center;' >"+
						//						//"<td height='6%' style ='position:relative;margin:0;padding:0;border:0;background-color:rgb(100,100,100);filter: alpha(opacity=.5); opacity:.5;'>"+
						//						"<div id = 'waitershield_innerdiv' style='position:absolute;border:none;left:0;top:0;height:100%;width:100%;background-color:steelblue;border-radius:8px;filter: alpha(opacity=50); opacity:.5; '>&nbsp;</div>"+
						////						"<div id ='waiterh' style='position:absolute;top:0;border:2px solid orange;margin:0 auto;height:40px;width:200px;'> "+
						//						//"</div>"+
						//
						////						waiterIMG_HTML+
						//						"</td>"+
						//						"<td></td>"+
						//					"</tr>"+
						//					"<tr >" +
						//						"<td height='47%'></td><td></td><td></td>"+
						//					"</tr>"+
						//				"</table>";
						//			//"</div>";
									
		var waitershield 											= document.createElement('div');
			waitershield.setAttribute('id', 'waitershield');  //set id
			waitershield.style.zIndex								= "102" ;
			waitershield.style.position								= "fixed" ;
			waitershield.style.top	 								= "0" ;
			waitershield.style.left	 								= "0" ;
			waitershield.style.bottom 								= "0" ;
			waitershield.style.right  								= "0" ;
			//waitershield.style.border  								= "2px solid red" ;
		
			//waitershield.className				= "waiterwaitershield";
			//waitershield.style.backgroundColor 	= "lightblue";
			waitershield.style.filter								= "alpha(opacity=0)";
			waitershield.style.opacity								= "0";
			waitershield.style.backgroundColor						= "white";//"rgb(250,250,250)";
			//shieldContainer.innerHTML 				= waitershieldHTML;
			document.body.appendChild(waitershield);
			waitershield 											= document.getElementById('waitershield');
		
		var waitershield_up 										= document.createElement('div');
			waitershield_up.setAttribute('id', 'waitershield_up');  //set id
			waitershield_up.style.zIndex							= "101" ;
			waitershield_up.style.position							= "fixed" ;
			waitershield_up.style.top	 							= "0" ;
			waitershield_up.style.left	 							= "0" ;
			waitershield_up.style.bottom 							= "0" ;
			waitershield_up.style.right  							= "0" ;
			waitershield_up.style.border  							= "0" ;
			waitershield_up.style.margin  							= "0" ;
			waitershield_up.style.padding  							= "0" ;
			
			document.body.appendChild(waitershield_up);
				
			waitershield_up 					   					= document.getElementById('waitershield_up');

//		var waitershield_up_h										= waitershield_up.offsetHeight;		
//		var waitershield_up_w										= waitershield_up.offsetWidth;		

		var waitershield_up_relative_stub 							= document.createElement('div');
			waitershield_up_relative_stub.setAttribute('id', 'waitershield_up_relative_stub');  //set id
			waitershield_up_relative_stub.style.zIndex				= "101" ;
			waitershield_up_relative_stub.style.position			= "relative" ;
			waitershield_up_relative_stub.style.top	 				= "0" ;
			waitershield_up_relative_stub.style.left	 			= "0" ;
			//waitershield_up_relative_stub.style.height 				= waitershield_up_h+"px" ;
			//waitershield_up_relative_stub.style.width  				= waitershield_up_w+"px" ;
			waitershield_up_relative_stub.style.border	 			= "0" ;
			waitershield_up_relative_stub.style.margin	 			= "0" ;
			waitershield_up_relative_stub.style.padding	 			= "0" ;
			waitershield_up.appendChild(waitershield_up_relative_stub);
			
			//jQuery(waitershield_up_relative_stub).css('height','100%');
			//jQuery(waitershield_up_relative_stub).css('width','100%');
			//jQuery(waitershield_up_relative_stub).css('background-color','pink');

			waitershield_up_relative_stub.style.position			= "absolute" ;
			waitershield_up_relative_stub.style.right				= "0" ;
			waitershield_up_relative_stub.style.bottom				= "0" ;


		var waitershield_up_shadower 								= document.createElement('div');
			waitershield_up_shadower.setAttribute('id', 'waitershield_up_shadower');  //set id
			waitershield_up_shadower.style.zIndex					= "101" ;
			waitershield_up_shadower.style.position					= "absolute" ;
			//waitershield_up_shadower.style.top	 					= parseInt(waitershield_up_h/2-(img_h+over_h)/2+1)+"px" ;
			//waitershield_up_shadower.style.left	 					= parseInt(waitershield_up_w/2-(img_w+over_w)/2)+"px" ;
			waitershield_up_shadower.style.height 					= parseInt(img_h+over_h)+"px" ;
			waitershield_up_shadower.style.width  					= parseInt(img_w+over_w)+"px" ;
			waitershield_up_shadower.style.opacity					= 0.5;
			waitershield_up_shadower.style.backgroundColor			= "steelblue";
			waitershield_up_shadower.style.margin        			= "0";
			waitershield_up_shadower.style.border		        	= "0";
			waitershield_up_shadower.style.padding		        	= "0";
			waitershield_up_shadower.style.transform = 'translate(-50%, -50%)';
			waitershield_up_shadower.style.top = "50%";
			waitershield_up_shadower.style.left = "50%";

			//try{waitershield_up_shadower.style.borderRadius         = "10px";}catch(ex){}
			waitershield_up.appendChild(waitershield_up_shadower);


			$("#waitershield_up_shadower").css("border-radius","8px");
			$("#waitershield_up_shadower").css("opacity","0.5");
			$("#waitershield_up_shadower").css("filter","alpha(opacity=50)");

		var waitershield_up_img 									= document.createElement('img');
			waitershield_up_img.setAttribute('id', 'waitershield_up_img');  //set id
			waitershield_up_img.style.zIndex						= "101" ;
			waitershield_up_img.style.position						= "absolute" ;
			//waitershield_up_img.style.top	 						= (waitershield_up_h/2-img_h/2)+"px" ;
			//waitershield_up_img.style.left	 						= (waitershield_up_w/2-img_w/2)+"px" ;
			waitershield_up_img.style.height 						= img_h+"px" ;
			waitershield_up_img.style.width  						= img_w+"px" ;
			waitershield_up_img.style.border						= "0";
			waitershield_up_img.style.margin						= "0";
			waitershield_up_img.style.padding						= "0";
			waitershield_up_img.style.transform = 'translate(-50%, -50%)';
			waitershield_up_img.style.top = "50%";
			waitershield_up_img.style.left = "50%";
			waitershield_up_img.alt = 'waiter shield image';
			//waitershield_up_img.src									= "images/preloader_green.gif";
			waitershield_up.appendChild(waitershield_up_img);
			
		}
		
		// at this point '#waitershield' element is always present in the HTML body
		if ((typeof FunctionCall === "undefined")||(FunctionCall==null))
		{
			
		} else
		{
			if (FunctionCall=='show')
			{
			var body_h													= document.body.offsetHeight;			
			var body_w													= document.body.offsetWidth;
				
				waitershield.style.visibility 							= 'visible';
				waitershield.style.height								= body_h+"px";
				waitershield.style.width								= body_w+"px";
				
				waitershield_up.style.visibility 						= 'visible';
				waitershield_up.style.height							= body_h+"px";
				waitershield_up.style.width								= body_w+"px";
				
			var waitershield_up_relative_stub 					   		= document.getElementById('waitershield_up_relative_stub');
				waitershield_up_relative_stub.style.height				= body_h+"px";
				waitershield_up_relative_stub.style.width				= body_w+"px";
		
			//var waitershield_h										= waitershield.offsetHeight;		
			//var waitershield_w										= waitershield.offsetWidth;		
				
			var waitershield_up_img 					   				= document.getElementById('waitershield_up_img');
			var waitershield_up_img_h 					   				= waitershield_up_img.offsetHeight;
			var waitershield_up_img_w 					   				= waitershield_up_img.offsetWidth;
				///alert("IMG _H : "+waitershield_up_img_h);
	
			var waitershield_up_shadower 					   			= document.getElementById('waitershield_up_shadower');			
				waitershield_up_shadower.style.top						= parseInt(body_h/2-(waitershield_up_img_h+over_h)/2+1)+"px" ;
				waitershield_up_shadower.style.left						= parseInt(body_w/2-(waitershield_up_img_w+over_w)/2)+"px" ;
				waitershield_up_shadower.style.height					= parseInt(waitershield_up_img_h+over_h)+"px";
				waitershield_up_shadower.style.width					= parseInt(waitershield_up_img_w+over_w)+"px";
	
			var waitershield_up_img 					   				= document.getElementById('waitershield_up_img');			
				waitershield_up_img.style.top							= parseInt(body_h/2-(waitershield_up_img_h)/2+1)+"px" ;
				waitershield_up_img.style.left							= parseInt(body_w/2-(waitershield_up_img_w)/2)+"px" ;
	//			waitershield_up_img.style.height						= parseInt(waitershield_up_img_h+over_h)+"px";
	//			waitershield_up_img.style.width							= parseInt(waitershield_up_img_w+over_w)+"px";
				
				//var waitershield_gif 					= document.getElementById('waitershield_gif');
				//fill_parent(document.getElementById("waitershield_innertable"));
	
				///centerElementInRelativeContainer(waitershield_gif);
				if (jQuery(document.body).hasClass('hicontrast'))
				{
	
					jQuery('#waitershield_up_img').attr('src','images/bw_preloader.gif');
					jQuery('#waitershield_up_img').css('height','150px');
					jQuery('#waitershield_up_img').css('width','150px');
				var h = jQuery('#waitershield_up').height()-150;
				var w = jQuery('#waitershield_up').width()-150;
					jQuery('#waitershield_up_img').css('top',parseFloat(h/2)+'px');
					jQuery('#waitershield_up_img').css('left',parseFloat(w/2)+'px');
				} else
				{
					
					//jQuery('#waitershield_up_img').attr('src','images/blue_preloader.gif');
					//jQuery('#waitershield_up_img').css('height','40px');
					//jQuery('#waitershield_up_img').css('width','200px');
					
					jQuery('#waitershield_up_img').attr('src','images/preloader_green.gif');
					jQuery('#waitershield_up_img').css('height',img_h + 'px');
					jQuery('#waitershield_up_img').css('width' ,img_w + 'px');
	
				var h = jQuery('#waitershield_up').height()-img_h;
				var w = jQuery('#waitershield_up').width()-img_w;
					jQuery('#waitershield_up_img').css('top',parseFloat(h/2)+'px');
					jQuery('#waitershield_up_img').css('left',parseFloat(w/2)+'px');
					
					
				 	h = jQuery('#waitershield_up').height()-img_h-over_h;
				 	w = jQuery('#waitershield_up').width()-img_w-over_w;
					jQuery('#waitershield_up_shadower').css('top',parseFloat(h/2)+'px');
					jQuery('#waitershield_up_shadower').css('left',parseFloat(w/2)+'px');
					jQuery('#waitershield_up_shadower').css('height',(img_h+over_h)+'px');
					jQuery('#waitershield_up_shadower').css('width',(img_w+over_w)+'px');
					jQuery('#waitershield_up_shadower').css('background-color','white');
					jQuery('#waitershield_up_shadower').css('border','1px solid lightgreen');
				}
			} else
			if (FunctionCall=='hide')
			{
				//check if hide is allowed
				if (jQuery(document.body).attr('allow_waitershield_hide')=='Y')
				{
					waitershield.style.visibility 	 						= 'hidden';
					waitershield_up.style.visibility 						= 'hidden';
				}
			}
		}	
}

function CurrencyFormat_old(num)
{
		//num = num.toString().replace(/\$|\,/g,'');
		var newstring="";
		var i = 0;
		var commanumber=0;
		for (i=0;i<num.length;i++)
		{
			if ((num.substring(i,i+1)==",")||(num.substring(i,i+1)=="1")||(num.substring(i,i+1)=="2")||(num.substring(i,i+1)=="3")||(num.substring(i,i+1)=="4")||(num.substring(i,i+1)=="5")||(num.substring(i,i+1)=="6")||(num.substring(i,i+1)=="7")||(num.substring(i,i+1)=="8")||(num.substring(i,i+1)=="9")||(num.substring(i,i+1)=="0"))
			 newstring=newstring+num.substring(i,i+1);
			if (num.substring(i,i+1)==",") commanumber = commanumber +1;
		}
		if (commanumber > 1) newstring = "";
		num = newstring;
		num = num.toString().replace(/\,/g,'.');
		if(isNaN(num)) num = "0";

		sign = (num == (num = Math.abs(num)));
		num = Math.floor(num*100+0.50000000001);
		cents = num%100;
		num = Math.floor(num/100).toString();
		if(cents<10) cents = "0" + cents;
		for (var i = 0; i < Math.floor((
				num.length-(1+i))/3); i++)
		num = num.substring(0,num.length-(4*i+3))+'.'+num.substring(num.length-(4*i+3));
		//alert(((sign)?'':'-')  + num + ',' + cents);
		return (((sign)?'':'-')  + num + ',' + cents);
}	

function CurrencyFormat(num)
{
	   
		    num=num.toString();
		    if(num.lastIndexOf('.')!=num.indexOf('.'))
		    {
		     //ci sono piu punti    
		     var dotPos=num.lastIndexOf('.');
			     num=num.substr(0,dotPos)+","+num.substr(dotPos+1);             
			     num=num.toString().replace('.','');            
		    }
		    else
		     num=num.toString().replace('.',',');
   
    var 	newstring="";
    var 	i = 0;
    var 	commanumber=0;
		    for (i=0;i<num.length;i++)
		    {
		        if(num.substring(i,i+1)==".")
		            newstring=newstring+",";
		        else
		        if ((num.substring(i,i+1)==",")||(num.substring(i,i+1)=="-")||(num.substring(i,i+1)=="1")||(num.substring(i,i+1)=="2")||(num.substring(i,i+1)=="3")||(num.substring(i,i+1)=="4")||(num.substring(i,i+1)=="5")||(num.substring(i,i+1)=="6")||(num.substring(i,i+1)=="7")||(num.substring(i,i+1)=="8")||(num.substring(i,i+1)=="9")||(num.substring(i,i+1)=="0"))
		         newstring=newstring+num.substring(i,i+1);
		        if (num.substring(i,i+1)=="," || num.substring(i,i+1)==".") commanumber = commanumber +1;
		    }
		    if (commanumber > 1) newstring = "";
		    num = newstring;
		    num = num.toString().replace(/\,/g,'.');
		    if(isNaN(num)) num = "0";
		
		    sign = (num == (num = Math.abs(num)));
		    num = Math.floor(num*100+0.50000000001);
		    cents = num%100;
		    num = Math.floor(num/100).toString();
		    if(cents<10) cents = "0" + cents;
		    for (var i = 0; i < Math.floor((
		            num.length-(1+i))/3); i++)
		    num = num.substring(0,num.length-(4*i+3))+'.'+num.substring(num.length-(4*i+3));
		    //alert(((sign)?'':'-')  + num + ',' + cents);
		    return (((sign)?'':'-')  + num + ',' + cents);
}    

function NumberFormat_(num,digits)
{//just a text never worked
    		num			=	num.toString();
		    if(num.lastIndexOf('.')!=num.indexOf('.'))
		    {
		     //ci sono piu punti    
	     var 	dotPos		=	num.lastIndexOf('.');
	     		num			=	num.substr(0,dotPos)+","+num.substr(dotPos+1);             
	     		num			=	num.toString().replace('.','');            
		    }
		    else
		    {//Only One . or none
		        num			=	num.toString().replace('.',',');
		    }
   
    var 	newstring		= 	"";
    var 	i 				= 	0;
    var 	commanumber		=	0;
		    for (i=0;i<num.length;i++)
		    {
		        if(num.substring(i,i+1)==".")
		        {
		            newstring	=	newstring+",";
		        }
		        else if ((num.substring(i,i+1)==",")||(num.substring(i,i+1)=="-")||(num.substring(i,i+1)=="1")||(num.substring(i,i+1)=="2")||(num.substring(i,i+1)=="3")||(num.substring(i,i+1)=="4")||(num.substring(i,i+1)=="5")||(num.substring(i,i+1)=="6")||(num.substring(i,i+1)=="7")||(num.substring(i,i+1)=="8")||(num.substring(i,i+1)=="9")||(num.substring(i,i+1)=="0"))
		        {	
		        	newstring	=	newstring+num.substring(i,i+1);
		        	if (num.substring(i,i+1)=="," || num.substring(i,i+1)==".") commanumber = commanumber +1;
		        }
		    }
		    if (commanumber > 1) newstring = "";
	    	num 			= 	newstring;
	    	num 			= 	num.toString().replace(/\,/g,'.');
		    if(isNaN(num)) num = "0";
		
	    	sign 			= 	(num == (num = Math.abs(num)));
	    	num 			= 	Math.floor(num*(10*digits)+0.50000000001);
	    	cents 			= 	num%100;
	    	num 			= 	Math.floor(num/(10*digits)).toString();
		    if(cents<10) cents = "0" + cents;
		    for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
		    	num 			= 	num.substring(0,num.length-(4*i+3))+'.'+num.substring(num.length-(4*i+3));
		    //alert(((sign)?'':'-')  + num + ',' + cents);
		    return (((sign)?'':'-')  + num + ',' + cents);
}    

function NumberFormat(elementIn,digits,ThousandsCharIn,DecimalCharIn,ShowThousandsIn)   
{   	
		//console.log("================ TTTTTTTTTT");
		ThousandsCharIn 				= '.';
		DecimalCharIn					= ',';
		
	var StringOut 						= "";
		//alert("\ndigits:"+digits+"\n ThousandsCharIn:"+ThousandsCharIn+"\n DecimalCharIn:"+DecimalCharIn+"\n ShowThousandsIn:"+ShowThousandsIn);
	var IntegerPart						= 0;
	var DecimalPart						= 0;
	var elementValueIn 					= elementIn.value;
	var elementValueIn_DecimalCharIn 	= replaceAll(elementValueIn,DecimalCharIn,'');
	var DecimalSeparatorsNumber			= elementValueIn.length-elementValueIn_DecimalCharIn.length;
	var elementValueNoThousandsCharIn	= replaceAll(elementValueIn,'\\.','');  
	//alert(" ----   elementValueNoThousandsCharIn:"+elementValueNoThousandsCharIn+"       ThousandsCharIn:"+ThousandsCharIn+" elementValueIn:"+elementValueIn);
		if (ShowThousandsIn=='Y')
		{
			//alert('elementValueNoThousandsCharIn : '+elementValueNoThousandsCharIn);
			$("debuggeroutput_content").html("elementValueNoThousandsCharIn:"+elementValueNoThousandsCharIn+"<br>elementValueIn:"+elementValueIn);
			if (DecimalSeparatorsNumber>1) { elementIn.value = $(elementIn).attr("old_value"); return;}
			if (digits==0)
			{
				for(var i=0;i<elementValueNoThousandsCharIn.length;++i)
				{
				var Char_i 																				= elementValueNoThousandsCharIn.substring(i,i+1); 
					
					if ((Char_i != '0')&&(Char_i != '1')&&(Char_i != '2')&&(Char_i != '3')&&(Char_i != '4')&&(Char_i != '5')&&(Char_i != '6')&&(Char_i != '7')&&(Char_i != '8')&&(Char_i != '9'))
					{
						elementIn.value = $(elementIn).attr("old_value"); return;
					}
				}
			}
			if (digits>0)
			{
				for(var i=0;i<elementValueNoThousandsCharIn.length;++i)
				{
				var Char_i 																				= elementValueNoThousandsCharIn.substring(i,i+1); 
					
					if ((Char_i != '0')&&(Char_i != '1')&&(Char_i != '2')&&(Char_i != '3')&&(Char_i != '4')&&(Char_i != '5')&&(Char_i != '6')&&(Char_i != '7')&&(Char_i != '8')&&(Char_i != '9')&&(Char_i != DecimalCharIn))
					{
						//alert("wicked : "+Char_i);
						elementIn.value = $(elementIn).attr("old_value"); return;
					}
				}
			}
	
			//Starting From Here the Number is well behaving
			if (digits>0)
			{
				if (DecimalSeparatorsNumber>0)
				{
					var Tokens 				= elementValueNoThousandsCharIn.split(DecimalCharIn);
						IntegerPart			= Tokens[0];
						DecimalPart			= Tokens[1];
				}else
				{
					IntegerPart				= elementValueNoThousandsCharIn;			
					DecimalPart				= "";
				}
			}else
			{
					IntegerPart				= elementValueNoThousandsCharIn;			
					DecimalPart				= "";
			}
		var IntegerPartLength				= IntegerPart.length;
			//alert("IntegerPartLength : "+IntegerPartLength);
		var blocks							= parseInt(IntegerPartLength/3)+1
			for(var y=1;y<=blocks;++y)
			{
			var SubstringStart 			= (IntegerPartLength-3*y);
			var SubstringEnd 			= (IntegerPartLength-3*y)+3;
				//			alert(" Block start:"+SubstringStart+"  End:"+SubstringEnd);
				if (SubstringEnd>0)
				{
					if (SubstringStart<0) SubstringStart=0;
					var MyBlock 			= IntegerPart.toString().substring(SubstringStart,SubstringEnd);
					if (y>1){StringOut		= MyBlock+ThousandsCharIn+StringOut;}else{StringOut				= MyBlock+StringOut;}
				}
	//			alert('MyBlock:'+MyBlock+' IntegerPart:'+IntegerPart+' Digits:'+digits+'   elementValueNoThousandsCharIn:'+elementValueNoThousandsCharIn);
			}
		}
		if (DecimalSeparatorsNumber>0) {StringOut = StringOut+DecimalCharIn;}
	
		StringOut 										= StringOut+DecimalPart;
		//return StringOut;
		//elementIn.value = "";
		elementIn.value = StringOut;
		$(elementIn).attr("old_value",StringOut);
		//alert("StringOut : "+StringOut);
		//$("#debuggeroutput_content").html("DecimalSeparatorsNumber : "+DecimalSeparatorsNumber);
		//alert("old_value:"+$(elementIn).attr("old_value"));
		//$(elementIn).data("old_value","dddd");
		//alert("num:"+num.value);
	//	var decimal=  /^[-+]?[0-9]+\.[0-9]+$/;   
	//	if(num.match(decimal))   
	//	{   
	//		alert('Correct, try another...')  
	//		return true;  
	//	}  
	//	else  
	//	{   
	//		alert('Wrong...!')  
	//		return false;  
	//	}  
}   

function ScrollController(top,left)
{
										console_log("ScrollController: "+top+"-"+left);
}

function getAssociatedFormElement(elementIn)
{
	var 								el 		= elementIn;
	var 								i		= 0;
	var 								goon	= 1;
										//console_log("getAssociatedFormElement el:"+elementIn.id);
										//console_log("getAssociatedFormElement el parent:"+el.parentNode.id);

										if (
												(el.getAttribute("form_acting")!=null)
												&&
												(el.getAttribute("form_acting").toUpperCase()=='Y')
											)
										{
											return el;
										}
										//Added on 2015/05/15 to manage the itself case. If elementIn is a generalizedForm element elementIn is returned. 
								
										while(goon>0)//(el.tagName.toUpperCase()!='FORM')&&(i<100))
										{
											++i;
											//alert('node = '+el.tagName+' daddy: '+el.parentNode.tagName);
											el = el.parentNode;
											//alert(' getAssociatedFormElement  id:'+el.id+' value : '+el.getAttribute("form_acting"));
											if (
													(el.getAttribute("form_acting")!=null)
													&&
													(el.getAttribute("form_acting").toUpperCase()=='Y')
												)
											{
												goon = 0;
												return el;
											}else
											{
											}
											if (i>100)
											{
												goon = 0;
												return null;
											}
										}
}

function getSWOwner(elementIn)
{
										return getOwnerSW(elementIn);
}

function getOwnerSW(elementIn)
{
	//QC passed
	var el 		= elementIn;
	var i		= 0;
	var goon 	= 1;
		//console_log("__getOwnerSW"+jQuery(elementIn).attr("id"));
	try{

			while(goon>0)//(el.tagName.toUpperCase()!='FORM')&&(i<100))
			{
				++i;
				//alert('node = '+el.tagName+' daddy: '+el.parentNode.tagName);
				el 	= el.parentNode;
				//alert(' getAssociatedFormElement  id:'+el.id+' value : '+el.getAttribute("form_acting"));
				//alert('getOwnerSW '+i+'.\n el in : '+elementIn.id+' .\n Testing : '+el.id+'\n Testing Class string : '+el.className+'\n indexOf : '+el.className.indexOf('IsSW'));
				if (
						(el.className!=null)
						&&
						(el.className.indexOf('IsSW')>-1)
					)
				{
					//alert('getOwnerSW going out found');
					goon = 0;
					return el;
				}else
				{

				}
				if (i>100)
				{
					goon = 0;
					alert('getOwnerSW going out i100');
					return null;
				}
			}
		} catch(error)
		{
	  		console.error(error);
		}
}

function getTEOwner(elementIn)
{//find closest TagExtender Element 
	var TEs = $(elementIn).closest(".IsTE");
	if ((TEs!=null)&&(TEs.length>0)) 
	{
		return TEs[0];
	}else
	{
		return null;
	}
}

function getParentSWByType(elementIn,SWType)
{
	//QC passed
	var el 		= elementIn;
	var i		= 0;
	var goon 	= 1;
	
		while(goon>0)//(el.tagName.toUpperCase()!='FORM')&&(i<100))
		{
			++i;
			//alert('node = '+el.tagName+' daddy: '+el.parentNode.tagName+'   SWType : '+SWType);
			el = el.parentNode;
			//alert(' getAssociatedFormElement  id:'+el.id+' value : '+el.getAttribute("form_acting"));
			//alert('getOwnerSW '+i+'.\n el in : '+elementIn.id+' .\n Testing : '+el.id+'\n Testing Class string : '+el.className+'\n indexOf : '+el.className.indexOf('IsSW'));
			if (
					(el.className!=null)
					&&
					(el.className.indexOf('IsSW')>-1)
					&&
					(el.className.indexOf(SWType)>-1)
				)
			{
				//alert('getOwnerSW going out found');
				goon = 0;
				return el;
			}
			else
			{
			
			}
			
			if (el.tagName.toUpperCase()=='BODY')
			{
				//alert("SW Type : "+SWType+" not found.....");
				return document.body;
			}
			if (i>100)
			{
				goon = 0;
				alert('getOwnerSW going out i100');
				return null;
			}
		}
}

function getAssociatedForm(elementIn)
{
	var el 	= elementIn;
	var i	= 0;
	
		while(1)//(el.tagName.toUpperCase()!='FORM')&&(i<100))
		{
			++i;
			//alert('node = '+el.tagName+' daddy: '+el.parentNode.tagName);
			//console_log("el:"+elementIn.id+" parent:"+el.parentNode.id);
			el = el.parentNode;
			if (el.tagName.toUpperCase()=='FORM')
			{
				return el;
			}
			if (i>100)
			{
				return null;
			}
		}
	
		return null;
		//alert("MyForm:"+el+". type:"+el.nodeName+"id:"+el.id);	
}

function manageAutoSubmit(elemIn,AssociatedForm)
{
	//alert('associated form:'+AssociatedForm);
	//alert('elemIn:'+elemIn);
	try
	{
			if (AssociatedForm=='##IDENTIFIER##')
			{
				AssociatedForm=getAssociatedForm(elemIn);
			}
		var SumbitTriggerElId = AssociatedForm +"SubmitTriggerId|";
		//alert('trigger element input id:'+SumbitTriggerElId);
		//alert('elemIn id:'+elemIn.id);
	 //   alert('AssociatedForm:'+AssociatedForm+'-------------SumbitTriggerElId:'+SumbitTriggerElId);

		var SumbitTriggerEl = document.getElementById(SumbitTriggerElId);
			if (elemIn.id.length>0 )
			{
				SumbitTriggerEl.value = elemIn.id;
				//alert('id not null!');
			}else
			{
				//alert('id is null!');
				
				SumbitTriggerEl.value =AssociatedForm+elemIn.name;
			}
	    var MyForm = document.getElementById(AssociatedForm);
	   // alert('A'+MyForm.nodeValue);
	    /*
	    var FormElements = MyForm.elements; 
	    var str='';
	    alert('Elements number:'+FormElements.length);
	    for (var i=0;i<FormElements.lenght;++i)
	    {
	    	str = str + FormElements[i]+"---------";
	    }
	    alert(str);
	    */
	
	    
	    var waitersEl = document.getElementById('waitershield');
	    	waitersEl.style.visibility = 'visible';
	    // waitersRunner(1);
	    	MyForm.submit();
	}catch(err)
	{
		alert('errore ManageAutosubmit:'+err);
	}	
}

function manageExcelServletSubmit_(elemIn,ExcelIdentifier)
{//not used
		alert('export xls');
	var QueryString = '?'+'Identifier='+elemIn.id+'&'+'ExcelType='+'CustomExcel'+'&'+'ExcelIdentifier='+ExcelIdentifier;
		//alert('QueryString:'+QueryString);
		document.location.href = "ExcelServlet"+QueryString;
	
	//alert('associated form:'+AssociatedForm);
//	alert('elemIn:'+elemIn);
	/*
	try
	{
		
		if (AssociatedForm=='##IDENTIFIER##')
		{
			AssociatedForm=getAssociatedForm(elemIn);
		}
		
		var SumbitTriggerElId = AssociatedForm +"SubmitTriggerId|";
		//alert('trigger element input id:'+SumbitTriggerElId);
		//alert('elemIn id:'+elemIn.id);
	 //   alert('AssociatedForm:'+AssociatedForm+'-------------SumbitTriggerElId:'+SumbitTriggerElId);

		var SumbitTriggerEl = document.getElementById(SumbitTriggerElId);
		if (elemIn.id.length>0 )
		{
			SumbitTriggerEl.value = elemIn.id;
			//alert('id not null!');
		}
		else
		{
			//alert('id is null!');
			
			SumbitTriggerEl.value =AssociatedForm+elemIn.name;
		}
	    var MyForm = document.getElementById(AssociatedForm);
	    */
	   // alert('A'+MyForm.nodeValue);
	    /*
	    var FormElements = MyForm.elements; 
	    var str='';
	    alert('Elements number:'+FormElements.length);
	    for (var i=0;i<FormElements.lenght;++i)
	    {
	    	str = str + FormElements[i]+"---------";
	    }
	    alert(str);
	    */
	
	    /*
	    var waitersEl = document.getElementById('waitershield');
	    waitersEl.style.visibility = 'visible';
	    // waitersRunner(1);
	    MyForm.submit();
		
		
	}
	catch(err)
	{
		alert('errore ManageAutosubmit:'+err);
	}
	*/
}

function manageExcelServletSubmit(elemIn,ExcelIdentifier,ExcelFileName)
{//not used
	var Mypageobjtoken					= $(document.body).attr('pageobjtoken');
	var Mypagename						= $(document.body).attr('pagename');
	var SessionPageFullName				= Mypageobjtoken+"_"+Mypagename;

	var	data_pagechunk					= 'sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+Mypagename+'&';
	
	var QueryString 					= '?'+encodeURI('Identifier='+elemIn.id+'&'+'ExcelType='+'CustomExcel'+'&'+'ExcelIdentifier='+ExcelIdentifier+'&'+'ExcelFileName='+ExcelFileName+'&'+data_pagechunk);
	
	//var QueryString = '?'+encodeURI('Identifier='+elemIn.id+'&'+'fileServerIdentifier='+fileServerIdentifier+'&'+'outputFileName='+outputFileName+'&'+'fileSource='+fileSource);
		//alert('QueryString:'+QueryString);
		document.location.href 			= "ExcelServlet"+QueryString;
}

/*
 * ExcelServlet or PDFServlet. Generate only is allowed. No FileDownloadAsk event.
 * To get FileDownloadAsk use fileDownload Servlet
 * @param elemIn
 * @param IdentifierIn
 * @param FileNameIn
 * @param ExportTypeIn
 * @param ReportIdentifierIn
 * @param ReportTypeIn
 * @returns
 */
function manageExcelPDFServletSubmit(elemIn,IdentifierIn,FileNameIn,ExportTypeIn,ReportIdentifierIn,ReportTypeIn)
{//ExcelServlet or PDFServlet
										//alert('Generating .XLS or .PDF file......');
	var 								Mypageobjtoken																						= $(document.body).attr('pageobjtoken');
	var 								Mypagename																							= $(document.body).attr('pagename');
	var 								SessionPageFullName																					= Mypageobjtoken+"_"+Mypagename;

	var									data_pagechunk																						= 'sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+Mypagename+'&';

	//ExportType:XLS,PDF,CSV....
										if (ExportTypeIn=='XLS')
										{
										var QueryString 																					= '?'+encodeURI('SubmitTrigger='+elemIn.id+'&'+'Identifier='+IdentifierIn+'&'+'ExcelType='+ReportTypeIn+'&'+'FileName='+FileNameIn+'&'+'ExcelIdentifier='+ReportIdentifierIn+'&'+data_pagechunk);//+'&'+'ExcelIdentifier='+ExcelIdentifier+'&'+'ExcelFileName='+ExcelFileName;
											//alert('QueryString:'+QueryString);
											document.location.href																			= "ExcelServlet"+QueryString;
										}
										if (ExportTypeIn=='PDF')
										{
										var QueryString 																					= '?'+encodeURI('SubmitTrigger='+elemIn.id+'&'+'Identifier='+IdentifierIn+'&'+'ReportType='+ReportTypeIn+'&'+'FileName='+FileNameIn+'&'+'ReportIdentifier='+ReportIdentifierIn+'&'+data_pagechunk);//+'&'+'ExcelIdentifier='+ExcelIdentifier+'&'+'ExcelFileName='+ExcelFileName;
											//alert('QueryString:'+QueryString);
											document.location.href																			= "PDFServlet"+QueryString;
										}
}

/**
 * @param elemIn
 * @param fileServerIdentifier 	if fileSource == 'FILE_STREAM' => use it to pass parameters to Java Object 
 * @param outputFileName
 * @param fileSource		
 * @returns 					no return 
 */
function managefileDownloadServletSubmit(elemIn,fileServerIdentifier,outputFileName,fileSource)
{
										//alert('Downloading file......');
	var 								Mypageobjtoken																						= $(document.body).attr('pageobjtoken');
	var	 								Mypagename																							= $(document.body).attr('pagename');
	var 								SessionPageFullName																					= Mypageobjtoken+"_"+Mypagename;
										//alert("SessionPageFullName:"+SessionPageFullName);

	var									data_pagechunk																						= 'sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+Mypagename;
										// fileSource : DB,FS,ONTHEFLY
										// fileServerIdentifier : Identifier Of file on Source. i.e. UUID code in DB list
	var 								QueryString 																						= '?'+encodeURI('Identifier='+elemIn.id+'&'+'fileServerIdentifier='+fileServerIdentifier+'&'+'outputFileName='+outputFileName+'&'+'fileSource='+fileSource+'&'+data_pagechunk);
										//alert('managefileDownloadServletSubmit QueryString:'+QueryString);

										document.location.href 																				= "fileDownload"+QueryString;
}

//function managefileDownloadServletSubmitByStream(elemIn,fileServerIdentifier,outputFileName,fileSource,FileGenParametersIn)
//{
//										//alert('Downloading file......');
//	var 								Mypageobjtoken																						= $(document.body).attr('pageobjtoken');
//	var	 							Mypagename																							= $(document.body).attr('pagename');
//	var 								SessionPageFullName																				= Mypageobjtoken+"_"+Mypagename;
//
//	var								data_pagechunk																						= 'sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+Mypagename;
//										// fileSource : DB,FS,ONTHEFLY
//										// fileServerIdentifier : Identifier Of file on Source. i.e. UUID code in DB list
//	var 								QueryString 																								= '?'+encodeURI('Identifier='+elemIn.id+'&'+'fileServerIdentifier='+fileServerIdentifier+'&'+'outputFileName='+outputFileName+'&'+'fileSource='+fileSource+'&'+data_pagechunk+'&'+'file_gen_parameters='+FileGenParametersIn);
//										//alert('QueryString:'+QueryString);
//
//										document.location.href 																			= "fileDownload"+QueryString;
//}

function manageAutoSubmitSilent(elemIn,AssociatedForm)
{
	try
	{
			if (AssociatedForm=='##IDENTIFIER##')
			{
				AssociatedForm=getAssociatedForm(elemIn);
			}
		
		var SumbitTriggerElId = AssociatedForm +"SubmitTriggerId|";

		var SumbitTriggerEl = document.getElementById(SumbitTriggerElId);
			if (elemIn.id.length>0 )
			{
				SumbitTriggerEl.value = elemIn.id;
				//alert('id not null!');
			}else
			{
				//alert('id is null!');
				
				SumbitTriggerEl.value =AssociatedForm+elemIn.name;
			}
	    var MyForm = document.getElementById(AssociatedForm);
		   // alert('A'+MyForm.nodeValue);
		    /*
		    var FormElements = MyForm.elements; 
		    var str='';
		    alert('Elements number:'+FormElements.length);
		    for (var i=0;i<FormElements.lenght;++i)
		    {
		    	str = str + FormElements[i]+"---------";
		    }
		    alert(str);
		    */
		
		    
		    // waitersRunner(1);
	    	MyForm.submit();
	}catch(err)
	{
		alert('errore ManageAutosubmit:'+err);
	}	
}

function selectForceOptionByTextValue(elementIn,TextValueIn)
{
	var elemenInOptionsList = elementIn.options;
	var StringOptionsList = "options list for element id : "+elementIn.id+"\n\n";
		for(var ffi=0;ffi<elemenInOptionsList.length;++ffi)
		{
			StringOptionsList+="\n index:"+ffi+" value : "+elemenInOptionsList[ffi].text;
		}
		alert(StringOptionsList);
}

function RemoveElementById(ElementIdIn)
{
	//alert('remove element id : '+ElementIdIn);
	var element = document.getElementById(ElementIdIn);
		if (typeof element!='undefined')
		{
			if (element!=null)
			{
				element.parentNode.removeChild(element);
			}
		}
		//alert('done ');
}

function RemoveElement(ElementIn)
{
	//alert('call to remove element : '+ElementIn.id);
	if (typeof ElementIn!='undefined')
	{
		if (ElementIn!=null)
		{
			try
			{
				ElementIn.parentNode.removeChild(ElementIn);					
			}catch(e)
			{
				alert(' remove alert '+e);
			}
		//	alert('remove done....');
		}else
		{
			alert('element to remove null');
		}
	}else
	{
		alert('element to remove undefined');
	}
}

function getCSS(element, property) 
{

	  var elem 	= document.getElementById(element);
	  var css 	= null;
	  
		  if(elem.currentStyle) 
		  {
		  
		    css = elem.currentStyle[property];
		  } else 
		  if(window.getComputedStyle) 
		  {
			  css = document.defaultView.getComputedStyle(elem, null).getPropertyValue(property);
		  }
	  
	  return css;
}

function lengthConversion(ReferenceInUnitToConvert,ReferenceInUnitConverted,ConvertingValue)
{
	var ConvertionRatio = ReferenceInUnitConverted/ReferenceInUnitToConvert;
		return ConvertingValue*ConvertionRatio;
}

function lengthConversionByLogoCorner(ConvertingValue)
{
	//alert('lengthConversionByLogoCorner in ');
	var ReferenceInUnitToConvert 	= 30;
	var ReferenceInUnitConverted 	= document.getElementById('ApplicationLogoCorner').clientWidth;
	var ConvertionRatio 			= ReferenceInUnitConverted/ReferenceInUnitToConvert;
	//alert('ConvertionRatio : '+ConvertionRatio);

		return ConvertingValue*ConvertionRatio;
}

function lengthConversionToPX(StringToConvert)
{
	var LengthOut =0; 
		if (StringToConvert.indexOf('mm')>-1)
		{
			LengthOut = parseInt(StringToConvert.replace('mm',''))*LengthConversionRatioMMtoPX;
		}
		if (StringToConvert.indexOf('px')>-1)
		{
			LengthOut = StringToConvert.indexOf('px');
		}
	
		return LengthOut+'px';
}

function LengthConversionRatioMMtoPXinizialize()
{
	var ReferenceInUnitToConvert 			= 30;
	var ReferenceInUnitConverted 			= document.getElementById('ApplicationLogoCorner').clientWidth;
	var ConvertionRatio 					= ReferenceInUnitConverted/ReferenceInUnitToConvert;
		LengthConversionRatioMMtoPX 			= ConvertionRatio;
		return LengthConversionRatioMMtoPX;

}

function toPXnormalize(elementInId)
{
	var elementIn = document.getElementById(elementInId);
		alert('elementin:'+elementInId);
	
	var elementWitdth = elementIn.clientWidth;
		elementIn.style.width=elementWitdth+'px';
		alert('elementin:'+elementIn.id);
}
		 
function closeLayerContainerByEmbeddedCommand(IdentifierIn)
{
	var SWToClose = document.getElementById(IdentifierIn);
	
		$(SWToClose).remove();
}

function hasTokens(StringIn)
{
		if ((StringIn.indexOf("|")>-1)&&(StringIn.indexOf("__")>-1))
		{
			return "dirty";
		}
		if ((StringIn.indexOf("|")>-1)&&(StringIn.indexOf("__")==-1))
		{
			return "|";
		}
		if ((StringIn.indexOf("|")==-1)&&(StringIn.indexOf("__")>-1))
		{
			return "__";
		}
		return null;
}

function normalizeTokens__(StringIn)
{
	var normalizeTokens__Out	= null;
	var tokensState 			= hasTokens(StringIn);
	//alert(' StringIn :'+StringIn+' has tokens : '+tokensState);
	if (tokensState!=null)
	{
		if (tokensState=='|')
		{
			normalizeTokens__Out = StringIn.split("|").join("__");
		}
		if (tokensState=='__')
		{
			normalizeTokens__Out = StringIn;
		}
	}
	return normalizeTokens__Out;
}

function getIdentifierTokenDepth(IdentifierIn)
{
	var TokensNumber				= 0;
	var NormalizedIdentifierTokenIn = normalizeTokens__(IdentifierIn);
	//alert('NormalizedIdentifierTokenIn :'+NormalizedIdentifierTokenIn);
		if (NormalizedIdentifierTokenIn!=null)
		{
			TokensNumber = NormalizedIdentifierTokenIn.split('__').length-2;
		}
		if (TokensNumber<0) TokensNumber = -1;
		return TokensNumber;
}

function getIdentifierParent(IdentifierIn)
{
	var ParentIdentifierOut = "";
		if (IdentifierIn != null)
		{
			var IdentifierTokens 		= IdentifierIn.split('|');
			var IdentifierTokensNumber 	= IdentifierTokens.length-2;
			for(var i=1;i<IdentifierTokensNumber;++i)
			{
				//alert('token : '+IdentifierTokens[i]);
				ParentIdentifierOut += "|"+IdentifierTokens[i];	
				//alert('ParentIdentifierOut:'+ParentIdentifierOut);
			}
			ParentIdentifierOut+="|";
		}else
		{
			ParentIdentifierOut= null;
		}
		//alert('out..........'+ParentIdentifierOut);
		return ParentIdentifierOut;
}

function getLastToken(IdentifierIn)
{
	var IdentifierOut = "";
		if (IdentifierIn != null)
		{
			var IdentifierTokens 		= IdentifierIn.split('|');
			var IdentifierTokensNumber 	= IdentifierTokens.length-2;
			IdentifierOut += IdentifierTokens[IdentifierTokensNumber];
		}else
		{
			IdentifierOut= null;
		}
		return IdentifierOut;
}

function getEventTargetElement(e)
{
//	 var elem, evt = e ? e:event;
	var elem	= null;
	var evt 	= e ? e:event;
		if (evt.srcElement)  elem = evt.srcElement;
		else if (evt.target) elem = evt.target;
		 /*
		 alert (''
		  +'You clicked the following HTML element: \n <'
		  +elem.tagName.toUpperCase()
		  +'>'
		 )*/
		return elem;
}

/*
function SendClientParameters()
{
		//alert("sending client parameters to server");
		var LengthConversionRatio 	= lengthConversionByLogoCorner(1);
		var screen_availHeight		= window.screen.availHeight;
		var screen_availWidth		= window.screen.availWidth;
		var screen_height			= window.screen.height;
		var screen_width			= window.screen.width;
		var screen_colorDepth		= window.screen.colorDepth;
		var screen_pixelDepth		= window.screen.pixelDepth;	
		var viewport_innerHeight    = $(window).height();
		var viewport_innerWidth     = $(window).width();
		
		var BrowserInfo 			= get_browser_info();
		var DataStringOut 			= 'screen_availHeight='+screen_availHeight+'&'+
									  'screen_availWidth='+screen_availWidth+'&'+
									  'screen_height='+screen_height+'&'+
									  'screen_width='+screen_width+'&'+
									  'screen_colorDepth='+screen_colorDepth+'&'+
									  'screen_pixelDepth='+screen_pixelDepth+'&'+
									  'LengthConversionRatio='+LengthConversionRatio+'&'+
									  'browser_name='+BrowserInfo.name+'&'+
		  							  'browser_version='+BrowserInfo.version+'&'+
		  							  'viewport_innerWidth='+viewport_innerWidth+'&'+
		  							  'viewport_innerHeight='+viewport_innerHeight;
	
		//alert('DataStringOut:'+DataStringOut+'ContextPath:'+ContextPath);
	
	
		$.ajax
		(
			{
				type: 		"GET",
				url: 		ContextPath+"/StateParameters",
				data: 		DataStringOut,
				dataType: 	"html",
				success: function(msg)
				{
					alert('success SendClientParameters. Client parameters to Server:'+msg);
					//window.location.replace(PageName+'.jsp?check');
				},
				error: function(e)
				{
					alert('SendClientParameters error'+e);
				}
			}
		);//ajax
}
*/
/*
function BeforeLoadPAGEParametersGenerate(FirstLoop,PageName,NextQueryString)
{//For old versions.....not used anymore
 //Initialization loop is performed by JS
	if (FirstLoop=='true')
	{
		//alert('FirstLoop:'+FirstLoop+'PageName:'+PageName);
		var LengthConversionRatio 	= lengthConversionByLogoCorner(1);
		var screen_availHeight		= window.screen.availHeight;
		var screen_availWidth		= window.screen.availWidth;
		var screen_height			= window.screen.height;
		var screen_width			= window.screen.width;
		var screen_colorDepth		= window.screen.colorDepth;
		var screen_pixelDepth		= window.screen.pixelDepth;	
		var viewport_innerHeight    = $(window).height();
		var viewport_innerWidth     = $(window).width();
		
		var BrowserInfo 			= get_browser_info();
		var DataStringOut 			= 'screen_availHeight='+screen_availHeight+'&'+
									  'screen_availWidth='+screen_availWidth+'&'+
									  'screen_height='+screen_height+'&'+
									  'screen_width='+screen_width+'&'+
									  'screen_colorDepth='+screen_colorDepth+'&'+
									  'screen_pixelDepth='+screen_pixelDepth+'&'+
									  'LengthConversionRatio='+LengthConversionRatio+'&'+
									  'browser_name='+BrowserInfo.name+'&'+
		  							  'browser_version='+BrowserInfo.version+'&'+
		  							  'viewport_innerWidth='+viewport_innerWidth+'&'+
		  							  'viewport_innerHeight='+viewport_innerHeight;

		//alert('DataStringOut:'+DataStringOut+'ContextPath:'+ContextPath);
	

		$.ajax
		(
			{
				type: 		"GET",
				url: 		ContextPath+"/StateParameters",
				data: 		DataStringOut,
				dataType: 	"html",
				success: function(msg)
				{
					//alert('success msg :'+msg);
					window.location.replace(PageName+'.jsp?check');
				},
				error: function(e)
				{
					alert('BeforeLoadParameters errore');
				}
			}
		);//ajax
	}else
	{
		//window.location.replace("filesystem.jsp");
	}
}*/

function serializeGeneralized_old(elemIn)
{
		return $(elemIn).find("select, textarea, input").serialize();
}

function serializeGeneralized(elemIn)
{
		//console_log(" serializeGeneralized contour id:"+elemIn.id);
	var StringOut 			= "";
	var formmore 			= jQuery(elemIn).attr("formmore");
		if (isValidElement(formmore))
		{
		var formmore_list 	=  formmore.split(";");
			for(var u=0;u<formmore_list.length;++u)
			{
			var currentform = document.getElementById(formmore_list[u]);
				//alert('lll '+currentform.id);
				StringOut 	= StringOut +"&"+$(currentform).filter(function() {return !this.disabled }).find("select, textarea, input").serialize();
			}
		}
	var StringoutMain = $(elemIn).find("select, textarea, input").filter(function() {return !this.disabled }).serialize();
	//.filter(function() {return !this.disabled && !this.readOnly;}).serialize();
		//console_log('StringoutMain:'+StringoutMain+'\nIOIOIOIOIOIOIOIOIOIOIOO');
		return StringoutMain+StringOut;
}


/*
//fills the parent for any element of class fill_parent
//used in Container SubWindows and in ......
starts from outer objects
*/
function execute_fill_parents()
{
	//alert("filling parents");
	/*
	var fill_parent_arr = $(".fill_parent");
		if (fill_parent_arr!=null)
		{
			for(var jj=0;jj<fill_parent_arr.length;++jj)
			{
				fill_parent(fill_parent_arr[jj]);
				//alert(' filled element : '+fill_parent_arr[jj].id);
			}
		}*/
	var fill_parent_arr = $(".IsSW");
	var max_depth = -1;
		for(var f=0;f<fill_parent_arr.length;++f)
		{
			var depth = $(fill_parent_arr[f]).parents(".IsSW").length;
				if (depth>max_depth) {max_depth=depth;}
			//console_log("----- id:"+fill_parent_arr[f].id+" depth:"+depth);
		}
		for(var depth_i=-1;depth_i<=max_depth;++depth_i)
		{
			//console_log("o fill_parent depth:"+depth_i);
			for(var f=0;f<fill_parent_arr.length;++f)
			{
			var depth_curr = $(fill_parent_arr[f]).parents(".IsSW").length;
				//console_log("		checking:"+fill_parent_arr[f].id+" depth curr:"+depth_curr);
				if (depth_i==depth_curr) 
				{
					//console_log("                                        fill_parent >>>>> :::"+fill_parent_arr[f].id);
				var fill_parent_arr_work = $(fill_parent_arr[f]).find(".fill_parent");
					if (fill_parent_arr_work!=null)
					{
						for(var jj=0;jj<fill_parent_arr_work.length;++jj)
						{
							fill_parent(fill_parent_arr_work[jj]);
						}
					}
					
					fill_parent_arr_work = $(fill_parent_arr[f]).find(".backgrounder");
					if (fill_parent_arr_work!=null)
					{
						for(var jj=0;jj<fill_parent_arr_work.length;++jj)
						{
							fill_parent(fill_parent_arr_work[jj]);
						}
					}					

					fill_parent_arr_work = $(fill_parent_arr[f]).find(".frame");
					if (fill_parent_arr_work!=null)
					{
						for(var jj=0;jj<fill_parent_arr_work.length;++jj)
						{
							fill_parent(fill_parent_arr_work[jj]);
						}
					}					
				}
				
				//console_log("----- id:"+fill_parent_arr[f].id+" depth:"+depth);
			}
		}

	var fill_parent_arr = $(".fill_parent_width");
		if (fill_parent_arr!=null)
		{
			for(var jj=0;jj<fill_parent_arr.length;++jj)
			{
				fill_parent_width(fill_parent_arr[jj]);
				//alert(' filled element : '+fill_parent_arr[jj].id);
			}		
		}
}

function fill_screen()
{
	//deprecated.....
	/*
	var fill_screen = $(".fill_screen");
	if ((fill_screen!=null)&&(fill_screen.length>0))
	{
		for(var g=0;g<fill_screen.length;++g)
		{
			if (fill_screen[g].parentNode.tagName.toUpperCase()=='BODY')
			{
				var BodyWidth 				= $(window).width();
				var BodyHeight 				= $(window).height();
				fill_screen[g].style.height = parseInt(BodyHeight-20)+"px";
				fill_screen[g].style.width  = parseInt(BodyWidth-20)+"px";
			}
			else
			{
				fill_parent(fill_screen[g]);
			}
		}
	}
	*/
}

function fill_viewport()
{
			//$(".fill_viewport").css('border','4px solid blue');
	
}

function fill_viewport_old()
{//cover up to body or window
				//alert("fill_viewport +/-...");
				//var Body_id    			= document.body.id;
				//var ScrollableFrame_id 	= Body_id+"frame|";
				//var ScrollableFrame		= document.getElementById(ScrollableFrame_id);
				
				//var frame_scroll_left 	= $(ScrollableFrame).scrollLeft(); 
				//var frame_scroll_top 	= $(ScrollableFrame).scrollTop(); 
				
				//console_log("ContentMaxBottom:"+ContentMaxBottom+"");
				
				
				//ContentMaxBottom and ContentMaxRight become from ManageScrollableDIVs
				
				//var ViewPortArea_H 		= Math.max($(window).height(), ContentMaxBottom)+frame_scroll_top;
				//var ViewPortArea_W 		= Math.max($(window).width() , ContentMaxRight) +frame_scroll_left;
				
			
				
			var fill_viewports = $(".fill_viewport");
				
				if ((fill_viewports!=null)&&(fill_viewports.length>0))
				{
					for(var g=0;g<fill_viewports.length;++g)
					{
						var my_target_w = Math.max($(window).width() ,jQuery(document.body).width());
						var my_target_h = Math.max($(window).height(),jQuery(document.body).height());
			
						//console_log("- viewport for : "+fill_viewports[g].id);
//							fill_viewports[g].style.height 		= $(window).height()+"px";
//							fill_viewports[g].style.width 		= $(window).width()+"px";
//						//console_log("       id:"+fill_viewports[g].id+" ViewPortArea_H : "+ViewPortArea_H+" ViewPortArea_W : "+ViewPortArea_W);
//						
//						var relative_stub              	   		= document.getElementById(fill_viewports[g].id+"relative_stub|");			
//							relative_stub.style.height     		= $(window).height()+"px";
//							relative_stub.style.width      		= $(window).width() +"px";
							fill_viewports[g].style.height 		= my_target_h+"px";
							fill_viewports[g].style.width 		= my_target_w+"px";
						//console_log("       id:"+fill_viewports[g].id+" ViewPortArea_H : "+ViewPortArea_H+" ViewPortArea_W : "+ViewPortArea_W);
						
						var relative_stub              	   		= document.getElementById(fill_viewports[g].id+"relative_stub|");			
							relative_stub.style.height     		= my_target_h+"px";
							relative_stub.style.width      		= my_target_w +"px";
						//frame and background do not need to be re shaped as being absolute
						// they should perfectly fit parent in all browsers
//						var backgrounder               = document.getElementById(fill_viewports[g].id+"backgrounder|");			
//						backgrounder.style.height      = parseInt(ViewPortArea_H)+"px";
//						backgrounder.style.width       = parseInt(ViewPortArea_W)+"px";
//			
//						var frame                      = document.getElementById(fill_viewports[g].id+"frame|");			
//						frame.style.height             = parseInt(ViewPortArea_H)+"px";
//						frame.style.width  		       = parseInt(ViewPortArea_W)+"px";
						//Content Area should cover All Children
						// May be this function has to be transferred into ScrollManagement
//						var ContentArea 		       			= document.getElementById(fill_viewports[g].id+"ContentArea|");
//							
//							$().find('*');
//						
//							ContentArea.style.height       		= parseInt(ViewPortArea_H)+"px";
//							ContentArea.style.width        		= parseInt(ViewPortArea_W)+"px";
					}
				}
}

function fill_parent(elem)
{
		console.log(new Error("Created via the new keyword!"));

		//alert(' fill_parent ');
		//console_log('				filling parent of :'+elem.id);
	var elem_parent_elem 		= elem.parentNode;
	var elem_parent_elem_width  = parseInt(elem_parent_elem.getBoundingClientRect().right -elem_parent_elem.getBoundingClientRect().left);
	var elem_parent_elem_height = parseInt(elem_parent_elem.getBoundingClientRect().bottom-elem_parent_elem.getBoundingClientRect().top);
		console_log("						elem id:"+elem.id+"  parent id:"+elem_parent_elem.id+" parent (w:"+elem_parent_elem_width+",h:"+elem_parent_elem_height+")");

	var elem_parent_elem_width  = jQuery(elem_parent_elem).innerWidth();
	var elem_parent_elem_height = jQuery(elem_parent_elem).innerHeight();
		//added 20191121. The question is to consider borders or not in calculating dimension. At this step borders are not considered.

		if (elem_parent_elem_width<0)  {elem_parent_elem_width=0;}
		if (elem_parent_elem_height<0) {elem_parent_elem_height=0;}

		elem.style.width			= elem_parent_elem_width/zoom_css_component+'px';
		elem.style.height			= elem_parent_elem_height/zoom_css_component+'px';

		//if (elem.id == "waitershield_innertable")
		//{
		//	alert(" elem_parent_elem_width : "+elem_parent_elem_width+" elem_parent_elem_height : "+elem_parent_elem_height);
		//}
		//alert('elem : '+elem.id+' adjusted height : '+elem.style.height+' adjusted width : '+elem.style.width);
		console_log('-----filling to parent-----');
		console.log(elem);
}

/**
 * Used for example by WindowHandlerCommander
 */
function fill_parent_width(elem)
{
	/* maybe better use css (even embedded in html) seeimng to perform better than javascript.
	 * checked with Concorso class
		alert('fill_parent_width:'+elem.id);
		console_log('filling parent of :'+elem.id);
	var elem_parent_elem 		= elem.parentNode;
	var elem_parent_elem_width  = parseInt(elem_parent_elem.getBoundingClientRect().right -elem_parent_elem.getBoundingClientRect().left);
		console_log("elem_parent_elem.id:"+elem_parent_elem.id+"  elem_parent_elem_width:"+elem_parent_elem_width);
		if (elem_parent_elem_width<0)  {elem_parent_elem_width=0;}	
		elem.style.width			= elem_parent_elem_width+'px';
		*/
}

function fill_parent_SW_width(elem)
{
		//alert();
		//console_log('filling parent of :'+elem.id);
	var elem_parent_elem 		= elem.parentNode;
	var elem_parent_elem_width  = parseInt(elem_parent_elem.getBoundingClientRect().right -elem_parent_elem.getBoundingClientRect().left);
		if (elem_parent_elem_width<0)  {elem_parent_elem_width=0;}
		elem.style.width			= elem_parent_elem_width+'px';
}

function check_newlevellayer(elemIn)
{
	var layer_number 			= null;
	var startingPos 			= (elemIn.className).indexOf('newlevellayer_');
		if (startingPos>=0)
		{
			var SubStart    			= elemIn.className.substr(startingPos,20);
			var first_space_Pos    		= SubStart.indexOf(' ');
			var class_newlayer_string 	= SubStart.substring(0,first_space_Pos);
				layer_number 			= class_newlayer_string.replace('newlevellayer_','');
		}
		return layer_number;
}

function AfterStartupOrReload()
{
								//executed once....we hope
								////////////////////debugger area /////////////////
						
								//alert('AfterStartupOrReload');
							var debuggeroutput 										= document.createElement("DIV");
								debuggeroutput.setAttribute("id","debuggeroutput");
								document.body.appendChild(debuggeroutput);
						
								//debuggeroutput.style.display			= 'none';
								
							var debuggeroutput  									= document.getElementById("debuggeroutput");
								debuggeroutput.style.position 						= 'absolute';
								debuggeroutput.style.left 							= '20px';
								debuggeroutput.style.bottom 						= '20px';
								debuggeroutput.style.height 						= '170px';
								debuggeroutput.style.width 							= '300px';
								debuggeroutput.style.zIndex 						= '100';
								debuggeroutput.style.backgroundColor 				= 'yellow';
								debuggeroutput.style.display 						= 'block';
								document.body.appendChild(debuggeroutput);
						
							var debuggeroutput_content_handle 						= document.createElement("DIV");
								debuggeroutput_content_handle.setAttribute("id","debuggeroutput_content_handle");
								debuggeroutput.appendChild(debuggeroutput_content_handle);
						
							var debuggeroutput_content_handle  						= document.getElementById("debuggeroutput_content_handle");
								debuggeroutput_content_handle.style.position 		= 'absolute';
								debuggeroutput_content_handle.style.left 			= '5px';
								debuggeroutput_content_handle.style.top 			= '5px';
								debuggeroutput_content_handle.style.right 			= '5px';
								debuggeroutput_content_handle.style.height 			= '5px';
								debuggeroutput_content_handle.style.zIndex 			= '100';
								debuggeroutput_content_handle.style.backgroundColor = 'green';
								debuggeroutput_content_handle.style.display 		= 'block';
						
							var debuggeroutput_content 								= document.createElement("DIV");
								debuggeroutput_content.setAttribute("id","debuggeroutput_content");
								debuggeroutput.appendChild(debuggeroutput_content);
							
							var debuggeroutput_content  							= document.getElementById("debuggeroutput_content");
								debuggeroutput_content.style.position 				= 'absolute';
								debuggeroutput_content.style.left 					= '5px';
								debuggeroutput_content.style.top 			    	= '15px';
								debuggeroutput_content.style.right 					= '5px';
								debuggeroutput_content.style.bottom 				= '5px';
								debuggeroutput_content.style.zIndex 				= '100';
								debuggeroutput_content.style.backgroundColor 		= 'lightblue';
								debuggeroutput_content.style.display 				= 'block';
								$("#debuggeroutput").resizable({ handle: "w,n,e,s" });
								$("#debuggeroutput").draggable({ handle: '#debuggeroutput_content_handle' });
								if (IsDebug=='Y')
								{
									debuggeroutput.style.display					= 'block';
								}else
								{
									debuggeroutput.style.display					= 'none';			
								}
								//				$( '#debuggeroutput' ).resize
								//				(
								//						function() 
								//						{
								//							/*
								//							var parentTop = parseInt(this.parentNode.getBoundingClientRect().top);
								//							var thisTop   = parseInt(this.getBoundingClientRect().top);
								//							
								//							if (parentTop>thisTop)
								//							{
								//  				  			//this.innerHTML="parent top : "+parentTop+" thisTop: "+thisTop+" overflow....";
								//								this.style.backgroundColor = 'red';
								//							}*/
								//						}
								//				);
							
								////////////////////DEBUGGER AREA /////////////////
							   	/*
							   	var NewLayerOBJs 		=$("div[class*='newlevellayer_']");// $(".newlevellayer_0");
							   	alert('NewLayerOBJs #:'+NewLayerOBJs.length);
							   	for(var i=0;i<NewLayerOBJs.length;++i)
							   	{
								   var startingPos 				= (NewLayerOBJs[i].className).indexOf('newlevellayer_');
								   var SubStart    				= NewLayerOBJs[i].className.substr(startingPos,20);
								   var first_space_Pos    		= SubStart.indexOf(' ');
								   var class_newlayer_string 	= SubStart.substring(0,first_space_Pos);
								   var layer_number 			= class_newlayer_string.replace('newlevellayer_','');    			
							
								   var elemid 					= NewLayerOBJs[i].id;
								   var layerDIV_id              = "level_"+layer_number;
								   var layerDIV_Elem			= document.getElementById(layerDIV_id);
								   var detachedElem             = $(NewLayerOBJs[i]).detach();
								   
								   $(detachedElem).appendTo(layerDIV_Elem);
								   
								   alert("elemid : "+elemid+" "+NewLayerOBJs[i].className+'\n layer class :>'+class_newlayer_string+'<\nlayer_number:'+layer_number);
							   	}*/
							   	//var mainpagetarget   = $("#level_0");
							   	//mainpage.appendTo(mainpagetarget);
							   	//alert('page load end...');
							   	///////////////////////////////////////////////////////////////////////////////////////////////////////////////
								/*
							   	var SWlist = $(".IsSW");
							   	alert("found el # : "+SWlist.length);
							   	for(var u=0;u<SWlist.length;++u)
							   	{
								   if ((typeof SWlist[u] === "undefined")||(SWlist[u]==null))
								   {
									   
								   }
								   else
								   {	   
									   	   var element_zindex 		= SWlist[u].style.zIndex;
										   var element_className 	= SWlist[u].className;
										   if ((element_zindex>0)&&(element_className.indexOf('newlevellayer_')>-1))
										   {
											   	alert("el id : "+SWlist[u].id);
												if (SWlist[u].parentNode.className.indexOf('ContentAreaBasic')>-1)
												{//ok   
													
												}
												else
												{//move
														alert("swap now");
													   var Body_id 			= document.body.id;
													   var ContainerDock_id = Body_id+"layer_"+element_zindex+"|ContentArea|";
													   var ContainerDock 	= document.getElementById(ContainerDock_id);
													   alert(" target elem : "+ContainerDock.id);
													   $(SWlist[u]).appendTo(ContainerDock);
												}
										   }
								   	}
							   	}
							   	alert("done....");*/
								///////////////////////////////////////////////////////////////////////////////////////////////////////////////   
								//execute on creation or reload only
								if (document.body.addEventListener)
								{
									document.body.addEventListener
									(
										"dragover",
										function(e)
										{
										  e = e || event;
										  e.preventDefault();
										}
										,
										false
									);

									document.body.addEventListener
									(
											"drop",
											function(e)
											{
												e = e || event;
												e.preventDefault();
											},
											false
									);
								}else
								{
									document.body.attachEvent
									(
										"ondragover",
										function(e)
										{
										  e = e || event;
										  e.preventDefault();
										}
									);
									document.body.attachEvent
									(
											"ondrop",
											function(e)
											{
												e = e || event;
												e.preventDefault();
											}
									);
								}

								//Attches keydown event on any element except input and tetarea for scroll management purpuoses
								
								//jQuery(document).off("keydown");
								jQuery(document).on("keydown",  
									function(event) 
									{
									var active_el			= 	document.activeElement;
										//console_log("onkeydown active_el_tagname:"+active_el.tagName+" readonly:"+active_el.readOnly+"  disabled:"+active_el.disabled +" TE_owner id:"+TE_owner.id+"  ffff:"+jQuery(TE_owner).hasClass("ComponentsTagExtenders-EnhancedTextEditor"));
										if (
											((active_el.tagName=='INPUT')&&(!active_el.readOnly)&&(!active_el.disabled))
											||
											((active_el.tagName=='TEXTAREA')&&(!active_el.readOnly)&&(!active_el.disabled))
										)
										{
											//console_log('keydown on input or textarea');
										}else
										{
											//alert("event : "+event);
											//alert("key code : "+getChar_a(event));
										var key_code = null;
											if (typeof event === "undefined")
											{
											var MyEvent 	= window.event;
												key_code 	= MyEvent.keyCode;
											}	else
											{
												key_code 	= event.keyCode;
											}
						
											//alert("KEY event....type: key_code:"+key_code);
											//console_log("event type = "+event.type);
											CAclient_params(null,null,event,null,null,null);
											if ((key_code==40)||(key_code == 38)||(key_code == 37)||(key_code == 39)||(key_code == 33)||(key_code == 34))
											{
												if ((Active_Slider_H!=null)&&((key_code == 37)||(key_code == 39)))
												{
													sliderScrollKey_div(Active_Slider_H,key_code);
												}
												if ((Active_Slider_V!=null)&&((key_code == 38)||(key_code == 40)||(key_code == 33)||(key_code == 34)))
												{
													//alert("keydown"+Active_Slider_V.id+"   hjhjhjj "+Active_Slider_V);
													sliderScrollKey_div(Active_Slider_V,key_code);
												}
												if ((Active_Slider_TABLE!=null)&&((key_code == 37)||(key_code == 39)))
												{
													sliderScrollKey_table(Active_Slider_TABLE,key_code);
												}
											}
										}											
									}
								);
								
								$(document).off("mousemove");
								$(document).on("mousemove",
									//to verify performance issues
									//Letting here "mousemove" event this is always active
									//  particularly in IE8 it may require too much resources......
									function(event) 
									{
										MousePosX  = event.pageX;
										//CAclient_params(null,null,event,null,null,null);
										//console_log('mousemove....'+event.target.id);
										CAclient('document',document,event,null,null,false);
									}
								);
								
							var bodyelem = document.body;
								if (bodyelem.addEventListener) 
								{    
									// all browsers except IE before version 9
								    // Internet Explorer, Opera, Google Chrome and Safari
							      	bodyelem.addEventListener ("mousewheel", MouseScroll, false);
							        // Firefox
							      	bodyelem.addEventListener ("DOMMouseScroll", MouseScroll, false);
								}else 
								{
							      	if (elem.attachEvent) 
							      	{ 
									  	// IE before version 9
							          	elem.attachEvent ("onmousewheel", MouseScroll);
							      	}
								}

								//END execute on creation or reload
	 
	 							generalTimer();
								
								
								
								//****************************************************************************************************************************
								//*******************Session Guidance Start***********************************************************************************
								//****************************************************************************************************************************
								//var PageNameToTimerSessionGuidance 					= body_Id.substring(1,body_Id.length-1);
								//setTimerSessionGuidanceVerify('','','');
								//****************************************************************************************************************************
								//****************************************************************************************************************************
								
								scrollManagement();
								
								body_focus_check();
								/// general events here
								
								//  if (window.addEventListener) window.addEventListener('DOMMouseScroll', wheel, false);
								//  window.onmousewheel = document.onmousewheel = wheel;
								////////////////////////////////////////////////////////////
								//WHEEL EVENTS MANAGEMENT
								//////////////////////////////////////
								//manageTextSelection(document);
								//$(document).on('dblclick mousedown', '.prevent-select', false);
								//disableSelect(document);
								//manageTextSelection(document);
								//var body_backgrounder_id 						= document.body.id+"backgrounder|";
								//var body_backgrounder_el 						= document.getElementById(body_backgrounder_id);
								//body_backgrounder_el.style.backgroundImage	= 'url(images/body_texture.png)';
								//body_backgrounder_el.style.backgroundRepeat = 'repeat';
								//body_backgrounder_el.style.backgroundSize   = 'auto';
}

function retrieveScrollElementByMovableElementId(MovableElementIDIn)
{
										if(typeof arrayScrolls != "undefined" && arrayScrolls != null && arrayScrolls.length > 0)
										{
											for(var ffi=0;ffi<arrayScrolls.length;++ffi)
											{
												if (arrayScrolls[ffi].CursorElementId == MovableElementIDIn)
												{
													return ffi;
												}
											}
											return -1;
										}else
										{
											return -1;
										}
}

function scrollManagement_test()
{
	var mylayers = $(document).find('[class*="newlevellayer"]');
		console.log("_____________________________");
		console.log(mylayers);
		if (mylayers.length>0)		
		{
			for(var g=0;g<mylayers.length;++g)
			{
				console_log('layer:'+mylayers[g].id);
			var SW_list 	= null;
				if (mylayers[g] === document.body) 
				{
					SW_list 	= jQuery(document.getElementById(mylayers[g].id+'relative_stub|')).find('.IsSW');
				} else
				{
					SW_list 	= jQuery(mylayers[g]).find('.IsSW');
				}
				
			var depth_min 	= mylayers[g].id.split("|").length;
			var depth_max 	= mylayers[g].id.split("|").length;
			
				SW_list.each(
					function(index, item)
					{
					var	item_id = item.id;
					var depth = item_id.split("|").length;
						if (depth>depth_max) depth_max = depth;
					}
				);
				
			var layer_contentarea_el = document.getElementById(mylayers[g].id+"ContentArea|");
				//jQuery(layer_contentarea_el ).width(jQuery(mylayers[g]).width());
				//jQuery(layer_contentarea_el ).height(jQuery(mylayers[g]).height());
				
				jQuery(layer_contentarea_el).css("width",jQuery(mylayers[g]).width()+"px");
				jQuery(layer_contentarea_el).css("height",jQuery(mylayers[g]).height()+"px");

				console_log(' layer_contentarea_el.id:'+layer_contentarea_el.id+'   SW :'+mylayers[g].id+' item width:'+jQuery(layer_contentarea_el).width());

				
				for(var u=depth_min;u<=depth_max;++u)
				{
					SW_list.each(
						function(index, item)
						{
						var v = item.id.split("|").length;
							if (u==v)
							{
							var item_contentarea_el = document.getElementById(item.id+"ContentArea|");
								jQuery(item_contentarea_el ).width(jQuery(item).width());
								jQuery(item_contentarea_el ).height(jQuery(item).height());
								item_contentarea_el.style.width	=	jQuery(item).width()+'px';

								console_log(' SW _contentarea_el.id:'+item_contentarea_el.id+'   SW :'+item.id+' item width:'+jQuery(item).width());
							}
						}
					);
				}
				console_log("depth_min:"+depth_min+"  depth_max:"+depth_max);
			}
		} else
		{
			console_log('pp==================================qq');
		}
}

function checkScrollableElement(
	MyElementToCheckSliders,
    scrollableOBJ_ID,
    allow_show_scroller,
    is_device_mobile,
    String_scrollManagement,
    ContentMaxRight,
    ContentMinLeft,
    ContentMinTop,
    ContentMaxBottom,
    CursorTickness,
    zoom_css_component
) 
{
    // Method body starts here
    	//console_log(" =========== checkScrollableElement MyElementToCheckSliders:"+MyElementToCheckSliders.id);
    
	    if (
	        jQuery(MyElementToCheckSliders).hasClass("no_slider_hori") ||
	        jQuery(MyElementToCheckSliders).hasClass("no_slider_vert")
	    ) 
	    {
	        allow_show_scroller = false;
	    }
	    
	    if (is_device_mobile) { allow_show_scroller = false; }
    	//console_log(" checkScrollableElement allow_show_scroller:"+allow_show_scroller);
    
    var scroller_dock = document.getElementById(scrollableOBJ_ID).getAttribute("scroller_dock");
    var TestElement = document.getElementById(scroller_dock);
    var TestElement_Rect = TestElement.getBoundingClientRect();
    var TestElement_Top = parseInt(TestElement_Rect.top);
    var TestElement_Bottom = parseInt(TestElement_Rect.bottom);
    var TestElement_Left = parseInt(TestElement_Rect.left);
    var TestElement_Right = parseInt(TestElement_Rect.right);
    
 /*   TestElement_Top = 0;
    TestElement_Bottom = 0;
    TestElement_Left = 0;
    TestElement_Right = 0;
  */  
    
    
	    if (TestElement_Right > ContentMaxRight) { ContentMaxRight = TestElement_Right; }
	    if (TestElement_Left < ContentMinLeft) { ContentMinLeft = TestElement_Left; }
	    if (TestElement_Top < ContentMinTop) { ContentMinTop = TestElement_Top; }
	    if (TestElement_Bottom > ContentMaxBottom) { ContentMaxBottom = TestElement_Bottom; }
	    
	    String_scrollManagement += '\nunder test element:' + scrollableOBJ_ID + ' top : ' + TestElement_Top + ' bottom : ' + TestElement_Bottom + ' left : ' + TestElement_Left + ' right : ' + TestElement_Right;
    
    var TestElement_childs_Top = TestElement_Top;
    var TestElement_childs_Bottom = TestElement_Bottom - CursorTickness;
    var TestElement_childs_Left = TestElement_Left;
    var TestElement_childs_Right = TestElement_Right - CursorTickness;
    var TestElementContentArea_id = scroller_dock.replace('frame|', 'ContentArea|');
    var TestElementContentArea = document.getElementById(TestElementContentArea_id);
    var TestElement_childs = $(TestElementContentArea).children();
    
    var outbounding_els = jQuery(TestElementContentArea).children('.parent_outbounding').filter(
        function() {
            return $(this).is(':visible') && $(this).css('display') !== 'none';
        }
    	);
    
    	if (isValidElement(outbounding_els) && (outbounding_els.length > 0)) 
    	{
        	allow_show_scroller = false;
        var parent_sw_ContentArea_el = document.getElementById(MyElementToCheckSliders.id + "ContentArea|");
        var parent_sw_stub_el = document.getElementById(MyElementToCheckSliders.id + "relative_stub|");
        var parent_sw_frame_el = document.getElementById(MyElementToCheckSliders.id + "frame|");
        var parent_sw_el = document.getElementById(MyElementToCheckSliders.id);
	        jQuery(parent_sw_ContentArea_el).css("overflow", "visible");
	        jQuery(parent_sw_stub_el).css("overflow", "visible");
	        jQuery(parent_sw_frame_el).css("overflow", "visible");
	        jQuery(parent_sw_el).css("overflow", "visible");
    	}
    
	    jQuery(TestElementContentArea).css("width", jQuery(MyElementToCheckSliders).width() + "px");
	    jQuery(TestElementContentArea).css("height", jQuery(MyElementToCheckSliders).height() + "px");
    
	    for (var g = 0; g < TestElement_childs.length; ++g) 
	    {
	        if (
	            (TestElement_childs[g].className.indexOf("fill_viewport") == -1) &&
	            (
	                (TestElement_childs[g].className.indexOf("IsSW") > -1) ||
	                (TestElement_childs[g].className.indexOf("IsTE") > -1)
	            ) &&
	            (TestElement_childs[g].style.display != 'none') &&
	            (!jQuery(TestElement_childs[g]).hasClass('outbounding'))
	        ) 
	        {
				//console_log("A TestElement_childs[g].id:"+TestElement_childs[g].id+" TestElement_childs_Right:"+TestElement_childs_Right);
	        var thisRect = TestElement_childs[g].getBoundingClientRect();
	        var thisTop = parseInt(thisRect.top);
	        var thisBottom = parseInt(thisRect.bottom);
	        var thisLeft = parseInt(thisRect.left);
	        var thisRight = parseInt(thisRect.right);
	            
	            if (thisTop < TestElement_childs_Top) TestElement_childs_Top = thisTop;
	            if (thisBottom > TestElement_childs_Bottom) TestElement_childs_Bottom = thisBottom;
	            if (thisLeft < TestElement_childs_Left) TestElement_childs_Left = thisLeft;
	            if (thisRight > TestElement_childs_Right) { TestElement_childs_Right = thisRight;}
				//console_log("		B TestElement_childs[g].id:"+TestElement_childs[g].id+" TestElement_childs_Right:"+TestElement_childs_Right);
	        }
	    }
        //console_log(" checkScrollableElement allow_show_scroller 2:"+allow_show_scroller);

    var TestElement_Width 				= TestElement_Right - TestElement_Left;
    var TestElement_Height 				= TestElement_Bottom - TestElement_Top;
    
    	TestElement_Width 				= jQuery(TestElement).width();
    	TestElement_Height 				= jQuery(TestElement).height();
    
    var TestElement_childs_Width 		= parseInt((TestElement_childs_Right - TestElement_childs_Left) / zoom_css_component);
    var TestElement_childs_Height 		= parseInt((TestElement_childs_Bottom - TestElement_childs_Top) / zoom_css_component);
    var SatusSliders 					= " ";
    
	    // Return an object with all the values that were modified
	    return {
	        allow_show_scroller: allow_show_scroller,
	        String_scrollManagement: String_scrollManagement,
	        ContentMaxRight: ContentMaxRight,
	        ContentMinLeft: ContentMinLeft,
	        ContentMinTop: ContentMinTop,
	        ContentMaxBottom: ContentMaxBottom,
	        TestElement_childs_Top: TestElement_childs_Top,
	        TestElement_childs_Bottom: TestElement_childs_Bottom,
	        TestElement_childs_Left: TestElement_childs_Left,
	        TestElement_childs_Right: TestElement_childs_Right,
	        TestElement_Width: TestElement_Width,
	        TestElement_Height: TestElement_Height,
	        TestElement_childs_Width: TestElement_childs_Width,
	        TestElement_childs_Height: TestElement_childs_Height,
	        SatusSliders: SatusSliders,
	        TestElementContentArea:TestElementContentArea
	    };
}

function scrollManagement()
{//20190307
										//fill_viewport();//still not working
										
										//executeWrapContent(); //only per .IsSW (for other components use css/html standard behavior to fullfill the goal)
										//execute_fill_parents(); //many components not only .IsSW . start from external components

										//console_log("****************SCROLL MANAGEMENT*****************************");
	var									is_device_mobile						= false;
										if (jQuery(document.body).hasClass('device_mobile')){is_device_mobile=true;}
	var									BodyZIndex 								= 0;
										if(jQuery(document.body).css('z-index'))
										{
											BodyZIndex 							= parseInt(jQuery(document.body).css('z-index'));
										}
								var		SW_MaxLevelToCheck  					= getCurrentMaxNewLevelLayerVisibleAndFillingViewPort();
								var 	allow_show_scroller 					= true;
										//1. Is calculated the scroll position and visibility of scroll sliders inside any SW
										//2. Is calculated the space occupation of the whole html code into the document
										//document.body.style.border='15px solid red';
								var 	String_scrollManagement 				= "_";
										ContentMaxBottom 						= 0;
										ContentMaxRight 						= 0;
										//arrayScrollPrintList('***SCROLL MANAGEMENT BEGIN***');
										//console_log("ManageScrollableDIVS ++++++Checking SWs++++++");
								var 	scrollableOBJ_IDs						= new Array();
								var		AllOBJs 								= $(".IsSW");
								
								
								var 	max_depth 								= -1;
								
								var 	hasWrapcontentH = AllOBJs.is(".wrapcontent_h");
								var 	hasWrapcontentV = AllOBJs.is(".wrapcontent_v");
								
								var 	wrapTypes = [];  //'base_unwrap', 'base_wrap', 'wrap_h', 'wrap_v'];
										if (hasWrapcontentV||hasWrapcontentH) { wrapTypes.push('base_wrap');} else {wrapTypes.push('base_unwrap');}
										if (hasWrapcontentH) wrapTypes.push('wrapcontent_h');
										if (hasWrapcontentV) wrapTypes.push('wrapcontent_v');
										

										for(var y=0;y<AllOBJs.length;++y)
										{
										var depth = getIdentifierTokenDepth(AllOBJs[y].id);;
											if (depth>max_depth) {max_depth=depth;}
											
											if(jQuery(AllOBJs[y]).attr('ori_width') !== undefined)
											{
												jQuery(AllOBJs[y]).width(jQuery(AllOBJs[y]).attr('ori_width'));
											}
											if(jQuery(AllOBJs[y]).attr('ori_height') !== undefined)
											{
												jQuery(AllOBJs[y]).height(jQuery(AllOBJs[y]).attr('ori_height'));
											}
											
										var my_slider_supports 					= jQuery(AllOBJs[y]).find(".slider_support");
											if (isValidElement(my_slider_supports))
											{
												//console_log(" ------------ analyze:"+AllOBJs[y].id+"  found slider_support len:"+my_slider_supports.length);
												for(var c=0;c<my_slider_supports.length;++c)
												{
													//console_log(" ------------ analyze:"+AllOBJs[y].id+"  support id:"+my_slider_supports[c].id);
													if (isValidElement(my_slider_supports[c].parentNode))
													{
														//console_log(" ------------ analyze:"+AllOBJs[y].id+"  parentnode id:"+my_slider_supports[c].parentNode.id);
														if (parseInt(jQuery(AllOBJs[y]).css('z-index'))<SW_MaxLevelToCheck)
														{
															//console_log(" hide  ");
															jQuery(my_slider_supports[c].parentNode).css('visibility','hidden');
														} else
														{
															//console_log(" show  ");
															jQuery(my_slider_supports[c].parentNode).css('visibility','visible');
														}
													}
												}
											}
										var OBJ_tagName 						= AllOBJs[y].tagName;
											//to include TD too
											if ((OBJ_tagName.toUpperCase()=='TABLE')||(OBJ_tagName.toUpperCase()=='TD')||(OBJ_tagName.toUpperCase()=='DIV')||(OBJ_tagName.toUpperCase()=='BODY'))
											{
											var scroller_dock 					= AllOBJs[y].getAttribute("scroller_dock");
												if (scroller_dock!=null)
												{
													scrollableOBJ_IDs.push(AllOBJs[y].id);
												}
											}
											
										}
										
										scrollableOBJ_IDs.sort((a, b) => {
										    const priorityA = getIdentifierTokenDepth(a);
										    const priorityB = getIdentifierTokenDepth(b);
										    return priorityB - priorityA;  // Higher values first
										});										


										wrapTypes.forEach(function(dd_i) 
										{
											{
												if ((dd_i=='wrapcontent_h')||(dd_i=='wrapcontent_v'))
												{
													scrollableOBJ_IDs.sort((a, b) => {
													    const priorityA = getIdentifierTokenDepth(a);
													    const priorityB = getIdentifierTokenDepth(b);
													    return priorityB - priorityA;  // Higher values first
													});
												}
												for(var y=0;y<scrollableOBJ_IDs.length;++y)
												{
																	//console.log("  scrollableOBJ_IDs:"+scrollableOBJ_IDs[y]);
													
																	//In order to cover and measure the whole children area a dummy small IsTE object is inserted inside LayerContainer ContantArea in the Upper Left Corner
																var SatusSliders = "";
																	allow_show_scroller 				= true;
																	if (document.getElementById(scrollableOBJ_IDs[y]).tagName.toUpperCase()=='BODY')
																	{//scroll only on the higher level in stack
																		//if (BodyZIndex<=SW_MaxLevelToCheck)
																		if (BodyZIndex<SW_MaxLevelToCheck)
																		{
																			allow_show_scroller 		= false;
																		}
																	}//Question. Not to show slider or disallow their selection?
																	//MayBe Sliders Can not Be under layers that are filling viewport (fill_viewport)?
																	// Or they are not usable?
																	//console.log("  scrollableOBJ_IDs:"+scrollableOBJ_IDs[y]+"  __ allow_show_scroller:"+allow_show_scroller);
    															var MyElementToCheckSliders = document.getElementById(scrollableOBJ_IDs[y]);
																	
																var result_check = checkScrollableElement(MyElementToCheckSliders,scrollableOBJ_IDs[y], allow_show_scroller,is_device_mobile,String_scrollManagement,ContentMaxRight,ContentMinLeft,ContentMinTop,ContentMaxBottom,CursorTickness,zoom_css_component);																	
																	
																	
																	if(
																		(dd_i=='base_wrap') 
																	)
																	{
																		if (jQuery(MyElementToCheckSliders).hasClass('wrapcontent_v'))
																		{
																			if (hasHeightStyle(MyElementToCheckSliders,'inline')) jQuery(MyElementToCheckSliders).attr('ori_height', jQuery(MyElementToCheckSliders).height());
																			MyElementToCheckSliders.style.height 	= result_check.TestElement_childs_Height+'px';
																			result_check.TestElementContentArea.style.height 	= result_check.TestElement_childs_Height+'px';
																		}
																		if (jQuery(MyElementToCheckSliders).hasClass('wrapcontent_h'))
																		{
																			if (hasWidthStyle(MyElementToCheckSliders,'inline')) jQuery(MyElementToCheckSliders).attr('ori_width', jQuery(MyElementToCheckSliders).width());
																			MyElementToCheckSliders.style.width 	= result_check.TestElement_childs_Width+'px';
																			result_check.TestElementContentArea.style.width 	= result_check.TestElement_childs_Width+'px';
																			MyElementToCheckSliders.TestElementContentArea.style.width 	= result_check.TestElement_childs_Width+'px';
																		}
																	} 
																	
																	if (
																		(dd_i=='base_unwrap') 
																		||
																		(dd_i=='wrapcontent_h')
																		||
																		(dd_i=='wrapcontent_v')
																	)
																	{
																		jQuery(MyElementToCheckSliders).attr('chils','('+result_check.TestElement_childs_Width+','+result_check.TestElement_childs_Height+')');
																		jQuery(MyElementToCheckSliders).attr('container','('+result_check.TestElement_Width+','+result_check.TestElement_Height+')');
																		
																		if (
																				((result_check.TestElement_childs_Width		>	result_check.TestElement_Width				)&&(result_check.TestElement_childs_Height		>	result_check.TestElement_Height))
																			|| 	((result_check.TestElement_childs_Width		>	result_check.TestElement_Width				)&&(result_check.TestElement_childs_Height	-2 	>	result_check.TestElement_Height-CursorTickness))
																			||	((result_check.TestElement_childs_Width-2	>	result_check.TestElement_Width-CursorTickness)&&(result_check.TestElement_childs_Height		>	result_check.TestElement_Height))
																		)
																		{//both sliders....race is decreased by a CursorTickness Step
																			//smoothed treshold adding two limit cases
																			SatusSliders					+= "A. Both slider. zoom_css_component:"+zoom_css_component+" TestElement_childs_Width:"+result_check.TestElement_childs_Width+" >  TestElement_Width:"+result_check.TestElement_Width+" .";
																		var ContentArea_Elem 				= result_check.TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
																			ContentArea_Elem.style.height 	= result_check.TestElement_childs_Height+'px';
																			if(result_check.allow_show_scroller) setDivScroller(ContentArea_Elem,"overflow_V",CursorTickness);
																			ContentArea_Elem.style.width 	= result_check.TestElement_childs_Width+'px';
																			if(result_check.allow_show_scroller) setDivScroller(ContentArea_Elem,"overflow_H",CursorTickness);
																			if(!result_check.allow_show_scroller )
																			{
																				resetDivScroller(ContentArea_Elem,"overflow_H");
																				resetDivScroller(ContentArea_Elem,"overflow_V");
																				//console_log("Not allowing scroller:"+ContentArea_Elem.id);
																			}
																			if (is_device_mobile)
																			{
																				jQuery(ContentArea_Elem.parentNode).css('overflow-x','scroll');
																				jQuery(ContentArea_Elem.parentNode).css('overflow-y','scroll');
																			}
																			jQuery(MyElementToCheckSliders).attr('tsliders','both');
																			
																		} else
																		//console_log("cccccc  "+scroller_dock+" me:"+TestElement_Height+" childs:"+TestElement_childs_Height);
																		if ((result_check.TestElement_childs_Width	>	result_check.TestElement_Width)&&(result_check.TestElement_childs_Height	-2 <=	result_check.TestElement_Height-CursorTickness))
																		{//only H slider....remove V slider
																			SatusSliders					+= "B. Only H slider. allow_show_scroller:"+allow_show_scroller+"  ";
																		var ContentArea_Elem 				= result_check.TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
																			ContentArea_Elem.style.width 	= result_check.TestElement_childs_Width+'px';
																			if(result_check.allow_show_scroller) setDivScroller(ContentArea_Elem,"overflow_H",CursorTickness);
																			ContentArea_Elem.style.height	= result_check.TestElement_Height+'px';
																			resetDivScroller(ContentArea_Elem,"overflow_V");
																			if(!result_check.allow_show_scroller )
																			{
																				resetDivScroller(ContentArea_Elem,"overflow_H");
																				resetDivScroller(ContentArea_Elem,"overflow_V");
																			}
																			if (is_device_mobile)
																			{
																				jQuery(ContentArea_Elem.parentNode).css('overflow-x','scroll');
																			}
																			jQuery(MyElementToCheckSliders).attr('tsliders','ori');
																		} else
																		if ((result_check.TestElement_childs_Width-2	<=	result_check.TestElement_Width-CursorTickness)&&(result_check.TestElement_childs_Height	>	result_check.TestElement_Height))
																		{//only V slider....remove H slider
																			SatusSliders				   += "C. Only V slider. allow_show_scroller:"+allow_show_scroller;
																		var ContentArea_Elem 				= result_check.TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
																			ContentArea_Elem.style.height 	= result_check.TestElement_childs_Height+'px';
																			if(result_check.allow_show_scroller) setDivScroller(ContentArea_Elem,"overflow_V",CursorTickness);
																			ContentArea_Elem.style.width	= result_check.TestElement_Width+'px';
																			resetDivScroller(ContentArea_Elem,"overflow_H");
																			if(!result_check.allow_show_scroller )
																			{
																				resetDivScroller(ContentArea_Elem,"overflow_H");
																				resetDivScroller(ContentArea_Elem,"overflow_V");
																			}
																			if (is_device_mobile)
																			{
																				jQuery(ContentArea_Elem.parentNode).css('overflow-y','scroll');
																			}
																			jQuery(MyElementToCheckSliders).attr('tsliders','vert allow_show_scroller:'+allow_show_scroller);
																		} else
																		if ((result_check.TestElement_childs_Width	<	result_check.TestElement_Width)&&(result_check.TestElement_childs_Height	<	result_check.TestElement_Height))
																		{
																			//no slider....remove
																			SatusSliders+= "Z. No slider.";
																		var ContentArea_Elem 				= result_check.TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
																			ContentArea_Elem.style.height	= result_check.TestElement_Height+'px';
																			resetDivScroller(ContentArea_Elem,"overflow_V");
																			ContentArea_Elem.style.width	= result_check.TestElement_Width+'px';
																			resetDivScroller(ContentArea_Elem,"overflow_H");
																			if(!allow_show_scroller )
																			{
																				resetDivScroller(ContentArea_Elem,"overflow_H");
																				resetDivScroller(ContentArea_Elem,"overflow_V");
																			}
																			jQuery(MyElementToCheckSliders).attr('tsliders','none1');
																		} else
																		{
																			//no slider....remove
																			SatusSliders+= "ZZ. No slider.";
																		var ContentArea_Elem 				= result_check.TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
																			ContentArea_Elem.style.height	= result_check.TestElement_Height+'px';
																			resetDivScroller(ContentArea_Elem,"overflow_V");
																			ContentArea_Elem.style.width	= result_check.TestElement_Width+'px';
																			resetDivScroller(ContentArea_Elem,"overflow_H");
																			if(!result_check.allow_show_scroller )
																			{
																				resetDivScroller(ContentArea_Elem,"overflow_H");
																				resetDivScroller(ContentArea_Elem,"overflow_V");
																			}
																			jQuery(MyElementToCheckSliders).attr('tsliders','none2');
																		}
																	}
																	
						
																	
												}//loop across scrollableOBJ_IDs[]
											}
										}
									);									
										
}

function scrollManagement_upto_20260206()
{//20190307

										//fill_viewport();//still not working
										
										//executeWrapContent(); //only per .IsSW (for other components use css/html standard behavior to fullfill the goal)
										//execute_fill_parents(); //many components not only .IsSW . start from external components

										//console_log("****************SCROLL MANAGEMENT*****************************");
	var									is_device_mobile						= false;
										if (jQuery(document.body).hasClass('device_mobile')){is_device_mobile=true;}
	var									BodyZIndex 								= 0;
										if(jQuery(document.body).css('z-index'))
										{
											BodyZIndex 							= parseInt(jQuery(document.body).css('z-index'));
										}
								var		SW_MaxLevelToCheck  					= getCurrentMaxNewLevelLayerVisibleAndFillingViewPort();
								var 	allow_show_scroller 					= true;
										//1. Is calculated the scroll position and visibility of scroll sliders inside any SW
										//2. Is calculated the space occupation of the whole html code into the document
										//document.body.style.border='15px solid red';
								var 	String_scrollManagement 				= "_";
										ContentMaxBottom 						= 0;
										ContentMaxRight 						= 0;
										//arrayScrollPrintList('***SCROLL MANAGEMENT BEGIN***');
										//console_log("ManageScrollableDIVS ++++++Checking SWs++++++");
								var 	scrollableOBJ_IDs						= new Array();
								var		AllOBJs 								= $(".IsSW");
								
								
								var 	max_depth = -1;

										for(var y=0;y<AllOBJs.length;++y)
										{
										var depth = getIdentifierTokenDepth(AllOBJs[y].id);;
											if (depth>max_depth) {max_depth=depth;}
											
											
										var my_slider_supports 					= jQuery(AllOBJs[y]).find(".slider_support");
											if (isValidElement(my_slider_supports))
											{
												//console_log(" ------------ analyze:"+AllOBJs[y].id+"  found slider_support len:"+my_slider_supports.length);
												for(var c=0;c<my_slider_supports.length;++c)
												{
													//console_log(" ------------ analyze:"+AllOBJs[y].id+"  support id:"+my_slider_supports[c].id);
													if (isValidElement(my_slider_supports[c].parentNode))
													{
														//console_log(" ------------ analyze:"+AllOBJs[y].id+"  parentnode id:"+my_slider_supports[c].parentNode.id);
														if (parseInt(jQuery(AllOBJs[y]).css('z-index'))<SW_MaxLevelToCheck)
														{
															//console_log(" hide  ");
															jQuery(my_slider_supports[c].parentNode).css('visibility','hidden');
														} else
														{
															//console_log(" show  ");
															jQuery(my_slider_supports[c].parentNode).css('visibility','visible');
														}
													}
												}
											}
										var OBJ_tagName 						= AllOBJs[y].tagName;
											//to include TD too
											if ((OBJ_tagName.toUpperCase()=='TABLE')||(OBJ_tagName.toUpperCase()=='TD')||(OBJ_tagName.toUpperCase()=='DIV')||(OBJ_tagName.toUpperCase()=='BODY'))
											{
											var scroller_dock 					= AllOBJs[y].getAttribute("scroller_dock");
												if (scroller_dock!=null)
												{
													scrollableOBJ_IDs.push(AllOBJs[y].id);
												}
											}
										}
										
										/*
										scrollableOBJ_IDs.sort((a, b) => {
										    const priorityA = getIdentifierTokenDepth(a);
										    const priorityB = getIdentifierTokenDepth(b);
										    return priorityB - priorityA;  // Higher values first
										});
										
										console.log(scrollableOBJ_IDs);
										*/

										for(var y=0;y<scrollableOBJ_IDs.length;++y)
										{
											//if (max_depth>0)
											{
												//for(var qi=max_depth;qi>=0;--qi)
												{
																	//console.log("____________________________________________testing SW:"+scrollableOBJ_IDs[y]);
																	//In order to cover and measure the whole children area a dummy small IsTE object is inserted inside LayerContainer ContantArea in the Upper Left Corner
																	allow_show_scroller 				= true;
																	if (document.getElementById(scrollableOBJ_IDs[y]).tagName.toUpperCase()=='BODY')
																	{//scroll only on the higher level in stack
																		//if (BodyZIndex<=SW_MaxLevelToCheck)
																		if (BodyZIndex<SW_MaxLevelToCheck)
																		{
																			allow_show_scroller 		= false;
																		}
																	}//Question. Not to show slider or disallow their selection?
																	//MayBe Sliders Can not Be under layers that are filling viewport (fill_viewport)?
																	// Or they are not usable?
																	//////////////////AAAAAAAAAAAAASTART
															var		MyElementToCheckSliders				= document.getElementById(scrollableOBJ_IDs[y]);
																	//console.log('UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU');
																	//console.log('initial MyElementToCheckSliders.id:'+MyElementToCheckSliders.id+"  w:"+jQuery(MyElementToCheckSliders).width());
																	
																	if 	(
																		jQuery(MyElementToCheckSliders).hasClass("no_slider_hori")
																		||
																		jQuery(MyElementToCheckSliders).hasClass("no_slider_vert")
																	)
																	{//no slider by server command
																		allow_show_scroller 			= false;
																	}
																	if (is_device_mobile) 	{allow_show_scroller = false;}
																	//console_log("id:"+scrollableOBJ_IDs[y]+"  allow_show_scroller:"+allow_show_scroller);
															var		scroller_dock 						= document.getElementById(scrollableOBJ_IDs[y]).getAttribute("scroller_dock");
																								//console_log("oooo####Checking overflow status for SW : "+scrollableOBJ_IDs[y]+" scroller_dock : "+scroller_dock);
															var		TestElement 						= document.getElementById( scroller_dock);
															var		TestElement_Rect	  				= TestElement.getBoundingClientRect();
															var		TestElement_Top 					= parseInt(TestElement_Rect.top);
															var		TestElement_Bottom 					= parseInt(TestElement_Rect.bottom);
															var		TestElement_Left 					= parseInt(TestElement_Rect.left);
															var		TestElement_Right 					= parseInt(TestElement_Rect.right);
																	///////////////////////////////////////////////////////////////////////////////////
																	//		var 	TestElement_H					= TestElement_Bottom-TestElement_Top;
																	//		var 	TestElement_W					= TestElement_Right -TestElement_Left;
																	//
																	//		if (TestElement_W>$(window).width()) 	{alert("test element "+TestElement.id+" over body");TestElement.style.width 	= $(window).width()+"px";}
																	//		if (TestElement_H>$(window).height()) 	{alert("test element "+TestElement.id+" over body");TestElement.style.height 	= $(window).height()+"px";}
																	///////////////////////////////////////////////////////////////////////////////////
																	//not used 
																	if (TestElement_Right  > ContentMaxRight) 	{ContentMaxRight  = TestElement_Right   ;}
																	//not used
																	if (TestElement_Left   < ContentMinLeft)  	{ContentMinLeft   = TestElement_Left    ;}
																	//not used
																	if (TestElement_Top    < ContentMinTop ) 	{ContentMinTop    = TestElement_Top 	;}
																	//not used
																	if (TestElement_Bottom > ContentMaxBottom) 	{ContentMaxBottom = TestElement_Bottom  ;}
																	String_scrollManagement 			+= '\nunder test element:'+scrollableOBJ_IDs[y]+' top : '+TestElement_Top+' bottom : '+TestElement_Bottom+' left : '+TestElement_Left+' right : '+TestElement_Right;
						
																	//console.log("id:"+scrollableOBJ_IDs[y]+"  ContentMaxRight: "+ContentMaxRight+" ContentMaxBottom : "+ContentMaxBottom);
																	//alert('TestElement_Left:'+TestElement_Left+'  TestElement_Right : '+TestElement_Right)
																	//console_log('        __________under test element:'+scrollableOBJ_IDs[y]+' top : '+TestElement_Top+' bottom : '+TestElement_Bottom+' left : '+TestElement_Left+' right : '+TestElement_Right);
															var 	TestElement_childs_Top 			= TestElement_Top;
															var 	TestElement_childs_Bottom 		= TestElement_Bottom-CursorTickness;
															var 	TestElement_childs_Left 		= TestElement_Left;
															var 	TestElement_childs_Right 		= TestElement_Right -CursorTickness;
															var 	TestElementContentArea_id 		= scroller_dock.replace('frame|','ContentArea|');
															var 	TestElementContentArea			= document.getElementById(TestElementContentArea_id);
															var 	TestElement_childs 				= $(TestElementContentArea).children();
															//var 	outbounding_els 				= jQuery(TestElementContentArea).children('.parent_outbounding');
								
															var 	outbounding_els 				= jQuery(TestElementContentArea).children('.parent_outbounding').filter
																	(
																		function() {
																	    return $(this).is(':visible') && $(this).css('display') !== 'none';
																	  	}
																  	);
						
																	if (isValidElement(outbounding_els)&&(outbounding_els.length>0))
																	{
																		allow_show_scroller 			= false;
																var 	parent_sw_ContentArea_el 		= document.getElementById(MyElementToCheckSliders.id+"ContentArea|");
																var 	parent_sw_stub_el 				= document.getElementById(MyElementToCheckSliders.id+"relative_stub|");
																var 	parent_sw_frame_el 				= document.getElementById(MyElementToCheckSliders.id+"frame|");
																var 	parent_sw_el 					= document.getElementById(MyElementToCheckSliders.id);
																		jQuery(parent_sw_ContentArea_el).css("overflow","visible");
																		jQuery(parent_sw_stub_el).css("overflow","visible");
																		jQuery(parent_sw_frame_el).css("overflow","visible");
																		jQuery(parent_sw_el).css("overflow","visible");
																	}
																	
																	//reset contentArea dimensions to its SW owner	
																	jQuery(TestElementContentArea).css("width",jQuery(MyElementToCheckSliders).width()+"px");
																	jQuery(TestElementContentArea).css("height",jQuery(MyElementToCheckSliders).height()+"px");
																	
																	//console_log("MyElementToCheckSliders.id:"+MyElementToCheckSliders.id+"  w:"+jQuery(MyElementToCheckSliders).width());
						
																	//console_log("MMMMMM TestElement_childs of :"+MyElementToCheckSliders.id+"OOPPM");
																	//console.log(TestElement_childs);
																	//only first level children
																	for(var g=0;g<TestElement_childs.length;++g)
																	{
																		//Is it possible that not only IsSws elements are to be measured
																		//but other elements too.
																		//E.g. HTMLEnhancedTagExtension are to be measured
																		//However at the moment HTMLEnhancedTagExtension have an IsSW class too
																		//Only visible elements (e.g. display not 'none') are tested
																		//var scroller_dock_loop 				= TestElement_childs[g].getAttribute("scroller_dock");
																		//console_log("vvvvvvv scrollableOBJ_IDs[y] "+scrollableOBJ_IDs[y]+" scroller_dock_loop : "+scroller_dock_loop);
																		//console_log("		elaborating child : "+g+" "+TestElement_childs[g].id+" scroller_dock_loop:"+scroller_dock_loop+"<");
																		//if ((TestElement_childs[g].className.indexOf("fill_viewport")==-1)&&(TestElement_childs[g].className.indexOf("IsSW")>-1)&&(TestElement_childs[g].style.display!='none')&&(scroller_dock_loop!=null))
																		//20150503 ...... removed the test on scroller_dock_loop......was not working with TreeManager.....working now
																		if (
																				(TestElement_childs[g].className.indexOf("fill_viewport")==-1)
																				&&
																				(
																						(TestElement_childs[g].className.indexOf("IsSW")>-1)
																						||
																						(TestElement_childs[g].className.indexOf("IsTE")>-1)
																						//TE elements added on 20181026....to keep an eye on it
																				)
																				&&
																				(TestElement_childs[g].style.display!='none')
																				&&
																				(!jQuery(TestElement_childs[g]).hasClass('outbounding'))
																			)
																		{
																			//console_log("                    results for : "+TestElement_childs[g].id);
																			//var thisElement 				= TestElement_childs[g];
																	var 	thisRect	  				= TestElement_childs[g].getBoundingClientRect();
																	var 	thisTop     				= parseInt(thisRect.top);
																	var 	thisBottom  				= parseInt(thisRect.bottom);
																	var 	thisLeft    				= parseInt(thisRect.left);
																	var 	thisRight   				= parseInt(thisRect.right);
																			if (thisTop   <TestElement_childs_Top   ) TestElement_childs_Top	= thisTop;
																			if (thisBottom>TestElement_childs_Bottom) TestElement_childs_Bottom	= thisBottom;
																			if (thisLeft  <TestElement_childs_Left  ) TestElement_childs_Left	= thisLeft;
																			if (thisRight >TestElement_childs_Right ) 
																			{
																				TestElement_childs_Right	= thisRight;
																				//console_log("-----parent:"+scrollableOBJ_IDs[y]+"<	me:"+TestElement_childs[g].id+"		 results print : "+TestElement_childs[g].id+" thisBottom:"+thisBottom+ "thisRight : "+thisRight);
																			}
																			//console_log("		parent:"+scrollableOBJ_IDs[y]+"<			 results print : "+TestElement_childs[g].id+" thisTop:"+thisTop+" thisBottom:"+thisBottom+" thisLeft:"+thisLeft+" thisRight : "+thisRight);
																			//console_log("-----parent:"+scrollableOBJ_IDs[y]+"<	me:"+TestElement_childs[g].id+"		 results print : "+TestElement_childs[g].id+" thisBottom:"+thisBottom+ "thisRight : "+thisRight);
																			//console.log(TestElement_childs[g]);
																			//console.log(" thisRight:"+thisRight+"  thisLeft:"+thisLeft+" zoom:"+zoom_css_component);
																			
																		}
																	}//TestElement_childs loop end
						
															var 	TestElement_Width  					= TestElement_Right -TestElement_Left;
															var 	TestElement_Height 					= TestElement_Bottom-TestElement_Top;
																	
																	TestElement_Width 					= jQuery(TestElement).width();
																	TestElement_Height 					= jQuery(TestElement).height();
															var 	TestElement_childs_Width  			= parseInt( (TestElement_childs_Right -TestElement_childs_Left)/zoom_css_component ) ;
															var 	TestElement_childs_Height 			= parseInt( (TestElement_childs_Bottom-TestElement_childs_Top)/zoom_css_component );
															var 	SatusSliders						= " ";
						
																	//console_log(" zoom_css_component :"+zoom_css_component);
																	//console_log("test element : "+scroller_dock+" me: (W:"+TestElement_Width+",H:"+TestElement_Height+") childs (W:"+TestElement_childs_Width+",H:"+TestElement_childs_Height+")");
																	//////////////////AAAAAAAAAAAAAEND
																	jQuery(MyElementToCheckSliders).attr('chils','('+TestElement_childs_Width+','+TestElement_childs_Height+')');
																	jQuery(MyElementToCheckSliders).attr('container','('+TestElement_Width+','+TestElement_Height+')');
																	if (
																			((TestElement_childs_Width		>	TestElement_Width				)&&(TestElement_childs_Height		>	TestElement_Height))
																		|| 	((TestElement_childs_Width		>	TestElement_Width				)&&(TestElement_childs_Height	-2 	>	TestElement_Height-CursorTickness))
																		||	((TestElement_childs_Width-2	>	TestElement_Width-CursorTickness)&&(TestElement_childs_Height		>	TestElement_Height))
																	)
																	{//both sliders....race is decreased by a CursorTickness Step
																		//smoothed treshold adding two limit cases
																		SatusSliders					+= "A. Both slider. zoom_css_component:"+zoom_css_component+" TestElement_childs_Width:"+TestElement_childs_Width+" >  TestElement_Width:"+TestElement_Width+" .";
																	var ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
																		ContentArea_Elem.style.height 	= TestElement_childs_Height+'px';
																		if(allow_show_scroller) setDivScroller(ContentArea_Elem,"overflow_V",CursorTickness);
																		ContentArea_Elem.style.width 	= TestElement_childs_Width+'px';
																		if(allow_show_scroller) setDivScroller(ContentArea_Elem,"overflow_H",CursorTickness);
																		if(!allow_show_scroller )
																		{
																			resetDivScroller(ContentArea_Elem,"overflow_H");
																			resetDivScroller(ContentArea_Elem,"overflow_V");
																			//console_log("Not allowing scroller:"+ContentArea_Elem.id);
																		}
																		if (is_device_mobile)
																		{
																			jQuery(ContentArea_Elem.parentNode).css('overflow-x','scroll');
																			jQuery(ContentArea_Elem.parentNode).css('overflow-y','scroll');
																		}
																		jQuery(MyElementToCheckSliders).attr('tsliders','both');
																	} else
																	//console_log("cccccc  "+scroller_dock+" me:"+TestElement_Height+" childs:"+TestElement_childs_Height);
																	if ((TestElement_childs_Width	>	TestElement_Width)&&(TestElement_childs_Height	-2 <=	TestElement_Height-CursorTickness))
																	{//only H slider....remove V slider
																		SatusSliders					+= "B. Only H slider. allow_show_scroller:"+allow_show_scroller+"  ";
																	var ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
																		ContentArea_Elem.style.width 	= TestElement_childs_Width+'px';
																		if(allow_show_scroller) setDivScroller(ContentArea_Elem,"overflow_H",CursorTickness);
																		ContentArea_Elem.style.height	= TestElement_Height+'px';
																		resetDivScroller(ContentArea_Elem,"overflow_V");
																		if(!allow_show_scroller )
																		{
																			resetDivScroller(ContentArea_Elem,"overflow_H");
																			resetDivScroller(ContentArea_Elem,"overflow_V");
																		}
																		if (is_device_mobile)
																		{
																			jQuery(ContentArea_Elem.parentNode).css('overflow-x','scroll');
																		}
																		jQuery(MyElementToCheckSliders).attr('tsliders','ori');
																	} else
																	if ((TestElement_childs_Width-2	<=	TestElement_Width-CursorTickness)&&(TestElement_childs_Height	>	TestElement_Height))
																	{//only V slider....remove H slider
																		SatusSliders				   += "C. Only V slider. allow_show_scroller:"+allow_show_scroller;
																	var ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
																		ContentArea_Elem.style.height 	= TestElement_childs_Height+'px';
																		if(allow_show_scroller) setDivScroller(ContentArea_Elem,"overflow_V",CursorTickness);
																		ContentArea_Elem.style.width	= TestElement_Width+'px';
																		resetDivScroller(ContentArea_Elem,"overflow_H");
																		if(!allow_show_scroller )
																		{
																			resetDivScroller(ContentArea_Elem,"overflow_H");
																			resetDivScroller(ContentArea_Elem,"overflow_V");
																		}
																		if (is_device_mobile)
																		{
																			jQuery(ContentArea_Elem.parentNode).css('overflow-y','scroll');
																		}
																		jQuery(MyElementToCheckSliders).attr('tsliders','vert allow_show_scroller:'+allow_show_scroller);
																	} else
																	if ((TestElement_childs_Width	<	TestElement_Width)&&(TestElement_childs_Height	<	TestElement_Height))
																	{
																		//no slider....remove
																		SatusSliders+= "Z. No slider.";
																	var ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
																		ContentArea_Elem.style.height	=	TestElement_Height+'px';
																		resetDivScroller(ContentArea_Elem,"overflow_V");
																		ContentArea_Elem.style.width	=	TestElement_Width+'px';
																		resetDivScroller(ContentArea_Elem,"overflow_H");
																		if(!allow_show_scroller )
																		{
																			resetDivScroller(ContentArea_Elem,"overflow_H");
																			resetDivScroller(ContentArea_Elem,"overflow_V");
																		}
																		jQuery(MyElementToCheckSliders).attr('tsliders','none1');
																	} else
																	{
																		//no slider....remove
																		SatusSliders+= "ZZ. No slider.";
																	var ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
																		ContentArea_Elem.style.height	= TestElement_Height+'px';
																		resetDivScroller(ContentArea_Elem,"overflow_V");
																		ContentArea_Elem.style.width	= TestElement_Width+'px';
																		resetDivScroller(ContentArea_Elem,"overflow_H");
																		if(!allow_show_scroller )
																		{
																			resetDivScroller(ContentArea_Elem,"overflow_H");
																			resetDivScroller(ContentArea_Elem,"overflow_V");
																		}
																		jQuery(MyElementToCheckSliders).attr('tsliders','none2');
																	} 
																	//console_log(" a:"+(TestElement_childs_Width-2)+" b:"+(TestElement_Width-CursorTickness) +"  TestElement_childs_Height:"+TestElement_childs_Height+"  TestElement_Height:"+TestElement_Height );
						
																	/*
																	if ((TestElement_childs_Width	>	TestElement_Width)&&(TestElement_childs_Height	>	TestElement_Height-CursorTickness))			
																	{//Both sliders...Race is decreased by CursorTickness value
																		SatusSliders+= "D. Both sliders.";
																	var ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
																		ContentArea_Elem.style.width 	= TestElement_childs_Width+'px';
																		if(allow_show_scroller) setDivScroller(ContentArea_Elem,"overflow_H",CursorTickness);
																		ContentArea_Elem.style.height 	= TestElement_childs_Height+'px';
																		if(allow_show_scroller) setDivScroller(ContentArea_Elem,"overflow_V",CursorTickness);
																		if(!allow_show_scroller )
																		{
																			resetDivScroller(ContentArea_Elem,"overflow_H");
																			resetDivScroller(ContentArea_Elem,"overflow_V");
																		}
																		if (is_device_mobile)
																		{
																			jQuery(ContentArea_Elem.parentNode).css('overflow-x','scroll');
																			jQuery(ContentArea_Elem.parentNode).css('overflow-y','scroll');
																		}
																	}
						
						
																	//console_log("TestElement_childs_Width:"+TestElement_childs_Width+"  TestElement_Width:"+TestElement_Width+"   CursorTickness:"+CursorTickness);	
																	if ((TestElement_childs_Width-2	>	TestElement_Width-CursorTickness)&&(TestElement_childs_Height	>	TestElement_Height))			
																	{//Both sliders....Race is decreased by CursorTickness value
																		SatusSliders					+= "F. Both sliders. TestElement_Width:"+TestElement_Width+"  TestElement_childs_Width:"+TestElement_childs_Width+"  TestElement_childs_Height:"+TestElement_childs_Height+"  TestElement_Height:"+TestElement_Height;
																	var ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
																		ContentArea_Elem.style.height 	= TestElement_childs_Height+'px';
																		if(allow_show_scroller) setDivScroller(ContentArea_Elem,"overflow_V",CursorTickness);
																		ContentArea_Elem.style.width 	= TestElement_childs_Width+'px';
																		if(allow_show_scroller) setDivScroller(ContentArea_Elem,"overflow_H",CursorTickness);
																		if(!allow_show_scroller )
																		{
																			resetDivScroller(ContentArea_Elem,"overflow_H");
																			resetDivScroller(ContentArea_Elem,"overflow_V");
																		}
																		if (is_device_mobile)
																		{
																			jQuery(ContentArea_Elem.parentNode).css('overflow-y','scroll');
																			jQuery(ContentArea_Elem.parentNode).css('overflow-x','scroll');
																		}
																	}
																	*/
																	//if (SatusSliders.length<3) {SatusSliders = "No slider....";}
																	
																	//if (document.getElementById(scrollableOBJ_IDs[y]).tagName.toUpperCase()=='BODY')
																	//{
																	//	console_log("______________________________ body......childs W:"+TestElement_childs_Width	+" body W:"+	TestElement_Width+"  SatusSliders:"+SatusSliders);
																	//} else
																	//{
																	//	console_log("under test id:"+scrollableOBJ_IDs[y]+" obj W:"+jQuery(MyElementToCheckSliders).width()+" obj H:"+jQuery(MyElementToCheckSliders).height()+	" CA W:"+jQuery(TestElementContentArea).width()+" CA H:"+jQuery(TestElementContentArea).height()+"  SatusSliders:"+SatusSliders);
																	//}
																	//console_log(",,,,,,,,##############################Slider Status for element  "+scrollableOBJ_IDs[y]+"klkl  "+SatusSliders+"    TestElementContentArea.heigth:"+TestElementContentArea.style.height);
												}											
											}
										}//loop across scrollableOBJ_IDs[]
										
										
										//arrayScrollPrintList('\n***END OF scrollManagement***\n');
										/*if 
										(
											(TestElement_childs_Width	>	TestElement_Width)
											&&
											(TestElement_childs_Height	>	TestElement_Height)
										)
										{
											var ContentArea_Elem 			= TestElementContentArea;
											var offset						= CursorTickness;
											ContentArea_Elem.style.width 	= TestElement_childs_Width+'px';
											setDivScroller(ContentArea_Elem,"overflow_H",offset);
											ContentArea_Elem.style.height 	= TestElement_childs_Height+'px';
											setDivScroller(ContentArea_Elem,"overflow_V",offset);
										}else
										{
												var GapShiftH = 0;
												var GapShiftV = 0;
												if (TestElement_childs_Width	>	TestElement_Width	) 		GapShiftV = CursorTickness;
												if (TestElement_childs_Height	>	TestElement_Height	) 		GapShiftH = CursorTickness;
												if (TestElement_childs_Width+GapShiftH>TestElement_Width)
												{	
														var ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
														ContentArea_Elem.style.width 	= TestElement_childs_Width+'px';
														//var scrollElementchk   = retrieveScrollElementById(scrollableOBJ_IDs[y]+'frame|','');
														//if (scrollElementchk > -1 ) arrayScrolls.splice(scrollElementchk);
														setDivScroller(ContentArea_Elem,"overflow_H",GapShiftH);
												}else
												{
														var ContentArea_Elem 			= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
														ContentArea_Elem.style.width	=	TestElement_Width+'px';
														resetDivScroller(ContentArea_Elem,"overflow_H");
												}
												if (TestElement_childs_Height+GapShiftV>TestElement_Height)
												{	
														var ContentArea_Elem 			= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
														
														ContentArea_Elem.style.height 	= TestElement_childs_Height+'px';
														//var scrollElementchk   = retrieveScrollElementById(scrollableOBJ_IDs[y]+'frame|','');
														//if (scrollElementchk > -1 ) arrayScrolls.splice(scrollElementchk);
														setDivScroller(ContentArea_Elem,"overflow_V",GapShiftV);
												}
												else
												{
														var ContentArea_Elem 			= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
														ContentArea_Elem.style.height	=	TestElement_Height+'px';
														resetDivScroller(ContentArea_Elem,"overflow_V");
												}
										}*/
										//execute_fill_parents();
}

function scrollManagement_old2()
{//20160612
	
		//1. Is calculated the scroll position and visibility of scroll sliders inside any SW
		//2. Is calculated the space occupation of the whole html code into the document

	//var String_scrollManagement = "_";

		ContentMaxBottom 		= 0;
		ContentMaxRight 		= 0;

	//arrayScrollPrintList('***SCROLL MANAGEMENT BEGIN***');
	//console_log("ManageScrollableDIVS ++++++Checking SWs++++++");
	var scrollableOBJ_IDs		= new Array();
	var AllOBJs 		    	= $(".IsSW");
		for(var y=0;y<AllOBJs.length;++y)
		{
		var OBJ_tagName =  AllOBJs[y].tagName;
		//to include TD too
			if ((OBJ_tagName.toUpperCase()=='DIV')||(OBJ_tagName.toUpperCase()=='BODY'))
			{
				var scroller_dock = AllOBJs[y].getAttribute("scroller_dock");
				if (scroller_dock!=null)
				{	
					scrollableOBJ_IDs.push(AllOBJs[y].id);
				}
			}
		}
		for(var y=0;y<scrollableOBJ_IDs.length;++y)
		{
		var scroller_dock 				= document.getElementById(scrollableOBJ_IDs[y]).getAttribute("scroller_dock");
			//console_log("####Checking overflow status for SW : "+scrollableOBJ_IDs[y]+" scroller_dock : "+scroller_dock);
		var TestElement 				= document.getElementById( scroller_dock);
		var TestElement_Rect	  		= TestElement.getBoundingClientRect();

		var TestElement_Top 			= parseInt(TestElement_Rect.top);
		var TestElement_Bottom 			= parseInt(TestElement_Rect.bottom);
		var TestElement_Left 			= parseInt(TestElement_Rect.left);
		var TestElement_Right 			= parseInt(TestElement_Rect.right);

			if (TestElement_Right  > ContentMaxRight) 	{ContentMaxRight  = TestElement_Right   ;}
			if (TestElement_Left   < ContentMinLeft)  	{ContentMinLeft   = TestElement_Left    ;}
			
			if (TestElement_Top    < ContentMinTop ) 	{ContentMinTop    = TestElement_Top 	;} 
			if (TestElement_Bottom > ContentMaxBottom) 	{ContentMaxBottom = TestElement_Bottom  ;} 
			String_scrollManagement += '\nunder test element:'+scrollableOBJ_IDs[y]+' top : '+TestElement_Top+' bottom : '+TestElement_Bottom+' left : '+TestElement_Left+' right : '+TestElement_Right;

			//	console.log("id:"+scrollableOBJ_IDs[y]+"  ContentMaxRight: "+ContentMaxRight+" left : "+TestElement_Left);
			//	alert('TestElement_Left:'+TestElement_Left+'  TestElement_Right : '+TestElement_Right)
			//console_log('        __________under test element:'+scrollableOBJ_IDs[y]+' top : '+TestElement_Top+' bottom : '+TestElement_Bottom+' left : '+TestElement_Left+' right : '+TestElement_Right);

		var TestElement_childs_Top 		= TestElement_Top;
		var TestElement_childs_Bottom 	= TestElement_Bottom-CursorTickness;
		var TestElement_childs_Left 	= TestElement_Left;
		var TestElement_childs_Right 	= TestElement_Right -CursorTickness;
		var TestElementContentArea_id 	= scroller_dock.replace('frame|','ContentArea|');
		var TestElementContentArea    	= document.getElementById(TestElementContentArea_id);
		var TestElement_childs 			= $(TestElementContentArea).children();
			for(var g=0;g<TestElement_childs.length;++g)
			{
				//Is it possible that not only IsSws elements are to be measured
				//but other elements too.
				//E.g. HTMLEnhancedTagExtension are to be measured
				//However at the moment HTMLEnhancedTagExtension have an IsSW class too
				//Only visible elements (e.g. display not 'none') are tested
			
			var scroller_dock_loop 				= TestElement_childs[g].getAttribute("scroller_dock");
			
				//console_log("vvvvvvv scrollableOBJ_IDs[y] "+scrollableOBJ_IDs[y]+" scroller_dock_loop : "+scroller_dock_loop);
				//console_log("		elaborating child : "+g+" "+TestElement_childs[g].id+" scroller_dock_loop:"+scroller_dock_loop+"<");
				//if ((TestElement_childs[g].className.indexOf("fill_viewport")==-1)&&(TestElement_childs[g].className.indexOf("IsSW")>-1)&&(TestElement_childs[g].style.display!='none')&&(scroller_dock_loop!=null))
				//20150503 ...... removed the test on scroller_dock_loop......was not working with TreeManager.....working now
				if ((TestElement_childs[g].className.indexOf("fill_viewport")==-1)&&(TestElement_childs[g].className.indexOf("IsSW")>-1)&&(TestElement_childs[g].style.display!='none'))
				{
				//console_log("                    results for : "+TestElement_childs[g].id);
				var thisRect	  				= TestElement_childs[g].getBoundingClientRect();
				
				var thisTop     				= parseInt(thisRect.top);
				var thisBottom  				= parseInt(thisRect.bottom);
				var thisLeft    				= parseInt(thisRect.left);
				var thisRight   				= parseInt(thisRect.right);
    
				if (thisTop   <TestElement_childs_Top   ) TestElement_childs_Top    = thisTop;
				if (thisBottom>TestElement_childs_Bottom) TestElement_childs_Bottom = thisBottom;
				if (thisLeft  <TestElement_childs_Left  ) TestElement_childs_Left   = thisLeft;
				if (thisRight >TestElement_childs_Right ) TestElement_childs_Right  = thisRight;
				
				//String_scrollManagement += "\n     testing child : "+TestElement_childs[g].id+" thisTop:"+thisTop+" thisBottom:"+thisBottom+" thisLeft:"+thisLeft+" thisRight : "+thisRight;
				
				//console_log("					 results print : "+TestElement_childs[g].id+" thisTop:"+thisTop+" thisBottom:"+thisBottom+" thisLeft:"+thisLeft+" thisRight : "+thisRight);

				}
			}
		var TestElement_Width  			= TestElement_Right -TestElement_Left;
		var TestElement_Height 			= TestElement_Bottom-TestElement_Top;

		var TestElement_childs_Width  	= TestElement_childs_Right -TestElement_childs_Left;
		var TestElement_childs_Height 	= TestElement_childs_Bottom-TestElement_childs_Top;
		
		var SatusSliders				= " ";
		
		/*
		if 
		(
			(TestElement_childs_Width	>	TestElement_Width)
			&&
			(TestElement_childs_Height	>	TestElement_Height)
		)	
		{
		
			var ContentArea_Elem 			= TestElementContentArea;
			var offset						= CursorTickness;
			ContentArea_Elem.style.width 	= TestElement_childs_Width+'px';
			setDivScroller(ContentArea_Elem,"overflow_H",offset);
			
			ContentArea_Elem.style.height 	= TestElement_childs_Height+'px';
			setDivScroller(ContentArea_Elem,"overflow_V",offset);


		}
		else
		{
			
				var GapShiftH = 0;
				var GapShiftV = 0;
				if (TestElement_childs_Width	>	TestElement_Width	) 		GapShiftV = CursorTickness;
				if (TestElement_childs_Height	>	TestElement_Height	) 		GapShiftH = CursorTickness;
				if (TestElement_childs_Width+GapShiftH>TestElement_Width)
				{	
						var ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
						
						ContentArea_Elem.style.width 	= TestElement_childs_Width+'px';
						//var scrollElementchk   = retrieveScrollElementById(scrollableOBJ_IDs[y]+'frame|','');
						//if (scrollElementchk > -1 ) arrayScrolls.splice(scrollElementchk);
						setDivScroller(ContentArea_Elem,"overflow_H",GapShiftH);
				}
				else
				{
						var ContentArea_Elem 			= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
		
						ContentArea_Elem.style.width	=	TestElement_Width+'px';
						resetDivScroller(ContentArea_Elem,"overflow_H");
				}
				
				if (TestElement_childs_Height+GapShiftV>TestElement_Height)
				{	
						var ContentArea_Elem 			= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
						
						ContentArea_Elem.style.height 	= TestElement_childs_Height+'px';
						//var scrollElementchk   = retrieveScrollElementById(scrollableOBJ_IDs[y]+'frame|','');
						//if (scrollElementchk > -1 ) arrayScrolls.splice(scrollElementchk);
						setDivScroller(ContentArea_Elem,"overflow_V",GapShiftV);
				}
				else
				{
						var ContentArea_Elem 			= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
		
						ContentArea_Elem.style.height	=	TestElement_Height+'px';
						resetDivScroller(ContentArea_Elem,"overflow_V");
				}

		}
		*/
		
			if ((TestElement_childs_Width	>	TestElement_Width)&&(TestElement_childs_Height	>	TestElement_Height))			
			{//both sliders....race is decreased by a CursorTickness Step
				SatusSliders+= "A. Both slider.";
		var 	ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
			
				ContentArea_Elem.style.height 	= TestElement_childs_Height+'px';
				setDivScroller(ContentArea_Elem,"overflow_V",CursorTickness);
			
				ContentArea_Elem.style.width 	= TestElement_childs_Width+'px';
				setDivScroller(ContentArea_Elem,"overflow_H",CursorTickness);
			}

			if ((TestElement_childs_Width	<	TestElement_Width)&&(TestElement_childs_Height	<	TestElement_Height))			
			{
				//no slider....remove
				SatusSliders+= "B. No slider.";

		var 	ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
			
				ContentArea_Elem.style.height	=	TestElement_Height+'px';
				resetDivScroller(ContentArea_Elem,"overflow_V");
				ContentArea_Elem.style.width	=	TestElement_Width+'px';
				resetDivScroller(ContentArea_Elem,"overflow_H");
			}
		
			if ((TestElement_childs_Width	>	TestElement_Width)&&(TestElement_childs_Height	<=	TestElement_Height-CursorTickness))			
			{//only H slider....remove V slider
			
				SatusSliders+= "C. Only H slider.";
			
		var 	ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
						
				ContentArea_Elem.style.width 	= TestElement_childs_Width+'px';
				setDivScroller(ContentArea_Elem,"overflow_H",0);
				ContentArea_Elem.style.height	= TestElement_Height+'px';
				resetDivScroller(ContentArea_Elem,"overflow_V");
			}
			if ((TestElement_childs_Width	>	TestElement_Width)&&(TestElement_childs_Height	>	TestElement_Height-CursorTickness))			
			{//Both sliders...Race is decresed by CursorTickness value

				SatusSliders+= "D. Both sliders.";

		var 	ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');
			
				ContentArea_Elem.style.width 	= TestElement_childs_Width+'px';
				setDivScroller(ContentArea_Elem,"overflow_H",CursorTickness);

				ContentArea_Elem.style.height 	= TestElement_childs_Height+'px';
				setDivScroller(ContentArea_Elem,"overflow_V",CursorTickness);
			}

			if ((TestElement_childs_Width	<=	TestElement_Width-CursorTickness)&&(TestElement_childs_Height	>	TestElement_Height))			
			{//only V slider....remove H slider

				SatusSliders				   += "E. Only V slider.";

			var ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');

				ContentArea_Elem.style.height 	= TestElement_childs_Height+'px';
				setDivScroller(ContentArea_Elem,"overflow_V",0);
			
				ContentArea_Elem.style.width	=	TestElement_Width+'px';
				resetDivScroller(ContentArea_Elem,"overflow_H");
			}

			if ((TestElement_childs_Width	>	TestElement_Width-CursorTickness)&&(TestElement_childs_Height	>	TestElement_Height))			
			{//Both sliders....Race is decresed by CursorTickness value

				SatusSliders+= "F. Both sliders.";

			var ContentArea_Elem 				= TestElementContentArea;//document.getElementById(parent_Id+'ContentArea|');

				ContentArea_Elem.style.height 	= TestElement_childs_Height+'px';
				setDivScroller(ContentArea_Elem,"overflow_V",CursorTickness);

				ContentArea_Elem.style.width 	= TestElement_childs_Width+'px';
				setDivScroller(ContentArea_Elem,"overflow_H",CursorTickness);
			}
			if (SatusSliders.length<3) {SatusSliders = "No slider....";}
			//console_log("####Slider Status for element  "+scrollableOBJ_IDs[y]+"  "+SatusSliders);		
		}//loop across scrollableOBJ_IDs[] 
		//arrayScrollPrintList('\n***END OF scrollManagement***\n');
}

/*
function scrollManagement_old(ElemsToCheck)
{
	if (ElemsToCheck!=null)
	{
		
		for(var i=0;i<ElemsToCheck.length;++i)
		{
			//Iterate ElemsToCheck[i]
			var parent_Id 					= getIdentifierParent(ElemsToCheck[i]);

			var parent_Elem					= document.getElementById(parent_Id);

			if 
			(
					(parent_Elem.tagName.toUpperCase()=='TABLE' )
					||
					(parent_Elem.tagName.toUpperCase()=='TR' )
			)
			{
				// do not do nothing
			}
			else
			{
				
					var parentRect	  				= parent_Elem.getBoundingClientRect();
					var parentTop     				= parseInt(parentRect.top);
					var parentLeft    				= parseInt(parentRect.left);
					var parentRight   				= parentLeft+parseInt(parentRect.width);
					var parentBottom  				= parentTop+parseInt(parentRect.height);
		
		
					//Parent frame and content area
					var OffsetWRight				= 0;
					var OffsetHTop					= 0;
					var ContentAreaWidth			= 0;
					var DescendantToMeasure 		= $(parent_Elem).find(".IsSW");
					for(var j=0;j<DescendantToMeasure.length;++j)
					{
						//iterate any sibling of the ElemsToCheck[i]
						
						var thisRect	  				= DescendantToMeasure[j].getBoundingClientRect();
						var thisTop     				= parseInt(thisRect.top);
						var thisLeft    				= parseInt(thisRect.left);
						var thisOffsetWidth    		    = parseInt(DescendantToMeasure[j].offsetWidth );
						var thisRight   				= parentLeft+parseInt(thisRect.width);
						var thisBottom  				= parentTop+parseInt(thisRect.height);
						if ((thisTop<parentTop)||(thisBottom>parentBottom))
						{
							//setDivScroller(parent_Elem,"overflow_V");
							
						}
						if ((thisLeft<parentLeft)||(parseInt(thisLeft+thisOffsetWidth)>parentRight))
						{
							//setDivScroller(parent_Elem,"overflow_H");	
							if (parseInt(thisLeft+thisOffsetWidth)>parentRight)
							{
								if ((parseInt(thisLeft+thisOffsetWidth)-parentRight) >OffsetWRight)
								{
									OffsetWRight = parseInt(thisLeft+thisOffsetWidth)-parentRight;
								}
							}
						}
					}
					if (OffsetWRight>0)
					{	
						ContentAreaWidth =   parseInt(parentRight-parentLeft+OffsetWRight);
						var ContentArea_Elem = document.getElementById(parent_Id+'ContentArea|');
						
						ContentArea_Elem.style.width = ContentAreaWidth+'px';
						setDivScroller(ContentArea_Elem,"overflow_H");
					}
					else
					{
						
						//ContentAreaWidth =   parseInt(parentRight-parentLeft+OffsetWRight);
						//var ContentArea_Elem = document.getElementById(parent_Id+'ContentArea|');
		
						ContentArea_Elem.style.width	=	ContentAreaWidth+'px';
						//resetDivScroller(ContentArea_Elem,"overflow_H");
					}
			}

		}
	}

}
*/
/*
function scrollManagement___()
{
	     

	$( '.scrollbar_trigger' ).resize
	(
			function() 
			{
				
//						var ScrollStatusSwitch			= "";
						var parentNode    				= this.parentNode;
				        var parentNodeId  				= this.parentNode.id;

				        var parentNodeScrollInitStatus 	= parentNode.getAttribute("scroll_status");
				        
						var parentRect	  				= this.parentNode.getBoundingClientRect();
						var thisRect	  				= this.getBoundingClientRect();
				
						var parentTop     				= parseInt(parentRect.top);
						var thisTop       				= parseInt(thisRect.top);

						var parentLeft    				= parseInt(parentRect.left);
						var thisLeft      				= parseInt(thisRect.left);

						var parentRight   				= parentLeft+parseInt(parentRect.width);
						var thisRight     				= thisLeft+parseInt(thisRect.width);

						var parentBottom  				= parentTop+parseInt(parentRect.height);
						var thisBottom    				= thisTop+parseInt(thisRect.height);
						
						if (document.getElementById(parentNodeId+"scroll_controller_top|")==null)
						{
							var div 						= document.createElement("DIV");
							div.setAttribute("id", parentNodeId+"scroll_controller_top|");
							div.style.position 				= "absolute";
							div.style.left					= 0;// parentLeft+"px";
							div.style.top					= 0;//parentTop+"px";
							div.style.height				= "10px";
							div.style.width			    	= parseInt(parentRect.right-parentRect.left)+"px";
							div.style.backgroundColor 		= "red";
							div.style.display				= "none";

							parentNode.appendChild(div);
						}
							
//							var div 						= document.createElement("DIV");
//							div.setAttribute("id", parentNodeId+"scroll_controller|");
//							div.style.position 				= "absolute";
//							div.style.right					= 0;// parentLeft+"px";
//							div.style.top					= 0;//parentTop+"px";
//							div.style.height				= parseInt(parentTop-parentBottom)+"px";
//							div.style.width			    	= "10px";
//							div.style.backgroundColor 		= "red";
//							parentNode.appendChild(div);

							if (document.getElementById(parentNodeId+"scroll_controller_right|")==null)
							{
							
								var div 						= document.createElement("DIV");
								div.setAttribute("id", parentNodeId+"scroll_controller_right|");
								div.style.position 				= "absolute";
								div.style.right					= 0;// parentLeft+"px";
								div.style.top					= 0;//parentTop+"px";
								div.style.height				= (-parentTop+parentBottom) +"px";
								div.style.width			    	= "10px";
								div.style.backgroundColor 		= "blue";
								div.style.display				= "none";
								parentNode.appendChild(div);
						}
						

			  		//	this.innerHTML=;
						//$("#debuggeroutput_content").html("parent top : "+parentTop+" thisTop: "+thisTop+" parent right : "+parentRight+" thisRight : "+thisRight);
						if 
						(						
								(parentTop>thisTop)
								||
								(parentBottom<thisBottom)
								||
								(parentLeft>thisLeft)
								||
								(parentRight<thisRight)

						)
						{
							this.style.backgroundColor 	= 'pink';
							parentNode.setAttribute("scroll_status","true");

						}
						else
						{
							this.style.backgroundColor = 'yellow';
							parentNode.setAttribute("scroll_status","false");
						}
						
						if (parentNode.getAttribute("scroll_status")!=null)
						{
							if (parentNode.getAttribute("scroll_status")!=parentNodeScrollInitStatus)
							{
								$("#debuggeroutput_content").html("change status");
								var scroll_controller_right 			= document.getElementById(parentNodeId+"scroll_controller_right|");
								var scroll_controller_top 				= document.getElementById(parentNodeId+"scroll_controller_top|");
								if (parentNode.getAttribute("scroll_status")=="true")
								{
									scroll_controller_right.style.display 	= "block";
									scroll_controller_top.style.display 	= "block";
									
								}
								else
								{
									scroll_controller_right.style.display 	 = "none";
									scroll_controller_top.style.display 	 = "none";
									
								}

							}
							else
							{
								$("#debuggeroutput_content").html("");								
							}
						}

						
			}
	);
	
	var scrollbar_trigger_elements = $( '.scrollbar_trigger' );
	for(var i=0;i<scrollbar_trigger_elements.length;++i)
	{
		var elOverflow 				= checkOverflow(scrollbar_trigger_elements[i]);
		var ContainerParentElement  = scrollbar_trigger_elements[i].parentNode;
		if (elOverflow=="overflow_HV")
		{
			setDivScroller(ContainerParentElement,"overflow_H");
			setDivScroller(ContainerParentElement,"overflow_V");
		}
		else
		{
			if (elOverflow=="overflow_H"){setDivScroller(ContainerParentElement,"overflow_H");}
			if (elOverflow=="overflow_V"){setDivScroller(ContainerParentElement,"overflow_V");}			
		}
	}
	
}*/

function checkOverflow(element)
{
	var overflow_H = "";
	var overflow_V = "";
	var elementParent 	= element.parentNode;
	var rectParent 		= elementParent.getBoundingClientRect();
	var rectElement 	= element.getBoundingClientRect();

		if( rectElement.right > rectParent.right)
		{
			   // your element have overflow
			overflow_H = "true";
		}
		if( rectElement.top < rectParent.top)	
		{
			  //your element don't have overflow
			overflow_V = "true";
		}
		if ((overflow_V=="true")&&(overflow_H=="true"))
		{
			return "both";
		}else
		{
			if (overflow_H=="true") return "overflow_H";
			if (overflow_V=="true") return "overflow_V";
			if ((overflow_H=="true") &&  (overflow_V=="true")) return "overflow_HV";
			return "false";
		}
}

/*
ContainerParentElement: SWIdentifier or ContentArea Identifier
 */
function resetDivScroller(ContainerParentElement,overflow_string)
{
										//console.log('ContainerParentElement:');
										//console.log(ContainerParentElement);
	var									OBJIdentifier 		= (ContainerParentElement.id).replace("ContentArea|","");
	var									OBJ 				= document.getElementById(OBJIdentifier);
										ContainerParentElement  = OBJ;
	var									parentNodeId		= ContainerParentElement.id;
										//var parentRect  	= ContainerParentElement.getBoundingClientRect();
										//var div				= null;
										if (overflow_string=='overflow_H')
										{
											//console_log("mmmmmmmmmm -------- H -------- removing:"+elemToRemove_id);
											$(ContainerParentElement).scrollLeft(0);
										var scrollElementchk   	= retrieveScrollElementById(parentNodeId+'frame|','');
											if 	(scrollElementchk>-1) {arrayScrolls.splice(scrollElementchk);}
										var elemToRemove_id    	= (parentNodeId+"slider_slot_bottom|").split("|").join("__");
											//console_log("mmmmmmmmmm element to remove id:"+elemToRemove_id);
										var elemToRemove 		= document.getElementById(elemToRemove_id);
											if (isValidElement(elemToRemove)) 
											{
												$(elemToRemove).remove();
											} else
											{
												//console_log("mmmmmmmmmm    elemToRemove NOT FOUND");
											}
										}
										if (overflow_string=='overflow_V')
										{
											//console_log("mmmmmmmmmm -------- V -------- removing:"+elemToRemove_id);
											$(ContainerParentElement).scrollTop(0);
										var scrollElementchk   	= retrieveScrollElementById(parentNodeId+'frame|','');
											if 	(scrollElementchk>-1) {arrayScrolls.splice(scrollElementchk);}
							
										var elemToRemove_id    	= (parentNodeId+"slider_slot_right|").split("|").join("__");
											//console_log("mmmmmmmmmm    elemToRemove.id:"+elemToRemove_id);
										var elemToRemove 		= document.getElementById(elemToRemove_id);
											if (isValidElement(elemToRemove)) 
											{
												$(elemToRemove).remove();
											}else
											{
												//console_log("mmmmmmmmmm    elemToRemove NOT FOUND");
											}
										}
}

function setDivScroller(ContainerParentElement,overflow_string,offset)
{
		//This function is called once for H slider and once for V slider
	var OBJIdentifier 							= (ContainerParentElement.id).replace("ContentArea|","");
	var OBJ 									= document.getElementById(OBJIdentifier);
		ContainerParentElement 					= OBJ;
	var parentNodeId							= ContainerParentElement.id;
	var parentRect  							= ContainerParentElement.getBoundingClientRect();
	var div										= null;
	var OBJ_zIndex								= OBJ.style.zIndex;
	//var scrollElementchk   = retrieveScrollElementById(parentNodeId+'frame|','');
	//if (scrollElementchk==-1)
	{
		//if scroller record into arrayScrolls is present or not
		//execute anyway
		//slider slots are added because of at OBJ redraw they are erased		
		//function		manageScrollableDIVs will retrieve info and will redraw sliders too
		if (overflow_string=='overflow_H')
		{
		var targetdiv_id						= (parentNodeId+"slider_slot_bottom|").split("|").join("__");
		var targetdiv 							= document.getElementById(targetdiv_id);
			if (targetdiv==null)
			{
				div 							= document.createElement("DIV");
				div.setAttribute("id", (parentNodeId+"slider_slot_bottom|").split("|").join("__"));
				div.style.position 				= "absolute";
				div.style.left					= 0;// parentLeft+"px";
				div.style.bottom				= 0;//parentTop+"px";
				div.style.height				= CursorTickness+"px";
				//div.style.width					= parseInt(parentRect.right-parentRect.left)-offset+"px";
				div.style.right 				= parseInt(offset)+"px";
				div.style.backgroundColor		= "red";
				div.style.display				= "block";
				div.style.border				= "none";
				div.style.margin				= "0px";
				div.style.padding				= "0px";
				//console_log("node id:"+parentNodeId+"   calculated_height:"+calculated_height+"  overflow_H");

				if (ContainerParentElement.tagName.toUpperCase()=="BODY")
				{
					//div.style.zIndex="100";
					// commented on 20160612 test purposes
					// there is problem when a second layer covers the level 1 layer
					// and the slider goes on to move the level 1 layer
					
					//div.style.zIndex=OBJ_zIndex;
					//^^^^^^^temporary solution
					div.style.zIndex			= OBJ_zIndex;
				}else
				{
					div.style.zIndex			= OBJ_zIndex;
				}
				ContainerParentElement.appendChild(div);
			}else
			{
				div 							= targetdiv;
				//div.style.width			    	= parseInt(parentRect.right-parentRect.left)-offset+"px";
				div.style.right = parseInt(offset)+"px";
				//width of slider container is the same of its parent element
				//seems to work....at least for BODY resize affecting the Page container
			}
		}

		if (overflow_string=='overflow_V')
		{
		var targetdiv_id						= (parentNodeId+"slider_slot_right|").split("|").join("__");
		var targetdiv 							= document.getElementById(targetdiv_id);
			if (targetdiv==null)
			{
				div 							= document.createElement("DIV");
				div.setAttribute("id", (parentNodeId+"slider_slot_right|").split("|").join("__"));
				div.style.position 				= "absolute";
				div.style.right					= 0;// parentLeft+"px";
				div.style.top					= 0;//parentTop+"px";
			var calculated_height				= ((-parseInt(parentRect.top)+parseInt(parentRect.bottom))-parseInt(offset));
				//console_log("node id:"+parentNodeId+"   calculated_height:"+calculated_height+"  overflow_V");
				if (calculated_height<0)	
				{
					calculated_height=0;
					div.style.height =0;
				} 
				else
				{
					div.style.bottom = parseInt(offset)+"px";

				}
				//Very strange case. Sometimes calculated_height is less than 0. Debug it!! 
				//div.style.height				= calculated_height+"px";
				div.style.width					= CursorTickness+"px";
				div.style.backgroundColor 		= "green";
				div.style.display				= "block";
				div.style.margin				= "0px";
				div.style.padding				= "0px";
				if (ContainerParentElement.tagName.toUpperCase()=="BODY")
				{
					//div.style.zIndex="100";
					// commented on 20160612 test purposes
					// there is problem when a second layer covers the level 1 layer
					// and the slider goes on to move the level 1 layer
					//div.style.zIndex=OBJ_zIndex;
					//^^^^^^^temporary solution
					div.style.zIndex			= OBJ_zIndex;
				}else
				{
					div.style.zIndex			= OBJ_zIndex;
				}
				ContainerParentElement.appendChild(div);
			}else
			{
				div 							= targetdiv;
				//div.style.height				= parseInt(parentRect.bottom-parentRect.top)-offset+"px";
				div.style.bottom = parseInt(offset)+"px";
				//height of slider container is the same of its parent element
				//seems to work....at least for BODY resize affecting the Page container
				//console_log("V scroll targetdiv NOT NULL appending slider:"+div.id+" to:"+ContainerParentElement.id);
			}
		}
		manageScrollableDIVs(div.id,OBJIdentifier,'lightgrey','rgb(96, 75, 255)',overflow_string,offset);
	}//dummy block
}

function arrayScrollPrintList(HeaderMessage)
{
	var 								StringarrayScrolls="";
										if (arrayScrolls.length>0)
										{
											for(var yh=0;yh<arrayScrolls.length;++yh)
											{
												StringarrayScrolls+="\n"+yh+" : "+arrayScrolls[yh].ScrollID+"...."+arrayScrolls[yh].ScrollSubID;	
											}
										}
										//console_log('\n'+HeaderMessage+'\narrayScrolls.lenght : '+arrayScrolls.length+"\n StringarrayScrolls:"+StringarrayScrolls);
										alert('\n'+HeaderMessage+'\narrayScrolls.lenght : '+arrayScrolls.length+"\n StringarrayScrolls:"+StringarrayScrolls);
}

function arrayScrollPrintListOnConsole(HeaderMessage)
{
	var 								StringarrayScrolls="";
										if (arrayScrolls.length>0)
										{
											for(var yh=0;yh<arrayScrolls.length;++yh)
											{
												StringarrayScrolls+="\n"+yh+" : "+arrayScrolls[yh].ScrollID+"...."+arrayScrolls[yh].ScrollSubID;
											}
										}
										console_log('\n'+HeaderMessage+'\narrayScrolls.lenght : '+arrayScrolls.length+"\n StringarrayScrolls:"+StringarrayScrolls);
}

/*
Returns the index of element found in array.
ScrollIDIn:
1)Use SW_el.id +"outer|scrollablediv|" for ListManager Elements
2)Use SW_el.id +"frame|" for any Element for any Element

ScrollSubIDIn:
1)Use an empty string for ListManager Elements
2)Use overflow_V/overflow_H for any Element for any Element
*/
function retrieveScrollElementById(ScrollIDIn,ScrollSubIDIn)
{
										if(typeof arrayScrolls != "undefined" && arrayScrolls != null && arrayScrolls.length > 0)
										{
											for(var ffi=0;ffi<arrayScrolls.length;++ffi)
											{
												if ((arrayScrolls[ffi].ScrollID== ScrollIDIn)&&(arrayScrolls[ffi].ScrollSubID==ScrollSubIDIn))
												{
													return ffi;
												}
											}
											return -1;
										}else
										{
											return -1;
										}
}

//for DIV only or for any element?
function manageScrollableDIVs(elementInId,OBJIdentifierIn,BackgroundColorIn,InlayBackgroundColorIn,OrientationString,offset)
{
	//console_log("-----manageScrollableDIVs..  OBJIdentifierIn:"+OBJIdentifierIn+"   elementInId:"+elementInId);
	//console.log('\nBackgroundColorIn:'+BackgroundColorIn+'\nInlayBackgroundColorIn:'+InlayBackgroundColorIn);
	if (OrientationString=='overflow_H')
	{
					//console.log('\nstarting manageScrollableDIVs for elem : '+elementInId+"\n OBJ : "+OBJIdentifierIn);
					//elementInId the real container where to bind sliders
					//at the moment this function is monobimensional (H or V is managed)
					//at this point we know that a slider is required and its slot is provided.
					//var s = document.getElementById(elementInId);
					//var t = document.getElementById(OBJIdentifierIn);

					//ContentArea 		 : the div that is moved on the basis of the slider
					//frame		  		 : the container of ContentArea. frame is the parent of ContentArea
					//slider_slot_bottom : the div that contains H slider
					//slider_slot_right  : the div that contains V slider

				var debug_string									= "";
					//elementInId is the slider group delimiter
				var elementIn 										= document.getElementById(elementInId);
				var ddi												= 0;

				var InnerDivSuffix									= 'ContentArea|';
				var OuterDivSuffix									= 'frame|';	// this one is used to create the arrayScroll Identifier 
				var slider_slot_bottomSuffix						= 'slider_slot_bottom|';
				var slider_slot_rightSuffix							= 'slider_slot_right|';

				var ControlledDIVInnerDivId 						= ""; //OBJIdentifierIn+InnerDivSuffix;  
				var ControlledDIVOuterDivId 						= ""; //OBJIdentifierIn+OuterDivSuffix;  
				var slider_slot_bottomId 							= ""; //OBJIdentifierIn+OuterDivSuffix;  
				var slider_slot_rightId 							= ""; //OBJIdentifierIn+OuterDivSuffix;  

					ControlledDIVInnerDivId 						= OBJIdentifierIn+InnerDivSuffix;  
					ControlledDIVOuterDivId 						= OBJIdentifierIn+OuterDivSuffix; // this one is the arrayScroll Identifier 
					slider_slot_bottomId							= (OBJIdentifierIn+ slider_slot_bottomId).split("|").join("__");
					slider_slot_rightId								= (OBJIdentifierIn+ slider_slot_rightId).split("|").join("__");

				var ContentElement									= document.getElementById(ControlledDIVInnerDivId);
				var ContainerFrameElement							= document.getElementById(ControlledDIVOuterDivId);
				var slider_slot_bottom								= document.getElementById(slider_slot_bottomId);
				var slider_slot_right								= document.getElementById(slider_slot_rightId);

					ContentElement.style.overflow					= 'hidden';
					ContainerFrameElement.style.overflow			= 'hidden';

				//var ScrollerActivationTreshOldWidth 				= $(ControlledDIVOuterDivElem).outerWidth();

				//var elementIn 									= document.getElementById(elementInId);
				var elementInId_OK									= elementInId.split("|").join("__");
				var ContainmentId 									= elementInId_OK;//+"CursorWrapper_"+ddi;
				var CursorId										= elementInId_OK+'H'+ddi+'_SLIDER'; 

					debug_string +=""+ControlledDIVInnerDivId+"<br>";

			var arrayScrollActive									= retrieveScrollElementById(ControlledDIVOuterDivId,'overflow_H');

				//We have to check if an arrayScroll Exists on not

				if (arrayScrollActive==-1)
				{
					//arrayScroll do not exists
					// ->to be generated
					//var XCursorRaceCl 							= parseInt(elementIn.offsetWidth)-offset; //parseInt(elementIn.clientWidth); //offsetWidth 
				var XCursorRaceCl 								= parseInt(elementIn.offsetWidth); 
				var XCursorStartCl								= parseInt(elementIn.getBoundingClientRect().left);
					//XContentInCl  							=	 $(document.getElementById(ControlledDIVInnerDivId)).outerWidth(true);
					//XContentInCl  							= $(document.getElementById(ContentElement)).outerWidth(true);
				var XContentInCl  								= ContentElement.clientWidth;

					setScrollElement(ControlledDIVOuterDivId, 'overflow_H',0, 0,'',XCursorRaceCl,0,XCursorStartCl,0,XContentInCl,0,CursorId);

					arrayScrollActive							= retrieveScrollElementById(ControlledDIVOuterDivId,'overflow_H');
				}else
				{
					//check if the content area has changed its dimensions
					//and refresh arrayScroll record arrayScroll[arrayScrollActive]
				var XContentInCl  									= ContentElement.clientWidth;
					arrayScrolls[arrayScrollActive].XContent 		= XContentInCl;
					//arrayScrolls[arrayScrollActive].XCursorRace = parseInt(elementIn.offsetWidth)-offset;
					arrayScrolls[arrayScrollActive].XCursorRace 	= parseInt(elementIn.offsetWidth);
					//arrayScroll already exists

					// ->to check
				}

				if ($(ContentElement).outerWidth()+offset>$(ContainerFrameElement).outerWidth())
				{
						if ((typeof elementIn.innerHTML =='undefined') || (elementIn.innerHTML == null) || (elementIn.innerHTML.length<5))
						{
							// slider does not exists

							var CursorWidth 					= getCursorWidthByCursorProgressive(arrayScrollActive,'')+'px';
							var CursorLeft 						= arrayScrolls[arrayScrollActive].left+'px';
							var ContainmentId 					= elementInId_OK;//+"CursorWrapper_"+ddi;
							var ContainmentString 				= "#"+ContainmentId;
							var CursorId						= elementInId_OK+'H'+ddi+'_SLIDER'; 
							var CursorString					= "#"+CursorId;
							var BackgroundColor 				= BackgroundColorIn;
							var InlayBackgroundColor 			= InlayBackgroundColorIn;

								elementIn.innerHTML				= "<div class= 'slider_support'  style='position:relative;width:100%;height:"+CursorTickness+"px;border:none;margin:0;padding:0;background-color:"+BackgroundColor+";' o_nclick=\"sliderScrollClick_div(event,'"+elementInId_OK+"H"+ddi+"_SLIDER','"+ControlledDIVOuterDivId+"','overflow_H');\"><div class='slider_cursor div_scroll_cursor_"+ddi+"' id= '"+elementInId_OK+"H"+ddi+"_SLIDER' style='border-radius:3px;position:absolute;margin:0px;padding:0px;top:0px;left:"+CursorLeft+";width:"+CursorWidth+";background-color:"+InlayBackgroundColor+";height:"+CursorTickness+"px;'></div></div>";
								
								$(elementIn ).find('.slider_support').on("mousedown",
									function(event)
									{
								var 	slider_cursor_el 		=	jQuery(event.target).find('.slider_cursor')[0];
										if (isValidElement(slider_cursor_el))
										{
											sliderScrollClick_div(event,slider_cursor_el.id,ControlledDIVOuterDivId,'overflow_H');
										}
									}
								);

								/*
								$(elementIn ).find('.slider_support').on("tap",function(){
									
									sliderScrollClick_div(event,elementInId_OK+'H'+ddi+'_SLIDER',ControlledDIVOuterDivId,'overflow_H');
								});*/

//													$(CursorString).draggable({ axis: "x", containment: ContainmentString});
//													
//													$(CursorString).on
//													( 		"drag", 
//															function( event, ui ) 
//															{
//																//On drag
//																//i.e. only if the user moves the slider
//																var movable 							= event.target;
//																var debug_string_l="scroll performed..... movable left : "+movable.style.left+" ContainmentString :"+ContainmentString;
//																$('#debuggeroutput_content').html(debug_string+debug_string_l);
//									
//																var arrayScrollActiveA					= retrieveScrollElementById(ControlledDIVOuterDivId,'overflow_H');
//																arrayScrolls[arrayScrollActiveA].left 	= parseInt(this.style.left);// 			= arrayScrolls[arrayScrollActiveA].left+'px';
//																ScrollElementAdjust_generic(ControlledDIVOuterDivId,movable.getBoundingClientRect().left,movable.getBoundingClientRect().right,'overflow_H');
//															} 
//													);
								$(CursorString).draggable
								(
									{
										axis		: "x", 
										containment : ContainmentString,
										start 		: function()
													{
														SliderCursorDragging = true;
													},
										drag		: function()
													{
														//On drag
														//i.e. only if the user moves the slider
														SliderCursorDragging 					= true;
													//var movable 								= event.target;
													var movable 								= this;

													var arrayScrollActiveA						= retrieveScrollElementById(ControlledDIVOuterDivId,'overflow_H');
														arrayScrolls[arrayScrollActiveA].left 	= parseInt(this.style.left);// 			= arrayScrolls[arrayScrollActiveA].left+'px';
													//var debug_string_l="CursorLeft:"+CursorLeft+"\nscroll performed..... movable left : "+movable.style.left+"\n ContainmentString :"+ContainmentString;
													//$('#debuggeroutput_content').html(debug_string+debug_string_l);
													var Lstring_out 							= "this.style.left:"+this.style.left+" \nmovable.style.left:"+movable.style.left;
														//$('#debuggeroutput_content').html(Lstring_out);
														//$('#debuggeroutput_content').html(Lstring_out);

														$('#debuggeroutput_content').html("MOVING  : "+ControlledDIVOuterDivId);
														ScrollElementAdjust_generic(ControlledDIVOuterDivId,movable.getBoundingClientRect().left/zoom_css_component,movable.getBoundingClientRect().right/zoom_css_component,'overflow_H');
													},
											stop    : function()
													{
														SliderCursorDragging = false;
													}
									}
								);
							}

							{// here slider exists
								//change data here? width....left?

							var CursorId						= elementInId_OK+'H'+ddi+'_SLIDER'; 
							var CursorElement					= document.getElementById(CursorId);
								CursorElement.style.width   	= getCursorWidthByCursorProgressive(arrayScrollActive,'')+'px';
								//Cursor container width and cursor width change is not still working perfectly.....

								//var stringwidth="";
								//stringwidth+= "\n before :"+CursorElement.style.width;
								//stringwidth+= "\n after :"+CursorElement.style.width;
							var movable 						= document.getElementById(CursorId);
								ScrollElementAdjust_generic(ControlledDIVOuterDivId,movable.getBoundingClientRect().left/zoom_css_component,movable.getBoundingClientRect().right/zoom_css_component,'overflow_H');
								//Adjusts frame scrollLeft in order to keep the same viewport

							var CurrentScrollLeft				= $(ContainerFrameElement).scrollLeft();
							var TargetLeft 						= getCursorLeftByContentAreaScollLeftAndByArrayScrollsActive(CurrentScrollLeft,arrayScrollActive);
								CursorElement.style.left        = TargetLeft+'px';
							}
				}else
				{
						$( ContainerFrameElement ).scrollLeft( parseInt("0"));
						//document.getElementById(ContentTableElement).style.left = "0px";
						//$(ControlledDIVInnerDivElem).scrollLeft(0);
						$(elementIn).empty();

					var arrayScrollActive							= retrieveScrollElementById(ContainerFrameElement.id,'overflow_H');

						if (arrayScrollActive!=-1)
						{// to create arrayScroll
							arrayScrolls.splice(arrayScrollActive);
						}
				}
	}
	if (OrientationString=='overflow_V')
	{

				//elementInId the real container where to bind sliders
				//at the moment this function is monobimensional (H or V is managed)
				//at this point we know that a slider is required and its slot is provided.

				//var s = document.getElementById(elementInId);
				//var t = document.getElementById(OBJIdentifierIn);
				
				//ContentArea 		 : the div that is moved on the basis of the slider
				//frame		  		 : the container of ContentArea. frame is the parent of ContentArea
				//slider_slot_bottom : the div that contains H slider
				//slider_slot_right  : the div that contains V slider

				var debug_string									= "";

					//elementInId is the slider group delimiter
				var elementIn 										= document.getElementById(elementInId);
				var ddi												= 0;

				var InnerDivSuffix									= 'ContentArea|';
				var OuterDivSuffix									= 'frame|';	// this one is used to crete the arrayScroll Identifier 
				var slider_slot_bottomSuffix						= 'slider_slot_bottom|';
				var slider_slot_rightSuffix							= 'slider_slot_right|';

				var ControlledDIVInnerDivId 						= ""; //OBJIdentifierIn+InnerDivSuffix;  
				var ControlledDIVOuterDivId 						= ""; //OBJIdentifierIn+OuterDivSuffix;  
				var slider_slot_bottomId 							= ""; //OBJIdentifierIn+OuterDivSuffix;  
				var slider_slot_rightId 							= ""; //OBJIdentifierIn+OuterDivSuffix;  

					ControlledDIVInnerDivId 						= OBJIdentifierIn+InnerDivSuffix;  
					ControlledDIVOuterDivId 						= OBJIdentifierIn+OuterDivSuffix; // this one is the arrayScroll Identifier 
					slider_slot_bottomId							= (OBJIdentifierIn+ slider_slot_bottomId).split("|").join("__");
					slider_slot_rightId								= (OBJIdentifierIn+ slider_slot_rightId).split("|").join("__");

				var ContentElement									= document.getElementById(ControlledDIVInnerDivId);
				var ContainerFrameElement							= document.getElementById(ControlledDIVOuterDivId);
				var slider_slot_bottom								= document.getElementById(slider_slot_bottomId);
				var slider_slot_right								= document.getElementById(slider_slot_rightId);

					ContentElement.style.overflow					='hidden';
					ContainerFrameElement.style.overflow			='hidden';

				//var ScrollerActivationTreshOldWidth 		= $(ControlledDIVOuterDivElem).outerWidth();

				//var elementIn 					= document.getElementById(elementInId);
				var elementInId_OK									= elementInId.split("|").join("__");
				var ContainmentId 									= elementInId_OK;//+"CursorWrapper_"+ddi;
				var CursorId										= elementInId_OK+'V'+ddi+'_SLIDER'; 
					debug_string 									+=""+ControlledDIVInnerDivId+"<br>";

				var arrayScrollActive								= retrieveScrollElementById(ControlledDIVOuterDivId,'overflow_V');

				//We have to check if an arrayScroll Exists on not

				if (arrayScrollActive==-1)
				{
					//arrayScroll do not exists
					// ->to be generated
					//var YCursorRaceCl 							= parseInt(elementIn.offsetHeight)-offset; //parseInt(elementIn.clientWidth); //offsetWidth 
				var YCursorRaceCl 								= parseInt(elementIn.offsetHeight);
				var YCursorStartCl								= parseInt(elementIn.getBoundingClientRect().top);
					//XContentInCl  							= $(document.getElementById(ControlledDIVInnerDivId)).outerWidth(true);
					//XContentInCl  							= $(document.getElementById(ContentElement)).outerWidth(true);
				var YContentInCl  								= ContentElement.clientHeight;
					//console_log("V A ControlledDIVOuterDivId:"+ControlledDIVOuterDivId+"  ContentY:"+YContentInCl);
					//alert('ContentElement.clientHeight:'+ContentElement.clientHeight);
					setScrollElement(ControlledDIVOuterDivId, 'overflow_V',0, 0,'',0,YCursorRaceCl,0,YCursorStartCl,0,YContentInCl,CursorId);
					arrayScrollActive							= retrieveScrollElementById(ControlledDIVOuterDivId,'overflow_V');
				}else
				{
					//alert('found arrayScroll');	
					//check if the content area has changed its dimensions
					//and refresh arrayScroll record arrayScroll[arrayScrollActive]
				var YContentInCl  								= ContentElement.clientHeight;
					arrayScrolls[arrayScrollActive].YContent 	= YContentInCl;
					//arrayScrolls[arrayScrollActive].YCursorRace = parseInt(elementIn.offsetHeight)-offset;
					arrayScrolls[arrayScrollActive].YCursorRace = parseInt(elementIn.offsetHeight);
					//alert("element in to xcursorrace:"+elementIn.id);
					//alert('arrayScrollActive : '+arrayScrollActive+' \narrayScrolls[arrayScrollActive].left :  ' +arrayScrolls[arrayScrollActive].left+'   \n arrayScrolls[arrayScrollActive].width : '+arrayScrolls[arrayScrollActive].width);
					//arrayScroll already exists
					// ->to check
				}
				if ($(ContentElement).outerHeight()+offset>$(ContainerFrameElement).outerHeight())
				{
							if ((typeof elementIn.innerHTML =='undefined') || (elementIn.innerHTML == null) || (elementIn.innerHTML.length<5))
							{
									//slider does not exists
								var CursorHeight 					= getCursorHeightByCursorProgressive(arrayScrollActive,'')+'px';
								var CursorTop 						= arrayScrolls[arrayScrollActive].top+'px';
//								var ContainmentId 					= elementInId_OK;//+"CursorWrapper_"+ddi;
								var ContainmentString 				= "#"+ContainmentId;
//								var CursorId						= elementInId_OK+'V'+ddi+'_SLIDER'; 
								var CursorString					= "#"+CursorId;
								var BackgroundColor 				= BackgroundColorIn;
								var InlayBackgroundColor 			= InlayBackgroundColorIn;


									elementIn.innerHTML				= "<div class='slider_support'  style='position:relative;height:100%;width:"+CursorTickness+"px;border:none;margin:0;padding:0;background-color:"+BackgroundColor+";' o_nclick=\"sliderScrollClick_div(event,'"+elementInId_OK+"V"+ddi+"_SLIDER','"+ControlledDIVOuterDivId+"','overflow_V');\"><div class='slider_cursor div_scroll_cursor_"+ddi+"' id= '"+elementInId_OK+"V"+ddi+"_SLIDER' style='border-radius:3px;position:absolute;margin:0;padding:0;top:0px;top:"+CursorTop+";height:"+CursorHeight+";width:"+CursorTickness+"px;background-color:"+InlayBackgroundColor+";'></div></div>";

									$(elementIn ).find('.slider_support').on("mousedown",
										function(event)
										{
									var 	slider_cursor_el 		=	jQuery(event.target).find('.slider_cursor')[0];
											if (isValidElement(slider_cursor_el))
											{
												sliderScrollClick_div(event,slider_cursor_el.id,ControlledDIVOuterDivId,'overflow_V');
											}
										}
									);
									/*
									$(elementIn ).find('.slider_support').on("tap",function(){
										sliderScrollClick_div(event,elementInId_OK+'V'+ddi+'_SLIDER',ControlledDIVOuterDivId,'overflow_V');
									});*/

/*								var	myZindex = jQuery(document.getElementById(OBJIdentifierIn)).css('z-index');
									jQuery(document.getElementById(OBJIdentifierIn)).append("<div style= 'z-index:"+myZindex+";position:absolute;right:6px;bottom:0;height:16px;width:16px;font-size:22px;' class='fa-solid fa-chevron-down'></div>");
									jQuery(document.getElementById(OBJIdentifierIn)).append("<div style= 'z-index:"+myZindex+";position:absolute;right:6px;top:0;height:16px;width:16px;font-size:22px;' class='fa-solid fa-chevron-up'></div>");
*/

//													$(CursorString).draggable({ axis: "y", containment: ContainmentString});
//													
//													$(CursorString).on
//													( 		"drag", 
//															function( event, ui ) 
//															{
//																//On drag
//																//i.e. only if the user moves the slider
//																var movable 							= event.target;
//																var debug_string_l="scroll performed..... movable left : "+movable.style.top+" ContainmentString :"+ContainmentString;
//																$('#debuggeroutput_content').html(debug_string+debug_string_l);
//									
//																var arrayScrollActiveA					= retrieveScrollElementById(ControlledDIVOuterDivId,'overflow_V');
//																arrayScrolls[arrayScrollActiveA].top 	= parseInt(this.style.top);// 			= arrayScrolls[arrayScrollActiveA].left+'px';
//																ScrollElementAdjust_generic(ControlledDIVOuterDivId,movable.getBoundingClientRect().top,movable.getBoundingClientRect().bottom,'overflow_V');
//															} 
//													);
													//alert('ContainmentString:'+ContainmentString);
													$(CursorString).draggable	(
																					{ 	axis		: "y", 
																						containment	: ContainmentString,
																						start		: function()
																										{
																											SliderCursorDragging = true;
																										},
																						drag		: function()
																										{
																											jQuery(document).scrollTop(0);
																											//avoid document moving when mouse oubounds viewport on vertical slider dragging

																											//On drag
																											//i.e. only if the user moves the slider
																											SliderCursorDragging = true;

																											//var movable 							= event.target;
																										var movable 							= this;
																										//var debug_string_l="scroll performed..... movable top : "+movable.style.top+" ContainmentString :"+ContainmentString+" MOVED EL:"+ControlledDIVOuterDivId;
																										//	$('#debuggeroutput_content').html(debug_string+debug_string_l);

																										var arrayScrollActiveA					= retrieveScrollElementById(ControlledDIVOuterDivId,'overflow_V');
																											arrayScrolls[arrayScrollActiveA].top 	= parseInt(this.style.top);// 			= arrayScrolls[arrayScrollActiveA].left+'px';
																											//console_log('iiiiiiiiii :'+this.style.top);
																											ScrollElementAdjust_generic(ControlledDIVOuterDivId,movable.getBoundingClientRect().top/zoom_css_component,movable.getBoundingClientRect().bottom/zoom_css_component,'overflow_V');
																										},
																						stop		: function()
																										{
																											SliderCursorDragging = false;
																										}
																					}
																				);
													/*
													$(CursorString).on
													( 		"drag", 
															function( event, ui ) 
															{
																//On drag
																//i.e. only if the user moves the slider
																var movable 							= event.target;
																var debug_string_l="scroll performed..... movable left : "+movable.style.top+" ContainmentString :"+ContainmentString;
																$('#debuggeroutput_content').html(debug_string+debug_string_l);
									
																var arrayScrollActiveA					= retrieveScrollElementById(ControlledDIVOuterDivId,'overflow_V');
																arrayScrolls[arrayScrollActiveA].top 	= parseInt(this.style.top);// 			= arrayScrolls[arrayScrollActiveA].left+'px';
																ScrollElementAdjust_generic(ControlledDIVOuterDivId,movable.getBoundingClientRect().top,movable.getBoundingClientRect().bottom,'overflow_V');
															} 
													);

									*/
							}

							{// here slider exists
								//alert('slider exists......');
								//change data here? width....left?

								//var CursorId					= elementInId_OK+'V'+ddi+'_SLIDER'; 

								var CursorIdLocal 				= arrayScrolls[arrayScrollActive].CursorElementId;
								var CursorElementLocal			= document.getElementById(CursorIdLocal);
									CursorElementLocal.style.height = getCursorHeightByCursorProgressive(arrayScrollActive,'')+'px';
								//Cursor container width and cursor width change is not still working perfectly.....
								
						//		var stringwidth="";
						//		stringwidth+= "\n before :"+CursorElement.style.width;
						//		stringwidth+= "\n after :"+CursorElement.style.width;
								//var movable 					= document.getElementById(CursorIdLocal);
									ScrollElementAdjust_generic(ControlledDIVOuterDivId,CursorElementLocal.getBoundingClientRect().top/zoom_css_component,CursorElementLocal.getBoundingClientRect().bottom/zoom_css_component,'overflow_V');
								//Adjusts frame scrollLeft in order to keep the same viewport

								var CurrentScrollTop				= $(ContainerFrameElement).scrollTop();
								var TargetTop 						= getCursorTopByContentAreaScollTopAndByArrayScrollsActive(CurrentScrollTop,arrayScrollActive);
									CursorElementLocal.style.top 	= TargetTop+'px';
							}
				}else
				{
					$( ContainerFrameElement ).scrollTop( parseInt("0"));
					//document.getElementById(ContentTableElement).style.left = "0px";
					//$(ControlledDIVInnerDivElem).scrollLeft(0);
					$(elementIn).empty();

				var arrayScrollActive							= retrieveScrollElementById(ContainerFrameElement.id,'overflow_V');
					if (arrayScrollActive!=-1)
					{// to create arrayScroll
						//alert('table scroll remove');
						arrayScrolls.splice(arrayScrollActive);
					}
				}
	}
}

function setUpFileUpload(SWIdentifierIn,PluginSelectorIn,BrowserNameIn,BrowserVersionIn,UploadPathIn)
{
	if (
			(typeof SWIdentifierIn === "undefined")||(SWIdentifierIn==null)
			||
			(typeof PluginSelectorIn === "undefined")||(PluginSelectorIn==null)
			||
			(typeof BrowserNameIn === "undefined")||(BrowserNameIn==null)||(BrowserNameIn.length<2)
			||
			(typeof BrowserVersionIn === "undefined")||(BrowserVersionIn==null)
			||
			(typeof UploadPathIn === "undefined")||(UploadPathIn==null)
		)
	{
		alert('setUpFileUpload not proper parameters!!!!');
	} else
	{
			dynamicallyLoadLibrary(ContextPath+'/js/dropzone/dropzone.min.js');
		
		var SW_el						= document.getElementById(SWIdentifierIn);
		var SW_contentarea_el			= document.getElementById(SWIdentifierIn+'ContentArea|');
		
		var SubmitTriggerId 			= SWIdentifierIn+"SubmitTrigger|";
		var AcceptedFilesId				= SWIdentifierIn+"acceptedfileslist|";
		var AcceptedFilesEl				= document.getElementById(AcceptedFilesId);

		var AcceptedFileslist			= jQuery(AcceptedFilesEl).val();
		
		//alert("browser Name :"+BrowserNameIn+" BrowserVersionIn:"+BrowserVersionIn+" UploadPathIn"+UploadPathIn);
		//myDropzone = $("div#"+DropzoneDIVIdentifierIn).dropzone({ url: "fileUpload" , maxFilesize: 999});
		//For lacking other browsers use flash module (i.e. MSIE 8)
		//alert("AcceptedFileslist:"+AcceptedFileslist);
		//if 
		//(
		//	( (BrowserNameIn!='MSIE')&&(BrowserNameIn.toUpperCase().indexOf("IE")==-1))
		//			//&&(BrowserNameIn.toUpperCase().indexOf("MICROSOFT")==-1) )
		//	//||
		//	//( (BrowserNameIn.toUpperCase().indexOf("MICROSOFT")>-1) && (parseInt(BrowserVersionIn)>8) )
		//) 
			if	( PluginSelectorIn == "DROPZONE")
			{
			var Mypageobjtoken			= $(document.body).attr('pageobjtoken');
			var Mypagename				= $(document.body).attr('pagename');
			var SessionPageFullName		= Mypageobjtoken+"_"+Mypagename;

			var DropzoneTargetIdentifier= replaceAll(SWIdentifierIn,"\\|", "__")+"dropzone_droparea__";
			//alert("DropzoneTargetIdentifier:"+DropzoneTargetIdentifier);
			var uploadURL 				= encodeURI("fileDBUpload?sessionpagefullname="+SessionPageFullName+"&SubmitTrigger="+SubmitTriggerId);
			var MyDz 					= new Dropzone("div#"+DropzoneTargetIdentifier, { autoProcessQueue:true,url: uploadURL,maxFilesize: 999,acceptedFiles: AcceptedFileslist});

						MyDz.on
						(
								"complete", 
								function (file) 
								{
									//alert("complete upload....");
									MyDz.removeFile(file);
									jQuery(SW_el).removeClass("nowsending");

									//check for pending file to upload
									if (this.getUploadingFiles().length === 0 && this.getQueuedFiles().length === 0) 
									{
										//No more files to upload

									  				//  doSomething();
									  			    //	alert('transfer complete');
									  				//var dataelement 			= provideSubmitHiddenInputByName(generalizedFormElement,IdentifierIn,"fileupload_message","fileupload_message");
		  												//jQuery(SW_el).removeClass("nowsending");
												var el_fileupload_message 	= document.getElementById(SWIdentifierIn+"fileupload_message|");

													if ( $( el_fileupload_message).length ) 
													{
									  							//	The element exists 								  				
													} else
													{
							  							//	The element does not exists 
													var myContainer 				= document.getElementById(SWIdentifierIn);
								  						//myContainer.innerHTML += "<input type ='hidden' name = 'fileupload_message' id = '"+SWIdentifierIn+"fileupload_message|' value='"+file.name+"'>";
													var fileupload_message_el 		= document.createElement("input");
														fileupload_message_el.id 	= SWIdentifierIn+'fileupload_message|';

														fileupload_message_el.setAttribute('type', 'hidden');
														fileupload_message_el.setAttribute('value', file.name);
														fileupload_message_el.setAttribute('name', 'fileupload_message');
														myContainer.appendChild(fileupload_message_el);
													}
											var 	el_fileupload_message 		= document.getElementById(SWIdentifierIn+"fileupload_message|");											 		
											//var 	dummyEvent					= new dummyEventGenerate();

											var 	customEvent					= new customEventGenerate('fileuplaodend');
													//CAclient(SWIdentifierIn,el_fileupload_message,customEvent,'Components.FileUpload','!@@PPFEEDBACKACTION@@! !@@VVSENDDATA@@! !@@PPFUNCTION@@! !@@VVFILEUPLOAD_COMPLETE@@! ',false);
													CAclient(SWIdentifierIn,el_fileupload_message,customEvent,'Components.ContainerDropArea','!@@PPFEEDBACKACTION@@! !@@VVSENDDATA@@! !@@PPFUNCTION@@! !@@VVFILEUPLOAD_COMPLETE@@! ',false);													
									}
								}
						);
						
						MyDz.on
						(		
							"sending", 
							function(file, xhr, data) 
							{
								jQuery(SW_el).addClass("nowsending");
								//alert("adding.....data");
								data.append("SubmitTrigger" , SubmitTriggerId);
								data.append("pageName" 		, "filesystem");
								data.append("path_uuid"		, UploadPathIn);
							}
						);
			}else 
			if	(PluginSelectorIn == "UPLOADIFY")
			{
							/*	
								$(document).ready(function() {
									//alert("goooo");
									$('#dropzone_droparea').uploadify({
									'uploader'  : 'uploadify.swf',
									'script'    : '../Lib/uploadify.php',
									//'cancelImg' : '../Lib/cancel.png',
									'auto'      : true,
									//'folder'    : '../../upload',
									'onComplete': function(event, queueID, fileObj, reposnse, data) {
									     //Do something here using the parameters as they defined in the docs
									 }
									});
									});
							*/
			var Mypageobjtoken				= $(document.body).attr('pageobjtoken');
			var Mypagename					= $(document.body).attr('pagename');
			var SessionPageFullName			= Mypageobjtoken+'_'+Mypagename;
	
			var UploadTargetId 				= replaceAll(SWIdentifierIn+"uploadify|","\\|", "__");
			var urichunk 					= encodeURI('fileDBUpload?sessionpagefullname='+SessionPageFullName+'&pageName='+Mypagename+'&path_uuid='+UploadPathIn+'&SubmitTrigger='+SWIdentifierIn+'SubmitTrigger|');
			var UploadTargetEl				= document.getElementById(UploadTargetId); 	 
				//alert("UploadTargetId:"+UploadTargetId+"  UploadTargetEl.id:"+UploadTargetEl.id);
	
				$(UploadTargetEl).uploadify
				(
						{
							'height'        	: 30, 
							'swf'           	: 'flash/uploadify.swf', 
							'formData'    		: {'SubmitTrigger' : SWIdentifierIn+'SubmitTrigger|', 'someOtherKey' : 1},
							'uploader'      	: urichunk, 
							'width'         	: 120, 
							//'auto'          	: true ,
							'onUploadStart' 	: function(file)  
							{			
				
							}
						}
				); 
			} else
			if	(PluginSelectorIn == "BASIC")
			{
			var Mypageobjtoken			= $(document.body).attr('pageobjtoken');
			var Mypagename				= $(document.body).attr('pagename');
			var SessionPageFullName		= Mypageobjtoken+"_"+Mypagename;
			
		var 	FileSend_el = document.getElementById(  SWIdentifierIn+'TagExtension_FileSend|');	
				jQuery(FileSend_el).find('.emcaption').css('width','67%');	
	
			}
	}
	
//	Dropzone.autoDiscover = false;
//
//	var dropzoneActivation_Elem 	= document.getElementById(SWIdentifierIn+"dropzone_StatusElement|");
//	var dropzoneActivation_Value	= dropzoneActivation_Elem.value;
//	var SWIdentifierInTokens;
//	alert('incoming dropzoneActivation_:'+dropzoneActivation_Value);
//	if (myDropzone!=null)
//	{
//		//Dropzone.destroy();
//	}
//	else
//	{
//		alert('is null.....');
//	}
//	if (SWIdentifierIn!=null)
//	{
//		SWIdentifierInTokens =  SWIdentifierIn.split("|");
//		if 
//		(
//				(dropzoneActivation_Value!=null)
//				&&
//				(dropzoneActivation_Value!='active')
//		)
//		{
//			try
//			{
//				myDropzone = new Dropzone("form#"+DropzoneDIVIdentifierIn, { url: "fileUpload",maxFilesize: 220});
//				dropzoneActivation_Value='active';	
//			}
//			catch(e)
//			{
//				alert('e : '+e);
//			}
//
//		}
//		else
//		{
//		
//		}
//		
//	}
//	if (myDropzone==null)
//	{
//		alert('elem id : '+DropzoneDIVIdentifierIn);
//		var myDropzone = new Dropzone("form#"+DropzoneDIVIdentifierIn, { url: "fileUpload",maxFilesize: 220});
//		dropzoneActivation_Value='active';	
//	
//	}
//
//	//var dropzone_Elem 			= document.getElementById(IdentifierIn);
//	alert('trasmitting dropzoneActivation_Value:'+dropzoneActivation_Value);
//	if (dropzoneActivation_Value='active')
//	{
//		var QuesryString				= "Identifier="+SWIdentifierInTokens[1]+"&ParametersToServer="+"!@@PPdropzone_StatusElement@@!_____!@@VVactive@@!";
//		sendParameter(SWIdentifierIn,QuesryString);
//		
//		//var QuesryString				= "Identifier="+SWIdentifierIn+"&ParametersToServer="+"!@@PPdropzone_StatusElement@@!_____!@@VVactive@@!";
//		executeGetCallonServer(SWIdentifierIn,"activate_dropzone","","");
//	}
//	

	
//	Dropzone.options.myDropzone = 
//	{
//			    maxFilesize: 25
//	}	
//	
//	$(dropzoneElem).dropzone = 
//	{
////			init: function() 
////			{
////				fbDropZone = this;
////				$("#removeAllImages").click(function(){fbDropZone.removeAllFiles();});
////			},
////			previewTemplate : '<div class="dz-preview dz-file-preview"><div class="dz-details"><div class="dz-filename"><span data-dz-name></span></div><div class="dz-size" data-dz-size></div><img data-dz-thumbnail /></div><div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div><div class="dz-success-"><span>ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã¢â‚¬Å“ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½</span></div><div class="dz-error-"><span>ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã¢â‚¬Å“ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¹ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¾ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¾ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¾Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦Ãƒâ€šÃ‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€šÃ‚Â¦ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ</span></div><div class="dz-error-message"><span data-dz-errormessage></span></div></div>',
//			paramName: "file", // The name that will be used to transfer the file
//			maxFilesize: 50, // MB
//			maxFiles : 1,
//			autoProcessQueue : false
//	};
}

function attachWindowResize()
{
								if (!isWindowResizeAttached) 
								{
		
									isResizeAttached  = true;
									$(window).resize
									(
										function(e)
										{
											if (e.target.id===undefined)
											{// target undefined -> whole page
												clearTimeout(window.resizedFinished);
										    	window.resizedFinished = setTimeout
										    	(
													function()
													{
		    										var fill_screen = $(".fill_screen");
														if (fill_screen!=null) 
														for(var g=0;g<fill_screen.length;++g)
														{
															fill_parent(fill_screen[g]);
														}
														jQuery(".Components-ListManager").each(
															function( key, value ) 
															{
																resizeOuterContainerDIV(this.id);
															}
														);
														body_focus_check();
														scrollManagement();
												        //console.log('Resize finished.');
												   var 	dummyEvt = new customEventGenerate("resize",document.body);    
												        CAclient(document.body.id,document.body,dummyEvt,'Components.Body','#@@PPFEEDBACKACTION@@# #@@VVPAGE_RESIZE@@# ',false); 
										    		}
										    		,1000
										    	);
											}
										}
									);
								}
}


function printFolderTreeWidth(scopeIn)
{
	var									ContentArea_id		= "|filesystem|ContainerMID|FBE|LeftRightTM|TM_row_0|TM_col_0|FolderTree|ContentArea|";	
	var									frame_id 			= "|filesystem|ContainerMID|FBE|LeftRightTM|TM_row_0|TM_col_0|FolderTree|ContentArea|";	
	var									ContentArea_elem	= document.getElementById(ContentArea_id );
	var									fame_elem			= document.getElementById(frame_id );
										alert(scopeIn+'\nframe width : '+fame_elem.clientWidth+'\n ContentArea width : '+ContentArea_elem.clientWidth);
}

function replaceAll(stringIn,to_replace, replace_with )
{
	//console_log("replaceAll string In:"+stringIn);
										if (typeof(stringIn) != "undefined" && stringIn != null)
										{
											  	return stringIn.replace(new RegExp(to_replace, 'g'), replace_with);
										}else
										{ 
												//alert("----stringIn :"+stringIn);
												return "";
										}
//	  if (stringIn==undefined) 	{alert('1');return "";}
//	  if (stringIn===undefined) {alert('2');return "";}
//	  if (stringIn==null) 		{alert('3');return "";}
//	  return stringIn.replace(new RegExp(to_replace, 'g'), replace_with);
}

function erase_temp_show()
{
	var 								HidingArray 																						= $(".temp_show");
										for(var j=0;j<HidingArray.length;++j)
										{
											HidingArray[j].style.display 	= 'none';
										var ItsCommanderRegister_Id 		= HidingArray[j].id+"commander_identifier|";
										var ItsCommanderRegister 			= document.getElementById(ItsCommanderRegister_Id);
											if (ItsCommanderRegister!=null)
											{
											var ItsCommander_id 			= ItsCommanderRegister.value;
											var ItsCommanderStateList_id 	= ItsCommander_id+"stateList|";
											var ItsCommanderStateList    	= document.getElementById(ItsCommanderStateList_id);
												if (ItsCommanderStateList!=null)
												{
													ItsCommanderStateList.value = 'hidden';
												}
											}
											if (HidingArray[j].className.indexOf('submenucontainer')>-1)
											{
												//alert("submenu container....");
											var parent_id 														= HidingArray[j].getAttribute('parent_id');
											var parent_commander_expansion_status_id 							= parent_id+"Commander|expansion_status|";
											var parent_commander_expansion_status_elem   						= document.getElementById(parent_commander_expansion_status_id);
												if (parent_commander_expansion_status_elem!=null)
												{
													parent_commander_expansion_status_elem.value 				= "N";
												var parent_commander_expansion_status_orientation_id 			= parent_id+"Commander|expansion_status_orientation|";
													parent_commander_expansion_status_orientation 				= document.getElementById(parent_commander_expansion_status_orientation_id);
													//alert("parent_commander_expansion_status_orientation : "+parent_commander_expansion_status_orientation.id);
													if (parent_commander_expansion_status_orientation!=null) {parent_commander_expansion_status_orientation.src = "icons/16x16/arrow_node_expansion_right_16x16.png";}
												}else
												{
													alert('not found.....');
												}
											}

										var ComboBox_els 														= jQuery(".ComponentsTagExtenders-EnhancedComboBox");
											for(var b=0;b<ComboBox_els.length;++b)
											{//Combo Box To Reset												
											var ComboBox_el 													= ComboBox_els[b];
											var ComboBox_id 													= ComboBox_el.id;

											var StateListId 													= ComboBox_id+"stateList|";
											var StateListEl 													= document.getElementById( StateListId);
												StateListEl.value 												= 'hidden';
											}
										}
}

function getAncestorByClassName(elementIn,CalssNameIn)
{
	var el 	= elementIn;
	var i	= 0;

	while(1)//(el.tagName.toUpperCase()!='FORM')&&(i<100))
	{
		++i;
		//alert('node = '+el.tagName+' daddy: '+el.parentNode.tagName);
		el = el.parentNode;
		//alert(' getAssociatedFormElement  id:'+el.id+' value : '+el.getAttribute("form_acting"));
		if (
				(el.className!=null)
				&&
				(el.className.indexOf(CalssNameIn)>-1)
			)
		{
			return el;
		}else
		{
		}
		if (i>100)
		{
			return null;
		}
	}
}

function sliderScrollClick_div(eventIn,MovableElementIdIn,ControlledDIVOuterDivIdIn,orientationIn)
{
	if (orientationIn=='overflow_H')
	{
		var arrayScrollActive 					= retrieveScrollElementById(ControlledDIVOuterDivIdIn,'overflow_H');
		var MousePosX 							= getPosition(eventIn).x;
			//console_log("MousePosX:"+MousePosX);
		var MovableElement 						= document.getElementById(MovableElementIdIn); 
		//var MovableElementRect 		= MovableElement.getBoundingClientRect(); 
		var MovableElementWidth					= MovableElement.clientWidth;//MovableElementRect.right-MovableElementRect.left;
		var TresholdRightPosX					= arrayScrolls[arrayScrollActive].XCursorRace-MovableElementWidth;
		//alert('click TresholdRightPosX:'+TresholdRightPosX);
		var TargetPosX							= MousePosX-arrayScrolls[arrayScrollActive].XCursorStart-MovableElementWidth/2;
			if (TargetPosX>TresholdRightPosX)  		{TargetPosX=TresholdRightPosX;}
			if (TargetPosX<0) 				   		{TargetPosX=0;}

			MovableElement.style.left  				= TargetPosX+'px';
			arrayScrolls[arrayScrollActive].left 	= TargetPosX;
			ScrollElementAdjust_generic(ControlledDIVOuterDivIdIn,MovableElement.getBoundingClientRect().left,MovableElement.getBoundingClientRect().right,'overflow_H');
	}

//	alert('container width : '+arrayScrolls[arrayScrollActive].XCursorRace+'MousePosX:'+MousePosX+' XCursorStart :'+arrayScrolls[arrayScrollActive].XCursorStart+' MovableElementWidth :'+MovableElementWidth+' TresholdRightPosX : '+TresholdRightPosX);
	if (orientationIn=='overflow_V')
	{
		var arrayScrollActive 					= retrieveScrollElementById(ControlledDIVOuterDivIdIn,'overflow_V');
		var MousePosY 							= getPosition(eventIn).y/zoom_css_component;
		
		var MovableElement 						= document.getElementById(MovableElementIdIn); 
		//var MovableElementRect 		= MovableElement.getBoundingClientRect(); 
		var MovableElementHeight				= MovableElement.clientHeight;//MovableElementRect.right-MovableElementRect.left;
		var TresholdBottomPosY					= arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight;
		var TargetPosY							= MousePosY-arrayScrolls[arrayScrollActive].YCursorStart-MovableElementHeight/2;
			if (TargetPosY>TresholdBottomPosY)		{TargetPosY=TresholdBottomPosY;}
			if (TargetPosY<0) 						{TargetPosY=0;}
			MovableElement.style.top  				= TargetPosY+'px';
			arrayScrolls[arrayScrollActive].top 	= TargetPosY;
			ScrollElementAdjust_generic(ControlledDIVOuterDivIdIn,MovableElement.getBoundingClientRect().top,MovableElement.getBoundingClientRect().bottom,'overflow_V');
	}
}

function sliderScrollPreset_div(amount,MovableElementIdIn,ControlledDIVOuterDivIdIn,orientationIn)
{//ControlledDIVOuterDivIdIn:frame
		if (orientationIn=='overflow_H')
		{
		var arrayScrollActive 					= retrieveScrollElementById(ControlledDIVOuterDivIdIn,'overflow_H');
		var MousePosX 							= amount;
		var MovableElement 						= document.getElementById(MovableElementIdIn); 
		//var MovableElementRect 		= MovableElement.getBoundingClientRect(); 
		var MovableElementWidth					= MovableElement.clientWidth;//MovableElementRect.right-MovableElementRect.left;
		var TresholdRightPosX					= arrayScrolls[arrayScrollActive].XCursorRace-MovableElementWidth;
		//alert('click TresholdRightPosX:'+TresholdRightPosX);
		var TargetPosX							= MousePosX-arrayScrolls[arrayScrollActive].XCursorStart-MovableElementWidth/2;
			if (TargetPosX>TresholdRightPosX)			{TargetPosX=TresholdRightPosX;}
			if (TargetPosX<0)							{TargetPosX=0;}

			MovableElement.style.left				= TargetPosX+'px';
			arrayScrolls[arrayScrollActive].left	= TargetPosX;
			ScrollElementAdjust_generic(ControlledDIVOuterDivIdIn,MovableElement.getBoundingClientRect().left,MovableElement.getBoundingClientRect().right,'overflow_H');
		}

//	alert('container width : '+arrayScrolls[arrayScrollActive].XCursorRace+'MousePosX:'+MousePosX+' XCursorStart :'+arrayScrolls[arrayScrollActive].XCursorStart+' MovableElementWidth :'+MovableElementWidth+' TresholdRightPosX : '+TresholdRightPosX);
		if (orientationIn=='overflow_V')
		{
		var arrayScrollActive 					= retrieveScrollElementById(ControlledDIVOuterDivIdIn,'overflow_V');
		var MousePosY 							= amount;
		var MovableElement						= document.getElementById(MovableElementIdIn); 
		//var MovableElementRect 		= MovableElement.getBoundingClientRect(); 
		var MovableElementHeight				= MovableElement.clientHeight;//MovableElementRect.right-MovableElementRect.left;
		var TresholdBottomPosY					= arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight;
		var TargetPosY							= MousePosY-arrayScrolls[arrayScrollActive].YCursorStart-MovableElementHeight/2;
			if (TargetPosY>TresholdBottomPosY)		{TargetPosY=TresholdBottomPosY;}
			if (TargetPosY<0) 				 		{TargetPosY=0;}

			MovableElement.style.top				= TargetPosY+'px';
			arrayScrolls[arrayScrollActive].top 	= TargetPosY;

			ScrollElementAdjust_generic(ControlledDIVOuterDivIdIn,MovableElement.getBoundingClientRect().top,MovableElement.getBoundingClientRect().bottom,'overflow_V');
		}
}

function sliderScrollPreset_div_rev2(amount,SWIdIn,orientationIn)
{//ControlledDIVOuterDivIdIn:frame
	var SWIdIn_aux									= replaceAll(SWIdIn,'\\|', '__');

	var SW_frame_el 								= document.getElementById(SWIdIn+"frame|");
	var SW_ContentArea_el 							= document.getElementById(SWIdIn+"ContentArea|");

		//console_log("SWIdIn_aux:"+SWIdIn_aux+"  frame id :"+SW_frame_el.id);
	var MySW 										= document.getElementById(SWIdIn);

	if (orientationIn=='overflow_H')
	{
			//console_log(" .......... "+SWIdIn_aux+"slider_slot_bottom__");
		var MovableElement 							= jQuery("#"+SWIdIn_aux+"slider_slot_bottom__").find(".slider_cursor")[0];
			//console_log("ccccccccc"+MovableElement.innerHTML)
		//var SHIFT_PC 								= 0;
		//var FREERUN 								= 0;
		//var CURSOR_M 								= 0;
		//var W_CONTENTAREA 						= 0;
		//var W_FRAME 								= 0;

		var arrayScrollActive 						= retrieveScrollElementById(SW_frame_el.id,'overflow_H');
			//var MousePosX 						= amount;
			//var MovableElement 					= document.getElementById(MovableElementIdIn); 
			//var MovableElementRect 				= MovableElement.getBoundingClientRect(); 
		var MovableElementWidth						= MovableElement.clientWidth;//MovableElementRect.right-MovableElementRect.left;
		var TresholdRightPosX						= arrayScrolls[arrayScrollActive].XCursorRace-MovableElementWidth;
			//alert('click TresholdRightPosX:'+TresholdRightPosX);
		var TargetPosX								= - amount*TresholdRightPosX /(jQuery(SW_frame_el).width() - jQuery(SW_ContentArea_el).width() );

			if (TargetPosX>TresholdRightPosX)  		{TargetPosX=TresholdRightPosX;}
			if (TargetPosX<0) 				   		{TargetPosX=0;}

			MovableElement.style.left  				= TargetPosX+'px';
			arrayScrolls[arrayScrollActive].left 	= TargetPosX;

			ScrollElementAdjust_generic(SW_frame_el.id,MovableElement.getBoundingClientRect().left,MovableElement.getBoundingClientRect().right,'overflow_H');
	}

	//alert('container width : '+arrayScrolls[arrayScrollActive].XCursorRace+'MousePosX:'+MousePosX+' XCursorStart :'+arrayScrolls[arrayScrollActive].XCursorStart+' MovableElementWidth :'+MovableElementWidth+' TresholdRightPosX : '+TresholdRightPosX);
	if (orientationIn=='overflow_V')
	{
		var MovableElement 							= jQuery("#"+SWIdIn_aux+"slider_slot_right__").find(".slider_cursor")[0];
		var arrayScrollActive 						= retrieveScrollElementById(SW_frame_el.id,'overflow_V');
		//var MousePosY 							= amount;
		//var MovableElement 						= document.getElementById(MovableElementIdIn); 
		//var MovableElementRect 					= MovableElement.getBoundingClientRect(); 
		var MovableElementHeight					= MovableElement.clientHeight;//MovableElementRect.right-MovableElementRect.left;
		var TresholdBottomPosY						= arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight;
		
		var TargetPosY								= - amount*TresholdRightPosY /(jQuery(SW_frame_el).height() - jQuery(SW_ContentArea_el).height() );
		//var TargetPosY								= MousePosY-arrayScrolls[arrayScrollActive].YCursorStart-MovableElementHeight/2;

			if (TargetPosY>TresholdBottomPosY)		{TargetPosY=TresholdRightPosY;}
			if (TargetPosY<0) 						{TargetPosY=0;}

			MovableElement.style.top  				= TargetPosY+'px';
			arrayScrolls[arrayScrollActive].top 	= TargetPosY;

			ScrollElementAdjust_generic(SW_frame_el.id,MovableElement.getBoundingClientRect().top,MovableElement.getBoundingClientRect().bottom,'overflow_V');
	}
}

function sliderScrollContentByDelta(deltaIn,SWIdIn,orientationIn)
{//ControlledDIVOuterDivIdIn:frame
		//console_log("sliderScrollContentByDelta .....");
	var SWIdIn_aux 									= replaceAll(SWIdIn,'\\|', '__');
	
	var SW_frame_el 								= document.getElementById(SWIdIn+"frame|");
	var SW_ContentArea_el 							= document.getElementById(SWIdIn+"ContentArea|");

		//console_log("SWIdIn_aux:"+SWIdIn_aux+"  frame id :"+SW_frame_el.id);
	var MySW 										= document.getElementById(SWIdIn);
	
		if (orientationIn=='overflow_H')
		{
				//console_log(" .......... "+SWIdIn_aux+"slider_slot_bottom__");
			var MovableElement 							= jQuery("#"+SWIdIn_aux+"slider_slot_bottom__").find(".slider_cursor")[0];
			
			var arrayScrollActive 						= retrieveScrollElementById(SW_frame_el.id,'overflow_H');
			
				if (MovableElement)
				{
			var CurrentX 								= arrayScrollActive.left;
			var TargetX 								= CurrentX+deltaIn;
				//console_log("CurrentX:"+CurrentX+" TargetX:"+TargetX);
				arrayScrollActive.left 					= TargetX; 
				ScrollElementAdjust_generic(SW_frame_el.id,MovableElement.getBoundingClientRect().left,MovableElement.getBoundingClientRect().right,'overflow_H');
				}
		}

		//alert('container width : '+arrayScrolls[arrayScrollActive].XCursorRace+'MousePosX:'+MousePosX+' XCursorStart :'+arrayScrolls[arrayScrollActive].XCursorStart+' MovableElementWidth :'+MovableElementWidth+' TresholdRightPosX : '+TresholdRightPosX);
		if (orientationIn=='overflow_V')
		{
			var arrayScrollActive 							= retrieveScrollElementById(SW_frame_el.id,'overflow_V');
			var MovableElement 								= jQuery("#"+SWIdIn_aux+"slider_slot_right__").find(".slider_cursor")[0];

			var MovableElementHeight						= MovableElement.clientHeight;//MovableElementRect.right-MovableElementRect.left;
	//		var TresholdBottomPosY							= arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight;
	//		var YContent									= arrayScrolls[arrayScrollActive].YContent;
			var deltaCursorTop								= parseFloat( ( (arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight)/arrayScrolls[arrayScrollActive].YContent  ) * (-deltaIn) ) ;
															  //proportion
				if (arrayScrolls[arrayScrollActive].top+deltaCursorTop > arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight ) 
				{
					arrayScrolls[arrayScrollActive].top		= parseInt(arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight);
				} else
				if (arrayScrolls[arrayScrollActive].top+deltaCursorTop < 0 )
				{
					arrayScrolls[arrayScrollActive].top		= 0; 
				} else
				{
					arrayScrolls[arrayScrollActive].top		+= parseInt(deltaCursorTop);	
				}
				MovableElement.style.top  					= arrayScrolls[arrayScrollActive].top+'px';
			var currentScrollTop							= jQuery(SW_frame_el).scrollTop();
				jQuery(SW_frame_el).scrollTop(currentScrollTop-deltaIn);
		}
}

function sliderScrollContentByTargetScroll(TargetScrollIn,SWIdIn,orientationIn)
{//ControlledDIVOuterDivIdIn:frame
		//console_log("sliderScrollContentByDelta .....");
	var SWIdIn_aux									= replaceAll(SWIdIn,'\\|', '__');

	var SW_frame_el 								= document.getElementById(SWIdIn+"frame|");
	var SW_ContentArea_el 							= document.getElementById(SWIdIn+"ContentArea|");

		//console_log("SWIdIn_aux:"+SWIdIn_aux+"  frame id :"+SW_frame_el.id);
	var MySW 										= document.getElementById(SWIdIn);

		if (orientationIn=='overflow_H')
		{
				//console_log(" .......... "+SWIdIn_aux+"slider_slot_bottom__");
		var MovableElement 							= jQuery("#"+SWIdIn_aux+"slider_slot_bottom__").find(".slider_cursor")[0];
			
		var arrayScrollActive 						= retrieveScrollElementById(SW_frame_el.id,'overflow_H');
			
			if (MovableElement)
			{
			var CurrentX 								= arrayScrollActive.left;
			var TargetX 								= CurrentX+deltaIn;
				//console_log("CurrentX:"+CurrentX+" TargetX:"+TargetX);
				arrayScrollActive.left 					= TargetX; 
				ScrollElementAdjust_generic(SW_frame_el.id,MovableElement.getBoundingClientRect().left,MovableElement.getBoundingClientRect().right,'overflow_H');
			}
		}

		//alert('container width : '+arrayScrolls[arrayScrollActive].XCursorRace+'MousePosX:'+MousePosX+' XCursorStart :'+arrayScrolls[arrayScrollActive].XCursorStart+' MovableElementWidth :'+MovableElementWidth+' TresholdRightPosX : '+TresholdRightPosX);
		if (orientationIn=='overflow_V')
		{
			var currentScrollTop							= jQuery(SW_frame_el).scrollTop();
			
			//var deltaIn 									= TargetScrollIn -currentScrollTop;
			
			var arrayScrollActive 							= retrieveScrollElementById(SW_frame_el.id,'overflow_V');
			var MovableElement 								= jQuery("#"+SWIdIn_aux+"slider_slot_right__").find(".slider_cursor")[0];
			
			var MovableElementHeight						= MovableElement.clientHeight;//MovableElementRect.right-MovableElementRect.left;
	//		var TresholdBottomPosY							= arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight;
	//		var YContent									= arrayScrolls[arrayScrollActive].YContent;
			var targetCursorTop								= parseFloat( ( (arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight)/arrayScrolls[arrayScrollActive].YContent  ) * (TargetScrollIn) ) ;
															  //proportion
				if (targetCursorTop > arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight ) 
				{
					arrayScrolls[arrayScrollActive].top		= targetCursorTop;
				} else
				if (targetCursorTop < 0 )
				{
					arrayScrolls[arrayScrollActive].top		= 0; 
				} else
				{
					arrayScrolls[arrayScrollActive].top		= targetCursorTop;	
				}
					
				MovableElement.style.top  					= arrayScrolls[arrayScrollActive].top+'px';
				jQuery(SW_frame_el).scrollTop(TargetScrollIn);
		}
}

/*
param MovableElement_IdIn: in the format __concorsi__slider_slot_bottom__H0_SLIDER. Is referred to the slider cursor
 */
function sliderScrollKey_div(MovableElement_IdIn,KeyIn)
{
		//console_log("PPPQQQ----sliderScrollKey_div:"+MovableElement_IdIn);
		//alert("KeyIn : "+KeyIn+" slider id : "+MovableElement_IdIn);
	var Movable_Element_elem 									= document.getElementById(MovableElement_IdIn);
		//console_log("MovableElement_IdIn:"+MovableElement_IdIn);
		if (Movable_Element_elem!=null)
		{
			//alert("found element");
			var SWOwner_element 								= getOwnerSW(Movable_Element_elem);
			var ControlledDIVOuterDivIdIn 						= SWOwner_element.id +"frame|"; 
			var multiplier										= 0;

				//alert('sliderScrollKey_div MovableElementIdIn : '+MovableElementIdIn+' KeyIn : '+KeyIn);
				if ((KeyIn==37)||(KeyIn==39))
				{
					if (KeyIn == 37) {multiplier = -1;}
					if (KeyIn == 39) {multiplier =  1;}
					//alert('overflow_H multiplier : '+multiplier );

					//if (orientationIn=='overflow_H')
					{
						//alert('MovableElement_IdIn:'+MovableElement_IdIn);
						var arrayScrollActive 						= retrieveScrollElementByMovableElementId(MovableElement_IdIn);

						//var MousePosX 							= getPosition(eventIn).x;
						var MovableElement 							= document.getElementById(MovableElement_IdIn); 
						//var MovableElementRect 					= MovableElement.getBoundingClientRect(); 
						var MovableElementWidth						= MovableElement.clientWidth;//MovableElementRect.right-MovableElementRect.left;
						var TresholdRightPosX						= arrayScrolls[arrayScrollActive].XCursorRace-MovableElementWidth;
						//alert('key TresholdRightPosX:'+TresholdRightPosX);

						//var TargetPosX							= MousePosX-arrayScrolls[arrayScrollActive].XCursorStart-MovableElementWidth/2;
						//alert('left before : '+arrayScrolls[arrayScrollActive].left);

						var TargetPosX 								= arrayScrolls[arrayScrollActive].left + parseInt((arrayScrolls[arrayScrollActive].XCursorRace-MovableElementWidth)/20)*multiplier;

							if (TargetPosX>TresholdRightPosX)		{TargetPosX=TresholdRightPosX;}
							if (TargetPosX<0) 						{TargetPosX=0;}

							//alert('TargetPosX : '+TargetPosX);
							//fMovableElement.style.left  				= TargetPosX+'px';
							//arrayScrolls[arrayScrollActive].left 	= TargetPosX;

							MovableElement.style.left				= TargetPosX+'px';
							arrayScrolls[arrayScrollActive].left 	= TargetPosX;
							//print_arrayScroll(arrayScrollActive);
							ScrollElementAdjust_generic(ControlledDIVOuterDivIdIn,MovableElement.getBoundingClientRect().left,MovableElement.getBoundingClientRect().right,'overflow_H');
					}
				}

				//alert('container width : '+arrayScrolls[arrayScrollActive].XCursorRace+'MousePosX:'+MousePosX+' XCursorStart :'+arrayScrolls[arrayScrollActive].XCursorStart+' MovableElementWidth :'+MovableElementWidth+' TresholdRightPosX : '+TresholdRightPosX);
				if ((KeyIn==38)||(KeyIn==40)||(KeyIn==33)||(KeyIn==34))
				{
						if (KeyIn == 38) {multiplier = -1;}
						if (KeyIn == 40) {multiplier =  1;}

						if (KeyIn == 33) {multiplier = -5;}
						if (KeyIn == 34) {multiplier =  5;}

						//alert('overflow_V');
						//CursorElementId
					var arrayScrollActive 							= retrieveScrollElementByMovableElementId(MovableElement_IdIn);
					//var MousePosY 								= getPosition(eventIn).y;
					var MovableElement 								= document.getElementById(MovableElement_IdIn); 
					//var MovableElementRect 						= MovableElement.getBoundingClientRect(); 
					var MovableElementHeight						= MovableElement.clientHeight;//MovableElementRect.right-MovableElementRect.left;
					var TresholdBottomPosY							= arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight;
					//var TargetPosY								= MousePosY-arrayScrolls[arrayScrollActive].YCursorStart-MovableElementHeight/2;
					var step 										= parseInt((arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight)/50);////20?30? how many steps?
					var gap 										= parseInt(arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight);
						if ((step == 0)&&(gap!=0)) {step=1;}
					var TargetPosY									= parseInt(arrayScrolls[arrayScrollActive].top + step*multiplier);

						//alert("TargetPosY initial :"+TargetPosY+" shift : "+parseInt((arrayScrolls[arrayScrollActive].YCursorRace-MovableElementHeight)/20)*multiplier+" multiplier : "+multiplier);
						if (TargetPosY>TresholdBottomPosY)		{TargetPosY=TresholdBottomPosY;}
						if (TargetPosY<0) 						{TargetPosY=0;}

						//alert('v ...arrayScrollActive:'+arrayScrollActive+'   TresholdBottomPosY:'+TresholdBottomPosY+" TargetPosY : "+TargetPosY);

						//slider cursor
						MovableElement.style.top					= TargetPosY+'px';
						arrayScrolls[arrayScrollActive].top 		= TargetPosY;
						//print_arrayScroll(arrayScrollActive);
						ScrollElementAdjust_generic(ControlledDIVOuterDivIdIn,MovableElement.getBoundingClientRect().top,MovableElement.getBoundingClientRect().bottom,'overflow_V');
				}
		}
}

function sliderScrollKey_table(MovableElement_IdIn,KeyIn)
{
	var Movable_Element_elem 		= document.getElementById(MovableElement_IdIn);
		if (Movable_Element_elem!=null)
		{
				var SWOwner_element 			= getOwnerSW(Movable_Element_elem);
				var ControlledDIVOuterDivIdIn 	= SWOwner_element.id +"outer|scrollablediv|"; 
				var multiplier 					= 0;

				if ((KeyIn==37)||(KeyIn==39))
				{
					if (KeyIn == 37) {multiplier = -1;}
					if (KeyIn == 39) {multiplier =  1;}

			//		if (orientationIn=='overflow_H')
					{
						//alert('MovableElement_IdIn:'+MovableElement_IdIn);
						var arrayScrollActive 					= retrieveScrollElementByMovableElementId(MovableElement_IdIn);

						//var MousePosX 							= getPosition(eventIn).x;
						var MovableElement 						= document.getElementById(MovableElement_IdIn); 
						//var MovableElementRect 		= MovableElement.getBoundingClientRect(); 
						var MovableElementWidth					= MovableElement.clientWidth;//MovableElementRect.right-MovableElementRect.left;
						var TresholdRightPosX					= arrayScrolls[arrayScrollActive].XCursorRace-MovableElementWidth;
							//alert('key TresholdRightPosX:'+TresholdRightPosX);

						//var TargetPosX							= MousePosX-arrayScrolls[arrayScrollActive].XCursorStart-MovableElementWidth/2;
						//alert('left before : '+arrayScrolls[arrayScrollActive].left);

					var TargetPosX 								= arrayScrolls[arrayScrollActive].left + parseInt((arrayScrolls[arrayScrollActive].XCursorRace-MovableElementWidth)/20)*multiplier;

						if (TargetPosX>TresholdRightPosX)		{TargetPosX=TresholdRightPosX;}
						if (TargetPosX<0)						{TargetPosX=0;}

						//alert('TargetPosX : '+TargetPosX);
						//fMovableElement.style.left  				= TargetPosX+'px';
						//arrayScrolls[arrayScrollActive].left 	= TargetPosX;

						MovableElement.style.left  				= TargetPosX+'px';
						arrayScrolls[arrayScrollActive].left 	= TargetPosX;
						//print_arrayScroll(arrayScrollActive);
						//console_log("ControlledDIVOuterDivIdIn :"+ ControlledDIVOuterDivIdIn+ " MovableElement : " +MovableElement);

						ScrollElementAdjust(ControlledDIVOuterDivIdIn,MovableElement.getBoundingClientRect().left,MovableElement.getBoundingClientRect().right,'overflow_H');
					}
				}
		}
}

function openpopup(popurl)
{ 
	//popurl=popurl +".jsp?autologin=true&ExecutionZone=GeneralLogin"; 
	popurl	= popurl +".jsp?start";
	winpops	= window.open(popurl,"","toolbar=no,menubar=no,location=no,width=300,height=330,scrollbars,");
} 	

///////////////////////////////////////////////////////////////////////////////////////////////////////
//// TIMING FUNCTION START
////Each Timer created by the use has to be registered in the arrayTimers
////They can be handled by a programmer defined TimerHandlerIn.
////Each TimerHandlerIn is associated to a TimerID 

var 	 				arrayTimers 				= [];

/***
 * TimerIDIn		: Identifier of Timer given by js creation function;
 * StepIn			: Timer Start Step???
 * TimerHandlerIn 	: Handler di find Timer in array
 * IntervalIn		: Time Interval
 */
function addTimer(TimerIDIn, StepIn, TimerHandlerIn,IntervalIn)
{
	var 				myTimerElement 				= new generateTimerElement(TimerIDIn, StepIn, TimerHandlerIn,IntervalIn);
						arrayTimers.push(myTimerElement);
}

/*
 * called by addTimer();
 */
function generateTimerElement(TimerIDIn, StepIn, TimerHandlerIn,IntervalIn) 
{
						this.TimerID																						= TimerIDIn;//System generated ID
						this.Step																							= StepIn;
						this.TimerHandler																					= TimerHandlerIn;//Programmer defined Handler 
						this.Interval																						= IntervalIn;
}

function getTimerPositionByHandler(TimerHandlerIn)
{
						//If a timer is found a non negative index is returned
						//If a timer is not found -1 is returned
					var matchElement=-1;
						if (arrayTimers!=null)
						{
							if(arrayTimers.length > 0) 
							{
								for(var kkj=0;kkj<arrayTimers.length;kkj++)
								{
									if (arrayTimers[kkj].TimerHandler==TimerHandlerIn)
									{
										matchElement	= kkj;	
									}
								}
							}
						}
						return matchElement;
}

function removeTimerByArrayPosition(PositionIn)
{
						window.clearTimeout(arrayTimers[PositionIn].TimerID);
						arrayTimers.splice(PositionIn,1);
}

function removeTimerByHandler(HandlerIn)
{
					var TimerPosition																						=  getTimerPositionByHandler(HandlerIn);
						if (TimerPosition>=0)
						{
							window.clearTimeout(arrayTimers[TimerPosition].TimerID);
							arrayTimers.splice(TimerPosition,1);
						}
}

function removeAllTimers()
{
						//alert('removeAllTimers() execution');
						if (arrayTimers.length>0)
						{
							for(var f=0;f<arrayTimers.length;++f)
							{
								removeTimerByArrayPosition(f);
							}
						}
						
					var x 										= setTimeout(function () {
  							alert("Closing app by timout trheshold");
						},100000); //It is very low probability that after 100 seconds x timeout will not be cleared
						for (var i = 0; i <= x; i++) clearTimeout(i);
}
////TIMING FUNCTION END
///////////////////////////////////////////////////////////////////////////////////////////////////////

function invalidateAfter(secondsIn) 
{
						exitCounter=0;
						
						setInterval(function () {myInvalidateTimer(secondsIn);}, 1000);
					
						function myInvalidateTimer(secondsIn) 
						{
							++exitCounter;
							if (exitCounter>secondsIn)
							{
								document.location.href = "JSPAux/SessionTimeout.jsp";
							}
						}
}

function centerElementInRelativeContainer(elemIn)
{
						//alert('centerElementInRelativeContainer elemIn:'+elemIn.id );
						if (elemIn!=null)
						{
						var elemIn_parent_elem = elemIn.parentNode;
							if (elemIn_parent_elem!=null)
							{												
								if (elemIn_parent_elem.style.position == 'relative')
								{
								var elemIn_parent_width 	= parseInt(elemIn_parent_elem.getBoundingClientRect().right -elemIn_parent_elem.getBoundingClientRect().left);  
								var elemIn_parent_height 	= parseInt(elemIn_parent_elem.getBoundingClientRect().bottom-elemIn_parent_elem.getBoundingClientRect().top);
								var elemIn_width 			= parseInt(elemIn.getBoundingClientRect().right -elemIn.getBoundingClientRect().left);  
								var elemIn_height 			= parseInt(elemIn.getBoundingClientRect().bottom-elemIn.getBoundingClientRect().top);
					
									elemIn.style.position   = 'absolute';
								var MyTop 	 				= parseInt((elemIn_parent_height- elemIn_height)/2);
									//alert("elemIn_parent_height : "+elemIn_parent_height+" elemIn_height : "+elemIn_height+" MyTop : "+MyTop);
								var MyLeft 					= parseInt((elemIn_parent_width - elemIn_width )/2);
									//alert('parent id :'+elemIn_parent_elem.id+' \n parent W: '+elemIn_parent_width+' me width : '+elemIn_width+' \n elemIn_parent_height : '+elemIn_parent_height+'  elemIn_height : '+elemIn_height+'\nMy Left:'+MyLeft+' MyTop:'+MyTop);
				
									elemIn.style.top 		= MyTop +'px';
									elemIn.style.left 		= MyLeft+'px'; 
								}
							}
						}
}

function overflow_control(IdentifierIn)
{
						document.getElementById(IdentifierIn).onkeypress = 
						function(event) 
						{
					var 	char = getChar(event || window.event);
						  	alert('pressed key : '+char);
						  	//if (!char) return // special key
						  	this.value = char.toUpperCase();
						  	return false;
						};
}

function defocusAllSW()
{
					var AllSW = $(".focused");
						if (AllSW!=null)
						{
							for(var gi=0;gi<AllSW.length;++gi)
							{
								//AllSW[gi].className = AllSW[gi].className.replace(" focused ",""); 
								jQuery(AllSW[gi]).removeClass('focused');
							}
						}
}

function defocusAll_slider_cursors()
{
					var AllSW = $(".focused");
						if (AllSW!=null)
						{
							for(var gi=0;gi<AllSW.length;++gi)
							{
								//AllSW[gi].className = AllSW[gi].className.replace(" focused ",""); 
								jQuery(AllSW[gi]).removeClass('focused');
							}
						}
}

function focused_elements_find()
{
	var 				AllFocusedSW = $(".focused");
						return AllFocusedSW;
}

function overflow_control_selection(IdentifierIn,ChangeUnderlyingSW)
{
						if(IdentifierIn=='document') return;
						//console.log(new Error());
						//onmouseover seems not to have bubbling...... 
						// to be optimized....
						// focus is activated only if the SW has got sliders....
						// focus may be needed for other pourposes, not only to drive overflow sliders...
					
						/*
						var String_ArrayScrolls ="";
						for(var ti=0;ti<arrayScrolls.length;++ti)
						{
							String_ArrayScrolls+= "<br> "+arrayScrolls[ti].ScrollID;
						}
						//alert('String_ArrayScrolls:'String_ArrayScrolls);
						$("#debuggeroutput_content").html("t_last_mouse_movement > t_last_key_event");
						alert("String_ArrayScrolls : "+String_ArrayScrolls);
						*/
						//console_log("overflow_control_selection. Calling SW  ID : "+IdentifierIn+" ChangeUnderlyingSW : "+ChangeUnderlyingSW);
						//$("#debuggeroutput_content").html("\nt_last_mouse_movement "+t_last_mouse_movement+"\n ....t_last_key_event"+t_last_key_event+"\n SliderCursorDragging:"+SliderCursorDragging);
	
						//// If the function is called (i.e. on mouseover event passing to an element to another)
						////    but a SW change was not recorded, the check is not perfromed at all
						///// always true exept than in overflow_control_selection() the parameter ChangeUnderlyingSW is not set at all....verify!
						if (ChangeUnderlyingSW)
						{
							//console_log('t_last_mouse_movement:'+t_last_mouse_movement+'   t_last_key_event:'+t_last_key_event+'   t_last_wheel_event:'+t_last_wheel_event+' SliderCursorDragging:'+SliderCursorDragging);
							//If you are dragging an element 
							//or if the mousemove was determinated not by a mouse movement but a scenario movement (e.g. the window was programmatically scrolled)
							if ((t_last_mouse_movement > t_last_key_event)&&(t_last_mouse_movement > t_last_wheel_event)&&(SliderCursorDragging==false))
							{
								//Here we have a change of underlying SW and was generated by a mouse movement
								//Following conditions are occurring:
								//	1- Mouse changed position
								//	2- Underlying SW was changed
								defocusAll_slider_cursors();
								
								Active_Slider_H 								= null;
								Active_Slider_V 								= null;
								Active_Slider_TABLE 							= null;
							
							var string_SubWindows								= IdentifierIn+";";
								//^^^^^useful for debugging pourposes
							
							var body_id											= document.body.id;
							
							var goon											= true;
								while(goon)
								{
									//check if the element identified by IdentifierIn has one or two sliders or no sliders
								var elementIn 					  				= document.getElementById(IdentifierIn);
									//var scroller_dock_id    		  				= elementIn.getAttribute("scroller_dock");
									//if (scroller_dock_id!=null){}
									//alert("looping:"+elementIn.id);
								var slider_slot_bottom_id 		  				= normalizeTokens__(IdentifierIn)+"slider_slot_bottom__";
								var slider_slot_bottom_elem		  				= document.getElementById(slider_slot_bottom_id);

								var slider_slot_right_id 		  				= normalizeTokens__(IdentifierIn)+"slider_slot_right__";
								var slider_slot_right_elem		  				= document.getElementById(slider_slot_right_id);

								var slider_ContentTableChunk_id   				= normalizeTokens__(IdentifierIn)+"TableForm__TablesSliderRow__2_SLIDER";
								var slider_ContentTableChunk_elem 				= document.getElementById(slider_ContentTableChunk_id);

									//console_log("Identifier In..."+IdentifierIn);
									//alert("checking "+IdentifierIn);
									if ((slider_slot_bottom_elem!=null)|| (slider_slot_right_elem!=null)||(slider_ContentTableChunk_elem!=null))
									{
										//console_log(" has slider:   "+slider_slot_bottom_elem+"  "+slider_slot_right_elem+"   "+slider_ContentTableChunk_elem);
										//alert(" slider_slot_bottom_elem : "+slider_slot_bottom_elem.id+" slider_slot_right_elem : "+slider_slot_right_elem.id);
										//found
										//$("#debuggeroutput_content").html("__ slider_slot_bottom_elem : "+slider_slot_bottom_elem.id+" slider_slot_right_elem : "+slider_slot_right_elem.id);
										goon						= false;
										//window.location.hash = '#'+IdentifierIn;
										//elementIn.focus();
										//console_log("__________________ IdentifierIn:"+IdentifierIn);
										//console_log("__________________ elementIn.className:"+elementIn.className+"   focused:"+elementIn.className.indexOf("focused"));
										
										if (elementIn.className.indexOf("focused")==-1)
										{
											defocusAllSW();
											//elementIn.className = elementIn.className + " focused ";
											jQuery(elementIn).addClass('focused');
										}
										if (slider_slot_bottom_elem!=null)
										{
											Active_Slider_H 					= normalizeTokens__(IdentifierIn)+"slider_slot_bottom__H0_SLIDER";
										var Active_Slider_H_el 					= document.getElementById(Active_Slider_H);
											//if (isValidElement(Active_Slider_H_el))	Active_Slider_H_el.className 		= Active_Slider_H_el.className+" focused ";
											if (isValidElement(Active_Slider_H_el))	jQuery(Active_Slider_H_el).addClass('focused');
										}
										if (slider_slot_right_elem!=null)
										{
											Active_Slider_V 					= normalizeTokens__(IdentifierIn)+"slider_slot_right__V0_SLIDER";
										var Active_Slider_V_el 					= document.getElementById(Active_Slider_V);
											//if (isValidElement(Active_Slider_V_el)) Active_Slider_V_el.className 		= Active_Slider_V_el.className+" focused ";
											if (isValidElement(Active_Slider_V_el)) jQuery(Active_Slider_V_el).addClass('focused');
										}
										
										if (slider_ContentTableChunk_elem!=null)
										{
											Active_Slider_TABLE 				= normalizeTokens__(IdentifierIn)+"TableForm__TablesSliderRow__2_SLIDER";	
										var Active_Slider_TABLE_el 				= document.getElementById(Active_Slider_TABLE);
										
											//Active_Slider_TABLE_el.className 	= Active_Slider_TABLE_el.className+" focused ";

											jQuery(Active_Slider_TABLE_el).addClass('focused');
							
											//alert("Active_Slider_TABLE : "+Active_Slider_TABLE);
											//$("#"+Active_Slider_TABLE).children[0].style.backgroundColor= "pink";
											//console_log("ccccc : "+Active_Slider_TABLE);
											//console_log("fff  "+$("#"+Active_Slider_TABLE).id);
															
											//__assenze__MainContainer__MyList__TableForm__TablesSliderRow__2_SLIDER
											//__assenze__MainContainer__MyList__TableForm__TablesSliderRow__2_SLIDER
										}
									} else
									{
										if (body_id==IdentifierIn) 
										{
											goon								= false;
										}else
										{
										//	console_log("  --- elementIn id:"+elementIn.id);
										var elementOwner						= getOwnerSW(elementIn);
											IdentifierIn 						= elementOwner.id;

											string_SubWindows			   		+= elementOwner.id+";";
										}
									}
								}//while end
							}
						}
}

function focusMonitor()
{
	//var activeObj = document.activeElement;
	
	//$('#debuggeroutput_content').html("focused element. element tag : "+activeObj.tagName+" id : "+activeObj.id);
}

function getChar_a(event) 
{
				  var 	key_code_out = null;
					  	//alert("event.which : "+event.which);
					  	if (event.which == null) 
					  	{
						  	//alert("d1");
						 	key_code_out=event.keyCode;
					    	//return String.fromCharCode(event.keyCode); // IE
					  	}  else 
						if (event.which!=0 && event.charCode!=0) 
				  		{
						  	key_code_out=event.which;
					  		//return String.fromCharCode(event.which);   // the rest
				  		}	else 
				  		{
				  			key_code_out=event.keyCode;
				  			//key_code_out= null;
				  			//return null; // special key
				  		}
		  				return key_code_out;
}

function getKeyCodeOnKeyDown(event) 
{
					var key_code = null;
						if (typeof event === "undefined")
						{
					var 	MyEvent 	= window.event;
							key_code 	= MyEvent.keyCode;			
						}else
						{
							key_code 	= event.keyCode;
						}		
						return key_code;
}

function keyEvents()
{
}

/*
function keyEvents()
{
	
	//var myformelement = document.getElementById("|login|authshield|uname|");
	$(document.body).on(
							"textchange", 
							function() 
							{
								var value = this.value;
								
								// ...
								alert("key -- : "+value);
							}
					);
}*/

/*
function keyEvents()
{
	document.onkeydown = function(e) 
	{
			//var key_press = String.fromCharCode(event.keyCode);
		
			//var key_code = event.keyCode;
			//var key_code = (window.event) ? event.which : event.keyCode;
			//^ IE8 compatibility
			
			var key_code = e.charCode || e.keyCode;
			$('#debuggeroutput_content').html(" key code : "+key_code+"\n Active_Slider_V : "+Active_Slider_V+"\n Active_Slider_H : "+Active_Slider_H);

			if ((key_code==40)||(key_code == 38)||(key_code == 37)||(key_code == 39)||(key_code == 33)||(key_code == 34))
			{
				if ((Active_Slider_H!=null)&&((key_code == 37)||(key_code == 39)))
				{
					sliderScrollKey_div(Active_Slider_H,key_code);					
				}
				if ((Active_Slider_V!=null)&&((key_code == 38)||(key_code == 40)||(key_code == 33)||(key_code == 34)))
				{
					//alert("keydown");
					sliderScrollKey_div(Active_Slider_V,key_code);					
				}

				
			}
			
			//if (key_code == 40)
			//{
			//	if (Active_Slider_V!=null)
			//	{
			//		var Active_Slider_V_elem = document.getElementById(Active_Slider_V);
			//		if (Active_Slider_V_elem!=null)
			//		{
			//			Active_Slider_V_elem.style.top = parseInt(parseInt(Active_Slider_V_elem.style.top)+10)+"px";
			//		}
			//		
			//	}	
				
			//}
			//if (key_code == 38)
			//{
			//	if (Active_Slider_V!=null)
			//	{
			//		var Active_Slider_V_elem = document.getElementById(Active_Slider_V);
			//		if (Active_Slider_V_elem!=null)
			//		{
			//			Active_Slider_V_elem.style.top = parseInt(parseInt(Active_Slider_V_elem.style.top)-10)+"px";
			//		}
			//		
			//	}	
			//	
			//}
			//	
			//if (key_code == 39)
			//{
			//	if (Active_Slider_H!=null)
			//	{
			//		var Active_Slider_H_elem = document.getElementById(Active_Slider_H);
			//		if (Active_Slider_H_elem!=null)
			//		{
			//			Active_Slider_H_elem.style.left = parseInt(parseInt(Active_Slider_H_elem.style.left)+10)+"px";
			//		}
			//		else
			//		{
			//			
			//		}
			//		
			//	}	
			//	
			//}

			//if (key_code == 37)
			//{
			//	if (Active_Slider_H!=null)
			//	{
			//		sliderScrollKey_div(Active_Slider_H,'overflow_H');
			//		
			//		var Active_Slider_H_elem = document.getElementById(Active_Slider_H);
			//		if (Active_Slider_H_elem!=null)
			//		{
			//			Active_Slider_H_elem.style.left = parseInt(parseInt(Active_Slider_H_elem.style.left)-10)+"px";
			//		}
			//		
			//		else
			//		{
			//			
			//		}
			//		
			//	}	
			//	
			//}

			 
			
	};

}*/

function print_arrayScroll(array_scroll_active_in)
{
	var StringOut		 = "";
		StringOut  		+= "<br>\n XCursorRace  : "+arrayScrolls[array_scroll_active_in].XCursorRace;
		StringOut  		+= "<br>\n left		     : "+arrayScrolls[array_scroll_active_in].left;
		StringOut  		+= "<br>\n XCursorStart : "+arrayScrolls[array_scroll_active_in].XCursorStart;
		StringOut  		+= "<br>\n XContent     : "+arrayScrolls[array_scroll_active_in].XContent;	
		StringOut  		+= "<br>\n YCursorRace  : "+arrayScrolls[array_scroll_active_in].YCursorRace;
		StringOut  		+= "<br>\n top		     : "+arrayScrolls[array_scroll_active_in].top;
		StringOut  		+= "<br>\n YCursorStart : "+arrayScrolls[array_scroll_active_in].YCursorStart;
		StringOut  		+= "<br>\n YContent     : "+arrayScrolls[array_scroll_active_in].YContent;	
		//$("#debuggeroutput_content").html(StringOut);
}

function body_focus_check()
{
	var body_element = document.body;
		//alert("checking body focus... .."+focused_elements_find().length);
		if ((focused_elements_find()==null)||(focused_elements_find().length==0))
		{
			//alert("ffff");
			overflow_control_selection(body_element.id);		
		}
}

function trackBoxLegend(viewer, mouseX, mouseY)
{
	    // Remove all previously drawn tracking object
	    viewer.hideObj("all");

    	// The chart and its plot area
    var c 				= viewer.getChart();
    var plotArea 		= c.getPlotArea();
   		//var document.createEement("div");
    
    	//Get the data x-value that is nearest to the mouse
    var xValue 			= c.getNearestXValue(mouseX);

    	// Compute the position of the box. This example assumes a label based x-axis, in which the labeling spacing
    	// is one x-axis unit. So the left and right sides of the box is 0.5 unit from the central x-value.
    var boxLeft 		= Math.min(c.getXCoor(xValue - 0.5), c.getXCoor(xValue + 0.5));
    var boxWidth 		= Math.max(0, Math.abs(c.getXCoor(xValue + 0.5) - c.getXCoor(xValue - 0.5)) - 1);
    var boxTop 			= plotArea.getTopY();
    var boxHeight 		= Math.max(0, plotArea.getHeight() - 2);

    	// Draw the track box
    	viewer.showTextBox("trackBox", boxLeft, boxTop, JsChartViewer.TopLeft, "","width:" + boxWidth + "px;height:" + boxHeight + "px;border:solid 1px black;z-index:99;");

    	// Array to hold the legend entries
    var legendEntries 	= [];

	    //$("#debuggeroutput_content").html("layers : "+c.getLayerCount()+" boxLeft : "+boxLeft);
	    // Iterate through all layers to build the legend array
	    for (var i = 0; i < c.getLayerCount(); ++i)
	    {
	    var layer = c.getLayerByZ(i);
	
	        // The data array index of the x-value
	    var xIndex = layer.getXIndexOf(xValue);
	
	        // Iterate through all the data sets in the layer
	        for (var j = 0; j < layer.getDataSetCount(); ++j)
	        {
	    var 	dataSet = layer.getDataSetByZ(j);
	
	            // Build the legend entry, consist of a colored square box, the name and the data value.
	        var dataColor = dataSet.getDataColor();
	        var dataValue = dataSet.getValue(xIndex);
	            if ((dataValue != null) && (dataColor != null))
	            {
	                legendEntries.push("<nobr>" + viewer.htmlRect(7, 7, dataColor) + " " +dataSet.getDataName() + ": " + dataValue.toPrecision(4) + "</nobr> ");
	            }
	        }
	    }
	
	    // Create the legend by joining the legend entries
	    if (legendEntries.length > 0)
	    {
	    var legend = "<u>" + c.xAxis().getFormattedLabel(xValue) + "</u><br />" + legendEntries.reverse().join("<br />");
	
	        // Display the legend at the bottom-right side of the mouse cursor
	        viewer.showTextBox("legend", mouseX + 16, mouseY + 16, JsChartViewer.TopLeft, legend,"z-index:99;border:solid 4px red;background:#ffffcc;padding:3px;font:bold 11px Arial;");
	    }
}

function ChartDirectorMouseover(ChartId)
{
	var viewer = JsChartViewer.get(ChartId);

		trackBoxLegend(viewer, viewer.getPlotAreaMouseX(), viewer.getPlotAreaMouseY());
		viewer.setAutoHide("all", "MouseOutPlotArea");
}

function getBrowerInfo()
{
	var isOpera 	= !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    	//Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
	var isFirefox 	= typeof InstallTrigger !== 'undefined';   // Firefox 1.0+
	var isSafari 	= Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
    	// At least Safari 3+: "[object HTMLElementConstructor]"
	var isChrome 	= !!window.chrome && !isOpera;              // Chrome 1+
	var isIE 		= /*@cc_on!@*/false || !!document.documentMode; // At least IE6

		//alert("Is Opera : "+isOpera+"\n isFirefox : "+isFirefox+"\n isSafari : "+isSafari+"\n isChrome : "+isChrome+"\n isIE : "+isIE);
		//alert("broeser name:"+get_browser_info().name+" version : "+get_browser_info().version);
		return "isOpera :  "+isOpera+" isFirefox : "+isFirefox+" isSafari : "+isSafari+" isChrome : "+isChrome+" isIE : "+isIE; 
}

function get_browser_info()
{
    var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 
    if(/trident/i.test(M[1])){
        tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
        return {name:'IE ',version:(tem[1]||'')};
        }   
    if(M[1]==='Chrome'){
        tem=ua.match(/\bOPR\/(\d+)/);
        if(tem!=null)   {return {name:'Opera', version:tem[1]};}
        }   
    M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
    return {
      name: M[0],
      version: M[1]
    };
 }

//Test newer version below
function centerElementInParent(element_id_in,centeringTypeIn)
{
						if ((centeringTypeIn!=null)&&((centeringTypeIn=='BOTH')||(centeringTypeIn=='H')||(centeringTypeIn=='V')))
						{
						var element_in 				= document.getElementById(element_id_in);
						var element_in_parent_el 	= element_in.parentNode;
							if ((element_in!=null)&&(element_in_parent_el!=null))
							{
							var element_in_left 				=  element_in.getBoundingClientRect().left;
							var element_in_right 				=  element_in.getBoundingClientRect().right;
							var element_in_top 					=  element_in.getBoundingClientRect().top;
							var element_in_bottom 				=  element_in.getBoundingClientRect().bottom;
							
							var element_in_parent_el_left 		=  element_in_parent_el.getBoundingClientRect().left;
							var element_in_parent_el_right 		=  element_in_parent_el.getBoundingClientRect().right;
							var element_in_parent_el_top 		=  element_in_parent_el.getBoundingClientRect().top;
							var element_in_parent_el_bottom 	=  element_in_parent_el.getBoundingClientRect().bottom;
							
								//console_log("element_in_parent_el_left:"+element_in_parent_el_left+" element_in_parent_el_right:"+element_in_parent_el_right);
								//console_log("element_in_left:"+element_in_left+" element_in_right:"+element_in_right);
								//console_log("element_in.id:"+element_in.id);
								//console_log("element_in_parent_el.id:"+element_in_parent_el.id);
								element_in.style.position			= 'absolute';
								//console_log("element_in_parent_el_left:"+element_in_parent_el_left+"  element_in_parent_el_right:"+element_in_parent_el_right);
								//console_log("__________"+jQuery(element_in_parent_el).width()+"         element_in_parent_el.id:"+element_in_parent_el.id);
								//jQuery(element_in_parent_el).css("background-color","pink");
								if (centeringTypeIn=='H') 		{element_in.style.left				= parseInt(((element_in_parent_el_right-element_in_parent_el_left)-(element_in_right-element_in_left))/2)+"px";}
								if (centeringTypeIn=='V') 		{element_in.style.top				= parseInt(((element_in_parent_el_bottom-element_in_parent_el_top)-(element_in_bottom-element_in_top))/2)+"px";}
								if (centeringTypeIn=='BOTH') 	
								{	
									element_in.style.left				= parseInt(((element_in_parent_el_right-element_in_parent_el_left)-(element_in_right-element_in_left))/2)+"px";
									element_in.style.top				= parseInt(((element_in_parent_el_bottom-element_in_parent_el_top)-(element_in_bottom-element_in_top))/2)+"px";
								}
							}
						}
}

//function centerElementInParent(element_id_in,centeringTypeIn)
//{
//	if ((centeringTypeIn!=null)&&((centeringTypeIn=='BOTH')||(centeringTypeIn=='H')||(centeringTypeIn=='V')))
//	{
//		var element_in 				= document.getElementById(element_id_in);
//		var element_in_parent 		= element_in.parentNode;
//		if ((element_in!=null)&&(element_in_parent !=null))
//		{
////			var element_in_left 				=  element_in.getBoundingClientRect().left;
////			var element_in_right 				=  element_in.getBoundingClientRect().right;
////			var element_in_top 					=  element_in.getBoundingClientRect().top;
////			var element_in_bottom 				=  element_in.getBoundingClientRect().bottom;
////			
////			var element_in_parent_el_left 		=  element_in_parent_el.getBoundingClientRect().left;
////			var element_in_parent_el_right 		=  element_in_parent_el.getBoundingClientRect().right;
////			var element_in_parent_el_top 		=  element_in_parent_el.getBoundingClientRect().top;
////			var element_in_parent_el_bottom 	=  element_in_parent_el.getBoundingClientRect().bottom;
////			
////			console_log("element_in_parent_el_left:"+element_in_parent_el_left+" element_in_parent_el_right:"+element_in_parent_el_right);
////			console_log("element_in_left:"+element_in_left+" element_in_right:"+element_in_right);
////			console_log("element_in.id:"+element_in.id);
////			console_log("element_in_parent_el.id:"+element_in_parent_el.id);
//			console_log( " element w :"+parseInt( jQuery(element_in).width()  ));
//			console_log( " element_parent w :"+parseInt( jQuery(element_in_parent).width()  ));
//			element_in.style.position			= 'absolute';
////			console_log("element_in_parent_el_left:"+element_in_parent_el_left+"  element_in_parent_el_right:"+element_in_parent_el_right);
////			console_log("__________"+jQuery(element_in_parent_el).width()+"         element_in_parent_el.id:"+element_in_parent_el.id);
////			jQuery(element_in_parent_el).css("background-color","pink");
//			if (centeringTypeIn=='H') 		{element_in.style.left				= parseInt(  ( parseInt( jQuery(element_in_parent).width()  ) - parseInt( jQuery(element_in).width()  ) )/2) +"px";}
//			if (centeringTypeIn=='V') 		{element_in.style.top				= parseInt(  ( parseInt( jQuery(element_in_parent).height() ) - parseInt( jQuery(element_in).height() ) )/2) +"px";}
//			if (centeringTypeIn=='BOTH') 	
//			{	
//				element_in.style.left				= parseInt(  ( parseInt( jQuery(element_in_parent).width()  )  - parseInt( jQuery(element_in).width()  ) )/2) +"px";
//				element_in.style.top				= parseInt(  ( parseInt( jQuery(element_in_parent).height() )  - parseInt( jQuery(element_in).height() ) )/2) +"px";
//			}
//		}
//	}
//}
//

//////////////////////////////////////LOG FUNCTIONS start////////////////////////////////////////////////

function console_log(ConsoleLogIn)
{
						try
						{
							if (IsDebug)
							{
								console.log(ConsoleLogIn);			
							}
						}catch(ex)
						{
							
						}
}

function WriteInfo (message) 
{
				    var info 		= document.getElementById ("debuggeroutput_content");
				    	info.innerHTML += message + "<br />";
				    	//info.scrollTop 	= info.scrollHeight;
}
//////////////////////////////////////LOG FUNCTIONS   end////////////////////////////////////////////////

function getViewport() 
{
	 var viewPortWidth;
	 var viewPortHeight;

		 // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
		 if (typeof window.innerWidth != 'undefined') 
		 {
		   viewPortWidth = window.innerWidth,
		   viewPortHeight = window.innerHeight
		 }
	
		 //IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
		 else 
		 if (typeof document.documentElement != 'undefined'
		 && typeof document.documentElement.clientWidth !='undefined' 
		 && document.documentElement.clientWidth != 0) 
		 {
		    viewPortWidth = document.documentElement.clientWidth,
		    viewPortHeight = document.documentElement.clientHeight
		 }
		 // older versions of IE
		 else 
		 {
		   viewPortWidth = document.getElementsByTagName('body')[0].clientWidth,
		   viewPortHeight = document.getElementsByTagName('body')[0].clientHeight
		 }
		 return [viewPortWidth, viewPortHeight];
}

function manageTextSelection(element)
{		
	    //manage text selection
		//alert('manage text selection....');
		if (element.addEventListener !== "undefined") 
		{
			  // Not IE
			element.addEventListener('click', checkSelection, false);
		} else 
		{
			  // IE
			element.attachEvent('onclick', checkSelection);
		}
}

function checkSelection() 
{
	//alert('text selection');
				var 	sel = {};
						if (window.getSelection) 
						{
							// Mozilla
							sel = window.getSelection();
						} else 
						if (document.selection)
						{
							// IE
							sel = document.selection.createRange();
						}

						// Mozilla
						if (sel.rangeCount)
						{
							sel.removeAllRanges();
							return;
						}

						// IE
						if (sel.text > '')
						{
							document.selection.empty();
							return;
						}
}

function createUUID() 
{
    // http://www.ietf.org/rfc/rfc4122.txt
	var					s = [];
	var					hexDigits = "0123456789abcdef";
						for (var i = 0; i < 36; i++) 
						{
							s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
						}
						s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
						s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
						s[8] = s[13] = s[18] = s[23] = "-";

	var 				uuid = s.join("");
						return uuid;
}

function SelectTextAreaContent(ElementIdIn)
{
//	 document.getElementById(ElementIdIn).focus();
//	 document.getElementById(ElementIdIn).select();
}

function pausecomp(millis)
{
					var date 	= new Date();
					var curDate = null;
				
						do { 
							curDate = new Date(); 
						} 
						while(curDate-date < millis);
} 

function strStartsWith(str, prefix) 
{
						return str.indexOf(prefix) === 0;
}

//function strEndsWith(str, suffix) 
//{
//    //return str.match(suffix+"$")==suffix;
//    return str.match(/suffix+"$")==suffix;
//}
function strEndsWith(myString, stringCheck)
{
	var 				foundIt = (myString.lastIndexOf(stringCheck) === myString.length - stringCheck.length) > 0;
						return foundIt;
}

function setElementVisibility(IdentifierIn,StatusIn)
{
					var el = document.getElementById(IdentifierIn);
						//alert("el.id : "+el.id+" StatusIn : "+StatusIn);
						if (StatusIn.toUpperCase == 'VISIBLE')
						{
							el.style.visibility = 'visible';
						}else
						{
							el.style.visibility = 'hidden';
						}
}

function childsDimensions(elIn)
{
					var h=0;
					var w=0;
			
					var childs = jQuery(elIn).find("*");
			
						for(var i=0;i<childs.length;++i)
						{
							if (jQuery(childs[i]).width()>w) w=jQuery(childs[i]).width(); 
							if (jQuery(childs[i]).height()>h) h=jQuery(childs[i]).height(); 
						}
						return {"w":w,"h":h}
}

function childsBoundings(elIn)
{
					var x_min = 1000000000000;
					var x_max = -1000000000000;
					var y_min = 1000000000000;
					var y_max = -1000000000000;
					
					var h=0;
					var w=0;
					
					var childs = jQuery(elIn).find("*");
			
						for(var i=0;i<childs.length;++i)
						{
						var element = childs[i];
						var Pos_top = parseInt( element.getBoundingClientRect().top) ;
						var Pos_bottom = parseInt(element.getBoundingClientRect().bottom );
							if (Pos_top<y_min) {y_min= Pos_top;}
							if (Pos_bottom>y_max) {y_max=Pos_bottom;}
						
						var Pos_left = parseInt( element.getBoundingClientRect().left) ;
						var Pos_right = parseInt(element.getBoundingClientRect().right) ;
							if (Pos_left<x_min) {x_min=Pos_left;}
							if (Pos_right>x_max) {x_max=Pos_right;}
							
							//console_log("  children iterate.....Pos_top:"+Pos_top+" y_min"+y_min + " Pos_bottom:"+Pos_bottom+" y_max:"+y_max);
							//console_log("  children iterate.....Pos_left:"+Pos_left+" Pos_right:"+Pos_right);
						}
						w=x_max-x_min;
						h=y_max-y_min;
						return {"w":w,"h":h}
}

function LoadExplainedElements(SWIdentifierIn)
{
					var SWel = document.getElementById(SWIdentifierIn);
						//console_log('explained elements of'+SWIdentifierIn);
						if (SWel!=null)
						{
							/*var explainedelements =*/ 
							$(SWel).find(".explainedelement").mouseenter(function(){ManageExplainedElements(this,'mouseenter');}).mouseover(function(){ManageExplainedElements(this,'mouseover');}).mouseleave(function(){ManageExplainedElements(this,'mouseleave');});
							//console_log(" found explainedelements : "+explainedelements.length);
						}
}

/*
 * elements that have a tooltip
 * @param elementIn
 * @param scope
 * @returns
 */
function ManageExplainedElements(elementIn,scope)
{
		//if (scope == 'mouseenter') alert('entering');
		//if (scope == 'mouseleave') alert('leaving');
		//.mouseleave(function(){alert('mousein');})
/*		if (isValidElement(elementIn))
		{
			console_log("::::::::::::::::::ManageExplainedElements. elementIn.id:"+elementIn.id+":   scope:"+scope);
		} else
		{
			console_log("::::::::::::::::::ManageExplainedElements. elementIn :NULL   scope:"+scope);
		}
*/
	var el_zindex = parseInt(jQuery(elementIn).css('z-index'));
		if (scope == 'newlevellayer_hidebelow')
		{
			if (document.getElementById('explainedelement_content')!=null)
			{
			var element_explainedelement_content 						= document.getElementById('explainedelement_content');
				element_explainedelement_content.style.visibility 		= 'hidden';
			}
			return;
		}

		if (document.getElementById('explainedelement_content')==null)
		{
		var MyElement 												= document.createElement('div');
			MyElement.setAttribute('id','explainedelement_content');
			//MyElement.setAttribute('class','MovingTableColumn_layer');
			MyElement.style.position								= 'fixed';
			MyElement.style.height									= '40px';
			MyElement.style.width									= '150px';
			MyElement.style.top										= '0px';
			MyElement.style.left									= '0px';
	//		MyElement.style.right									= '0px';
	//		MyElement.style.bottom									= '0px';
	//		MyElement.style.backgroundColor 						= 'pink';
			MyElement.style.zIndex									= '102';
			//movingTableColumnElement.style.border 				= "3px solid blue";
			//movingTableColumnElement.style.cursor					= "move";
			//MyElement.style.borderRadius							= '5px';
			//MyElement.style.border 								= '1px solid yellow';
			document.body.appendChild(MyElement);
		}

		if (el_zindex>0) { jQuery('#explainedelement_content').css('z-index',el_zindex);}
	var element_explainedelement_content 							= document.getElementById('explainedelement_content');
	var tooltip_id						 							= $(elementIn).attr("tooltip_id");
		elementIn.style.cursor 			 							= "pointer";
		if (jQuery(elementIn).hasClass("idisabled"))
		{
			jQuery(elementIn).css("cursor","not-allowed");
		}
		//elementIn.style.cursor 			 							= "none";
//		alert("tooltip_id:"+tooltip_id);
		if((scope == 'mouseenter') || (scope == 'mouseover'))
		{
		//alert('hjklò'+elementIn.id);
		
		var	arrow_up_down											= "";
		var cantilever_x				 							= 15;
		// var shift_x  					 							= 8;
		// var shift_y  					 							= 17;
		var window_x 					 							= parseFloat($(window).width()/zoom_css_component);
		var window_y 					 							= parseFloat($(window).height()/zoom_css_component);
		var el_pos_x 					 							= parseInt($(elementIn).offset().left/zoom_css_component);
		var el_pos_y 					 							= parseInt($(elementIn).offset().top/zoom_css_component);
		//el_pos_y 					 							= parseInt(elementIn.offsetTop);
		var el_outerHeight				 							= parseInt($(elementIn).outerHeight());
		var el_outerWidth				 							= parseInt($(elementIn).outerWidth());
		var quarter  					 							= "";
		var posvalues  					 							= "";
		var img_arrow_position			 							= "";
		var content_explainerbox_position	 						= "";
			if (el_pos_y>parseInt(window_y/2)) 
			{//reversed V
					quarter 											= quarter+"D";
				//var string_pos 											= parseInt(window_y-(    $(elementIn).offset().top)+6 )+"px";
				var	string_pos 											= parseInt(window_y-el_pos_y+6 )+"px";
					posvalues 											= posvalues +" explainer bottom :"+string_pos;
					element_explainedelement_content.style.bottom  		= string_pos;
					element_explainedelement_content.style.top			= "auto";
					img_arrow_position									= img_arrow_position+"bottom:0;";
					content_explainerbox_position						= content_explainerbox_position +"bottom:25px;";
					arrow_up_down										= "down";
					//console_log("reversed V");
			} else 
			{//basic V
				quarter 											= quarter+"U";
				element_explainedelement_content.style.top  		= parseInt($(elementIn).offset().top+el_outerHeight)+"px";
				element_explainedelement_content.style.top  		= parseInt(el_pos_y+el_outerHeight)+"px";

				element_explainedelement_content.style.top.bottom 	= "auto";
				img_arrow_position									= img_arrow_position+"top:0;";
				content_explainerbox_position						= content_explainerbox_position +"top:25px;";//was 10px
				arrow_up_down										= "up";
				//console_log("basic V  offset_top:"+$(elementIn).offset().top + "  el_outerHeight:"+el_outerHeight );
			}
			if (el_pos_x>parseInt(window_x/2)) 
			{//reversed H
				//var string_pos 											= parseInt(window_x-(    $(elementIn).offset().left+el_outerWidth  ) - cantilever_x)+"px";
			var string_pos 											= parseInt(window_x-(    el_pos_x+el_outerWidth  ) - cantilever_x)+"px";
				//alert("string_pos:"+string_pos);
				posvalues 											= posvalues+" explainer right :"+string_pos;
				element_explainedelement_content.style.right 		= string_pos;
				element_explainedelement_content.style.left  		= "auto";
				quarter 											= quarter+"R";
				img_arrow_position									= img_arrow_position+"right:8px;";//was 2px
				content_explainerbox_position						= content_explainerbox_position +"right:0;";
			} 	else 
			{//basic H
				element_explainedelement_content.style.left 			= parseInt($(elementIn).offset().left-cantilever_x)+"px";
				element_explainedelement_content.style.left 			= parseInt(el_pos_x-cantilever_x)+"px";
				element_explainedelement_content.style.right 			= "auto";
				quarter 												= quarter+"L";
				img_arrow_position										= img_arrow_position+"left:8px;";
				content_explainerbox_position							= content_explainerbox_position +"left:0;";
			}
			element_explainedelement_content.style.visibility 			= 'visible';
			
		var ToolTipMessageContent 										= arrayToolTips_getContentByIdentifier(tooltip_id);
			if ((ToolTipMessageContent==null)||(ToolTipMessageContent=='null'))
			{
				element_explainedelement_content.style.display 			= 'none';
			}	else
			{
				element_explainedelement_content.style.display 			= 'block';
			}
			if (!jQuery(elementIn).hasClass('explainedelement'))
			{
				element_explainedelement_content.style.display 			= 'none';
			}
			//console_log("searching.....tooltip_id:"+tooltip_id+' ToolTipMessageContent:'+ToolTipMessageContent );

			//element_explainedelement_content.innerHTML 			= "<div style='position:relative;width:100%;height:100%;'><img src='icons/elementexplain/square_tilt.png' style='position:absolute;"+img_arrow_position+"'><div style='position:absolute;min-height:25px;min-width:100px;background-color:#28dff3;border-radius:5px;text-align:center;line-height:25px;"+content_explainerbox_position+"'><span style='font-family:arial;font-size:12px;color:blue;margin-left:4px;'>"+ToolTipMessageContent+"</span></div></div>";
			element_explainedelement_content.innerHTML 					= "<div class='explainedelement_outer' style='position:relative;width:100%;height:100%;padding:4px;'><div class='explainedelement_inner' style='position:absolute;min-height:25px;min-width:100px;background-color:#504d4f;border:2px solid black;border-radius:5px;text-align:center;line-height:25px;"+content_explainerbox_position+"'><span style='font-family:arial;font-size:13px;font-weight:500;color:#f2f2f2;margin-left:4px;margin-right:4px;'>"+ToolTipMessageContent+"</span></div><img src='icons/elementexplain/tooltip_pointer_"+arrow_up_down+".png' style='position:absolute;"+img_arrow_position+"'></div>";
			//element_explainedelement_content.style.border = "1px solid red";						
		}

		if(scope == 'mouseleave') 
		{
			element_explainedelement_content.style.visibility 		= 'hidden';
		}
}

function SetIsDebug(valueIn)
{
		IsDebug = valueIn;
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////

function ToolTipMessageServerCallBackTokenize(msgIn)
{
			var Rows 						 = msgIn.split("!#####!");
				for(var g=0;g<Rows.length;++g)
				{
					if (Rows[g].length>10)
					{
					var MyTOOLTIPID 		 = getValueByParName(Rows[g],'MESSAGEID');
					var MyMESSAGE_CONTENT 	 = getValueByParName(Rows[g],'MESSAGE_CONTENT');
					var MyarrayToolTipsIndex = arrayToolTips_getIndexByIdentifier(MyTOOLTIPID);
						if (MyarrayToolTipsIndex==-1)
						{//add
							arrayToolTips_addElement(MyTOOLTIPID, MyMESSAGE_CONTENT);
						}else
						{//refresh
							arrayToolTips[MyarrayToolTipsIndex].Content = MyMESSAGE_CONTENT;
						}
					}
				}
				jQuery('.IsSW').each(function(){
					LoadExplainedElements(this.id);	
					//SW where LoadExplainedElements was not yet performed
				});
}

function dummyEventGenerate() 
{
    this.type 					= 'dummy';  
    this.cancelBubble			= true;
    this.bubbles				= true;
    this.stopPropagation 		= function () 
							    {
							      //  this.lastName = name;
							    };
}

/**
 * Fake event. Not a real event. It looks like an event in most applications
 * Target is not managed
 * do not use on prefix
 */
/*
class customEventGenerate 
{
    constructor(TypeIn) 
    {
        this.type 			= TypeIn;
        this.cancelBubble 	= true;
        this.bubbles 		= true;
        this.stopPropagation = function() 
        {
            //  this.lastName = name;
        };
    }
    // Getter
	get type() 
	{
	    return this.type;
	}
}
*/
/**
 * Fake event. Not a real event. It looks like an event in most applications
 * Target is managed
 * do not use on prefix
 */
class customEventGenerate 
{
	constructor(TypeIn, targetEl) 
	{
        this.target 		= targetEl;
        this.currentTarget 	= targetEl;
        this.type 			= TypeIn;
        this.cancelBubble 	= true;
        this.bubbles 		= true;
        this.stopPropagation = function() 
        {
            //  this.lastName = name;
        };
    }
    /*
    // Getter
	get type() 
	{
	    return this.type;
	}
    // Getter
	get target() 
	{
	    return this.target;
	}
    // Getter
	get currentTarget() 
	{
	    return this.currentTarget;
	}*/
}

/**
 * Real event. Somtimes performs worst than fake event.
 * ATTENTION. May generate infinite loop.  
 */
/*
function customEventGenerateN(TypeIn)
{
	return new Event(TypeIn, {"bubbles":true, "cancelable":false});
}*/

function lockedSWManagement()
{	
//	var els_not_active = $(".not_active.IsSW")
//	if ((els_not_active!=null)&&(els_not_active.length)>0)
//	{
//		for(var i=0;i<els_not_active.length;++i)
//		{
//			$(els_not_active[i]).find(".IsSW").addClass("not_active");
//		}
//	}
}


function getCurrentMaxNewLevelLayer()
{
		//retrieves the Max level of MaxNewLevelLayer SWs
	var CurrentMaxNewLevelLayer 	= -1;
		//alert("Checking Body. ID:"+scrollableOBJ_IDs[y]);
	var SWs_newlevellayer 			= $('div[class*=newlevellayer]');
		//alert("SWs_newlevellayer len : "+SWs_newlevellayer.length);
		if (SWs_newlevellayer.length>0)
		{
			for(var g_lays_i=0;g_lays_i<SWs_newlevellayer.length;++g_lays_i)
			{
			var CurrentNewLevelLayer = parseInt(check_newlevellayer(SWs_newlevellayer[g_lays_i]));
				//Pay Attention. CurrentNewLevelLayer may be null 
				// try catch needed
				//alert("CurrentNewLevelLayer  : "+CurrentNewLevelLayer);
				if (CurrentNewLevelLayer>CurrentMaxNewLevelLayer) 
				{
					CurrentMaxNewLevelLayer = CurrentNewLevelLayer;
				} 
			}
		}
		return CurrentMaxNewLevelLayer;
}

function getCurrentMaxNewLevelLayerVisible()
{
		//retrieves the Max level of MaxNewLevelLayer SWs
	var CurrentMaxNewLevelLayer 	= -1;
		//alert("Checking Body. ID:"+scrollableOBJ_IDs[y]);
	var SWs_newlevellayer 			= $('div[class*=newlevellayer]');
		//alert("SWs_newlevellayer len : "+SWs_newlevellayer.length);
		if (SWs_newlevellayer.length>0)
		{
			for(var g_lays_i=0;g_lays_i<SWs_newlevellayer.length;++g_lays_i)
			{
				if (
						(jQuery(SWs_newlevellayer[g_lays_i]).css('display')=='none')
						||
						(jQuery(SWs_newlevellayer[g_lays_i]).is(":hidden"))
						
					)
					{
					
					}else
					{
					var CurrentNewLevelLayer = parseInt(check_newlevellayer(SWs_newlevellayer[g_lays_i]));
						//Pay Attention. CurrentNewLevelLayer may be null 
						// try catch needed
						//alert("CurrentNewLevelLayer  : "+CurrentNewLevelLayer);
						//console_log(" visible element:"+SWs_newlevellayer[g_lays_i].id+" is LevelLayer:"+CurrentNewLevelLayer);
						if (CurrentNewLevelLayer>CurrentMaxNewLevelLayer) 
						{
							CurrentMaxNewLevelLayer = CurrentNewLevelLayer;
						} 
					}
			}
		}
		return CurrentMaxNewLevelLayer;
}

function getCurrentMaxNewLevelLayerVisibleAndFillingViewPort()
{
		//retrieves the Max level of MaxNewLevelLayer SWs
	var CurrentMaxNewLevelLayer 	= -1;
		//alert("Checking Body. ID:"+scrollableOBJ_IDs[y]);
	var SWs_newlevellayer 			= $('div[class*=newlevellayer]');
		//alert("SWs_newlevellayer len : "+SWs_newlevellayer.length);
		if (SWs_newlevellayer.length>0)
		{
			for(var g_lays_i=0;g_lays_i<SWs_newlevellayer.length;++g_lays_i)
			{
				//console_log("zzzzzzzzzzzzzz "+SWs_newlevellayer[g_lays_i].id);
				if (
						(jQuery(SWs_newlevellayer[g_lays_i]).css('display')=='none')
						||
						(jQuery(SWs_newlevellayer[g_lays_i]).is(":hidden"))
				)
				{

				}else
				{
					if (jQuery(SWs_newlevellayer[g_lays_i]).hasClass("fill_viewport"))
					{
					var CurrentNewLevelLayer = parseInt(check_newlevellayer(SWs_newlevellayer[g_lays_i]));
						//Pay Attention. CurrentNewLevelLayer may be null 
						// try catch needed
						//alert("CurrentNewLevelLayer  : "+CurrentNewLevelLayer);
						//console_log(" visible element:"+SWs_newlevellayer[g_lays_i].id+" is LevelLayer:"+CurrentNewLevelLayer);
						if (CurrentNewLevelLayer>CurrentMaxNewLevelLayer) 
						{
							CurrentMaxNewLevelLayer = CurrentNewLevelLayer;
						}
					}
				}
			}
		}
		return CurrentMaxNewLevelLayer;
}

function removeParamsFromURL(sParam)
{
				//never used....verify
			var url 			= window.location.href.split('?')[0]+'?';
            var sPageURL 		= decodeURIComponent(window.location.search.substring(1)),
                sURLVariables 	= sPageURL.split('&'),sParameterName,i;
         
	            for (i = 0; i < sURLVariables.length; i++) 
	            {
	                sParameterName  = sURLVariables[i].split('=');
	                if (sParameterName[0] != sParam) 
	                {
	                    url = url + sParameterName[0] + '=' + sParameterName[1] + '&';
	                }
	            }
	            return url.substring(0,url.length-1);
}

function replaceUrlParam(url, paramName, paramValue)
{
	    if (paramValue == null) 
	    {
	        paramValue = '';
	    }
    var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
	    if (url.search(pattern)>=0) {
	        return url.replace(pattern,'$1' + paramValue + '$2');
	    }
	    url = url.replace(/[?#]$/,'');
	    return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
}
//window.location = removeParams(parameter);

function StartUpSequence(StepIn,ServerAnswerIn,pageobjtokenIn,QueryStringIn)
{
		//const bowser = require("bowser");
		alert(" StartUpSequence step in:"+StepIn+"    localstoragepageobjtoken:"+sessionStorage.getItem('pageobjtoken'));

	var MyBody								= document.body;
	var hiddenField_querystring 			= null;
	var hiddenField_nextstep 				= null;
	var hiddenField_pageobjtoken 			= null;
		if (!isValidElement(document.getElementById("startupform")))
		{
		var MyPageName						= $(document.body).attr('pagename');
		var pageobjtoken					= $(document.body).attr('pageobjtoken');
		var form 							= document.createElement("form");
			form.style.height				="200px";
			form.style.width				="200px";
			form.style.backgroundColor		="red";
			form.setAttribute("id", "startupform");
			form.setAttribute("method", "post");
		    //form.setAttribute("action", MyPageName+".jsp");
			form.setAttribute("action", MyPageName);
		    //form.style.visibility			= "hidden";
		    //form.setAttribute("target", "chat");

	    	//Hidden Field
	    	hiddenField_pageobjtoken 		= document.createElement("input");
		    hiddenField_pageobjtoken.setAttribute("name" 	, "pageobjtoken");
		    hiddenField_pageobjtoken.setAttribute("id" 		, "startupform_pageobjtoken");
		    form.appendChild(hiddenField_pageobjtoken);
		    
			hiddenField_querystring 		= document.createElement("input");
			hiddenField_querystring.setAttribute("name" , "querystring");
		    hiddenField_querystring.setAttribute("id" 	, "startupform_querystring");
		    form.appendChild(hiddenField_querystring);

			hiddenField_nextstep 			= document.createElement("input");
			hiddenField_nextstep.setAttribute("name" 	, "nextstep");
		    hiddenField_nextstep.setAttribute("id" 		, "startupform_nextstep");
		    form.appendChild(hiddenField_nextstep);

		    document.body.appendChild(form);
		} 
		
		hiddenField_querystring 	= document.getElementById("startupform_querystring");
		hiddenField_nextstep 		= document.getElementById("startupform_nextstep");
		hiddenField_pageobjtoken 	= document.getElementById("startupform_pageobjtoken");
		
		//console_log("StartUpSequence.....Step:"+StepIn);
		if (StepIn==-3)
		{// Not found pageobjtoken....
		 	// Not State implemented
		 	//	Set pageobjtoken and nextaction
			
		 	//Trying to retrieve it in window.name
			$(document.body).attr('form_acting', 'Y');

	var 	inbody_pageobjecttoken 					= jQuery(document.body).attr("pageobjtoken")+"_pageobjtoken";

			if (window.name.length<5)
			{
	var 			pageobjtoken					= createUUID();
					window.name						= pageobjtoken+"_pageobjtoken";
					//if (sessionStorage.getItem('pageobjtoken')==null) 	sessionStorage.setItem('pageobjtoken',pageobjtoken);
			}else
			if (window.name.indexOf("pageobjtoken")>-1)
			{//existing pageobjtoken
				//location.href 					= location.href + location.search+"&pageobjtoken="+window.name.replace(pageobjtoken,"");
				//alert("Yes window name.."+window.name+"..query string:"+location.search);
			    //hiddenField_pageobjtoken.setAttribute("value", window.name.replace("_pageobjtoken",""));
				if (window.name!=inbody_pageobjecttoken) 
				{
					//alert('problem!!!');
					jQuery(hiddenField_querystring).val(QueryStringIn);
					jQuery(hiddenField_nextstep).val("-1");
					// alert("pre-start");
				    //form.submit();
				}
			}
			hiddenField_pageobjtoken.setAttribute("value", window.name.replace("_pageobjtoken",""));
			hiddenField_querystring.setAttribute("value", QueryStringIn);

			//alert("No window name....query string:"+location.search);
		var LengthConversionRatio 			= 1;//lengthConversionByLogoCorner(1);
		//alert("LengthConversionRatio:"+LengthConversionRatio);
		var screen_availHeight				= window.screen.availHeight;
		var screen_availWidth				= window.screen.availWidth;
		var screen_height					= window.screen.height;
		var screen_width					= window.screen.width;
		var screen_colorDepth				= window.screen.colorDepth;
		var screen_pixelDepth				= window.screen.pixelDepth;	
		var viewport_innerHeight    		= $(window).height();
		var viewport_innerWidth     		= $(window).width();
				//bowser = require('bowser');
		//var result_bowsser 					= bowser.getParser(window.navigator.userAgent);

				//alert('browser:'+result.parsedResult.browser.name+'   version:'+result.parsedResult.browser.version+"   mobile:"+result.parsedResult.mobile+'   browser_os='+result.parsedResult.os.name  );
				//alert('browser:'+bowser.name+'   version:'+bowser.version+"   mobile:"+bowser.mobile+'   browser_os='+bowser.osname  );
				//^^^old version
				//var BrowserInfo 				= get_browser_info();
		var	StringDevice					= deviceShow();
		var DataStringOut					=	'screen_availHeight='+screen_availHeight+'&'+
												'screen_availWidth='+screen_availWidth+'&'+
												'screen_height='+screen_height+'&'+
												'screen_width='+screen_width+'&'+
												'screen_colorDepth='+screen_colorDepth+'&'+
												'screen_pixelDepth='+screen_pixelDepth+'&'+
												'LengthConversionRatio='+LengthConversionRatio+'&'+
												'browser_name='+bowser.name+'&'+
												'browser_version='+bowser.version+'&'+
												'browser_mobile='+bowser.mobile+'&'+
												'browser_os='+bowser.osname +'&'+
												'viewport_innerWidth='+viewport_innerWidth+'&'+
												'viewport_innerHeight='+viewport_innerHeight+'&'+
												StringDevice;

		var	Mypageobjtoken					= window.name.replace("_pageobjtoken","");
		var	Mypagename						= $(document.body).attr('pagename');
		var	SessionPageFullName				= Mypageobjtoken+"_"+Mypagename;

		var	data							= 'Step=-2'+'&'+DataStringOut+'&sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+Mypagename;
			//alert("StartUpSequence data:"+data);
			//alert('StartupSequenceCallServer \nStepIn:'+StepIn+'\n Next Step:'+NextStep+'\n dataIn:'+dataIn+"\n data:"+data);

			$.ajax
			(
				{
					type	: "POST",
					url		: "StartUpSequence",
					data	: data,
					dataType: "text",
					success	: function(msg)
					{

						//$("#risultato").html(msg);
						//alert('StartUpSequence Servlet communication OK');
						//alert( "StartupSequenceCallServer success. Sent data Was:"+data +"  result message is:"+msg);
						//StartUpSequence('-1',msg,Mypageobjtoken,'');
						jQuery(hiddenField_nextstep).val("-1");
						jQuery(hiddenField_querystring).val(QueryStringIn);
						jQuery(hiddenField_pageobjtoken).val(Mypageobjtoken);
						
						
						form.submit();
					},
					error: function()
					{
						alert(ServerFailMessage);
						//WaiterShield('hide');
					}			 
				}
			);//Ajax
		} else	//End Step 3
		if (StepIn==-2)
		{// Not found pageobjtoken....
		 //	Set pageobjtoken and nextaction
			//step not used anymore obsolete
			//Trying to retrieve it in window.name
			$(document.body).attr('form_acting', 'Y');

		var inbody_pageobjecttoken 					= jQuery(document.body).attr("pageobjtoken")+"_pageobjtoken";

			if (window.name.length<5)
			{
			var pageobjtoken					= createUUID();
				window.name						= pageobjtoken+"_pageobjtoken";
				hiddenField_pageobjtoken.setAttribute("value", window.name.replace("_pageobjtoken",""));
				//alert("No window name....query string:"+location.search);

			var LengthConversionRatio 			= lengthConversionByLogoCorner(1);
				//alert("LengthConversionRatio:"+LengthConversionRatio);
			var screen_availHeight				= window.screen.availHeight;
			var screen_availWidth				= window.screen.availWidth;
			var screen_height					= window.screen.height;
			var screen_width					= window.screen.width;
			var screen_colorDepth				= window.screen.colorDepth;
			var screen_pixelDepth				= window.screen.pixelDepth;	
			var viewport_innerHeight			= $(window).height();
			var viewport_innerWidth				= $(window).width();
					//bowser = require('bowser');
					//alert('browser:'+bowser.name+'   version:'+bowser.version+"   mobile:"+bowser.mobile+'   browser_os='+bowser.osname  );
					//var BrowserInfo 				= get_browser_info();
			var	StringDevice					= deviceShow();
			var DataStringOut 					=   'screen_availHeight='+screen_availHeight+'&'+
													'screen_availWidth='+screen_availWidth+'&'+
													'screen_height='+screen_height+'&'+
													'screen_width='+screen_width+'&'+
													'screen_colorDepth='+screen_colorDepth+'&'+
													'screen_pixelDepth='+screen_pixelDepth+'&'+
													'LengthConversionRatio='+LengthConversionRatio+'&'+
													'browser_name='+bowser.name+'&'+
													'browser_version='+bowser.version+'&'+
													'browser_mobile='+bowser.mobile+'&'+
													'browser_os='+bowser.osname +'&'+
													'viewport_innerWidth='+viewport_innerWidth+'&'+
													'viewport_innerHeight='+viewport_innerHeight+'&'+
													StringDevice;

			var Mypageobjtoken					= window.name.replace("_pageobjtoken","");
			var Mypagename						= $(document.body).attr('pagename');
			var SessionPageFullName				= Mypageobjtoken+"_"+Mypagename;

			var	data							= 'Step=-2'+'&'+DataStringOut+'&sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+Mypagename;
				//alert('StartupSequenceCallServer \nStepIn:'+StepIn+'\n Next Step:'+NextStep+'\n dataIn:'+dataIn+"\n data:"+data);
				

				$.ajax
				(
					{
						type	: "POST",
						url		: "StartUpSequence",
						data	: data,
						dataType: "text",
						success	: function(msg)
						{
							//$("#risultato").html(msg);
							//alert('StartUpSequence Servlet communication OK');
							//alert( "StartupSequenceCallServer success. Sent data Was:"+data +"  result message is:"+msg);
							//alert('query string:'+QueryStringIn);
							//StartUpSequence('-1',msg,Mypageobjtoken,'');

							jQuery(hiddenField_nextstep).val("-1");
							jQuery(hiddenField_querystring).val(QueryStringIn);
							
							jQuery(hiddenField_pageobjtoken).val(Mypageobjtoken);

							form.submit();
						},
						error: function()
						{
							alert(ServerFailMessage);
							//WaiterShield('hide');
						}
					}
				);//Ajax
			} else 
			if (window.name.indexOf("pageobjtoken")>-1)
			{//existing pageobjtoken
				//location.href 					= location.href + location.search+"&pageobjtoken="+window.name.replace(pageobjtoken,"");
				//alert("Yes window name.."+window.name+"..query string:"+location.search);
				hiddenField_pageobjtoken.setAttribute("value", window.name.replace("_pageobjtoken",""));
				if (window.name!=inbody_pageobjecttoken) 
				{
					//alert('problem!!!');
					jQuery(hiddenField_querystring).val(QueryStringIn);
					jQuery(hiddenField_nextstep).val("-1");
					// alert("pre-start");
					
					jQuery(hiddenField_pageobjtoken).val(Mypageobjtoken);

				    form.submit();
				}
			}
		} else
		if (StepIn==0)
		{
			//alert("going async now ");
			jQuery(hiddenField_querystring).val(QueryStringIn);

			$(MyBody).attr('form_acting', 'Y');

			//alert("-------H:"+window.innerHeight+"W:"+window.innerWidth+"____:"+$(window).width());

			//MyBody.style.border   		= "3px solid red";
			//MyBody.style.height   		= "100%";
			//MyBody.style.width    		= "100%";

		var	MyBodyContent         			= 
									      "		<div id='"+MyBody.id+"relative_stub|'  style='position:relative;width:100%;height:100%;border:none;z-index:0;'>"
	   				    		+   	  "		   	<div class='backgrounder' id='"+MyBody.id+"backgrounder|'  style='position:absolute;z-index:0;top:0px;left:0px;bottom:0px;right:0px;width:100%;height:100%;border:none;'> "
	   				    		+   	  "	   	   	</div> "
	   				    		+   	  "	   		<div  id='"+MyBody.id+"frame|' style='position:absolute;z-index:0;top:0;left:0;bottom:0;right:0;width:100%;height:100%;border:none;'> "
	   				    		+   	  "				<div  class='ContentArea' id='"+MyBody.id+"ContentArea|' style='position:relative;z-index:0;width:100%;height:100%;'> "
	   				    		+   	  "					<input type = 'hidden' id = '"+MyBody.id+"SubmitTriggerId|' name = 'SubmitTrigger' value ='' > "
	   				    		+   	  "					<input type = 'hidden' id = '"+MyBody.id+"Starter|' 		name = 'PageStarter'   value ='0' > "
	   				    		+   	  "				</div> "
	   				    		+   	  "			</div>"
	   				    		+   	  "		</div>"
								+		  "		<div id='"+MyBody.id+"LogoCorner|'></div>";
	
	
			MyBody.innerHTML      			= MyBodyContent;     
			
			
			//WaiterShield('show');
			
		var Mypageobjtoken					= window.name.replace("_pageobjtoken","");
	
		var Mypagename						= $(document.body).attr('pagename');
		var SessionPageFullName				= Mypageobjtoken+"_"+Mypagename;
	
		var	data							= 'Step=0&sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+Mypagename;
			//alert('StartupSequenceCallServer \nStepIn:'+StepIn+'\n Next Step:'+NextStep+'\n dataIn:'+dataIn+"\n data:"+data);
		
			$.ajax
			(
				{
					type	: "POST",
					url		: "StartUpSequence",
					data	: data,
					dataType: "text",
					success	: function(msg)
					{
						//$("#risultato").html(msg);
						//alert('StartUpSequence Servlet communication OK');
						//alert( "StartupSequenceCallServer success. Sent data Was:"+data +"  result message is:"+msg);
						//StartUpSequence(NextStep,msg,Mypageobjtoken);

						StartUpSequence(1,msg,pageobjtokenIn,QueryStringIn)
					},
					error: function()
					{
						alert(ServerFailMessage);
						//WaiterShield('hide');
					}			 
				}
			);//Ajax
		} else
		if (StepIn==1)
		{
			//alert('stepin :1');
			jQuery(document.body).attr('allow_waitershield_hide','Y');
		var String_In 									= replaceAll(ServerAnswerIn,"#", "!" );


		var bodybackgroundstyle_In 			= getValueByParName(String_In,'bodybackgroundstyle');
			//console_log("######## bodystyle_In:"+bodybackgroundstyle_In);
			if ((bodybackgroundstyle_In)&&(bodybackgroundstyle_In.length>5))
			{

			var backgrounderStyle_id	= MyBody.id+'backgrounder|';
			var backgrounderStyle_el	= document.getElementById(backgrounderStyle_id);

			var backgrounderStyle_Tokens= bodybackgroundstyle_In.split(';');
				for(var g=0;g<backgrounderStyle_Tokens.length-1;++g)
				{
				var PropContent_array 	= backgrounderStyle_Tokens[g].split(":");
					//alert("backgrounderStyle_el prop:"+PropContent_array[0]+"  val:"+PropContent_array[1]);
					$(backgrounderStyle_el).css(PropContent_array[0],PropContent_array[1]);
				}
				//backgrounderStyle_el.style=bodystyle_In;
				//alert("element style ="+backgrounderStyle_el.style);
				//document.body.style=document.body.style+bodystyle_In;
			}

		var bodystylechunk_In 				= getValueByParName(String_In,'bodystylechunk');

			//console_log("######## bodystylechunk_In:"+bodystylechunk_In);
			if ((bodystylechunk_In)&&(bodystylechunk_In.length>5))
			{
			var bodystylechunk_Tokens	= bodystylechunk_In.split(';');
				for(var g=0;g<bodystylechunk_Tokens.length-1;++g)
				{
				var PropContent_array 	= bodystylechunk_Tokens[g].split(":");
					//alert("backgrounderStyle_el prop:"+PropContent_array[0]+"  val:"+PropContent_array[1]);
					$(document.body).css(PropContent_array[0],PropContent_array[1]);
				}
				//backgrounderStyle_el.style=bodystyle_In;
				//alert("element style ="+backgrounderStyle_el.style);
				//document.body.style=document.body.style+bodystyle_In;
			}

		var logocorner_In 					= getValueByParName(String_In,'logocorner');
		var LogoCornerEl 					= document.getElementById(document.body.id+'LogoCorner|');
			if (isValidElement(LogoCornerEl))
			{
				console_log('found logo corner....do not do');
			}else
			{
				jQuery(document.body).prepend("<div id='"+document.body.id+"LogoCorner|' ></div>");
				LogoCornerEl 					= document.getElementById(document.body.id+'LogoCorner|');
				console_log('not found logo corner....do');
			}
			$(LogoCornerEl).replaceWith(logocorner_In);

		var body_content_area_el			= document.getElementById(document.body.id+'ContentArea|');
		
		var splashscreen_In 				= getValueByParName(String_In,'splashscreen');
			$(body_content_area_el).append("<div id='"+document.body.id+"ContentArea|splashscreen|' style='height:300px;width:300px;z-index:500;'>"+splashscreen_In+"</div>");
			
		var splashscreen_element 			= document.getElementById(document.body.id+"ContentArea|splashscreen|"); 
		var splashscreen_element_left		= 10000;
		var splashscreen_element_right		= -10000;
		var splashscreen_element_top		= 10000;
		var splashscreen_element_bottom		= -10000;
		
			jQuery(splashscreen_element).children().each(
					function() 
					{
						var position 	= jQuery(this).position();
						if (position.left 						<splashscreen_element_left	) 	{splashscreen_element_left	=position.left;}
						if (position.left+jQuery(this).width()	>splashscreen_element_right	)	{splashscreen_element_right	=position.left+jQuery(this).outerWidth();}
						if (position.top 						<splashscreen_element_top	) 	{splashscreen_element_top	=position.top;}
						if (position.top+jQuery(this).height()	>splashscreen_element_bottom)	{splashscreen_element_bottom=position.top +jQuery(this).outerHeight();}
					}
				);
		var content_w 					= parseInt(splashscreen_element_bottom-splashscreen_element_top);
		var content_h 					= parseInt(splashscreen_element_right-splashscreen_element_left);
			$(splashscreen_element).css("height",content_h+"px");
			$(splashscreen_element).css("width" ,content_w+"px");

			//console_log("W:"+parseInt(content_w)+" H:"+parseInt(content_h));

			centerElementInParent(document.body.id+'ContentArea|splashscreen|','BOTH');

		var TimeInterval				= 20000;
		var TimeStep					= 100;


		var body_width 					= $(document.body).width();
		var body_height 				= $(document.body).height();
		var splashscreen_el 			= document.getElementById(document.body.id+'ContentArea|splashscreen|');
		var splashscreen_width 			= $(splashscreen_el).width();
		var splashscreen_height 		= $(splashscreen_el).height();

		var space_x 					= (body_width-splashscreen_width); 
		var space_y 					= (body_height-splashscreen_height);
			$(splashscreen_el).click(function() {
				  this.style.display='none';
				 // alert( "Handler for .click() called." );

			});
			splashscreen_el.style.left	= parseInt(space_x/2)+"px";
			splashscreen_el.style.top	= parseInt(space_y/2)+"px";
			//splashscreen_el.style.border="2px dotted green";
			$(splashscreen_el).css('border-radius','10px');
			$(splashscreen_el).css('overflow','hidden');
			//$(splashscreen_el).css("left", parseInt(space_x)+"px");
			//alert('space_x:'+space_x+'  space_y:'+space_y);
			if (splashscreen_In)
			{
				//alert("splashscreen_In.length:"+splashscreen_In.length);
				if (splashscreen_In.length>5)
				{
				var element_child 	= splashscreen_el.firstChild;
					//alert('splashscreen_el:'+splashscreen_el.id+' element_child id:'+element_child.id+'    '+$(element_child).attr("timeinterval") );
					//alert(" timeinterval :"+$($(splashscreen_el).first()[0]).data("timeinterval")+"   child id:"+($(splashscreen_el).first())[0].innerHTML);
					
					if ((element_child!=null)&&(parseInt($(element_child).attr("timeinterval"))>1000))
					{
					TimeInterval 	= parseInt( $(element_child).attr("timeinterval"));
					}
					if ((element_child!=null)&&(parseInt($(splashscreen_el).first().data("timestep"))>10))
					{
					TimeStep 		= parseInt( $(element_child).attr("timestep"));
					}
					//alert("TimeInterval:"+TimeInterval+" TimeStep:"+TimeStep);
					setTimerSplashScreen(TimeInterval,TimeStep );			
				}else
				{
					$(splashscreen_el).css("display","none");
				}
			}else
			{
				$(splashscreen_el).css("display","none");
			}
			//$(LogoCornerEl).replaceWith(ServerAnswerIn);

		var endsessionhtml_In 				= getValueByParName(String_In,'endsessionhtml');
			$(body_content_area_el).append("<div id='"+document.body.id+"ContentArea|endsessionhtml|' style='height:500px;width:500px;border:2px solid blue;display:none;'>"+endsessionhtml_In+"</div>");

		var objectjssenddataembedded_In 	= getValueByParName(String_In,'objectjssenddataembedded');
			//jQuery(document.body).append(objectjssenddataembedded_In);

		var JS								= document.createElement('script');
			JS.text							= objectjssenddataembedded_In;
			document.body.appendChild(JS);

			//WaiterShield('hide');
			//alert('ppppp');

		var CallerElement  					= document.getElementById(document.body.id+"Starter|");

			sendData(document.body.id,CallerElement,"ComponentsBasic.Starter");
		} else
		{
			alert("case not managed StepIn:"+StepIn);
		}
		//StepIn==2
		//Is better to call jsp by post where possible
}

function getDeviceString()
{
			var 	LengthConversionRatio 			= 1;
			var 	screen_availHeight				= window.screen.availHeight;
			var 	screen_availWidth				= window.screen.availWidth;
			var 	screen_height					= window.screen.height;
			var 	screen_width					= window.screen.width;
			var 	screen_colorDepth				= window.screen.colorDepth;
			var 	screen_pixelDepth				= window.screen.pixelDepth;	
			var 	viewport_innerHeight			= $(window).height();
			var 	viewport_innerWidth				= $(window).width();

			var		StringDevice					= deviceShow();
			var 	DataStringOut 					=   'screen_availHeight='+screen_availHeight+'&'+
														'screen_availWidth='+screen_availWidth+'&'+
														'screen_height='+screen_height+'&'+
														'screen_width='+screen_width+'&'+
														'screen_colorDepth='+screen_colorDepth+'&'+
														'screen_pixelDepth='+screen_pixelDepth+'&'+
														'LengthConversionRatio='+LengthConversionRatio+'&'+
														'browser_name='+bowser.name+'&'+
														'browser_version='+bowser.version+'&'+
														'browser_mobile='+bowser.mobile+'&'+
														'browser_os='+bowser.osname +'&'+
														'viewport_innerWidth='+viewport_innerWidth+'&'+
														'viewport_innerHeight='+viewport_innerHeight+'&'+
														StringDevice;
														//console_log('DataStringOut:'+DataStringOut);
					return DataStringOut;

} 

function reloadPageExecute(queryString,pageObjectToken)
{
	    var err = new Error();
    console.log(err.stack) ;

					alert(' reloadPageExecute ');	
					if (!isValidElement(document.getElementById("startupform")))
					{
		var 			pagename 						= retrievepageName();
		
		var 			form 							= document.createElement("form");
						form.style.height				= "200px";
						form.style.width				= "200px";
						form.style.backgroundColor		= "red";
						form.setAttribute("id", "startupform");
						form.setAttribute("method", "post");
						form.setAttribute("action", pagename);
					    //form.style.visibility			= "hidden";
					    //form.setAttribute("target", "chat");
					    jQuery(form).addClass('startupformclass');
			
				    	//Hidden Field
		var		    	hiddenField_pageobjtoken 		= document.createElement("input");
					    hiddenField_pageobjtoken.setAttribute("name" 	, "startupform_pageobjtoken");
					    hiddenField_pageobjtoken.setAttribute("id" 		, "startupform_pageobjtoken");
					    form.appendChild(hiddenField_pageobjtoken);
					    
		var				hiddenField_querystring 		= document.createElement("input");
						hiddenField_querystring.setAttribute("name" 	, "startupform_querystring");
					    hiddenField_querystring.setAttribute("id" 		, "startupform_querystring");
					    form.appendChild(hiddenField_querystring);
					    
/*		var				hiddenField_devicestring 		= document.createElement("input");
						hiddenField_devicestring.setAttribute("name" 	, "startupform_devicestring");
					    hiddenField_devicestring.setAttribute("id" 		, "startupform_devicestring");
					    form.appendChild(hiddenField_devicestring);
*/			
						/*hiddenField_nextstep 			= document.createElement("input");
						hiddenField_nextstep.setAttribute("name" 	, "nextstep");
					    hiddenField_nextstep.setAttribute("id" 		, "startupform_nextstep");
					    form.appendChild(hiddenField_nextstep);*/
					    document.body.appendChild(form);
					} 
					
				var pagename 							= retrievepageName();
			    //var SessionPageFullName					= retrievePageObjToken()+"_"+pagename;
					//setCookie(SessionPageFullName+"_step",1,1);
					storeStep(1);
					//alert("ooooo reloadPageExecute queryString >"+queryString+"< len:"+queryString.length);
					jQuery('#startupform_querystring').val(queryString);
					jQuery('#startupform_pageobjtoken').val(pageObjectToken);
				var form_el 							= document.getElementById('startupform');
					form_el.submit();
}

function StartUpSequenceN()
{
		var PrevLoopQueryString 					= jQuery(document.body).attr('startupform_querystring');
		//var JSP_pageObjToken 						= jQuery(document.body).attr('pageobjtoken');
		var afterReload 							= false;
			if (jQuery(document.body).attr('afterreload')=='true') afterReload = true;
		var request_context_path 					= jQuery(document.body).attr('request_context_path');
			//alert("Entering StartUpSequenceN:"+request_context_path+"  pageobjtoken:"+retrievePageObjToken() );
			setContextPath(request_context_path);
			//console.log('StartUpSequenceN ----BEFORE  pageobjtoken:'+sessionStorage.getItem("pageobjtoken"));
		var reloadScope 							= "";
		var pagename 								= retrievepageName();			//console.log('StartUpSequenceN:'+window. location. href+"  --- "+url_tokens[url_tokens.length-1]);
		
			dynamicallyLoadLibrary(request_context_path+'/js/CAclientPages/CAclient_'+pagename+'.js');
		
			//alert("No window name....query string:"+location.search);
			//alert(window. location. href);	
//var 		StringFomgClient = "clientstring=winows.name:"+window.name+" sessionStorage pageobjtoken:"+sessionStorage.getItem("pageobjtoken");
			//fetchHTML(StringFomgClient);
			setPageTitle("Demetra Concorsi");
			//lengthConversionByLogoCorner(1);
			//alert("LengthConversionRatio:"+LengthConversionRatio);
			//jQuery(document.body).append("<div>Hi....</div>");									
			//alert('afterreload:'+jQuery(document.body).attr('afterreload'));

			//console.log(" pageobjtoken MMMMMMMMMMM:"+sessionStorage.getItem("pageobjtoken"));
			//if (window.name.length<5)
			if (afterReload)
			{
				//alert('afterReload executing');
				jQuery(document.body).attr('afterReload','false');
				//reload with querystring at first page load
				if (retrievePageObjToken()=='') storePageObjToken(createUUID());

			var SessionPageFullName				= retrievePageObjToken()+"_"+pagename;
			var	data							= 'Step=-2'+'&'+getDeviceString()+'sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+retrievePageObjToken()+'&pagename='+pagename+'&'+PrevLoopQueryString;
			
				//not used anymore
				ServerStateImplement(true,data);

				//jQuery(document.body).html("PAGE RELOAD OPERATION");
				//ServerCallBackTokenizeReload('');
				//ServerCallBackTokenize('');
				//AfterStartupOrReload();
			} else
			if (window.location.search.length>0)
			{
				//alert('found query string ');
				reloadScope 						= "hidequerystring";
			} else
			{
				//alert('PrevLoopQueryString:'+PrevLoopQueryString+" JSP_pageObjToken:"+JSP_pageObjToken);
				//if (sessionStorage.getItem("pageobjtoken")<5)
				//alert('sessionStorage.getItem("pageobjtoken"):'+sessionStorage.getItem("pageobjtoken"));
				if (retrievePageObjToken()=="")
				{//not existing window.name
					//alert(' not existing pageobjtoken ');
					//bowser = require('bowser');
					//alert('browser:'+bowser.name+'   version:'+bowser.version+"   mobile:"+bowser.mobile+'   browser_os='+bowser.osname  );
					//var BrowserInfo 				= get_browser_info();
					//alert("A 2 I OOOOOOOOOOOOOMMMMM pageobjtoken NULL");
					
				//var Mypageobjtoken					= createUUID();
					//window.name						= pageobjtoken+"_pageobjtoken";
					//sessionStorage.setItem("pageobjtoken",Mypageobjtoken);
					storePageObjToken(createUUID());
					
				var SessionPageFullName				= retrievePageObjToken()+"_"+pagename;
		
				var	data							= 'Step=-2'+'&'+getDeviceString()+'&sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+retrievePageObjToken()+'&pagename='+pagename;
					//alert('StartupSequenceCallServer \nStepIn:'+StepIn+'\n Next Step:\n dataIn:\n data:'+data);
					//console.log('StartUpSequenceN startup pageobjtoken:'+sessionStorage.getItem("pageobjtoken"));
					//console_log('page creation data:'+data);
					setCookie(SessionPageFullName+"_step",1,1);
					//not used anymore
					ServerStateImplement(true,data);
					//fetchHTML(data);
					//jQuery(document.body).html(SessionPageFullName);
				} else
				if (retrievePageObjToken().length>0)
				{
					//jQuery(document.body).html("OOOOOOOOOOOOOMMMMM pageobjtoken NOT NULL");

				var Mypageobjtoken					= retrievePageObjToken();
				var SessionPageFullName				= Mypageobjtoken+"_"+pagename;
				var SubmitTrigger  					= '|'+pagename+'|page_reload|';
				var Identifier  					= '|'+pagename+'|';
				var	data							= 'Step=-2'+'&sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+pagename+'&action=pagereload&SubmitTrigger='+SubmitTrigger+'&Identifier='+Identifier;
				
					//console.log('StartUpSequenceN  reload');
					alert('startup b data:'+data);
					//ServerStateImplement(true,data);
					//fetchHTML(data);
					//console.log( "step current cookie:"+SessionPageFullName+"_step " );
					//reloadScope						= "reload";
					//console.log("step next:"+step);
					//jQuery(document.body).html(" first reload push!! title:"+sessionStorage.getItem("pagetitle"));
					//document.tile 					= sessionStorage.getItem("pagetitle");
					
					
					
					//ServerStateImplement(true,data);
					
					
					fillReloadPage();
					
				var step 							= parseInt(getCookie(SessionPageFullName+"_step"));
					setCookie(SessionPageFullName+"_step",++step,1);

					if (step==3)
					{
						setCookie(SessionPageFullName+"_step",1,1);
						//not used anymore
						ServerStateImplement(true,data);
					}
				} else
				{
					//jQuery(document.body).html("OOOOOOOOOOOOOMMMMM 3");
				}
			}
			//console.log('StartUpSequenceN ----AFTER  pageobjtoken:'+sessionStorage.getItem("pageobjtoken"));
			if (reloadScope=='reload')
			{
				reloadPageExecute('',sessionStorage.getItem("pageobjtoken"));
			} else
			if (reloadScope=='hidequerystring')
			{
			var myPageObjToken = 		retrievePageObjToken();
				if(myPageObjToken=='') {myPageObjToken = createUUID();} 
				reloadPageExecute(location.search.replace('?',''),sessionStorage.getItem("pageobjtoken"));
			}
}

function deviceShow()
{
    var 	md 						= new MobileDetect(window.navigator.userAgent);
	    //alert("mobile:"+md.mobile() );
	    							/*
								      console_log('mobile detect mobile:'+ md.mobile() );          // 'Sony'
								      console_log('mobile detect phone:'+ md.phone() );           // 'Sony'
								      console_log('mobile detect tablet:'+ md.tablet() );          // null
								      console_log('mobile detect useragent:'+md.userAgent() );       // 'Safari'
								      console_log('mobile detect os:'+ md.os() );              // 'AndroidOS'
								      console_log('mobile detect iPhone:'+ md.is('iPhone') );      // false
								      console_log('mobile detect bot:'+md.is('bot') );         // false
								      console_log('mobile detect Webkit:'+ md.version('Webkit') );         // 534.3
								      console_log('mobile detect Build:'+ md.versionStr('Build') );       // '4.1.A.0.562'
								      console_log('mobile detect playstation|xbox:'+ md.match('playstation|xbox') ); // false
	    
									  console_log("device.portrait() :"+ device.portrait());
								      console_log("device.landscape() :"+ device.landscape());
								      console_log("device.mobile() :"+ device.mobile());
								      console_log("device.tablet() :"+ device.tablet());
								      console_log("device.ipad() :"+ device.ipad());
								      console_log("device.ipod() :"+ device.ipod());
								      console_log("device.iphone() :"+ device.iphone());
								      console_log("device.android() :"+ device.android());
								      console_log("device.androidTablet() :"+ device.androidTablet());
								      console_log("device.blackberryTablet() :"+ device.blackberryTablet());
								      console_log("device.fxos() :"+ device.fxos());
								      console_log("device.fxosPhone() :"+ device.fxosPhone());
								      console_log("device.fxosTablet() :"+ device.fxosTablet());
								      console_log("device.meego() :"+ device.meego());
								      console_log("device.television() :"+ device.television());
										*/
								//	is_device_mobile	=      device.mobile();

	var 	StringOut 				= "";
	    	StringOut  			   += "mobile_mobile="+md.mobile()+"&";
	    	StringOut 			   += "mobile_phone="+md.phone()+"&";
	    	StringOut 			   += "mobile_tablet="+md.tablet()+"&";
	    	StringOut 			   += "mobile_useragent="+md.userAgent()+"&";
	    	StringOut 			   += "mobile_os="+md.os()+"&";
	    	StringOut 			   += "mobile_iphone="+md.is('iPhone')+"&";
	    	StringOut 			   += "mobile_bot="+md.is('bot')+"&";
	    	StringOut 			   += "mobile_webkit="+md.version('Webkit')+"&";
	    	StringOut 			   += "mobile_build="+md.versionStr('Build')+"&";
	    	StringOut 			   += "mobile_playstation_xbox="+md.match('playstation|xbox')+"&";

	    	
	    	
	    	StringOut 			   += "device_portrait="+ device.portrait()+"&";
	    	StringOut 			   += "device_landscape="+ device.landscape()+"&";
	    	StringOut 			   += "device_mobile="+ device.mobile()+"&";
	    	StringOut 			   += "device_tablet="+ device.tablet()+"&";
	    	StringOut 			   += "device_ipad="+ device.ipad()+"&";
	    	StringOut 			   += "device_ipod="+ device.ipod()+"&";
	    	StringOut 			   += "device_iphone="+ device.iphone()+"&";
	    	StringOut 			   += "device_android="+ device.android()+"&";
	    	StringOut 			   += "device_androidtablet="+ device.androidTablet()+"&";
	    	StringOut 			   += "device_blackberrytablet="+ device.blackberryTablet()+"&";
	    	StringOut 			   += "device_fxos="+ device.fxos()+"&";
	    	StringOut 			   += "device_fxosphone="+ device.fxosPhone()+"&";
	    	StringOut 			   += "device_fxostablet="+ device.fxosTablet()+"&";
	    	StringOut 			   += "device_meego="+ device.meego()+"&";
	    	StringOut 			   += "device_television="+ device.television()+"&";

	    	return StringOut; 
}

function EnhancedTextEditorReset(IdentifierIn,StringIn)
{
				var  	EnhancedTextEditor_el 						= document.getElementById(IdentifierIn);
						EnhancedTextEditor_el.style.backgroundColor = 'green';
				var  	EnhancedTextEditorIsModified_el 			= document.getElementById(IdentifierIn+"IsModified|");
						EnhancedTextEditorIsModified_el.value 		= 'N';
						if( typeof StringIn === 'undefined' || StringIn === null )
						{
						    // Do stuff
						}
						else
						{
					var  	EnhancedTextEditorOriginalContent_el 			= document.getElementById(IdentifierIn+"OriginalContent|");
							EnhancedTextEditorOriginalContent_el.value 		= StringIn;
					var  	EnhancedTextEditorCurrentContent_el 			= document.getElementById(IdentifierIn+"CurrentContent|");
							EnhancedTextEditorCurrentContent_el.value 		= StringIn;				
						}			
}

function ManageCarousel(FunctionIn,ElementIn)
{
					var CarouselParents = $(ElementIn).parents('.Components-Carousel');
						//alert("found : "+CarouselParents.length);
						//$(ElementIn).parents('.Components-Carousel').css('border','3px solid red');
						$(CarouselParents).find('td').removeClass('selected');
						$(ElementIn).addClass('selected');
}

function closeWindow()
{
    var 				browserName = navigator.appName;
    var 				browserVer = parseInt(navigator.appVersion);
					    //alert(browserName + " : "+browserVer);
					
					    //document.getElementById("flashContent").innerHTML = "<br>&nbsp;<font face='Arial' color='blue' size='2'><b> You have been logged out of the Game. Please Close Your Browser Window.</b></font>";
					
					    if(browserName == "Microsoft Internet Explorer")
					    {
					    var ie7 = (document.all && !window.opera && window.XMLHttpRequest) ? true : false;  
					        if (ie7)
					        {  
					          //This method is required to close a window without any prompt for IE7 & greater versions.
					          window.open('','_parent','');
					          window.close();
					        }
					       	else
					        {
					          //This method is required to close a window without any prompt for IE6
					          this.focus();
					          self.opener = this;
					          self.close();
					        }
					   }
					   else
					   {  
					       //For NON-IE Browsers except Firefox which doesnt support Auto Close
					       try
					       {
					           this.focus();
					           self.opener = this;
					           self.close();
					       }
					       catch(e)
					       {
					
					       }
					
					       try
					       {
					           window.open('','_self','');
					           window.close();
					       }
					       catch(e)
					       {
					
					       }
					   }
}


/*
function GenericObjectsList(ObjectTypeIn)
{
		var ObjectType = '';
	  	
		
		var obj = {
			     getType: function(param)
			     {  
			          return ObjectType;  
			     }
			  };
		// private constructor 
		var __construct = function() 
		{
	       alert("Object Created.");
	       ObjectType = ObjectTypeIn;
		}()
		 get area() 
		{
			return this.calcArea()
		}

}
*/


function  GenericObjectsList (typeIn)
{
	var that		= this;
	var type 		= '';
	var contents 	= new Array();
	var Ids 		= new Array();
		//sample.push(new Object());
	 	//private constructor 
	var __construct = function() 
	   	{
	       //alert("Object Created.");
	       type = typeIn;
	   	}()
	   	
		that.getType = function () 
		{
			return type;
		};

		that.getSize = function () 
		{
			return Ids.length;
		};

		that.getElement = function (elementId) 
		{
			return type+"--->"+elementId;
		};

		that.addElement = function (IdentifierIn,elementIn,forceIn) 
		{
			//alert('stored type:'+type+' type In:'+getObjectType(elementIn));
		var found 					= 'N';
			if (!forceIn)
			{
				for(var i=0;i<Ids.length;++i)
				{
					if (Ids[i]==IdentifierIn) {found = 'Y';}
				}
			}
			
			if ((getObjectType(elementIn)==type)&&(found=='N'))
			{
				Ids.push(IdentifierIn);
				contents.push(elementIn);
			}
		};
		
		that.getElementByIdentifier 	= function (IdentifierIn) 
		{
			//var ObjectOut = null;
			for(var i=0;i<Ids.length;++i)
			{
				if (Ids[i]==IdentifierIn) return contents[i];
			}
			return null;
		};
		
		that.removeElementByIdentifier 	= function (IdentifierIn)
		{
			for(var i=0;i<Ids.length;++i)
			{
				if (Ids[i]==IdentifierIn) 
				{
					Ids.splice(i,1);
					contents.splice(i,1);
				}
			}
		}
		
		that.removeElementByPosition 	= function (PositionIn)
		{
			if (PositionIn<Ids.length)
			{
				Ids.splice(PositionIn,1);
				contents.splice(PositionIn,1);
			}
		}
		
		that.getElementByPosition 		= function (PositionIn) 
		{
			if (PositionIn>Ids.length) {return null;}
			return contents[PositionIn];
		};
		
		that.getElementIdByPosition 	= function (PositionIn) 
		{
			if (PositionIn>Ids.length) {return null;}
			return Ids[PositionIn];
		};
}

function getObjectType(obj)
{
	if (obj && obj.constructor && obj.constructor.toString()) 
	{

        /*
         *  for browsers which have name property in the constructor
         *  of the object,such as chrome 
         */
        if(obj.constructor.name) {
            return obj.constructor.name;
        }
        var str = obj.constructor.toString();
        /*
         * executed if the return of object.constructor.toString() is 
         * "[object objectClass]"
         */

        if(str.charAt(0) == '[')
        {
                var arr = str.match(/\[\w+\s*(\w+)\]/);
        } else {
                /*
                 * executed if the return of object.constructor.toString() is 
                 * "function objectClass () {}"
                 * for IE Firefox
                 */
                var arr = str.match(/function\s*(\w+)/);
        }
        if (arr && arr.length == 2) 
        {
                    return arr[1];
        }
	}
	return undefined; 
  }


function getPlainTextFromHTML(htmlIn,BufferDIVid)
{
					var BufferDIVel 			= document.getElementById(BufferDIVid);
						BufferDIVel.innerHTML 	= htmlIn;
						//console_log("htmlIn:"+htmlIn);
					var MyText					= $(BufferDIVel).text();
						MyText					= MyText.replace(/[\n\r]/g, '');
						return MyText; 
}

function isValidElement(ElementIn)
{
						return ((typeof(ElementIn) !== 'undefined') && (ElementIn !== null));	
}

function dateDiff(dt1, dt2,adding_days)
{
	    /*
	     * setup 'empty' return object
	     */
    var ret = {days:0, months:0, years:0};

	    /*
	     * If the dates are equal, return the 'empty' object
	     */
    	if (dt1 == dt2) return ret;

	    /*
	     * ensure dt2 > dt1
	     */
	    if (dt1 > dt2)
	    {
	    var dtmp = dt2;
	        dt2 = dt1;
	        dt1 = dtmp;
	    }

    
    	dt2.setDate(dt2.getDate() + adding_days);

    	//dt2.addDays(adding_days);
	    /*
	     * First get the number of full years
	     */

    var year1 = dt1.getFullYear();
    var year2 = dt2.getFullYear();

    var month1 = dt1.getMonth();
    var month2 = dt2.getMonth();

    var day1 = dt1.getDate();
    var day2 = dt2.getDate();

	    /*
	     * Set initial values bearing in mind the months or days may be negative
	     */

	    ret['years'] = year2 - year1;
	    ret['months'] = month2 - month1;
	    ret['days'] = day2 - day1;

	    /*
	     * Now we deal with the negatives
	     */

	    /*
	     * First if the day difference is negative
	     * eg dt2 = 13 oct, dt1 = 25 sept
	     */
	    if (ret['days'] < 0)
	    {
        /*
         * Use temporary dates to get the number of days remaining in the month
         */
        var dtmp1 = new Date(dt1.getFullYear(), dt1.getMonth() + 1, 1, 0, 0, -1);

        var numDays = dtmp1.getDate();

	        ret['months'] -= 1;
	        ret['days'] += numDays;
    	}

	    /*
	     * Now if the month difference is negative
	     */
	    if (ret['months'] < 0)
	    {
	        ret['months'] += 12;
	        ret['years'] -= 1;
	    }

    	return ret;
}

function remove_accents(strAccents) 
{
				    var strAccents 					= strAccents.split('');
				    var strAccentsOut 				= new Array();
				    var strAccentsLen 				= strAccents.length;
				    var accents 					= "ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
				    var accentsOut 					= "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
					    for (var y = 0; y < strAccentsLen; y++) 
					    {
					        if (accents.indexOf(strAccents[y]) != -1) 
					        {
					            strAccentsOut[y] 	= accentsOut.substr(accents.indexOf(strAccents[y]), 1);
					        } else
					        {
					        	
					            strAccentsOut[y] 	= strAccents[y];
					        }
					    }
				    	strAccentsOut 				= strAccentsOut.join('');
				    var strAccentsOut_ok    		= strAccentsOut.replace(/[^a-z0-9\s]/gi, '').replace(/[-\s]/g, '');
				
				    	return strAccentsOut_ok;
}

function OpenPersonalPage(UnameIn,DomainIn,FirstNameIn,LastNameIn)
{
						//alert('UnameIn:'+UnameIn+'  DomainIn:'+DomainIn+' FirstNameIn:'+FirstNameIn+'   LastNameIn:'+LastNameIn);
						//window.open("me", "_blank ");
					var redirectWindow = window.open('me', '_blank');
    					redirectWindow.location;

}

function getErrorObject()
{
  						try { throw Error('') } catch(err) { return err; }
}

function canDoJob(elIn)
{
							var 		can_do 																								= true;
							var			main_el 																							= elIn;
										if (! ((jQuery(elIn).hasClass(".IsTE"))||(jQuery(elIn).hasClass(".IsSW"))) )
										{ 
											main_el 																						= jQuery(elIn).parents(".IsSW , .IsTE")[0];
										}else
										{
										}
										
										//if (typeof car.color === 'undefined')
										//console_log( "prop disabled:" +jQuery(elIn).prop("disabled")+"<");
										//console_log( "attr disabled:" +jQuery(elIn).attr("disabled")+"<");
										//console_log( "prop readonly:" +jQuery(elIn).prop("readonly")+"<");
										//console_log( "attr readonly:" +jQuery(elIn).attr("readonly")+"<");

										if (jQuery(elIn).hasClass("disabled")) 						{can_do = false;}
										if (jQuery(elIn).hasClass("readonly")) 						{can_do = false;}
										if (jQuery(elIn).prop("disabled")) 							{can_do = false;}
										if (jQuery(elIn).prop("readonly")) 							{can_do = false;}
										if (jQuery(elIn).attr("disabled")=="disabled") 				{can_do = false;}
										if (jQuery(elIn).attr("readonly")=="readonly") 				{can_do = false;}
										
										if (jQuery(main_el).hasClass("disabled")) 					{can_do = false;}
										if (jQuery(main_el).hasClass("readonly")) 					{can_do = false;}
										if (jQuery(main_el).prop("disabled")) 						{can_do = false;}
										if (jQuery(main_el).prop("readonly")) 						{can_do = false;}
										if (jQuery(main_el).attr("disabled")=="disabled") 			{can_do = false;}
										if (jQuery(main_el).attr("readonly")=="readonly") 			{can_do = false;}

										return can_do;
}

function isNumeric(n)
{
										return !isNaN(parseFloat(n)) && isFinite(n);
}

function escapeHtml (string) 
{
				    var entityMap = {
				        "&": "&amp;",
				        "<": "&lt;",
				        ">": "&gt;",
				        '"': '&quot;',
				        "'": '&#39;',
						"\\":'&bsol;',
				        "/": '&#x2F;'
				    };
				    return String(string).replace(/[&<>"'\/]/g, function (s) {
				        return entityMap[s];
				    });
}

 function decodeHtml (string) 
 {
			    var entityMap = {
			        "&amp;": "&",
			        "&lt;": "<",
			        "&gt;": ">",
			        '&quot;': '"',
			        '&#39;': "'",
					'&bsol;':"\\",
			        '&#x2F;': "/"
			    };
			    return String(string).replace(/&amp;|&lt;|&gt;|&quot;|&#39;|&bsol;|&#x2F;/gi, function (s) {
			        return entityMap[s];
			    });
}

function ToAzureSSO(elIn,UnameAndDomainIn,pageobjtokenIn)
{
				//var pageobjtoken = jQuery(document.body).attr('pageobjtoken');
		var 	new_tab_string = '/msal4j-servlet-auth?auto=Y&pageobjtoken='+pageobjtokenIn+'&current_unameanddomain='+UnameAndDomainIn; 
				//alert("new_tab_string:"+new_tab_string);
				//window.open(new_tab_string,'_blank') ; 
				window.open(new_tab_string,'demetra_office365_sso') ;
}

function ToEIDASGatewayTest(elIn,CRAGEST_SESSION_ID)
{
	  const 	params = new URLSearchParams();
				params.append('auto', 'Y');
				params.append('CRAGEST_SESSION_ID', CRAGEST_SESSION_ID);
				params.append('entityId', 'https://sp-proxy.pre.eid.gov.it/spproxy/idpit');
				params.append('attributeConsumingServiceIndex', '100');
				params.append('assertionConsumerServiceIndex', '0');
	  const 	queryString = params.toString();
	  //const url = "https://istanzeonline.crea.gov.it/loginEIDAS/mypage.jsp?"+queryString;
	  const 	url = "https://20.67.106.55/loginEIDAS/mypage.jsp?"+queryString;
   				window.open(url,'demetra_SPIDTest') ;
}

function ToEIDASGateway(elIn,CRAGEST_SESSION_ID,URLIn,client_id_in)
{
	  const 	params = new URLSearchParams();
				params.append('auto', 'Y');
				params.append('CRAGEST_SESSION_ID', CRAGEST_SESSION_ID);
				params.append('client-id', client_id_in);
				params.append('entityId', 'https://sp-proxy.pre.eid.gov.it/spproxy/idpit');
				params.append('attributeConsumingServiceIndex', '100');
				params.append('assertionConsumerServiceIndex', '0');
	  const 	queryString = params.toString();
	  const 	url = URLIn+"?"+queryString;
				window.open(url,'demetra_eIDAS') ;
}

function ToCIEGateway(elIn,CRAGEST_SESSION_ID,URLIn,client_id_in)
{
	  const 	params = new URLSearchParams();
				params.append('auto', 'Y');
				params.append('CRAGEST_SESSION_ID', CRAGEST_SESSION_ID);
				params.append('client-id', client_id_in);
				params.append('entityId', 'https://idserver.servizicie.interno.gov.it/idp/profile/SAML2/POST/SSO');
	  const 	queryString = params.toString();
	  const 	url = URLIn+"?"+queryString;
				window.open(url,'demetra_CIE') ;
}

function ToSPIDGateway(elIn,CRAGEST_SESSION_ID)
{
				//var pageobjtoken = jQuery(document.body).attr('pageobjtoken');
	var 		new_tab_string = 'https://concorsi.crea.gov.it/webapplg/mypage.jsp?auto=Y&CRAGEST_SESSION_ID='+CRAGEST_SESSION_ID; 
				//alert("new_tab_string:"+new_tab_string);
				//window.open(new_tab_string,'_blank') ; 
				window.open(new_tab_string,'demetra_SPID') ;
}

function ValidateEmail(input) 
{
var 			emailRegex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/, "gm");
var 			isValidEmail = emailRegex.test(input);
				//console_log("ValidateEmail:"+input+" result:"+isValidEmail);
				return isValidEmail;
}

function setCaretPosition_(elemId, caretPos) 
{
	var elem = document.getElementById(elemId);

		if(elem != null) 
		{
			if(elem.createTextRange) 
			{
			var range = elem.createTextRange();
				range.move('character', caretPos);
				range.select();
			}else 
			{
				if(elem.selectionStart) 
				{
					elem.focus();
					elem.setSelectionRange(caretPos, caretPos);
				}
				else
				elem.focus();
			}
		}
}

function setCaretPosition(ctrl, pos) 
{
  // Modern browsers
  	if (ctrl.setSelectionRange) 
	{
		ctrl.focus();
		ctrl.setSelectionRange(pos, pos);
  		// IE8 and below
	} else 
	if (ctrl.createTextRange) 
	{
	var range = ctrl.createTextRange();
		range.collapse(true);
		range.moveEnd('character', pos);
		range.moveStart('character', pos);
		range.select();
	}
}

function findHighestZIndexInChildhood(elIn)
{
    var 	divs 			= jQuery(elIn).find('*');
    var 	highest 		= 0;
		    for (var i = 0; i < divs .length; i++)
		    {
				if(		
					($(divs[i]).is(":visible"))
					&&
					(!($(divs[i]).css('display') == 'none'))
				)
				{
		        var zindex_str = divs[i].style.zIndex;
		        //var zindex = parseInt(divs[i].style.zIndex);
			        if(divs[i].id.length>0)
			        {
						if (isNumeric(zindex_str))
						{
						var zindex = parseInt(divs[i].style.zIndex);
							//console_log("id:"+divs[i].id+" zindex:"+zindex+" visible:"+jQuery(divs[i]).css('visibility')+" display:"+jQuery(divs[i]).css('display'));
						    if (zindex > highest) 
						    {
						        highest = zindex;
						    } 
					    }
					}
		    	}
		    }
		    return highest;
}

function findHighestZIndexInFamily(elIn)
{
		var childhood_max_zindex 	=	findHighestZIndexInChildhood(elIn);
		var me_zindex_text 			=	jQuery(elIn).css('z-index');
			if (isNumeric(me_zindex_text)) 
			{
			var	me_zindex=parseInt(me_zindex_text);
				if (me_zindex>childhood_max_zindex) {childhood_max_zindex=me_zindex;}
			}
			return childhood_max_zindex;
}

function changeBodyDimensions(dim_width,dim_height)
{
			jQuery(document.body).css('width',dim_width+'px');	
			jQuery(document.body).css('height',dim_height+'px');	
			//jQuery(document.body).css('background-color','orange');	
}

/**
 * Do not force replace for execution speed.
 * To replace script use addScript java method in SubWindow Class
 */
function _dynamicallyLoadLibrary(urlIn)
{
}

/**
 * Do not force replace for execution speed.
 */
function _dynamicallyLoadStyleSheet(urlIn)
{
	var found =jQuery('head').find("link[href^='" + urlIn +"']");
		if (found.length==0)
		{
		var d 				= new Date();
		var ms 				= d.getTime();
		var tqs 			= "?v="+ms;
			urlIn 			= urlIn+tqs;
			jQuery('head').append(
				"<link rel='stylesheet' href='"+urlIn+"' >"
			);
		}	else
		{
			console.log("found stylesheet code "+urlIn);
		}
}

/*
 * called by server incoming js command only when nedded.
 */
function _dynamicallyLoadJSModule(CodeIn)
{
			var Mypageobjtoken																										= $(document.body).attr('pageobjtoken');
			var Mypagename																											= $(document.body).attr('pagename');
			var SessionPageFullName																									= Mypageobjtoken+"_"+Mypagename;		
			var	data_pagechunk																										= 'sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+Mypagename+'&';

	var 		modulesQueryString = '?'+data_pagechunk+'code='+CodeIn;
				jQuery('head').append("<script  src='JSModuleProvider"+modulesQueryString+"' type='module' ></script>");
}

function tableWidthLoad()
{
	var WidthString = $('#infowidth').attr("value");
	var WidthArray = WidthString.split(';'); 
		for(var i=0;i<WidthArray.length;i++)
		{
		var ParVal  = WidthArray[i].split('\:');
			$("#"+ParVal[0]).css("width",ParVal[1]);
		}
}

function delegate(event, ui)
{
	//$('#B').html( $(ui.element).prop("tagName"));
	var totwidth=0;
	var StringOut="";
	var WidthString = $('#infowidth').attr("value");
	var WidthArray = WidthString.split(';'); 
	var isbefore="true";
	var CallerName =  $(ui.element).attr("id");
	for(var i=0;i<WidthArray.length;i++)
	{
		StringOut+="<br> i:"+i+"   "+WidthArray[i];
		var ParVal  = WidthArray[i].split('\:');
		//var ID 		= ParVal[0];
		//var Width 	= ParVal[1];
		StringOut+=" ParVal[0]:"+ParVal[0]+"______"+ParVal[1]+"------";
		if (ParVal[0]==CallerName) isbefore="false";
		if (isbefore=="true")
		{
			$("#"+ParVal[0]).css("width",ParVal[1]);
		}
		totwidth=$("#demotable").width();

		
		if (totwidth>690)
		{
			$("#containerdiv").css("width",(totwidth+50));
			//$("#containerdiv").css("background-color","blue");
		}
		else
		{
			$("#containerdiv").css("width",700);
			
		}
		$('#C').html( "width:"+totwidth);

		//$("#"+ID).htlm("Width");
		//$('#B').html( WidthArray[i]+" kkk "+ParVal +'   ID:'+ID+' width:'+Width);
	}
	$('#B').html( $('#infowidth').attr("value")+"<br>"+StringOut);	
}


function __sendData(A,elementIn,CallingClass)
{
	var SendDataOutString = "";
		if (CallingClass=='Components.FileBrowser')
		{
			//var rootpath = elementIn.id;
			SendDataOutString+="rootpath="+elementIn.id+"&functioncall=nodeexpand";
		}

		$.ajax
		(
				{
					type	:"POST",
					url		:"FBCommands?"+SendDataOutString,
					success	:function(result)
							{
							//$("#div1").html(result);
								//alert('result : '+result);
								sendDataCallbackTokenizer("FileBrowser",elementIn,result);
							}
				}
		);
}

function __sendDataCallbackTokenizer(FunctionCall,elementIn,ServerMsg)
{
	var AddingHTML="";
	var SeAddingElements = ServerMsg.split("<end>");
		//alert('ServerMsg tokens :'+SeAddingElements.length);
		for(var aei=0;aei<SeAddingElements.length-1;++aei)
		{
		//var Path="";
		var depth = -1;
		var MyChildren = $(elementIn).children();
			//alert('found children : '+MyChildren.length);
			for(var ffi=0;ffi<MyChildren.length;++ffi)
			{
				if ( $(MyChildren[ffi]).attr("name")=="depth" )
				{
					depth = parseInt(MyChildren[ffi].value);
				}
			}
		var SeAddingElementTokens = SeAddingElements[aei].split("@@@@");
			//alert('SeAddingElementTokens size : '+SeAddingElementTokens.length);
		var Name = SeAddingElementTokens[0];
		var Path = SeAddingElementTokens[1];
		var AddingHMLChunk = "";
			AddingHMLChunk	+= "<div id = 'FOLDER_"+Path+"' style='position:relative;margin-left:"+((depth+1)*8)+"px;height:30px;width:50px;background-color:lightblue;border:1px solid blue;' onclick=\"pathClick(this);\" >";
			AddingHMLChunk	+= "<input type=\"hidden\" name='depth' 			value='"+(depth+1)+"'>";
			AddingHMLChunk	+= "<input type=\"hidden\" name='completepath' 	value='"+Path+"'>";		
			AddingHMLChunk	+= Name;
			AddingHMLChunk	+= "</div>";
			AddingHTML +=AddingHMLChunk;
		}	
		$(AddingHTML).insertAfter(elementIn);	
}

function pathClick(elementIn)
{
	sendData(null,elementIn,'Components.FileBrowser');
	//alert("elementIn:"+elementIn.id);
}

function drawFilesTable(IdentifierIn,elementInId)
{
	//alert('files table drawing....');
	var cols					= 4;
	var rows					= 4;
	var HTMLfilesList 			= "";
	var FilesListGeneratorId 	= "FilesListGenerator";
		HTMLfilesList+=" <table id ='"+FilesListGeneratorId+"' width=\"100%\" height=\"100%\" border=\"1\" style='top:0px;bottom:0px;left:0px;right:0px;border:1px solid lime;background-color:red;'>";

		for(var ggj=0;ggj<rows;++ggj)
		{
			HTMLfilesList+=" <tr>";
			for(var ggk=0;ggk<rows;++ggk)
			{
				HTMLfilesList+="	<td class=\"noselect resourceelement_outer\" height='"+100/rows+"%' style='position:relative;border:2px solid white;margin:0;padding:0;' onclick=\"fileBroserFileSelectionReset('"+FilesListGeneratorId+"');\">";
				////HTMLfilesList+="		<div class=\"resourceelement_outer\" style='width:90%;height:90%;margin:0;padding:0;top:0;position:absolute;display:table;background-color:yellow;border:2px solid red;'> ";
				HTMLfilesList+="			<input type = 'hidden' class=\"selectmemo\" id = 'SELECTMEMO_COMPLETEPATH_"+((ggj*cols)+ggk)+"' name = 'selectmemo' value ='N'> ";
				HTMLfilesList+="			<div id = 'CONTENT_COMPLETEPATH_"+((ggj*cols)+ggk)+"' class=\"noselect resourceelement\" style='height:30px;line-height:30px;width:80%;background-color:lightgrey;border:1px solid pink;'> ";
				HTMLfilesList+=" 				jfile : "+((ggj*cols)+ggk)+"";
				HTMLfilesList+="			</div>";
				////HTMLfilesList+="		</div>";
				HTMLfilesList+="	</td>";
			}
			HTMLfilesList+=" </tr>";
		}
		//HTMLfilesList+="<tr height=50%><td>1</td><td>2</td></tr>";
		//HTMLfilesList+="<tr height=50%><td>3</td><td>4</td></tr>";
		HTMLfilesList+=" </table>";
		$('#'+elementInId).html(HTMLfilesList);
		//alert('fff'+document.getElementById('FilesListGenerator').parentNode.clientHeight);
		//alert('hhh'+$(document.getElementById('FilesListGenerator').parentNode).height());
		//alert('table:'+$('#FilesListGenerator').height());	
	var TableParentHeight =  $(document.getElementById('FilesListGenerator').parentNode).height();
		$(document.getElementById('FilesListGenerator')).height(TableParentHeight);
	
    var ResourceConainerList 		= $(document.getElementById('FilesListGenerator')).find(".noselect");
	    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
	    {
	    	disableSelect(ResourceConainerList[vvi]);
	    }
}

function fileBroserFileSelectionUp(eventIn,elementIn)
{
	//var ElementSelector = document.getElementById(elementIn.id+'_selector_div');
	document.getElementById(elementIn.id+'_state').value = "0000";
	$('#'+elementIn.id+'_selector_div').remove();
}

function fileBroserFileSelectionReset(eventIn,elementIn)
{
	
		$('#debugger_content').html('mouse out ');

	
	//var ElementSelector = document.getElementById(elementIn.id+'_selector_div');
	var CallerdId = elementIn.id;
		document.getElementById(CallerdId+'_state').value = "0000";
		$('#'+CallerdId+'_selector_div').remove();
}

/////////////////////////////////////FS MOUSE SELECTION///////////////////////////
function fileBroserFileSelectionDown_ori(OwnerOBJIn,eventIn,elementIn)
{
	//$('#debuggeroutput_content').html('jjjjjjjj');
	//var ElementTDContining 					= elementIn.parentNode;
	
	var ElementTDContining					= OwnerOBJIn;
	var ElementTDContiningrect				= ElementTDContining.getBoundingClientRect();
	
		document.getElementById(elementIn.id+'_state').value = "0000";
	
		$('#'+elementIn.id+'_selector_div').remove();

	var ElementState 						= document.getElementById(elementIn.id+'_state');
	var ElementLeftTopCoord 				= document.getElementById(elementIn.id+'_lefttop_corner');
		
	var mouseCoords 						= getCoords(eventIn);
    var startX 								= parseInt(mouseCoords.x) - parseInt(ElementTDContiningrect.left);
    var startY 								= parseInt(mouseCoords.y) - parseInt(ElementTDContiningrect.top);
		ElementLeftTopCoord.value 			= ""+startX+";"+startY;

	var elementSelector 					= document.createElement('div');

		elementSelector.id 					= elementIn.id+"_selector_div";

		elementSelector.style.position 		= "absolute";
		elementSelector.style.left			= startX+"px";
		elementSelector.style.top			= startY+"px";
	
		elementSelector.style.height		= "0px";
		elementSelector.style.width			= "0px";
		//elementSelector.style.backgroundColor 	= "white";//"rgba(100,100,10,0.2)";
		elementSelector.className			= "selectordiv"; 
	
		elementSelector.style.zIndex		= "99";
	
		elementSelector.setAttribute("onmousemove","fileBroserFileSelectionMove(event,document.getElementById('"+elementIn.id+"'))");
		elementIn.appendChild(elementSelector);
	
	    ElementState.value					= "0050";
}

function fileBroserFileSelectionMove_ori(eventIn,elementIn)
{
		//alert('moving');
		if (document.getElementById(elementIn.id+'_state').value=='0050')
		{
		var ElementTDContining 			= elementIn.parentNode;	
		var ElementTDContiningrect		= ElementTDContining.getBoundingClientRect();
		var mouseCoords 				= getCoords(eventIn);
	    var posX 						= parseInt(mouseCoords.x) - parseInt(ElementTDContiningrect.left) ;
	    var posY 						= parseInt(mouseCoords.y) - parseInt(ElementTDContiningrect.top);
	    var elementSelector				= document.getElementById(elementIn.id+'_selector_div');
		var ElementLeftTopCoord 		= document.getElementById(elementIn.id+'_lefttop_corner');
	    var startX 						= parseInt(ElementLeftTopCoord.value.split(";")[0]);
	    var startY 						= parseInt(ElementLeftTopCoord.value.split(";")[1]);
	    var Height						= posY-startY;
	    var Width						= posX-startX;
		    elementSelector.style.width 	= Width+"px";
		    elementSelector.style.height 	= Height+"px";
	    
	    
	    var elementSelectorRect 		= elementSelector.getBoundingClientRect();
	    var ResourceConainerList 		= $(ElementTDContining).find(".resourceelement");
		    //alert('found : '+ResourceConainerList.length);
		    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
		    {
		    	if (IsElementIntoSelectionArea(ResourceConainerList[vvi],elementSelectorRect))
		    	{
		    		ResourceConainerList[vvi].style.backgroundColor = "lime";
		    		document.getElementById(ResourceConainerList[vvi].id.replace("CONTENT_","SELECTMEMO_")).value="Y";
		    	}else
		    	{
		    		ResourceConainerList[vvi].style.backgroundColor = "lightgrey";
		    		document.getElementById(ResourceConainerList[vvi].id.replace("CONTENT_","SELECTMEMO_")).value="N";
		    	}
		    }
		}
		//alert('moved');
}

function fileBroserFileSelectionReset(FilesListGeneratorIdIn)
{
    var ResourceConainerList 		= $(document.getElementById(FilesListGeneratorIdIn)).find(".resourceelement");
	    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
	    {
	    	ResourceConainerList[vvi].style.backgroundColor= "lightgrey";
			document.getElementById(ResourceConainerList[vvi].id.replace("CONTENT_","SELECTMEMO_")).value="N";
	    }
}
/////////////END/////////////////////FS MOUSE SELECTION///////////////////////////


function IsElementIntoSelectionArea_old(elementIn,ElementSelectorRectIn)
{
	var output= true;
	 
	var elementTestRect = elementIn.getBoundingClientRect();
	
		//alert('elementTestRect.left : '+elementTestRect.left+' elementTestRect.right '+elementTestRect.right+' elementTestRect.top :'+elementTestRect.top+' elementTestRect.bottom : '+elementTestRect.bottom);
		if 
			(
				//test X
				(elementTestRect.right<ElementSelectorRectIn.left)
				||
				(ElementSelectorRectIn.right<elementTestRect.left)
				||
				//test Y
				(elementTestRect.bottom<ElementSelectorRectIn.top)
				||
				(ElementSelectorRectIn.bottom<elementTestRect.top)
			)
		{
			output=  false;
		}
		$('#debugger_content').html("output:"+output);

		return output;
}

function disableSelect(el)
{			
									    if(el.addEventListener)
									    {
									        el.addEventListener("mousedown",disabler,"false");
									    }else 
									    {
									        el.attachEvent("onselectstart",disabler);
									    }
}
 
function enableSelect(el)
{
									    if(el.addEventListener)
									    {
									    	el.removeEventListener("mousedown",disabler,"false");
									    }else 
									    {
									        el.detachEvent("onselectstart",disabler);
									    }
}
 
//never called
function disabler(e)
{
									    if(e.preventDefault){ e.preventDefault(); }
									    return false;
}

function transferAnyAttribute(SourceElIn,TargetElIn)
{
										for (const name of SourceElIn.getAttributeNames()) 
										{
									  const value = SourceElIn.getAttribute(name);
									  		//console.log("  trasferring name:"+name+"  value:"+value+"		TargetElIn.id:"+	TargetElIn.id);
									  		jQuery(TargetElIn).attr(name,value);
										}
}

function setPageTitle(valIn)
{
	    								//document.title = valIn;
}

function setUpModernGraphicHTMLExtenders()
{
		jQuery('.ComponentsTagExtenders-EnhancedComboBox').each(
			function()
			{
				if (jQuery(this).find('.fa-solid').length==0)
				{
					if (!jQuery(this).hasClass("disabled"))
					{
						
				var		TE_el_height 				= jQuery(jQuery(this).find('.ComponentsTagExtenders-EnhancedComboBox-ccontent')[0]).height();
				
				var		hasTrigger 					= false;
				var 	trigger_el 					= document.getElementById (this.id+ "trigger|");
						if (
							jQuery(trigger_el).is(":visible")
							&&
							(jQuery(trigger_el).css("display")!='none')
						)
						{
	/*						jQuery(trigger_el).css("visibility","hidden");
							jQuery(trigger_el).css("display","none");
	*/					
						var trigger_el_id 			=  trigger_el.id;	
							//jQuery(trigger_el).detach();
							jQuery(trigger_el).replaceWith("<i id = '"+trigger_el_id+"' class='fa-solid fa-bars' style='position:absolute;top:0;right:0;color:black;line-height:"+TE_el_height+"px;font-size:20px;cursor:pointer;' ></i>");
							hasTrigger				= true;
						}
						
				var 	resetter_el 				= 	document.getElementById (this.id+ "resetter|");
						if (
							jQuery(resetter_el).is(":visible")
							&&
							(jQuery(resetter_el).css("display")!='none')
							&&
							(!jQuery(this).hasClass("customresetter") )
						)
						{
							//jQuery(resetter_el).css("visibility","hidden");
							//jQuery(resetter_el).css("display","none");
											
							jQuery(resetter_el).css("background-image","none");
							jQuery(resetter_el).css("background-color","transparent");
							jQuery(resetter_el).css("margin","none");
							jQuery(resetter_el).css("margin-top","0");
						var bias_right 				= 0; 
							if (hasTrigger){bias_right = 20;}
							jQuery(resetter_el).css("right",bias_right+"px");
							jQuery(resetter_el).css("width","20px");
							jQuery(resetter_el).css("height",TE_el_height+"px");
							jQuery(resetter_el).css("top","0px");
							
							jQuery(resetter_el).before("<i class='fa-solid fa-xmark' style='position:absolute;top:0;right:"+bias_right+"px;color:red;line-height:"+TE_el_height+"px;font-size:25px;cursor:pointer;' ></i>");
						}
					}			
				}
			}
		);
		
		jQuery('.ComponentsTagExtenders-EnhancedInput').each(
			function()
			{
		var		resetter_shift				= 0;
		var		TE_el_height 				= jQuery(this).height();
		var 	MoreChooser_el 				= document.getElementById (this.id+ "MoreChooser|");
		var 	DataResetter_el 			= document.getElementById (this.id+ "DataResetter|");
		
				if (
					jQuery(MoreChooser_el).is(":visible")
					&&
					(jQuery(MoreChooser_el).css("display")!='none')
				)
				{
					resetter_shift 			= TE_el_height+4;
					jQuery(MoreChooser_el).css("background-image","none");
					jQuery(MoreChooser_el).css("background-color","transparent");
					if (jQuery(this).find('.fa-solid.fa-ellipsis').length==0)
					{
						jQuery(MoreChooser_el).before("<i class='fa-solid fa-ellipsis' style='position:absolute;top:0;right:0px;color:red;line-height:"+TE_el_height+"px;font-size:22px;cursor:pointer;' ></i>");
					}
				}
				if (
					jQuery(DataResetter_el).is(":visible")
					&&
					(jQuery(DataResetter_el).css("display")!='none')
				)
				{
					jQuery(DataResetter_el).css("background-image","none");
					jQuery(DataResetter_el).css("background-color","transparent");
					jQuery(DataResetter_el).css("right",resetter_shift+"px");
					if (jQuery(this).find('.fa-solid.fa-xmark').length==0)
					{
						jQuery(DataResetter_el).before("<i class='fa-solid fa-xmark' style='position:absolute;top:0;right:"+resetter_shift+"px;color:red;line-height:"+TE_el_height+"px;font-size:22px;cursor:pointer;border:none;' ></i>");
					}
				}
			}		
		);
		
		
		jQuery('.ComponentsTagExtenders-WindowHandlerCommander').each(
			function()
			{
				
				if (jQuery(this).find('.fa-solid').length==0)
				{
			var		TE_el_height 				= jQuery(this).height();
			var		xright						= 4;
			var 	close_el 					= document.getElementById(this.id+ "close|");
					if (isValidElement(close_el))
					{
						jQuery(close_el).css("width",TE_el_height+"px");
						jQuery(close_el).css("height",TE_el_height+"px");
						jQuery(close_el).css("border","1px solid red");
						jQuery(close_el).css("right",xright+"px");
						jQuery(close_el).css("visibility","hidden");
						
						jQuery(this).append("<i class='fa-solid fa-xmark' style='cursor:pointer;position:absolute;top:0;height:"+TE_el_height+"px;line-height:"+TE_el_height+"px;right:"+xright+"px;width:"+TE_el_height+"px;font-size:130%;'></i>");
						
					}
			var 	multiplewindows_el 			= document.getElementById (this.id+ "multiplewindows|");
					if (isValidElement(multiplewindows_el))
					{
						xright+= 4+TE_el_height;
						jQuery(multiplewindows_el).css("width",TE_el_height+"px");
						jQuery(multiplewindows_el).css("height",TE_el_height+"px");
						jQuery(multiplewindows_el).css("border","1px solid red");
						jQuery(multiplewindows_el).removeAttr("src");
						jQuery(multiplewindows_el).css("right",xright+"px");
						jQuery(multiplewindows_el).css("visibility","hidden");
						jQuery(this).append("<i class='fa-solid fa-window-restore' style='cursor:pointer;position:absolute;top:0;height:"+TE_el_height+"px;line-height:"+TE_el_height+"px;right:"+xright+"px;width:"+TE_el_height+"px;font-size:130%;'></i>");
					}
					
			var 	fullscreen_el 			= document.getElementById (this.id+ "fullscreen|");
					if (isValidElement(fullscreen_el))
					{
						xright+= 4+TE_el_height;
						jQuery(fullscreen_el).css("width",TE_el_height+"px");
						jQuery(fullscreen_el).css("height",TE_el_height+"px");
						jQuery(fullscreen_el).css("border","1px solid red");
						jQuery(fullscreen_el).removeAttr("src");
						jQuery(fullscreen_el).css("right",xright+"px");
						jQuery(fullscreen_el).css("visibility","hidden");
						jQuery(this).append("<i class='fa-solid fa-window-maximize' style='cursor:pointer;position:absolute;top:0;height:"+TE_el_height+"px;line-height:"+TE_el_height+"px;right:"+xright+"px;width:"+TE_el_height+"px;font-size:130%;'></i>");
					}					
				}
				jQuery(this).find('.fa-window-restore').off("mousedown");
				jQuery(this).find('.fa-window-restore').on("mousedown",function(e){
				var 	SW_el 				= getSWOwner(e.target);
				//var 	SW_type 			= jQuery(SW_el).attr('owner_family').replaceAll('-','.');;	
				var 	my_TE_el 			= getTEOwner(e.target);		
				var 	multiplewindows_el  = document.getElementById(my_TE_el.id+'multiplewindows|');
				var		dummyMouseDown 		= new customEventGenerate('mousedown',multiplewindows_el);
					 	CAclient(SW_el.id,multiplewindows_el,dummyMouseDown,'applicationModel.HTMLEnhancedTagExtension'," !@@PPFEEDBACKACTION@@! !@@VVSENDDATA@@! ",false);
				});
				jQuery(this).find('.fa-door-open').off("mousedown");
				jQuery(this).find('.fa-door-open').on("mousedown",function(e){
				var 	SW_el 				= getSWOwner(e.target);
				//var 	SW_type 			= jQuery(SW_el).attr('owner_family').replaceAll('-','.');;	
				var 	my_TE_el 			= getTEOwner(e.target);		
				var 	close_el  			= document.getElementById(my_TE_el.id+'close|');
				var		dummyMouseDown 		= new customEventGenerate('mousedown',close_el);
					 	CAclient(SW_el.id,close_el,dummyMouseDown,'applicationModel.HTMLEnhancedTagExtension'," !@@PPFEEDBACKACTION@@! !@@VVSENDDATA@@! ",false);
				});
				
				jQuery(this).find('.fa-xmark').off("mousedown");
				jQuery(this).find('.fa-xmark').on("mousedown",function(e){
				var 	SW_el 				= getSWOwner(e.target);
				//var 	SW_type 			= jQuery(SW_el).attr('owner_family').replaceAll('-','.');;	
				var 	my_TE_el 			= getTEOwner(e.target);		
				var 	close_el  			= document.getElementById(my_TE_el.id+'close|');
				var		dummyMouseDown 		= new customEventGenerate('mousedown',close_el);
					 	CAclient(SW_el.id,close_el,dummyMouseDown,'applicationModel.HTMLEnhancedTagExtension'," !@@PPFEEDBACKACTION@@! !@@VVSENDDATA@@! ",false);
				});
				
				jQuery(this).find('.fa-window-maximize').off("mousedown");
				jQuery(this).find('.fa-window-maximize').on("mousedown",function(e){
				var 	SW_el 				= getSWOwner(e.target);
				//var 	SW_type 			= jQuery(SW_el).attr('owner_family').replaceAll('-','.');;	
				var 	my_TE_el 			= getTEOwner(e.target);		
				var 	fullscreen_el  		= document.getElementById(my_TE_el.id+'fullscreen|');
				var		dummyMouseDown 		= new customEventGenerate('mousedown',fullscreen_el);
					 	CAclient(SW_el.id,fullscreen_el,dummyMouseDown,'applicationModel.HTMLEnhancedTagExtension'," !@@PPFEEDBACKACTION@@! !@@VVSENDDATA@@! ",false);
				});
			}		
		);

}

function SetupSearchGroupSelects(IdentifierIn)
{
	var mySW = document.getElementById(IdentifierIn);
		jQuery(mySW).find(".SearchFieldsSelect").each( function(){SearchSegments(this);});
}

function randomNumber(min, max) 
{
	  									return Math.floor(Math.random() * (max - min)) + min;
}

function getCookie(name) 
{
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCookie(name,value,days) 
{
    var expires = "";
	    if (days) 
	    {
	    var date = new Date();
	        date.setTime(date.getTime() + (days*24*60*60*1000));
	        expires = "; expires=" + date.toUTCString();
	    }
	var cookieContent = name + "=" + (value || "")  + expires + "; SameSite=Lax ; path=/";   
	    document.cookie = cookieContent;
	    //console.log("writing cookie:"+cookieContent);
}

function printDateFull()
{
				var currentdate = new Date(); 
				var datetime = "Last Sync: " + currentdate.getDate() + "/"
                + (currentdate.getMonth()+1)  + "/" 
                + currentdate.getFullYear() + " @ "  
                + currentdate.getHours() + ":"  
                + currentdate.getMinutes() + ":" 
                + currentdate.getSeconds();
				//console.log('time:'+datetime);
}

function removePageObjToken()
{
		sessionStorage.clear();
		window.name = "";
}

function storePageObjToken(uuid)
{
		sessionStorage.setItem("pageobjtoken",uuid);
		window.name = uuid;
}

function retrievePageObjToken()
{
	var	out = sessionStorage.getItem("pageobjtoken");
	//var out =window.name;
		if(out===null) out = "";
		if(out==null) out = "";
		if (window.name.length>0) 
		{
			out = window.name;
		} 
		return out;
}

function providePageObjToken()
{
		if (retrievePageObjToken().length==0 )
		{
			storePageObjToken(createUUID());
		}
		return retrievePageObjToken();
}

function storeStep(stepIn)
{
	var step_key = url_store_helper()+"_"+retrievepageName()+"_step";
		removesessionStorageItems(retrievepageName());
		sessionStorage.setItem(step_key,stepIn);
}

function retrieveStep()
{
	var step_key = url_store_helper()+"_"+retrievepageName()+"_step";
	var	out = sessionStorage.getItem(step_key);
		if (out!= null && out.length>0) removesessionStorageItems(retrievepageName());
		return out;
}

function retrieveCookieChoice()
{
const 									cookieNotice = localStorage.getItem("e9a6b634d4be4afeb98c6276a7ea53dd_cookieNotice") ?? "none";
										return cookieNotice;
}

function setCookieChoice(valueIn)
{
										localStorage.setItem("e9a6b634d4be4afeb98c6276a7ea53dd_cookieNotice",valueIn);
}

function removesessionStorageItems(excludingPageName) 
{
	//console_log('_______________________remove session storage step counters excluding page name:'+excludingPageName);
    const keysToRemove = [];
    
    for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        //console.log('key:'+key);
        if (key && key.endsWith('_step') && !key.includes(excludingPageName)) 
        {
            keysToRemove.push(key);
        }
    }
    
    keysToRemove.forEach(key => {
        sessionStorage.removeItem(key);
    });
    
    //console.log(`Rimossi ${keysToRemove.length} item dal localStorage`);
    return keysToRemove.length;
}

function url_store_helper()
{
	const currentUrl = window.location.href;
    
    // Create URL object for easy parsing
    const url = new URL(currentUrl);
    
    // Extract hostname and pathname
    let formatted = url.hostname + url.pathname;
    
    // Remove trailing slash if present
    if (formatted.endsWith('/')) {
        formatted = formatted.slice(0, -1);
    }
    
    // Replace all forward slashes with underscores
    formatted = formatted.replace(/\//g, '_');
    return formatted;
}

function retrievepageName()
{
		var 		url 							= window.location.origin + window.location.pathname;
		var 		url_tokens 						= url.split('/');
		var 		pagename 						= url_tokens[url_tokens.length-1];
					pagename 						= pagename.replace('.jsp','');
					return pagename;
}

function storePageTitle()
{
					//alert("storing title:"+document.title);
					sessionStorage.setItem("pagetitle",document.title);
					//alert("stored title:"+sessionStorage.getItem("pagetitle"));
}

function fillReloadPage()
{
					//console.log(new Error());
					//var request_context_path 					= jQuery(document.body).attr('request_context_path');
					//dynamicallyLoadLibrary(request_context_path+'/js/SessionGuidance.js');


					
					
		var 		refreshDisclaimerEng 					= "Refreshing page?";
					
		var 		refreshDisclaimer 						= "Aggiornamento pagina?";
					jQuery(document.body).html(
						"<br>"+
						"<br>"+
						"<br>"+
						" <span style='position:absolute;top:100px;left:5%;width:300px;font-size:18px;font-family:arial;font-weight:600;color:green;'>"+refreshDisclaimerEng+"</span>"+
						"<br>"+
						"<br>"+
						"<br>"+
						" <div id='button_refresh_ita'  class='button_scheda button_refresh_group' style='position:absolute;top:100px;left:30%;height:25px;width:200px;color:white;border:1px solid blue;font-family:arial;font-weight:600;background-color:blue;border-radius:3px;cursor:pointer;text-align:center;'  ><span style='width:100%;position:absolute;left:0;right:0;top:0;bottom:0;line-height:25px;'>Page refresh</span></div>"+
						" <div id='button_close_eng'   	class='button_scheda button_close_group' style='position:absolute;top:100px;left:50%;height:25px;width:200px;color:white;border:1px solid blue;font-family:arial;font-weight:600;background-color:blue;border-radius:3px;cursor:pointer;text-align:center;' ><span style='width:100%;position:absolute;left:0;right:0;top:0;bottom:0;line-height:25px;'>Leave</span></div>"+
						"<br>"+
						"<br>"+
						"<br>"+
						"<div style='position:absolute;top:275px;width:40%;left:15%;height:0px;border:1px solid lightblue;'></div>"+
						" <span style='position:absolute;top:425px;left:5%;width:300px;font-size:18px;font-family:arial;font-weight:600;color:green;'>"+refreshDisclaimer+"</span>"+
						"<br>"+
						"<br>"+
						"<br>"+
						" <div id='button_refresh_ita'    class='button_scheda button_refresh_group' style='position:absolute;top:425px;left:30%;height:25px;width:200px;color:white;border:1px solid blue;font-family:arial;font-weight:600;background-color:blue;border-radius:3px;cursor:pointer;text-align:center;' ><span style='width:100%;position:absolute;left:0;right:0;top:0;bottom:0;line-height:25px;'>Aggiornamento pagina</span></div>"+
						" <div id='button_close_eng'      class='button_scheda button_close_group'   style='position:absolute;top:425px;left:50%;height:25px;width:200px;color:white;border:1px solid blue;font-family:arial;font-weight:600;background-color:blue;border-radius:3px;cursor:pointer;text-align:center;' ><span style='width:100%;position:absolute;left:0;right:0;top:0;bottom:0;line-height:25px;'>Uscita</span></div>"
					); 
					
					jQuery('.button_refresh_group').on("mousedown",function(){
						//reloadPageExecute('',retrievePageObjToken());
					var 	StartUpForm_el =  setStartUpForm();
							jQuery('#startupform_querystring').val('drawagain=Y');
							jQuery('#startupform_pageobjtoken').val(providePageObjToken());
							jQuery(StartUpForm_el).submit();	
					});
					jQuery('.button_close_group').on("mousedown",
						function()
						{
							SessionInvalidate();
							jQuery(document.body).html(
								"<br><br><br><br><span style='font-family:arial;font-size:18px;font-weight:600;color:green;margin-left:10%;'>Click&nbsp;&nbsp;<a href='"+window.location.origin + window.location.pathname+"' style='color:#0073e6;'>here</a>&nbsp;&nbsp;to open a new page </span>"+
								"<br><br><br><br><span style='font-family:arial;font-size:18px;font-weight:600;color:green;margin-left:10%;'>Click&nbsp;&nbsp;<a href='"+window.location.origin + window.location.pathname+"' style='color:#0073e6;'>qui</a>&nbsp;&nbsp;per aprire una nuova pagina </span>"
							);	
						}
					);
					
}

function dhm (ms) {
  const days = Math.floor(ms / (24*60*60*1000));
  const daysms = ms % (24*60*60*1000);
  const hours = Math.floor(daysms / (60*60*1000));
  const hoursms = ms % (60*60*1000);
  const minutes = Math.floor(hoursms / (60*1000));
  const minutesms = ms % (60*1000);
  const sec = Math.floor(minutesms / 1000);
  var 	result = [];
  		result.push(days);
  		result.push(hours);
  		result.push(minutes);
  		result.push(sec);
  		
  		return result;
}

function getPosition(e) 
{
    	e = e || window.event;
    var cursor = {x:0, y:0};
	    if (e.pageX || e.pageY) 
	    {
	        cursor.x = e.pageX;
	        cursor.y = e.pageY;
	    } 
	    else 
	    {
	    var de = document.documentElement;
	    var b = document.body;
	        cursor.x = e.clientX +  (de.scrollLeft || b.scrollLeft) - (de.clientLeft || 0);
	        cursor.y = e.clientY +  (de.scrollTop || b.scrollTop) - (de.clientTop || 0);
    	}
    	return cursor;
}

function drawClientActions(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn,CAclient_StateIn,texttoshow)
{
										if (
											  (eventIn.type!="mousemove")
											&&(eventIn.type!="mouseleave")
											&&(eventIn.type!="mouseenter")
											&&(eventIn.type!="mouseover")
											&&(eventIn.type.indexOf('SCROLL')==-1) 
											&&(eventIn.type!='pagedrawend') 
											&&(eventIn.type!='datasend') 
										) 
										{
											console.log('##drawClientActions## '+texttoshow+" STATE:"+CAclient_StateIn+' IdentifierIn:'+IdentifierIn+' eventIn.type:'+eventIn.type+' elementIn.id:'+elementIn.id);
										}
}

function hasWidthStyle($element, checkType) 
{
    checkType = checkType || 'any'; // 'inline', 'computed', or 'any'
    
    switch(checkType) {
        case 'inline':
            // Check only inline style attribute
            var style = jQuery(element).attr('style');
            return !!(style && /\bwidth\s*:/i.test(style));
            
        case 'computed':
            // Check computed/current width value
            var width = jQuery(element).css('width');
            return !!(width && width !== 'auto');
            
        case 'any':
        default:
            // Check either inline or computed
            var inlineStyle = jQuery(element).attr('style');
            var computedWidth = jQuery(element).css('width');
            return (
                (inlineStyle && /\bwidth\s*:/i.test(inlineStyle)) ||
                (computedWidth && computedWidth !== 'auto')
            );
    }
}

function hasHeightStyle(element, checkType) 
{
    checkType = checkType || 'any'; // 'inline', 'computed', or 'any'
    
    switch(checkType) {
        case 'inline':
            // Check only inline style attribute
            var style = jQuery(element).attr('style');
            return !!(style && /\bwidth\s*:/i.test(style));
            
        case 'computed':
            // Check computed/current width value
            var width = jQuery(element).css('width');
            return !!(width && width !== 'auto');
            
        case 'any':
        default:
            // Check either inline or computed
            var inlineStyle = jQuery(element).attr('style');
            var computedWidth = jQuery(element).css('width');
            return (
                (inlineStyle && /\bwidth\s*:/i.test(inlineStyle)) ||
                (computedWidth && computedWidth !== 'auto')
            );
    }
}

function addToSessionLog(chunk, options = {}) 
{
    const {
        maxEntries = 100,        // Maximum number of entries to keep
        key = 'sessionLog',       // Custom storage key
        format = 'iso'           // 'iso', 'locale', or 'timestamp'
    } = options;
    
    // Format timestamp
    let timestamp;
    switch(format) {
        case 'locale':
            timestamp = new Date().toLocaleString();
            break;
        case 'timestamp':
            timestamp = Date.now();
            break;
        default:
            timestamp = new Date().toISOString();
    }
    
    const timestampedChunk = `[${timestamp}] ${chunk}`;
    
    // Get existing log
    let log = sessionStorage.getItem(key);
    let logArray = log ? JSON.parse(log) : [];
    
    // Add new chunk
    logArray.push(timestampedChunk);
    
    // Limit number of entries (optional)
    if (logArray.length > maxEntries) {
        logArray = logArray.slice(-maxEntries);
    }
    
    // Save back to sessionStorage
    sessionStorage.setItem(key, JSON.stringify(logArray));
    
    return logArray;
}let	redirectHandler = null;

var backHandler = null;

var isBrowserActionIntercept = false;


/**
 * Do not force replace for execution speed.
 * To replace script use addScript java method in SubWindow Class
 */
function dynamicallyLoadLibrary(urlIn)
{
	var found 				= jQuery('head').find("script[src^='" + urlIn +"']");
		if (found.length==0)
		{
		var d 				= new Date();
		var ms 				= d.getTime();
		var tqs 			= "?v="+ms;
			urlIn 			= urlIn+tqs;
			jQuery('head').append("<script  src='"+urlIn+"'></script>");
			console_log('loaded js library '+urlIn);
		}	
		else
		{
			console.log("dynamicallyLoadLibrary. found script code "+urlIn);
		}
}

/**
 * Do not force replace for execution speed.
 */
function dynamicallyLoadStyleSheet(urlIn)
{
	var found =jQuery('head').find("link[href^='" + urlIn +"']");
		if (found.length==0)
		{
		var d 				= new Date();
		var ms 				= d.getTime();
		var tqs 			= "?v="+ms;
			urlIn 			= urlIn+tqs;
			jQuery('head').append(
				
				"<link rel='stylesheet' href='"+urlIn+"' >"
			);
		}	else
		{
			console.log("found stylesheet code "+urlIn);
		}
}

/**
 * Do not force replace for execution speed.
 */
function dynamicallyLoadFontAwesome(urlIn)
{
	var found =jQuery('head').find("link[href^='" + urlIn +"']");
		if (found.length==0)
		{
		var d 				= new Date();
		var ms 				= d.getTime();
		var tqs 			= "?v="+ms;
			urlIn 			= urlIn+tqs;
			jQuery('head').append(
				
				"<link rel='stylesheet' href='"+urlIn+"' referrerpolicy='no-referrer' >"
			);
		}	else
		{
			console.log("found FontAwesome code "+urlIn);
		}
}


/*
 * called by server incoming js command only when nedded.
 */
function dynamicallyLoadJSModule(CodeIn)
{
			var Mypageobjtoken																										= $(document.body).attr('pageobjtoken');
			var Mypagename																											= $(document.body).attr('pagename');
			var SessionPageFullName																									= Mypageobjtoken+"_"+Mypagename;		
			var	data_pagechunk																										= 'sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+Mypagename+'&';

	var 		modulesQueryString = '?'+data_pagechunk+'code='+CodeIn;
				jQuery('head').append("<script  src='JSModuleProvider"+modulesQueryString+"' type='module' ></script>");
}

function dynamicallyLoadPdfModule()
{
	var request_context_path 					= jQuery(document.body).attr('request_context_path');
	var found =jQuery('head').find("script[src='" + request_context_path +"/js/pdfjsN/build/pdf.mjs']");
		if (found.length==0)
		{
			jQuery('head').append("<script class='pdfjsNmodule' src='"+request_context_path+"/js/pdfjsN/build/pdf.mjs' type='module' ></script>");
		}
}

function setStartUpForm()
{
					if (!isValidElement(document.getElementById("startupform")))
					{
		var 			pagename 						= retrievepageName();
		
		var 			form 							= document.createElement("form");
						form.style.height				= "200px";
						form.style.width				= "200px";
						form.style.backgroundColor		= "red";
						form.setAttribute("id", "startupform");
						form.setAttribute("method", "post");
						form.setAttribute("action", pagename);
					    //form.style.visibility			= "hidden";
					    //form.setAttribute("target", "chat");
					    jQuery(form).addClass('startupformclass');
			
				    	//Hidden Field
		var		    	hiddenField_pageobjtoken 		= document.createElement("input");
					    hiddenField_pageobjtoken.setAttribute("name" 	, "startupform_pageobjtoken");
					    hiddenField_pageobjtoken.setAttribute("id" 		, "startupform_pageobjtoken");
					    form.appendChild(hiddenField_pageobjtoken);
					    
		var				hiddenField_querystring 		= document.createElement("input");
						hiddenField_querystring.setAttribute("name" 	, "startupform_querystring");
					    hiddenField_querystring.setAttribute("id" 		, "startupform_querystring");
					    form.appendChild(hiddenField_querystring);
					    
					    document.body.appendChild(form);
					}
					 
				var outForm = document.getElementById('startupform');
					jQuery('#startupform_querystring').val("");
			return  outForm;
}

function StartUpSequenceM2()
{
	var 	out_cmd 								= 'none';
	
	var 	StepIn 									= retrieveStep();
	
	var    	startupform_querystring_data 			= getStartupformQuerystringInfo();
	
	var 	is_afterstartupform 					= jQuery(document.body).attr('afterstartupform') === 'true';
			
	const 	navInfo 								= getNavigationInfo();
			//not main information and if not available a fallabck is predefined
			//Should be checked against multiple browsers and sysstems
		
			if (isNaN(StepIn)||(!isValidElement(StepIn))) StepIn = 0;
	var 	StartUpForm_el 							=  setStartUpForm();
			jQuery(document.body).attr('afterstartupform','false');
			jQuery(document.body).attr('startupform_querystring','');
			setContextPath(jQuery(document.body).attr('request_context_path'));

			
			if ((window.location.search.length>0)&&(!startupform_querystring_data.containsDrawagain))
			{
				jQuery('#startupform_querystring').val(location.search.replace('?',''));
				jQuery('#startupform_pageobjtoken').val(providePageObjToken());
				out_cmd 							=  'immediate_reload';
			}
			
			//alert('StepIn:'+StepIn+'  is_afterstartupform:'+is_afterstartupform+' startupform_querystring_data containsDrawagain:'+startupform_querystring_data.containsDrawagain+' navInfo:'+navInfo.type);
			
			sendAndForget(' StartUpSequenceM2 StepIn:'+StepIn+'  is_afterstartupform:'+is_afterstartupform+' startupform_querystring_data containsDrawagain:'+startupform_querystring_data.containsDrawagain+' navInfo:'+navInfo.type);

			//StepIn will be modified only if not an 'immediate_reload' is performed
			if (out_cmd != 'immediate_reload' )
			{
				//1) PRIMA APERTURA PAGINA NO QS
				if ((!is_afterstartupform)&&(StepIn==0)&&(!startupform_querystring_data.containsDrawagain)) 
				{//NOT increase Step
				 //first page or parameters passed in query string 
					//alert("1 nav info:"+navInfo.type);	
					out_cmd ='first_load';
				} else
				//2) PRIMA APERTURA PAGINA CON QS
				if ((is_afterstartupform)&&(StepIn==0)&&(!startupform_querystring_data.containsDrawagain))
				{// increase Step
					//alert("2");					
					out_cmd ='first_load';
				} else
				//3) CHIAMATO TASTO RELOAD DA UTENTE OPPURE RICHIAMO PAGINA MEDIANTE INVIO SULLA URL SENZA DATI INTEGRATIVI PRESENTI NELLA QS
				if ((!is_afterstartupform)&&(StepIn>0)&&(!startupform_querystring_data.containsDrawagain))
				{
					if (navInfo.type == 'navigate')
					{
						out_cmd ='further_load';
						out_cmd ='courtesy_draw';
					} else
					if (navInfo.type == 'reload')
					{
						out_cmd ='courtesy_draw';
					} else
					{
						out_cmd ='courtesy_draw';
					}
					//alert("3 out_cmd:"+out_cmd);
					sendAndForget('StepIn:'+StepIn+" - 3 out_cmd:"+out_cmd);					
				} else
				//4) RITORNO DA PAGINA DI CORTESIA RELOAD
				if (startupform_querystring_data.containsDrawagain)
				{
					out_cmd ='further_load';
					//alert("4");					
				} else
				//5) RICHIAMO PAGINA MEDIANTE QS CON DATI INTEGRATIVI
				if ((is_afterstartupform)&&(StepIn>0)&&(startupform_querystring_data.length>0))
				{
					out_cmd ='further_load';
					//alert("5");					
				} else
				//7) RICHIAMO PAGINA MEDIANTE POST
				if (is_afterstartupform)
				{
					//alert("7");					
				}

				/*
		var    	startupform_querystring 			= jQuery(document.body).attr('startupform_querystring');
				//alert('startupform_querystring:'+startupform_querystring);
				
				++ StepIn;
				storeStep(StepIn);
				//console.log('navInfo');
				//console.log(navInfo);
				if (navInfo.type == 'navigate')
				{
					
					
					if ( (isValidElement(startupform_querystring))&&(startupform_querystring.indexOf('drawagain')>-1) )
					{
						StepIn=1;
						storeStep(StepIn);
						out_cmd ='first_load';
					} else
					if(is_afterstartupform)
					{
						StepIn=1;
						storeStep(StepIn);
						out_cmd ='first_load';
						alert('BBBB ');						
					} else
					{
						if (StepIn==1) {out_cmd ='first_load';}
						if (StepIn>1)  {out_cmd ='successive_load';}
					}
				} else
				if (navInfo.type == 'reload')
				{
					out_cmd = 'called_manual_reload';
				} else
				if (navInfo.type == 'back_forward')
				{
					out_cmd = 'called_manual_reload';
				}
				*/
			}

			//alert('   out_cmd:'+out_cmd );
			sendAndForget('StepIn:'+StepIn+" BEFORE EXECUTE COMMANDS out_cmd:"+out_cmd);					
			
			/** EXECUTE COMMANDS****/
			if (navInfo.type == 'back_forward')
			{
				
			} else
			if (out_cmd == 'called_manual_reload') 
			{
				//window.location.href = 'http://localhost:9090/webapp/refreshwarning.jsp?callerpage='+retrievepageName();
				window.location.href = ContextPath+ '/refreshwarning.jsp?callerpage='+retrievepageName();
			} else	
			if (out_cmd == 'first_load') 
			{
				/*
				history.replaceState({ progressive: 1 }, '', null);
				history.pushState({ progressive: 2 }, '', null);
				history.pushState({ progressive: 3 }, '', null);
				history.pushState({ progressive: 4 }, '', null);
				history.pushState({ progressive: 5 }, '', null);
				history.pushState({ progressive: 6 }, '', null);
				history.pushState({ progressive: 7 }, '', null);
				history.pushState({ progressive: 8 }, '', null);
				history.pushState({ progressive: 9 }, '', null);
				history.pushState({ progressive: 10 }, '', null);
				*/				
				storeStep(Number(StepIn) +1) ;
			var	data							= 'Step='+StepIn+'&cookiechoice='+retrieveCookieChoice()+'&'+getDeviceString()+'sessionpagefullname='+providePageObjToken()+"_"+retrievepageName()+'&pageobjtoken='+retrievePageObjToken()+'&pagename='+retrievepageName()+'&'+startupform_querystring_data.value+"&first_load=Y&further_load=N&qsmoredata="+(startupform_querystring_data.length>0?"Y":"N");
				ServerStateImplement(true,data);
			} else
			if (out_cmd == 'further_load') 
			{
				storeStep(Number(StepIn) +1);

			var	data							= 'Step='+StepIn+'&cookiechoice='+retrieveCookieChoice()+'&'+getDeviceString()+'sessionpagefullname='+providePageObjToken()+"_"+retrievepageName()+'&pageobjtoken='+retrievePageObjToken()+'&pagename='+retrievepageName()+'&'+startupform_querystring_data.value+ "&first_load=N&further_load=Y&qsmoredata="+(startupform_querystring_data.length>0?"Y":"N");
				ServerStateImplement(true,data);				
			} else
			if (out_cmd == 'courtesy_draw') 
			{
				fillReloadPage();
			} else
			if (out_cmd == 'immediate_reload') 
			{
			var StartUpForm_el 						= document.getElementById('startupform');
				jQuery(StartUpForm_el).submit();	
			}
}

function loadjQuery()
{
	const script = document.createElement("script");
	script.src = 'js/jq/jquery-3.7.1.min.js';
	script.type = 'text/javascript';
	document.head.appendChild(script);
}


function getStartupformQuerystringInfo() 
{
var value = jQuery(document.body).attr('startupform_querystring') || '';

    return {
        value: value,
        length: value.length,
        containsDrawagain: value.indexOf('drawagain') !== -1 ? true : false
    };
}

function getNavigationInfo()
{
const performance = window.performance || window.webkitPerformance || window.msPerformance || window.mozPerformance;
    
    const navigationEntries = performance.getEntriesByType('navigation');
   const referrer = document.referrer;
var currentUrl = window.location.href;
    if (navigationEntries.length === 0) 
    {
        return { type: 'unknown', lastUrl: referrer, currentUrl: currentUrl };
    }
    
    const navEntry = navigationEntries[0];
    var navType = "unknown";
    switch(navEntry.type) {
        case 'navigate':
            navType = 'new_navigation'; // Navigazione da altro URL
        case 'reload':
            navType = 'reload'; // Ricarica pagina
        case 'back_forward':
            navType = 'back_forward'; // Navigazione history
        case 'prerender':
            navType = 'prerender'; // Pagina pre-renderizzata
        default:
            navType = 'unknown';
    }
    const result = {
        type: navEntry.type,
        typeReadable: navType,
        currentUrl: currentUrl,
        lastUrl: referrer, // Questo è l'URL di provenienza
        isSameOrigin: referrer.startsWith(window.location.origin),
        navigationDetails: {
            redirectCount: navEntry.redirectCount,
            loadTime: navEntry.duration
        }
    };
    return result;
    
    //return { type: 'unknown', lastUrl: 'kkk', currentUrl: 'currentUrl' };

}



const intervalId = setInterval(() => {
	
/*	var disclaimer_progressive = "";
			if (history.state && history.state.progressive !== undefined) 
			{
				disclaimer_progressive=Number(history.state.progressive);
				if (history.state.progressive<10) {window.history.go(1);}
			} else
			{
				disclaimer_progressive = "NONE ";
				
			}
	if (jQuery(document.body).find('.debuggerpanel').length==0)
	{
		jQuery(document.body).append("<div class='debuggerpanel' style='position:absolute;top:0;left:0;font-size:44px;width:1px;height:1px;color:blue;z-index:20000;overflow:hidden;'></div>");
	}
	jQuery (".debuggerpanel").html("progressive:"+disclaimer_progressive);
	*/
	//	history.pushState(null, '', location.href);

	var currStep = retrieveStep();
		if (isNaN(currStep)||(!isValidElement(currStep)))
		{
			//console_log('forcing step to 1');
			storeStep(1);	
		}

}, 250);


     
function sendAndForget( data) {
    // Just fire the request and ignore everything
    //fetch( "JSPaux/logbyrequest.jsp?rowcontent=" +" "+Date.now()+" "+ data).catch(() => {});
}


/*
window.addEventListener('popstate', (event) => {
	alert('popstate! state:'+event.progressive+' history.length :'+history.length+' state content:'+JSON.stringify(event.state));
	

				history.pushState({ progressive: 21 }, '', null);
				history.pushState({ progressive: 22 }, '', null);
				history.pushState({ progressive: 23 }, '', null);
				history.pushState({ progressive: 24 }, '', null);
				history.pushState({ progressive: 25 }, '', null);
				history.pushState({ progressive: 26 }, '', null);
				history.pushState({ progressive: 27 }, '', null);
				history.pushState({ progressive: 28 }, '', null);
				history.pushState({ progressive: 29 }, '', null);
				history.pushState({ progressive: 30 }, '', null);
				
});
*/     



window.addEventListener('pageshow', (event) => {
  if (event.persisted) 
  {
    // Page restored from BFCache → force reload
    //alert("Page restored from BFCache");
    window.location.reload();
  }
});



sendAndForget("loading JS");

(function() {
    'use strict';
    
    // Method 1: History state management
    function pushHistoryStates() {
        // Push multiple states
        for (let i = 0; i < 5; i++) {
            history.pushState({ blocked: true }, '', window.location.href);
        }
    }
    
    // Method 2: Intercept popstate
    function interceptPopState() {
        window.addEventListener('popstate', function(e) {
            // Push new state forward
            history.pushState({ blocked: true }, '', window.location.href);
            
            // Force reload current page
            window.location.replace(window.location.href);
        });
    }
    
    // Method 3: Disable right-click (optional)
    function disableRightClick() {
        document.addEventListener('contextmenu', function(e) {
            e.preventDefault();
            return false;
        });
    }
    
    // Method 4: Monitor visibility
    function monitorVisibility() {
        let visibilityCount = 0;
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) {
                visibilityCount++;
                if (visibilityCount > 2) {
                    // User might be trying to use back button
                    setTimeout(() => {
                        if (document.hidden) {
                            window.location.replace(window.location.href);
                        }
                    }, 100);
                }
            }
        });
    }
    
    // Initialize all methods
    pushHistoryStates();
    interceptPopState();
    
    // Optional: uncomment if needed
    // disableRightClick();
    // monitorVisibility();
})();var LoginUname     						= ""; 
var LoginFirstName 						= "";
var LoginLastName  						= "";
var TimeSliderLength 					= 120;
var SliderAuthenticationShieldTreshold 	= 0.5;
var TimeSliderStep   					= 0;
var LastActionServerTime				= 0;
var LastCommunicatedServerTime 			= 0;
var ServerClientTimeBias				= 0;
var SessionTimingState					= null;
var SessionGuidanceUnavailabilities     = 0;
var messageWidth 						= 250;
var callserver_tolerace_s				= 30;
var session_status_from_server 			= '';
var server_status 						= '';
var session_id							= "";
var endsessionhtml 						= "";
//var server_endpoints_calls 				= [0,0,0,0]; //0:pingalive, 1:SessionGuidance


function loginFailShowMessage___(SWIdentifierIn,BackMessageIn)
{
										alert('_-_-_-_ loginFailShowMessage');
									var LoginBackMessage_Id 				= SWIdentifierIn+'LoginBackMessage|';
									var LoginBackMessage_element 			= document.getElementById(LoginBackMessage_Id);
									
								
									var PageTitleContainer_Id 				= SWIdentifierIn+'PageTitleContainer|';
									var PageTitleContainer_element 			= document.getElementById(PageTitleContainer_Id);
										alert("PageTitleContainer_element.id:"+PageTitleContainer_element.id);
								//	PageTitleContainer_element.style.top 	= "38.5%";
										PageTitleContainer_element.style.backgroundColor = "red";
										$(LoginBackMessage_element).html(BackMessageIn);
}

function loginFailShowMessage(SWIdentifierIn,BackMessageIn,unameIn,domainIn)
{
		//console_log("domainIn:"+domainIn);
		/*
	var uname_Id 							= SWIdentifierIn+'ameun|';
	var uname_element 			    		= document.getElementById(uname_Id);
		uname_element.setAttribute("value",unameIn);

	var password_Id 						= SWIdentifierIn+'password|';
	var password_element 					= document.getElementById(password_Id);
		password_element.setAttribute("value","");
	
	var LoginBackMessage_Id 				= SWIdentifierIn+'LoginBackMessage|';
	var LoginBackMessage_element 			= document.getElementById(LoginBackMessage_Id);
	//$(LoginBackMessage_element).html(BackMessageIn);
	//alert('LoginBackMessage_element.id : '+LoginBackMessage_element.id);
		LoginBackMessage_element.style.display	= 'block';
	
		$(LoginBackMessage_element).html(""+BackMessageIn);
		*/
		/*
	var PageTitleContainer_Id 				= SWIdentifierIn+'PageTitleContainer|';
	var PageTitleContainer_element 			= document.getElementById(PageTitleContainer_Id);
		//alert("PageTitleContainer_element.id:"+PageTitleContainer_element.id);
		if (PageTitleContainer_element!=null)
		{
			PageTitleContainer_element.style.top= "365px";
		}
		//PageTitleContainer_element.style.backgroundColor = "red";
		*/
}

function loginUserChange(UnameIn,FirstNameIn,LastNameIn)
{
										//console.log('loginUserChange.  UnameIn:'+UnameIn+' FirstNameIn:'+FirstNameIn+'  LastNameIn:'+LastNameIn);
										LoginUname     			= UnameIn;
										LoginFirstName 			= FirstNameIn;
										LoginLastName  			= LastNameIn;
								   		// ScreenSaverState	= 'disabled';
										SessionTimingState		= 'SCSA';
									var ILA_el = jQuery('.Components-InLineAuthenticator')[0];
										//console_log("ILA display:"+jQuery(ILA_el).css('display')+"  visibile:"+jQuery(ILA_el).is(":visible"));
										if 
										( 
											isValidElement(ILA_el)
											&&
											(
												(!jQuery(ILA_el).is(":visible"))
												||
												(!isValidElement(jQuery(ILA_el).css('display')))
												||
												(jQuery(ILA_el).css('display')=='none')
											)
										)
										{
											SessionTimingState		= 'IDLE';
										}
								  //  alert('Login. Uname: '+UnameIn+' FirstNameIn:'+FirstNameIn+' LastNameIn:'+LastNameIn);
}

function LogoCornerSetUserString()
{
										//alert('LogoCornerSetUserString. LoginFirstName:'+LoginFirstName+' LoginLastName:'+LoginLastName+'    LoginUaname:'+LoginUname);
									var StringOut   			= "";	
										if ((LoginFirstName!='null')&&(LoginLastName!='null'))
										{
											StringOut   			= LoginFirstName;
											if ((LoginLastName != '')&&(LoginLastName != ' '))
											{
												StringOut   		= LoginFirstName+"&nbsp;"+LoginLastName;	
											}
										}
										if ((LoginFirstName!='null')&&(LoginLastName=='null'))
										{
											StringOut   			= LoginFirstName;
										}
										if ((LoginFirstName=='null')&&(LoginLastName=='null'))
										{
											StringOut   			= LoginUname;
										}
								
									var blinkingname_element 	= document.getElementById('blinkingname');
									
										$(blinkingname_element).html(StringOut);
}

function ApplicationStateCornerPositionChange(command)
{
									var LogoCornerSW 										= jQuery(".ComponentsBasic-LogoCorner")[0];
										//jQuery(LogoCornerSW).css("border","2px solid red");	
									var ApplicationStateCorner_element 					    = document.getElementById('ApplicationStateCorner_table');
									var ApplicationStateCornerPositioningState_element 	    = document.getElementById('ApplicationStateCornerPositioningState');
									var AllowMoving_H_element 								= document.getElementById('ApplicationStateCornerPositioningAllowMoving_H');
									var AllowMoving_V_element 								= document.getElementById('ApplicationStateCornerPositioningAllowMoving_V');
									var	userMessagesAlignment 								= "";
										//alert('command:'+command+' ApplicationStateCornerPositioningEnabled_element value:  '+ApplicationStateCornerPositioningEnabled_element.value);
										if (command=='init')
										{// do not do nothing
											jQuery(LogoCornerSW).css('overflow','visible');
											jQuery(LogoCornerSW).find('.contentarea').css('overflow','visible');
											jQuery(LogoCornerSW).find('.frame').css('overflow','visible');
											jQuery(LogoCornerSW).find('.relative_stub').css('overflow','visible');
											jQuery(LogoCornerSW).find('.backgrounder').css('overflow','visible');
											
											jQuery(LogoCornerSW).find('.menucommands').find('.LogoCornerButton').off();
											jQuery(LogoCornerSW).find('.menucommands').find('.LogoCornerButton').on('mousedown',function(event){LogoCornerCommands(event.target);});
											jQuery('#blinkingname').on('mousedown',function(event){LogoCornerCommands(event.target);});
											
											
											jQuery('#ApplicationStateCornerPositioning_L').off();
											jQuery('#ApplicationStateCornerPositioning_L').on('mousedown',function(){ApplicationStateCornerPositionChange('translate_h');});
											jQuery('#ApplicationStateCornerPositioning_L').on('mouseover',function(){ApplicationStateCornerPositionChange('translate_h');});
											jQuery('#ApplicationStateCornerPositioning_R').off();
											jQuery('#ApplicationStateCornerPositioning_R').on('mousedown',function(){ApplicationStateCornerPositionChange('translate_h');});
											jQuery('#ApplicationStateCornerPositioning_R').on('mouseover',function(){ApplicationStateCornerPositionChange('translate_h');});
										
											jQuery('#ApplicationStateCornerPositioning').off();
											jQuery('#ApplicationStateCornerPositioning').on('mousedown',function(){ApplicationStateCornerPositionChange('translate_v');});
											jQuery('#ApplicationStateCornerPositioning').on('mouseover',function(){ApplicationStateCornerPositionChange('translate_v');});
											
											jQuery('#ApplicationLogoCorner').off();
											jQuery('#ApplicationLogoCorner').on('mousedown',function(){clickingApplicationStateCorner();});
											jQuery('#ApplicationLogoCorner').on('mouseover',function(event){hoveringApplicationStateCorner(event.target);});
											jQuery('#ApplicationLogoCorner').on('mouseleave',function(event){unhoveringApplicationStateCorner(event.target);});
											
										}
										//alert(" Found Position : "+ApplicationStateCornerPositioningState_element_value+" command:"+command+" AllowMoving_V_element.value:"+AllowMoving_V_element.value+" AllowMoving_H_element.value:"+AllowMoving_H_element.value );
								
										if (AllowMoving_V_element.value=='Y')
										{
										var ApplicationStateCornerPositioningState_element_value = ApplicationStateCornerPositioningState_element.value;
											//alert(" Found Position : "+ApplicationStateCornerPositioningState_element_value+" command:"+command);
											if (command=='translate_v')
											{ 
												//alert('position changing : '+command);
												if (ApplicationStateCornerPositioningState_element_value=='top_right')
												{
													ApplicationStateCornerPositioningState_element.value = 'bottom_right';
												}else
												if (ApplicationStateCornerPositioningState_element_value=='bottom_right')
												{
													ApplicationStateCornerPositioningState_element.value = 'top_right';
												}else
												if (ApplicationStateCornerPositioningState_element_value=='top_left')
												{
													ApplicationStateCornerPositioningState_element.value = 'bottom_left';
												}else
												if (ApplicationStateCornerPositioningState_element_value=='bottom_left')
												{
													ApplicationStateCornerPositioningState_element.value = 'top_left';
												}
											}
										}
								
										if (AllowMoving_H_element.value=='Y')
										{
										var ApplicationStateCornerPositioningState_element_value = ApplicationStateCornerPositioningState_element.value;
											if (command=='translate_h')
											{
												//alert('position changing : '+command);
												if (ApplicationStateCornerPositioningState_element_value== 'top_right')
												{
													ApplicationStateCornerPositioningState_element.value = 'top_left';
												}else
												if (ApplicationStateCornerPositioningState_element_value== 'top_left')
												{
													ApplicationStateCornerPositioningState_element.value = 'top_right';
												}else
												if (ApplicationStateCornerPositioningState_element_value== 'bottom_right')
												{
													ApplicationStateCornerPositioningState_element.value = 'bottom_left';
												}else
												if (ApplicationStateCornerPositioningState_element_value== 'bottom_left')
												{
													ApplicationStateCornerPositioningState_element.value = 'bottom_right';
												}
											}
										}
								
								//	if  (
								//		(ApplicationStateCornerPositioningEnabled_element.value=='enabled')
								//		||
								//		(ApplicationStateCornerPositioningEnabled_element.value=='locked')
								//		)
								//	{	//Not used?
								//		//Commands: force_top_right, force_bottom_right, reset_top_right, reset_bottom_right really sent by server?  20160528
								//		//		if (command=='force_top_right')
								//		//		{
								//		//			ApplicationStateCornerPositioningState_element.value   = 'top_right';
								//		//			ApplicationStateCornerPositioningEnabled_element.value = 'locked';
								//		//		}	
								//		//		if (command=='force_bottom_right')
								//		//		{
								//		//			ApplicationStateCornerPositioningState_element.value   = 'bottom_right';
								//		//			ApplicationStateCornerPositioningEnabled_element.value = 'locked';
								//		//
								//		//		}	
								//		//		if (command=='reset_top_right')
								//		//		{
								//		//			ApplicationStateCornerPositioningState_element.value   = 'top_right';
								//		//			ApplicationStateCornerPositioningEnabled_element.value = 'enabled';
								//		//
								//		//		}
								//		//		if (command=='reset_bottom_right')
								//		//		{
								//		//			ApplicationStateCornerPositioningState_element.value   = 'bottom_right';
								//		//			ApplicationStateCornerPositioningEnabled_element.value = 'enabled';
								//		//		}
								//	}
								
								var 	ApplicationStateCornerPositioningState_element 	= document.getElementById('ApplicationStateCornerPositioningState');
									//	if (ApplicationStateCornerPositioningState_element.value =='top_right')
									//	{
									//		//alert('drwaing up');
									//		ApplicationStateCorner_element.style.top      	= '5px';
									//		ApplicationStateCorner_element.style.right    	= '5px';
									//		//ApplicationStateCorner_element.style.bottom   = 'none';
									//		
									//
									//	}
								
										jQuery(ApplicationStateCorner_element).css("left","auto");
										jQuery(ApplicationStateCorner_element).css("right","auto");
										jQuery(ApplicationStateCorner_element).css("top","auto");
										jQuery(ApplicationStateCorner_element).css("bottom","auto");
										jQuery(ApplicationStateCorner_element).css("position","absolute");
										if (ApplicationStateCornerPositioningState_element.value =='top_right')
										{
											jQuery(LogoCornerSW).css("left","auto");
											jQuery(LogoCornerSW).css("right","15px");
											jQuery(LogoCornerSW).css("top","28px");
											if (jQuery(document.body).hasClass('device_mobile')) {jQuery(LogoCornerSW).css("top","0");}
											jQuery(LogoCornerSW).css("bottom","auto");
											
											userMessagesAlignment							= "right";
											/*
											ApplicationStateCorner_element.style.left 		= "auto";//targetWidth+'px';
											ApplicationStateCorner_element.style.right		= "10px";
											ApplicationStateCorner_element.style.top		= '15px';
											ApplicationStateCorner_element.style.bottom		= 'auto';
											*/
											jQuery(ApplicationStateCorner_element).css("top","0");
											jQuery(ApplicationStateCorner_element).css("right","0");
											
											document.getElementById('ApplicationStateCornerPositioning_R').style.visibility = 'visible';
											document.getElementById('ApplicationStateCornerPositioning_R').style.display 	= '';
											document.getElementById('ApplicationStateCornerPositioning_L').style.visibility = 'hidden';
											document.getElementById('ApplicationStateCornerPositioning_L').style.display    = 'none';
											jQuery("#ApplicationStateCornerPositioning").insertBefore("#ApplicationLogoCorner");
										} else
										if (ApplicationStateCornerPositioningState_element.value =='top_left')
										{
											jQuery(LogoCornerSW).css("left","15px");
											jQuery(LogoCornerSW).css("right","auto");
											jQuery(LogoCornerSW).css("top","28px");
											if (jQuery(document.body).hasClass('device_mobile')) {jQuery(LogoCornerSW).css("top","0");}
											jQuery(LogoCornerSW).css("bottom","auto");
											
											userMessagesAlignment							= "left";
											/*ApplicationStateCorner_element.style.left 		= '5px';
											ApplicationStateCorner_element.style.right 		= 'auto';
											ApplicationStateCorner_element.style.top   		= '15px';
											ApplicationStateCorner_element.style.bottom   	= 'auto';
											*/
											jQuery(ApplicationStateCorner_element).css("top","0");
											jQuery(ApplicationStateCorner_element).css("left","0");
								
											document.getElementById('ApplicationStateCornerPositioning_R').style.visibility = 'hidden';
											document.getElementById('ApplicationStateCornerPositioning_R').style.display    = 'none';
											//document.getElementById('ApplicationStateCornerPositioning_R').style.border     = 'none';
								
											document.getElementById('ApplicationStateCornerPositioning_L').style.visibility = 'visible';
											document.getElementById('ApplicationStateCornerPositioning_L').style.display    = '';
											jQuery("#ApplicationStateCornerPositioning").insertBefore("#ApplicationLogoCorner");
										} else
										if (ApplicationStateCornerPositioningState_element.value =='bottom_right')
										{
											jQuery(LogoCornerSW).css("left","auto");
											jQuery(LogoCornerSW).css("right","15px");
											jQuery(LogoCornerSW).css("top","auto");
											jQuery(LogoCornerSW).css("bottom","15px");
											if (jQuery(document.body).hasClass('device_mobile')) {jQuery(LogoCornerSW).css("bottom","0");											if (jQuery(document.body).hasClass('device_mobile')) {jQuery(LogoCornerSW).css("bottom","0");jQuery(LogoCornerSW).css("right","0");}}
								
										
										//var body_height 						  		= document.body.clientHeight;
										var ApplicationStateCorner_element_height 		= ApplicationStateCorner_element.clientHeight;
										//var targetHeight 						  		= parseInt(body_height-ApplicationStateCorner_element_height-5); 
								
											userMessagesAlignment							= "right";
											/*
											ApplicationStateCorner_element.style.right 		= '10px';
											ApplicationStateCorner_element.style.left 		= 'auto';
											ApplicationStateCorner_element.style.top   		= targetHeight+'px';
											ApplicationStateCorner_element.style.bottom   	= 'auto';*/
											jQuery(ApplicationStateCorner_element).css("bottom","0");
											jQuery(ApplicationStateCorner_element).css("right","0");
											document.getElementById('ApplicationStateCornerPositioning_R').style.visibility = 'visible';
											document.getElementById('ApplicationStateCornerPositioning_R').style.display 	= '';
											document.getElementById('ApplicationStateCornerPositioning_L').style.visibility = 'hidden';
											document.getElementById('ApplicationStateCornerPositioning_L').style.display    = 'none';
											jQuery("#ApplicationStateCornerPositioning").insertAfter("#TimeSlider");
										} else
										if (ApplicationStateCornerPositioningState_element.value =='bottom_left')
										{
											jQuery(LogoCornerSW).css("left","15px");
											jQuery(LogoCornerSW).css("right","auto");
											jQuery(LogoCornerSW).css("top","auto");
											jQuery(LogoCornerSW).css("bottom","15px");
											if (jQuery(document.body).hasClass('device_mobile')) {jQuery(LogoCornerSW).css("bottom","0");jQuery(LogoCornerSW).css("left","0");}
											
										//var body_height 						  		= document.body.clientHeight;
										var ApplicationStateCorner_element_height 		= ApplicationStateCorner_element.clientHeight;
										//var targetHeight 						  		= parseInt(body_height-ApplicationStateCorner_element_height-5); 
								
											userMessagesAlignment							= "left";
											/*
											ApplicationStateCorner_element.style.left 		= '5px';
											ApplicationStateCorner_element.style.right 		= 'auto';
											ApplicationStateCorner_element.style.top   		= targetHeight+'px';
											ApplicationStateCorner_element.style.bottom   	= 'auto';
											*/
											jQuery(ApplicationStateCorner_element).css("bottom","0");
											jQuery(ApplicationStateCorner_element).css("left","0");
								
											document.getElementById('ApplicationStateCornerPositioning_R').style.visibility = 'hidden';
											document.getElementById('ApplicationStateCornerPositioning_R').style.display    = 'none';
											document.getElementById('ApplicationStateCornerPositioning_L').style.visibility = 'visible';
											document.getElementById('ApplicationStateCornerPositioning_L').style.display    = '';
											jQuery("#ApplicationStateCornerPositioning").insertAfter("#TimeSlider");
										}

										if (userMessagesAlignment=='right')
										{
		var 								UserMessageBox_el = document.getElementById('UserMessageBox');
										//var UserMessageBox_width = jQuery(UserMessageBox_el).width();
											//jQuery(UserMessageBox_el).css("width","200px");
											//jQuery(UserMessageBox_el).css("margin-right","0px");
											//jQuery(UserMessageBox_el).css("margin-left","auto");
											//jQuery(UserMessageBox_el).css("margin-right","0px");
		var									ApplicationLogoCorner_el 		= document.getElementById('ApplicationLogoCorner');
		
		var 								ApplicationLogoCorner_width 	= $(ApplicationLogoCorner_el).innerWidth();
	
		var 								messagebox_els_w=0;	
											jQuery(UserMessageBox_el).find(".usermessagebox_element").each(
												function() {
												var thismessageWidth = jQuery(this).width();
													//if ( parseInt($( this ).width( )) > messagebox_els_w ) { messagebox_els_w= $( this ).width( );}
													jQuery(this).css("margin-left",(-thismessageWidth+ApplicationLogoCorner_width)+"px")
													//console_log('re-positioning usermessagebox_element'); 
												}
											);
											//jQuery(UserMessageBox_el).css("width",messagebox_els_w+"px");
										} else
										if (userMessagesAlignment=='left')
										{
			var 							UserMessageBox_el = document.getElementById('UserMessageBox');
										//var UserMessageBox_width = jQuery(UserMessageBox_el).width();
											//jQuery(UserMessageBox_el).css("width","200px");
											//jQuery(UserMessageBox_el).css("margin-right","0px");
											//jQuery(UserMessageBox_el).css("margin-right","auto");
											//jQuery(UserMessageBox_el).css("margin-left","0px");
										var messagebox_els_w=0;	
											jQuery(UserMessageBox_el).find(".usermessagebox_element").each(
												function() {
													if ( parseInt($( this ).width( )) > messagebox_els_w ) { messagebox_els_w= $( this ).width( );}
													jQuery(this).css("margin-left","0px") 
												}
											);
											//jQuery(UserMessageBox_el).css("width",messagebox_els_w+"px");
										}
						var 			ApplicationStateCornerContainer_el																	= ApplicationStateCorner_element.parentNode;
						var 			shadower_el 																						= document.getElementById(ApplicationStateCornerContainer_el.id+"shadower|");
										if (!isValidElement(shadower_el))
										{
											jQuery(ApplicationStateCornerContainer_el).prepend("<div id='"+ApplicationStateCornerContainer_el.id+"shadower|' o_nmouseleave='mouseleaveshadower(this)' > </div>")
										}
										shadower_el 																						= document.getElementById(ApplicationStateCornerContainer_el.id+"shadower|");
										jQuery(shadower_el).css("z-index",jQuery(LogoCornerSW).css('z-index'));
										jQuery(shadower_el).css("width","200px");
										jQuery(shadower_el).css("height","200px");
										jQuery(shadower_el).css("top","10px");
										jQuery(shadower_el).css("left","10px");
										jQuery(shadower_el).css("position","fixed");
										jQuery(shadower_el).css("background-color","#F1F1F1");
										jQuery(shadower_el).css("border-radius","35px");
										jQuery(shadower_el).css("opacity","0.8");
										jQuery(shadower_el).on("mouselave",function(event){mouseleaveshadower(event.target);});
										
										
								var 	ApplicationStateCorner_element_top	= jQuery(ApplicationStateCorner_element).position().top;
								var 	ApplicationStateCorner_element_left	= jQuery(ApplicationStateCorner_element).position().left;
								var 	ApplicationStateCorner_element_width	= jQuery(ApplicationStateCorner_element).width();
								var 	ApplicationStateCorner_element_height	= jQuery(ApplicationStateCorner_element).height();
								
										jQuery(shadower_el).css("top",(ApplicationStateCorner_element_top-15)+"px");
										jQuery(shadower_el).css("left",(ApplicationStateCorner_element_left-15)+"px");
										jQuery(shadower_el).css("width",(ApplicationStateCorner_element_width+30)+"px");
										jQuery(shadower_el).css("height",(ApplicationStateCorner_element_height+30)+"px");
										jQuery(shadower_el).css("visibility","hidden");
										jQuery(shadower_el).css("display","none");
										
										floatHeperImplement_inner();
										
										//console_log('KKKKKKKKKKKKKKKKKKKKKKKKKKKKK NNNNNNNNNNNNNNNNNNNNNNNNNN BBBBBBBB');
										if (jQuery(ApplicationStateCornerPositioningState_element).val().indexOf('top')>-1)
										{
									var 	myEl 		= document.getElementById('UserMessageBox');
									var 	movableEl 	= $(myEl).detach();
									var 	myDockerEl 	= document.getElementById('ApplicationStateCorner');
											jQuery(myDockerEl).append(movableEl);
											jQuery(myEl).css("margin-bottom","none");	
										} else
										if (jQuery(ApplicationStateCornerPositioningState_element).val().indexOf('bottom')>-1)
										{
									var 	myEl 		= document.getElementById('UserMessageBox');
									var 	movableEl 	= $(myEl).detach();
									var 	myDockerEl 	= document.getElementById('ApplicationStateCorner');
											jQuery(myDockerEl).prepend(movableEl);	
											jQuery(myEl).css("margin-bottom","15px");
										}
										
}

function mouseleaveshadower(elIn)
{
									var SWel 			= getSWOwner(elIn);
									var shadower_el 	= document.getElementById(SWel.id+"shadower|") ;
										jQuery(shadower_el).html("");
										ApplicationStateCornerPositionChange('');
}

function clickingApplicationStateCorner()
{
										ApplicationStateCornerWide(document.getElementById('ApplicationStateCorner'));
										floatHeperImplement();
}

function hoveringApplicationStateCorner(elIn)
{
									var ApplicationLogoCorner_el 							= document.getElementById('ApplicationLogoCorner');
										jQuery(ApplicationLogoCorner_el).attr('stephover','-14');
}

function unhoveringApplicationStateCorner(elIn)
{
									var ApplicationLogoCorner_el 							= document.getElementById('ApplicationLogoCorner');
										jQuery(ApplicationLogoCorner_el).attr('stephover','1');
}


function ApplicationStateCornerWide(elIn)
{
									var ApplicationStateCorner_element 					    = document.getElementById('ApplicationStateCorner_table');
									var ApplicationStateCorner_element_top					= jQuery(ApplicationStateCorner_element).position().top;
									var ApplicationStateCorner_element_left					= jQuery(ApplicationStateCorner_element).position().left;
									var ApplicationStateCorner_element_width				= jQuery(ApplicationStateCorner_element).width();
									var ApplicationStateCorner_element_height				= jQuery(ApplicationStateCorner_element).height();
								
									var mySW 												= getSWOwner(elIn);
									var	shadower_el 										= document.getElementById(mySW.id+"shadower|");
								
										jQuery(shadower_el).html("<span><br> Regolazione tempo di inutilizzo massimo<br> Lingua:ITAliano<br> Messaggi </span>");
										ApplicationStateCornerPositionChange('');
								
									var ApplicationStateCornerPositioningState_element 		= document.getElementById('ApplicationStateCornerPositioningState');
									var is_right=false;
										if (jQuery(ApplicationStateCornerPositioningState_element).val().indexOf('right')>-1)
										{
											is_right = true;
										}
									var is_top=false;
										if (jQuery(ApplicationStateCornerPositioningState_element).val().indexOf('top')>-1)
										{
											is_top = true;
										}
										
										if (is_right)
										{
											jQuery(shadower_el).css("left",(ApplicationStateCorner_element_left-200)+"px");
											jQuery(shadower_el).css("width",(ApplicationStateCorner_element_left-200+ApplicationStateCorner_element_width+10) +"px");
										} else
										{
											jQuery(shadower_el).css("width",500 +"px");		
											jQuery(shadower_el).css("left",(-200)+"px");
										}
										
										if (is_top)
										{
											//console_log("nnn:"+(ApplicationStateCorner_element_top-400));
											//jQuery(shadower_el).css("bottom",(ApplicationStateCorner_element_top-400)+"px");
											jQuery(shadower_el).css("height",600 +"px");
										} else
										{
											jQuery(shadower_el).css("top",(ApplicationStateCorner_element_top-400)+"px");
											jQuery(shadower_el).css("height",(400+ApplicationStateCorner_element_height+10) +"px");
										}
										jQuery(shadower_el).css("border-radius","250px");	
}

function timeSliderAdjust()
{
										// this function adjusts the state of the timing slider under the LogoCorner Box
									var d 												= new Date();
									var CurrentTime										= parseInt(d.getTime()/1000);
									var	LastRefreshElapsedTime							= CurrentTime-LastActionServerTime;
									var CurrentSliderPercentage							= LastRefreshElapsedTime/TimeSliderLength;
										//++TimeSliderStep;
										//var LogoCorner_debugger_element 					= document.getElementById('LogoCorner_debugger_bottom');
										//$(LogoCorner_debugger_element).html("last click:"+LastActionServerTime+"\nCurrentTime:"+CurrentTime+"\nLastRefreshElapsedTime:"+LastRefreshElapsedTime);
										
										if (CurrentSliderPercentage<0.99)
										{
											//var TimeSlider_treshold_element 	= document.getElementById("TimeSlider_treshold");
											//var TimeSlider_treshold_left		= parseInt(TimeSlider_treshold_element.getBoundingClientRect().left);
											var TimeSlider_available_time_element 				= document.getElementById("TimeSlider_available_time");
											var TimeSlider_available_time_magnified_element 	= document.getElementById("TimeSlider_available_time_magnified");
			
											var TimeSlider_element 											= document.getElementById("TimeSlider");
											//var TimeSlider_left					= parseInt(TimeSlider_element.getBoundingClientRect().left);
											var TimeSlider_width 											= parseInt(TimeSlider_element.clientWidth);
			
											//var ScreenSaverActivationRatio 		= (TimeSlider_treshold_left-TimeSlider_left)/TimeSlider_width;
			
											var TimeSlider_available_time_width								= TimeSlider_width*(1-CurrentSliderPercentage);
			
												//alert(" TimeSlider_available_time_width:"+parseInt(TimeSlider_available_time_width));
												TimeSlider_available_time_element.style.width 				= parseInt(TimeSlider_available_time_width)+'px';
												if (isValidElement(TimeSlider_available_time_magnified_element)) 
												{
													TimeSlider_available_time_magnified_element.style.width 	= parseFloat(CurrentSliderPercentage*100)+'%';
													jQuery(TimeSlider_available_time_magnified_element).css("right","0");
													jQuery(TimeSlider_available_time_magnified_element).css("left","auto");
												}
												
												
												if ((1-CurrentSliderPercentage)<SliderAuthenticationShieldTreshold)
												{
													//TimeSlider_available_time_element.style.backgroundColor = 'none';//'#FF3300' ;
													$("#ApplicationStateCorner").find(".remaining_time").css('border','1px solid red');
													$("#ApplicationStateCorner").find(".remaining_time").css('background-color','orange');
												} else
												{
													//TimeSlider_available_time_element.style.backgroundColor = 'none';
													$("#ApplicationStateCorner").find(".remaining_time").css('border','1px solid green');
													$("#ApplicationStateCorner").find(".remaining_time").css('background-color','lime');
												}
												
											//TimeSlider_available_time_element.style.borderRight  = "1px solid green";
											/*
											if (CurrentSliderPercentage<=SliderAuthenticationShieldTreshold)
											{
												var AdjustedLength 							= parseInt(TimeSlider_width*CurrentSliderPercentage);
												var ScreenSaverRatio 						= (AdjustedLength/TimeSlider_width);
										
												//alert('AdjustedLength:'+AdjustedLength+' TimeSlider_width:'+TimeSlider_width);
												TimeSlider_available_time_element.style.width = AdjustedLength+'px';
												console.log('AdjustedLength:'+AdjustedLength+' TimeSlider_width:'+TimeSlider_width);
												if (ScreenSaverRatio<ScreenSaverActivationRatio)
												{
													TimeSlider_available_time_element.style.backgroundColor = 'red';	
													if (ScreenSaverState=='disabled')
													{
														ScreenSaverShow();
													}
												}
												else
												{
													TimeSlider_available_time_element.style.backgroundColor = 'lime';	
													
												}
												$('#LogoCorner_debugger').html("...TimeSlider_treshold_left:"+TimeSlider_treshold_left+"<br>TimeSlider_left:"+TimeSlider_left+"<br>TimeSlider_width:"+TimeSlider_width+"<br>ScreenSaverRatio"+ScreenSaverRatio+"<br> ScreenSaverActivationRatio:"+ScreenSaverActivationRatio);
											}*/
			
											if ((1-CurrentSliderPercentage)<SliderAuthenticationShieldTreshold)
											{
												if (SessionTimingState=='IDLE')
												{
												//var body_id 		= document.body.id;
								
													//var PageName_local  = body_id.substring(1,body_id.length-1);
								
													//TimerSessionGuidanceVerify(PageName_local,"ScheduledCall","null","null"); 
													
												}
											}
										}else
										{
											//session destroy on Server ---session invalidate?
										}
}

function AuthShieldShowHide(authshield_show_hide_value, showWaiterShield)
{//inside StateImplement_Application
										//console_log("         AuthShieldShowHide.....with senddata");
								var 	body_id 											= document.body.id;
								var 	authshield_id 										= body_id+"authshield|";
								var 	dockElement_id  									= body_id+"ContentArea|";
								var 	dockElement 										= document.getElementById(dockElement_id);
								var 	authshield_element									= document.getElementById(authshield_id);
										if ((authshield_element === undefined )||(authshield_element==null))
										{
										    authshield_element 			 					= document.createElement("div");
											authshield_element.id 		 					= authshield_id;
											authshield_element.setAttribute("form_acting","Y");
											authshield_element.setAttribute("showWaiterShield",showWaiterShield);
											
											authshield_element.className  					= " IsSW ";
											authshield_element.style.display  				= "block";
											authshield_element.style.position 				= "absolute";
											authshield_element.style.height					= "200px";
											authshield_element.style.width					= "200px";
											authshield_element.style.top					= "50px";
											authshield_element.style.left					= "50px";
											//autshield_element.style.backgroundColor		= "yellow";
											dockElement.appendChild(authshield_element);
										}
										authshield_element									= document.getElementById(authshield_id);
									//authshield_element.style.visibility					= "hidden";
									
									var SubmitTrigger_id 									= body_id+"authshield|SubmitTrigger|";
									var SubmitTrigger_element								= document.getElementById(SubmitTrigger_id);
										if ((SubmitTrigger_element === undefined )||(SubmitTrigger_element==null))
										{
											var SubmitTrigger_element 			   			= document.createElement("input");
												SubmitTrigger_element.id 		   			= SubmitTrigger_id;
												SubmitTrigger_element.setAttribute("name","SubmitTrigger");
												SubmitTrigger_element.style.display			= "none";
									
												SubmitTrigger_element.value 	   			= body_id+"authshield|authshield_show_hide|";
												authshield_element.appendChild(SubmitTrigger_element);
										}
								
									var Identifier_id 										= body_id+"authshield|Identifier|";
									var Identifier_element									= document.getElementById(Identifier_id);
										if ((Identifier_element === undefined )||(Identifier_element==null))
										{
											var Identifier_element 			       			= document.createElement("input");
											    Identifier_element.id 		       			= Identifier_id;
											    Identifier_element.setAttribute("name","Identifier");
											    Identifier_element.style.display			= "none";
											    Identifier_element.value 	       			= body_id+"authshield|";
												authshield_element.appendChild(Identifier_element);
										}
								
									var authshield_show_id 									= body_id+"authshield|authshield_show_hide|";
									var authshield_show_element								= document.getElementById(authshield_show_id);
										if ((authshield_show_element === undefined )||(authshield_show_element==null))
										{
											    authshield_show_element 		   			= document.createElement("input");
												authshield_show_element.id 		   			= authshield_show_id;
												authshield_show_element.setAttribute("name","authshield_show_hide");
												authshield_show_element.value 	   			= authshield_show_hide_value;
												authshield_show_element.style.display		= "none";
												authshield_element.appendChild(authshield_show_element);
										}else
										{
												authshield_show_element.value 	   			= authshield_show_hide_value;
										}
										if (authshield_show_hide_value=='show')
										{
											jQuery("#TimeSlider_treshold").css("visibility","hidden");		
											jQuery("#TimeSlider_setter").css("visibility","hidden");	
												
										} else
										if (authshield_show_hide_value=='hide')
										{
											jQuery("#TimeSlider_treshold").css("visibility","visible");
											jQuery("#TimeSlider_setter").css("visibility","visible");		
										}
							
								var 	authshield_show_element			   			= document.getElementById(authshield_show_id);
								
										sendData(body_id+"authshield|",authshield_show_element,"Components.InLineAuthenticator");
}

/*
function setTimerSessionGuidanceVerify(IdentifierIn)
{
	var my_interval 			= 2000;
	
		TimerSessionGuidanceVerify(IdentifierIn,"ScheduledCall","null","null");
		SessionGuidancePageName = IdentifierIn;
	var MyTimerId 				= setInterval(function(){TimerSessionGuidanceVerify(IdentifierIn,"ScheduledCall","null","null");}, my_interval);
		addTimer(MyTimerId, my_interval, IdentifierIn,my_interval);
}*/

/**
 * No action taken.
 * Remote info about session and connection are stored in local variables.
 * 
 * Is called from 2 ppoints:
 * - generalTimer()
 * - TimerSessionGuidanceImplement(
 */
function ConnectionServerCheck()
{//each 2 seconds 
									var SessionChunk 								= "";
										if (jQuery(document.body).attr('session_id').length>0)
										{
											SessionChunk							+= "&session_id="+jQuery(document.body).attr('session_id');
										}
										
										$.ajax
										(
											{
												type	: "GET",
												url		: "pingalive",
												data	: SessionChunk,
												cache	: false,
												dataType: "json",
												success	: function(JMSG)
												{
													//if we are yeere
													session_status_from_server  	= JMSG.session_status;//4
													server_status  					= JMSG.server_status;
													
													console_log(" 2 session_status_from_server:"+session_status_from_server);

													
													jQuery(document.body).attr("session_status",session_status_from_server);
													jQuery(document.body).attr("server_status",server_status);//debug purposes
												},
												error: function(xhr, status, error)
												{//SERVER OR NETWORK DOWN. NOT INVALIDATED SESSION CASE.
													console_log("===========================================================");
													//covers everything
													console.log(xhr);
													console.log(status);
													console.log(error);
													server_status 					= "KO";
													jQuery(document.body).attr("server_status",server_status);//debug purposes
												}			 
											}
										);//ajax
}

/**
 * Looping only if SESSION is valid
 * Triggered from timer
 */
function TimerSessionGuidanceVerify(CommandIn,Parameter1_In,Parameter2_In)
{//each 2 seconds 
								//		alert('TimerSessionGuidanceVerify PageNameIn:'+PageNameIn+'  CommandIn:'+CommandIn+' Parameter1_In:'+Parameter1_In+' Parameter2_In:'+Parameter2_In);
								//	var LogoCorner_debugger_element 					  =	document.getElementById('UserCorner');
								//		LogoCorner_debugger_element.style.backgroundColor = "paleturquoise";
								//		alert("TimerSessionGuidanceVerify CommandIn:"+CommandIn);
								//	$("#TimeSlider").css("background-color","paleturquoise");
										//console.log("...............TimerSessionGuidanceVerify( caller CommandIn:"+CommandIn+" Parameter1_In:"+Parameter1_In+"  Parameter2_In:"+Parameter2_In);
								
										if (SessionTimingState =='INVA')
										{
											//SessionTimingState already is INVA
											SessionInvalidate();
										} else
										{
											//Valid session
									var 	d 								= new Date();
											if (isNaN(jQuery(document.body).attr("last_server_call")) )
											{
												jQuery(document.body).attr("last_server_call_hr",d.toLocaleTimeString());
												jQuery(document.body).attr("last_server_call",d.getTime());
											}
											
											if (isNaN(jQuery(document.body).attr("user_avail_time_s")) )
											{
												jQuery(document.body).attr("user_avail_time_s","1000");
											}	
											
										var last_server_call_ms 			= parseInt(jQuery(document.body).attr("last_server_call"));	
										var user_avail_time_ms 				= parseInt(jQuery(document.body).attr("user_avail_time_s"))*1000;	
										var	serverlastcall_elapsed_ms 		= d.getTime() - last_server_call_ms ;
											//console_log("================================"+d.toLocaleTimeString()+"===============================");
											//console_log("serverlastcall_elapsed_ms:"+serverlastcall_elapsed_ms+"   user_avail_time_ms:"+user_avail_time_ms);
											if ((d.toLocaleTimeString()-last_server_call_ms)<callserver_tolerace_s)
											{// check id Session is still usable
												//console_log("TimerSessionGuidanceVerify check session usable");
												//ConnectionServerCheck();
											} else
											{
												//console_log("TimerSessionGuidanceVerify usable");
											}
											
											if(serverlastcall_elapsed_ms>user_avail_time_ms+2500)
											{//Session is not still usable
												//console_log("TimerSessionGuidanceVerify UNUSABLE");
												//ConnectionServerCheck();
												SessionInvalidate();
											}else	
											if (session_status_from_server=='OK')
											{//can call server
											var Mypageobjtoken				= $(document.body).attr('pageobjtoken');
											var Mypagename					= $(document.body).attr('pagename');
											var SessionPageFullName			= Mypageobjtoken+"_"+Mypagename;
											var	data_pagechunk				= "sessionpagefullname="+SessionPageFullName+"&pageobjtoken="+Mypageobjtoken+"&pagename="+Mypagename;
											var data 						= data_pagechunk
													+"&"
													//+"PageName="+Mypagename+"&"
													+"Command="+CommandIn+"&"
													+"Parameter1="+Parameter1_In+"&"
													+"Parameter2="+Parameter2_In;//+"&"+"Uname="+UnameIn;
												//alert('TimerSessionGuidanceVerify. data  : '+data);
												//WaiterShield('hide');
												
												jQuery(document.body).attr("last_server_call_hr",d.toLocaleTimeString());
												jQuery(document.body).attr("last_server_call",d.getTime());
												
												
												$.ajax
												(
													{//dummy
														type	: "GET",
														url		: "SessionGuidance",
														data	: data,
														cache	: false,
														dataType: "html",
														success	: function(msg)
														{
															// if you are here session is valid
															// SessionEnd string is returned 
															//server_endpoints_calls[1] 						= 1;
															if (msg.indexOf("ERROR.")==0)
															{
																console.log("found following error:"+msg);	
															} else
															{
																//1
																TimerSessionGuidanceImplement(msg);
															}								
														},
														error: function()
														{//SERVER OR NETWORK DOWN. NOT INVALIDATED SESSION CASE.
															console_log("Session guidance call Error ");
														}			 
													}//dummy
												);//ajax
											}//END server session status OK 
										}//NOT INVA
}

function ConnectionStatusShield(scopeIn)
{
										if (scopeIn=='show')
										{
											//document.body.innerHTML 				= endsessionhtml_content; 
											if (jQuery(document.body).find(".troublesessionhtml_container").length==0)
											{
												jQuery(document.body).append("<div class='troublesessionhtml_container' style='position:absolute;z-index:1000;left:0px;top:0px;bottom:0px;right:0px;background-color:white;'></div>");
												jQuery(".troublesessionhtml_container").append(
													"<div style='position:absolute;top:10%;left:30%;width:40%;height:40%;background-image:url(images/preloader_c.gif);background-position:center;background-repeat: no-repeat;background-size: auto;'></div>"+
													"<span style='font-family:arial;font-size:22px;color:#06C;position:absolute;width:100%;text-align:center;bottom:30%;height:20%;'>Sembra ci sia qualche problema.<br><br>Appena possibile sarà visualizzata di nuovo la pagina <br> intanto è utile controllare la connessione del proprio dispositivo. </span>"+
													
													"<span style='font-family:arial;font-size:22px;color:#06C;position:absolute;width:100%;text-align:center;bottom:5%;height:20%;'>Something is not properly working.<br><br>As soon as possible page will be shown again <br> meanwhile check device connection may be useful. </span>"
													
													);
											}
											jQuery(document.body).find(".endsessionhtml_container").css("visibility","hidden");
											jQuery(document.body).find(".endsessionhtml_container").css("display","none");
											jQuery(document.body).find(".troublesessionhtml_container").css("visibility","visible");
											jQuery(document.body).find(".troublesessionhtml_container").css("display","block");
											
										var logocorner_el 							= document.getElementById(document.body.id+"LogoCorner|");
										var logocorner_z_index 						= isValidElement(logocorner_el)? parseInt( jQuery(logocorner_el).css('z-index')):10000;
											
											jQuery(".troublesessionhtml_container").css("z-index",logocorner_z_index+1);
											
											jQuery('.endsessionhtml_container').appendTo(document.body);
											
											jQuery('.explainedelement_content').remove();
										} else
										if (scopeIn=='hide')
										{
											jQuery(".troublesessionhtml_container").css("visibility","hidden");
											jQuery(".troublesessionhtml_container").css("display","none");		
										}
}

/** 
 * Shows shield only....no operation performed
 * 
*/
function SessionEndShield(scopeIn)
{
								//var 	endsessionhtml_el 						= document.getElementById(document.body.id+"ContentArea|endsessionhtml|");
								//var 	endsessionhtml_content 					= endsessionhtml_el.innerHTML;
										//document.body.innerHTML 				= endsessionhtml_content; 
									var endsessionhtml_content 					= endsessionhtml;
										
										if (jQuery(document.body).find(".endsessionhtml_container").length==0)
										{
											jQuery(document.body).append("<div class='endsessionhtml_container' style='position:absolute;z-index:1000;left:0px;top:0px;bottom:0px;right:0px;background-color:white;'></div>");			
											jQuery(".endsessionhtml_container").append(endsessionhtml_content);
										}
										if (scopeIn=='show')
										{
											jQuery(".endsessionhtml_container").css("visibility","visible");
											jQuery(".endsessionhtml_container").css("display","block");
											
											jQuery(document.body).find('.troublesessionhtml_container').css("visibility","hidden");
											jQuery(document.body).find('.troublesessionhtml_container').css("display","none");
											
											jQuery('.endsessionhtml_container').appendTo(document.body);
											
										var logocorner_el 							= document.getElementById(document.body.id+"LogoCorner|");
										var logocorner_z_index 						= isValidElement(logocorner_el)? parseInt( jQuery(logocorner_el).css('z-index')):10000;
											//console_log("logocorner_z_index:"+logocorner_z_index);	
											jQuery(".endsessionhtml_container").css("z-index",logocorner_z_index+1);
										} else
										if (scopeIn=='hide')
										{
											jQuery(".endsessionhtml_container").css("visibility","hidden");
											jQuery(".endsessionhtml_container").css("display","none");
										}
										
										jQuery('.endsessionhtml_container').find('.pageopener').off();
										jQuery('.endsessionhtml_container').find('.pageopener').on('mousedown',function(){
											removePageObjToken();
											storeStep(0);
											session_status_from_server = "";//3
											server_status = "";
											jQuery(document.body).attr("session_status",session_status_from_server);
											jQuery(document.body).attr("server_status","");
											jQuery(document.body).attr("session_id","");
											jQuery(document.body).attr("last_server_call","");
											jQuery(document.body).attr("last_server_call_hr","");

											window.location.assign(window.location.href+'?timestep='+Date.now() );
										});
}

function implementSssionConnections()
{
										console_log(' implementSessionConnections _____ session_status_from_server:'+session_status_from_server);
	
	
										if (
											((session_status_from_server=='KO')||(SessionTimingState=='INVA'))
											&& 
											(session_status_from_server!='OK')
										)
										{
											++SessionGuidanceUnavailabilities;
										} else
										if (session_status_from_server=='OK') 
										{
											SessionGuidanceUnavailabilities = 0;
										}
										jQuery(document.body).attr('SessionGuidanceUnavailabilities',SessionGuidanceUnavailabilities);

										console_log(' implementSessionConnections _____:'+SessionGuidanceUnavailabilities);

										
										if (SessionGuidanceUnavailabilities>5)
										{
											jQuery('.ComponentsBasic-LogoCorner').remove();
											removePageObjToken();
											storeStep(0);
											session_status_from_server = 'KO';//2
											//removeAllTimers();
											SessionInvalidate();
										}
										
										if (server_status=='OK')
										{
											ConnectionStatusShield('hide');
											if (session_status_from_server=='OK')
											{
												SessionEndShield('hide');												
											}	else	
											{
												SessionEndShield('show');
											}									
										} else	
										{
											ConnectionStatusShield('show');
										}
}

function SessionEnd_old()
{
									var x 										= setTimeout('alert("x");',100000); //It is very low probability that after 100 seconds x timeout will not be cleared
										for (var i = 0; i <= x; i++) clearTimeout(i);
								
									var endsessionhtml_el 						= document.getElementById(document.body.id+"ContentArea|endsessionhtml|");
									var endsessionhtml_content 					= endsessionhtml_el.innerHTML;
										document.body.innerHTML 				= endsessionhtml_content; 
}

function refresh_SliderAuthenticationShieldTreshold(PercentagePosition)
{
										//console_log(" @@ PercentagePosition:"+PercentagePosition);
										//alert("_PercentagePosition : "+PercentagePosition);
									var PercentagePosition_float 		   		= parseFloat(PercentagePosition);
										//alert('PercentagePosition:'+PercentagePosition);
									    SliderAuthenticationShieldTreshold 		= PercentagePosition_float;
									var SliderTreshold_element 	 		   		= document.getElementById('TimeSlider_treshold');
									var Slider_element 	 		 		   		= document.getElementById('TimeSlider');
									
										if(isValidElement(Slider_element)&&isValidElement(SliderTreshold_element))
										{
										var Slider_width		     		   		= parseInt(Slider_element.clientWidth);
										var SliderTreshold_left      		   		= PercentagePosition_float*Slider_width;
											//alert("SliderTreshold_element.id : "+SliderTreshold_element.id+" \nSliderTreshold_left : "+SliderTreshold_left+" \n PercentagePosition_float : "+PercentagePosition_float+" \n Slider_width : "+Slider_width);
											if (!jQuery(SliderTreshold_element).hasClass("draggingnow"))
											{
												SliderTreshold_element.style.left 	   	= SliderTreshold_left+'px';
												jQuery(SliderTreshold_element).attr("sliderauthenticationshieldtreshold_perc_init",PercentagePosition);
											}
											
										var TimeSlider_setter_el 							= document.getElementById('TimeSlider_setter');	
										var ApplicationLogoCorner_disclaimer_dd_el 			= document.getElementById('ApplicationLogoCorner_disclaimer_dd');	
											if (isValidElement(ApplicationLogoCorner_disclaimer_dd_el))
											{
											var ApplicationLogoCorner_disclaimer_dd_width = 	jQuery(ApplicationLogoCorner_disclaimer_dd_el).width();
											var timesetter_left = parseInt(ApplicationLogoCorner_disclaimer_dd_width*PercentagePosition_float);
											//console_log("   ApplicationLogoCorner_disclaimer_dd_width:"+ApplicationLogoCorner_disclaimer_dd_width+"  ApplicationLogoCorner_disclaimer_dd_width:"+ApplicationLogoCorner_disclaimer_dd_width+"   CurrentSliderPercentage:"+CurrentSliderPercentage);
												jQuery(TimeSlider_setter_el).css("left",timesetter_left+"px");
												jQuery(TimeSlider_setter_el).css("visibility","visible");
											}
										}
}

function LogoCornerTriggerSliderActivate(elemId,pageNameIn)
{	
	//var 								ApplicationLogoCorner_el 																			= document.getElementById("ApplicationLogoCorner");
	var 								TimeSlider_treshold_el = document.getElementById("TimeSlider_treshold");
	//var 								body_content_area_el 																				= document.getElementById(document.body.id+"ContentArea|");
	var 								elem 																								= document.getElementById(elemId);

	var									HTML_blocks																							="";		
										for(var g=0;g<16;++g)
										{
											//HTML_blocks += "<div style='position:absolute;left:"+(g*25+2)+"px;top:0;width:20px;background-color:lime;height:15px;border:1px solid green;border-radius:3px;'> </div>"
											HTML_blocks += "<div class='remaining_time' style='position:absolute;left:"+(g*6.25)+"%;top:0;width:4.25%;background-color:lime;height:15px;border:1px solid green;border-radius:3px;'> </div>"		
										}
									  	jQuery(".float_helper_board").append
										(
											"<div id='ApplicationLogoCorner_disclaimer' style='position:absolute;z-index:100000;top:0%;left:0%;bottom:0%;right:0%;background-color:transparent;visibility:visible;'>"+
													//"<div style='position:absolute;top:10px;left:40px;right:40px;height:300px;width:450px;background-color:lightgrey;border-radius:5px;' >"+
													//"</div>"+
													"<div id = 'ApplicationLogoCorner_magnifier_header'  style='position:relative;margin:0 auto;top: 5%;height:85px;width:90%;font-family:arial;font-size:15px;font-weight:600;;text-align:center;background-color:aliceblue;color:darkcyan;border-radius:0px;border:1px solid lightblue;'><br>Tempo di permanenza nella piattaforma.<br>Spostamento a sinistra maggiore tempo a disposizione.<br>Spostamento a destra maggior riservatezza. </div>"+
													"<div id = 'ApplicationLogoCorner_magnifier_moretime' class='button_generic_widthfromserver secondary' style='position:relative;margin:0 auto;top: 10%;height:25px;width:90%;font-family:Arial;font-size:20px;border:1px solid lightgrey;color:blue;text-align:center;background-color:lightgrey;border-radius:3px;cursor:pointer;'><span class='emcaption' style='width:70%;text-align:center;white-space:nowrap;'><<<<< Maggior Tempo a disposizione </span></div>"+
													"<div id = 'ApplicationLogoCorner_disclaimer_dd' style='position:relative;margin:0 auto;top: 15%;height:50px;width:90%;background-color:white;border:1px solid lightblue;'>"+
															""+HTML_blocks+
														"<div id='TimeSlider_available_time_magnified' style='width:100%;position:absolute;left:0;top:0;height:26px;border:none;overflow:hidden;background-color:white;'>"+
														"</div>"+
														"<div id='TimeSlider_setter' style='position:absolute;left:0;top:20px;height:30px;width:10px;background-color:yellow;visibility:hidden;'></div>"+
													"</div>"+
													"<div id = 'ApplicationLogoCorner_magnifier_lesstime' 	class='button_generic_widthfromserver secondary' style='position:relative;margin:0 auto;top: 20%;height:25px;width:90%;font-family:Arial;font-size:20px;border:1px solid lightgrey;color:blue;text-align:center;background-color:lightgrey;border-radius:3px;cursor:pointer;'><span class='emcaption' style='width:90%;text-align:center;'>Maggior Riservatezza >>>>> </span></div>"+
													"<div id = 'ApplicationLogoCorner_magnifier_hide' 		class='button_generic_widthfromserver primary' style='position:relative;margin:0 auto;top: 25%;height:25px;width:90%;font-family:Arial;font-size:20px;border:1px solid lightgrey;color:blue;text-align:center;background-color:lightgrey;border-radius:3px;cursor:pointer;visibility:hidden;'><span class='emcaption' style='width:100%;text-align:center;'>OK</span> </div>"+
											"</div>"
										);
										//centerElementInParent('ApplicationLogoCorner_disclaimer','H');
							var 		ApplicationLogoCorner_disclaimer_el 															= document.getElementById("ApplicationLogoCorner_disclaimer");
							var 		ApplicationLogoCorner_magnifier_moretime_el 													= document.getElementById("ApplicationLogoCorner_magnifier_moretime");
							var 		ApplicationLogoCorner_magnifier_lesstime_el 													= document.getElementById("ApplicationLogoCorner_magnifier_lesstime");
							var 		ApplicationLogoCorner_magnifier_hide_el 														= document.getElementById("ApplicationLogoCorner_magnifier_hide");
							//var 		TimeSlider_setter_el 																			= document.getElementById("TimeSlider_setter");
							
										//console_log('nnnn mmm '+ApplicationLogoCorner_disclaimer_el.id);
							
										jQuery('.float_helper_board').css('background-color','white');
										jQuery(ApplicationLogoCorner_magnifier_hide_el).mousedown(
											function() 
											{
												jQuery(ApplicationLogoCorner_disclaimer_el).css("visibility","hidden");
												LogoCornerFuncts('clear');
											}
										);

										jQuery(ApplicationLogoCorner_magnifier_lesstime_el).mousedown(function() {

															var 	SliderPosition_ori 	 	= parseInt(TimeSlider_treshold_el.style.left);
															var 	ContainmentWidth 		= TimeSlider_treshold_el.parentNode.clientWidth;
															var 	SliderPercentage_ori 	= SliderPosition_ori/ContainmentWidth; 
															
															var		SliderPercentage 		= SliderPercentage_ori +0.10;
																	if (SliderPercentage>.9) SliderPercentage=0.9; 
																	//alert('-ContainmentWidth :   SliderPercentage :'+SliderPercentage);
																	//jQuery(TimeSlider_setter_el).css("left",parseFloat(SliderPercentage*340)+ "px");
																	TimerSessionGuidanceVerify("TresholdChange",SliderPercentage,"null");
													});
										jQuery(ApplicationLogoCorner_magnifier_moretime_el).mousedown(function() {
															var 	SliderPosition_ori 	 	= parseInt(TimeSlider_treshold_el.style.left);
															var 	ContainmentWidth 		= TimeSlider_treshold_el.parentNode.clientWidth;
															var 	SliderPercentage_ori 	= SliderPosition_ori/ContainmentWidth; 
																	
															var		SliderPercentage 		= SliderPercentage_ori -0.10;
																	if (SliderPercentage<0) SliderPercentage=0.01; 
																	//alert('+ContainmentWidth :   SliderPercentage :'+SliderPercentage);
																	//jQuery(TimeSlider_setter_el).css("left",parseFloat(SliderPercentage*340)+ "px");
																	TimerSessionGuidanceVerify("TresholdChange",SliderPercentage,"null");
													});
										$(elem).draggable
								  		(
								  			{
								  				axis		: 'x',
								  				containment	: 'parent',
								  				cursor		: 'e-resize',
								  				start: function()
								  								{
													  				jQuery(elem).addClass("draggingnow");
												  				},
								  				stop		: function() 
								  								{
													  				jQuery(elem).removeClass("draggingnow");
															var 	SliderPosition 	 = parseInt(this.style.left);
															var 	ContainmentWidth = this.parentNode.clientWidth;
															var 	SliderPercentage = SliderPosition/ContainmentWidth;
																	if (SliderPercentage>0.9) SliderPercentage = 0.9;
																	//alert('ContainmentWidth : '+ContainmentWidth+ '  SliderPercentage : '+SliderPercentage);
																	TimerSessionGuidanceVerify("TresholdChange",SliderPercentage,"null");
								  								}
								  			}
								  		);
								  		
								  		/*
								  		jQuery(ApplicationLogoCorner_el).on(
											  'mouseover',
											function() 
											{		
												floatHeperImplement();
											}
										);*/											
}

function floatHeperImplement()
{
									var LogoCornerEl = 	jQuery('.ComponentsBasic-LogoCorner')[0];
						
										jQuery(LogoCornerEl).css("position","fixed");
										jQuery(LogoCornerEl).css("width","80%");
										jQuery(LogoCornerEl).css("height","80%");
										jQuery(LogoCornerEl).addClass("expanded");
										jQuery(LogoCornerEl).css("border-radius","20px");
										jQuery(LogoCornerEl).css("overflow","hidden");
										
										jQuery(LogoCornerEl).find(".relative_stub").css("width","100%");
										jQuery(LogoCornerEl).find(".backgrounder").css("width","100%");
										jQuery(LogoCornerEl).find(".backgrounder").css("background-color","grey");
										jQuery(LogoCornerEl).find(".backgrounder").css("border-radius","20px");
										jQuery(LogoCornerEl).find(".frame").css("width","100%");
										jQuery(LogoCornerEl).find(".contentarea").css("width","100%");
										
										jQuery(LogoCornerEl).find(".relative_stub").css("height","100%");
										jQuery(LogoCornerEl).find(".backgrounder").css("height","100%");
										jQuery(LogoCornerEl).find(".frame").css("height","100%");
										jQuery(LogoCornerEl).find(".contentarea").css("height","100%");
										
										jQuery(LogoCornerEl).find(".relative_stub").css("overflow","visible");
										jQuery(LogoCornerEl).find(".backgrounder").css("overflow","visible");
										jQuery(LogoCornerEl).find(".frame").css("overflow","visible");
										jQuery(LogoCornerEl).find(".contentarea").css("overflow","visible");

							
										jQuery('#ApplicationStateCorner_table').css("margin","15px");			
										
										if (
											jQuery(document.body).find(".float_hepler_nodes").length
										||
											jQuery(document.body).find(".float_helper_board").length
										)
										{
										} else
										{
											jQuery(LogoCornerEl).find(".backgrounder").css("opacity","0.7");
											jQuery(LogoCornerEl).find(".contentarea").addClass("float_helper");
											jQuery(".float_helper").append("<div class='float_helper_board' style='position:absolute;top:20%;bottom:2%;right:10%;left:30%;border:none;background-color:transparent;border-radius:5px;'><div>");
										//var current_hicontrast_el = document.getElementById(document.body.id+"LogoCorner|current_hicontrast|");
										
											for (var h=0;h<10;++h)
											{
												jQuery('.float_helper').append("<div class='float_hepler_nodes float_hepler_node"+h+"' style='position:absolute;left:0px;top:0px;width:2px;height:2px;background-color:transparent;' ></div>"); 
											}
											
										var float_hepler_nodes = jQuery('.float_hepler_nodes');
											if (jQuery(document.body).hasClass('hicontrast')) 	
											{	
												jQuery(float_hepler_nodes[0]).html("<span style='text-align:center;position:absolute;left:0;top:0;width:100%;height:30px;line-height:30px;color:black;background-color:white;font-family:arial;font-size:30px;opacity:1;' o_nmousedown='HighContrastSwitch(\"N\")'>Normal View generica</span>");
												jQuery(float_hepler_nodes[0]).find("span").off("mousedown");
												jQuery(float_hepler_nodes[0]).find("span").on("mousedown",function(){HighContrastSwitch('N');});
											}
											if (!jQuery(document.body).hasClass('hicontrast')) 	
											{	
												jQuery(float_hepler_nodes[0]).html("<span style='text-align:center;position:absolute;left:0;top:0;width:100%;height:30px;line-height:30px;color:black;background-color:white;font-family:arial;font-size:30px;opacity:1;' o_nmousedown='HighContrastSwitch(\"Y\")'>Hi Contrast/Alto Contrasto</span>");
												jQuery(float_hepler_nodes[0]).find("span").off("mousedown");
												jQuery(float_hepler_nodes[0]).find("span").on("mousedown",function(){
													HighContrastSwitch('Y');
												});
											}

									
											jQuery(float_hepler_nodes[1]).html("<span style='text-align:center;position:absolute;left:0;top:0;width:100%;height:32px;line-height:30px;color:black;background-color:white;font-family:arial;font-size:30px;opacity:1;' o_nmousedown='LogoCornerFuncts(\"index\")'>More/Altre Pagine</span>");
											jQuery(float_hepler_nodes[1]).find("span").off("mousedown");
											jQuery(float_hepler_nodes[1]).find("span").on("mousedown",function(){LogoCornerFuncts("index");});
											
											jQuery(float_hepler_nodes[2]).html("<span style='text-align:center;position:absolute;left:0;top:0;width:100%;height:32px;line-height:30px;color:black;background-color:white;font-family:arial;font-size:30px;opacity:1;' o_nmousedown='LogoCornerFuncts(\"messages\")'>Messages/Messaggi</span>");
											jQuery(float_hepler_nodes[2]).find("span").off("mousedown");
											jQuery(float_hepler_nodes[2]).find("span").on("mousedown",function(){LogoCornerFuncts("messages");});
											
											jQuery(float_hepler_nodes[3]).html("<span style='text-align:center;position:absolute;left:0;top:0;width:100%;height:32px;line-height:30px;color:black;background-color:white;font-family:arial;font-size:30px;opacity:1;' o_nmousedown='LogoCornerFuncts(\"timeout\")'>Timeout/Durata</span>");
											jQuery(float_hepler_nodes[3]).find("span").off("mousedown");
											jQuery(float_hepler_nodes[3]).find("span").on("mousedown",function(){LogoCornerFuncts("timeout");});
											
											jQuery(float_hepler_nodes[4]).html("<span style='text-align:center;position:absolute;left:0;top:0;width:100%;height:32px;line-height:30px;color:black;background-color:white;font-family:arial;font-size:30px;opacity:1;' o_nmousedown='LogoCornerFuncts(\"zoom\")'>Settings Zoom Preferenze</span>");
											jQuery(float_hepler_nodes[4]).find("span").off("mousedown");
											jQuery(float_hepler_nodes[4]).find("span").on("mousedown",function(){LogoCornerFuncts("zoom");});
											
											jQuery(float_hepler_nodes[5]).html("<span style='text-align:center;position:absolute;left:0;top:0;width:100%;height:32px;line-height:30px;color:black;background-color:white;font-family:arial;font-size:30px;opacity:1;' o_nmousedown='LogoCornerFuncts(\"languages\")'>Language/Lingua </span>");
											jQuery(float_hepler_nodes[5]).find("span").off("mousedown");
											jQuery(float_hepler_nodes[5]).find("span").on("mousedown",function(){LogoCornerFuncts("languages");});
											
											
											jQuery(float_hepler_nodes[6]).html("<span style='text-align:center;position:absolute;left:0;top:0;width:100%;height:32px;line-height:30px;color:black;background-color:white;font-family:arial;font-size:30px;opacity:1;cursor:pointer;' o_nmousedown='LogoCornerFuncts(\"back\")'><i class=\"fa-solid fa-xmark\" style='font-size:32px;color:red;'></i></span>");
											jQuery(float_hepler_nodes[6]).find("span").off("mousedown");
											jQuery(float_hepler_nodes[6]).find("span").on("mousedown",function(){LogoCornerFuncts("back");});
											
											jQuery(float_hepler_nodes[7]).html("<span style='text-align:center;position:absolute;left:0;top:0;width:100%;            line-height:30px;color:black;background-color:white;font-family:arial;font-size:30px;opacity:1;cursor:pointer;' >Floating assistant leaves space to contents.<br>Logo to recall it. Move it by arrows " + 
											" <i class=\"fa-solid fa-square-caret-left\" 	o_nmousedown=\"ApplicationStateCornerPositionChange('translate_h')\" ></i>&nbsp; "+
											" <i class=\"fa-solid fa-square-caret-right\" 	o_nmousedown=\"ApplicationStateCornerPositionChange('translate_h')\"></i>&nbsp; "+
											" <i class=\"fa-solid fa-square-caret-up\" 		o_nmousedown=\"ApplicationStateCornerPositionChange('translate_v')\"></i>&nbsp; "+
											" <i class=\"fa-solid fa-square-caret-down\" 	o_nmousedown=\"ApplicationStateCornerPositionChange('translate_v')\"></i> "+
											" </span>");
											
											jQuery(float_hepler_nodes[7]).find(".fa-solid").off("mousedown");
											jQuery(float_hepler_nodes[7]).find(".fa-square-caret-left").on("mousedown",function(){ApplicationStateCornerPositionChange('translate_h');});
											jQuery(float_hepler_nodes[7]).find(".fa-square-caret-right").on("mousedown",function(){ApplicationStateCornerPositionChange('translate_h');});
											jQuery(float_hepler_nodes[7]).find(".fa-square-caret-up").on("mousedown",function(){ApplicationStateCornerPositionChange('translate_v');});
											jQuery(float_hepler_nodes[7]).find(".fa-square-caret-down").on("mousedown",function(){ApplicationStateCornerPositionChange('translate_v');});
											
											jQuery(float_hepler_nodes[8]).html("<span style='text-align:center;position:absolute;left:0;top:0;width:100%;height:32px;line-height:30px;color:black;background-color:white;font-family:arial;font-size:30px;opacity:1;cursor:pointer;' >Logout&nbsp;&nbsp;&nbsp;<i class=\"fa-solid fa-power-off\" style='font-size:26px;color:red;'></i></span>");
											jQuery(float_hepler_nodes[8]).find("span").off("mousedown");
											jQuery(float_hepler_nodes[8]).find("span").on("mousedown",function(){SessionInvalidate();});

										}
										floatHeperImplement_inner();
}

function ZoomUserArranger()
{
				var						MyZoomRatio_Now							= detectZoom.zoom();
										jQuery('.float_helper_board').append(
											"<span class='float_helper_board_zoomgauge_disc' 	style='font-family:arial;font-size:22px;color:black;position:absolute;left:48%;top:30%;'>  Zoom </span>"+
											"<span class='float_helper_board_zoomgauge_user' 	style='font-family:arial;font-size:8px;color:black;position:absolute;left:2%;top:90%;'>  browser zoom : <span class='float_helper_board_zoomvalue_user'  >"+MyZoomRatio_Now+"</span></span>"+
											"<span class='float_helper_board_zoomgauge_body' 	style='font-family:arial;font-size:8px;color:black;position:absolute;left:45%;top:90%;'>  body zoom    : <span class='float_helper_board_zoomvalue_body'  >"+10+"</span></span>"+
											"<span class='float_helper_board_zoomgauge_global' 	style='font-family:arial;font-size:8px;color:black;position:absolute;left:70%;top:90%;'>  global zoom  : <span class='float_helper_board_zoomvalue_global'>"+10+"</span></span>"+
											"<table class='zoomselector' style='position:absolute;width:70%;top:40%;left:10%;font-family:arial;font-size:22px;color:black;'><tr><td zoomval='0.6'>60%</td><td zoomval='0.70'>70%</td><td zoomval='0.80'>80%</td><td  zoomval='0.9'>90%</td><td  zoomval='1'>100%</td><td  zoomval='1.1'>110%</td><td  zoomval='1.25'>125%</td></tr></table>"
										);
										jQuery('.float_helper_board').css('background-color','white');	
										jQuery('.zoomselector').find("td")
										  .on( "mousedown", function() {
										 var 	zoom_target = parseFloat( $( this ).attr( "zoomval" ))  ;
										 		//console_log("nnnnnnnnnnnn:"+detectZoom.zoom());
												zoom_css_component = parseFloat(zoom_target/detectZoom.zoom());
												ZoomCSSComponentImplement();
												ManageZoomChange();
												scrollManagement();
			
			  							       /*
			  							    var scaleval= "0.6";
			  							       $(document.body).css({
													  '-webkit-transform' : 'scale(' + scaleval + ')',
													  '-moz-transform'    : 'scale(' + scaleval + ')',
													  '-ms-transform'     : 'scale(' + scaleval + ')',
													  '-o-transform'      : 'scale(' + scaleval + ')',
													  'transform'         : 'scale(' + scaleval + ')'
													});
												*/	
										  } 
										);		
}

function ZoomCSSComponentImplement()
{
										 //console_log("zoom implementing %:"+zoom_css_component*100);
			  							 document.body.style.zoom = parseFloat(zoom_css_component);	
}

function LogoCornerFuncts(ScopeIn)
{
										jQuery('.float_hepler_nodes').removeClass('selected');
										if (ScopeIn=='messages')
										{
										var metabutton_el = jQuery('.float_hepler_node2')[0];
											if (!jQuery(metabutton_el).hasClass('disabled'))
											{
											var sender_id = 	"|"+jQuery(document.body).attr('pagename')+"|LogoCorner|messages|";	
											var sender_el = 	document.getElementById(sender_id);
												sendData(document.body.id+"LogoCorner|",sender_el,"ComponentsBasic.LogoCorner");
											} else
											{
												console_log('disbaled')
											}
										} else 
										if (ScopeIn=='languages')
										{
										var metabutton_el = jQuery('.float_hepler_node5')[0];
											if (!jQuery(metabutton_el).hasClass('disabled'))
											{
											var sender_id = 	"|"+jQuery(document.body).attr('pagename')+"|LogoCorner|languages|";	
											var sender_el = 	document.getElementById(sender_id);
												sendData(document.body.id+"LogoCorner|",sender_el,"ComponentsBasic.LogoCorner");
											} else
											{
												console_log('disbaled')
											}
										} else 
										if (ScopeIn=='index')
										{
										var metabutton_el = jQuery('.float_hepler_node1')[0];
											if (!jQuery(metabutton_el).hasClass('disabled'))
											{
											var sender_id = 	"|"+jQuery(document.body).attr('pagename')+"|LogoCorner|showindex|";	
											var sender_el = 	document.getElementById(sender_id);
												sendData(document.body.id+"LogoCorner|",sender_el,"ComponentsBasic.LogoCorner");
											} else
											{
												console_log('disbaled')
											}
										} else 	
										if (ScopeIn=='clear')
										{
											jQuery('.float_helper_board').empty();	
											jQuery('.float_helper_board').css('background-color','transparent');	
										} else
										if (ScopeIn=='zoom')
										{
											jQuery('.float_hepler_node4').addClass('selected');
											jQuery('.float_helper').find(".float_helper_board").css('display','block');
											jQuery('.float_helper_board').empty();	
											ZoomUserArranger();		
										} else
										if (ScopeIn=='timeout')
										{
										var metabutton_el = jQuery('.float_hepler_node3')[0];
											if (!jQuery(metabutton_el).hasClass('disabled'))
											{
												jQuery('.float_hepler_node3').addClass('selected');
												jQuery('.float_helper').find(".float_helper_board").css('display','block');
												jQuery('.float_helper_board').empty();	
												LogoCornerTriggerSliderActivate(null,jQuery(document.body).attr('pagename'));		
											}
										} else
										if (ScopeIn=='back')
										{
										var padding = 5;
											jQuery('#ApplicationStateCorner_table').css('top',padding+"px");
											jQuery('#ApplicationStateCorner_table').css('left',padding+"px");
											jQuery('#ApplicationStateCorner_table').css('margin',"0px");
										var my_w=	parseInt(jQuery('#ApplicationStateCorner').width());
										var my_h=	parseInt(jQuery('#ApplicationStateCorner').height());
											jQuery('.float_helper').find(".float_helper_board").remove();
											jQuery('.float_helper').find(".float_hepler_nodes").remove();		
											jQuery('.float_helper').css("background-color","transparent");
										
										var logocorner_el = jQuery('.ComponentsBasic-LogoCorner')[0];
											jQuery(logocorner_el).css("width",my_w+(2*padding)+"px");
											jQuery(logocorner_el).css("height",my_h+(2*padding)+"px");
											jQuery(logocorner_el).css("border-radius","0px");
											jQuery(logocorner_el).find(".backgrounder").css("background-color","transparent");
											jQuery(logocorner_el).removeClass('expanded');
											
											jQuery(logocorner_el).find(".relative_stub").css("overflow","visible");
											jQuery(logocorner_el).find(".backgrounder").css("overflow","visible");
											jQuery(logocorner_el).find(".frame").css("overflow","visible");
											jQuery(logocorner_el).find(".contentarea").css("overflow","visible");
										} else
										if (ScopeIn=='openpersonalpage')
										{
											
											if (jQuery('#LogoCornerUserUname').text() != 'STARTING_SESSION_WEB_UNAUTHENTICATED')
											{
												OpenPersonalPage();
											}
										}
}

function floatHeperImplement_inner()
{
									var left_right_orientation = "left";
									var top_bottom_orientation = "top";
									var pos_x = jQuery('#ApplicationLogoCorner').offset().left;
										//var pos_xr = jQuery('#ApplicationLogoCorner').offset().right;
									var pos_y = jQuery('#ApplicationLogoCorner').offset().top;
									var float_hepler_nodes = jQuery('.float_hepler_nodes');
									
										if (pos_x<200) 	left_right_orientation = "right";		
										if (pos_y>200) 	top_bottom_orientation = "bottom";		
											for (var h=0;h<10;++h)
											{
												jQuery(float_hepler_nodes[h]).css("height",'32px');
												jQuery(float_hepler_nodes[h]).css("left",'auto');
												jQuery(float_hepler_nodes[h]).css("right",'auto');
												jQuery(float_hepler_nodes[h]).css("top",'auto');
												jQuery(float_hepler_nodes[h]).css("bottom",'auto');
												jQuery(float_hepler_nodes[h]).css('border-radius','5px');
												jQuery(float_hepler_nodes[h]).css('overflow','hidden');
												jQuery(float_hepler_nodes[h]).css('cursor','pointer');
											}
											
										jQuery(".float_helper_board").css("left",'auto');
										jQuery(".float_helper_board").css("right",'auto');
										jQuery(".float_helper_board").css("top",'auto');
										jQuery(".float_helper_board").css("bottom",'auto');
										jQuery(".float_helper_board").css(left_right_orientation,'34%');
										jQuery(".float_helper_board").css(top_bottom_orientation,'21.5%');
										jQuery(".float_helper_board").css('width','48%');
										jQuery(".float_helper_board").css('height','75%');
										//jQuery(".float_helper_board").css('background-color','white');


											
										jQuery(float_hepler_nodes[0]).css('width','30%');
										//jQuery(float_hepler_nodes[0]).css('height','35px');
										jQuery(float_hepler_nodes[0]).css(top_bottom_orientation,'90%');
										jQuery(float_hepler_nodes[0]).css(left_right_orientation,'2%');
											
										jQuery(float_hepler_nodes[1]).css('width','30%');
										jQuery(float_hepler_nodes[1]).css(top_bottom_orientation,'80%');
										jQuery(float_hepler_nodes[1]).css(left_right_orientation,'2%');
											
										jQuery(float_hepler_nodes[2]).css('width','30%');
										jQuery(float_hepler_nodes[2]).css(top_bottom_orientation,'70%');
										jQuery(float_hepler_nodes[2]).css(left_right_orientation,'2%');
									

										jQuery(float_hepler_nodes[4]).css('width','30%');
										jQuery(float_hepler_nodes[4]).css(top_bottom_orientation,'60%');
										jQuery(float_hepler_nodes[4]).css(left_right_orientation,'2%');

										jQuery(float_hepler_nodes[5]).css('width','30%');
										jQuery(float_hepler_nodes[5]).css(top_bottom_orientation,'50%');
										jQuery(float_hepler_nodes[5]).css(left_right_orientation,'2%');

										jQuery(float_hepler_nodes[3]).css('width','30%');
										jQuery(float_hepler_nodes[3]).css(top_bottom_orientation,'40%');
										jQuery(float_hepler_nodes[3]).css(left_right_orientation,'2%');

										jQuery(float_hepler_nodes[8]).css('width','30%');
										jQuery(float_hepler_nodes[8]).css(top_bottom_orientation,'30%');
										jQuery(float_hepler_nodes[8]).css(left_right_orientation,'2%');

										jQuery(float_hepler_nodes[6]).css('width','5%');
										jQuery(float_hepler_nodes[6]).css(top_bottom_orientation,'88%');
										jQuery(float_hepler_nodes[6]).css(left_right_orientation,'90.5%');
										

										jQuery(float_hepler_nodes[7]).css('width','80%');
										jQuery(float_hepler_nodes[7]).css('height',jQuery(float_hepler_nodes[7]).find('span').height()+'px');
										jQuery(float_hepler_nodes[7]).css(top_bottom_orientation,'2%');
										jQuery(float_hepler_nodes[7]).css(left_right_orientation,'2%');
										

										
										jQuery('.float_hepler_node7').find('.fa-square-caret-left').css("visibility","hidden");
										jQuery('.float_hepler_node7').find('.fa-square-caret-right').css("visibility","hidden");
										jQuery('.float_hepler_node7').find('.fa-square-caret-left').css("display","none");
										jQuery('.float_hepler_node7').find('.fa-square-caret-right').css("display","none");
										if (jQuery('#ApplicationStateCornerPositioning_R').is(":visible"))
										{
											jQuery('.float_hepler_node7').find('.fa-square-caret-left').css("visibility","visible");
											jQuery('.float_hepler_node7').find('.fa-square-caret-left').css("display","inline-block");
										} else 
										if (jQuery('#ApplicationStateCornerPositioning_L').is(":visible"))
										{
											jQuery('.float_hepler_node7').find('.fa-square-caret-right').css("visibility","visible");
											jQuery('.float_hepler_node7').find('.fa-square-caret-right').css("display","inline-block");
										} 
										
										jQuery('.float_hepler_node7').find('.fa-square-caret-up').css("visibility","hidden");
										jQuery('.float_hepler_node7').find('.fa-square-caret-down').css("visibility","hidden");
										jQuery('.float_hepler_node7').find('.fa-square-caret-up').css("display","none");
										jQuery('.float_hepler_node7').find('.fa-square-caret-down').css("display","none");
										if
										( 
											(jQuery('#ApplicationStateCornerPositioning').is(":visible"))
											&&
											(jQuery('#ApplicationStateCornerPositioning').offset().top<jQuery('#ApplicationLogoCorner').offset().top)
										)
										{
											jQuery('.float_hepler_node7').find('.fa-square-caret-down').css("visibility","visible");
											jQuery('.float_hepler_node7').find('.fa-square-caret-down').css("display","inline-block");
										} else 
										if 
										(
											(jQuery('#ApplicationStateCornerPositioning').is(":visible"))
											&&
											(jQuery('#ApplicationStateCornerPositioning').offset().top>jQuery('#ApplicationLogoCorner').offset().top)
										)
										{
											jQuery('.float_hepler_node7').find('.fa-square-caret-up').css("visibility","visible");
											jQuery('.float_hepler_node7').find('.fa-square-caret-up').css("display","inline-block");
										} 
													
}
function HighContrastSwitch(valIn)
{
										if (valIn=='Y')
										{
										var sender_id = 	"|"+jQuery(document.body).attr('pagename')+"|LogoCorner|switch_hicontrast|";	
										var sender_el = document.getElementById(sender_id);
											sendData(document.body.id+"LogoCorner|",sender_el,"ComponentsBasic.LogoCorner");
											jQuery(".float_helper").css("visibility","hidden");
										} else
										if (valIn=='N')
										{
										var sender_id = 	"|"+jQuery(document.body).attr('pagename')+"|LogoCorner|switch_normalcontrast|";	
										var sender_el = document.getElementById(sender_id);
											sendData(document.body.id+"LogoCorner|",sender_el,"ComponentsBasic.LogoCorner");
											jQuery(".float_helper").css("visibility","hidden");
										}
}

/*
function LogoCornerTriggerSliderActivate_old(elemId,pageNameIn)
{	
		var 								ApplicationLogoCorner_el 																			= document.getElementById("ApplicationLogoCorner");
		
		//var 								body_content_area_el 																				= document.getElementById(document.body.id+"ContentArea|");
		var 								elem 																								= document.getElementById(elemId);

		var									HTML_blocks																							="";		
											for(var g=0;g<16;++g)
											{
												HTML_blocks += "<div style='position:absolute;left:"+(g*25+2)+"px;top:0;width:20px;background-color:lime;height:15px;border:1px solid green;border-radius:3px;'> </div>"		
											}
										  	jQuery(document.body).append
											(
												
												"<div id='ApplicationLogoCorner_disclaimer' style='position:absolute;z-index:100000;top:10px;left:10px;bottom:10px;right:10px;background-color:#f1efefe3;visibility:hidden;'>"+
														"<div style='position:absolute;top:10px;left:40px;right:40px;height:300px;width:450px;background-color:lightgrey;border-radius:5px;' >"+
														"</div>"+
														"<div  style='position:Absolute;left:50px;top:20px;height:75px;width:430px;font-family:Arial;font-size:15px;font-weight:600;;text-align:center;background-color:aliceblue;color:darkcyan;border-radius:0px;border:1px solid lightblue;'>Scelta del tempo di attesa della applicazione. Spostamento a sisnistra maggiore tempo a disposizione. Spostamento a destra maggior riservatezza. </div>"+
														"<div id = 'ApplicationLogoCorner_magnifier_moretime' class='button_generic_widthfromserver secondary' style='position:Absolute;left:100px;top:110px;height:25px;width:340px;font-family:Arial;font-size:20px;border:1px solid lightgrey;color:blue;text-align:center;background-color:lightgrey;border-radius:3px;cursor:pointer;'><span class='emcaption' style='width:85%;text-align:center;white-space:nowrap;'><<<<< Maggior Tempo a disposizione </span></div>"+
														"<div id='ApplicationLogoCorner_disclaimer_dd' style='position:absolute;left:100px;top:140px;width:340px;height:50px;background-color:transparent;'>"+
															"<div id='TimeSlider_available_time_magnified' style='width:340px;position:absolute;left:0;top:0;height:50px;border:none;overflow:hidden;background-color:white;'>"+
																""+HTML_blocks+
															"</div>"+
															"<div id='TimeSlider_setter' style='position:absolute;left:0;top:20px;height:30px;width:10px;background-color:yellow;'></div>"+
														"</div>"+
														"<div id = 'ApplicationLogoCorner_magnifier_lesstime' 	class='button_generic_widthfromserver secondary' style='position:Absolute;left:100px;top:200px;height:25px;width:340px;font-family:Arial;font-size:20px;border:1px solid lightgrey;color:blue;text-align:center;background-color:lightgrey;border-radius:3px;cursor:pointer;'><span class='emcaption' style='width:85%;text-align:center;'>Maggior Riservatezza >>>>> </span></div>"+
														"<div id = 'ApplicationLogoCorner_magnifier_hide' 		class='button_generic_widthfromserver primary' style='position:Absolute;left:100px;top:250px;height:25px;width:340px;font-family:Arial;font-size:20px;border:1px solid lightgrey;color:blue;text-align:center;background-color:lightgrey;border-radius:3px;cursor:pointer;'><span class='emcaption' style='width:100%;text-align:center;'>OK</span> </div>"+
												"</div>"
											);
								var 		ApplicationLogoCorner_disclaimer_el 															= document.getElementById("ApplicationLogoCorner_disclaimer");
								var 		ApplicationLogoCorner_magnifier_moretime_el 													= document.getElementById("ApplicationLogoCorner_magnifier_moretime");
								var 		ApplicationLogoCorner_magnifier_lesstime_el 													= document.getElementById("ApplicationLogoCorner_magnifier_lesstime");
								var 		ApplicationLogoCorner_magnifier_hide_el 														= document.getElementById("ApplicationLogoCorner_magnifier_hide");
								var 		TimeSlider_setter_el 																			= document.getElementById("TimeSlider_setter");
								
											jQuery(ApplicationLogoCorner_magnifier_hide_el).mousedown(
												function() 
												{
													jQuery(ApplicationLogoCorner_disclaimer_el).css("visibility","hidden");

												}
											);
								
											jQuery(ApplicationLogoCorner_magnifier_lesstime_el).mousedown(function() {
																var 	SliderPosition_ori 	 	= parseInt(elem.style.left);
																var 	ContainmentWidth 		= elem.parentNode.clientWidth;
																var 	SliderPercentage_ori 	= SliderPosition_ori/ContainmentWidth; 
																
																var		SliderPercentage 		= SliderPercentage_ori +0.10;
																		if (SliderPercentage>.9) SliderPercentage=0.9; 
																		//alert('-ContainmentWidth :   SliderPercentage :'+SliderPercentage);
																		jQuery(TimeSlider_setter_el).css("left",parseFloat(SliderPercentage*340)+ "px");
																		TimerSessionGuidanceVerify(pageNameIn,"TresholdChange",SliderPercentage,"null");
														});
											jQuery(ApplicationLogoCorner_magnifier_moretime_el).mousedown(function() {
																var 	SliderPosition_ori 	 	= parseInt(elem.style.left);
																var 	ContainmentWidth 		= elem.parentNode.clientWidth;
																var 	SliderPercentage_ori 	= SliderPosition_ori/ContainmentWidth; 
																		
																var		SliderPercentage 		= SliderPercentage_ori -0.10;
																		if (SliderPercentage<0) SliderPercentage=0.01; 
																		//alert('+ContainmentWidth :   SliderPercentage :'+SliderPercentage);
																		jQuery(TimeSlider_setter_el).css("left",parseFloat(SliderPercentage*340)+ "px");
																		TimerSessionGuidanceVerify(pageNameIn,"TresholdChange",SliderPercentage,"null");
														});
											$(elem).draggable
									  		(
									  			{
									  				axis		: 'x',
									  				containment	: 'parent',
									  				cursor		: 'e-resize',
									  				start: function()
									  								{
														  				jQuery(elem).addClass("draggingnow");
													  				},
									  				stop		: function() 
									  								{
														  				jQuery(elem).removeClass("draggingnow");
																var 	SliderPosition 	 = parseInt(this.style.left);
																var 	ContainmentWidth = this.parentNode.clientWidth;
																var 	SliderPercentage = SliderPosition/ContainmentWidth;
																		//alert('ContainmentWidth : '+ContainmentWidth+ '  SliderPercentage : '+SliderPercentage);
										
																		TimerSessionGuidanceVerify("TresholdChange",SliderPercentage,"null");
									  								}
									  			}
									  		);
								
//			var 							TimeSlider_el 																					= document.getElementById("TimeSlider");
											jQuery(ApplicationLogoCorner_el).mousedown(
												function() 
												{		
													if (jQuery("#LogoCornerUserUname").text().indexOf('UNAUTHENTICATED')>-1)
													{
														//alert('UNAUTHENTICATED');
													}	
													else									
													{
					var 								ApplicationLogoCorner_disclaimer_el 														= document.getElementById("ApplicationLogoCorner_disclaimer");
														//alert("---- uuuu");
														if (!isValidElement(ApplicationLogoCorner_disclaimer_el))
														{
														} else 
														{
															ApplicationLogoCorner_disclaimer_el.style.visibility = "visible";
															jQuery(ApplicationLogoCorner_el).find(".remaining_time").each(
																function()
																{
																	
																}
															);
															//jQuery(ApplicationLogoCorner_disclaimer_el).html("content::::::");
															
						var 								sliderauthenticationshieldtreshold_perc_init											= parseFloat(jQuery(elem).attr("sliderauthenticationshieldtreshold_perc_init"));
															jQuery(TimeSlider_setter_el).css("left",parseFloat(sliderauthenticationshieldtreshold_perc_init*340)+ "px");
														}
													}

												}
											);											
}
*/

/** 
 * Ajax Callback called by TimerSessionGuidanceVerify
 * @param StringOriIn
 * @returns
 */
function TimerSessionGuidanceImplement(StringOriIn)
{
										if (SessionTimingState!='INVA')
										{
											//console.log("StateImplement_Application():"+StringOriIn);
											//alert("StateImplement_Application:"+StringOriIn);
											//INVA : Invalidate
											//SCSA : Screen Saver Activate
											//IDLE : Idle 
										var String_In 										= replaceAll(StringOriIn,"#", "!" );
										var Uname_In 										= getValueByParName(String_In,'uname');
										var blinkingname_In 								= getValueByParName(String_In,'blinkingname');
										var SliderAuthenticationShieldTreshold_In 			= getValueByParName(String_In,'SliderAuthenticationShieldTreshold');
										var LastCommunicatedServerTime_In 		   			= getValueByParName(String_In,'CurrentServerTime');
										var LastActionServerTime_In 						= getValueByParName(String_In,'LastActionServerTime');
										var LastActionServerTime_hr_In 						= getValueByParName(String_In,'LastActionServerTime_hr');
										var lastping_hr_In 									= getValueByParName(String_In,'lastping_hr');
										var SessionTimingState_In 							= getValueByParName(String_In,'SessionTimingState');
										var SessionIdleLength_In 							= getValueByParName(String_In,'SessionIdleLength');
										var UseScreenSaver_In 								= getValueByParName(String_In,'UseScreenSaver');
										var ActiveMessages_In 								= getValueByParName(String_In,'ActiveMessages');
										var hicontrast_In 									= getValueByParName(String_In,'hicontrast');
										var obj_in_execution_In 							= getValueByParName(String_In,'obj_in_execution');
										 	session_id  									= getValueByParName(String_In,'session_id');
										var user_avail_time_s_In 							= getValueByParName(String_In,'user_avail_time_s');
											session_status_from_server  					= getValueByParName(String_In,'session_status');
									
											//console_log(" 1 session_status_from_server:"+session_status_from_server);
										
										
											jQuery(document.body).attr("lastactionservertime_hr",LastActionServerTime_hr_In);
											jQuery(document.body).attr("lastping_hr",lastping_hr_In);
											jQuery(document.body).attr("user_avail_time_s",user_avail_time_s_In);
											jQuery(document.body).attr("session_id",session_id);
											
											if (obj_in_execution_In=='Y')
											{
												jQuery(document.body).attr("obj_in_execution","OK");
											} else
											{
												jQuery(document.body).attr("obj_in_execution","KO");
											}
											
											if(hicontrast_In=='Y') 
											{
												jQuery(document.body).addClass('hicontrast');
											} else
											{
												jQuery(document.body).removeClass('hicontrast');
											}
											
											$('#LogoCornerUserUname').text(Uname_In);
											$('#PageUseScreenSaver').text("page use screensaver"+UseScreenSaver_In);
											
											$('#blinkingname').text(blinkingname_In);
											$('#SessionGuidanceContent').text('SessionGuidanceContent:'+StringOriIn);
											
											if (UseScreenSaver_In =="false") {$('#TimeSlider').css('display','none');} else if (UseScreenSaver_In =="true") {$('#TimeSlider').css('display','block');}
											
											
											if	(SliderAuthenticationShieldTreshold_In!='NULL')
											{
												//alert('KKKK SliderAuthenticationShieldTresholdIn:'+SliderAuthenticationShieldTresholdIn);
											var SliderAuthenticationShieldTreshold_In_num  	= -1;
												try
												{
													SliderAuthenticationShieldTreshold_In_num  	= parseFloat(SliderAuthenticationShieldTreshold_In);
												}catch(ex)
												{
													
												}
												if (SliderAuthenticationShieldTreshold_In_num>=0)
												{
													//console.log("::::::::"+SliderAuthenticationShieldTreshold_In_num);
													refresh_SliderAuthenticationShieldTreshold(SliderAuthenticationShieldTreshold_In);			
												}
											}
											
											if	(SessionIdleLength_In!='NULL')
											{	
												TimeSliderLength								= SessionIdleLength_In;
											}
											
											if	(LastCommunicatedServerTime_In!='NULL')
											{
												LastCommunicatedServerTime 						= parseInt(LastCommunicatedServerTime_In);
											var d 												= new Date();
											var CurrentTime										= parseInt(d.getTime()/1000);
											
											    ServerClientTimeBias            				= LastCommunicatedServerTime-CurrentTime;
											}
										
											//alert("LastActionServerTime_local : "+LastActionServerTime_local);
											if	(LastActionServerTime_In!='NULL')
											{
												LastActionServerTime 							= LastActionServerTime_In;
											}
										
											//console.log("StateImplement_Application SessionTimingState_In:"+SessionTimingState_In+" curr:"+SessionTimingState);									
											if	(SessionTimingState_In!='NULL')
											{
												//console.log("StateImplement_Application A1 SessionTimingState_In:"+SessionTimingState_In+" SessionTimingState:"+SessionTimingState);
												if (
													(SessionTimingState_In=='SCSA') 
													&& 
													(SessionTimingState!='SCSA')
												)
												{
													//console.log("StateImplement_Application A2 ");
													if (UseScreenSaver_In=='true') 
													{ 
														//console.log("StateImplement_Application A3 ");
														//console_log("switching on AuthShieldS!!!!!!!!!!!!!!!");
														AuthShieldShowHide('show','Y');
													} else 
													{ 
														//console.log("StateImplement_Application A4 ");
														AuthShieldShowHide('show','N');
													}
													implemetMessages(ActiveMessages_In);
												} else 
												if ((SessionTimingState_In=='IDLE'))// && (SessionTimingState=='SCSA'))
												{
													//console.log("StateImplement_Application A5 ");
													//if (UseScreenSaver_In=='true') { AuthShieldShowHide('hide','Y');} else { AuthShieldShowHide('hide','N');}
													AuthShieldShowHide('hide','N');
													implemetMessages(ActiveMessages_In);
												} 
												
												//console.log("StateImplement_Application A7 ");
												//console_log("SessionTimingState_In:"+SessionTimingState_In+"  SessionTimingState:"+SessionTimingState);
												
												SessionTimingState								= SessionTimingState_In; //assign - TimerSessionGuidanceImplement
												
										var 	ExitEl 											= document.getElementById("|"+$(document.body).attr('pagename') +"|LogoCorner|Exit|");
										var 	IndexEl 										= document.getElementById("|"+$(document.body).attr('pagename') +"|LogoCorner|Index|");
										var 	MessagesEl 										= document.getElementById("|"+$(document.body).attr('pagename') +"|LogoCorner|Messages|");
										var 	LanguagesEl 									= document.getElementById("|"+$(document.body).attr('pagename') +"|LogoCorner|Languages|");
										var 	Messages_disclaimerEl 							= document.getElementById("|"+$(document.body).attr('pagename') +"|LogoCorner|Messages_disclaimer|");
									
												if (Uname_In=='STARTING_SESSION_WEB_UNAUTHENTICATED')
												{
													jQuery(IndexEl).css("visibility","hidden");
													jQuery(MessagesEl).css("visibility","hidden");
													//jQuery(LanguagesEl).css("visibility","hidden");
													jQuery(Messages_disclaimerEl).css("visibility","hidden");
													jQuery("#TimeSlider_setter").css("visibility","hidden");
													jQuery("#ApplicationLogoCorner_magnifier_moretime").css("visibility","hidden");
													jQuery("#ApplicationLogoCorner_magnifier_lesstime").css("visibility","hidden");
													if (jQuery('.float_hepler_node3').hasClass('selected')){ LogoCornerFuncts('clear');jQuery('.float_hepler_node3').removeClass('selected');} 		
													jQuery('.float_hepler_node3').addClass('disabled');
													jQuery('.float_hepler_node2').addClass('disabled');
													jQuery('.float_hepler_node1').addClass('disabled');
												}	else //END UNAUTHENTICATED
												{//AUTHENTICATED
													jQuery(IndexEl).css("visibility","visible");
													jQuery(MessagesEl).css("visibility","visible");
													jQuery(LanguagesEl).css("visibility","visible");
													jQuery(Messages_disclaimerEl).css("visibility","visible");
													jQuery("#TimeSlider_setter").css("visibility","visible");
													jQuery("#ApplicationLogoCorner_magnifier_moretime").css("visibility","visible");
													jQuery("#ApplicationLogoCorner_magnifier_lesstime").css("visibility","visible");
													if (SessionTimingState=='IDLE')
													{
														jQuery(LanguagesEl).css("visibility","visible");		
														jQuery(IndexEl).css("visibility","visible");		
														jQuery(MessagesEl).css("visibility","visible");		
									
														jQuery('.float_hepler_node5').removeClass('disabled');
														jQuery('.float_hepler_node3').removeClass('disabled');
														jQuery('.float_hepler_node2').removeClass('disabled');
														jQuery('.float_hepler_node1').removeClass('disabled');
														
														if (jQuery('.float_hepler_nodes.selected').length==0)
														{
															LogoCornerFuncts('timeout');
														}
														jQuery(LanguagesEl).addClass("explainedelement");
														jQuery(IndexEl).addClass("explainedelement");
														jQuery(MessagesEl).addClass("explainedelement");
														jQuery(ExitEl).addClass("explainedelement");
														jQuery(LanguagesEl.parentNode).addClass("explainedelement");
														jQuery(IndexEl.parentNode).addClass("explainedelement");
														jQuery(MessagesEl.parentNode).addClass("explainedelement");
														jQuery(ExitEl.parentNode).addClass("explainedelement");
													} else //END SessionTimingState=='IDLE'
													if (SessionTimingState=='SCSA')
													{
														jQuery('.float_hepler_node5').addClass('disabled');
														jQuery('.float_hepler_node3').addClass('disabled');
														jQuery('.float_hepler_node2').addClass('disabled');
														jQuery('.float_hepler_node1').addClass('disabled');
														
														jQuery('.float_hepler_node3').css('visibility','hidden');
														if (jQuery('.float_hepler_node3').hasClass('selected')){ LogoCornerFuncts('clear');jQuery('.float_hepler_node3').removeClass('selected');} 
														jQuery(LanguagesEl).css("visibility","hidden");		
														jQuery(IndexEl).css("visibility","hidden");		
														jQuery(MessagesEl).css("visibility","hidden");
														
														jQuery(LanguagesEl).removeClass("explainedelement");
														jQuery(IndexEl).removeClass("explainedelement");
														jQuery(MessagesEl).removeClass("explainedelement");
														jQuery(ExitEl).addClass("explainedelement");
														jQuery(LanguagesEl.parentNode).removeClass("explainedelement");
														jQuery(IndexEl.parentNode).removeClass("explainedelement");
														jQuery(MessagesEl.parentNode).removeClass("explainedelement");
														jQuery(ExitEl.parentNode).addClass("explainedelement");
				
													}	else //END SessionTimingState=='SCSA'							
													if (SessionTimingState=='INVA')
													{
														jQuery('.ComponentsBasic-LogoCorner').empty();
														SessionInvalidate();
													}//END SessionTimingState=='INVA'
												}//END AUTHENTICATED USER
											}// END SessionTimingState_In NOT NULL
										} else
										if (SessionTimingState=='INVA')
										{
											SessionInvalidate();
										}
										
										jQuery(document.body).attr("session_status",session_status_from_server);
	}
	
	function implemetMessages(msgsN)
	{
								var 	messageEl 				= document.getElementById("|"+$(document.body).attr('pagename') +"|LogoCorner|Messages|");
								var 	disclaimer_messageEl 	= document.getElementById("|"+$(document.body).attr('pagename') +"|LogoCorner|Messages_disclaimer|");
										if(isValidElement(messageEl)&&isValidElement(disclaimer_messageEl))
										{
									var		container_messageEl 	= messageEl.parentNode;
									var 	zIndex 					= jQuery("#ApplicationStateCorner").css('z-index');
											jQuery(messageEl).css("posiiton","absolute");
											jQuery(messageEl).css("left","0px");
											jQuery(messageEl).css("top","0px");
											jQuery(messageEl).css("top","0px");
											if (isValidElement(container_messageEl))
											{
												if (!isValidElement(disclaimer_messageEl))
												{
													jQuery(container_messageEl).prepend("<span id ='"+"|"+$(document.body).attr('pagename') +"|LogoCorner|Messages_disclaimer|' style='background-color:red;color:white;display:block;position:absolute;left:0;top:0;'></span>");
												} else
												{
												}
												
												if (parseInt(msgsN)>0)
												{
													disclaimer_messageEl 	= document.getElementById("|"+$(document.body).attr('pagename') +"|LogoCorner|Messages_disclaimer|");
													jQuery(disclaimer_messageEl).html("&nbsp;"+msgsN+"&nbsp;");
													jQuery(disclaimer_messageEl).css("visibility","visible");
													jQuery(disclaimer_messageEl).css("z-index",zIndex);
													jQuery(disclaimer_messageEl).css("font-family","arial");
													jQuery(disclaimer_messageEl).css("font-size","12px");
													jQuery(disclaimer_messageEl).css("font-weight","600");
													jQuery(disclaimer_messageEl).css("border-radius","6px");
													jQuery(disclaimer_messageEl).css("background-color","red");
													jQuery(disclaimer_messageEl).css("color","white");
													jQuery(disclaimer_messageEl).css("text-aling","center");
													jQuery(disclaimer_messageEl).css("padding","0px");
													jQuery(disclaimer_messageEl).css("top","0px");											
												}else
												{
													disclaimer_messageEl 	= document.getElementById("|"+$(document.body).attr('pagename') +"|LogoCorner|Messages_disclaimer|");
													jQuery(disclaimer_messageEl).css("visibility","hidden");
													jQuery(disclaimer_messageEl).html("");
													jQuery(disclaimer_messageEl).css("background-color","transparent");
												}	
											} else
											{
												disclaimer_messageEl 	= document.getElementById("|"+$(document.body).attr('pagename')+"|LogoCorner|Messages_disclaimer|");
												jQuery(disclaimer_messageEl).css("visibility","hidden");
												jQuery(disclaimer_messageEl).html("");
												jQuery(disclaimer_messageEl).css("background-color","transparent");
											}	
										}
}
	

function SessionInvalidate()
{	
										console_log("####################### session invalidate function");
										
									var url 							= window.location.origin + window.location.pathname;
									var url_tokens 						= url.split('/');
									var pagename 						= url_tokens[url_tokens.length-1];
									var Mypageobjtoken					= sessionStorage.getItem("pageobjtoken");
									var SessionPageFullName				= Mypageobjtoken+"_"+pagename;
									var	data_pagechunk					= 'sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+pagename;
										//console_log("removing item pageobjtoken");
										
										console_log("SessionInvalidate. cookie session deleting ");

										jQuery(document.body).removeClass("IsSW");
										jQuery('.ComponentsBasic-LogoCorner').empty();
										jQuery('.ComponentsBasic-LogoCorner').remove();
										jQuery(document.body).removeAttr("pageobjtoken");
										
										removePageObjToken();
										storeStep(0);
						
										if(getCookie( session_id+"_SESSION_EXPIRED" )=='Y')
										{
											
										}	else	
										{
											$.ajax
											(
												{
													type	: "POST",
													url		: "SessionInvalidate",
													data	: data_pagechunk,
													dataType: "html",
													success	: function(msgBack)
													{
														console_log("####################### session invalidate callback OK");
														setCookie(session_id+"_SESSION_EXPIRED","Y",365);
														implementSssionConnections();
													},
													error: function()
													{
														console.log(" SessionInvalidate error");
														jQuery(document.body).removeClass("IsSW");
														//document.body.innerHTML = msgBack;
													}			 
												}
											);//ajax
										}										
}

function setTimerSplashScreen(SplashScreenTreshold,TimeStep )
{
									var MyTimerId 				= setInterval(function(){ImplementTimerSplashScreen(SplashScreenTreshold);}, TimeStep);
									var element_splashscreen 	= document.getElementById( document.body.id+"ContentArea|splashscreen|");
										$(element_splashscreen).data("timer_id",MyTimerId);
										$(element_splashscreen).data("current_step",parseInt(SplashScreenTreshold/TimeStep));
										$(element_splashscreen).data("max_step"	  ,parseInt(SplashScreenTreshold/TimeStep));
										$(element_splashscreen).css("position","fixed");
										//$(element_splashscreen).css("top","0");
										//$(element_splashscreen).css("left","0");
										$(element_splashscreen).appendTo(document.body);
}

function ImplementTimerSplashScreen(SplashScreenTreshold)
{	
									var element_splashscreen = document.getElementById( document.body.id+"ContentArea|splashscreen|");
										if (element_splashscreen)
										{
										var element_splashscreen_current_step 	= parseInt($(element_splashscreen).data("current_step"));
										var element_splashscreen_max_step 		= parseInt($(element_splashscreen).data("max_step"));
										var percentage 							= element_splashscreen_current_step/element_splashscreen_max_step;
										var timer_id 							= $(element_splashscreen).data("timer_id")
											if (element_splashscreen_current_step==0) {clearInterval(timer_id);			$(element_splashscreen).css("display","none");}
											$(element_splashscreen).data("current_step",parseInt(element_splashscreen_current_step-1));
											
											$(element_splashscreen).css("filter","alpha(opacity="+parseInt(percentage*100)+")");
											$(element_splashscreen).css("opacity",percentage);
										}
}

function makeHiContrast(scopeIn)
{
										if (scopeIn=='Y')
										{
											jQuery(document.body).addClass('hicontrast');
										} else
										if (scopeIn=='N')
										{
											jQuery(document.body).removeClass('hicontrast');
										}
}

function openpage(PageIn)
{
										location.href = PageIn;
}

/**
 * floating menu helper
 */
function accessHelperAction(CurrentStep)
{
										CurrentStep 								= CurrentStep;
									var period_len 									= 40;
									var sin_out  									= Math.sin(2 * Math.PI*(0.5*CurrentStep/period_len));
									var period_N 									= parseInt(0.5*CurrentStep/period_len) ;
										if(jQuery('.float_hepler_node7').length>0)
										{//if helper shield is visibile do not perfrom sosimage loop
											period_N = 3;
										}
										jQuery('#ApplicationLogoCorner').css('cursor','help');
										jQuery('#ApplicationLogoCorner').find('img').css('cursor','help');
									
										//console_log("period_N:"+period_N+"  CurrentStep:"+CurrentStep);

									var sosimage_el 								= null;
									
									var logocorner_el 								= jQuery('.ComponentsBasic-LogoCorner')[0];
										if ( ( isValidElement(logocorner_el))&&(jQuery('#ApplicationLogoCorner').length))
										{
											if (CurrentStep==0)
											{
												if (jQuery(document.body).find('.sosimage').length)
												{
												} else
												{
												var img 								= document.createElement("div");
													jQuery(img).attr('id','sosimage'); 
													jQuery(img).addClass('sosimage');
													
													jQuery(logocorner_el).find('.contentarea').append(img);
													sosimage_el 						= jQuery('.sosimage')[0];
													jQuery(sosimage_el).css('cursor','help');
													
													

													jQuery(sosimage_el).append("<span class='infocorner fa-solid fa-circle-info' style='font-size:110px;color:rgb(60,150,52);color:#0059b3; width:100%;height:100%;position:absolute;left:0px;top:0px;background-color:white;line-height:115px; '></span>");

													jQuery(sosimage_el).css('heigh','100px');
													jQuery(sosimage_el).css('width','100px');
													
													jQuery(sosimage_el).on(
														'mousedown',
														function() 
														{		
															floatHeperImplement();
														}
													);
													jQuery(sosimage_el).on(
														'mouseenter',
														function() 
														{		
																jQuery(this).addClass('hovered');
														}
													);
												}
											}
											
										var logocorner_z 								= parseInt($(logocorner_el).css("z-index"));
											sosimage_el 								= jQuery('.sosimage')[0];
											jQuery(sosimage_el).css("z-index",(logocorner_z+1));
										var bias_left 									= jQuery(jQuery('#ApplicationLogoCorner')[0]).offset().left- jQuery(logocorner_el).offset().left;							
										var bias_top 									= jQuery(jQuery('#ApplicationLogoCorner')[0]).offset().top - jQuery(logocorner_el).offset().top;
										var corner_width								= jQuery(jQuery('#ApplicationLogoCorner')[0]).width();						
										//var corner_height	=	jQuery(jQuery('#ApplicationLogoCorner')[0]).height();
											//console_log('jkljkljklhh corner_left:'+corner_left+' windows scroll leff:'+$(window).scrollLeft());
											jQuery(sosimage_el).css('width',corner_width+'px');
											jQuery(sosimage_el).css('height',corner_width+'px');
											jQuery(sosimage_el).css('position','absolute');
											//jQuery(sosimage_el).css('top',corner_top+'px');
											//jQuery(sosimage_el).css('left',corner_left+'px');

											//console_log('bias_top:'+bias_top+'  logo corner top: '+jQuery(logocorner_el).position().top);
											jQuery(sosimage_el).css('top',bias_top+'px');
											jQuery(sosimage_el).css('left',bias_left+'px');
											
											if (jQuery(logocorner_el).position().top<50)
											{
												if(jQuery(sosimage_el).hasClass('hovered'))
												{
													jQuery(sosimage_el).css('top',(120+bias_top)+'px');
												} 
											} else
											if (jQuery(logocorner_el).position().top>50)
											{
												if(jQuery(sosimage_el).hasClass('hovered'))
												{
													jQuery(sosimage_el).css('top',(-120+bias_top)+'px');
												} 
											}
											
											
											if (period_N==0)
											{
												jQuery(sosimage_el).css('visibility','visible');
												jQuery(sosimage_el).css("display","block");
												jQuery(sosimage_el).css('background-image','url(icons/ipovision.webp)');
												jQuery(sosimage_el).css('background-size','cover');
												jQuery(sosimage_el).attr('alt','High contrast helper');
												jQuery(sosimage_el).find('.infocorner').css('visibility','hidden');
											var clipper_perc 							= parseInt(sin_out*100) ;	

												jQuery(sosimage_el).css("clip-path","circle("+clipper_perc+"%)");
												if (sin_out<0) 
												{
													jQuery(sosimage_el).css('visibility','hidden');
													jQuery(sosimage_el).css("display","none");
													jQuery(sosimage_el).css('background-image','none');
												}
											} else
											if (period_N==1)
											{
												jQuery(sosimage_el).css('visibility','hidden');
												jQuery(sosimage_el).css("display","none");
												jQuery(sosimage_el).css('background-image','none');
												jQuery(sosimage_el).find('.infocorner').css('visibility','hidden');
												jQuery(sosimage_el).removeClass('hovered');
											} else
											if (period_N==2)
											{
												jQuery(sosimage_el).css('visibility','visible');
												jQuery(sosimage_el).css("display","block");
												jQuery(sosimage_el).css('background-image','none');
												jQuery(sosimage_el).find('.infocorner').css('visibility','visible');
											var clipper_perc = parseInt(sin_out*100) ;	
												jQuery(sosimage_el).css("clip-path","circle("+clipper_perc+"%)");

												if (sin_out<0) 
												{
													jQuery(sosimage_el).css('visibility','hidden');
													jQuery(sosimage_el).css("display","none");
													jQuery(sosimage_el).css('background-image','none');
												}
											} else
											if (period_N==3)
											{
												jQuery(sosimage_el).css('visibility','hidden');
												jQuery(sosimage_el).css("display","none");
												jQuery(sosimage_el).css('background-image','none');
												jQuery(sosimage_el).find('.infocorner').css('visibility','hidden');
												jQuery(sosimage_el).removeClass('hovered');
											}
											//console_log('period_N:'+period_N);

											/*if ((CurrentStep<timerMaxStep)&&(CurrentStep>0))
											{
												jQuery(sosimage_el).css("clip-path","n");
												jQuery(sosimage_el).css("visibility","visible");
												
												if (CurrentStep>=fadeoutStep_start)
												{
												var clipper_perc = 100*( 1 - (CurrentStep - fadeoutStep_start)/(fadeoutStep_end - fadeoutStep_start));	
												//var	corner_width_stretch  = corner_width * [(timerMaxStep -faedoutStep) - (CurrentStep-faedoutStep)]/(timerMaxStep -faedoutStep);
													jQuery(sosimage_el).css("clip-path","circle("+clipper_perc+"%)");
													//console_log("clipper_perc:"+clipper_perc);
													//jQuery('.sosimage').css("width",corner_width_stretch+"px");
													//console_log("fading out");
												}
												if (CurrentStep>=fadeoutStep_end)
												{
													jQuery(sosimage_el).css("visibility","hidden");														
													jQuery(sosimage_el).css("display","none");														
													//console_log(" fadeout operative");
												}
												//console_log("CurrentStep:"+CurrentStep);
											}
											*/
										}
}

function sctuncover(evtIn,SwIdIn,ScopeIn,staticEl)
{
						var				pwd_el																					= document.getElementById(SwIdIn+"password|");
										if (isValidElement(pwd_el))
										{
											if (ScopeIn=="load")
											{
												jQuery(staticEl).css("background-color","trasparent");
												jQuery(staticEl).css("background","none");
												jQuery(pwd_el).attr("unsecret_counter","0");
												jQuery(pwd_el.parentNode).find("i").remove();
												jQuery(pwd_el).after("<i class='fa-solid fa-eye' style='position:absolute;top:0;right:0;width:7%;color:green;font-size:140%;'></i>");
											} else
											if (ScopeIn=="do_secret")
											{
												elIn 																				= evtIn.currentTarget;
												jQuery(pwd_el).attr("type","password");
												jQuery(elIn).css("background-color","whitesmoke");
												jQuery(elIn).css("background-image","url(icons/32x32/pwd_view_32x32.png)");
												jQuery(elIn).css("background-color","trasparent");
												jQuery(elIn).css("background","none");
												jQuery(pwd_el).attr("unsecret_counter","0");
												jQuery(pwd_el.parentNode).find("i").remove();
												jQuery(pwd_el).after("<i class='fa-solid fa-eye' style='position:absolute;top:0;right:0;width:7%;color:green;font-size:140%;'></i>");
											} else
											if (ScopeIn=="do_unsecret")
											{
												if (jQuery(pwd_el).attr("type")=="password")
												{
													elIn 																			= evtIn.currentTarget;
													jQuery(pwd_el).attr("type","");
													jQuery(elIn).css("background-color","whitesmoke");
													jQuery(elIn).css("background-image","url(icons/32x32/pwd_hide_32x32.png)");
													jQuery(pwd_el).attr("unsecret_counter","0");
													jQuery(elIn).css("background-color","trasparent");
													jQuery(elIn).css("background","none");
													jQuery(pwd_el.parentNode).find("i").remove();
													jQuery(pwd_el).after("<i class='fa-solid fa-eye-slash' style='position:absolute;top:0;right:0;bottom:0;width:7%;color:grey;font-size:140%;'></i>");
												} else
												{
													elIn 																			= evtIn.currentTarget;
													jQuery(pwd_el).attr("type","password");
													jQuery(elIn).css("background-color","whitesmoke");
													jQuery(elIn).css("background-image","url(icons/32x32/pwd_view_32x32.png)");
													jQuery(elIn).css("background-color","trasparent");
													jQuery(elIn).css("background","none");
													jQuery(pwd_el.parentNode).find("i").remove();
													jQuery(pwd_el).after("<i class='fa-solid fa-eye' style='position:absolute;top:0;right:0;bottom:0;width:7%;color:grey;font-size:140%;color:green;'></i>");
												}
											}
										}
}

function usernameswitchState()
{
										if (document.getElementById("blinkingname")!=null)
										{
										var elem								= document.getElementById("blinkingname");
											elem.style.visibility				= (elem.style.visibility=='visible'?'hidden':'visible');
											timeSliderAdjust();
										}
}

function ZoomTimer()
{
				var						MyZoomRatio_el							= document.getElementById("MyZoomRatio");
				var						MyZoomRatio_Now							= detectZoom.zoom();
										if (MyZoomRatio!=0)
										{
											if (MyZoomRatio_Now!=MyZoomRatio)
											{
												
												//document.body.style.zoom = "1";
												zoom_css_component = 1;
												ZoomCSSComponentImplement();
												
												console_log("******************************************** ZOOM CHANGE EVENT ********************************************");
												if (MyZoomRatio_Now>MyZoomRatio)
												{
													console_log("########### zoom increasing.........");
													ManageZoomChange();
												}else
												{
													console_log("########### zoom decreasing.........");
													ManageZoomChange();
												}
											}
										}
										MyZoomRatio								= MyZoomRatio_Now;
										Window_innerHeight 						= $(window).height();
										Window_innerWidth 						= $(window).width();
										jQuery('.float_helper_board_zoomvalue').text(parseInt(MyZoomRatio*100)+"%");
					
										$(MyZoomRatio_el).html("<span style='font-family:arial;font-size:12px;'>zoom : "+MyZoomRatio+"</span><br><span >Window_innerHeight : "+Window_innerHeight+"</span><br><span >Window_innerWidth:"+Window_innerWidth+" </span>");
}

function generalTimer()
{
									var ApplicationLogoCorner_el 							= document.getElementById('ApplicationLogoCorner');
									var ApplicationStateCorner_el 							= document.getElementById('ApplicationStateCorner');
									var ApplicationLogoCorner_loadshadower_el 				= document.getElementById('ApplicationLogoCorner_loadshadower');
									
									var stephover 											= jQuery(ApplicationLogoCorner_el).attr('stephover');
									var GeneralTimerIndex 									= getTimerPositionByHandler('generaltimer');
										if (GeneralTimerIndex == -1)
										{
					var						interval										= 250;
												//		var MyTimerId = setInterval(function(){schedule_operations();}, schedule_operations_interval);
												//		addTimer(MyTimerId, 0, 'schedule_operations',schedule_operations_interval);
											addTimer(setInterval(function(){generalTimer();}, interval), 0, 'generaltimer',interval);
											GeneralTimerIndex 								= getTimerPositionByHandler('generaltimer');
										} else
										{
											++arrayTimers[GeneralTimerIndex].Step;
										}
										

										if (arrayTimers[GeneralTimerIndex].Step == 1000) arrayTimers[GeneralTimerIndex].Step = 0;
										//console_log("general timer step:"+arrayTimers[GeneralTimerIndex].Step);
										//console_log("GeneralTimerIndex:"+GeneralTimerIndex);
										
										//TriggerToolTipText after 5 seconds
										if (arrayTimers[GeneralTimerIndex].Step %1000 == 20 ) {TriggerToolTipText();}

										if (arrayTimers[GeneralTimerIndex].Step %4 == 0 ) {usernameswitchState();}
										accessHelperAction((arrayTimers[GeneralTimerIndex].Step+80) %300);//each 25 seconds
										if (arrayTimers[GeneralTimerIndex].Step %8 == 0 ) {ZoomTimer();}										
										
										
										if (arrayTimers[GeneralTimerIndex].Step %12 == 0 ) {ConnectionServerCheck();}
										
										if (arrayTimers[GeneralTimerIndex].Step %12 == 5 ) {TimerSessionGuidanceVerify("ScheduledCall","null","null");}

										if (arrayTimers[GeneralTimerIndex].Step %2 == 0 ) {TimerUserMessages();}
										
										if (arrayTimers[GeneralTimerIndex].Step %12 == 5 ) {implementSssionConnections();}


										jQuery(ApplicationLogoCorner_loadshadower_el).css("visibility","hidden");
										if(stephover==-1)
										{
											jQuery(ApplicationStateCorner_el).attr('stephover',++stephover);
											ApplicationStateCornerWide(ApplicationLogoCorner_el);
											floatHeperImplement();												
										}	else
										{
											if (stephover<0) 
											{
												jQuery(ApplicationLogoCorner_el).attr('stephover',++stephover);
												jQuery(ApplicationLogoCorner_loadshadower_el).css("width",(100+stephover*10)+"%");
												jQuery(ApplicationLogoCorner_loadshadower_el).css("height","3px");
												jQuery(ApplicationLogoCorner_loadshadower_el).css("visibility","visible");
												jQuery(ApplicationLogoCorner_loadshadower_el).css("background-color","blue");
											} 
										}
}

function LogoCornerCommands(elIn)
{
										if (elIn.id==document.body.id+'LogoCorner|Exit|')
										{
											SessionInvalidate();
										} else
										if (elIn.id==document.body.id+'LogoCorner|Index|')
										{
											LogoCornerFuncts('index');		
										} else
										if (elIn.id==document.body.id+'LogoCorner|Messages|')
										{
											LogoCornerFuncts('messages');
										} else
										if (elIn.id==document.body.id+'LogoCorner|Languages|')
										{
											LogoCornerFuncts('languages');
										} else
										if (elIn.id=='blinkingname')
										{
											LogoCornerFuncts('openpersonalpage');
										}
}

function addUserMessage(isHTML,MessageIn)
{
	
										//console_log("is_sent:"+isSent+" message:"+MessageIn);
										//$.playSound("sounds/alert");
										$.playSound("sounds/alert_new");
										
										//var TimerUserMsssagesPosition 		= getTimerPositionByHandler('TimerUserMsssages');
										//	if (TimerUserMsssagesPosition<0) {	addTimerUserMessages('TimerUserMsssages')};
										//	TimerUserMsssagesPosition 		= getTimerPositionByHandler('TimerUserMsssages');
										
										//alert("TimerUserMsssagesPosition : "+TimerUserMsssagesPosition);
	var 								MessageInVerified 	 			= replaceAll(MessageIn,"#A#", "'" );

	var									ApplicationStateCorner_el 		= document.getElementById('ApplicationStateCorner');
	var									ApplicationLogoCorner_el 		= document.getElementById('ApplicationLogoCorner');
	
	var 								ApplicationLogoCorner_el_width = $(ApplicationLogoCorner_el).innerWidth();
										//alert("ApplicationStateCorner_el_width:"+ApplicationLogoCorner_el_width);
	var									UserMessageBox			  		= document.getElementById('UserMessageBox');
										if ((typeof UserMessageBox == "undefined")||(UserMessageBox==null))
										{
											jQuery(ApplicationStateCorner_el).append("<div id='UserMessageBox' style='margin:0;padding:0;height:800px;width:"+parseInt(ApplicationLogoCorner_el_width)+"px;border:1px solid green;'></div>");
										}
										
	var									d 								= new Date();
	var									CurrentTime						= parseInt(d.getTime()/1000);


	var									UserMessageBox					= document.getElementById('UserMessageBox');
										UserMessageBox.innerHTML		+= "<div creation_time='"+CurrentTime+"' class='usermessagebox_element'  style='margin:0;margin-top:15px;padding:0;position:relative;border:1px solid green;width:"+parseInt(ApplicationLogoCorner_el_width-2)+"px;width:"+messageWidth+"px;'>" +
																		   "   <div class='usermessagebox_header' 			style='position:absolute;height:25px;line-height:25px;margin:0;padding:0;top:0;background-color:rgb(54, 146, 193);width:"+parseInt(ApplicationLogoCorner_el_width-4)+"px;color:white;font-family:arial;font-size:15px;font-weight:600;text-align:center;width:"+messageWidth+"px;'><i class='fa-solid fa-triangle-exclamation' style='position:absolute;left:8px;font-size:26px;color:orange;color:orange;'></i> Attenzione </div>" +
																		   "   <div class='usermessagebox_closer' 			style='position:absolute;height:25px;width:25px;top:0;right:0;background-color:orange;' o_nmousedown=\"removeUserMessage(this)\"> <i class='fa-solid fa-xmark'></i></div>" +
																		   "   <div class='usermessagebox_backgrounder'		style='position:absolute;top:25px;left:0;bottom:0;right:0;background-image:url(images/mytexture.webp);opacity: 0.3;filter: alpha(opacity=30);background-color:white;'></div>" +
																		   "   <div class='usermessagebox_docker' 			style='position:absolute;top:25px;bottom:0;width:100%;min-height:30px;background-color:white;background-color:lime;text-wrap: balance;width:"+messageWidth+"px;font-family:arial;font-size:15px;'><br>"+MessageInVerified+"<br>&nbsp;&nbsp;&nbsp;<br></div>" +
																		   "</div>";
																		   
										jQuery(UserMessageBox).find('.usermessagebox_closer').css('cursor','pointer');
										jQuery(UserMessageBox).find('.usermessagebox_closer').css('background-color','trasparent');
										jQuery(UserMessageBox).find('.usermessagebox_closer').css('background-image','none');
										jQuery(UserMessageBox).find('.usermessagebox_closer').addClass('fa-solid');
										jQuery(UserMessageBox).find('.usermessagebox_closer').addClass('fa-xmark');
										jQuery(UserMessageBox).find('.usermessagebox_closer').off();
										jQuery(UserMessageBox).find('.usermessagebox_closer').on("mousedown",
											function(event)
											{
												removeUserMessage(event.target);
											}
										);
										
										UserMessageBox_Adjust_Height($("#UserMessageBox").find(".usermessagebox_element"));

										//ApplicationStateCornerPositionChange('translate_h');
										ApplicationStateCornerPositionChange('');
										
}

function removeUserMessage(elementIn)
{
								var		els_hide = 	jQuery(elementIn).closest(".usermessagebox_element");
										jQuery(els_hide).css("border","2px solid green");
										jQuery(els_hide).css("visibility","hidden");
										jQuery(els_hide).css("display","none");
										jQuery(els_hide).css("height","0");
										jQuery(els_hide).css("overflow","hidden");
										jQuery(els_hide).attr("creation_time",'0');
										UserMessageBox_Adjust_Height($("#UserMessageBox").find(".usermessagebox_element"));
										TimerUserMessages();
										//alert("found:"+els_hide.length);
}

function TimerUserMessages()
{
								var 	UserMessagesArray 		  = $("#UserMessageBox").find(".usermessagebox_element");
										$("#debuggeroutput_content").html("User Messages N.:"+UserMessagesArray.length);
								var 	d 						  = new Date();
								var 	CurrentTime				  = parseInt(d.getTime()/1000);
										for(var i=0;i<UserMessagesArray.length;++i)
										{
									var 	UserMessage_creation_time = parseInt($(UserMessagesArray[i]).attr("creation_time"));
									
											//console_log("i#"+i+"  TimerUserMessages : "+parseInt(CurrentTime-UserMessage_creation_time));
											if (parseInt(CurrentTime-UserMessage_creation_time) > 12)
											{
												RemoveElement(UserMessagesArray[i]);
												UserMessagesArray.splice(i,1);
											}
											$("#debuggeroutput_content").html("creation_time :"+UserMessage_creation_time);
										}
										UserMessageBox_Adjust_Height(UserMessagesArray);
										//alert("TimerUserMessages....");
}

function UserMessageBox_Adjust_Height(UserMessagesArray)
{
									var UserMessageBox_el_Height	  = 0;
										for(var i=0;i<UserMessagesArray.length;++i)
										{
											if (!jQuery(UserMessagesArray[i]).hasClass('processed'))
											{
												jQuery(UserMessagesArray[i]).addClass('processed');
											var	usermessagebox_header_el = jQuery(UserMessagesArray[i]).find('.usermessagebox_header')[0]; 
												
											var childs_dims 		= childsBoundings(jQuery(UserMessagesArray[i]).find('.usermessagebox_docker') );
											var usermessagebox_w 	= jQuery(UserMessagesArray[i]).width();
											
											
											var usermessagebox_docker_target_w = Math.max(parseInt(childs_dims.w), parseInt(usermessagebox_w));
												jQuery(UserMessagesArray[i]).css("width",usermessagebox_docker_target_w+"px");
												jQuery(UserMessagesArray[i]).find('.usermessagebox_docker').css("width",usermessagebox_docker_target_w+"px");
								
												childs_dims 		= childsBoundings(jQuery(UserMessagesArray[i]).find('.usermessagebox_docker') );
											
											var usermessagebox_h 	= jQuery(UserMessagesArray[i]).height();
								
											var usermessagebox_docker_target_h = Math.max(parseInt(childs_dims.h), parseInt(usermessagebox_h));
												
												
												//console_log("target_h:"+target_h+" childs.h:"+childs_dims.h);
											var usermessagebox_target_h = usermessagebox_docker_target_h +(isValidElement(usermessagebox_header_el)?jQuery(usermessagebox_header_el).height():0);
													
								
												/*console_log("   usermessagebox_h:"+usermessagebox_h  +"header : "+(isValidElement(usermessagebox_header_el)?jQuery(usermessagebox_header_el).height():0)
												
												+"   width "+usermessagebox_docker_target_w
												);*/
												jQuery(UserMessagesArray[i]).css("height",usermessagebox_target_h);
											}
											UserMessageBox_el_Height += jQuery(UserMessagesArray[i]).height()+10;
										}//UserMessagesArray
										if (UserMessagesArray.length==0) {UserMessageBox_el_Height=0;}
										if (isValidElement(document.getElementById('UserMessageBox'))) 
										{//maybe not still created
											document.getElementById('UserMessageBox').style.height = UserMessageBox_el_Height+"px";
										}
}var CurrentZINDEX 				= 1;
var CurrentMAX_ZINDEX 			= 1;
var CurrentLISTVISIBLELEVELS 	= "";
//Used by ServerCallBackTokenize
// 	This variable keeps track of the higher z-index of the Page at the current point of time. 
//  CurrentMAX_ZINDEX or CurrentZINDEX could change at each Server answer in ServerCallBackTokenize
//	Once found the higher level of visible Objects all elements with z-Index between CurrentMAX_ZINDEX and 50 are deleted
//  CurrentZINDEX was replaced by CurrentMAX_ZINDEX being more appropriate
//  CurrentZINDEX and CurrentMAX_ZINDEX 
//  CurrentZINDEX is kept for backward compatibility

var InitialPage 				= -1;
var DivScrollInfoString 		= "";

//var FadeColorValue = 0;
var FadeID						= 0;

var ServerFailMessage   		= "Si e' verificato un problema di comunicazione con il server.\nPremere F5 per ripristinare la pagina!";

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////   arrayLockedSW /////////////////////////////////////////////////////////////////////////////////
var arrayLockedSW				= [];
var ServerState					= [];

var JSEMBEDDED_ARRAY 			= [];
var SW_notvisiblelist 			= "";


var curreModRowFromServer = [];


function generateLockedSWElement(IdentifierIn) 
{
    		this.Identifier 					= IdentifierIn;
}

function addLockedSW(IdentifierIn)
{
	var myarrayLockedSWElement 					= new generateLockedSWElement(IdentifierIn);
		arrayLockedSW.push(myarrayLockedSWElement);
}

function retrieveArrayPositionLockedSWByIdentifier(IdentifierIn)
{
	var posOut = -1;
		if (IdentifierIn!=null)
		{
			for(var h=0;h<arrayLockedSW.length;++h)
			{
				//console_log("eeeeeeee arrayLockedSW:"+arrayLockedSW[h].Identifier+" IdentifierIn:"+IdentifierIn);
				if (arrayLockedSW[h].Identifier == IdentifierIn)
				{
					posOut=h;
				}
			}
		}
		return posOut;
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function gopageElfadeout(ElementInBaseId,FadeColorValue)
{
	var 						AskedPageElementId       = ElementInBaseId+"TableForm|CurrentPage|";
	var 						CurrentPageMemoElementId = ElementInBaseId+"TableForm|CurrentPageMemo|";
	var 						FaderCounterElementId    = ElementInBaseId+"TableForm|FaderCounter|";
	var 						FaderIDElementId    	 = ElementInBaseId+"TableForm|FaderID|";
	var 						gopageElementId 	 	 = ElementInBaseId+"TableForm|gopage|";
	var 						gopageElement   	     = document.getElementById(gopageElementId);

								if(FadeColorValue < 255) 
								{ 
									FadeColorValue += 10; 
									document.getElementById(AskedPageElementId).style.backgroundColor	= "rgb(255,255,"+FadeColorValue+")";;
									document.getElementById(FaderCounterElementId).value 				= FadeColorValue;
				var 				FaderIDInternal=setTimeout(function(){gopageElfadeout(ElementInBaseId,FadeColorValue);}, 100);
							
									document.getElementById(FaderIDElementId).value = FaderIDInternal;
								}else 
								{
				var 				FaderIdInternal 																					= document.getElementById(FaderIDElementId).value;
									FadeColorValue 																						= 0; 
									clearTimeout(FaderIdInternal);
									gopageElement.style.visibility																		= 'hidden';
									jQuery(gopageElement.parentNode).find('*').css('visibility','hidden');
									document.getElementById(AskedPageElementId).value													= document.getElementById(CurrentPageMemoElementId).value;
									document.getElementById(FaderCounterElementId).value 												= 0;
									jQuery(gopageElement).removeClass('cangopage');
								}
}

function elementSwitchVisibility(ElementIdIn,ColorIn) 
{
	var 						elem						= document.getElementById(ElementIdIn);
								elem.style.backgroundColor  = ColorIn;
		//elem.style.visibility=(elem.style.visibility=='visible'?'hidden':'visible');
} 

function BlinkPageSelection(AskedPageElement) 
{//not found any call to this function. Delete?
	var 						interval = 100;
	var 						AskedPageElementId = AskedPageElement.id; 
							   // var elem=document.getElementById(GoPageElementId);
							    for (var wi=0;wi<5;++wi)
							    {
							    	setInterval(function(){elementSwitchVisibility(AskedPageElementId,'red');},interval);
							    	setInterval(function(){elementSwitchVisibility(AskedPageElementId,'blue');},interval);
							    	
							//    	elem.style.visibility='hidden';
							//    	pausecomp(interval); 
							//    	elem.style.visibility='visible';
							//    	pausecomp(interval); 
							
							//        elem.style.visibility=(elem.style.visibility=='visible'?'hidden':'visible');
							    }
}

function IsValidInteger(value) 
{
				var OutValue = true;
				var intValue = -1;
				    if (value.length == 0) 
				    {
				    	OutValue =  false;
				    }
					try
					{
					     intValue = parseInt(value);
					}catch(err)
					{
				    	OutValue =  false;
					}
				    if (intValue*0 == 0) 
				    {
				    	OutValue=true;
				    }else
				    {
				    	OutValue =  false;
				    }
				
				    if (intValue <= 0)
				    {
				    	OutValue =  false;
				    }
				    intValue=0;
				    return OutValue;
}

function validateNumberInsert(evt,element)
{
		//if((evt.keyCode!=8)&&(evt.keyCode!=13))
		if (evt.keyCode!=8)
		{//working
		var theEvent = evt || window.event;

		var key = theEvent.keyCode || theEvent.which;
			key = String.fromCharCode( key );
			
		var regex = /[0-9]|\./;

			if( !regex.test(key) )
			{
				theEvent.returnValue = false;
				if(theEvent.preventDefault) theEvent.preventDefault();
			}
		}
	
		if (evt.keyCode==13)
		{//not working at 20200315......feature implemented into PageChangeControl(ElementIn) method 
			var ElementInId 			= element.id;
			//var AskedPage 				= element.value;
			var ElementInBaseId 		= "";
			var ElementInIdTokens 		= ElementInId.split("|");
			var ElementInIdTokensNumber = ElementInIdTokens.length;
				for(var i=0;i<ElementInIdTokensNumber-3;++i)
				{
					ElementInBaseId=ElementInBaseId+ElementInIdTokens[i]+"|";
				}
	//		var TotalPagesElementId 	 = ElementInBaseId+"TableForm|TotalPages|";
	//		var TotalPagesElement        = document.getElementById(TotalPagesElementId);
	//		var TotalPages 				 = TotalPagesElement.value;
			
	//		var CurrentPageMemoElementId = ElementInBaseId+"TableForm|CurrentPageMemo|";
	//		var CurrentPageMemoElement 	 = document.getElementById(CurrentPageMemoElementId);
	//		var CurrentPageMemo 		 = CurrentPageMemoElement.value;
	
			var gopageElementId 	 	 = ElementInBaseId+"TableForm|gopage|";
			var gopageElement   	     = document.getElementById(gopageElementId);
	
	//		var FaderIDElementId 		 = ElementInBaseId+"TableForm|FaderID|";
			
	//		var FormElementId 		     = ElementInBaseId+"TableForm|";
	//		var FormElement			 	 = document.getElementById(FormElementId);
			
				if (element.value.length>0)
				{
					gopageElement.click();
					///FormElement.submit();
				}
		}
}

function PageChangeControl(ElementIn)
{
		//console_log("__________PageChangeControl:"+ElementIn.id+"   >>>>>>>>>>>>> "+getKeyCodeOnKeyDown(ElementIn.event));
		if (getKeyCodeOnKeyDown(ElementIn.event)==13)
		{
		var LMSW 						= jQuery(ElementIn).closest(".IsSW")[0];
		var gopageElementId 	 	 	= LMSW.id+"TableForm|gopage|";
		var gopageElement   	     	= document.getElementById(gopageElementId);
			if (jQuery(gopageElement).hasClass('cangopage'))
			{
				//gopageElement.click();
			var myevent	= new customEventGenerate('mousedown',gopageElement);
				CAclient(LMSW.id,gopageElement,myevent,'Components.ListManager','#@@PPFEEDBACKACTION@@# #@@VVSENDDATA@@#',true);
			}
		} else
		{
		var ElementInId 					= ElementIn.id;
		var AskedPage 						= ElementIn.value;
		var ElementInBaseId 				= "";
		var ElementInIdTokens 				= ElementInId.split("|");
		var ElementInIdTokensNumber 		= ElementInIdTokens.length;
			for(var i=0;i<ElementInIdTokensNumber-3;++i)
			{
				ElementInBaseId					= ElementInBaseId+ElementInIdTokens[i]+"|";
			}
		var TotalPagesElementId 	 		= ElementInBaseId+"TableForm|TotalPages|";
		var TotalPagesElement        		= document.getElementById(TotalPagesElementId);
		var TotalPages 				 		= TotalPagesElement.value;
		
		var CurrentPageMemoElementId 		= ElementInBaseId+"TableForm|CurrentPageMemo|";
		var CurrentPageMemoElement 	 		= document.getElementById(CurrentPageMemoElementId);
		var CurrentPageMemo 		 		= CurrentPageMemoElement.value;

		var gopageElementId 	 	 		= ElementInBaseId+"TableForm|gopage|";
		var gopageElement   	     		= document.getElementById(gopageElementId);
			gopageElement.style.visibility  = 'hidden';
			
			jQuery(gopageElement.parentNode).find('*').css('visibity','hidden');

		var FaderIDElementId 		 		= ElementInBaseId+"TableForm|FaderID|";


		var FaderIdInternal 				= document.getElementById(FaderIDElementId).value;
			clearTimeout(FaderIdInternal);
		
			if (AskedPage.length==0)
			{
				gopageElfadeout(ElementInBaseId,0);
			} else
			{
				if ((parseInt(AskedPage) > 0 ) && (parseInt(AskedPage)<=parseInt(TotalPages)))
				{
					if (parseInt(AskedPage)==parseInt(CurrentPageMemo))
					{
						
					}else
					{
						gopageElement.style.visibility = 'visible';
						jQuery(gopageElement).addClass('cangopage');
						jQuery(gopageElement.parentNode).find('*').css('visibility','visible');
						gopageElfadeout(ElementInBaseId,0);
					}
				}else
				{
					ElementIn.value = CurrentPageMemo;
				}
			}
		}
}

function PageBeforeChangeControl(elementIn)
{
	InitialPage = elementIn.value;
}

//Gets the browser specific XmlHttpRequest Object
function getXmlHttpRequestObject() 
{
	if (window.XMLHttpRequest) 
	{
		return new XMLHttpRequest();
	} 
	else 
		if(window.ActiveXObject) 
		{
			return new ActiveXObject("Microsoft.XMLHTTP");
		} 
		else 
		{
			//Display your error message here. 
			//and inform the user they might want to upgrade
			//their browser.
		}
}

//Initiate the asyncronous request.
function sayHello() 
{
	//If our XmlHttpRequest object is not in the middle of a request, start the new asyncronous call.
	if (receiveReq.readyState == 4 || receiveReq.readyState == 0) 
	{
		//Setup the connection as a GET call to SayHello.html.
		//True explicity sets the request to asyncronous (default).
		receiveReq.open("GET", 'SayHello.html', true);
		//Set the function that will be called when the XmlHttpRequest objects state changes.
		receiveReq.onreadystatechange = handleSayHello; 
		//Make the actual request.
		receiveReq.send(null);
	}
}

function allowSendSubmit(submittingForm ) 
{
	submittingForm.submit;
}

var receiveReq = getXmlHttpRequestObject();

//Called every time our XmlHttpRequest objects state changes.
function handleSayHello() 
{
	//Check to see if the XmlHttpRequests state is finished.
	if (receiveReq.readyState == 4) 
	{
		//Set the contents of our span element to the result of the asyncronous call.
		document.getElementById('span_result').innerHTML = receiveReq.responseText;
	}
}
/*
function handleDivScrollParameters() 
{
	//Check to see if the XmlHttpRequests state is finished.
	if (receiveReq.readyState == 4) 
	{
		//Set the contents of our span element to the result of the asyncronous call.
		var fromServer = receiveReq.responseText;
		var StartAnswerPos = fromServer.search('<ANSWER>');
		var EndAnswerPos = fromServer.search('</ANSWER>');
		
		if((StartAnswerPos>-1)&& (EndAnswerPos>-1))
		{
			var AnswerString = fromServer.substring(StartAnswerPos+8,EndAnswerPos);	
			DivsPositioningTool(AnswerString);
		}
	}
}*/

function downloadDivScrollParameters(fromServer) 
{
	//Check to see if the XmlHttpRequests state is finished.
		//Set the contents of our span element to the result of the asyncronous call.
		//var fromServer = receiveReq.responseText;
	var StartAnswerPos = fromServer.search('<ANSWER>');
	var EndAnswerPos = fromServer.search('</ANSWER>');

		if((StartAnswerPos>-1)&& (EndAnswerPos>-1))
		{
		var AnswerString = fromServer.substring(StartAnswerPos+8,EndAnswerPos);	
			DivsPositioningTool(AnswerString);
		}
}

function findFormsAndScrollableDivs()
{
	var 	countDivs 			= document.getElementsByTagName('div').length;
	var 	StringOut			= '';
	var  	countScrollableDivs	= 0;

		for(var i=0;i<countDivs;++i)
		{
		var StringChunk	= '';
		var ename 		= document.getElementsByTagName('div')[i].id;
			if(ename.search('scrollablediv')>-1)
			{
				++countScrollableDivs;
			var ScrollLeft  = document.getElementById(ename).scrollLeft;
			var ScrollTop  = document.getElementById(ename).scrollTop;
				StringChunk = ename+";"+ScrollLeft+";"+ScrollTop+ ",";

				StringOut=StringOut+StringChunk;
			}
	}
var countForms=addOnSubmitFormElements();

	if ((countForms>0)&&(countScrollableDivs>0))
	{
		try
		{
			var jsmonitorelement=document.getElementById('jsControlsState');
			var jsmonitorelementstyle 	= jsmonitorelement.getAttribute("style");
				jsmonitorelementstyle	= jsmonitorelementstyle+'background-color:red;';
				jsmonitorelement.setAttribute('style', jsmonitorelementstyle);
		}catch(err)
		{
			alert('errore:'+err);
		}
		sendParam(StringOut);
	}
    //setTimeout("FindScrollableDivs()",3000);
}

function manageDivScrollInfo()
{
	DivScrollInfoString=generateDivScrollInfoString();
	//writeDivScrollInfoStringIntoInputs(DivScrollInfoString);
}

function writeDivScrollInfoStringIntoInputs(DivScrollInfoString)
{
	var DIVScrollInfoInputs			= document.getElementsByName('scrollinfo') ;
	var DIVScrollInfoInputsNumber	= DIVScrollInfoInputs.length;
		for(var i=0;i<DIVScrollInfoInputsNumber;++i)
		{
		var elem=DIVScrollInfoInputs[i];
			elem.setAttribute('value',DivScrollInfoString);
		}
}

function setScrollDataOnDivs()
{
	var DivScrollData = DivScrollInfoString.split(",");
		for(var kh=0;kh<DivScrollData.length;++kh)
		{
			if ((DivScrollData[kh]!=null)&&(DivScrollData[kh].length>2))
			{
			var SingleDivScrollData = (DivScrollData[kh]).split(";");
			var elementToSet 		= document.getElementById(SingleDivScrollData[0]);
				elementToSet.scrollLeft = SingleDivScrollData[1];
				elementToSet.scrollTop  = SingleDivScrollData[2];
			}
		}
}
function generateDivScrollInfoString()
{
	var countDivs = document.getElementsByTagName('div').length;
	var StringOut='';
	var  countScrollableDivs=0;

	for(var i=0;i<countDivs;++i)
	{
			var StringChunk='';
			var ename = document.getElementsByTagName('div')[i].id;
			if(ename.search('scrollablediv')>-1)
			{
				++countScrollableDivs;
			var ScrollLeft  = document.getElementById(ename).scrollLeft;
			var ScrollTop  = document.getElementById(ename).scrollTop;
				StringChunk = ename+";"+ScrollLeft+";"+ScrollTop+ ",";
				StringOut=StringOut+StringChunk;
			}
	}
	return StringOut;
}

function sendParam(DivString) 
{
	//If our XmlHttpRequest object is not in the middle of a request, start the new asyncronous call.
	if (receiveReq.readyState == 4 || receiveReq.readyState == 0) 
	{
		//Setup the connection as a GET call to SayHello.html.
		//True explicity sets the request to asyncronous (default).
		receiveReq.open("GET", 'getDivScrollPos.jsp?setDivString='+DivString, true);
		//Set the function that will be called when the XmlHttpRequest objects state changes.
		//receiveReq.onreadystatechange = handleSayHello; 
		//Make the actual request.
		receiveReq.send(null);
	}
}

function getParam() 
{
	//If our XmlHttpRequest object is not in the middle of a request, start the new asyncronous call.
	
	if (receiveReq.readyState == 4 || receiveReq.readyState == 0) 
	{
		//Setup the connection as a GET call to SayHello.html.
		//True explicity sets the request to asyncronous (default).
		receiveReq.open("GET", 'getDivScrollPos.jsp?command=getDivString', true);
		//Set the function that will be called when the XmlHttpRequest objects state changes.
		receiveReq.onreadystatechange = handleDivScrollParameters;
		//receiveReq.
		//Make the actual request.
		receiveReq.send(null);
	}
}

function ScrollRetrieve()
{
	//getParam();
}

function DivsPositioningTool(StringIn)
{
	var BackTokens = StringIn.split(",");
	for(var i=0;i<BackTokens.length-1;++i)
	{
	var CurrentToken=BackTokens[i];
	var InfoChunks = BackTokens[i].split(";");

	var el  = document.getElementById(InfoChunks[0]);
		//var scrollL= parseInt(InfoChunks[1]);
		//var scrollT= parseInt(InfoChunks[2]);
		if (InfoChunks[1]=="0")
		{}
		else
		{
			el.scrollLeft = InfoChunks[1];
		}
	//	if (parseInt(InfoChunks[1])>0) el.scrollLeft= parseInt(InfoChunks[1]);
	//	if (parseInt(InfoChunks[2])>0) el.scrollTop = parseInt(InfoChunks[2]);
	}
}

function addOnSubmitFormElements()
{
	var  AllForms = document.getElementsByTagName('form');
	var FormsNumber = AllForms.length;
		for(var i=0;i<=FormsNumber;++i)
		{
		var SingleForm = AllForms[i];
			try
			{
			var SingleFomrId = SingleForm.id;
				if (SingleFomrId.length>0) document.getElementById(SingleFomrId).setAttribute('onSubmit','alert("hi")'); 
			}catch(err)
			{
				alert('errore:'+err);
			}
		}
		return FormsNumber;
}

/*seems not to be called anywhere */
function addHiddenInputToFormElements()
{
var	AllForms = document.getElementsByTagName('form');
var	FormsNumber = AllForms.length;
	for(var i=0;i<=FormsNumber;++i)
	{
		var SingleForm = AllForms[i];
		try
		{
		var SingleFomrId = SingleForm.id;
		var frm = document.getElementById(SingleFomrId);
			add_input_field(frm, 'hidden', 'scrollinfo', 'novalue');
		}catch(err)
		{
			console.log('errore:'+err);
		}
	}
	return FormsNumber;
}

function add_input_field(form_object, field_type, field_name, field_value) 
{
	if(form_object) 
	{
	var input = document.createElement('INPUT');
		if(document.all) 
		{
			input.type  = field_type;
			input.name  = field_name;
			input.value = field_value;
		} 
		else 
			if(document.getElementById) 
			{
				input.setAttribute('type', field_type);
				input.setAttribute('name', field_name);
				input.setAttribute('value', field_value);
			}
			form_object.appendChild(input);
	}
}

////function PanelsBymultipleChoise(elementin)
//{
//	if (elementin.checked)
//	{
//		sendCheckBoxParams(elementin.id,'on');
//	}
//	else
//	{
//		sendCheckBoxParams(elementin.id,'off');
//	}
//	
//	
//}
//
//function sendCheckBoxParams(elementid,value) 
//{
//	//If our XmlHttpRequest object is not in the middle of a request, start the new asyncronous call.
//	if (receiveReq.readyState == 4 || receiveReq.readyState == 0) 
//	{
//		
//		//Setup the connection as a GET call to SayHello.html.
//		//True explicity sets the request to asyncronous (default).
//		receiveReq.open("GET", 'getCheckBoxsState.jsp?unitid='+elementid+'&unitvalue='+value, true);
//		//Set the function that will be called when the XmlHttpRequest objects state changes.
//		//receiveReq.onreadystatechange = handleDivScrollParameters;
//		//receiveReq.
//		//Make the actual request.
//		receiveReq.send(null);
//	}
//}

var exists;

	//function to call inside ajax callback 
function set_exists(x)
{
		exists = x;
}

$(document).ready
(
  	function() 
  	{           
        $('#submit').click
        (
        		function(event) 
        		{  
            	var username=$('#user').val();
         			$.get
         			(
         					'ActionServlet',
         					{user:username},
         					function(responseText) 
         					{
         							$('#welcometext').text(responseText);
         							set_exists(responseText);
         					}
         			).fail
    		  		(
    		  				function() 
    		  				{
    		    				alert( "error" );
    		  				}
    		  		);
        		}
        );
	}
 );

//this function is about the same of the following one (provideSubmitTriggerElement)
// functions are to be unified
/*
function retrieveSubmitTriggerEl(FormElementIn)
{
	var FormElementInId 		= FormElementIn.id;
	var SubmitTriggerId			= FormElementInId+"SubmitTriggerId|";
	var SubmitTriggerElement 	= document.getElementById(SubmitTriggerId);
	if (SubmitTriggerElement==null)
	{
		var input 					= document.createElement("input");
		input.setAttribute("type", "hidden");
		input.setAttribute("name", "Identifier");
		input.setAttribute("value", "");
		input.setAttribute("id", SubmitTriggerId);
		FormElementIn.appendChild(input);
		SubmitTriggerElement 	= document.getElementById(SubmitTriggerId);
	}
	return SubmitTriggerElement;
}*/

function provideSubmitTriggerElement(generalizedFormElementIn,IdentifierIn,ElementIn)
{
	var SubmitTriggerArr 			= $(generalizedFormElementIn).find( "input[name='SubmitTrigger']" );
		if ((typeof SubmitTriggerArr === "undefined") || (SubmitTriggerArr==null)) {} else { for(var h=0;h<SubmitTriggerArr.length;++h){$(SubmitTriggerArr[h]).remove();}}
	var SubmitTriggerElementIdIn	= generalizedFormElementIn.id+"SubmitTriggerId|";
	var SubmitTriggerElement 		= document.getElementById(SubmitTriggerElementIdIn);
		if
		(
			(typeof SubmitTriggerElement=== "undefined")
			||
			(SubmitTriggerElement == null)
		)
		{
		var input 						= document.createElement("input");
			input.setAttribute("type", "hidden");
			input.setAttribute("name", "SubmitTrigger");
			input.setAttribute("value", ElementIn.id);
			input.id 					= generalizedFormElementIn.id+"SubmitTriggerId|";
			generalizedFormElementIn.appendChild(input);
		}else
		{
			SubmitTriggerElement.setAttribute("value", ElementIn.id);
		}
	var out =  document.getElementById(generalizedFormElementIn.id+"SubmitTriggerId|");
		return out;
}

function provideAssociatedIdentifierInput(generalizedFormElementIn,IdentifierIn)
{
	var IdentifierHiddenInputs 			= $(generalizedFormElementIn).find('input[name="Identifier"]');//.each(function( index ) {alert( index + ": " + $( this ).text() );});
	var out 							= null;
	//var IdentifierHiddenInputs = $(generalizedFormElementIn).find('td').each(function( index ) {alert( index + ": " + $( this ).text() );});
		if (IdentifierHiddenInputs.length==0)
		{
		var input 										= document.createElement("input");
			input.setAttribute("type", "hidden");
			input.setAttribute("name", "Identifier");
			input.setAttribute("value", IdentifierIn);
			input.id 									= generalizedFormElementIn.id+"Identifier|";
			generalizedFormElementIn.appendChild(input);
			out 										=  input;
		}else
		{
			//for(var i=0;i<IdentifierHiddenInputs.length;++i)
			if (IdentifierHiddenInputs!=null)
			{
				if (IdentifierHiddenInputs instanceof Array)
				{
					IdentifierHiddenInputs[0].value = IdentifierIn;
					out 							=   IdentifierHiddenInputs[0];
				}
				else
				{
					out 							=   IdentifierHiddenInputs[0];
				}
			}else
			{
				alert('IdentifierHiddenInputs is null');
			}
		}
		out.value 											= IdentifierIn;
		return out;
}

function provideSubmitHiddenInputByName(generalizedFormElementIn,IdentifierIn,ElementNameIn,ElementIdentifierIn)
{
			//The submit Trigger has to be 
	var 	status 						= null;
	var 	FoundElemArr 				= $(generalizedFormElementIn).find( "input[name='"+ElementNameIn+"']" );
	var 	providingElement			= null;
	var 	providingElementIdIn		= generalizedFormElementIn.id+ElementIdentifierIn+"|";
			if ((typeof FoundElemArr === "undefined") || (FoundElemArr==null)) 
			{//Not Found
				status = "TO_GENERATE";
			}else 
			{//Found 
				if (FoundElemArr.length==0)
				{//Not found
					status  = "TO_GENERATE";
				}
				if (FoundElemArr.length==1)
				{//Found one 
					status  		 = "DONT_GENERATE_FOUND_ONE";
					providingElement = FoundElemArr[0];
					providingElement.setAttribute("id",providingElementIdIn);
				}
				if (FoundElemArr.length>1)
				{//Found more 
					status  = "DONT_GENERATE_TOOMANY";
				}
			}
			//clean the input hidden fields that have the required name in order to avoid submit data overlap
			if (status  == "TO_GENERATE")
			{
				var input 					= document.createElement("input");
					input.setAttribute("type", "hidden");
					input.setAttribute("name", ElementNameIn);
					input.setAttribute("id"  , providingElementIdIn);
					generalizedFormElementIn.appendChild(input);
					providingElement 			= document.getElementById(providingElementIdIn);
			}
			if (status  == "DONT_GENERATE_FOUND_ONE")
			{
				providingElement.setAttribute("id"  , providingElementIdIn);
			}
			
			return providingElement;
}

/*
 * Add multiple forms actors: add moreform attribute to AssociatedFormElement. e.g. |Test|ContainerA| is main form add moreform = '|Test|ContainerB|' to it. 
 * 
 * @param IdentifierIn
 * @param element
 * @param SWType
 * @returns
 */
function sendData(IdentifierIn,element,SWType)
{
										//IdentifierIn is the identifier of the OBJ
										//console_log("sendData - IdentifierIn:"+IdentifierIn+" element.id:"+element.id+" SWType : "+SWType+"  WaintingServer:"+WaintingServer);
										//console.trace();
										//console_log("WaintingServer:"+WaintingServer);
										
										if (WaintingServer							== false)
										{
											//console_log("\nHHHHHHHHHHHHHHHHHHHHHHH\nHHHHHHHHHHHHHHHHHHHHHHH\nHHHHHHHHHHHHHHHHHHHHHHHsendData - No waiting Server.   IdentifierIn:"+IdentifierIn);
											WaintingServer																										= true;
										var Mypageobjtoken																										= $(document.body).attr('pageobjtoken');
										var Mypagename																											= $(document.body).attr('pagename');
										var SessionPageFullName																									= Mypageobjtoken+"_"+Mypagename;		
										var	data_pagechunk																										= 'sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+Mypagename+'&';
											//console_log("  SENDDATA A 1");
											if (retrieveArrayPositionLockedSWByIdentifier(IdentifierIn)==-1) 
											{
													//console_log("  SENDDATA A 2");
												var elemIn 																										= element;
												var elementIn 																									= element;
												//var QueryString 																								= "";
												var data																										= "";
												var OutgoingURL 																								= "CAAs";
													//console_log("SENDDATA _______________ elemIn.id:"+elemIn.id);
												var generalizedFormElement  																					= getAssociatedFormElement(elemIn);
												var generalizedFormElementIn 																					= generalizedFormElement;
													//console_log("SENDDATA _______________ generalizedFormElementIn.id:"+generalizedFormElementIn.id);
												var SWTypeIn 																									= SWType;
													//console_log("                 generalizedFormElement.id:"+generalizedFormElement.id+"");
													//var showWaiterShield  																							= generalizedFormElement.getAttribute("showWaiterShield");
												var showWaiterShield  																							= generalizedFormElement.getAttribute("showwaitershield");
												var showWaiterShieldIn 																							= showWaiterShield;

												var IdentifierElement																							= provideAssociatedIdentifierInput(generalizedFormElement,IdentifierIn);
												var IdentifierElementIn 																						= IdentifierElement;
													//Identifier associated with form 

												var SumbitTriggerEl																								= provideSubmitTriggerElement(generalizedFormElement,IdentifierIn,elemIn);
													SumbitTriggerElIn																							= SumbitTriggerEl;
													//Submit trigger Element. Associated with form
													//A Field is always sent to server. Its name : SubmitTrigger, its id : .......|SubmitTriggerId|, its value : the id of the submitting element
													//var SumbitTriggerEl 		= retrieveSubmitTriggerEl(generalizedFormElement);

													//console_log("BBBBBBBB 77777ddd BEFORE");

																			//console_log("BBBBBBBB 77777ddd QQQQQQ SWTypeIn:"+SWTypeIn+" kmmmmmm generalizedFormElementIn:"+generalizedFormElementIn.id+"	SumbitTriggerElIn:"+SumbitTriggerElIn.id);
																			//Here we test if to goon and perform ajax inside this method or permorm ajax inside the senddata method of the caller class
																			if (performSendDataOnClassTypes(elementIn,IdentifierIn,IdentifierElementIn,generalizedFormElementIn,SWTypeIn,showWaiterShieldIn,SumbitTriggerElIn,showWaiterShieldIn,data_pagechunk)==false)
																			{
																				//console_log("BBBBBBBB 77777ddd EEEEEE");
																				if(SWType=="ComponentsBasic.TDElement")
																				{
																					data 																										= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsBasic.TDElement";
																					//WaiterShield('show');
																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}

																					$.ajax
																					(
																						{
																							type	: "POST",
																							url		: "CAAs",
																							data	: data,
																							dataType: "html",
																							success	: function(msg)
																							{
																								//$("#risultato").html(msg);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																					);//ajax
																				}

																				if(SWType=="ComponentsBasic.Starter")
																				{
																					var PageStarterElement_id 																					= generalizedFormElement.id+"Starter|"
																					var PageStarterElement      																				= document.getElementById(PageStarterElement_id);
																					var inner_serializeGeneralized 																			= serializeGeneralized(generalizedFormElement);
																						if (PageStarterElement.value=='0')
																						{
																							data 																								= data_pagechunk+"Identifier="+IdentifierIn+"&"+inner_serializeGeneralized;
																						}
																						if (PageStarterElement.value=='1')
																						{
																						var QueryStringOut 																						= BeforeLoadPAGEParametersGenerate_QueryString();    	
																							data 																								= data_pagechunk+"Identifier="+IdentifierIn+"&"+QueryStringOut+"&"+inner_serializeGeneralized+"&launchpoint=Senddata_ComponentsBasic.Starter";
																						}
																						//data 					= "Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement);
																						//WaiterShield('show');
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}

																						$.ajax
																						(
																							{
																								type	: "POST",
																								url		: "CAAs",
																								data	: data,
																								dataType: "html",
																								success	: function(msg)
																								{
																									//$("#risultato").html(msg);
																									ServerCallBackTokenize_first(msg);
																								},
																								error: function()
																								{
																									alert(ServerFailMessage);
																									WaiterShield('hide');
																								}
																							}
																						);//ajax
																				}

																				if(SWType=="::::ComponentsBasic.Starter")
																				{//remove....there are 2 of them
																				var PageStarterElement_id 								= generalizedFormElement.id+"Starter|"
																				var PageStarterElement									= document.getElementById(PageStarterElement_id);


																				var inner_serializeGeneralized 							= serializeGeneralized(generalizedFormElement);
																					if (PageStarterElement.value=='0')
																					{
																						data 											= data_pagechunk+"Identifier="+IdentifierIn+"&"+inner_serializeGeneralized;
																					}
																					if (PageStarterElement.value=='1')
																					{
																					var QueryStringOut 									= BeforeLoadPAGEParametersGenerate_QueryString();    	
																						data 											= data_pagechunk+"Identifier="+IdentifierIn+"&"+QueryStringOut+"&"+inner_serializeGeneralized+"&launchpoint=Senddata_ComponentsBasic.Starter";
																					}
																					//data 					= "Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement);
																					//WaiterShield('show');
																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					$.ajax
																					(
																						{
																							type	: "POST",
																							url		: "CAAs",
																							data	: data,
																							dataType: "html",
																							success	: function(msg)
																							{
																								//$("#risultato").html(msg);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																					);//ajax
																				}

																				if(SWType=="Components.ContainerDropArea")
																				{
																					data 													= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_Components.ContainerDropArea";
																					//WaiterShield('show');
																					//if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					$.ajax
																					(
																						{
																							type	: "POST",
																							url		: "CAAs",
																							data	: data,
																							dataType: "html",
																							success	: function(msg)
																							{
																								//$("#risultato").html(msg);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																					);//ajax
																				}

																				if(SWType=="ComponentsBasic.FieldSearcher")
																				{
																					data 																										= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsBasic.FieldSearcher";
																					//WaiterShield('show');
																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					$.ajax
																					(
																						{
																							type	: "POST",
																							url		: "CAAs",
																							data	: data,
																							dataType: "html",
																							success	: function(msg)
																							{
																								//$("#risultato").html(msg);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																					);//ajax
																				}
																				
																				if(SWType=="ComponentsCustom.FSFileBean")
																				{
																					data 																										= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsCustom.FSFileBean";
																					//WaiterShield('show');
																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					$.ajax
																					(
																						{
																							type	: "POST",
																							url		: "CAAs",
																							data	: data,
																							dataType: "html",
																							success	: function(msg)
																							{
																								//$("#risultato").html(msg);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																					);//ajax
																				}
																				
																				if(SWType=="Components.Container:::")
																				{
																					data 																										= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_Components.Container";

																					//WaiterShield('show');
																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					$.ajax
																					(
																						{
																							type	: "POST",
																							url		: "CAAs",
																							data	: data,
																							dataType: "html",
																							success	: function(msg)
																							{
																								//$("#risultato").html(msg);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																					);//ajax
																				}

																				if(SWType=="ComponentsBasic.LogoCorner")
																				{
																					data 																										= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsBasic.LogoCorner";
																					//WaiterShield('show');
																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					$.ajax
																					(
																						{
																							type	: "POST",
																							url		: "CAAs",
																							data	: data,
																							dataType: "html",
																							success	: function(msg)
																							{
																								//$("#risultato").html(msg);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																					);//ajax
																				}
																				
																				if(SWType=="Components.TableManager")
																				{
																					if (elemIn.name =='RecordNavigation')
																					{
																					var inputNavigation = document.createElement("input");
																						inputNavigation.setAttribute("type" , "hidden");
																						inputNavigation.setAttribute("name" , "RecordNavigation");
																						inputNavigation.setAttribute("value", elemIn.value);
																						generalizedFormElement.appendChild(inputNavigation);

																					var inputTableCommand = document.createElement("input");
																						inputTableCommand.setAttribute("type" , "hidden");
																						inputTableCommand.setAttribute("name" , "TableCommand");
																						inputTableCommand.setAttribute("value", "RecordNavigation");
																						generalizedFormElement.appendChild(inputTableCommand);
																					}
																					if (elemIn.name == 'find')
																					{
																						//This case TableForm is overwritten
																						SWSearchFormId										= IdentifierIn+"HTMLFieldSearchers|";
																						SWSearchForm										= document.getElementById(SWSearchFormId);
																					var inputFind 											= document.createElement("input");
																						inputFind.setAttribute("type" , "hidden");
																						inputFind.setAttribute("name" , "find");
																						//inputFind.setAttribute("value", elemIn.value);
																						if (elemIn.id.indexOf("clear|") 	> -1) 	inputFind.setAttribute("value","azzera");
																						if (elemIn.id.indexOf("find|") 		> -1) 	inputFind.setAttribute("value","cerca");
																						if (elemIn.id.indexOf("find_any|") 	> -1) 	inputFind.setAttribute("value","cerca tutti");
																						SWSearchForm.appendChild(inputFind);
																						WaiterShield('show');
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																						// The form is serialized (TableForm or other forms)
																						// form should be replaced with divs on order to simplify Object placements
																						//data = $(TableForm).serialize();//+"&Identifier="+SumbitTriggerEl.id;;//+"&Identifier="+SumbitTriggerEl.id;;
																					}

																					data 													= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_Components.TableManager";
																					//WaiterShield('show');
																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					$.ajax
																					(
																						{
																							type	: "POST",
																							url		: "CAAs",
																							data	: data,
																							dataType: "html",
																							success	: function(msg)
																							{
																								//$("#risultato").html(msg);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																					);//ajax
																				}

																				if(SWType=="applicationModel.HTMLEnhancedTagExtension000")
																				{//manage Events.........
																				var TEOwnerElement 										=  getTEOwner(element);
																			//		var TagType_Id   	= elemIn.id+"HTMLEnhancedType"+"|";
																			//
																			//		var TagType_Elem 	= document.getElementById(TagType_Id);
																			//		var TagType_Value 	= TagType_Elem.value;
																				var TagType_Value   									= TEOwnerElement.getAttribute("owner_family").replace("-",".");
																					//for applicationModel.HTMLEnhancedTagExtension identifiers switch their role
																					//IdentifierIn, that acts the role of identifier of SW is carried by owner attribute of SW
																					//The parameter IdentifierIn is the id of the TAG Extender element. Is stored in TAGExtenderId variable
																				var IdentifierTAGExtender								= IdentifierIn;
																					//var IdentifierTAGExtender	= element.id;
																				var IdentifierIn    									= TEOwnerElement.getAttribute("owner");
																					if(TagType_Value=="ComponentsTagExtenders.PagingNavigator")
																					{
																						//may comply Components.ListManager and Components.ModularVContainer too;
																					var TableFormId											= generalizedFormElement.id+"TableForm|";
																					var TableForm											= document.getElementById(TableFormId);
																						if (elemIn.name =='RecordNavigation')
																						{
																						var inputNavigation 								= document.createElement("input");
																							inputNavigation.setAttribute("type" , "hidden");
																							inputNavigation.setAttribute("name" , "RecordNavigation");
																							inputNavigation.setAttribute("value", elemIn.value);
																							TableForm.appendChild(inputNavigation);

																						var inputTableCommand 								= document.createElement("input");
																							inputTableCommand.setAttribute("type" , "hidden");
																							inputTableCommand.setAttribute("name" , "TableCommand");
																							inputTableCommand.setAttribute("value", "RecordNavigation");
																							TableForm.appendChild(inputTableCommand);

																							SumbitTriggerEl.value 							= elemIn.id;
																						}
																						/*if (elemIn.name =='layout_select')
																							{
																								var inputNavigation 		= document.createElement("input");
																									inputNavigation.setAttribute("type", "hidden");
																									inputNavigation.setAttribute("name", "layout_select");
																									inputNavigation.setAttribute("value", elemIn.value);
																									TableForm.appendChild(inputNavigation);
																								var inputTableCommand 		= document.createElement("input");
																									inputTableCommand.setAttribute("type" , "hidden");
																									inputTableCommand.setAttribute("name" , "TableCommand");
																									inputTableCommand.setAttribute("value", "layout_select");
																									TableForm.appendChild(inputTableCommand);
																							}*/
																				 		data 												= data_pagechunk+"Identifier="+IdentifierIn+"&"+"IdentifierTAGExtender="+IdentifierTAGExtender+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_applicationModel.HTMLEnhancedTagExtension";
																						//WaiterShield('show');
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																						$.ajax
																						(
																							{
																								type	: "POST",
																								url		: "CAAs",
																								data	: data,
																								dataType: "html",
																								success	: function(msg)
																								{
																									//$("#risultato").html(msg);
																									ServerCallBackTokenize(msg);
																								},
																								error: function()
																								{
																									alert(ServerFailMessage);
																									WaiterShield('hide');
																								}
																							}
																						);//ajax																						
																					}

																					if (TagType_Value=='ComponentsTagExtenders.FSFileBean')
																					{
																						///remove his block.
																						//FSFileBean is now a ComponentsBasic type class and not a ComponentsTagExtenders type class
																						data 												= data_pagechunk+"Identifier="+IdentifierIn+"&"+"IdentifierTAGExtender="+IdentifierTAGExtender+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsTagExtenders.FSFileBean";
																						//WaiterShield('show');
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																						$.ajax
																						(
																							{
																								type	: "POST",
																								url		: "CAAs",
																								data	: data,
																								dataType: "html",
																								success	: function(msg)
																								{
																									//$("#risultato").html(msg);
																									ServerCallBackTokenize(msg);
																								},
																								error: function()
																								{
																									alert(ServerFailMessage);
																									WaiterShield('hide');
																								}
																							}
																						);//ajax
																					}

																					if (TagType_Value=='ComponentsTagExtenders.WindowHandlerCommander')
																					{
																						data 												= data_pagechunk+"Identifier="+IdentifierIn+"&"+"IdentifierTAGExtender="+IdentifierTAGExtender+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsTagExtenders.WindowHandlerCommander";
																						//WaiterShield('show');
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																						$.ajax
																						(
																							{
																								type	: "POST",
																								url		: "CAAs",
																								data	: data,
																								dataType: "html",
																								success	: function(msg)
																								{
																									//$("#risultato").html(msg);
																									ServerCallBackTokenize(msg);
																								},
																								error: function()
																								{
																									alert(ServerFailMessage);
																									WaiterShield('hide');
																								}
																							}
																						);//ajax
																					}
																					if (TagType_Value=='ComponentsTagExtenders.EnhancedButton')
																					{
																						data 												= data_pagechunk+"Identifier="+IdentifierIn+"&"+"IdentifierTAGExtender="+IdentifierTAGExtender+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsTagExtenders.EnhancedButton";
																						//WaiterShield('show');
																						//console_log("iiiiiiiiiiiiiiiiiiiiiiiii  ComponentsTagExtenders.EnhancedButton:"+data);
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																						$.ajax
																						(
																							{
																								type	: "POST",
																								url		: "CAAs",
																								data	: data,
																								dataType: "html",
																								success	: function(msg)
																								{
																									//$("#risultato").html(msg);
																									ServerCallBackTokenize(msg);
																								},
																								error: function()
																								{
																									alert(ServerFailMessage);
																									WaiterShield('hide');
																								}
																							}
																						);//ajax
																					}
																					if (TagType_Value=='ComponentsTagExtenders.EnhancedSpan')
																					{
																						data 												= data_pagechunk+"Identifier="+IdentifierIn+"&"+"IdentifierTAGExtender="+IdentifierTAGExtender+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsTagExtenders.EnhancedSpan";
																						//WaiterShield('show');
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																						$.ajax
																						(
																							{
																								type	: "POST",
																								url		: "CAAs",
																								data	: data,
																								dataType: "html",
																								success	: function(msg)
																								{
																									//$("#risultato").html(msg);
																									ServerCallBackTokenize(msg);
																								},
																								error: function()
																								{
																									alert(ServerFailMessage);
																									WaiterShield('hide');
																								}
																							}
																						);//ajax
																					}
																					if (TagType_Value=='ComponentsTagExtenders.EnhancedInput')
																					{
																						data 																									= data_pagechunk+"Identifier="+IdentifierIn+"&"+"IdentifierTAGExtender="+IdentifierTAGExtender+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsTagExtenders.EnhancedSpan";
																						//WaiterShield('show');
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																						$.ajax
																						(
																							{
																								type	: "POST",
																								url		: "CAAs",
																								data	: data,
																								dataType: "html",
																								success	: function(msg)
																								{
																									//$("#risultato").html(msg);
																									ServerCallBackTokenize(msg);
																								},
																								error: function()
																								{
																									alert(ServerFailMessage);
																									WaiterShield('hide');
																								}
																							}
																						);//ajax
																					}
																					if (TagType_Value=='ComponentsTagExtenders.EnhancedComboBox')
																					{
																						data 												= data_pagechunk+"Identifier="+IdentifierIn+"&"+"IdentifierTAGExtender="+IdentifierTAGExtender+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsTagExtenders.EnhancedComboBox";
																						//WaiterShield('show');
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																						$.ajax
																						(
																							{
																								type	: "POST",
																								url		: "CAAs",
																								data	: data,
																								dataType: "html",
																								success	: function(msg)
																								{
																									//$("#risultato").html(msg);
																									ServerCallBackTokenize(msg);
																								},
																								error: function()
																								{
																									alert(ServerFailMessage);
																									WaiterShield('hide');
																								}
																							}
																						);//ajax
																					}
																					if (TagType_Value=='ComponentsTagExtenders.EnhancedCheckBox')
																					{
																						//var IconPath_Id   		= elemIn.id+"icon_path"+"|";
																						//var IconPath_Elem 		= document.getElementById(IconPath_Id);
																						//var IconPath_Value 		= "url('"+IconPath_Elem.value+"')";
																					var elemIn_id 											= elemIn.id;
																					var check_status_Id 									= elemIn_id.replace('check_area|','')+"checkuncheck_storage"+"|";
																					var check_status_Elem 									= document.getElementById(check_status_Id);
																					var check_status_Value 									= check_status_Elem.value;
																						//if(check_status_Value=='unchecked')
																						{
																							//check_status_Elem.value			= 'false';
																							//elemIn.style.backgroundImage 	= 'none';
																						}
																						//if(check_status_Value=='checked')
																						{
																							//check_status_Elem.value			= 'true';				
																							//elemIn.style.backgroundImage 	= IconPath_Value;
																						}

																						//var IsAutoSubmit_Id 	= elemIn.id+"IsAutoSubmit"+"|";
																						//var IsAutoSubmit_Elem 	= document.getElementById(IsAutoSubmit_Id);
																						//var IsAutoSubmit_Value 	= IsAutoSubmit_Elem.value;

																						jQuery(SumbitTriggerEl).val(elemIn.id);
																						IdentifierTAGExtender 								= IdentifierIn; 
																						data 												= data_pagechunk+"Identifier="+IdentifierIn+"&"+"IdentifierTAGExtender="+IdentifierTAGExtender+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsTagExtenders.EnhancedCheckBox";

																						//WaiterShield('show');
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																						$.ajax
																						(
																							{
																								type	: "POST",
																								url		: "CAAs",
																								data	: data,
																								dataType: "html",
																								success	: function(msg)
																								{
																									//$("#risultato").html(msg);
																									ServerCallBackTokenize(msg);
																								},
																								error: function()
																								{
																									alert(ServerFailMessage);
																									WaiterShield('hide');
																								}
																							}
																						);//ajax
																					}
																				}
																				if(SWType=="ComponentsBasic.ListTreeMenuElement")
																				{
																					//used in RichListManager item selection
																				var generalizedFormElement  																					= getAssociatedFormElement(elemIn);
																					//provideSubmitTriggerElement(generalizedFormElement,IdentifierIn,elemIn);
																					/*var IdentifierElement 			= generalizedFormElement.getElementsByName("Identifier");
																					if (IdentifierElement===undefined)
																					{
																						var input 					= document.createElement("input");
																						input.setAttribute("type", "hidden");
																						input.setAttribute("name", "Identifier");
																						input.setAttribute("value", IdentifierIn);
																						generalizedFormElement.appendChild(input);
																						
																					}*/
																					//var SumbitTriggerElId 		 = generalizedFormElement.id +"SubmitTriggerId|";
																					//var SumbitTriggerEl 		 = document.getElementById(SumbitTriggerElId);
																					//SubmitTrigger represents the object that caused the sendData event
																					//For backward compatibility
																					//Moreover it seems to be nice.....
																					//if (elemIn.id!=null ){SumbitTriggerEl.value = element.id;}
																					//	console_log("   --------------------------------------  \n"+serializeGeneralized(generalizedFormElement));
																					data 													= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsBasic.ListTreeMenuElement";
																					//printFolderTreeWidth('\nSending data');
																					//arrayScrollPrintList('\nSending data');
																					WaiterShield('show');
																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					$.ajax
																					(
																						{
																							type	: "POST",
																							url		: OutgoingURL,
																							data	: data,
																							dataType: "html",
																							//timeout :30000,
																							success	: function(msg)
																							{
																								//$("#risultato").html(msg);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																					);//ajax
																				}
																				if(SWType=="ComponentsBasic.FlexElement")
																				{
																				var generalizedFormElement  								= getAssociatedFormElement(elemIn);

																				var input 													= document.createElement("input");
																					input.setAttribute("type", "hidden");
																					input.setAttribute("name", "Identifier");
																					input.setAttribute("value", IdentifierIn);
																					generalizedFormElement.appendChild(input);
																				var SumbitTriggerElId 		 								= generalizedFormElement.id +"SubmitTriggerId|";
																				var SumbitTriggerEl 		 								= document.getElementById(SumbitTriggerElId);
																				//SubmitTrigger represents the object that caused the sendData event
																				//For backward compatibility
																				//Moreover it seems to be nice.....
																					if (elemIn.id!=null ){SumbitTriggerEl.value = element.id;}
																					data 													= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsBasic.FlexElement";
																					//WaiterShield('show');
																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					$.ajax
																					(
																						{
																							type	: "POST",
																							url		: OutgoingURL,
																							data	: data,
																							dataType: "html",
																							success	: function(msg)
																							{
																								//$("#risultato").html(msg);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																					);//ajax
																				}
																				if(SWType=="ComponentsBasic.TextAreaPopUp")
																				{
																				var generalizedFormElement 									= getAssociatedFormElement(element);
																				//the element input type butto is not automatically serialized, so it has to be added
																				var inputButton 											= document.createElement("input");
																					inputButton.setAttribute("type" , "hidden");
																					inputButton.setAttribute("name" , "find");
																					inputButton.setAttribute("value", elemIn.value);
																					generalizedFormElement.appendChild(inputButton);

																				var input 													= document.createElement("input");
																					input.setAttribute("type", "hidden");
																					input.setAttribute("name", "Identifier");
																					input.setAttribute("value", IdentifierIn);
																					generalizedFormElement.appendChild(input);

																					//var SumbitTriggerElId 	= elementForm.id +"SubmitTriggerId|";
																					//var SumbitTriggerEl 	= document.getElementById(SumbitTriggerElId);
																					//SubmitTrigger represents the object that caused the sendData event
																					//For backward compatibility
																					//if (element.id.length>0 )
																					//{
																					//	SumbitTriggerEl.value = element.id;
																					//}
																					//else
																					//{
																						// useful only in ListManager
																						//SumbitTriggerEl.value =IdentifierIn+"form|"+elemIn.name+"|";
																					//}
																					//data = $(ComponentForm).serialize();
																					data 																										= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsBasic.TextAreaPopUp";
																					$.ajax
																					(
																							{
																								type	: "POST",
																								url		: OutgoingURL,
																								data	: data,
																								dataType: "html",
																								success	: function(msg)
																								{
																									ServerCallBackTokenize(msg);
																								},
																								error: function()
																								{
																									alert(ServerFailMessage);
																									WaiterShield('hide');
																								}
																							}
																					);//ajax
																				}
																				if(SWType=="ComponentsBasic.MessagePopUp")
																				{
																				var generalizedFormElement 									= getAssociatedFormElement(element);
																					//the element input type button is not automatically serialized, so it has to be added
																				var inputButton 											= document.createElement("input");
																					inputButton.setAttribute("type" , "hidden");
																					inputButton.setAttribute("name" , "doAction");
																					inputButton.setAttribute("value", elemIn.value);
																					generalizedFormElement.appendChild(inputButton);

																				var input 													= document.createElement("input");
																					input.setAttribute("type", "hidden");
																					input.setAttribute("name", "Identifier");
																					input.setAttribute("value", IdentifierIn);
																					generalizedFormElement.appendChild(input);

																					//var SumbitTriggerElId 	= elementForm.id +"SubmitTriggerId|";
																					//var SumbitTriggerEl 	= document.getElementById(SumbitTriggerElId);
																					//SubmitTrigger represents the object that caused the sendData event
																					//For backward compatibility
																					//if (element.id.length>0 )
																					//{
																					//	SumbitTriggerEl.value = element.id;
																					//}
																					//else
																					//{
																						// useful only in ListManager
																						//SumbitTriggerEl.value =IdentifierIn+"form|"+elemIn.name+"|";
																					//}
																					//data = $(ComponentForm).serialize();
																					data																											= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsBasic.MessagePopUp";
																					$.ajax
																					(
																							{
																								type	: "POST",
																								url		: OutgoingURL,
																								data	: data,
																								dataType: "html",
																								success	: function(msg)
																								{
																									ServerCallBackTokenize(msg);
																								},
																								error: function()
																								{
																									alert(ServerFailMessage);
																									WaiterShield('hide');
																								}
																							}
																					);//ajax
																				}																				
																				if(SWType=="ComponentsBasic.BasicControl")
																				{																					
																				var generalizedFormElement  								= getAssociatedFormElement(elemIn);

																			//		var elementForm 		= getAssociatedForm(element);
																			//		var SumbitTriggerElId 	= elementForm.id +"SubmitTriggerId|";
																			//		var SumbitTriggerEl 	= document.getElementById(SumbitTriggerElId);
																			//		//SubmitTrigger represents the object that caused the sendData event
																			//		//For backward compatibility
																			//		if (element.id.length>0 )
																			//		{
																			//			SumbitTriggerEl.value = element.id;
																			//		}
																			//		else
																			//		{
																			//			// useful only in ListManager
																			//			//SumbitTriggerEl.value =IdentifierIn+"form|"+elemIn.name+"|";
																			//		}
																					/*var input = document.createElement("input");
																					input.setAttribute("type", "hidden");
																					input.setAttribute("name", "Identifier");
																					input.setAttribute("value", element.id);
																					elementForm.appendChild(input);*/
																					//data = $(elementForm).serialize()+"&Identifier="+element.id;
																					data 													= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsBasic.BasicControl";
																					//data = dataaux.split('%7C').join('|');
																					//invio
																					//WaiterShield('show');
																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					$.ajax
																					(
																						{
																							type	: "POST",
																							url		: OutgoingURL,
																							data	: data,
																							dataType: "html",
																							success	: function(msg)
																							{
																								//$("#risultato").html(msg);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																					);//ajax
																				}
																				if(SWType=="Components.InLineAuthenticator")
																				{
																				var generalizedFormElement  								= getAssociatedFormElement(elemIn);
																					data 													= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_ComponentsBasic.InLineAuthenticator";
																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					$.ajax
																					(
																						{
																							type	: "POST",
																							url		: OutgoingURL,
																							data	: data,
																							dataType: "html",
																							success	: function(msg)
																							{
																								//$("#risultato").html(msg);
																								//console_log("Components.InLineAuthenticator back msg"+msg);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																						);//ajax
																				}
																				if(SWType=="Components.TableManager_old")
																				{
																					//This code retrieves the Form that contains data to be sent
																					//To Server.
																					//In ListManager the main form is TableForm, but the
																					//server communication can be triggered by the Search Field Group too
																					//so the case has to be managed from the 'find' chunk below
																					// TableForm has to be overwritten
																				var TableFormId				= IdentifierIn+"TableForm|";
																				var TableForm				= document.getElementById(TableFormId);
																					//SubmitTrigger represents the object that caused the sendData event
																					//For backward compatibility
																				var SumbitTriggerElId 		= IdentifierIn +"TableForm|SubmitTriggerId|";
																				var SumbitTriggerEl 		= document.getElementById(SumbitTriggerElId);
																					// Submit Trigger field is retrieved.
																					// Following code sets the content of the Submit Trigger Field
																					if (element.id.length>0 )
																					{
																						SumbitTriggerEl.value 	= element.id;
																					}else
																					{	// if the calling lement has not got ad Id, 
																						// the value is provided by the element name
																						// Any element to perfom server communication
																						// and send Data needs at least a name or an Id
																						// or both of them
																						SumbitTriggerEl.value 	= IdentifierIn+"TableForm|"+elemIn.name+"|";
																					}

																					//SubWindow Identifier here
																					//Most times is already present into HTML 
																					//but is re-added for redundancy 
																				var input 					= document.createElement("input");
																					input.setAttribute("type", "hidden");
																					input.setAttribute("name", "Identifier");
																					input.setAttribute("value", IdentifierIn);
																					TableForm.appendChild(input);
																					//var inputSubmitTrigger = document.createElement("input");
																					//input.setAttribute("type", "hidden");
																					//input.setAttribute("name", "Identifier");
																					//input.setAttribute("value", IdentifierIn);
																					//TableForm.appendChild(input);
																					if (elemIn.name =='RecordNavigation')
																					{
																					var inputNavigation 	= document.createElement("input");
																						inputNavigation.setAttribute("type" , "hidden");
																						inputNavigation.setAttribute("name" , "RecordNavigation");
																						inputNavigation.setAttribute("value", elemIn.value);
																						TableForm.appendChild(inputNavigation);

																					var inputTableCommand 	= document.createElement("input");
																						inputTableCommand.setAttribute("type" , "hidden");
																						inputTableCommand.setAttribute("name" , "TableCommand");
																						inputTableCommand.setAttribute("value", "RecordNavigation");
																						TableForm.appendChild(inputTableCommand);
																					}
																					data 													= data_pagechunk+$(TableForm).serialize()+"&launchpoint=Senddata_old_Components.TableManager";
																					$.ajax({
																						type	: "POST",
																						url		: OutgoingURL,
																						data	: data,
																						dataType: "html",
																						success	: function(msg)
																						{
																							//$("#debuggeroutput").html(data);
																							ServerCallBackTokenize(msg);
																						},
																						error: function()
																						{
																							alert(ServerFailMessage);
																							WaiterShield('hide');
																						}
																						});//ajax
																				}
																				if(SWType=="Components.ModularVContainer")
																				{
																				var TableFormId												= IdentifierIn+"TableForm|";
																				var TableForm												= document.getElementById(TableFormId);
																					if (elemIn.name =='RecordNavigation')
																					{
																					var inputNavigation 									= document.createElement("input");
																						inputNavigation.setAttribute("type" , "hidden");
																						inputNavigation.setAttribute("name" , "RecordNavigation");
																						inputNavigation.setAttribute("value", elemIn.value);
																						TableForm.appendChild(inputNavigation);

																					var inputTableCommand 									= document.createElement("input");
																						inputTableCommand.setAttribute("type" , "hidden");
																						inputTableCommand.setAttribute("name" , "TableCommand");
																						inputTableCommand.setAttribute("value", "RecordNavigation");
																						TableForm.appendChild(inputTableCommand);
																						//WaiterShield('show');
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					}
																					if (elemIn.name =='RecordsetOperation')
																					{
																						OutgoingURL 									= "CAAs";
																						/*var input 					= document.createElement("input");
																						input.setAttribute("type", "hidden");
																						input.setAttribute("name", "Identifier");
																						input.setAttribute("value", IdentifierIn);
																						TableForm.appendChild(input);*/
																					var inputTableCommand								= document.createElement("input");
																						inputTableCommand.setAttribute("type" , "hidden");
																						inputTableCommand.setAttribute("name" , "RecordsetOperation");
																						inputTableCommand.setAttribute("value", elemIn.value);
																						TableForm.appendChild(inputTableCommand);
																					}

																					if (elemIn.name == 'find')
																					{
																						//This case TableForm is overwritten
																						SWSearchFormId										= IdentifierIn+"HTMLFieldSearchers|";
																						SWSearchForm										= document.getElementById(SWSearchFormId);

																					var inputFind 											= document.createElement("input");
																						inputFind.setAttribute("type" , "hidden");
																						inputFind.setAttribute("name" , "find");
																						//inputFind.setAttribute("value", elemIn.value);
																						if (elemIn.id.indexOf("clear|") 	> -1) 	inputFind.setAttribute("value","azzera");
																						if (elemIn.id.indexOf("find|") 		> -1) 	inputFind.setAttribute("value","cerca");
																						if (elemIn.id.indexOf("find_any|") 	> -1) 	inputFind.setAttribute("value","cerca tutti");

																						SWSearchForm.appendChild(inputFind);

																						WaiterShield('show');
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}

																						alert('SumbitTriggerEl ---- :'+SumbitTriggerEl.value);
																						// The form is serialized (TableForm or other forms)
																						// form should be replaced with divs on order to simplify Object placements
																						//data = $(TableForm).serialize();//+"&Identifier="+SumbitTriggerEl.id;;//+"&Identifier="+SumbitTriggerEl.id;;
																					}

																					data 													= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_Components.ModularVContainer";
																					ServerStateImplement(false,data);										
																				}
																				if(SWType=="Components.ListRichChoiceManager")
																				{
																				var TableFormId												= IdentifierIn+"TableForm|";
																				var TableForm												= document.getElementById(TableFormId);
																					if (elemIn.name =='RecordNavigation')
																					{
																					var inputNavigation 									= document.createElement("input");
																						inputNavigation.setAttribute("type" , "hidden");
																						inputNavigation.setAttribute("name" , "RecordNavigation");
																						inputNavigation.setAttribute("value", elemIn.value);
																						TableForm.appendChild(inputNavigation);

																					var inputTableCommand 									= document.createElement("input");
																						inputTableCommand.setAttribute("type" , "hidden");
																						inputTableCommand.setAttribute("name" , "TableCommand");
																						inputTableCommand.setAttribute("value", "RecordNavigation");
																						TableForm.appendChild(inputTableCommand);

																						//WaiterShield('show');
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					}

																					if (elemIn.name == 'find')
																					{
																						//This case TableForm is overwritten
																						SWSearchFormId										= IdentifierIn+"HTMLFieldSearchers|";
																						SWSearchForm										= document.getElementById(SWSearchFormId);

																					var inputFind 											= document.createElement("input");
																						inputFind.setAttribute("type" , "hidden");
																						inputFind.setAttribute("name" , "find");
																						//inputFind.setAttribute("value", elemIn.value);
																						if (elemIn.id.indexOf("clear|") 	> -1) 	inputFind.setAttribute("value","azzera");
																						if (elemIn.id.indexOf("find|") 		> -1) 	inputFind.setAttribute("value","cerca");
																						if (elemIn.id.indexOf("find_any|") 	> -1) 	inputFind.setAttribute("value","cerca tutti");
																						SWSearchForm.appendChild(inputFind);
																						WaiterShield('show');
																						if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}

																						// The form is serialized (TableForm or other forms)
																						// form should be replaced with divs on order to simplify Object placements
																						//data = $(TableForm).serialize();//+"&Identifier="+SumbitTriggerEl.id;;//+"&Identifier="+SumbitTriggerEl.id;;
																					}
																					data 													= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_Components.ModularVContainer";

																					$.ajax
																					(
																						{
																							type    : "POST",
																							url     : OutgoingURL,
																							data    : data,
																							dataType: "html",
																							success : function(msg)
																							{
																								//			$("#debuggeroutput").html(data);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');																					
																							}
																						}
																					);//ajax
																				}
																				if(SWType=="Components.ListManager")
																				{
																					alert('KKKNNPPP');
																					//This code retrieves the Form that contains data to send
																					//To Server.
																					//In ListManager the main form is TableForm, but the
																					//server communication can be triggered by the Search Field Group too
																					//so the case has to be managed from the 'find' block below
																					// TableForm has to be overwritten
																				var TableFormId												= IdentifierIn+"TableForm|";
																				var TableForm												= document.getElementById(TableFormId);

																					//SubmitTrigger represents the object that caused the sendData event
																					//For backward compatibility
																				var SumbitTriggerElId 										= IdentifierIn +"SubmitTriggerId|";
																				var SumbitTriggerEl 										= document.getElementById(SumbitTriggerElId);
																					// Submit Trigger field is retrieved.
																					// Following code sets the content of the Submit Trigger Field
																					if (element.id.length>0 )
																					{
																						SumbitTriggerEl.value 								= element.id;
																					}else
																					{	// If the calling element has not got an Id, 
																						// the value is provided by the element name
																						// Any element to perform server communication
																						// and send Data needs at least a name or an Id
																						// or both of them
																						SumbitTriggerEl.value 								= IdentifierIn+"TableForm|"+elemIn.name+"|";
																					}
																					//var SW_el 																									= document.getElementById(IdentifierIn);
																					//SubWindow Identifier here
																					//Most times is already present into HTML 
																					//but is re-added for redundancy 
																				var input 													= document.createElement("input");
																					input.setAttribute("type", "hidden");
																					input.setAttribute("name", "Identifier");
																					input.setAttribute("value", IdentifierIn);
																					TableForm.appendChild(input);

																					//var inputSubmitTrigger = document.createElement("input");
																					//input.setAttribute("type", "hidden");
																					//input.setAttribute("name", "Identifier");
																					//input.setAttribute("value", IdentifierIn);
																					//TableForm.appendChild(input);
																					if (typeof elemIn.name != 'undefined') 
																					{
																						if (elemIn.name =='DataFieldOperation')
																						{
																						}
																						if (elemIn.name =='ReportExportOperation')
																						{
																							TableForm 										= elemIn.parentNode;
																							OutgoingURL 									= "PDFServlet";
																							/*var input = document.createElement("input");
																							input.setAttribute("type", "hidden");
																							input.setAttribute("name", "Identifier");
																							input.setAttribute("value", IdentifierIn);
																							TableForm.appendChild(input);
																							var inputTableCommand 	= document.createElement("input");
																							inputTableCommand.setAttribute("type" , "hidden");
																							inputTableCommand.setAttribute("name" , "TableCommand");
																							inputTableCommand.setAttribute("value", elemIn.value);
																							TableForm.appendChild(inputTableCommand);*/
																						}
																						if (elemIn.name =='RecordsetOperation')
																						{
																							OutgoingURL 									= "CAAs";
																							/*var input 					= document.createElement("input");
																							input.setAttribute("type", "hidden");
																							input.setAttribute("name", "Identifier");
																							input.setAttribute("value", IdentifierIn);
																							TableForm.appendChild(input);*/
																						var inputTableCommand								= document.createElement("input");
																							inputTableCommand.setAttribute("type" , "hidden");
																							inputTableCommand.setAttribute("name" , "RecordsetOperation");
																							inputTableCommand.setAttribute("value", elemIn.value);
																							TableForm.appendChild(inputTableCommand);
																						}
																						if (elemIn.name =='TableCommand')
																						{
																							/*var inputNavigation = document.createElement("input");
																							inputNavigation.setAttribute("type" , "hidden");
																							inputNavigation.setAttribute("name" , "RecordNavigation");
																							inputNavigation.setAttribute("value", elemIn.value);
																							TableForm.appendChild(inputNavigation);*/
																						var inputTableCommand 								= document.createElement("input");
																							inputTableCommand.setAttribute("type" , "hidden");
																							inputTableCommand.setAttribute("name" , "TableCommand");
																							inputTableCommand.setAttribute("value", elemIn.value);
																							TableForm.appendChild(inputTableCommand);
																						}
																						if (elemIn.name =='RecordNavigation')
																						{
																						var inputNavigation 								= document.createElement("input");
																							inputNavigation.setAttribute("type" , "hidden");
																							inputNavigation.setAttribute("name" , "RecordNavigation");
																							inputNavigation.setAttribute("value", elemIn.value);
																							TableForm.appendChild(inputNavigation);

																						var inputTableCommand 								= document.createElement("input");
																							inputTableCommand.setAttribute("type" , "hidden");
																							inputTableCommand.setAttribute("name" , "TableCommand");
																							inputTableCommand.setAttribute("value", "RecordNavigation");
																							TableForm.appendChild(inputTableCommand);
																						}
																						if (elemIn.name =='layout_select')
																						{
																						var inputNavigation 								= document.createElement("input");
																							inputNavigation.setAttribute("type", "hidden");
																							inputNavigation.setAttribute("name", "layout_select");
																							inputNavigation.setAttribute("value", elemIn.value);
																							TableForm.appendChild(inputNavigation);

																						var inputTableCommand 								= document.createElement("input");
																							inputTableCommand.setAttribute("type" , "hidden");
																							inputTableCommand.setAttribute("name" , "TableCommand");
																							inputTableCommand.setAttribute("value", "layout_select");
																							TableForm.appendChild(inputTableCommand);
																						}
																						if (elemIn.name =='SortingStorer')
																						{
																							//var refreshTableCommand = document.getElementById(IdentifierIn+'RecordNavigation|refresh|');
																							//refreshTableCommandTimeOut(refreshTableCommand);
																						var inputNavigation 								= document.createElement("input");
																							inputNavigation.setAttribute("type", "hidden");
																							inputNavigation.setAttribute("name", "SortingSelection");
																							inputNavigation.setAttribute("value", elemIn.value);
																							TableForm.appendChild(inputNavigation);

																						var inputTableCommand 								= document.createElement("input");
																							inputTableCommand.setAttribute("type" , "hidden");
																							inputTableCommand.setAttribute("name" , "TableCommand");
																							inputTableCommand.setAttribute("value", "SortingSelection");
																							TableForm.appendChild(inputTableCommand);
																						}
																						if (elemIn.name =='orderercommand')
																						{
																							//var refreshTableCommand = document.getElementById(IdentifierIn+'RecordNavigation|refresh|');
																							//refreshTableCommandTimeOut(refreshTableCommand);

																						var orderercorner_el 								= document.getElementById(IdentifierIn+'orderercorner|');
																						var inputOrdering 									= document.createElement("input");
																							inputOrdering.setAttribute("type", "hidden");
																							inputOrdering.setAttribute("name", "OrderingSelection");
																							inputOrdering.setAttribute("value", jQuery(elemIn).attr("command")+"."+jQuery(orderercorner_el).attr("row_n"));
																							TableForm.appendChild(inputOrdering);

																						var inputTableCommand 								= document.createElement("input");
																							inputTableCommand.setAttribute("type" , "hidden");
																							inputTableCommand.setAttribute("name" , "TableCommand");
																							inputTableCommand.setAttribute("value", "OrderingSelection");
																							TableForm.appendChild(inputTableCommand);
																						}
																						if (elemIn.name == 'find')
																						{
																							//This case TableForm is overwritten
																							TableFormId										= IdentifierIn+"HTMLFieldSearchers|";
																							TableForm										= document.getElementById(TableFormId);
																						var inputFind 										= document.createElement("input");
																							inputFind.setAttribute("type" , "hidden");
																							inputFind.setAttribute("name" , "find");
																							//inputFind.setAttribute("value", elemIn.value);
																							if (elemIn.id.indexOf("clear|") > -1) 		inputFind.setAttribute("value","azzera");
																							if (elemIn.id.indexOf("find|") > -1) 		inputFind.setAttribute("value","cerca");
																							if (elemIn.id.indexOf("find_any|") > -1) 	inputFind.setAttribute("value","cerca tutti");

																							TableForm.appendChild(inputFind);
																							//generalizedFormElement = TableForm;
																						}
																						if ((elemIn.name == 'CheckAll')||(elemIn.name == 'UnCheckAll'))
																						{

																						}
																					}else
																					{// elemIn is the same of element
																					 // here the case when the element name is not defined
																					}

																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					//WaiterShield('show');
																					// The form is serialized (TableForm or other forms)
																					// form should be replaced with divs on order to simplify Object placements
																					//data = $(TableForm).serialize();//+"&Identifier="+SumbitTriggerEl.id;;//+"&Identifier="+SumbitTriggerEl.id;;
																					alert('PPPPMMMBBBNNN');
																					data 												= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_Components.ListManager";

																						//data = $('#|dwcoll|ContainerUP|ScadenzeContratti|TableForm|').serialize();//+"&Identifier="+SumbitTriggerEl.id;;
																						//data = dataaux.split('%7C').join('|');
																						//invio
																						//$("#debuggeroutput").html(data);

																						//clean submit inputs....
																						//Next Action sumbit fields should be empty
																				var MyOwnerSW											= getOwnerSW(elemIn);
																					//$(MyOwnerSW).find('input[name=find]').val("");
																					$(MyOwnerSW).find('input[name=TableCommand]').val("");
																					$(MyOwnerSW).find('input[name=SortingSelection]').val("");
																					$(MyOwnerSW).find('input[name=RecordsetOperation]').val("");
																					$(MyOwnerSW).find('input[name=PresetComboChoice]').val("");
																					//This chunk of code is experimental.
																					// Is needed to keep input fields clean
																					// If the ListManager is not redrawn at each submit they remain dirty.
																					// Above lines ensure next call will be performed without dirty values
																					//console_log("sending data:"+data);
																					
																					$.ajax
																					(
																						{
																							type    : "POST",
																							url     : OutgoingURL,
																							data    : data,
																							dataType: "html",
																							success : function(msg)
																							{
																								//$("#debuggeroutput").html(data);
																								ServerCallBackTokenize(msg);
																							},
																							error: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																					);//ajax

																					/*data = $(TableForm).serialize();
																					$.get('CAAs', data)
																					.done
																					(
																							function(data) 
																							{
																							ServerCallBackTokenize(data);
																							}
																					);*/

																					//QueryString = "Identifier="+IdentifierIn+"&ElementAtomId="+element.id;//+"&"+dataout;
																					//if (element.name == "RecordNavigation")
																					//{
																					//	QueryString+="&RecordNavigation="+element.value;	
																					//}
																					//if (element.name == "TableCommand")
																					//{
																					//	QueryString+="&TableCommand="+element.value;
																					//	QueryString+="&SubmitTrigger="+IdentifierIn+'TableForm|SubmitTriggerId|';
																					//}
																				}
																				if(SWType=="Components.SubWindowChooser")
																				{
																					//if (elemIn.id!=null ){SumbitTriggerEl.value = element.id;}
																					data 													= data_pagechunk+"Identifier="+IdentifierIn+"&"+"ElementAtomId="+element.id+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_Components.SubWindowChooser";
																					//QueryString = data_pagechunk+"Identifier="+IdentifierIn+"&ElementAtomId="+element.id+"&launchpoint=Senddata_Components.SubWindowChooser";
																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					WaiterShield('show');
																					$.ajax({
																						type	: "POST",
																						url		: "CAAs",
																						data	: data,
																						dataType: "html",
																						success: function(msg)
																						{
																							//$("#risultato").html(msg);
																							ServerCallBackTokenize(msg);
																						},
																						error: function()
																						{
																							alert(ServerFailMessage);
																							WaiterShield('hide');
																						}
																						});//ajax
																				}
																				if(SWType=="Utils.FSManager")
																				{
																					/*String fileName 		= request.getParameter("filename");
																					String directoryName 	= request.getParameter("directoryname");
																					String directoryUp 		= request.getParameter("up");
																					String directoryHome 	= request.getParameter("home");
																					String pageUp 			= request.getParameter("pageup");
																					String pageDn 			= request.getParameter("pagedn");
																					String NewFolderName 	= request.getParameter("NewFolderName");
																					String NewFolderCommand = request.getParameter("NewFolderCommand");
																					String DeleteCommand 	= request.getParameter("delete");*/
																				var generalizedFormElement  								= getAssociatedFormElement(elemIn);
																				var element_name 											= element.getAttribute("name");
																					if (element_name=="filename")
																					{
																					var input 												= document.createElement("input");
																						input.setAttribute("type" , "hidden");
																						input.setAttribute("name" , element_name);
																						input.setAttribute("value", element_name.value);
																						generalizedFormElement.appendChild(input);
																					}
																					if (element_name=="directoryname")
																					{
																					var input 												= document.createElement("input");
																					var My_directoryname 									= getLastToken(element.id);
																						input.setAttribute("type" , "hidden");
																						input.setAttribute("name" , element_name);
																						input.setAttribute("value", My_directoryname);
																						generalizedFormElement.appendChild(input);
																					}
																					if (element_name=="up")
																					{
																					var input 												= document.createElement("input");
																						input.setAttribute("type" , "hidden");
																						input.setAttribute("name" , element_name);
																						input.setAttribute("value", element_name.value);
																						generalizedFormElement.appendChild(input);
																					}
																					if (element_name=="home")
																					{
																					var input 												= document.createElement("input");
																						input.setAttribute("type" , "hidden");
																						input.setAttribute("name" , element_name);
																						input.setAttribute("value", element_name.value);
																						generalizedFormElement.appendChild(input);
																					}
																					if (element_name=="pageup")
																					{
																					var input 												= document.createElement("input");
																						input.setAttribute("type" , "hidden");
																						input.setAttribute("name" , element_name);
																						input.setAttribute("value", element_name.value);
																						generalizedFormElement.appendChild(input);
																					}
																					if (element_name=="pagedn")
																					{
																					var input 												= document.createElement("input");
																						input.setAttribute("type" , "hidden");
																						input.setAttribute("name" , element_name);
																						input.setAttribute("value", element_name.value);
																						generalizedFormElement.appendChild(input);
																					}
																					if (element_name=="NewFolderName")
																					{
																					var input 												= document.createElement("input");
																						input.setAttribute("type" , "hidden");
																						input.setAttribute("name" , element_name);
																						input.setAttribute("value", element_name.value);
																						generalizedFormElement.appendChild(input);
																					}
																					if (element_name=="NewFolderCommand")
																					{
																					var input 												= document.createElement("input");
																						input.setAttribute("type" , "hidden");
																						input.setAttribute("name" , element_name);
																						input.setAttribute("value", element_name.value);
																						generalizedFormElement.appendChild(input);
																					}
																					if (element_name=="delete")
																					{
																					var input 												= document.createElement("input");
																						input.setAttribute("type" , "hidden");
																						input.setAttribute("name" , element_name);
																						input.setAttribute("value", element_name.value);
																						generalizedFormElement.appendChild(input);
																					}

																			var 	input 													= document.createElement("input");
																					input.setAttribute("type", "hidden");
																					input.setAttribute("name", "Identifier");
																					input.setAttribute("value", IdentifierIn);
																					generalizedFormElement.appendChild(input);
																					//var SumbitTriggerElId 		 = generalizedFormElement.id +"SubmitTriggerId|";
																					//var SumbitTriggerEl 		 = document.getElementById(SumbitTriggerElId);
																					//SubmitTrigger represents the object that caused the sendData event
																					//For backward compatibility
																					//Moreover it seems to be nice.....
																					//if (elemIn.id!=null ){SumbitTriggerEl.value = element.id;}
																					data 													= data_pagechunk+"Identifier="+IdentifierIn+"&"+serializeGeneralized(generalizedFormElement)+"&launchpoint=Senddata_Utils.FSManager";
																					//WaiterShield('show');
																					if ((showWaiterShield!=null)&&(showWaiterShield!="N")) {WaiterShield('show');}
																					$.ajax
																					(
																						{
																							type	: "POST",
																							url		: "CAAs",
																							data	: data,
																							dataType: "html",
																							success	: function(msg)
																							{
																								//$("#risultato").html(msg);
																								ServerCallBackTokenize(msg);
																							},
																							error	: function()
																							{
																								alert(ServerFailMessage);
																								WaiterShield('hide');
																							}
																						}
																					);//ajax
																				}
																				if(SWType=="BasicComponents.TextAreaPopUp")
																				{//Pay Attention......BasicComponents.TextAreaPopUp is already present above
																				 // this branch seems to not perform any action at all	
																					QueryString 											= data_pagechunk+"Identifier="+IdentifierIn+"&ElementAtomId="+element.id+"&find="+element.value+"&launchpoint=Senddata_BasicComponents.TextAreaPopUp";
																				}
																				if(SWType=="BasicComponents.MessagePopUp")
																				{//Pay Attention......BasicComponents.TextAreaPopUp is already present below
																					// this branch seems to not perform any action at all
																					QueryString 											= data_pagechunk+"Identifier="+IdentifierIn+"&ElementAtomId="+element.id+"&doAction="+element.value+"&launchpoint=Senddata_BasicComponents.MessagePopUp";
																				}
																				/*var jqxhr = $.get
																							( 
																								"CAAs?"+QueryString, 
																								function() 
																								{
																					  			//	alert( "success" );
																								}
																							)
																					  		.done
																					  		(
																					  				function(data) 
																					  				{
																					    				ServerCallBackTokenize(data);
																					  				}
																					  		)
																					  		.fail
																					  		(
																					  				function() 
																					  				{
																					    				alert( "error" );
																					  				}
																					  		)
																					  		.always
																					  		(	
																					  				function() 
																					  				{
																					  				}
																					  		);*/
																				/*$.get('CAAs', data)
																			  	.done
																					(
																							function(data) 
																							{
																							ServerCallBackTokenize(data);
																							}
																					);*/
																		}else
																		{
																			
																		}
											} 
										}
}

function sendDataForm(IdentifierIn,element,SWType,IdentifierFormIn)
{
									var ElementIn = document.getElementById(IdentifierFormIn);
									var QueryString = "";
									var data;
										if(SWType=="Utils.DataBeanFunctions")
										{
											data = $(ElementIn).serialize();
											data += "&Identifier="+IdentifierIn+"&ElementAtomId="+element.id+"&find="+element.value+"&launchpoint=Senddata_Utils.DataBeanFunctions";
										}
	/*$.get('CAAs', data)
			  	.done
		  		(
		  				function(data) 
		  				{
		    				ServerCallBackTokenize(data);
		  				}
		  		);*/
}

function sendDataLayoutDispatcher(IdentifierIn,FunctionCallIn,eventIn)
{
	var Mypageobjtoken				= $(document.body).attr('pageobjtoken');
	var Mypagename					= $(document.body).attr('pagename');
	var SessionPageFullName			= Mypageobjtoken+"_"+Mypagename;
	var	data_pagechunk				= 'sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+Mypagename+'&';

		//console_log(":::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::");
		//console_log('entering  sendDataLayoutDispatcher ..... Identifier:'+IdentifierIn+'  FunctionCallIn ::' +FunctionCallIn);
	var TableFormId					= IdentifierIn+"TableForm|";
	var element_layout_name_name	=	"";
	/*var TableForm			= document.getElementById(TableFormId);
	var SumbitTriggerElId 	= IdentifierIn +"TableForm|SubmitTriggerId|";
	var SumbitTriggerEl 	= document.getElementById(SumbitTriggerElId);
	//SubmitTrigger represents the object that caused the sendData event
	//For backward compatibility
	if (element.id.length>0 )
	{
		SumbitTriggerEl.value = element.id;
	}else
	{
		SumbitTriggerEl.value =IdentifierIn+"TableForm|"+elemIn.name+"|";
	}
	var input = document.createElement("input");
	input.setAttribute("type", "hidden");
	input.setAttribute("name", "Identifier");
	input.setAttribute("value", IdentifierIn);
	TableForm.appendChild(input);*/

	var msgToDispatcherLayout=data_pagechunk+"Identifier="+IdentifierIn+"&FunctionCall="+FunctionCallIn;//+"&layout_name="+ActiveRowOrder+"&layout-string=";
	var share_el = document.getElementById(IdentifierIn+"_share|checkuncheck_storage|");
		if (isValidElement(share_el)) msgToDispatcherLayout = msgToDispatcherLayout+"&share="+jQuery(share_el).val();
	if (FunctionCallIn=='retrievemetadata') //START:restrievemetadata
	{
		//var elementApplicationLogoCorner 		= document.getElementById('ApplicationLogoCorner');
		//var elementApplicationLogoCornerWidth 	= elementApplicationLogoCorner.clienWidth; 
		var WidthStringToDispatch 				= "";
		var elementTableContents 				= document.getElementById(IdentifierIn.split("|").join("__")+'ContentTable__');
//		var elementTableContentsThead 			= elementTableContents.childNodes;
		var FoundChunks							= 0;
		//console.log("elementTableContents : "+elementTableContents.id+" IdentifierIn : "+IdentifierIn);
//		for(var ggi=0;ggi<elementTableContentsThead.length;ggi++)
//		{
//			if (elementTableContentsThead[ggi].tagName.toUpperCase() == 'THEAD')
//			{
//				var elementTableHeader 			= elementTableContentsThead[ggi];
//				var elementTableHeaderChilds 	= elementTableHeader.childNodes;
//				for(var ggj=0;ggj<elementTableHeaderChilds.length;ggj++)
//				{
//					if (elementTableHeaderChilds[ggj].tagName.toUpperCase() == 'TR')
//					{
//						var elementTableHeaderRow 			= elementTableHeaderChilds[ggj];
//						var elementTableHeaderRowChilds 	= elementTableHeaderRow.childNodes;
						//console.log(">>>>>>>>>>>>>"+elementTableContents.id);
					var elementTableHeaderRowChilds = $(elementTableContents).find("th");
						
						for(var ggk=0;ggk<elementTableHeaderRowChilds.length;ggk++)
						{
							if (elementTableHeaderRowChilds[ggk].tagName.toUpperCase() == 'TH')
							{
							var elementTableHeaderRowTH 		= elementTableHeaderRowChilds[ggk];
								//found TH. Is needed to obtain element width
							var elementWidth 					= parseInt(elementTableHeaderRowTH.clientWidth);
							var elementTableHeaderRowTHElems	= elementTableHeaderRowTH.childNodes;
								for(var ggu=0;ggu<elementTableHeaderRowTHElems.length;ggu++)
								{
									var elementUnderTest 		= elementTableHeaderRowTHElems[ggu];
									var elementUnderTestName 	= $(elementUnderTest).attr("name");
									if (typeof elementUnderTestName!= 'undefined')
									{
										if(elementUnderTestName=='SortingStorer')
										{
											WidthStringToDispatch+=elementUnderTest.id+":"+elementWidth+"px;";
											++FoundChunks;
										}
									}
								}
							}
						}
//						ggj = elementTableHeaderChilds.length;
						//loop exit
//					}
//				}
//			}
//		}
		if (FoundChunks>0)
		{
			msgToDispatcherLayout+="&ColumnWidthStringToDispatch="+WidthStringToDispatch;
		}
	}//END:retrievemetadata
	if (FunctionCallIn=='LiveColumnWidthChanges') //LiveColumnWidthChanges
	{
		///////////////////////////////////
		var ggj							= 0;
		///////////////////////////////////
		var CSSwidth					= "";
		var Stopwidth 					= $(eventIn.target).width();
		var CallerColumnName 			= "";
		var auxid 						= "";
		var CallerElement 				= eventIn.target;
		var CallerTagName 				= eventIn.target.tagName;
		var CallerElementChilds 		= CallerElement.childNodes;
		var MyColumnName				= "";
		var DebugString					= "";
		var CurrentColumnFound			= "false";
		///$('#debuggeroutput').html("ddddd"+CallerTagName+" --childs number  : "+CallerElementChilds.length);
		var table 						= document.getElementById(IdentifierIn.split("|").join("__")+'ContentTable__');
		//var CallerElementChilds 		= CallerElement.childNodes;
		//$('#debuggeroutput').html("uuuuui");	
		//console.log("===================================");
		for(var rri=0;rri<CallerElementChilds.length;rri++)
		{
			if (typeof CallerElementChilds[rri] !='undefined')
			{
			var	NameAttribute = $(CallerElementChilds[rri]).attr('name');
				//AttributeString = AttributeString+"<br>" +rri +"  g "+NameAttribute;
				
				if (typeof NameAttribute  != 'undefined')
				{
					//AttributeString=AttributeString+' OK';
					if (NameAttribute=='SortingStorer')
					{
						var CurrentId 	= CallerElementChilds[rri].id;
						var MyIdTokens 	= CurrentId.split("|");
						MyColumnName 	= MyIdTokens[MyIdTokens.length-2];
					}
				}
				//$('#debuggeroutput').html("jjjiii");
			}
			//if (elementTableHeaderChilds[rrj].getAttribute("name") == 'SortingStorer')
			//{
				//auxid = elementTableHeaderChilds[rrj].id; 
			//}
		}
		var CallerElement 				= eventIn.target;
		var CallerElementId 			= CallerElement.id;

		var WidthStringToDispatch 		= "";
		var elementTableContents 		= document.getElementById(IdentifierIn.split("|").join("__")+'ContentTable__');
		var elementTableHeaderRowChilds	= $(elementTableContents).find("th");

		var elementTableContentsThead 	= elementTableContents.childNodes;
		var FoundChunks					= 0;
		//console.log("elementTableHeaderRowChilds : "+elementTableHeaderRowChilds.length);

//		for(var ggi=0;ggi<elementTableContentsThead.length;ggi++)
//		{
//			if (elementTableContentsThead[ggi].tagName.toUpperCase() == 'THEAD')
//			{
//				var elementTableHeader 			= elementTableContentsThead[ggi];
//				var elementTableHeaderChilds 	= elementTableHeader.childNodes;
//				for(var ggj=0;ggj<elementTableHeaderChilds.length;ggj++)
//				{
//					if (elementTableHeaderChilds[ggj].tagName.toUpperCase() == 'TR')
//					{
//						var elementTableHeaderRow 	= elementTableHeaderChilds[ggj];
//						var elementTableHeaderRowChilds 	= elementTableHeaderRow.childNodes;
						for(var ggk=0;ggk<elementTableHeaderRowChilds.length;ggk++)
						{
							if (elementTableHeaderRowChilds[ggk].tagName.toUpperCase() == 'TH')
							{
								var elementTableHeaderRowTH 		= elementTableHeaderRowChilds[ggk];
								var elementTableHeaderRowTHElems	= elementTableHeaderRowTH.childNodes;
								var ColumnWidth 					= elementTableHeaderRowTH.clientWidth;
								var CallerColumnElementPos 			= elementTableHeaderRowTH.getBoundingClientRect();
								for(var ggu=0;ggu<elementTableHeaderRowTHElems.length;ggu++)
								{
									var elementUnderTest 		= elementTableHeaderRowTHElems[ggu];
									var elementUnderTestName 	= $(elementUnderTest).attr("name");
									//console.log("_______________ggu="+ggu+" elementUnderTestName:"+elementUnderTestName);
									if (typeof elementUnderTestName!= 'undefined')
									{
										if(elementUnderTestName=='SortingStorer')
										{
											var elementUnderTestIdTokens = elementUnderTest.id.split("|");
											var elementUnderTestColName =  elementUnderTestIdTokens[elementUnderTestIdTokens.length-2];
											if (elementUnderTestColName==MyColumnName)
											{
												ColumnWidth 					 = elementTableHeaderRowTH.clientWidth;
												WidthStringToDispatch			+= elementUnderTestColName+":"+ColumnWidth+";";
												++FoundChunks;
												CSSWidth = "[]"+ CallerColumnElementPos.left+"  - "+CallerColumnElementPos.right ;//getCSS(elementTableHeaderRowTH, 'width'); 
												
											}
										}
									}
									//if (elementUnderTest.getAttribute("name")=='SortingStorer')
									//{
									//	WidthStringToDispatch+=elementUnderTest.id+":"+ColumnWidth+";";
									//	++FoundChunks;
									//}
								}
							}
						}
						//ggj = elementTableHeaderChilds.length;
						//loop exit
//					}
//				}
//			}
//		}
		if (FoundChunks>0)
		{
			msgToDispatcherLayout+="&WidthStringToDispatch="+WidthStringToDispatch;
		}
		//$('#debuggeroutput_content').html("caller column ttt : " +MyColumnName+"  .... "+WidthStringToDispatch+" stop width:"+Stopwidth+" ,,CSSwidth :"+CSSWidth);
		/*RELEASE 1 : ALL COLUMNS WIDTH ARE SENT
		var WidthStringToDispatch 		= "";
		var elementTableContents 		= document.getElementById(IdentifierIn+'TableContents|');
		var elementTableContentsThead 	= elementTableContents.childNodes;
		var FoundChunks					= 0;

		for(var ggi=0;ggi<elementTableContentsThead.length;ggi++)
		{
			if (elementTableContentsThead[ggi].tagName.toUpperCase() == 'THEAD')
			{
				var elementTableHeader 			= elementTableContentsThead[ggi];
				var elementTableHeaderChilds 	= elementTableHeader.childNodes;
				for(var ggj=0;ggj<elementTableHeaderChilds.length;ggj++)
				{
					if (elementTableHeaderChilds[ggj].tagName.toUpperCase() == 'TR')
					{
						var elementTableHeaderRow 	= elementTableHeaderChilds[ggj];
						var elementTableHeaderRowChilds 	= elementTableHeaderRow.childNodes;
						for(var ggk=0;ggk<elementTableHeaderRowChilds.length;ggk++)
						{
							if (elementTableHeaderRowChilds[ggk].tagName.toUpperCase() == 'TH')
							{
								var elementTableHeaderRowTH 		= elementTableHeaderRowChilds[ggk];
								var elementTableHeaderRowTHElems	= elementTableHeaderRowTH.childNodes;
								var ColumnWidth 					= elementTableHeaderRowTH.clientWidth;
								for(var ggu=0;ggu<elementTableHeaderRowTHElems.length;ggu++)
								{
									var elementUnderTest = elementTableHeaderRowTHElems[ggu];
									if (elementUnderTest.getAttribute("name")=='SortingStorer')
									{
										WidthStringToDispatch+=elementUnderTest.id+":"+ColumnWidth+";";
										++FoundChunks;
									}
								}
							}
						}
						ggj = elementTableHeaderChilds.length;
						//loop exit
					}
				}
			}
		}
		if (FoundChunks>0)
		{
			msgToDispatcherLayout+="&WidthStringToDispatch="+WidthStringToDispatch;
		}*/
	}//LiveColumnWidthChanges
	if (FunctionCallIn=='LiveColumnSequenceChanges') //LiveColumnSequenceChanges
	{
			//$('#debuggeroutput_content').html('JJJJJJJJJJJJJJJ');
			removeTimerTableColumnMovingStartingBy(IdentifierIn);
		var SortingStringToDispatch 	= "";
		var elementTableContents 		= document.getElementById(normalizeTokens__(IdentifierIn)+'ContentTable__');
			//var elementTableContentsThead 	= elementTableContents.childNodes;
			//var Foundtables = $('#'+normalizeTokens__(IdentifierIn)+'ContentTable__');
			//console.log("fond tables : "+Foundtables.length);
		var elementTableContentsThead  = $(elementTableContents).find('th');
			//console.log("table:"+elementTableContents.id+" HTML : "+elementTableContents.innerHTML);
			//var MyTHEAD = $(Foundtables).find('thead');
			//console.log("MyTHEAD len : "+MyTHEAD.length);
		var FoundChunks					= 0;
			//console.log("elementTableContentsThead :"+elementTableContentsThead.length+" tagname : "+elementTableContentsThead[0].tagName);
//		for(var ggi=0;ggi<elementTableContentsThead.length;ggi++)
//		{
//			console.log("ggi : "+ggi+" elementTableContentsThead[ggi].tagName : "+elementTableContentsThead[ggi].tagName);
//			if (elementTableContentsThead[ggi].tagName.toUpperCase() == 'THEAD')
//			{
//				var elementTableHeader 			= elementTableContentsThead[ggi];
//				var elementTableHeaderChilds 	= elementTableHeader.childNodes;
//				for(var ggj=0;ggj<elementTableHeaderChilds.length;ggj++)
//				{
//					if (elementTableHeaderChilds[ggj].tagName.toUpperCase() == 'TR')
//					{
//						var elementTableHeaderRow 			= elementTableHeaderChilds[ggj];
//						var elementTableHeaderRowChilds 	= elementTableHeaderRow.childNodes;
					var elementTableHeaderRowChilds     = $(elementTableContents).find('th');
						for(var ggk=0;ggk<elementTableHeaderRowChilds.length;ggk++)
						{
							//console.log("ggk : "+elementTableHeaderRowChilds[ggk].tagName);
							if (elementTableHeaderRowChilds[ggk].tagName.toUpperCase() == 'TH')
							{
							var	elementTableHeaderRowTH 		= elementTableHeaderRowChilds[ggk];
							var	elementTableHeaderRowTHElems	= elementTableHeaderRowTH.childNodes;
								for(var ggu=0;ggu<elementTableHeaderRowTHElems.length;ggu++)
								{
									var elementUnderTest 		= elementTableHeaderRowTHElems[ggu];
									var elementUnderTestName 	= $(elementUnderTest).attr("name");
									if (typeof elementUnderTestName!= 'undefined')
									{
										if(elementUnderTestName=='SortingStorer')
										{
											SortingStringToDispatch+=elementUnderTest.id+";";
											++FoundChunks;
										}
									}
								}
							}
						}
						//ggj = elementTableHeaderChilds.length;
						//loop exit
//					}
//				}
//			}
//		}
		if (FoundChunks>0)
		{
			msgToDispatcherLayout+="&ColumnSequenceStringToDispatch="+SortingStringToDispatch;
			//console.log('msgToDispatcherLayout:'+msgToDispatcherLayout);
		}
	}//LiveColumnSequenceChanges
	if (FunctionCallIn=='storelayout') //storelayout
	{
	var element_layout_name 		= document.getElementById("sortablelist");
		element_layout_name_name	= element_layout_name.options[element_layout_name.selectedIndex].text;		
		msgToDispatcherLayout	   += "&layout_name="+element_layout_name_name+"&layout_string=";

	var LayoutStringToSend 		= "";
		LayoutStringToSend 			= LayoutStringToDispatchGenerate();

		/*var StringToStore = "";//" !-----! ";//"!#####! !@@PPROWNAME@@! !@@VVCOLUMNINFO@@! !@@PPROWTYPE@@! !@@VVTABLESTRUCTURE@@!";
		var elementsListToSend  =  document.getElementsByTagName("li");
		for(var jo=0;jo<elementsListToSend.length;jo++)
		{
			if (
					(elementsListToSend[jo].id!='undefined')
					&&
					(elementsListToSend[jo].id.substring(0,12)== 'column_name_' )
				)
			{
				var StringToStoreChunk	= "!-----! ";
				//var ColumnSQLName		="";
				//var ColumnWidth			="";
				//var ColumnVisibility	="";
				//var ColumnDataOrdering	="";

				
				
				var childArray = elementsListToSend[jo].childNodes;
				var tt =0;
				for( tt=0;tt<childArray.length;tt++)
				{
					if (typeof childArray[tt].name != 'undefined')
					{
						if (childArray[tt].name=='COLUMNNAME')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";// ColumnSQLName = childArray[tt].value;		
						}
						if (childArray[tt].name=='COLUMNLABEL')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";// ColumnWidth = childArray[tt].value;		
						}
						if (childArray[tt].name=='COLUMNVISIBILITY')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";
						}
						if (childArray[tt].name=='COLUMNSORTING')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";
						}
						if (childArray[tt].name=='COLUMNWIDTH')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"px"+"@@!";
						}
					}
				}
				//var childArray = container.children;
				//StringToStoreChunk+=" !-----! ";
				StringToStore	  +=StringToStoreChunk;
				//StringToStore+="!@@PPCOLUMNNAME@@! !@@VV"+elementsListToSend[jo].id.substring(12)+"@@! ";
				//StringToStore+="!@@PPCOLUMNWIDTH@@! !@@VV"+elementsListToSend[jo].id.substring(12)+"@@! ";
				//var $descendantDivs = $(elementsListToSend[jo]).find( "div" );
				//for(var hx=0;hx<$descendantDivs.legth;hx++)
				//{
				//	alert('ddddddddddddxxxxxxxxxxx');
				//	if (
				//			($descendantDivs[hx].id!='undefined')
				//			&&
				//			($descendantDivs[hx].id.substring(0,13)== 'TableColWidth' )
				//		)
				//	{
				//		alert('found width');
				//	}
				//}
				//StringToStoreColName+=
			}
			//StringToStore+="!-----! ";
		}*/
		msgToDispatcherLayout+=LayoutStringToSend;
	}//storelayout

	if (FunctionCallIn=='addlayout') //addlayout
	{
	var element_layout_name 		 = document.getElementById("NewArrangerElementName");
		//var ActiveRowOrder			 = element_layout_name.value;
		element_layout_name_name 		 = element_layout_name.value;//getValueByParName(RowsOrder[ActiveRowOrder],'ROWNAME');
		msgToDispatcherLayout	   		+= "&layout_name="+element_layout_name_name+"&layout_string=";
	var LayoutStringToSend 			 = "";
		LayoutStringToSend 				 = LayoutStringToDispatchGenerate();
		/*
		var StringToStore = "";//" !-----! ";//"!#####! !@@PPROWNAME@@! !@@VVCOLUMNINFO@@! !@@PPROWTYPE@@! !@@VVTABLESTRUCTURE@@!";
		var elementsListToSend  =  document.getElementsByTagName("li");
		for(var jo=0;jo<elementsListToSend.length;jo++)
		{
			if (
					(elementsListToSend[jo].id!='undefined')
					&&
					(elementsListToSend[jo].id.substring(0,12)== 'column_name_' )
				)
			{

				var StringToStoreChunk	= "!-----! ";
				//var ColumnSQLName		="";
				//var ColumnWidth			="";
				//var ColumnVisibility	="";
				//var ColumnDataOrdering	="";
				var childArray = elementsListToSend[jo].childNodes;
				var tt =0;
				for( tt=0;tt<childArray.length;tt++)
				{
					if (typeof childArray[tt].name != 'undefined')
					{
						if (childArray[tt].name=='COLUMNNAME')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";// ColumnSQLName = childArray[tt].value;		
						}
						if (childArray[tt].name=='COLUMNLABEL')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";// ColumnWidth = childArray[tt].value;		
						}
						if (childArray[tt].name=='COLUMNVISIBILITY')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";
						}
						if (childArray[tt].name=='COLUMNSORTING')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";
						}
						if (childArray[tt].name=='COLUMNWIDTH')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"px"+"@@!";
						}

					}
				}
				StringToStore	  +=StringToStoreChunk;
				
			}
			//StringToStore+="!-----! ";
			
		}*/

		msgToDispatcherLayout+=LayoutStringToSend;
	}//addlayout
	if (FunctionCallIn=='ereaselayout') //START : refreshcurrentlayout
	{
		var element_layout_name 		 = document.getElementById("sortablelist");
			element_layout_name_name     = element_layout_name.options[element_layout_name.selectedIndex].text;
		var element_LM_layout_name 		 = document.getElementById(IdentifierIn+"TableForm|layout_select|");
		var element_LM_layout_name_name	 = element_LM_layout_name .options[element_LM_layout_name.selectedIndex].text;		
			msgToDispatcherLayout	        += "&layout_name="+element_layout_name_name+"&LM_layout_name="+element_LM_layout_name_name;
			if (element_LM_layout_name_name==element_layout_name_name)
			{
				msgToDispatcherLayout+= "&layout_same=true";
			}
	}
	if (FunctionCallIn=='refreshcurrentlayout') //START : refreshcurrentlayout
	{
		var element_layout_name 							= document.getElementById("sortablelist");
		//var ActiveRowOrder			= element_layout_name.options[element_layout_name.selectedIndex].value;
		var ActiveRowName 									= element_layout_name.options[element_layout_name.selectedIndex].text;
			msgToDispatcherLayout	 						+= "&layout_name="+ActiveRowName+"&layout_string=";
		var LayoutStringToSend								= "";
			LayoutStringToSend								= LayoutStringToDispatchGenerate();
		/*var StringToStore = "";//" !-----! ";//"!#####! !@@PPROWNAME@@! !@@VVCOLUMNINFO@@! !@@PPROWTYPE@@! !@@VVTABLESTRUCTURE@@!";
		var elementsListToSend  =  document.getElementsByTagName("li");
		for(var jo=0;jo<elementsListToSend.length;jo++)
		{
			if (
					(elementsListToSend[jo].id!='undefined')
					&&
					(elementsListToSend[jo].id.substring(0,12)== 'column_name_' )
				)
			{
				var StringToStoreChunk	= "!-----! ";
				//var ColumnSQLName		="";
				//var ColumnWidth			="";
				//var ColumnVisibility	="";
				//var ColumnDataOrdering	="";
				var childArray = elementsListToSend[jo].childNodes;
				var tt =0;
				for( tt=0;tt<childArray.length;tt++)
				{
					if (typeof childArray[tt].name != 'undefined')
					{
						if (childArray[tt].name=='COLUMNNAME')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";// ColumnSQLName = childArray[tt].value;		
						}
						if (childArray[tt].name=='COLUMNLABEL')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";// ColumnWidth = childArray[tt].value;		
						}
						if (childArray[tt].name=='COLUMNVISIBILITY')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";
						}
						if (childArray[tt].name=='COLUMNSORTING')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";
						}
						if (childArray[tt].name=='COLUMNWIDTH')
						{
							StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"px"+"@@!";
						}
					}
				}
				//var childArray = container.children;
				//StringToStoreChunk+=" !-----! ";
				StringToStore	  +=StringToStoreChunk;
				//StringToStore+="!@@PPCOLUMNNAME@@! !@@VV"+elementsListToSend[jo].id.substring(12)+"@@! ";
				//StringToStore+="!@@PPCOLUMNWIDTH@@! !@@VV"+elementsListToSend[jo].id.substring(12)+"@@! ";
				//var $descendantDivs = $(elementsListToSend[jo]).find( "div" );
				//for(var hx=0;hx<$descendantDivs.legth;hx++)
				//{
				//	alert('ddddddddddddxxxxxxxxxxx');
				//	if (
				//			($descendantDivs[hx].id!='undefined')
				//			&&
				//			($descendantDivs[hx].id.substring(0,13)== 'TableColWidth' )
				//		)
				//	{
				//		alert('found width');
				//	}
				//}
				//StringToStoreColName+=
			}
			//StringToStore+="!-----! ";
		}*/
		msgToDispatcherLayout+=LayoutStringToSend;
		// really needed this chunk of code?
		// at the moment, on 11/10/2014 'refreshcurrentlayout' is called only by CloseMe() method 
		// in TableLayout.js file
		//		document.getElementById(IdentifierIn+"TableStateInfo|layuot_state|").value 				= '0050';
		//		document.getElementById(IdentifierIn+"RecordNavigation|layout|").style.backgroundColor 	= 'yellow';
		//		var elem = document.getElementById('TableArragner');
		//		elem.parentNode.removeChild(elem);
	}//END : refreshcurrentlayout

	$.ajax
	(
		{
			type		: "POST",
			//url: "test/ajaxreciever.jsp",
			url			: "LayoutDispatcher",
			data		: msgToDispatcherLayout,
			dataType	: "html",
			success		: function(msgFromDispatcherLayout)
			{
				//$("#risultato").html(msg);
				//ServerCallBackTokenize(msgFromDispatcherLayout);
				if (FunctionCallIn=='retrievemetadata')
				{
					ParseTableRowDataAndCommands(FunctionCallIn,msgFromDispatcherLayout,IdentifierIn);
					Force_sortablelist_Entering_layout_name="";
				}
				if (FunctionCallIn=='storelayout')
				{
					layout_state_tracking('Reset',IdentifierIn);
					sendData(IdentifierIn,document.getElementById(IdentifierIn+'TableForm|layout_select|'),'Components.ListManager');
				}

				if (FunctionCallIn=='addlayout')
				{
					Force_sortablelist_Entering_layout_name = element_layout_name_name;
					//('adding layout:'+Force_sortablelist_Entering_layout_name);
					///////////////
					// this code should be rearranged into a new function and merged with TableSorter function into TableLayout.js
					RemoveElementById('TableArragner');
				var element_layout_select   	= document.getElementById(IdentifierIn+"TableForm|layout_select|");
				var option 						= document.createElement("option");
					option.text 				= element_layout_name_name;
					option.value 				= element_layout_name_name;
					element_layout_select.add(option);
					element_layout_select.value = element_layout_name_name;
					sendData(IdentifierIn,element_layout_select,'Components.ListManager');
					generateTableSorterFrame(IdentifierIn);
					layout_state_tracking('Reset',IdentifierIn);
					sendDataLayoutDispatcher(IdentifierIn,'retrievemetadata');
				}
				if (FunctionCallIn=='ereaselayout')
				{
						if (msgToDispatcherLayout.indexOf('layout_same=true')>-1)
						{
						var element_LM_layuot_name  = document.getElementById(IdentifierIn+'TableForm|layout_select|');
							element_LM_layuot_name.options[0].selected = true; 
							sendData(IdentifierIn,document.getElementById(IdentifierIn+'TableForm|layout_select|'),'Components.ListManager');
						}
						Force_sortablelist_Entering_layout_name = "Predefinito";
						///////////////
						// this code should be rearranged into a new function and merged with TableSorter function into TableLayout.js
						RemoveElementById('TableArragner');
						sendDataLayoutDispatcher(IdentifierIn,'retrievemetadata');
						generateTableSorterFrame(IdentifierIn);
				}
				if (FunctionCallIn=='LiveColumnSequenceChanges')
				{
					ParseTableRowDataAndCommands(FunctionCallIn,msgFromDispatcherLayout,IdentifierIn);
				}
				if (FunctionCallIn=='LiveColumnSequenceChanges')
				{
					//ParseTableRowDataAndCommands(FunctionCallIn,msgFromDispatcherLayout);					
				}
				if (FunctionCallIn=='refreshcurrentlayout')
				{
					//ParseTableRowDataAndCommands(FunctionCallIn,msgFromDispatcherLayout);
					sendData(IdentifierIn, document.getElementById(IdentifierIn+'RecordNavigation|refresh|'),'Components.ListManager');
				}
			},
			error: function()
			{
				alert("Chiamata LayoutDispatcher fallita, si prega di riprovare...");
			}
		}
	);//ajax
}

//this function should be improved
//at the moment it seems that any elemet has to find the same element to refresh
//or its parent....
//The trouble fires when disappears an element and in a futher step it appears back again 
//If the element that is turing on is on thirth place it has to  reappear at the thirth place again.
//On this configuration, if an element has not got a parent or itself does not exist in an 
//hidden way won't be shown at all
//may be client could require unparented elements

//If the parent of an element has got a level (z-index) lower than the element, they can't be linked
//If there is a level jump, attribute newlevellayer_ is present
//and the element has to be linked to body


function ServerStateImplement(isStartupOrReload,dataIn)
{
				jQuery('#servercallback').remove();
				
				if (isStartupOrReload)
				{
					dynamicallyLoadFontAwesome(ContextPath+'/js/font-awesome/all.min.css');

					$.ajax
					(
						{
							type	: "GET",
							url		: "StartUpSequence",
							dataType: "html",
						   	data	: dataIn,
							async	: true,
							success	: function(msg)
							{
								
								ServerCallBackTokenize(msg);
								
								AfterStartupOrReload();
								storePageObjToken(jQuery(document.body).attr('pageobjtoken'));
								storePageTitle();
								attachWindowResize();	
							},
							error: function()
							{
								alert(ServerFailMessage);
								//WaiterShield('hide');
							}
						}
					);
				} else
				{
					//console.log("========================== ServerStateImplement not reload ===========================");
					$.ajax(
						{
							type	: "POST",
							url		: "CAAs",
							data	: dataIn,
							dataType: "html",
							async	: true,

							success: function(msg)
							{
								ServerCallBackTokenize(msg);
							},
							error: function()
							{
								alert(ServerFailMessage);
								WaiterShield('hide');
							}
						}
					);//ajax
				}
}

function ServerStateImplement___usingiframe(isStartupOrReload,dataIn)
{

				jQuery('#servercallback').remove();
				//console_log("removing any event");
				if (isStartupOrReload)
				{
	//		const 	iframe = document.createElement('iframe');
	//				iframe.src= encodeURI('StartUpSequence?'+dataIn);
	//				$('body').append(iframe);
	//				console.log(jQuery(iframe).contents().find('#servercallback').text());
	//				$('body').append('<iframe src="'+encodeURI('StartUpSequence?'+dataIn)+'" name="frame1" id="frame1"></iframe>');

					//console.log($("#frame1").contents().find('#servercallback'));
					//const pippoContent = $('#frame1').contents().find('#servercallback').val();

								jQuery(document.body).html("ciao");

/*
        	const   myiframe = $('#frame1')[0];

        			myiframe.addEventListener('load', function () {
					    console.log('Iframe has finished loading!');
					    
					    // Optional: Access iframe document if same-origin
					    try {
					      const doc = myiframe.contentDocument || myiframe.contentWindow.document;
					      console.log('Iframe body:'+ doc.body);
					      console.log(doc.body);
					     var servercallback_el = jQuery(doc).find("#servercallback")[0];
					     console.log(  servercallback_el );
					     
					     
					         const content = servercallback_el.content.cloneNode(true);
					         console.log(content);
					         jQuery(document.body).append("<div id='target-div'></div>");

							  // 3. Get the target container where you want to insert the template content
							  const target =  document.createElement("div");
							
							  // 4. Append the cloned content to the target container
							  target.appendChild(content);
							console.log(	jQuery(target).html());
							var msg = "<div id='servercallback' style='height:0px;width:0px;visibility:hidden;overflow:hidden;' >"+jQuery(target).html()+"</div>";
							
							
								//ServerCallBackTokenize(msg);
								//AfterStartupOrReload();
								//storePageObjToken(jQuery(document.body).attr('pageobjtoken'));
								//storePageTitle();		
								
								jQuery(document.body).html("ciao");

					    } catch (e) {
					      console.warn('Could not access iframe content (likely cross-origin).');
					    }
					  });
					  */
				} else
				{
					/*
					try 
					{
				        // Use fetch with proper error handling
				  const response = await fetch('/CAAs?'+dataIn, 
				        {
				            method: 'GET',
				            headers: {
				                'Content-Type': 'text/html',
				            },
				            credentials: 'same-origin'
				        });
				
				        if (!response.ok) 
				        {
				            throw new Error(`HTTP error! status: ${response.status}`);
				        }
				
        		const 	htmlContent = await response.text();
						ServerCallBackTokenize(htmlContent);
				    } catch (error) 
				    {
				        console.error('Failed to load user data:', error);
				        // Fallback or error UI handling
						alert(ServerFailMessage);
						WaiterShield('hide');
				    }*/
				}
}


// Optimal pattern for Lighthouse
async function loadUserData() {
}




function ServerCallBackTokenize_new(msg)
{
	
								jQuery('#servercallback').remove();
								//console.log('================================================');
								//console.log(msg);
								//jQuery(document.body).prepend(msg);
								
							var	endsessionhtml_els = jQuery(msg).find('.endsessionhtml');
								if (endsessionhtml_els.length>0)
								{
									endsessionhtml = jQuery(endsessionhtml_els[0]).html();
									//jQuery(document.body).find('.endsessionhtml').remove();
								}
								
								jQuery(msg).find(".jsembedded.caclient").each(
									function()
									{
									var linked_sw = $(this).attr("linked_sw");
										jQuery("head").find("script.caclient[linked_sw='"+linked_sw+"']").remove();
										$(this).detach().appendTo("head");
									}
								);
								
								jQuery(msg).find(".jsembedded.objectmainscript").each(
									function()
									{
									var owner_family = $(this).attr("owner_family");
										jQuery("head").find("script.objectmainscript[owner_family='"+owner_family+"']").remove();
										$(this).detach().appendTo("head");
									}
								);
								
								jQuery(msg).find(".jsembedded.jsfile").each(
									function()
									{
									var file_id = $(this).attr("file_id");
										jQuery("head").find("script.jsfile[file_id='"+file_id+"']").remove();
										$(this).detach().appendTo("head");
									}
								);


								jQuery(msg).find(".jsembedded.jsfunctionfree").each(
									function()
									{
									var function_signature = $(this).attr("function_signature");
										jQuery("head").find("script.jsfunction[function_signature='"+function_signature+"']").remove();
										$(this).detach().appendTo("head");
									}
								);
								
								
							var performsenddataonclasstypes_incoming_els =	jQuery(document.body).find('.performsenddataonclasstypes');
								
								if (performsenddataonclasstypes_incoming_els.length>0)
								{
									jQuery("head").find(".performsenddataonclasstypes").remove();
									jQuery(document.body).find('.performsenddataonclasstypes').detach().appendTo("head");
								}
								
								
								ServerCallBackTokenizeTasks('ELEMENTREFRESH');
								
								
								
								ServerCallBackTokenizeTasks('NOTVISIBLELIST');
								
								performAttachToSW();
								
								ZoomCSSComponentImplement();
								
								execute_UserMessages.call();
								execute_beforeLoad.call();
								execute_afterLoad.call();
								manage_clientevents.call();
								
								setUpModernGraphicHTMLExtenders();
								
								//drag,move,.....ListManager and moving PopUp
										
								//JS management. changed now
								//performJSinSW_after();


								//scrollManagement(ModifiedElements);
								
								
								//Level management....start
								newlevel_layer_after_load();
								cleanlevellayer_docker();
								//Level management....stop
								
								
								scrollManagement();




								$( ".ContainerMovable" ).draggable
								(
									{
										start: function() 
										{
										var MyWidth														= $(this).innerWidth();
											this.style.width											= MyWidth+"px";
										var MyHeight													= $(this).innerHeight();
											this.style.height											= MyHeight+"px";
						
										var owner_family 												= replaceAll(jQuery(this).attr('owner_family'),'-','.');
										  	//console_log("ContainerMovable start000000 "+event.type);
											CAclient(this.id,this,event,owner_family,'#@@PPMODIFIER@@# #@@VVStartWindowMove@@#',false);
										},
										handle: ".ContainerMovableHandler",
										containment: "parent",
										stop: function() 
										{
										var MyWidth														= $(this).innerWidth();
											this.style.width											= MyWidth+"px";
										var MyHeight													= $(this).innerHeight();
											this.style.height											= MyHeight+"px";
						
										var owner_family 												= replaceAll(jQuery(this).attr('owner_family'),'-','.');
											//console_log("ContainerMovable start000000 "+event.type);
											CAclient(this.id,this,event,owner_family,'#@@PPMODIFIER@@# #@@VVEndWindowMove@@#',false);
										},
									}
								);
						
								$( ".dragHeader" ).draggable
								(
									{
										start: function() 
										{
									var		MyWidth				=	$(this).innerWidth();
											this.style.width	=	MyWidth+"px";
									var		MyHeight			=	$(this).innerHeight();
											this.style.height	=	MyHeight+"px";
										},
										handle: ".dragHeaderHandler",
										containment : [1,1,$(window).width()-100,$(window).height()-100]
									}
								);
								
								$(".resizabletextarea").resizable
								(
									{
										minHeight		: 300,
										minWidth		: 300,
										containment		: ".resizabletextareacontainer"
									}
								);


	var 						dummyEventDrawPageEnd					= new customEventGenerate('pagedrawend');

								//CAclient(document.body.id,document.body,dummyEventDrawPageEnd,'Pages.Body','#@@PPFEEDBACKACTION@@# #@@VVPAGE_DARWEND@@# ',false); 
								//change 20190905
								CAclient(document.body.id,document.body,dummyEventDrawPageEnd,'Pages.'+jQuery(document.body).attr('pagename'),'#@@PPFEEDBACKACTION@@# #@@VVPAGE_DARWEND@@# ',false); 

								//Fill the parents of relative_stub elements
								//used in Container SubWindow or in other objs

								//console_log("back!!!!!!!!");
								WaintingServer 							= false;

								WaiterShield('hide');
								jQuery('.servercallback_htmlblock').remove();
								setTimeout(
								    function() {
										ClientEventsImplement(); 
								    }, 500
								);
}

function performAttachToSW()
{
								 $(document.body).find('.attachtosw').each(function() {
							        var $this = $(this);
							        
										//console_log("__________________ parent node :"+this.parentNode.id+"   has class IsSW:"+jQuery(this.parentNode).hasClass('.IsSW'));

							        
							        // Find the closest ancestor with class 'IsSW'
							        var $target = $this.parents('.IsSW');
							        
							        // If no IsSW ancestor exists, OR the immediate parent is already .IsSW → skip
							        if ($target.length === 0 || jQuery(this.parentNode).hasClass('IsSW')) 
							        {
										//console_log(" not moving "+this.id);
							            return;
							        }
							        
									//console_log(" moving "+this.id+" and trying to attach to:"+$target[0].id);
									//console.log($target);
							        // Move the element to be a direct child of the nearest IsSW ancestor
							        // (appends it as the last child – change to .prependTo() if you need it first)
							        $this.appendTo($target[0]);
							    });
}

function ServerCallBackTokenize(msg)
{
								//console_log('ServerCallBackTokenize:'+msg);
								if (msg!='')
								{
									jQuery('#servercallback').remove();
									jQuery(document.body).prepend(msg);
								}
								
							var	endsessionhtml_els = jQuery(document.body).find('.endsessionhtml');
								if (endsessionhtml_els.length>0)
								{
									endsessionhtml = jQuery(endsessionhtml_els[0]).html();
									jQuery(document.body).find('.endsessionhtml').remove();
								}
								
								jQuery(document.body).find(".styleembedded.styleclient").each(
									function()
									{
										
									var linked_style_id = $(this).attr("linked_style_id");
											console_log(" found style element______ linked_style_id:"+linked_style_id);
										jQuery("head").find("style.styleclient[linked_style_id='"+linked_style_id+"']").remove();
										console.log("found to remove in head:"+jQuery("head").find("style.styleclient[linked_style_id='"+linked_style_id+"']").length);
										$(this).detach().appendTo("head");
									}
								);
								
								jQuery(document.body).find(".jsembedded.caclient").each(
									function()
									{
									var linked_sw = $(this).attr("linked_sw");
										jQuery("head").find("script.caclient[linked_sw='"+linked_sw+"']").remove();
										$(this).detach().appendTo("head");
									}
								);
								
								jQuery(document.body).find(".jsembedded.objectmainscript").each(
									function()
									{
									var owner_family = $(this).attr("owner_family");
										jQuery("head").find("script.objectmainscript[owner_family='"+owner_family+"']").remove();
										$(this).detach().appendTo("head");
									}
								);
								
								jQuery(document.body).find(".jsembedded.jsfile").each(
									function()
									{
									var file_id = $(this).attr("file_id");
										jQuery("head").find("script.jsfile[file_id='"+file_id+"']").remove();
										$(this).detach().appendTo("head");
									}
								);

								jQuery(document.body).find(".jsembedded.jsfunctionfree").each(
									function()
									{
									var function_signature = $(this).attr("function_signature");
										jQuery("head").find("script.jsfunction[function_signature='"+function_signature+"']").remove();
										$(this).detach().appendTo("head");
									}
								);
								
							var performsenddataonclasstypes_incoming_els =	jQuery(document.body).find('.performsenddataonclasstypes');
								
								if (performsenddataonclasstypes_incoming_els.length>0)
								{
									jQuery("head").find(".performsenddataonclasstypes").remove();
									jQuery(document.body).find('.performsenddataonclasstypes').detach().appendTo("head");
								}
								
								
								ServerCallBackTokenizeTasks('ELEMENTREFRESH');
								
								
								
								ServerCallBackTokenizeTasks('NOTVISIBLELIST');
								
								performAttachToSW();

								ZoomCSSComponentImplement();
								
								execute_UserMessages.call();
								execute_beforeLoad.call();
								execute_afterLoad.call();
								manage_clientevents.call();
								
								
								setUpModernGraphicHTMLExtenders();
								
								//drag,move,.....ListManager and moving PopUp
										
								//JS management. changed now
								//performJSinSW_after();


								//scrollManagement(ModifiedElements);
								
								
								//Level management....start
								newlevel_layer_after_load();
								cleanlevellayer_docker();
								//Level management....stop
								
								
								scrollManagement();




								$( ".ContainerMovable" ).draggable
								(
									{
										start: function() 
										{
										var MyWidth														= $(this).innerWidth();
											this.style.width											= MyWidth+"px";
										var MyHeight													= $(this).innerHeight();
											this.style.height											= MyHeight+"px";
						
										var owner_family 												= replaceAll(jQuery(this).attr('owner_family'),'-','.');
										  	//console_log("ContainerMovable start000000 "+event.type);
											CAclient(this.id,this,event,owner_family,'#@@PPMODIFIER@@# #@@VVStartWindowMove@@#',false);
										},
										handle: ".ContainerMovableHandler",
										containment: "parent",
										stop: function() 
										{
										var MyWidth														= $(this).innerWidth();
											this.style.width											= MyWidth+"px";
										var MyHeight													= $(this).innerHeight();
											this.style.height											= MyHeight+"px";
						
										var owner_family 												= replaceAll(jQuery(this).attr('owner_family'),'-','.');
											//console_log("ContainerMovable start000000 "+event.type);
											CAclient(this.id,this,event,owner_family,'#@@PPMODIFIER@@# #@@VVEndWindowMove@@#',false);
										},
									}
								);
								$( ".dragHeader" ).draggable
								(
									{
										start: function() 
										{
									var		MyWidth				=	$(this).innerWidth();
											this.style.width	=	MyWidth+"px";
									var		MyHeight			=	$(this).innerHeight();
											this.style.height	=	MyHeight+"px";
										},
										handle: ".dragHeaderHandler",
										containment : [1,1,$(window).width()-100,$(window).height()-100]
									}
								);
								
								$(".resizabletextarea").resizable
								(
									{
										minHeight		: 300,
										minWidth		: 300,
										containment		: ".resizabletextareacontainer"
									}
								);



	var 						dummyEventDrawPageEnd					= new customEventGenerate('pagedrawend');

								//CAclient(document.body.id,document.body,dummyEventDrawPageEnd,'Pages.Body','#@@PPFEEDBACKACTION@@# #@@VVPAGE_DARWEND@@# ',false); 
								//change 20190905
								CAclient(document.body.id,document.body,dummyEventDrawPageEnd,'Pages.'+jQuery(document.body).attr('pagename'),'#@@PPFEEDBACKACTION@@# #@@VVPAGE_DARWEND@@# ',false); 

								//Fill the parents of relative_stub elements
								//used in Container SubWindow or in other objs

								//console_log("back!!!!!!!!");
								WaintingServer 							= false;

								WaiterShield('hide');//affected by forced reflow
								
								jQuery('.servercallback_htmlblock').remove();
								
								ClientEventsImplement();
}

function ServerCallBackTokenizeReload(msg)
{
								if (msg!='')
								{
									jQuery('#servercallback').remove();
									//console.log('================================================');
									//console.log(msg);
									jQuery(document.body).prepend(msg);
								}
								
							var	endsessionhtml_els = jQuery(document.body).find('.endsessionhtml');
								if (endsessionhtml_els.length>0)
								{
									endsessionhtml = jQuery(endsessionhtml_els[0]).html();
									jQuery(document.body).find('.endsessionhtml').remove();
								}
								
								jQuery(document.body).find(".jsembedded.caclient").each(
									function()
									{
									var linked_sw = $(this).attr("linked_sw");
										jQuery("head").find("script.caclient[linked_sw='"+linked_sw+"']").remove();
										$(this).detach().appendTo("head");
									}
								);
								
								jQuery(document.body).find(".jsembedded.objectmainscript").each(
									function()
									{
									var owner_family = $(this).attr("owner_family");
										jQuery("head").find("script.objectmainscript[owner_family='"+owner_family+"']").remove();
										$(this).detach().appendTo("head");
									}
								);
								
								jQuery(document.body).find(".jsembedded.jsfile").each(
									function()
									{
									var file_id = $(this).attr("file_id");
										jQuery("head").find("script.jsfile[file_id='"+file_id+"']").remove();
										$(this).detach().appendTo("head");
									}
								);


								jQuery(document.body).find(".jsembedded.jsfunctionfree").each(
									function()
									{
									var function_signature = $(this).attr("function_signature");
										jQuery("head").find("script.jsfunction[function_signature='"+function_signature+"']").remove();
										$(this).detach().appendTo("head");
									}
								);
								
								
							var performsenddataonclasstypes_incoming_els =	jQuery(document.body).find('.performsenddataonclasstypes');
								
								if (performsenddataonclasstypes_incoming_els.length>0)
								{
									jQuery("head").find(".performsenddataonclasstypes").remove();
									jQuery(document.body).find('.performsenddataonclasstypes').detach().appendTo("head");
								}
								
								
								ServerCallBackTokenizeTasks('ELEMENTREFRESH');
								
							
								
								ServerCallBackTokenizeTasks('NOTVISIBLELIST');
								
								ZoomCSSComponentImplement();
								
								execute_UserMessages.call();
								execute_beforeLoad.call();
								execute_afterLoad.call();
								manage_clientevents.call();
								
								setUpModernGraphicHTMLExtenders();
								
								//drag,move,.....ListManager and moving PopUp
										
								//JS management. changed now
								//performJSinSW_after();


								//scrollManagement(ModifiedElements);
								
								
								//Level management....start
								newlevel_layer_after_load();
								cleanlevellayer_docker();
								//Level management....stop
								
								
								scrollManagement();


								$( ".ContainerMovable" ).draggable
								(
									{
										start: function() 
										{
										var MyWidth														= $(this).innerWidth();
											this.style.width											= MyWidth+"px";
										var MyHeight													= $(this).innerHeight();
											this.style.height											= MyHeight+"px";
						
										var owner_family 												= replaceAll(jQuery(this).attr('owner_family'),'-','.');
										  	//console_log("ContainerMovable start000000 "+event.type);
											CAclient(this.id,this,event,owner_family,'#@@PPMODIFIER@@# #@@VVStartWindowMove@@#',false);
										},
										handle: ".ContainerMovableHandler",
										containment: "parent",
										stop: function() 
										{
										var MyWidth														= $(this).innerWidth();
											this.style.width											= MyWidth+"px";
										var MyHeight													= $(this).innerHeight();
											this.style.height											= MyHeight+"px";
						
										var owner_family 												= replaceAll(jQuery(this).attr('owner_family'),'-','.');
											//console_log("ContainerMovable start000000 "+event.type);
											CAclient(this.id,this,event,owner_family,'#@@PPMODIFIER@@# #@@VVEndWindowMove@@#',false);
										},
									}
								);
						
								$( ".dragHeader" ).draggable
								(
									{
										start: function() 
										{
									var		MyWidth				=	$(this).innerWidth();
											this.style.width	=	MyWidth+"px";
									var		MyHeight			=	$(this).innerHeight();
											this.style.height	=	MyHeight+"px";
										},
										handle: ".dragHeaderHandler",
										containment : [1,1,$(window).width()-100,$(window).height()-100]
									}
								);
								
								$(".resizabletextarea").resizable
								(
									{
										minHeight		: 300,
										minWidth		: 300,
										containment		: ".resizabletextareacontainer"
									}
								);
								
	var 						dummyEventDrawPageEnd					= new customEventGenerate('pagedrawend');

								//CAclient(document.body.id,document.body,dummyEventDrawPageEnd,'Pages.Body','#@@PPFEEDBACKACTION@@# #@@VVPAGE_DARWEND@@# ',false); 
								//change 20190905
								CAclient(document.body.id,document.body,dummyEventDrawPageEnd,'Pages.'+jQuery(document.body).attr('pagename'),'#@@PPFEEDBACKACTION@@# #@@VVPAGE_DARWEND@@# ',false); 
								
								//Fill the parents of relative_stub elements
								//used in Container SubWindow or in other objs

								//console_log("back!!!!!!!!");
								WaintingServer 							= false;

								WaiterShield('hide');
								
								jQuery('.servercallback_htmlblock').remove();
								ClientEventsImplement();
								
								/*
								setTimeout(
								    function() {
										ClientEventsImplement(); 
								    }, 500
								);*/
}

function ServerCallBackTokenizeTasks(CommandTypeSubstring)
{
		//console_log("===========ServerCallBackTokenize task:"+CommandTypeSubstring+"==================================================================================================");
		TimeSliderStep 	 = 0;
		
		if (CommandTypeSubstring=='NOTVISIBLELIST')
		{//A.A 
			//Elements are set to not visible, but are not deleted
			//console_log("_______________________________REMOVING ELEMENTS LIST_______________________________");
		var SW_notvisiblelist 	= jQuery('.swnotvisiblelist')[0].value;
		
			//console.log('SW_notvisiblelist:'+SW_notvisiblelist);
				
		var NOTVISIBLELIST 		= SW_notvisiblelist;
		var NOTVISIBLELISTIDS   = NOTVISIBLELIST.split(';');
			//console_log('removing el #'+NOTVISIBLELISTIDS.length);
			for(var h=0;h<NOTVISIBLELISTIDS.length;++h)
			{
				//console_log('removing element '+h+' id: '+NOTVISIBLELISTIDS[h]);
				jQuery("head").find("script.caclient[linked_sw^='"+NOTVISIBLELISTIDS[h]+"']").remove();

				//var ElementToDelete = document.getElementById(NOTVISIBLELISTIDS[h]);
				//if (ElementToDelete!=null) alert('deleting element :'+ElementToDelete.id);
				if (NOTVISIBLELISTIDS[h].length>0)
				{
						try
						{
						var elementsToHide = $("div[id^='"+NOTVISIBLELISTIDS[h]+"']");//.remove();
							//find ll DIVs that have and ID starting with NOTVISIBLELISTIDS[h] identifier
							//console.log(" process removing element:"+NOTVISIBLELISTIDS[h]);
							if (elementsToHide.length>0)
							{
								for(var di = 0;di<elementsToHide.length;++di)
								{
									if (elementsToHide[di].className.indexOf("IsSW")>-1)
									{
									var display_current_status = elementsToHide[di].style.display;
										//if ((display_current_status==null) || (display_current_status.length<2)) display_current_status = 'block';
										elementsToHide[di].setAttribute("display_base_status",display_current_status);
										elementsToHide[di].style.display = 'none';
									}
									//when the element turns on again
									//its attribute display_base_status will be erased by the Server Stream
									// at the moment the attribute display_base_status is not used.....
									//should be useful, e.g. if you want turn on an element from js
									//and not by the server.
								}
							}
						}catch(err)
						{
		
						}
					}
			}//NOTVISIBLELISTIDS loop end
		}//end not visible list

		/*
		if (CommandTypeSubstring=='LEVELSMANAGE')
		{//A.B
			CurrentMAX_ZINDEX 		= parseInt(getParValueByParName('MAX',CommandLines[i]));
			CurrentLISTVISIBLELEVELS = getParValueByParName('MAX',CommandLines[i]);
		var goon 					= true;
			while(goon)
			{
					var AllElements = document.getElementsByTagName('*');
						if (AllElements!=null)
						{
						var AllElementsN = AllElements.length;
							for(var ke = 0;ke<AllElementsN;++ke)
							{
								if((AllElements[ke].id!='undefined')&&(AllElements[ke].id.substr(0,6)=='level_'))
								{//Not used anymore
								 //Elements with ad id starting with "level_" where used in a sperimental release of the app	

								}else
								{
								var keZINDEX = -1;
									try
									{
										keZINDEX = AllElements[ke].style.zIndex;
									}catch(err)
								    {
										console.log(err);
										keZINDEX=-1;
								    }
									if 
									(
											(AllElements[ke].id!=null)
											&&
											(keZINDEX>-1)
											&&
											(parseInt(AllElements[ke].style.zIndex) >CurrentMAX_ZINDEX)
											&&
											(parseInt(AllElements[ke].style.zIndex) <50)
											&&
											(AllElements[ke].className.indexOf("IsSW") >-1)
											//remove only elements being SubWindow. Their nature is known
											//if we remove this constraint some elements that are imported from other frameworks risk to be removed
											//E.g.: Google maps elements 
									)
									{
										console_log("removing SW id:"+AllElements[ke].id+"  AllElements[ke].style.zIndex:"+AllElements[ke].style.zIndex );


										//removeAllFamiliyGivenParentElement(AllElements[ke]);
										try
										{
											//console_log(" removing:"+AllElements[ke].id);
											removeAllFamiliyGivenParentElement(AllElements[ke]);
											$(AllElements[ke]).remove();
											break;
										}catch(err)
										{

										}
									}
								}
								if (ke== AllElementsN-1) goon = false;

							}//for end
						//	alert('element iterate done'+goon);
						}else
						{
							goon = false;
						}
				}
		}//A.B END
		*/
	

		if (CommandTypeSubstring=='ELEMENTREFRESH')
		{//A
			ServerState = jQuery('#servercallback').find('.servercallback_htmlblock');
			jQuery('.servercallback_htmlblock').remove();
		var CommandLinesN 	 = ServerState.length;
			//console.log('found els #:'+CommandLinesN);
			//var LastRefreshId	 = null;
		var ModifiedElements = new Array();
			for(var i = 0 ; i < CommandLinesN ; ++i)
			{//A.C
				//var refresh_SW_el										= null; 

				//console.log("______");
				//console.log(jQuery(ServerState[i]));
			var aux_id =jQuery(ServerState[i]).attr('id');
			var ID_Refresh 											= aux_id.replace('servercallback_html_','');
			var HTML_Refresh 										= jQuery(ServerState[i]).html();
				//console_log('refreshing element : '+ID_Refresh+' containing html (200 chars) :'+HTML_Refresh.substring(0,200));
				ModifiedElements.push(ID_Refresh);
				if ((ID_Refresh.length>1) && (HTML_Refresh.length>1))
				{//Element sent by server consistance
				  //A.C.A_true
					//document.getElementById(ID_Refresh).innerHTML = HTML_Refresh;

					//console_log('__________________refreshing:'+ID_Refresh+' with :'+HTML_Refresh);

					//console_log('__________________ do refreshing:'+ID_Refresh+" full content:"+HTML_Refresh);
				var elemtochange 									= document.getElementById(ID_Refresh);
					//is the element of the document that has got the same ID of the element sebt by server
	
					//console.log('RRRRRRR HTML_Refresh:'+HTML_Refresh);
				var NewElement 	 									= document.createElement('div');
					NewElement.innerHTML 							= HTML_Refresh;
				var elementToInsert									= NewElement.firstChild;

					//console_log("trying to insert or refresh: "+elementToInsert.id);
					//NewElement.style.zIndex=100;
					//NewElement.style.backgroundColor='pink';
					//NewElement.style.position = "fixed";
					//NewElement.style.top = "10px";
					//NewElement.style.left = "10px";
					//NewElement.style.right = "10px";
					//NewElement.style.bottom = "10px";
					//document.body.innerHTML='';
					//NewElement.innerHTML = HTML_Refresh;
					//document.body.appendChild(NewElement);
					
					if (elemtochange==null)
					{//A.C.A_true.A_true
						//console_log("\n\n\nELEMENTTOCHANGE IS NULL------------------");
						//not found the given element inside the document
						// we have to find the point where to attach given element
						//Let's search the parent of the element to attach
					var elementToInsert_newlevellayer  				= check_newlevellayer(elementToInsert);
						//elementToInsert is the element generated by the HTML code available in HTML_Refresh
	
					var pelem_id 									= getIdentifierParent(ID_Refresh);
						//id that should have the parent of the element sent by server
					var ParentElemForAttach_Elem 					= document.getElementById(pelem_id);
						//checking if the document has got an element that has an ID same than the parent of the element sent by server
						if (ParentElemForAttach_Elem!=null)
						{	

							//A.C.A_true.A_true.A_true
							//found the parent Of the element to attach

						var ParentElemForAttach_Elem_newlevellayer  = check_newlevellayer(ParentElemForAttach_Elem);
							if 
							(
								(
									(ParentElemForAttach_Elem_newlevellayer!=null)
										&&
									(elementToInsert_newlevellayer!=null)
									    &&	
									(ParentElemForAttach_Elem_newlevellayer==elementToInsert_newlevellayer)
									//both elements are newlevellayer elements and they have the same level
									//this is possible when two or more elements are generated by the same one 
									//and all of them lay on an upper floor
								    //see better......very strange if parent and child have a level jump and is the same 
									//two siblings can have the same level jump on respect to the parent
								)
								||
								(elementToInsert_newlevellayer==null)
								//elementToInsert_newlevellayer newlevellayer_ is null
								//the element to insert, generated by the HTML code HTML_Refresh, does not jump level
								//This way if an element to insert has got a parent, go on to attach to its parent
							)
							{	
								//A.C.A_true.A_true.A_true.A_true
								//level layer has not changed on respect to its parent
								//attach to parent
							var DummyElementToRefresh 	 			= document.createElement('div');
								DummyElementToRefresh.setAttribute('id',ID_Refresh);
								//DummyElementToRefresh simulates elemtochange
								//elemtochange is null beacuse was not present in the document
								//We create a dummy element that acts as elemtochange

							var ParentElemForAttach_Elem_docker_id 	= ParentElemForAttach_Elem.id+"ContentArea|";  
								ParentElemForAttach_Elem_docker 	= document.getElementById(ParentElemForAttach_Elem_docker_id);
								$(DummyElementToRefresh).appendTo(ParentElemForAttach_Elem_docker);
								//We attach DummyElementToRefresh to parent element found i.e. ParentElemForAttach_Elem

								elemtochange 						= document.getElementById(ID_Refresh);
								//var elemtochange = document.getElementById(ID_Refresh);
								// elemtochange is now the same of DummyElementToRefresh,
								// but obtained by the document

								$(elemtochange).replaceWith(HTML_Refresh);
								//seems a poker game, but i did not find a way to avoid it

								LastRefreshId 						= ID_Refresh;
								//reliable? keep track of the last element attached or better of the last parent element that acted as dock?
								//this way we can use last attached element as a dock. Is it correct?

								//performJSinSW(ID_Refresh);
								//ServerCallBackTokenize
							}	//A.C.A_true.A_true.A_true.A_true
								//attach to parent END
							else
							{	//A.C.A_true.A_true.A_true.A_false
								//level layer has changed on respect to its parent
								//or is not possible to find a parent with same level_layer 

								//attach to body
								// if the element to 
							var AppendingElementId  				= document.body.id+"ContentArea|";
							var AppendingElement   					= document.getElementById(AppendingElementId);

								//^^^^^^^^ up to 20150422							
								if (AppendingElement!=null)
								{
									//DummyElementToRefresh simulates elemtochange
									//elemtochange is null beacuse was not present in the document
									//We create a dummy element that acts as elemtochange
								var DummyElementToRefresh 	 	= document.createElement('div');
									DummyElementToRefresh.setAttribute('id',ID_Refresh);


									$(DummyElementToRefresh).appendTo(AppendingElement);
									//We attach DummyElementToRefresh to body

									elemtochange 				= document.getElementById(ID_Refresh);
									// elemtochange is now the same of DummyElementToRefresh,
									// but obtained by the document

									$(elemtochange).replaceWith(HTML_Refresh);
									//seems a poker game, but i did not find a way to avoid it

									LastRefreshId 				= ID_Refresh;
									//reliable? keep track of the last element attached or better of the last parent element that acted as dock?
									//this way we can use last attached element as a dock. Is it correct?
								}
							}	//A.C.A_true.A_true.A_true.A_false
								//attach to body END
						}//A.C.A_true.A_true.A_true
						//found the parent Of the element to attach END
						else
						{
							//console.log(" element with no point to attach it:"+ID_Refresh+"   wished dock:"+pelem_id);
						}
					}//A.C.A_true.A_true element to change
					//Element sent by server consistance END
					else
					{	//A.C.A_true.A_false element to change
						// the element to change was found.
						//console_log("\n\n\nELEMENT TO CHANGE NOT NULL:"+elemtochange.id);
						//I.E. is existing an element on the document that has got same ID of the one sent by server

						//same level

						////^^^^^^^^upto 20191210
					var elementToInsert_newlevellayer  				= check_newlevellayer(elementToInsert);
					var elemtochange_newlevellayer  				= check_newlevellayer(elemtochange);
					var NaturalParent_id 							= getIdentifierParent(ID_Refresh);

						if ((elementToInsert_newlevellayer==null)&&(elemtochange_newlevellayer!=null))
						{//find parent
						var hosting_element							= document.getElementById(NaturalParent_id+"ContentArea|");
							if (NaturalParent_id=='|') 
							{ 
	
								$(document.body).append(elementToInsert.firstChild);
								transferAnyAttribute(elementToInsert,document.body);	
							} else
							{
								jQuery(hosting_element).append(elementToInsert);
								jQuery(elemtochange).remove();
							}
							//may be an element was NewLevelLayer and now is not it anymore
							//It reaches its parent
						} else
						{
							//console_log("mnmnmnmnmnmnmnmnm B NaturalParent_id:"+NaturalParent_id);
							//console_log("  target el id:"+elemtochange.id+" HTML_Refresh:"+HTML_Refresh);
							if (NaturalParent_id=='|') 
							{ 
								//console.log(document.body);
								//console.log(elementToInsert.firstChild);
							var toremove_el =	document.getElementById(document.body.id+"relative_stub|");
								jQuery(toremove_el).remove();

								//console.log('appending inside body :'+jQuery(elementToInsert.firstChild).html());
								jQuery(document.body).prepend(elementToInsert.firstChild);	
								//jQuery(document.body).append("<div id='debugger_bvc' ></div>");
								//jQuery('#debugger_bvc').append(elementToInsert);
								transferAnyAttribute(elementToInsert,document.body);
								//console.log(document.body);	
							} else
							{
								$(elemtochange).replaceWith(HTML_Refresh);
							}	
						}
						LastRefreshId 									= ID_Refresh;
						//performJSinSW(ID_Refresh);
						//ServerCallBackTokenize
					}
				}//A.C.A_true END
				//element sent by server consistance check
			}//A.C END
			//element sent by server to refresh list
		}//A END
}


function getParValueByParName(ParNameIn,CommandLineToSearch)
{
	var ParameterNameSearchString 	= '!@@PP'+ParNameIn+'@@!';
	var ParameterNamePos 			= CommandLineToSearch.search(ParameterNameSearchString);
		ParameterNamePos 			= ParameterNamePos+ParameterNameSearchString.length;
		ParameterNameSubstring 		= CommandLineToSearch.substring(ParameterNamePos,CommandLineToSearch.length);
	var ParameterValuePosStart 		= ParameterNameSubstring.search("!@@VV")+5;
	var ParameterValuePosEnd  		= ParameterNameSubstring.search("@@!");
	
	var ParameterValueSubstring  	= ParameterNameSubstring.substring(ParameterValuePosStart,ParameterValuePosEnd);
	return ParameterValueSubstring;
}


function LayoutStringToDispatchGenerate()
{
	var StringToStore = "";//" !-----! ";//"!#####! !@@PPROWNAME@@! !@@VVCOLUMNINFO@@! !@@PPROWTYPE@@! !@@VVTABLESTRUCTURE@@!";
	var elementsListToSend  =  document.getElementsByTagName("li");
	for(var jo=0;jo<elementsListToSend.length;jo++)
	{
		if (
				(elementsListToSend[jo].id!='undefined')
				&&
				(elementsListToSend[jo].id.substring(0,12)== 'column_name_' )
			)
		{
			
			var StringToStoreChunk	= "!-----! ";
			//var ColumnSQLName		="";
			//var ColumnWidth			="";
			//var ColumnVisibility	="";
			//var ColumnDataOrdering	="";

			
			
		var childArray = elementsListToSend[jo].childNodes;
		var tt =0;
			for( tt=0;tt<childArray.length;tt++)
			{
				if (typeof childArray[tt].name != 'undefined')
				{
					if (childArray[tt].name=='COLUMNNAME')
					{
						StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";// ColumnSQLName = childArray[tt].value;		
					}
					if (childArray[tt].name=='COLUMNLABEL')
					{
						StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";// ColumnWidth = childArray[tt].value;		
					}
					if (childArray[tt].name=='COLUMNVISIBILITY')
					{
						StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";
					}
					if (childArray[tt].name=='COLUMNSORTING')
					{
						StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+childArray[tt].value+"@@!";
					}
					if (childArray[tt].name=='COLUMNWIDTH')
					{
						StringToStoreChunk += "!@@PP"+childArray[tt].name+"@@! !@@VV"+parseInt(childArray[tt].value)+"px"+"@@!";
					}

				}				
			}
			StringToStore	  +=StringToStoreChunk;
		}
	}
	return StringToStore;
}

function sendParameter(OBJIdenfifierIn,QueryStringIn)
{	
	
	var data = QueryStringIn;
	
	$.ajax
	(
		{
			type: 		"GET",
			url: 		"ParametersCommunication",
			data: 		data,
			dataType: 	"html",
			success: function(msg)
			{
				//$("#risultato").html(msg);
				//ServerCallBackTokenize(msg);
	
			},
			error: function()
			{
				alert(ServerFailMessage);
				//WaiterShield('hide');
			}			 
		}
	);//ajax
}
	
function executeGetCallonServer(CallerID,Action,Parameter1,Parameter2)
{
	var data = "CallerID="+CallerID+"&Action="+Action+"&Parameter1="+Parameter1+"&Parameter2="+Parameter2;
		$.ajax
		(
			{
				type: 		"GET",
				url: 		"ServerGetCallExecute",
				data: 		data,
				dataType: 	"html",
				success: function(msg)
				{
					//$("#risultato").html(msg);
					//ServerCallBackTokenize(msg);
				},
				error: function()
				{
					alert(ServerFailMessage);
					//WaiterShield('hide');
				}			 
			}
		);//ajax
}

function TriggerToolTipText()
{
	var 	data = "";
			$.ajax
			(
				{
					type	: "POST",
					url		: "getToolTipText",
					data	: data,
					dataType: "html",
					success	: function(msg)
					{
						//$("#risultato").html(msg);
						ToolTipMessageServerCallBackTokenize(msg);
					},
					error: function()
					{
						alert(ServerFailMessage);
						WaiterShield('hide');
					}			 
				}
			);//ajax
}

function newlevel_layer_after_load()
{
	
		//This function appends every node that has a class newlevellayer
		//to Body
	var SWs_newlevellayer 				= $('div[class*=newlevellayer]'); //$('[class^="newlevellayer"]');

		//every element is checked.
		//Array should be ordered
		for (var i = 0; i < SWs_newlevellayer.length; i++) 
		{
		//var el_a =  SWs_newlevellayer[i].cloneNode(true);
		//var el_b =  SWs_newlevellayer[i+1].cloneNode(true);
	var 	MyParentNode				= SWs_newlevellayer[i].parentNode;
	var 	ancestor_SW = null;
			if (isValidElement(SWs_newlevellayer[i].parentNode ))
			{
				ancestor_SW = $(SWs_newlevellayer[i].parentNode).closest('.IsSW');
			}

			//console.log("   -------------------  ");
			//console.log(ancestor_SW);
			
			if (
				isValidElement(MyParentNode)
			&&
				(MyParentNode.tagName.toUpperCase()=='BODY')
			)
			{
				//element attahced to body: do not do nothing
				
			}else
			if (
				isValidElement(ancestor_SW)
				&&
				jQuery(ancestor_SW).hasClass("isbody")
			)
			{//elements attached to ContentArea of body
			var detached_element 		= $(document.getElementById(SWs_newlevellayer[i].id)).detach();
				$('body').append(detached_element);
				ManageExplainedElements(null,'newlevellayer_hidebelow');
			} else 
			if (
					($(MyParentNode).hasClass("isbody")==false)
				&&
					($(MyParentNode).prop("tagName").toLowerCase() != 'body')
				&&
					($(MyParentNode).hasClass('levellayer_dockerContentArea')==false )
				)
			{
			var SWParentId 					= getIdentifierParent(SWs_newlevellayer[i].id);
			var SWParent   					= document.getElementById(SWParentId); 
				if (SWParent.style.zIndex<SWs_newlevellayer[i].style.zIndex)
				{
					/*
				var detached_element 		= $(document.getElementById(SWs_newlevellayer[i].id)).detach();
					if (jQuery(detached_element).hasClass("fill_viewport"))
					{
						//e.g. LayerContainer
						$('body').append(detached_element);
						ManageExplainedElements(null,'newlevellayer_hidebelow');
					} else
					{
					var checking_id = SWs_newlevellayer[i].id;
						checking_id = checking_id.substring(0,checking_id.length-1);
	
					var dummy_layer_container_html = 							
						"<div owner_family='ComponentsBasic-LayerContainer' scroller_dock = '"+checking_id+"levellayer_docker|frame|' id = '"+checking_id+"levellayer_docker|' class = 'levellayer_docker id"+replaceAll(checking_id+"levellayer_docker|","\\|", "__")+"   ComponentsBasic-LayerContainer IsSW  fill_viewport levellayer_docker newlevellayer_"+SWs_newlevellayer[i].style.zIndex+"' style='position:absolute;left:0;top:0;z-index:"+SWs_newlevellayer[i].style.zIndex+"; ' >" +
						"   <div class='relative_stub' id='"+checking_id+"levellayer_docker|relative_stub|' style='position:relative;width:100%;height:100%;border:none;'>" +
								"<div id='"+checking_id+"levellayer_docker|backgrounder|' class='"+replaceAll(checking_id+"levellayer_docker|backgrounder|","\\|", "__")+"    backgrounder' style='position:absolute;top:0px;left:0px;bottom:0px;right:0px;width:100%;height:100%;border:none;background-color:white;filter: alpha(opacity=70); opacity:0.7;'>" +
								"</div>" +
								"<div id='"+checking_id+"levellayer_docker|frame|' style='position: absolute; top: 0px; left: 0px; bottom: 0px; right: 0px; width: 100%; height: 100%; border: none; overflow: hidden;'>" +
									"<div class='levellayer_dockerContentArea' id='"+checking_id+"levellayer_docker|ContentArea|' style='position: relative; width: 1600px; height: 1089px; overflow: hidden;'>" +
									"</div>"+
								"</div>"+
							"</div>"+
						"</div>";
						$('body').append(dummy_layer_container_html);
						
					var mydockerContentArea_el = document.getElementById(checking_id+'levellayer_docker|ContentArea|');
						
						jQuery(mydockerContentArea_el).append(detached_element);
						ManageExplainedElements(null,'newlevellayer_hidebelow');
						
					}
						*/
	//				var levellayer_docker 	= jQuery(".levellayer_docker.level"+SWs_newlevellayer[i].style.zIndex);
	//				if (levellayer_docker.length==0)
	//				{console_log('111111111111111111111111111');
	//					$('body').append(
	//							"<div class = 'fill_parent levellayer_docker level"+SWs_newlevellayer[i].style.zIndex+"' " +
	//									" style='position:absolute;z-index:"+SWs_newlevellayer[i].style.zIndex+";background-color:lime; '" +
	//							">" +
	//							"</div>"
	//					);
	//				}	
	//				jQuery(".levellayer_docker.level"+SWs_newlevellayer[i].style.zIndex).append(detached_element);
	//
	//					ManageExplainedElements(null,'newlevellayer_hidebelow');
	//					//Is correctly placed?
				}				
			}
		}
}

function cleanlevellayer_docker()
{
			//console_log("**********************************************************");
	var 	dockers=jQuery(".levellayer_docker");
			for(var u=0;u<dockers.length;++u)
			{
			var active_childs = 0;
			var SWs= jQuery(dockers[u]).find(".levellayer_dockerContentArea .IsSW");
				//console_log("SWs#"+SWs.length);
				for(var v=0;v<SWs.length;++v)
				{
					//console_log(""+SWs[v].id+" display:"+jQuery(SWs[v]).css("display"));
					if (!(jQuery(SWs[v]).css("display")=="none"))
					{
						++active_childs;
					}
				}
				/*
				20240626 removed beacuse of levellayer_docker bad management.
				if an SW (i.e. SWs[i]) has display set to none its TE childs may be still visible and display block
				other possible solution is to fully remove SWs while parsing NOTVIVIBLELIST
				nowasdays NOTVIVIBLELIST is not  
			var TEs= jQuery(dockers[u]).find(".levellayer_dockerContentArea .IsTE");
				//console_log("TEs#"+TEs.length);
				for(var v=0;v<TEs.length;++v)
				{
					if (!(jQuery(TEs[v]).css("display")=="none"))
					{
						++active_childs;
					}
				}*/
	
				//if (
				//				(jQuery(dockers[u]).find(".IsTE").length==0)
				//			&&
				//			
				//				(jQuery(dockers[u]).find(".IsSW").length==0)
				//)
				if (active_childs==0)
				{//removedocker
				//console_log("?????????? SW ID:"+dockers[u].id);
				var to_remove_childs = jQuery(dockers[u]).find(".IsSW");
					for(var g=0;g<to_remove_childs.length;++g)
					{
						console_log("deleting:"+to_remove_childs[g].id);
						jQuery(to_remove_childs[g]).remove();
					}
				
					jQuery(dockers[u]).remove();
				}
			}
			//dockers=jQuery(".levellayer_dockerContentArea");
}



function ServerCallBackTokenizeTasksNew(CommandTypeSubstring,doc)
{
		console_log("===========ServerCallBackTokenize task:"+CommandTypeSubstring+"==================================================================================================");
		TimeSliderStep 	 = 0;
		
		if (CommandTypeSubstring=='NOTVISIBLELIST')
		{//A.A 
			//Elements are set to not visible, but are not deleted
			//console_log("_______________________________REMOVING ELEMENTS LIST_______________________________");
		var SW_notvisiblelist 	= jQuery(doc).find('.swnotvisiblelist')[0].value;
			
		var NOTVISIBLELIST 		= SW_notvisiblelist;
		var NOTVISIBLELISTIDS   = NOTVISIBLELIST.split(';');
			//console_log('removing el #'+NOTVISIBLELISTIDS.length);
			for(var h=0;h<NOTVISIBLELISTIDS.length;++h)
			{
				//console_log('removing element '+h+' id: '+NOTVISIBLELISTIDS[h]);
				jQuery("head").find("script.caclient[linked_sw^='"+NOTVISIBLELISTIDS[h]+"']").remove();

				//var ElementToDelete = document.getElementById(NOTVISIBLELISTIDS[h]);
				//if (ElementToDelete!=null) alert('deleting element :'+ElementToDelete.id);
				if (NOTVISIBLELISTIDS[h].length>0)
				{
						try
						{
						var elementsToHide = $("div[id^='"+NOTVISIBLELISTIDS[h]+"']");//.remove();
							//find ll DIVs that have and ID starting with NOTVISIBLELISTIDS[h] identifier
							//console.log(" process removing element:"+NOTVISIBLELISTIDS[h]);
							if (elementsToHide.length>0)
							{
								for(var di = 0;di<elementsToHide.length;++di)
								{
									if (elementsToHide[di].className.indexOf("IsSW")>-1)
									{
									var display_current_status = elementsToHide[di].style.display;
										//if ((display_current_status==null) || (display_current_status.length<2)) display_current_status = 'block';
										elementsToHide[di].setAttribute("display_base_status",display_current_status);
										elementsToHide[di].style.display = 'none';
									}
									//when the element turns on again
									//its attribute display_base_status will be erased by the Server Stream
									// at the moment the attribute display_base_status is not used.....
									//should be useful, e.g. if you want turn on an element from js
									//and not by the server.
								}
							}
						}catch(err)
						{
		
						}
					}
			}//NOTVISIBLELISTIDS loop end
		}//end not visible list

		/*
		if (CommandTypeSubstring=='LEVELSMANAGE')
		{//A.B
			CurrentMAX_ZINDEX 		= parseInt(getParValueByParName('MAX',CommandLines[i]));
			CurrentLISTVISIBLELEVELS = getParValueByParName('MAX',CommandLines[i]);
		var goon 					= true;
			while(goon)
			{
					var AllElements = document.getElementsByTagName('*');
						if (AllElements!=null)
						{
						var AllElementsN = AllElements.length;
							for(var ke = 0;ke<AllElementsN;++ke)
							{
								if((AllElements[ke].id!='undefined')&&(AllElements[ke].id.substr(0,6)=='level_'))
								{//Not used anymore
								 //Elements with ad id starting with "level_" where used in a sperimental release of the app	

								}else
								{
								var keZINDEX = -1;
									try
									{
										keZINDEX = AllElements[ke].style.zIndex;
									}catch(err)
								    {
										console.log(err);
										keZINDEX=-1;
								    }
									if 
									(
											(AllElements[ke].id!=null)
											&&
											(keZINDEX>-1)
											&&
											(parseInt(AllElements[ke].style.zIndex) >CurrentMAX_ZINDEX)
											&&
											(parseInt(AllElements[ke].style.zIndex) <50)
											&&
											(AllElements[ke].className.indexOf("IsSW") >-1)
											//remove only elements being SubWindow. Their nature is known
											//if we remove this constraint some elements that are imported from other frameworks risk to be removed
											//E.g.: Google maps elements 
									)
									{
										console_log("removing SW id:"+AllElements[ke].id+"  AllElements[ke].style.zIndex:"+AllElements[ke].style.zIndex );


										//removeAllFamiliyGivenParentElement(AllElements[ke]);
										try
										{
											//console_log(" removing:"+AllElements[ke].id);
											removeAllFamiliyGivenParentElement(AllElements[ke]);
											$(AllElements[ke]).remove();
											break;
										}catch(err)
										{

										}
									}
								}
								if (ke== AllElementsN-1) goon = false;

							}//for end
						//	alert('element iterate done'+goon);
						}else
						{
							goon = false;
						}
				}
		}//A.B END
		*/
	

		if (CommandTypeSubstring=='ELEMENTREFRESH')
		{//A
			ServerState = jQuery(doc).find('.servercallback_htmlblock');

		var CommandLinesN 	 = ServerState.length;
			//console.log('found els #:'+CommandLinesN);
			//var LastRefreshId	 = null;
		var ModifiedElements = new Array();
			for(var i = 0 ; i < CommandLinesN ; ++i)
			{//A.C
				//var refresh_SW_el										= null; 

				//console.log(ServerState[i]);
			var aux_id 												= jQuery(ServerState[i]).attr('id');
			var ID_Refresh 											= aux_id.replace('servercallback_html_','');
			var HTML_Refresh 										= jQuery(ServerState[i]).html();
				//console_log('refreshing element : '+ID_Refresh+' containing html (200 chars) :'+HTML_Refresh.substring(0,200));
				ModifiedElements.push(ID_Refresh);
				if ((ID_Refresh.length>1) && (HTML_Refresh.length>1))
				{//Element sent by server consistance
				  //A.C.A_true
					//document.getElementById(ID_Refresh).innerHTML = HTML_Refresh;

					//console_log('__________________refreshing:'+ID_Refresh+' with :'+HTML_Refresh);

					//console_log('__________________ do refreshing:'+ID_Refresh+" full content:"+HTML_Refresh);
				var elemtochange 									= document.getElementById(ID_Refresh);
					//is the element of the document that has got the same ID of the element sebt by server
	
					//console.log('RRRRRRR HTML_Refresh:'+HTML_Refresh);
				var NewElement 	 									= document.createElement('div');
					NewElement.innerHTML 							= HTML_Refresh;
				var elementToInsert									= NewElement.firstChild;

					//console_log("trying to insert or refresh: "+elementToInsert.id);
					//NewElement.style.zIndex=100;
					//NewElement.style.backgroundColor='pink';
					//NewElement.style.position = "fixed";
					//NewElement.style.top = "10px";
					//NewElement.style.left = "10px";
					//NewElement.style.right = "10px";
					//NewElement.style.bottom = "10px";
					//document.body.innerHTML='';
					//NewElement.innerHTML = HTML_Refresh;
					//document.body.appendChild(NewElement);
					
					if (elemtochange==null)
					{//A.C.A_true.A_true
						//console_log("\n\n\nELEMENTTOCHANGE IS NULL------------------");
						//not found the given element inside the document
						// we have to find the point where to attach given element
						//Let's search the parent of the element to attach
						
					var elementToInsert_newlevellayer  				= check_newlevellayer(elementToInsert);
						//elementToInsert is the element generated by the HTML code available in HTML_Refresh
						
					var pelem_id 									= getIdentifierParent(ID_Refresh);
						//id that should have the parent of the element sent by server
					var ParentElemForAttach_Elem 					= document.getElementById(pelem_id);
						//checking if the document has got an element that has an ID same than the parent of the element sent by server
						if (ParentElemForAttach_Elem!=null)
						{

							//A.C.A_true.A_true.A_true
							//found the parent Of the element to attach

						var ParentElemForAttach_Elem_newlevellayer  = check_newlevellayer(ParentElemForAttach_Elem);
							if 
							(
								(
									(ParentElemForAttach_Elem_newlevellayer!=null)
										&&
									(elementToInsert_newlevellayer!=null)
									    &&	
									(ParentElemForAttach_Elem_newlevellayer==elementToInsert_newlevellayer)
									//both elements are newlevellayer elements and they have the same level
									//this is possible when two or more elements are generated by the same one 
									//and all of them lay on an upper floor
								    //see better......very strange if parent and child have a level jump and is the same 
									//two siblings can have the same level jump on respect to the parent
								)
								||
								(elementToInsert_newlevellayer==null)
								//elementToInsert_newlevellayer newlevellayer_ is null
								//the element to insert, generated by the HTML code HTML_Refresh, does not jump level
								//This way if an element to insert has got a parent, go on to attach to its parent
							)
							{	
								//A.C.A_true.A_true.A_true.A_true
								//level layer has not changed on respect to its parent
								//attach to parent
							var DummyElementToRefresh 	 			= document.createElement('div');
								DummyElementToRefresh.setAttribute('id',ID_Refresh);
								//DummyElementToRefresh simulates elemtochange
								//elemtochange is null beacuse was not present in the document
								//We create a dummy element that acts as elemtochange

							var ParentElemForAttach_Elem_docker_id 	= ParentElemForAttach_Elem.id+"ContentArea|";  
								ParentElemForAttach_Elem_docker 	= document.getElementById(ParentElemForAttach_Elem_docker_id);
								$(DummyElementToRefresh).appendTo(ParentElemForAttach_Elem_docker);
								//We attach DummyElementToRefresh to parent element found i.e. ParentElemForAttach_Elem

								elemtochange 						= document.getElementById(ID_Refresh);
								//var elemtochange = document.getElementById(ID_Refresh);
								// elemtochange is now the same of DummyElementToRefresh,
								// but obtained by the document

								$(elemtochange).replaceWith(HTML_Refresh);
								//seems a poker game, but i did not find a way to avoid it

								LastRefreshId 						= ID_Refresh;
								//reliable? keep track of the last element attached or better of the last parent element that acted as dock?
								//this way we can use last attached element as a dock. Is it correct?

								//performJSinSW(ID_Refresh);
								//ServerCallBackTokenize
							}	//A.C.A_true.A_true.A_true.A_true
								//attach to parent END
							else
							{	//A.C.A_true.A_true.A_true.A_false
								//level layer has changed on respect to its parent
								//or is not possible to find a parent with same level_layer 

								//attach to body
								// if the element to 
							var AppendingElementId  				= document.body.id+"ContentArea|";
							var AppendingElement   					= document.getElementById(AppendingElementId);

								//^^^^^^^^ up to 20150422							
								if (AppendingElement!=null)
								{
									//DummyElementToRefresh simulates elemtochange
									//elemtochange is null beacuse was not present in the document
									//We create a dummy element that acts as elemtochange
								var DummyElementToRefresh 	 	= document.createElement('div');
									DummyElementToRefresh.setAttribute('id',ID_Refresh);


									$(DummyElementToRefresh).appendTo(AppendingElement);
									//We attach DummyElementToRefresh to body

									elemtochange 				= document.getElementById(ID_Refresh);
									// elemtochange is now the same of DummyElementToRefresh,
									// but obtained by the document

									$(elemtochange).replaceWith(HTML_Refresh);
									//seems a poker game, but i did not find a way to avoid it

									LastRefreshId 				= ID_Refresh;
									//reliable? keep track of the last element attached or better of the last parent element that acted as dock?
									//this way we can use last attached element as a dock. Is it correct?
								}
							}	//A.C.A_true.A_true.A_true.A_false
								//attach to body END
						}//A.C.A_true.A_true.A_true
						//found the parent Of the element to attach END
						else
						{
							//console.log(" element with no point to attach it:"+ID_Refresh+"   wished dock:"+pelem_id);
						}
					}//A.C.A_true.A_true element to change
					//Element sent by server consistance END
					else
					{	//A.C.A_true.A_false element to change
						// the element to change was found.
						//console_log("\n\n\nELEMENT TO CHANGE NOT NULL:"+elemtochange.id);
						//I.E. is existing an element on the document that has got same ID of the one sent by server

						//same level

						////^^^^^^^^upto 20191210
					var elementToInsert_newlevellayer  				= check_newlevellayer(elementToInsert);
					var elemtochange_newlevellayer  				= check_newlevellayer(elemtochange);
					var NaturalParent_id 							= getIdentifierParent(ID_Refresh);

						if ((elementToInsert_newlevellayer==null)&&(elemtochange_newlevellayer!=null))
						{//find parent
						var hosting_element							= document.getElementById(NaturalParent_id+"ContentArea|");
							if (NaturalParent_id=='|') 
							{ 
	
								$(document.body).append(elementToInsert.firstChild);
								transferAnyAttribute(elementToInsert,document.body);	
							} else
							{
								jQuery(hosting_element).append(elementToInsert);
								jQuery(elemtochange).remove();
							}
							//may be an element was NewLevelLayer and now is not it anymore
							//It reaches its parent
						} else
						{
							//console_log("mnmnmnmnmnmnmnmnm B NaturalParent_id:"+NaturalParent_id);
							//console_log("  target el id:"+elemtochange.id+" HTML_Refresh:"+HTML_Refresh);
							if (NaturalParent_id=='|') 
							{ 
								//console.log(document.body);
								//console.log(elementToInsert.firstChild);
							var toremove_el =	document.getElementById(document.body.id+"relative_stub|");
								jQuery(toremove_el).remove();

								//console.log('appending inside body :'+jQuery(elementToInsert.firstChild).html());
								jQuery(document.body).prepend(elementToInsert.firstChild);	
								//jQuery(document.body).append("<div id='debugger_bvc' ></div>");
								//jQuery('#debugger_bvc').append(elementToInsert);
								transferAnyAttribute(elementToInsert,document.body);
								//console.log(document.body);	
							} else
							{
								$(elemtochange).replaceWith(HTML_Refresh);
							}	
						}
						LastRefreshId 									= ID_Refresh;
						//performJSinSW(ID_Refresh);
						//ServerCallBackTokenize
					}
				}//A.C.A_true END
				//element sent by server consistance check
			}//A.C END
			//element sent by server to refresh list
		}//A END
}
var MapsList 		= null; 
var MarkersList 	= null;
var CKEditorsList 	= null; 


/**
 * Listmanager Combo
 */
function showComboRow(targetFields,targetContents,el)
{
		//alert("el.id:"+el.id);
		//alert("selected index : "+el.selectedIndex);
		//do not edit. check if used in AutoRend
		//	console_log(targetFields);
		//	console_log(targetContents);
		//	console_log(el);
		//console_log("showComboRow-----------------------------");
		try
		{
		var AfterChangeSelectedIndex 	= el.selectedIndex;
		var SW_el 						= getOwnerSW(el);
			//alert("SW_el:"+OwnerSW.id);
			//alert("targetContents : "+targetContents.length);
			//alert("targetFields:"+targetFields+"targetContents: "+targetContents);
		var rows 						= targetContents.length/targetFields.length;
			//		for(var CurrentTarget=0;CurrentTarget<targetFields.length;++CurrentTarget)
			//		{
			//			alert('searched element by name : '+targetFields[CurrentTarget]);
			//			
			//			var els = $(SW_el).find("input[name='"+targetFields[CurrentTarget]+"']");
			//			
			//			//alert("setting field : "+targetFields[CurrentTarget]+" found:"+els[0]);
			//			 // document.getElementById(targetFields[CurrentTarget]).value=targetContents[id+CurrentTarget*rows].replace(/&&apice;/g,"\'");
			//			els[0].value=targetContents[AfterChangeSelectedIndex+CurrentTarget*rows].replace(/&&apice;/g,"\'");
			//		}
			for(var CurrentTarget=0;CurrentTarget<targetFields.length;++CurrentTarget)
			{//finds linked fields to change. They are input fields
							//console_log("target fields............."+CurrentTarget+"     name to find: "+targetFields[CurrentTarget]);
			var els 					= $(SW_el).find("input[name='"+targetFields[CurrentTarget]+"']");
				els[0].value=targetContents[AfterChangeSelectedIndex+CurrentTarget*rows].replace(/&&apice;/g,"\'");
			var DataFieldOperation_els 	= $(SW_el).find("input[name='DataFieldOperation']");
				if(DataFieldOperation_els.length==0)
				{
					$(SW_el).append("<input type='hidden' id ='"+SW_el.id+"TableForm|DataFieldOperation|' name='DataFieldOperation'  >");
				}
				DataFieldOperation_els 	= $(SW_el).find("input[name='DataFieldOperation']");
				if(DataFieldOperation_els.length==0)
				{
					alert("showComboRow error !!!!");
				} else
				{
var 				filedoperstion_data 					= new Object();
					filedoperstion_data.calling_field_id 	= els[0].id;
					filedoperstion_data.operation_type  	= "PresetComboChoice";
					filedoperstion_data.chosen_index 		= AfterChangeSelectedIndex;
   var 				filedoperstion_dataString				= JSON.stringify(filedoperstion_data);					
					DataFieldOperation_els[0].value			=filedoperstion_dataString;
					sendData(SW_el.id,DataFieldOperation_els[0],'Components.ListManager');
				}				
				//IdentifierIn+"TableForm|"
			}
		}catch(err)
		{
			console_log(err);
			alert("error ShowComboRow:"+err);
		}
}

/**
 * Listmanager Combo
 */
function showComboRow_old(targetFields,targetContents,id)
{
	//do not edit. check if used in AutoRend
		try
		{
			rows = targetContents.length/targetFields.length;
			for(var CurrentTarget=0;CurrentTarget<targetFields.length;++CurrentTarget)
			{
				 document.getElementById(targetFields[CurrentTarget]).value=targetContents[id+CurrentTarget*rows].replace(/&&apice;/g,"\'");
			}
		}catch(err)
		{
			alert("error ShowComboRow:"+err);
		}
}


/**
 * Not used anymore
 */
function manageComboBox(elementIn)
{
		//do not edit......old RichComboBox implementation
	var Parent 					= elementIn.parentNode;
	var GrandParent 			= Parent.parentNode;
	var GrandParent2 			= GrandParent.parentNode;
	var GrandParent3 			= GrandParent2.parentNode;
	var GrandParentzIndex		= GrandParent3.style.zIndex;
	//alert('GrandParent 2 zIndex:'+GrandParentzIndex+' tag :'+GrandParent3.tagName);
	var GrandParent3Rect 		= GrandParent3.getBoundingClientRect();
	var HTMLChooseItemsIn		= 'hi';
	
		$(GrandParent3).find('div').each
		(
			 function () 
			 {
		   // alert(this.getAttribute("name")); // "this" is the current element in the loop
				 if (this.getAttribute("name")=="enhancedcombo_htmllist") HTMLChooseItemsIn = this.innerHTML;
			 }
		);
	
	var movingTableColumnElement 						= document.createElement('div');
		movingTableColumnElement.setAttribute('id','ComboBoxList');
		movingTableColumnElement.setAttribute('class','comboboxlist');
		movingTableColumnElement.style.position			= 'fixed';
		//movingTableColumnElement.style.height			='200px';
		//movingTableColumnElement.style.width			='50px';
		movingTableColumnElement.style.top				= GrandParent3Rect.left+GrandParent3.offsetHeight+'px';
		movingTableColumnElement.style.left				= GrandParent3Rect.left+'px';
		movingTableColumnElement.style.width			= GrandParent3.clientWidth+'px';
	//	movingTableColumnElement.style.bottom			= '0px';
		//movingTableColumnElement.style.backgroundColor 	= 'rgba(200,100,200,0.1)';
		movingTableColumnElement.style.zIndex			= GrandParentzIndex;
		movingTableColumnElement.style.border 			= "3px solid blue";
		movingTableColumnElement.innerHTML				= HTMLChooseItemsIn;
		document.body.appendChild(movingTableColumnElement);
}


function LoadRichComboBox(elemIdIn)
{
	try{
		var boundListElemStateId	= elemIdIn+"stateList|";
		var boundListState_el	    = document.getElementById( boundListElemStateId);
		
		var boundListElemId 		= elemIdIn+"boundList|";
		var boundListElem			= document.getElementById(boundListElemId);
		var boundListTargetId 		= boundListElem.value;
			if (jQuery(boundListState_el).val()=='hidden')
			{
			var elemToHide 			= document.getElementById(boundListTargetId);
				//alert('elemToHide:'+elemToHide.id);
				elemToHide.style.display='none';
			}
		
			if (jQuery(boundListState_el).val()=='visible')
			{
				document.getElementById(boundListTargetId).style.display='block';
				ListRichChoiceManager_show(elemIdIn);
			}
		} catch (error)
		{
			console.log(error);			
		}
}


function setupRichComboBox(SWIdIn)
{
	var SW_el 					= document.getElementById(SWIdIn);
	var commanderidentifierId 	= jQuery(SW_el).attr('CommanderIdentifier');
	var commanderidentifier_el 	= document.getElementById(commanderidentifierId);
		if (isValidElement(commanderidentifier_el))
		{
			LoadRichComboBox(commanderidentifierId);
		}
}

function resetRichComboBox(eventIn,elemIdIn)
{
	var elementIn 				= document.getElementById(elemIdIn);
	var TEOwnerElement 			= getSWOwner(elementIn);
		sendData(TEOwnerElement.id,elementIn,'applicationModel.HTMLEnhancedTagExtension');
}

function triggerRichComboBox(eventIn,elemIdIn)
{
		//elemIdIn is TE EnhancedComboBox	
	var boundListElemId 							= elemIdIn+"boundList|";
	var boundListElem								= document.getElementById(boundListElemId);
	var boundListTargetId 							= boundListElem.value;
	
	var boundListStateId							= elemIdIn+"stateList|";
	var boundListState_el	    					= document.getElementById(boundListStateId);
	var boundListState 								= jQuery(boundListState_el).val()
		//resets to hidden the state of any RichComboBox
		// state of current RichComboBox is stored in boundListState variable, even if now is forced to hidden by following statement 
		erase_temp_show();
	
	var OBJToHideShowElem 							= document.getElementById(boundListTargetId);
		if (OBJToHideShowElem==null) 
		{
			alert('Bound List '+boundListTargetId+' Not Found');
			return;
		} else
		{
		var GraphHostingSW_Id						= elemIdIn+"GraphHostingSW|";
		var GraphHostingSW_el	    				= document.getElementById(GraphHostingSW_Id);
		var HOST_id 								= jQuery(GraphHostingSW_el).val();
		var HOST_el 								= document.getElementById(HOST_id+"ContentArea|");
			if (isValidElement(HOST_el))
			{
			var element_aux 						= $(OBJToHideShowElem).detach();
				$(HOST_el).append(element_aux);
			}
		}

	var OBJToHideShowId 							= OBJToHideShowElem.id;
	var commanderListTargetId						= OBJToHideShowId+"CommanderLink|";
	var commanderListTargetElem 					= document.getElementById(commanderListTargetId);
		if (commanderListTargetElem==null)
		{
		var commanderListTargetElem 				= document.createElement('input');
			commanderListTargetElem.setAttribute('id',commanderListTargetId);
			commanderListTargetElem.setAttribute('type','hidden');
			commanderListTargetElem.setAttribute('value',elemIdIn);
			OBJToHideShowElem.appendChild(commanderListTargetElem);
		}
	var commanderListTargetElem 					= document.getElementById(commanderListTargetId);
	
		if ( boundListState  =='hidden')
		{
			jQuery(boundListState_el).val('visible');
			ListRichChoiceManager_show(elemIdIn);
			scrollManagement();
			return;
		} else
		if (boundListState=='visible')
		{
		var elemToHide 								= document.getElementById(boundListTargetId);
			elemToHide.style.display				= 'none';
			jQuery(boundListState_el).val('hidden');
			return;
		}
}

function ListRichChoiceManager_show(elemIdIn)
{
		var OBJEelem 								= document.getElementById(elemIdIn);
		var boundListElemId 						= elemIdIn+"boundList|";
		var boundListElem							= document.getElementById(boundListElemId);
		var boundListTargetId 						= boundListElem.value;
		var DirectionExtension_id      				= elemIdIn+"DirectionExtension|";
		var DirectionExtension_el      				= document.getElementById(DirectionExtension_id);
		var DirectionExtension_val     				= jQuery(DirectionExtension_el).val();
		var OBJToHideShowElem 						= document.getElementById(boundListTargetId);
			if (OBJToHideShowElem==null) 
			{
				alert('Bound List '+boundListTargetId+' Not Found');
				return;
			} else
			{
			var GraphHostingSW_Id					= elemIdIn+"GraphHostingSW|";
			var GraphHostingSW_el	    			= document.getElementById(GraphHostingSW_Id);
			var HOST_id 							= jQuery(GraphHostingSW_el).val();
			var HOST_el 							= document.getElementById(HOST_id+"ContentArea|");
				if (isValidElement(HOST_el))
				{
				var element_aux 					= $(OBJToHideShowElem).detach();
					$(HOST_el).append(element_aux);
				}
			}
	
		var OBJToHideShowId 						= OBJToHideShowElem.id;
		var commanderListTargetId					= OBJToHideShowId+"CommanderLink|";
		var commanderListTargetElem 				= document.getElementById(commanderListTargetId);
			if (commanderListTargetElem==null)
			{
			var commanderListTargetElem 			= document.createElement('input');
				commanderListTargetElem.setAttribute('id',commanderListTargetId);
				commanderListTargetElem.setAttribute('type','hidden');
				commanderListTargetElem.setAttribute('value',elemIdIn);
				OBJToHideShowElem.appendChild(commanderListTargetElem);
			}
		var commanderListTargetElem 				= document.getElementById(commanderListTargetId);
	
		var elemToShow 								= document.getElementById(boundListTargetId);
			elemToShow.style.display				= 'block';
			elemToShow.style.position				= 'fixed';
			elemToShow.style.zIndex 				= '200';
			elemToShow.className        			= elemToShow.className.replace(" temp_show"," ");
			elemToShow.className	   				+= " temp_show";
			jQuery(elemToShow).css('display','block');
			jQuery(elemToShow).css('visibility','visible');
		var elemToShowRelStub						= elemToShow.parentNode;
		
			ListRichChoiceManager_wrap_setup(elemToShow.id);
			elemToShow.style.position 				= 'absolute';
		var elemToShow_height 						= jQuery(elemToShow).height();
		var elemToShow_width 						= jQuery(elemToShow).width();
		
		var elemToShow_child_SW 	   				= jQuery(elemToShow).find(".ComponentsBasic-ListTreeMenuElement");
		
		var elemToShow_child_SW_child_height 		= 0; 
		var elemToShow_child_SW_child_width 		= 0; 
		
			for(var t=0;t<elemToShow_child_SW.length;++t)
			{
				elemToShow_child_SW_child_height += jQuery(elemToShow_child_SW).height();
				elemToShow_child_SW_child_width  += jQuery(elemToShow_child_SW).width();
			}
			elemToShow_height 						= Math.max(elemToShow_height, elemToShow_child_SW_child_height);
			elemToShow_width 						= Math.max(elemToShow_width, elemToShow_child_SW_child_width);
						
			/*not use getBoundingClientRect ...browser compatibility issues*/
		var OBJEelem_y 								= $(OBJEelem).offset().top - $(window).scrollTop();
		var elemToShowRelStub_y 					= $(elemToShowRelStub).offset().top - $(window).scrollTop();
		var shift_y 								= OBJEelem_y-elemToShowRelStub_y;
		
		var OBJEelem_x 								= $(OBJEelem).offset().left - $(window).scrollLeft();
		var elemToShowRelStub_x 					= $(elemToShowRelStub).offset().left - $(window).scrollLeft();
		var shift_x 								= OBJEelem_x-elemToShowRelStub_x;
		
			if( DirectionExtension_val=='BOTTOM')
			{					
				elemToShow.style.left				= shift_x+'px';
				elemToShow.style.top				= parseInt(shift_y)+jQuery(OBJEelem).height()+'px';
			}
		
			if( DirectionExtension_val=='TOP')
			{
				elemToShow.style.left				= '0px';
				elemToShow.style.top				= '0px';
				//console.log(">>>>>>>>> shift_y:"+shift_y+" elemToShow_height:"+elemToShow_height+" elemToShow_bottom: elemToShow_height:"+elemToShow_height+" elemToShow id:"+elemToShow.id);
				elemToShow.style.top 				= shift_y-elemToShow_height+'px';
				elemToShow.style.left				= shift_x+'px';
			}
			ListRichChoiceManager_wrap_setup(elemToShow.id);
}

function ListRichChoiceManager_wrap_setup(current_SW_id)
{
	executeWrapContent();
	/*
	var 		mySW 										= document.getElementById(current_SW_id);
	var 		max_X 										= -10000;
	var 		min_X 										=  10000;
	var 		max_Y 										= -10000;
	var 		min_Y 										=  10000;
				jQuery(mySW).find('.IsSW, IsTE, form').each(
					function()
					{
					var myTop 								= parseInt(jQuery(this).offset().top);
					var myHeight 							= parseInt(jQuery(this).outerHeight());
					var myBottom 							= parseInt(myTop+myHeight);
					
						if (myTop   	< min_Y){min_Y=myTop;}
						if (myBottom	> max_Y){max_Y=myBottom;}

					var myLeft 								= parseInt(jQuery(this).offset().left);
					var myWidth 							= parseInt(jQuery(this).outerWidth());
					var myRight 							= parseInt(myLeft+myWidth);
					
						if (myLeft 		< min_X){min_X=myLeft;}
						if (myRight 	> max_X){max_X=myRight;}
					}
				);
				if (min_Y< max_Y)
				{
					jQuery(mySW).css("height",parseInt(max_Y-min_Y)+"px");
				}
				if (min_X< max_X)
				{
					jQuery(mySW).css("width",parseInt(max_X-min_X)+"px");
				}
				*/				
}

function WrapContentImplement(current_SW_id,doV,doH)
{
				//console_log('WrapContentImplement current_SW_id:'+current_SW_id+"  dov:"+doV+"  doH:"+doH);
	var 		mySW 										= document.getElementById(current_SW_id);
	var 		max_X 										= -10000;
	var 		min_X 										=  10000;
	var 		max_Y 										= -10000;
	var 		min_Y 										=  10000;
				jQuery(mySW).find('.IsSW, IsTE, form').each(
					function()
					{
					var myTop 								= parseInt(jQuery(this).offset().top);
					var myHeight 							= parseInt(jQuery(this).outerHeight());
					var myBottom 							= parseInt(myTop+myHeight);
					
						if (myTop   	< min_Y){min_Y=myTop;}
						if (myBottom	> max_Y){max_Y=myBottom;}

					var myLeft 								= parseInt(jQuery(this).offset().left);
					var myWidth 							= parseInt(jQuery(this).outerWidth());
					var myRight 							= parseInt(myLeft+myWidth);
					
						if (myLeft 		< min_X){min_X=myLeft;}
						if (myRight 	> max_X){max_X=myRight;}
					}
				);
				if (min_Y< max_Y)
				{
					if (doV) {jQuery(mySW).css("height",parseInt(max_Y-min_Y)+"px");} 
				}
				if (min_X< max_X)
				{
					if (doH) {jQuery(mySW).css("width",parseInt(max_X-min_X)+"px");}
				}				
}


function executeWrapContent()
{
				//console_log(' executeWrapContent start');
		var		wrapcontent_h 			= [];	
				jQuery(".wrapcontent_h").each(function(){
					wrapcontent_h.push(this);
				});
		var		goon 					= true;
				while(goon)
				{
				var depth 				= -1;
					if(wrapcontent_h.length>0)
					{
						for(var g=0;g<wrapcontent_h.length;++g)
						{
							//console.log('wrapcontent_h[g]:'+wrapcontent_h[g].id);
						var depthL 		= getIdentifierTokenDepth(wrapcontent_h[g].id);
							if (depthL> depth) depth = depthL;
						}
						for(var g=0;g<wrapcontent_h.length;++g)
						{
							if (getIdentifierTokenDepth(wrapcontent_h[g].id)==depth)
							{
								WrapContentImplement(wrapcontent_h[g].id,false,true);
								wrapcontent_h.splice(g,1);
								g = 0;	
							}
						}
					} else
					{
						goon = false;
					}					
				}
				
		var		wrapcontent_v 			= [];	
				jQuery(".wrapcontent_v").each(function(){
					wrapcontent_v.push(this);
				});
		var		goon 					= true;
				while(goon)
				{
				var depth 				= -1;
					if(wrapcontent_v.length>0)
					{
						for(var g=0;g<wrapcontent_v.length;++g)
						{
						var depthL 		= getIdentifierTokenDepth(wrapcontent_v[g].id);
							if (depthL> depth) depth = depthL;
						}
						//console.log(' current depth:'+depth);
						for(var g=0;g<wrapcontent_v.length;++g)
						{
							if (getIdentifierTokenDepth(wrapcontent_v[g].id)==depth)
							{
								WrapContentImplement(wrapcontent_v[g].id,true,false);
								wrapcontent_v.splice(g,1);
								g = 0;	
							}
						}
					} else
					{
						goon = false;
					}					
				}
				//console_log(' executeWrapContent end');
}

function selectRichListNode(elementIn)
{
	var 		elementIdentifier 					= elementIn.id;
	var 		elementCommanderLinkIdentifier		= elementIdentifier+"CommanderLink|";
	var 		elementCommanderLink				= document.getElementById(elementCommanderLinkIdentifier);
	var 		elementCommanderIdentifier			= elementCommanderLink.value;
				//alert("commander element id : "+elementCommanderIdentifier);
				triggerRichComboBox(elementCommanderIdentifier);
}

function LoadMenu(identifierIn)
{
	var 		SW_el 					= document.getElementById(identifierIn);
	var 		SW_zIndex 				= jQuery(SW_el).css('z-index');
				//var BaseBackgroundColor 	= document.getElementById(identifierIn+"BaseBackgroundColor|").value;
				//var HilightBackgroundColor 	= document.getElementById(identifierIn+"HilightBackgroundColor|").value;
				//alert('BaseBackgroundColor:'+BaseBackgroundColor+'HilightBackgroundColor:'+HilightBackgroundColor);
	var 		showonlywhenselecting 	= jQuery(SW_el).attr('showonlywhenselecting');
	var 		submenucontainers 		= $(SW_el).find(".submenucontainer");
	var 		arrayLength 			= submenucontainers.length;
				//alert("arrayLength : "+arrayLength);
				for (var i = 0; i < arrayLength; i++) 
				{
				var parent_id 			= submenucontainers[i].getAttribute("parent_id");
					if (parent_id==identifierIn)
					{
						//alert("turning on submenu : "+i);
						submenucontainers[i].style.display 		= "inline-block";
						if (showonlywhenselecting=='Y')
						{
							jQuery(submenucontainers[i]).find(".ComponentsBasic-ListTreeMenuElement").each(
								function(index, value) {
									if (!jQuery(this).hasClass('selected'))
									{
										jQuery(this).css('visibility','hidden');
										jQuery(this).css('display','none');
									}	
								}
							);
						var showtrigger_id = submenucontainers[i].id.replace('MenuChunksContainer','MenuChunksShowTrigger');
							jQuery(submenucontainers[i]).css("position","relative");
							jQuery(submenucontainers[i]).append(
								"<i id = '"+showtrigger_id+"' class='fa-solid fa-bars' style='position:absolute;top:0;right:0;z-index:"+SW_zIndex+";' o_nmousedown='MenuShowonlywhenselecting(this,\""+identifierIn+"\")'></i>"
							);
							jQuery(submenucontainers[i]).off();
							jQuery(submenucontainers[i]).on(
								'mousedown',
								function(event)
								{
									MenuShowonlywhenselecting(event.target,identifierIn);
								}
							);
						}
					}else
					{
						submenucontainers[i].style.display 		= "none";
						//var MyParentElement 					= document.getElementById(parent_id);
					var MyParentElementCommander 				= document.getElementById(parent_id+"Commander|");
						MyParentElementCommander.style.display	= 'block';
						//alert('parent commander to show :'+MyParentElementCommander.id);
					}
				}
				$(SW_el).find(".ComponentsBasic-ListTreeMenuElement").addClass("unhovering");
}

function MenuShowonlywhenselecting(elIn,SDIdIn)
{
	var 					submenucontainers 	= jQuery(elIn).parents(".submenucontainer");
							
					//var 	parent_id	=		jQuery(submenucontainers[0]).attr("parent_id");	
					var 	SW_el				= document.getElementById(SDIdIn);
							if (!jQuery(submenucontainers[0]).hasClass('mobileselecttingexpanded'))
							{
								jQuery(submenucontainers[0]).find(".ComponentsBasic-ListTreeMenuElement").each(
									function(index, value) {
										//if (!jQuery(this).hasClass('selected'))
										{
											jQuery(this).css('visibility','visible');
											jQuery(this).css('display','block');
										}	
									}
								);
								jQuery(submenucontainers[0]).addClass('mobileselecttingexpanded')
							} else	
							if (jQuery(submenucontainers[0]).hasClass('mobileselecttingexpanded'))
							{
								jQuery(submenucontainers[0]).find(".ComponentsBasic-ListTreeMenuElement").each(
									function(index, value) {
										if (!jQuery(this).hasClass('selected'))
										{
											jQuery(this).css('visibility','hidden');
											jQuery(this).css('display','none');
										}	
									}
								);
								jQuery(submenucontainers[0]).removeClass('mobileselecttingexpanded')
							} 	
							
	//var 					submenucontainers 	= jQuery(elIn).parents(".submenucontainer");
							
	var						menuFrame_el 		= document.getElementById(SW_el.id+"frame|");
							//console_log('menuFrame_el.id:'+menuFrame_el.id);
							jQuery(menuFrame_el).css("overflow","visible");
	var						menu_el 			= document.getElementById(SW_el.id);
							jQuery(menu_el).css("overflow","visible");
}

function LoadMenu_old(identifierIn)
{
	var element 				= document.getElementById(identifierIn);
	var BaseBackgroundColor 	= document.getElementById(identifierIn+"BaseBackgroundColor|").value;
	var HilightBackgroundColor 	= document.getElementById(identifierIn+"HilightBackgroundColor|").value;
	//alert('BaseBackgroundColor:'+BaseBackgroundColor+'HilightBackgroundColor:'+HilightBackgroundColor);

	var submenucontainers 	= $(element).find(".submenucontainer");
	var arrayLength 		= submenucontainers.length;
	for (var i = 0; i < arrayLength; i++) 
	{
		var currentsubmenucontainer				= submenucontainers[i];		
		var callingSubMenuChunkId 				= submenucontainers[i].getAttribute("parent_id");
		var callingSubMenuChunk 				= document.getElementById(callingSubMenuChunkId);
		var calledSubMenuId						= submenucontainers[i].id;
		var calledSubMenu						= document.getElementById(calledSubMenuId);
		var calledSubMenu_standard_visibility 	= calledSubMenu.style.display;

		//alert(" id in :"+identifierIn+" \nsubmenucontainer : "+submenucontainers[i].id+" called from : "+callingSubMenuChunkId);		
		//callingSubMenuChunk.onmouseover = function() { calledSubMenu.style.display=calledSubMenu_standard_visibility; };
		//if (currentsubmenucontainer.id != identifierIn) currentsubmenucontainer.style.display = 'none';

	    if (callingSubMenuChunkId==identifierIn)
	    {
	    	
	    }else
	    {
	    	currentsubmenucontainer.style.display = 'none';
			callingSubMenuChunk.onclick = function() 
											{ 
													var CurrentNode 			= document.getElementById(calledSubMenuId);
													CurrentNode.style.display	= 'block'; 
													CurrentNode.className 		= CurrentNode.className+" temporary_to_delete";
													$(CurrentNode).mouseleave(function(){CurrentNode.style.display='none';});
											};
			callingSubMenuChunk.onmouseover = function() 
											{ 
													var CurrentNode 			= document.getElementById(calledSubMenuId);
													CurrentNode.style.display	= 'block'; 
													if (CurrentNode.className.indexOf("temporary_to_delete") < 0)
													{
														CurrentNode.className 		= CurrentNode.className+" temporary_to_delete";													
													}
													$(CurrentNode).mouseleave(function(){CurrentNode.style.display='none';});
											};
	    }
	    if (calledSubMenu.id==identifierIn)
	    {
	    	
	    }else
	    {

	    }
	    //Do something
	}
}

function deleteTemporary()
{
	$(".temporary_to_delete").remove();
}

function TreeNodeCommander(ElementIdIn,UUIDScriptBox)
{
	var TreeNodeCommanderScript 					= $(".TreeNodeCommanderScript");
		for(var t=0;t<TreeNodeCommanderScript.length;++t)
		{
			//alert("\nTreeNodeCommanderScript.id:"+TreeNodeCommanderScript[t].id+"\n UUIDScriptBox : "+UUIDScriptBox);
			if (TreeNodeCommanderScript[t].id!=UUIDScriptBox)
			{
				//alert('removing');
				$(TreeNodeCommanderScript[t]).remove();
			}else
			{
				//alert('leaving');
			}
		}
		//alert('tree node commander script');
	var IconFileExpandedInit						= "tree_expanded.png";
	var IconFileCollpasedInit						= "tree_collapsed.png";
	var IconFileExpandedCurrent						= IconFileExpandedInit;
	var IconFileCollpasedCurrent					= IconFileCollpasedInit;

	var TreeElem 									= document.getElementById(ElementIdIn);
	//var BaseBackgroundColor 		= document.getElementById(ElementIdIn+"BaseBackgroundColor|").value;
	//alert('BaseBackgroundColor:'+BaseBackgroundColor);
	var TreeNodeCommanders 							= $(TreeElem).find(".tree_node_commander");
		//alert('len:'+TreeNodeCommanders.lenght);
		for(var i=0;i<TreeNodeCommanders.length;++i)
		{
		var childhood_last 							= TreeNodeCommanders[i].getAttribute("childhood_last");
		var ListTreeMenuElementId 					= TreeNodeCommanders[i].getAttribute("tree_element_id");
		var SwitchExpanded							= document.getElementById(ListTreeMenuElementId+'switch_exp_col|');
		var CollapsedExpandedFiles					= document.getElementById(ListTreeMenuElementId+'collapse_expand_icons|').value;
			//alert("CollapsedExpandedFiles:"+CollapsedExpandedFiles);
			if (CollapsedExpandedFiles.length>5)
			{
			//var CollapsedExpandedFilesTokens = CollapsedExpandedFiles.split(":");
				//alert('CollapsedExpandedFiles:'+CollapsedExpandedFiles+'\nsplit tokens:'+CollapsedExpandedFilesTokens.length+' \n 0:'+CollapsedExpandedFilesTokens[0]+'\n 1:'+CollapsedExpandedFilesTokens[1]);
				IconFileCollpasedCurrent 			= CollapsedExpandedFiles.split(":")[0];
				IconFileExpandedCurrent  			= CollapsedExpandedFiles.split(":")[1];
			}
		var SwitchExpandedValue						= SwitchExpanded.value;
		var IconFile								= "";
		
			if (SwitchExpandedValue=='true')
			{
				//IconFile = 'tree_collapsed.png';			
				IconFile 							= IconFileCollpasedCurrent;
			}else
			{
				//IconFile = 'tree_expanded.png';
				IconFile 							= IconFileExpandedCurrent;
			}
			//alert('SwitchExpanded id:'+SwitchExpanded.id+' SwitchExpanded value:'+SwitchExpanded.value+'\n icon file : '+IconFile+'\nIconFileCollpasedCurrent:'+IconFileCollpasedCurrent+'\nIconFileExpandedCurrent:'+IconFileExpandedCurrent);

			//TreeNodeCommanders[i].style.backgroundColor = 'black';
			TreeNodeCommanders[i].style.position 	= 'relative';
		//var TreeNodeCommanderHeight 				= TreeNodeCommanders[i].clientHeight;
		var TreeNodeCommanderParentOBJ          	= getOwnerSW(TreeNodeCommanders[i])
		var TreeNodeCommanderHeight 				= TreeNodeCommanderParentOBJ.clientHeight;
			if (childhood_last=='true')
			{
			var found_treenodecommander_aux_els		= jQuery(TreeNodeCommanders[i]).find('.treenodecommander_aux');
				if (found_treenodecommander_aux_els.length==0)
				{
					//console_log('vvv TreeNodeCommanderHeight:'+TreeNodeCommanderHeight);
					jQuery(TreeNodeCommanders[i]).append( 
						"<table class='treenodecommander_aux' cellpadding='0' cellspacing='0' style='width:16px;height:"+TreeNodeCommanderHeight+"px;border:none;margin:0;padding:0;border:none;'>" +
							"<tr >" +
								"<td style='width:50%;height:10px;border-right:1px dotted grey;'>" +
								"</td>" +
								"<td style = 'border-bottom:1px dotted grey;'>" +
								"</td>" +
							"</tr>" +
							"<tr>" +
								"<td style='width:50%;height:100%;border-right:none;border-right:none;'>" +
								"</td>" +
								"<td>" +
								"</td>" +
							"</tr>" +
						"</table>" +
						"<img alt='Collapse or expand tree' id = '"+ListTreeMenuElementId+"CollapseExpandCommand|' height='10px' width='10px'  o_nclick=\"CAclient('"+ListTreeMenuElementId+"',this,event,'ComponentsBasic.ListTreeMenuElement','   !@@PPFEEDBACKACTION_CLICK_LEFT@@! !@@VVSENDDATA@@!   ',false)\"  src='icons/"+IconFile+"' style='position:absolute;border:none;left:3px;top:5px;' >"
					);
					addCLIENTEVENT(ListTreeMenuElementId,ListTreeMenuElementId+'CollapseExpandCommand|','mousedown','ComponentsBasic.ListTreeMenuElement','!@@PPFEEDBACKACTION_CLICK_LEFT@@! !@@VVSENDDATA@@!',false,'')
				}
			} else
			{
			var found_treenodecommander_aux_els= 	jQuery(TreeNodeCommanders[i]).find('.treenodecommander_aux');
				if (found_treenodecommander_aux_els.length==0)
				{
					jQuery(TreeNodeCommanders[i]).append( 
						"<table  class='treenodecommander_aux' cellpadding='0' cellspacing='0' style='width:16px;height:"+TreeNodeCommanderHeight+"px;border:none;margin:0;padding:0;border:none;'>" +
							"<tr >" +
								"<td style='width:50%;height:10px;border-right:1px dotted grey;'>" +
								"</td>" +
								"<td style = 'border-bottom:1px dotted grey;'>" +
								"</td>" +
							"</tr>" +
							"<tr>" +
								"<td style='width:50%;height:100%;border-right:none;border-right:1px dotted grey;'>" +
								"</td>" +
								"<td>" +
								"</td>" +
							"</tr>" +
						"</table>" +
						"<img alt='Collapse or expand tree' id = '"+ListTreeMenuElementId+"CollapseExpandCommand|' height='10px' width='10px'  o_nclick=\"CAclient('"+ListTreeMenuElementId+"',this,event,'ComponentsBasic.ListTreeMenuElement',' !@@PPFEEDBACKACTION_CLICK_LEFT@@! !@@VVSENDDATA@@! ',false)\" src='icons/"+IconFile+"' style='position:absolute;border:none;left:3px;top:5px;' >"
					);
					addCLIENTEVENT(ListTreeMenuElementId,ListTreeMenuElementId+'CollapseExpandCommand|','mousedown','ComponentsBasic.ListTreeMenuElement','!@@PPFEEDBACKACTION_CLICK_LEFT@@! !@@VVSENDDATA@@!',false,'')
				}
			}
		}
}

function LoadAccordion(identifierIn)
{
	var element 			= document.getElementById(identifierIn);
	var submenucontainers 	= $(element).find(".submenucontainer");
	var arrayLength 		= submenucontainers.length;
	for (var i = 0; i < arrayLength; i++) 
	{
	var currentsubmenucontainer				= submenucontainers[i];
	
	var callingSubMenuChunkId 				= submenucontainers[i].getAttribute("parent_id");
	var callingSubMenuChunk 				= document.getElementById(callingSubMenuChunkId);

	var calledSubMenuId						= submenucontainers[i].id;
	var calledSubMenu						= document.getElementById(calledSubMenuId);
	var calledSubMenu_standard_visibility 	= calledSubMenu.style.display;

		//alert(" id in :"+identifierIn+" \nsubmenucontainer : "+submenucontainers[i].id+" called from : "+callingSubMenuChunkId);
		
		//callingSubMenuChunk.onmouseover = function() { calledSubMenu.style.display=calledSubMenu_standard_visibility; };
		//if (currentsubmenucontainer.id != identifierIn) currentsubmenucontainer.style.display = 'none';
		
	    if (callingSubMenuChunkId==identifierIn)
	    {
	    	
	    }else
	    {
	    	currentsubmenucontainer.style.display = 'none';
			callingSubMenuChunk.onclick = function() 
											{ 
													var CurrentNode 			= document.getElementById(calledSubMenuId);
													CurrentNode.style.display	= 'block'; 
													CurrentNode.className 		= CurrentNode.className+" temporary_to_delete";
													$(CurrentNode).mouseleave(function(){CurrentNode.style.display='none';});
											};
			callingSubMenuChunk.onmouseover = function() 
											{ 
													var CurrentNode 			= document.getElementById(calledSubMenuId);
													CurrentNode.style.display	= 'block'; 
													if (CurrentNode.className.indexOf("temporary_to_delete") < 0)
													{
														CurrentNode.className 		= CurrentNode.className+" temporary_to_delete";													
													}
													$(CurrentNode).mouseleave(function(){CurrentNode.style.display='none';});
											};

	    }
	    if (calledSubMenu.id==identifierIn)
	    {
	    	
	    }else
	    {
	    	
	    }
	    //Do something
	}
}

function IsElementIntoSelectionArea(elementTestRectIn,ElementSelectorRectIn)
{
	var output			= true;
	//var elementTestRect = elementIn.getBoundingClientRect();
	var errors			= 0;
	var error_string	= "";
	
	var XminSelector 	= Math.min(ElementSelectorRectIn.left, ElementSelectorRectIn.right);
	var XmaxSelector 	= Math.max(ElementSelectorRectIn.left, ElementSelectorRectIn.right);
	var YminSelector 	= Math.min(ElementSelectorRectIn.top , ElementSelectorRectIn.bottom);
	var YmaxSelector 	= Math.max(ElementSelectorRectIn.top , ElementSelectorRectIn.bottom);

	var XminTested 		= Math.min(elementTestRectIn.left, elementTestRectIn.right);
	var XmaxTested 		= Math.max(elementTestRectIn.left, elementTestRectIn.right);
	var YminTested 		= Math.min(elementTestRectIn.top , elementTestRectIn.bottom);
	var YmaxTested 		= Math.max(elementTestRectIn.top , elementTestRectIn.bottom);
	
	if (XmaxSelector  	< XminTested)  {++errors;  		error_string+="1 ";}
	if (XminSelector  	> XmaxTested)  {++errors;		error_string+="2 ";}
	if (YmaxSelector	< YminTested)  {++errors;		error_string+="3 ";}
	if (YminSelector    > YmaxTested)  {++errors;		error_string+="4 ";}

	if 
		(
			//test X
			(XmaxSelector  	< XminTested)
			||
			(XminSelector  	> XmaxTested)
			||
			//test Y
			(YmaxSelector	< YminTested)
			||
			(YminSelector   > YmaxTested)
		)
	{
		output=  false;
	}
	//$('#debugger_content').html("output:"+output);
	//alert('elementTestRect.left : '+elementTestRect.left+'\n elementTestRect.right '+elementTestRect.right+'\n elementTestRect.top :'+elementTestRect.top+'\n elementTestRect.bottom : '+elementTestRect.bottom+'\n output : '+output);
	//console_log("  elementTestRect.right:"+elementTestRect.right+"  ElementSelectorRectIn.left: "+ElementSelectorRectIn.left+ "  elementTestRect.bottom:"+elementTestRect.bottom+"    ElementSelectorRectIn.top:"+ElementSelectorRectIn.top);
	//console_log("  errors:"+errors+"    error_string:"+error_string);
		return output;
}

function setLastClick(OwnerOBJIn)
{
	var Ancestor_l1							= getOwnerSW(OwnerOBJIn);
	var Ancestor_l2							= getOwnerSW(Ancestor_l1);
	var Ancestor_l3							= getOwnerSW(Ancestor_l2);
	
	var FileListContainer					= Ancestor_l3;
	//alert('FileListContainer : '+FileListContainer.id);
		$(FileListContainer).find(".ComponentsCustom-FSFileBean").css("border","none");
		OwnerOBJIn.style.border = '1px dotted blue';
}

function LoadMediaShow(OBJIdentifierIn)
{
	var OBJ 							= document.getElementById(OBJIdentifierIn);
	var OBJRect 						= OBJ.getBoundingClientRect();
	var OBJContentArea  				= document.getElementById(OBJIdentifierIn+"ContentArea|");

		OBJContentArea.style.overflow 	 = "hidden";

	var canvas 							= document.createElement("div");
		//canvas.style.border 			= "2px solid yellow";
		canvas.style.position 			= "absolute";
		canvas.style.top				= "0";
		canvas.style.left				= "0";
		canvas.style.right				= "0";
		canvas.style.bottom				= "0";
		canvas.id 						= OBJIdentifierIn+"canvas|";
		OBJContentArea.appendChild(canvas);

	var ImageCurrentIndex 				=  jQuery(document.getElementById(OBJIdentifierIn+'MediaCurrent|')).val();
//	var ImageCurrentIndex				= -1;		
//	var ImagesList 						= document.getElementById(OBJIdentifierIn+'MediaList|').value.split(";");
//		ImagesList.splice(ImagesList.length-1);
//		for(var u=0;u<ImagesList.length;++u)
//		{
//			if (ImagesList[u]==ImageCurrent) {ImageCurrentIndex=u;}
//		}
//		
//		if (ImageCurrentIndex>-1)
//		{
//			ImageChange(OBJIdentifierIn,'auto');			
//		}
//		else
//		{
//			ImageChange(OBJIdentifierIn,'0');
//		}
		ImageChange(OBJIdentifierIn,ImageCurrentIndex);
		MediaShowWings(OBJIdentifierIn);
}

// old upto 2020/02/20
//function ImageChange(OBJIdIn,CommandIn)
//{
//	//alert('img change OBJIdIn : '+OBJIdIn+'CommandIn: '+CommandIn);
//	var ImagesList 			= document.getElementById(OBJIdIn+'MediaList|').value.split(";");
//		ImagesList.splice(ImagesList.length-1);
//	var ImageCurrent 		= document.getElementById(OBJIdIn+'MediaCurrent|').value;
//	var ImageCurrentIndex 	= -1;
////	alert('images #:'+ImagesList.length);
//	for(var u=0;u<ImagesList.length;++u)
//	{
//		if (ImagesList[u]==ImageCurrent) {ImageCurrentIndex=u;}
////		alert('images #'+u+':'+ImagesList[u]);
//
//	}
//	//alert('CommandIn:'+CommandIn+' ImageCurrentIndex:'+ImageCurrentIndex );
//	if (ImageCurrentIndex>-1)
//	{
//		if (CommandIn=='R') 						{++ImageCurrentIndex;}
//		if (CommandIn=='L') 						{--ImageCurrentIndex;}
//		if (CommandIn=='0')   						{alert('command 0');ImageCurrentIndex=0;}
//		if (ImageCurrentIndex<0) 				  	{ImageCurrentIndex=ImagesList.length-1;}
//		if (ImageCurrentIndex>ImagesList.length-1) 	{ImageCurrentIndex=0;}
//	}
//	else
//	{
//		ImageCurrentIndex=0;
//	}
//	
//	//alert('current index:'+ImageCurrentIndex);
//	var canvas = document.getElementById(OBJIdIn+"canvas|");
//	var data_pagechunk 																									= "Identifier="+OBJIdIn+"&sessionpagefullname="+jQuery(document.body).attr("pageobjtoken")+"_"+jQuery(document.body).attr("pagename")+"&pageobjtoken="+jQuery(document.body).attr("pageobjtoken")+"&pagename="+jQuery(document.body).attr("pagename")+"&file_uuid="+ImagesList[ImageCurrentIndex];
//
//	$(canvas).html("<img id ='"+OBJIdIn+"shownimage|' src='ImageProvideFromDB?"+data_pagechunk+"' style='overflow:hidden;max-width:100%;height:auto;'>");
//	//$(canvas).html('<img src="ImageProvide?Code='+ImagesList[ImageCurrentIndex]+'" style="overflow:hidden;">');
//	 
//	
//
//
//	document.getElementById(OBJIdIn+'MediaCurrent|').value = ImagesList[ImageCurrentIndex];
//}

function ImageChange(OBJIdIn,CommandIn)
{
	var ImagesList 			= jQuery(document.getElementById(OBJIdIn+'MediaList|')).val().split(";");
	var ImagesList_len 		= ImagesList.length-1;
	var ImageCurrentIndex 	= jQuery(document.getElementById(OBJIdIn+'MediaCurrent|')).val();
		if (CommandIn=='R') 						
		{
			++ImageCurrentIndex;
		} else
		if (CommandIn=='L') 						
		{
			--ImageCurrentIndex;
		} else
		{
			ImageCurrentIndex 	= parseInt(CommandIn);
		}
		
		if (ImageCurrentIndex>=ImagesList_len)
		{
			ImageCurrentIndex = 0;
		} else
		if (ImageCurrentIndex<0)
		{
			ImageCurrentIndex = ImagesList_len-1;
		}
	var canvas 																											= document.getElementById(OBJIdIn+"canvas|");
	var data_pagechunk 																									= encodeURI("Identifier="+OBJIdIn+"&sessionpagefullname="+jQuery(document.body).attr("pageobjtoken")+"_"+jQuery(document.body).attr("pagename")+"&pageobjtoken="+jQuery(document.body).attr("pageobjtoken")+"&pagename="+jQuery(document.body).attr("pagename")+"&file_uuid="+ImagesList[ImageCurrentIndex]+"&fileServerIdentifier="+ImagesList[ImageCurrentIndex]);

		$(canvas).html("<img alt='Current image' id ='"+OBJIdIn+"shownimage|' src='ImageProvideFromDB?"+data_pagechunk+"' style='display:block;overflow:hidden;'>");
		jQuery(document.getElementById(OBJIdIn+'MediaCurrent|')).val(ImageCurrentIndex);
		
		if (jQuery(document.getElementById(OBJIdIn+'CenterInParent|')).val()=="true")
		{
			//alert("ffffffff"+document.getElementById(OBJIdIn+'shownimage|').id);
			//centerElementInParent(OBJIdIn+'shownimage|','BOTH');
			jQuery(document.getElementById(OBJIdIn+'shownimage|')).imageScale({
				  scale:'best-fit',
				  align:'center'
				});
		}
}

function MediaShowHandlers(OBJIdentifierIn)
{
	var OBJ 							= document.getElementById(OBJIdentifierIn);
	var OBJRect 						= OBJ.getBoundingClientRect();
	var OBJContentArea  				= document.getElementById(OBJIdentifierIn+"ContentArea|");
	var HandleHeight 					= 50;
	var OBJHeight 						= parseInt(OBJRect.bottom-OBJRect.top);
	var HandleTop  						= parseInt(OBJHeight/2-HandleHeight/2);
	if (document.getElementById(OBJIdentifierIn+"HandleL|")==null)
	{
	var HandleL 						= document.createElement("div");
		HandleL.id  					= OBJIdentifierIn+"HandleL|";
		//HandleL.style.border 			= "2px solid red";
		HandleL.style.position 			= "absolute";
		HandleL.style.height			= "50px";
		HandleL.style.width				= "50px";
		HandleL.style.left				= "5px";
		HandleL.style.top 				= HandleTop+"px";
		HandleL.style.display 			= "block";
		HandleL.style.backgroundColor 	= "lightgrey";
		HandleL.style.opacity 			= "0.7";
		HandleL.style.filter 			= "alpha(opacity=70)";

		//alert('ContextPath:'+ContextPath);
		HandleL.style.backgroundImage   = "url(\'.."+ContextPath+"/icons/48x48/L.png\')";
		HandleL.setAttribute("onclick","ImageChange('"+OBJIdentifierIn+"','L');");
		//HandleL.setAttribute("onmouseleave","MediaShowHideHandles('"+OBJIdentifierIn+"');");	
		OBJContentArea.appendChild(HandleL);
	}
	var HandleL = document.getElementById(OBJIdentifierIn+"HandleL|");
		HandleL.style.display = "block";
		jQuery(HandleL).css("cursor","pointer");
	if (document.getElementById(OBJIdentifierIn+"HandleR|")==null)
	{	
		var HandleR 					= document.createElement("div");
		HandleR.id 						= OBJIdentifierIn+"HandleR|";
		//HandleR.style.border 			= "2px solid blue";
		HandleR.style.position 			= "absolute";
		HandleR.style.height			= "50px";
		HandleR.style.width				= "50px";
		HandleR.style.right				= "5px";
		HandleR.style.top 				= HandleTop+"px";
		HandleR.style.display 			= "block";
		HandleR.style.backgroundColor 	= "lightgrey";
		HandleR.style.opacity 			= "0.7";
		HandleR.style.filter 			= "alpha(opacity=70)";
		HandleR.style.backgroundImage   = "url('.."+ContextPath+"/icons/48x48/R.png')";
		HandleR.setAttribute("onclick","ImageChange('"+OBJIdentifierIn+"','R');");	
		//HandleR.setAttribute("onmouseleave","MediaShowHideHandles('"+OBJIdentifierIn+"');");	
		OBJContentArea.appendChild(HandleR);
	}
	var HandleR 						= document.getElementById(OBJIdentifierIn+"HandleR|");
		HandleR.style.display 			= "block";
		jQuery(HandleR).css("cursor","pointer");
}

function MediaShowHideHandlers(OBJIdentifierIn,eventIn)
{
	var HandleR 						= document.getElementById(OBJIdentifierIn+"HandleR|");
	var HandleL 						= document.getElementById(OBJIdentifierIn+"HandleL|");
	//$("#debuggeroutput_content").html("OBJIdentifierIn:"+OBJIdentifierIn+" HandleR ID : "+HandleR.id );
	//var posccc="";
	var HandleRRect 					=  HandleR.getBoundingClientRect();
	var HandleLRect 					=  HandleL.getBoundingClientRect();	
	var MouseCoord 						= getCoords(eventIn);
	
	if 
	(	((MouseCoord.x>HandleRRect.left)&& (MouseCoord.x<HandleRRect.right)&&(MouseCoord.y>HandleRRect.top)&& (MouseCoord.y<HandleRRect.bottom))
		||
		((MouseCoord.x>HandleLRect.left)&& (MouseCoord.x<HandleLRect.right)&&(MouseCoord.y>HandleLRect.top)&& (MouseCoord.y<HandleLRect.bottom))
	)
	{
		//$("#debuggeroutput_content").html("int");
		//posccc = "int";
	}
	else
	{
		//posccc = "ext";
		//$("#debuggeroutput_content").html("ext");
		HandleL.style.display = "none";
		HandleR.style.display = "none";
		
	}
	/*
	$("#debuggeroutput_content").html(
			"int MouseCoord.x:"+MouseCoord.x+" HandleR.left : "+HandleRRect.left+" HandleR.right : "+HandleRRect.right 
			+
			"int MouseCoord.x:"+MouseCoord.x+" HandleL.left : "+HandleLRect.left+" HandleL.right : "+HandleLRect.right 
			+
			"int MouseCoord.y:"+MouseCoord.y+" HandleR.top : "+HandleRRect.top+" HandleR.bottom : "+HandleRRect.bottom
			+
			"int MouseCoord.y:"+MouseCoord.y+" HandleL.top : "+HandleLRect.top+" HandleL.bottom : "+HandleLRect.bottom
+ " 		posccc = "+posccc
	);
		*/
//	HandleL.style.display = "none";
//	HandleR.style.display = "none";	
}

function MediaShowWings(OBJIdentifierIn)
{
	var OBJ 							= document.getElementById(OBJIdentifierIn);
	var OBJRect 						= OBJ.getBoundingClientRect();
	var OBJContentArea  				= document.getElementById(OBJIdentifierIn+"ContentArea|");
	var WingL 							= document.createElement("div");
		WingL.id  						= OBJIdentifierIn+"WingL|";
		//WingL.style.border 				= "2px solid black";
		WingL.style.position 			= "absolute";
		WingL.style.top					= "0";
		WingL.style.bottom				= "0";
		WingL.style.left				= "0";
		WingL.style.width 				= "100px";
		WingL.setAttribute("onmousemove","MediaShowHandlers('"+OBJIdentifierIn+"');");
	//	WingL.setAttribute("onmouseleave","MediaShowHandlers('"+OBJIdentifierIn+"');");
		WingL.setAttribute("onmouseleave","MediaShowHideHandlers('"+OBJIdentifierIn+"',event);");	
		OBJContentArea.appendChild(WingL);	
	var WingR 							= document.createElement("div");
		WingR.id 						= OBJIdentifierIn+"WingR|";
		//WingR.style.border 				= "2px solid blue";
		WingR.style.position 			= "absolute";
		WingR.style.top					= "0";
		WingR.style.bottom				= "0";
		WingR.style.right 				= "0";
		WingR.style.width 				= "100px";
		WingR.setAttribute("onmousemove","MediaShowHandlers('"+OBJIdentifierIn+"');");	
		//WingR.setAttribute("onmouseleave","MediaShowHandlers('"+OBJIdentifierIn+"');");	
		WingR.setAttribute("onmouseleave","MediaShowHideHandlers('"+OBJIdentifierIn+"',event);");	

		OBJContentArea.appendChild(WingR);
}

/*
 * 	If control is locked no automatic action is performed. Anyway the event is sent to CAclient
 * 
 * @param els
 * @param action
 * @param size
 * @param basepath
 * @param execute The function to execute....is always called with two parameters: triggering element and triggering event
 * @param event		never used still 20201219
 * @returns
 */
function EnhancedCheckBox(els,action,size,basepath,execute,event)
{
		//console.log('EnhancedCheckBox..... function execute:'+execute+' action:'+action);
		//els refer to check_area of EnhancedCheckBox TagExtension
	var dimensionNameChunk		= "16x16";
	var checkImageName 			= "";
	var uncheckImageName 		= "";
	var checkboxImageName 		= "";
	//var functionName			= "myFunction_special;";//Is called execute function in parameters list
		if ((els==null)||(typeof els === "undefined"))
		{
		}else
		{
			if (els.length>=0)
			{
				for(var u=0;u<els.length;++u)
				{
					if (els[u].id.indexOf("check_area")>0)
					{
						MyInnerFunction(els[u]);
						setIsModified(els[u]);
					}
				}
			}else
			{
				if (els.id.indexOf("check_area")>0)
				{
					MyInnerFunction(els);
					setIsModified(els);
				}
			}
		}
	
		function MyInnerFunction(elementIn)
		{		
				//if program flow is here is sure that elementIn is the check_area
				//console_log("---MyInnerFunction----------action:"+action+" elementIn.id:"+elementIn.id);
				//console.log(new Error());
				//alert("MyInnerFunction elementInIn : "+elementIn.id);
				//console_log("MyInnerFunction c.a. : "+action);
				
				if ((size==null)||(size==="undefined"))
				{
						dimensionNameChunk 	= '16x16';
				}else
				{
						if (size==16 ) dimensionNameChunk 	= '16x16';
						if (size==24 ) dimensionNameChunk 	= '24x24';
						if (size==32 ) dimensionNameChunk 	= '32x32';
						if (size==64 ) dimensionNameChunk 	= '64x64';
						if (size==128) dimensionNameChunk 	= '128x128';
				}
				checkImageName 				= basepath+"/"+"check_"+dimensionNameChunk+".png";
				checkboxImageName 			= basepath+"/"+"checkbox_"+dimensionNameChunk+".png";;

				
			var TE_Owner 					= getTEOwner(elementIn);
				if (action=='uncheck')
				{
					if (!jQuery(elementIn).hasClass("EnChkBox_locked") )
					{
						$(elementIn).find("input[name*='checkuncheck_storage']").val("unchecked");
						$(elementIn).find("img[name*='checked_icon']").css("visibility","hidden");
						$(elementIn).find("img[name*='checked_icon']").attr("src","");
						
						$(elementIn).removeClass('EnChkBox_checked');
						$(elementIn).removeClass('EnChkBox_unchecked');
						$(elementIn).addClass('EnChkBox_unchecked');
						
						$(TE_Owner).removeClass('EnChkBox_checked');
						$(TE_Owner).removeClass('EnChkBox_unchecked');
						$(TE_Owner).addClass('EnChkBox_unchecked');
					}
				} else
				if (action=='check')
				{
					if (!jQuery(elementIn).hasClass("EnChkBox_locked") )
					{
						$(elementIn).find("input[name*='checkuncheck_storage']").val("checked");
						$(elementIn).find("img[name*='checked_icon']").css("visibility","visible");
						$(elementIn).find("img[name*='checked_icon']").attr("src",checkImageName);
						//console_log(">>>>>||||"+checkImageName);
						
						$(elementIn).removeClass('EnChkBox_checked');
						$(elementIn).removeClass('EnChkBox_unchecked');
						$(elementIn).addClass('EnChkBox_checked');
						
						$(TE_Owner).removeClass('EnChkBox_checked');
						$(TE_Owner).removeClass('EnChkBox_unchecked');
						$(TE_Owner).addClass('EnChkBox_checked');
					}
				} else		
				if ((action=='draw_checked')||(action=='draw_unchecked')||(action=='draw_checked_locked')||(action=='draw_unchecked_locked'))
				{
					var elementIn_id 	= "";
						if (elementIn.getAttribute('id') == null)
						{
							elementIn_id 	= getTEOwner(elementIn).id+'check_area|';
							elementIn.id	= elementIn_id;
						}else
						{
							//elementIn_id = elementIn.getAttribute('id');
						}
						/*
						if ((size==null)||(size==="undefined"))
						{
								dimensionNameChunk 	= '16x16';
						}else
						{
								if (size==16 ) dimensionNameChunk 	= '16x16';
								if (size==24 ) dimensionNameChunk 	= '24x24';
								if (size==32 ) dimensionNameChunk 	= '32x32';
								if (size==64 ) dimensionNameChunk 	= '64x64';
								if (size==128) dimensionNameChunk 	= '128x128';
								checkImageName 				  		= basepath+"/"+"check_"+dimensionNameChunk+".png";
								checkboxImageName 					= basepath+"/"+"checkbox_"+dimensionNameChunk+".png";;
						}
						*/
		
						if (jQuery(elementIn).find("[name='checked_icon']").length>0)
						{
							//console_log("already found checked_icon");
						} else
						{
							elementIn.innerHTML 			+= "<img alt='Checked flag' name= 'checked_icon' src='"+checkImageName+"' style ='position:absolute;top:0;left:0;' >";
						}
						
						$(elementIn).removeClass('EnChkBox_checked');
						$(elementIn).removeClass('EnChkBox_unchecked');
						
						$(TE_Owner ).removeClass('EnChkBox_checked');
						$(TE_Owner ).removeClass('EnChkBox_unchecked');
						
						$(TE_Owner ).removeClass('EnChkBox_locked');//added 20200206
						$(elementIn).removeClass('EnChkBox_locked');//added 20200206
						
					var checkuncheck_storage 								= $(elementIn).find("input[name*='checkuncheck_storage']");
						if ((checkuncheck_storage==null)||(typeof checkuncheck_storage === 'undefined')||(checkuncheck_storage.length==0))
						{
						var TeOwner_el 																										= getTEOwner(elementIn);
							jQuery(elementIn).append("<input id='"+TeOwner_el.id+"checkuncheck_storage|' type='hidden' 	name='"+TeOwner_el.id+"checkuncheck_storage|' value = '"+action.replace('draw_','')+"'>" +
							  "<img 	alt='Check box'			name='checkbox_icon' 		src   = '"+checkboxImageName+"' style ='position:absolute;top:0;left:0;' >"
													);
						}else
						{
							//alert("Found content");
						}
						if (action=='draw_checked')
						{	
							$(elementIn).addClass('EnChkBox_checked');
							$(TE_Owner ).addClass('EnChkBox_checked');
							
							$(elementIn).find("input[name*='checkuncheck_storage']").val("checked");
							//$(elementIn).find("img[name*='checked_icon']").css("visibility","visible");
							$(elementIn).find("img[name*='checked_icon']").attr("src",checkImageName);
							$(elementIn).find("img[name*='checked_icon']").css("visibility","visible");
						} else
						if (action=='draw_checked_locked')
						{	
							$(elementIn).addClass('EnChkBox_checked');
							$(elementIn).addClass('EnChkBox_locked');
							
							$(TE_Owner ).addClass('EnChkBox_checked');
							$(TE_Owner ).addClass('EnChkBox_locked');
							
							$(elementIn).find("input[name*='checkuncheck_storage']").val("checked");
							//$(elementIn).find("img[name*='checked_icon']").css("visibility","visible");
							$(elementIn).find("img[name*='checked_icon']").attr("src",checkImageName);
							$(elementIn).find("img[name*='checked_icon']").css("visibility","visible");
						} else
						if(action=='draw_unchecked')
						{
							$(elementIn).addClass('EnChkBox_unchecked');
							$(TE_Owner ).addClass('EnChkBox_unchecked');
							
							$(elementIn).find("input[name*='checkuncheck_storage']").val("unchecked");
							//$(elementIn).find("img[name*='checked_icon']").css("visibility","hidden");
							$(elementIn).find("img[name*='checked_icon']").attr("src","");
							$(elementIn).find("img[name*='checked_icon']").css("visibility","hidden");
						} else
						if(action=='draw_unchecked_locked')
						{
							$(elementIn).addClass('EnChkBox_unchecked');
							$(elementIn).addClass('EnChkBox_locked'  );
							
							$(TE_Owner ).addClass('EnChkBox_unchecked');
							$(TE_Owner ).addClass('EnChkBox_locked'   );
		
							$(elementIn).find("input[name*='checkuncheck_storage']").val("unchecked");
							//$(elementIn).find("img[name*='checked_icon']").css("visibility","hidden");
							$(elementIn).find("img[name*='checked_icon']").attr("src","");
							$(elementIn).find("img[name*='checked_icon']").css("visibility","hidden");
						}
						
						//if (!jQuery(elementIn).hasClass('attached_click_event'))
						{
							//jQuery(elementIn).addClass('attached_click_event');
							$(elementIn).off();
							$(elementIn).click
									(	
											function(e)
											{
										var  	Action_out  = "";
												if (jQuery(elementIn).hasClass('EnChkBox_unchecked'))
												{
													Action_out  = "check";
												} else
												if (jQuery(elementIn).hasClass('EnChkBox_checked'))
												{
													Action_out  = "uncheck";
												}
												//EnhancedCheckBox(elementIn,Action_out,null,null,execute,e);
												EnhancedCheckBox(elementIn,Action_out,null,basepath,execute,e);
												window[execute](this,e);
											}
									);
						}
						//elementIn.style.position		= 'relative';
						//elementIn.style.background 		= 'none';
		}
	}
	
	function setIsModified(elementIn)
	{
		var IsModifiedEl_id 	= getTEOwner(elementIn).id+"IsModified|";
		var IsModifiedEl	 	= document.getElementById(IsModifiedEl_id);

		var OriginalContentEl_id= getTEOwner(elementIn).id+"OriginalContent|";
		var OriginalContentEl	= document.getElementById(OriginalContentEl_id);
		var current_state 		= $(elementIn).find("input[name*='checkuncheck_storage']").val().replace('draw_','').replace('_locked','');
			if (current_state==OriginalContentEl.value)
			{
				IsModifiedEl.value = 'N';
			}else
			{
				IsModifiedEl.value = 'Y';
			}
	}
}

function myFunction_special(dddd)
{
	//alert("_____clicked "+dddd.id);
}

function SayHello()
{
	//alert('Hello : '+Ain+' '+Bin+"......."+elIn.id);s
	alert("fffffmmmm");
}

function myCheckFunction_EnhanchedCheckBox(elementIn,eventIn)
{
	//console_log(">> propagation to CAclient elementIn.id: "+elementIn.id+" eventIn.type:"+eventIn.type);
	//alert("_____ CheckBox caller: "+elementIn.id+" Event type:"+eventIn.type);
	//CAclient(elementIn.id,elementIn,eventIn,"ComponentsTagExtenders.EnhancedCheckBox","",false);
	
	//This function has to be upgraded.......replace with getTEOwner..... 
	var IdentifierIn 	= "";
	//var TEOwner 		= getTEOwner(elementIn);
	var SWOwner 		= getOwnerSW(elementIn);

		if(jQuery.isArray(SWOwner))
		{
			IdentifierIn 	= SWOwner[0].id 
		}else
		{
			IdentifierIn 	= SWOwner.id 
		}
		
		//CAclient(IdentifierIn,elementIn,eventIn,"ComponentsTagExtenders.EnhancedCheckBox","",false);
		CAclient(IdentifierIn,elementIn,eventIn,"applicationModel.HTMLEnhancedTagExtension","",false);
}

//seems to be not necessary.....At the moment reset and set is provided by  EnhancedCheckBox itself
//function EnhancedCheckBoxSetStatus(elsIn,NewStatusIn)
//{
//	var els = elsIn;
//	if ((els==null)||(typeof els === "undefined"))
//	{
//		
//	}
//	else
//	{
//		if (els.length>=0)
//		{
////			alert("elements array");
//			for(var u=0;u<els.length;++u)
//			{
//				PrintId(els[u]);
//				SetStatus(elIn,'');
//			}
//		}
//		else
//		{
////			alert("elements single checkbox els.id :  "+els.id);
//			PrintId(els);
//			SetStatus(els,'');
//		}
//	}
//	
//	function SetStatus(elIn,NewStatusIn)
//	{
//		jQuery(elIn).unbind();
//		jQuery(elIn).find("*").unbind();
//		console_log("unbinding ....."+elIn.id);
//	}
//	
//	function PrintId(elIn)
//	{
//		console_log(" >>>>>>>>>>>>>>>>>>>>>>>>>>>> "+elIn.id);
//	}
//}
////////////START - FILEBROWSER ENHANCED

///////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////      START - OLDER - TO REMOVE	  /////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////

function fileBrowserFileSelectionUP(BaseId,eventIn)
{/////seems to be an older version....to remove?
	//alert('base id : '+BaseId);
	//var BaseId								= OwnerOBJIn.id+'Layer|';
	//$("#debuggeroutput_content").html(">>>>fileBrowserFileSelectionUP fileBrowserFileSelectionUP"+BaseId);
	if (
			(document.getElementById(BaseId+'state|')!=null)
			//&&(document.getElementById(BaseId)!=null)
		)
	{
			var element_State						= document.getElementById(BaseId+'state|');
				element_State.value 				= "0000";
				//$(element_State).remove();
				
				//var element_Lefttop_corner				= document.getElementById(BaseId+'lefttop_corner|');
				//element_Lefttop_corner.style.display='none';
				//$(element_Lefttop_corner).remove();
			
				//var element_selector_div				= document.getElementById(BaseId+'selector_div|');
				//element_selector_div.style.display='none';
			
				//alert('mmm');
			var MyDivs = $(".selector_div");
				for(var i =0; i<MyDivs.length;++i)
				{
					MyDivs[i].style.display = 'none';
					//alert('MyDivs[i].id : '+MyDivs[i].id);
				}
				//$(element_selector_div).remove();
			
				//alert('elementLayer id : '+elementLayer.id);
				//alert('FileListContainerIn id : '+FileListContainerIn.id);
				//alert('up......BaseId:'+BaseId);
				
		var 	FileListContainer = document.getElementById(BaseId.replace("Layer|",""));
				
				if (eventIn.ctrlKey)
				{//consolidate previouse group selection
					//alert('CTRL');
				var ResourceConainerList 		= $(FileListContainer).find(".ComponentsCustom-FSFileBean");
				    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
				    {
				    	var MyFSBean_selection_element = document.getElementById(ResourceConainerList[vvi].id+"selected|");
				    	if (MyFSBean_selection_element.value == "GY") {MyFSBean_selection_element.value="Y";ResourceConainerList[vvi].style.backgroundColor = "lime";}
				    	if (MyFSBean_selection_element.value == "G")  {MyFSBean_selection_element.value="Y";ResourceConainerList[vvi].style.backgroundColor = "lime";}
				    	//if (MyFSBean_selection_element.value == "Y")  {                                     ResourceConainerList[vvi].style.backgroundColor = "lime";}
				    	//if (MyFSBean_selection_element.value == "N")  {                                     ResourceConainerList[vvi].style.backgroundColor = "lightgrey";}
				    }		
				}
	}
}

function fileBrowserFileSelectionDown(OwnerOBJIn,eventIn,elementIn)
{	/////seems to be an older version....to remove?
	//is triggered inside TD and not FSBean
	
	var Ancestor_l1								= getOwnerSW(OwnerOBJIn);
//	var Ancestor_l2								= getOwnerSW(Ancestor_l1);
	//var Ancestor_l3							= getOwnerSW(Ancestor_l2);
	//alert("Ancestor_l1 : "+Ancestor_l1.id);
	
	var FileListContainer						= Ancestor_l1;
	//$("#debuggeroutput_content").html("eeeeeeeeeee FileListContainer.id : "+FileListContainer.id);
		if (eventIn.ctrlKey)
		{//consolidate previous group selection
			//alert('CTRL');
		    var ResourceConainerList 		= $(FileListContainer).find(".ComponentsCustom-FSFileBean");
			    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
			    {
			    var MyFSBean_selection_element = document.getElementById(ResourceConainerList[vvi].id+"selected|");
			    	if (MyFSBean_selection_element.value == "GY") {MyFSBean_selection_element.value="Y";ResourceConainerList[vvi].style.backgroundColor = "lime";}
			    	if (MyFSBean_selection_element.value == "G")  {MyFSBean_selection_element.value="Y";ResourceConainerList[vvi].style.backgroundColor = "lime";}
			    	if (MyFSBean_selection_element.value == "Y")  {                                     ResourceConainerList[vvi].style.backgroundColor = "lime";}
			    	if (MyFSBean_selection_element.value == "N")  {                                     ResourceConainerList[vvi].style.backgroundColor = "lightgrey";}
			    }		
		}else
		{// reset any previous selection
		    var ResourceConainerList 		= $(FileListContainer).find(".ComponentsCustom-FSFileBean");
			    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
			    {
			    var MyFSBean_selection_element = document.getElementById(ResourceConainerList[vvi].id+"selected|");
			    	if (MyFSBean_selection_element.value == "GY") {MyFSBean_selection_element.value="N";ResourceConainerList[vvi].style.backgroundColor = "lightgrey";}
			    	if (MyFSBean_selection_element.value == "Y")  {MyFSBean_selection_element.value="N";ResourceConainerList[vvi].style.backgroundColor = "lightgrey";}
			    	if (MyFSBean_selection_element.value == "N")  {                                     ResourceConainerList[vvi].style.backgroundColor = "lightgrey";}
			    	MyFSBean_selection_element.value="N";ResourceConainerList[vvi].style.backgroundColor = "lightgrey";
		    	}		
		}
	
		if (eventIn.ctrlKey)
		{
	    var ResourceConainerList 				= $(elementIn).find(".ComponentsCustom-FSFileBean");
		    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
		    {	    		
	    	var d = new Date();
	    	var n = d.getTime();
	    	var before = document.getElementById(ResourceConainerList[vvi].id+"selected|").value;

	    		if (document.getElementById(ResourceConainerList[vvi].id+"selected|").value=="Y")
	    		{
		    		document.getElementById(ResourceConainerList[vvi].id+"selected|").value="N";
		    		ResourceConainerList[vvi].style.backgroundColor = "lightgrey";
			    	//alert('from Y to N');
	    		}else
	    		//if (document.getElementById(ResourceConainerList[vvi].id+"selected|").value=="N")
	    		{
		    		document.getElementById(ResourceConainerList[vvi].id+"selected|").value="Y";
		    		ResourceConainerList[vvi].style.backgroundColor = "lime";
			    	//alert('from N to Y');

	    		}
		    var after 						= document.getElementById(ResourceConainerList[vvi].id+"selected|").value;
		    	
		    	//$("#debuggeroutput_content").html("switch........ "+n+" before : "+before+" after : "+after);
	    	}
		}else
		{//No CTRL key
	    var ResourceConainerList 				= $(elementIn).find(".ComponentsCustom-FSFileBean");
		    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
		    {
		    		ResourceConainerList[vvi].style.backgroundColor = "lime";
		    		document.getElementById(ResourceConainerList[vvi].id+"selected|").value="Y";
		    }
		}
	
	var FileListContainerRect					= FileListContainer.getBoundingClientRect();
	var BaseId									= FileListContainer.id+'Layer|';
		if (document.getElementById(BaseId+'lefttop_corner|')==null)
		{
		var elementInput_lefttop_corner 		= document.createElement('input');
			elementInput_lefttop_corner.id			= BaseId+'lefttop_corner|';
			elementInput_lefttop_corner.setAttribute('type','hidden');
			FileListContainer.appendChild(elementInput_lefttop_corner);		
		}
	
	var elementInput_lefttop_corner 			= document.getElementById(BaseId+'lefttop_corner|');
	
		if (document.getElementById(BaseId+'state|')==null)
		{	
		var elementInput_state          		= document.createElement('input');
			elementInput_state.setAttribute('type','hidden');
			elementInput_state.id 					= BaseId+'state|';
			FileListContainer.appendChild(elementInput_state);
		}
	var elementInput_state 						= document.getElementById(BaseId+'state|');

	//alert("state el created : "+elementInput_state.id);
	//FileListContainer.setAttribute("onmousemove","fileBrowserFileSelectionMove('"+BaseId+"',event);");
	//FileListContainer.setAttribute("onmouseup"  ,"fileBrowserFileSelectionUP('"+BaseId+"');");


	
	//var ElementState 							= document.getElementById(BaseId+'state|');
	var ElementLeftTopCoord 					= document.getElementById(BaseId+'lefttop_corner|');
	
	var mouseCoords 							= getCoords(eventIn);
    var startX 									= parseInt(mouseCoords.x) - parseInt(FileListContainerRect.left);
    var startY 									= parseInt(mouseCoords.y) - parseInt(FileListContainerRect.top);
		ElementLeftTopCoord.value 				= ""+startX+";"+startY;

		if (document.getElementById(BaseId+'selector_div|')==null)
		{
		var elementSelector 					= document.createElement('div');
			elementSelector.id 					= BaseId+'selector_div|';
			FileListContainer.appendChild(elementSelector);
			elementSelector.style.position 		= "absolute";
			elementSelector.className			= "selector_div"; 
		}
	var elementSelector 						= document.getElementById(BaseId+'selector_div|');
		elementSelector.style.left				= startX+"px";
		elementSelector.style.top				= startY+"px";
		elementSelector.style.height			= "2px";
		elementSelector.style.width				= "2px";
		elementSelector.style.backgroundColor 	= "rgb(116,227,235)";
		elementSelector.style.opacity 			= ".6"; //For real browsers;
		elementSelector.style.filter 			= "alpha(opacity=60)"; //For IE;
		elementSelector.style.border			= "1px dotted blue";
		elementSelector.style.zIndex			= "100";
		elementSelector.style.display			= "block";
		//elementSelector.setAttribute("onmousemove","fileBrowserFileSelectionMove('"+BaseId+"',event);");
		//elementSelector.setAttribute("onmouseup"  ,"fileBrowserFileSelectionUP('"+BaseId+"');");
		elementInput_state.value				= "0050";
		//if (isShortClick) {elementInput_state.value						= "0000";elementSelector.style.display			= "none";}
   		// $("#debuggeroutput_content").html(" elementInput_state value : "+elementInput_state.value);
}

function fileBrowserFileSelectionMove(BaseId,eventIn)
{
	//YG is set only when a FS element is rounded by a selection rectangle
	var MyState 									= document.getElementById(BaseId+'state|');
	//var d 											= new Date();
	//var n 											= d.getTime();
		//$("#debuggeroutput_content").html("button state : "+detect_button(eventIn));

   		//$('#debuggeroutput_content').html("fileBrowserFileSelectionMove ............ BaseId :"+BaseId+" n : "+n+" MyState value : "+MyState.value);

		if (MyState!=null)
		{
	   // $('#debuggeroutput_content').html("fileBrowserFileSelectionMove inside el id : "+MyState.value);

				//alert('BaseId:'+BaseId);
				var FileListContainer = document.getElementById(BaseId.replace('Layer|',''));
				if (document.getElementById(BaseId+'state|').value=='0050')
				{
					//alert('moving');		
					//var ElementTDContining 			= elementIn.parentNode;	
					//var ElementTDContining			= OwnerOBJIn;
					var ElementTDContining				= FileListContainer;
					var ElementTDContiningrect			= ElementTDContining.getBoundingClientRect();
					var mouseCoords 					= getCoords(eventIn);
				    var posX 							= parseInt(mouseCoords.x) - parseInt(ElementTDContiningrect.left) ;
				    var posY 							= parseInt(mouseCoords.y) - parseInt(ElementTDContiningrect.top);
				    var elementSelector					= document.getElementById(BaseId+'selector_div|');
					var ElementLeftTopCoord 			= document.getElementById(BaseId+'lefttop_corner|');
				    var startX 							= parseInt(ElementLeftTopCoord.value.split(";")[0]);
				    var startY 							= parseInt(ElementLeftTopCoord.value.split(";")[1]);
				    	//console_log("----moving file selection.............. startX:"+startX+"   startY:"+startY);
				    var Height							= posY-startY;
				    var Width							= posX-startX;
				    var Movement 						= Math.abs(Width)+Math.abs(Height);
					    if (Width<0)					{elementSelector.style.left = startX+Width +'px';}
					    if (Height<0)					{elementSelector.style.top  = startY+Height+'px';}
					    elementSelector.style.width 	= Math.abs(Width) +"px";
					    elementSelector.style.height 	= Math.abs(Height)+"px";
			
				 //   $("#debuggeroutput_content").html("sel width : "+Width+" sel height : "+Height+' elementSelector.id:'+elementSelector.id);
				    //if(Movement>200)
				    {
							    var elementSelectorRect 		= elementSelector.getBoundingClientRect();
							    var ResourceConainerList 		= $(ElementTDContining).find(".ComponentsCustom-FSFileBean");
							    //alert('found : '+ResourceConainerList.length);
							    //$('#debuggeroutput_content').html("found   :"+ResourceConainerList.length);
							    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
							    {
							    	var MySelection_elem 					= document.getElementById(ResourceConainerList[vvi].id+"selected|");
							    	var MySelection_elem_already_selected   = false;
							    	if (MySelection_elem.value.indexOf("Y")>-1) {MySelection_elem_already_selected= true;}
							    	if (IsElementIntoSelectionArea(ResourceConainerList[vvi].getBoundingClientRect(),elementSelectorRect))
							    	{
							    		ResourceConainerList[vvi].style.backgroundColor = "lime";
							    		//document.getElementById(ResourceConainerList[vvi].id+"selected|").value="Y";
							    		if (MySelection_elem_already_selected) {MySelection_elem.value="YG";} else {MySelection_elem.value="G";}
							    	} else
							    	{
							    		//ResourceConainerList[vvi].style.backgroundColor = "lightgrey";
							    		//document.getElementById(ResourceConainerList[vvi].id+"selected|").value="N";
							    		if (MySelection_elem_already_selected) {MySelection_elem.value="Y";} else {MySelection_elem.value="N";ResourceConainerList[vvi].style.backgroundColor = "lightgrey";}
							    	}
							    }
					}
				}
		}
}

///////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////   END - OLDER - TO REMOVE	  /////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////

function FileDraggingDIV_loadContent(ElementsContainerIn,dragging_div_element)
{
	//var dragging_div_content = $(".dragging_div_content")[0];
		//$(MovingDIV).empty();
	var SelectedElements 	 = $(ElementsContainerIn).find(".ComponentsCustom-FSFileBean");
	if (SelectedElements.length>0)
	{
		var DraggingFilesList_HTML = "<div style='height:5px;width:20px;'></div>";
		for(var h=0;h<SelectedElements.length;++h)
		{
			if (document.getElementById(SelectedElements[h].id+"selected|").value.indexOf("Y")>-1)
			{
				var file_body_html = document.getElementById(SelectedElements[h].id+"FSFileBody|").firstChild.innerHTML;
				var file_icon_html = document.getElementById(SelectedElements[h].id+"FSFileIcon|").innerHTML;
				DraggingFilesList_HTML   += "<table cellpaadding='0' cellspacing='0' id='"+dragging_div_element.id+"DraggingFiles_"+h+"|' style='font-family:arial;font-size:14px;font-weight:600;margin-left:5px;margin-right:5px;margin-top:0;margin-bottom:0;padding:0;border-collapse:collapse;'>" +
										 	"	<tr style='margin:0;padding:0;'>" +
										 	"		<td style='margin:0;padding:0;'>" +
										 	"	" +file_icon_html+
										 	"		</td>" +
										 	"		<td style='margin:0;padding:0;'>" +
										 	"	" +file_body_html+
										 	"		</td>" +
										 	"	</tr>" +
										 	"</table>";
				//alert("H:"+DraggingFilesList_element.clientHeight+" W:"+DraggingFilesList_element.clientWidth);
			}
		}
//		if (document.getElementById(MovingDIV.id+"DraggingFilesList|")!=null){alert("fffffff");}
//		var DraggingFilesList_element 				= document.createElement("div");
//			DraggingFilesList_element.id 			= MovingDIV.id+"DraggingFilesList|";
//			DraggingFilesList_element.style.position="absolute";
//			DraggingFilesList_element.innerHTML 	= DraggingFilesList_HTML;
//			DraggingFilesList_element.style.border	= "5px solid red";
//			MovingDIV.appendChild(DraggingFilesList_element);
		
//		MovingDIV.innerHTML = "<div id ='"+MovingDIV.id+"DraggingFilesList|' style='position:absolute;border:5px solid red;font-family:arial;font-size:14px;'>"+DraggingFilesList_HTML+"</div>";
		//var DraggingFilesList_element 				= document.getElementById(MovingDIV.id+"content|");
		DraggingFilesList_HTML+="<div style='height:5px;width:20px;'></div>";
		dragging_div_element.innerHTML  	= DraggingFilesList_HTML;
		//dragging_div_content = $(dragging_div_element).find(".dragging_div_content")[0];
		//dragging_div_content = $(".dragging_div_content")[0];
		//$("#debuggeroutput_content").html(" 1.dragging_div_element.id : "+dragging_div_element.id+"<br>2.dragging_div_content_id : "+dragging_div_content.id+"<br>>>>>>>>>"+dragging_div_content.style.border+"<br>---->>>>"+$(dragging_div_content).outerHeight()+"<br>id:"+dragging_div_content.id+"<br>H:"+$(dragging_div_content).height()+" W:"+$(dragging_div_content).width());
//		MovingDIV.style.height = parseInt(DraggingFilesList_element.getBoundingClientRect().bottom)-parseInt(DraggingFilesList_element.getBoundingClientRect().top )+"px";
//		MovingDIV.style.width  = parseInt(DraggingFilesList_element.getBoundingClientRect().right) -parseInt(DraggingFilesList_element.getBoundingClientRect().left)+"px";
	}
}

function FileListRefreshLastMouseDown(LastSelectedElementIn,FileBrowserEnhanchedElementIn)
{
			if (LastSelectedElementIn!=null)
			{
				//console_log("LastSelectedElementIn.id : "+LastSelectedElementIn.id+"   File Container Id:"+FileBrowserEnhanchedElementIn.id);
				var 	FSFileBean_array = $(FileBrowserEnhanchedElementIn).find(".ComponentsCustom-FSFileBean");//.css("border-roght","3px solid lime");
						for(var t=0;t<FSFileBean_array.length;++t){FSFileBean_array[t].style.borderRight= "1px solid transparent";}
						console_log("FSFileBean_array found:"+FSFileBean_array.length);
						if (LastSelectedElementIn!=null) LastSelectedElementIn.style.borderRight = "3px solid red";
			}
}

function fileBrowserCreateDraggingDiv(FileListContainerIn,filebrowserenhancedcontainer_elementIn,startXIn,startYIn)
{
		if (document.getElementById(filebrowserenhancedcontainer_elementIn.id+'dragging_div|')==null)
		{//create DRAGGING DIV
		var elementDragging 							= document.createElement('div');
			elementDragging.id 							= filebrowserenhancedcontainer_elementIn.id+'dragging_div|';
			filebrowserenhancedcontainer_elementIn.appendChild(elementDragging);
			elementDragging.style.position 				= "absolute";
			elementDragging.className					= "dragging_div"; 
			elementDragging.style.left					= startXIn+"px";
			elementDragging.style.top					= startYIn+"px";
//			elementDragging.style.height				= "200px";
//			elementDragging.style.width					= "200px";
			elementDragging.style.backgroundColor 		= "lightblue";
			elementDragging.style.opacity 				= ".9"; //For real browsers;
			elementDragging.style.filter 				= "alpha(opacity=90)"; //For IE;
			elementDragging.style.border				= "1px dotted black";
			elementDragging.style.zIndex				= "100";
			elementDragging.style.display				= "block";
			//elementDragging.innerHTML 				= "<div class='dragging_div_content' id = '"+filebrowserenhancedcontainer_element.id+"'dragging_div|content|' style='position:absolute;border:5px solid blue;height:0;width:0;'></div>";
			
//		var elementDragging_content 				= document.createElement('div');
//			elementDragging_content.id				= filebrowserenhancedcontainer_element.id+'dragging_div|content|';
//			elementDragging_content.className		= 'dragging_div_content';
//			elementDragging_content.style.position	= "absolute";
////			elementDragging_content.style.width     = "0px";
////			elementDragging_content.style.height    = "0px";
//			elementDragging_content.style.border	= "5px solid blue";
//
//			elementDragging.appendChild(elementDragging_content);
		}	
	var elementDragging 								= document.getElementById(filebrowserenhancedcontainer_elementIn.id+'dragging_div|');
		elementDragging.style.display					= "hidden";
}

function fileBrowserCreateSelectorDiv(FileListContainerIn,startXIn,startYIn)
{
		if (document.getElementById(FileListContainerIn.id+'selector_div|')==null)
		{
		var elementSelector 						= document.createElement('div');
			elementSelector.id 						= FileListContainerIn.id+'selector_div|';
			FileListContainerIn.appendChild(elementSelector);
			
			elementSelector.style.position 			= "absolute";
			elementSelector.className				= "selector_div"; 
			elementSelector.style.left				= startXIn+"px";
			elementSelector.style.top				= startYIn+"px";
			elementSelector.style.height			= "2px";
			elementSelector.style.width				= "2px";
			elementSelector.style.backgroundColor 	= "lightgrey";
			elementSelector.style.opacity 			= ".6"; //For real browsers;
			elementSelector.style.filter 			= "alpha(opacity=60)"; //For IE;
			elementSelector.style.border			= "1px dotted blue";
			elementSelector.style.zIndex			= "100";
			elementSelector.style.display			= "block";
		}
	var elementSelector 							= document.getElementById(FileListContainerIn.id+'selector_div|');
		elementSelector.style.display			    = "none";
}

function fileBrowserSavePreviousState(FileListContainerIn)
{
	var FSFileBean_array 							= $(FileListContainerIn).find(".ComponentsCustom-FSFileBean");
		for(var t = 0;t<FSFileBean_array.length;++t)
		{
			var selected_input_id 					= FSFileBean_array[t].id+"selected|";
			var selected_input_el 					= document.getElementById(selected_input_id);
			var selected_previous_input_id  		= FSFileBean_array[t].id+"selected_previuos|";
			var selected_previous_input_el 			= document.getElementById(selected_previous_input_id);
				if (selected_input_el!=null) 
				{
					//alert("selected_input_id :"+selected_input_id+"  selected_input_el.id:"+selected_input_el.id+"  val:"+selected_input_el.value);
					selected_previous_input_el.value=selected_input_el.value; 
				}
		}
}

function fileBrowserResetState(FileListContainerIn)
{
	var FSFileBean_array 							= $(FileListContainerIn).find(".ComponentsCustom-FSFileBean");	
		for(var t = 0;t<FSFileBean_array.length;++t)
		{
			var selected_input_id 					= FSFileBean_array[t].id+"selected|";
			var selected_input_el 					= document.getElementById(selected_input_id);
			var selected_previous_input_id  		= FSFileBean_array[t].id+"selected_previuos|";
			var selected_previous_input_el 			= document.getElementById(selected_previous_input_id);
				if (selected_input_el!=null) 
				{
					//alert("selected_input_id :"+selected_input_id+"  selected_input_el.id:"+selected_input_el.id+"  val:"+selected_input_el.value);
					selected_previous_input_el.value= "N"; 
					selected_input_el.value 		= "N"; 
				}
		}
}

function fileBrowserCountSelected(FileListContainerIn)
{
	var FSFileBean_array 							= $(FileListContainerIn).find(".ComponentsCustom-FSFileBean");
	var	ArraySelections								= [0,0];
		for(var t = 0;t<FSFileBean_array.length;++t)
		{
			var selected_input_id 					= FSFileBean_array[t].id+"selected|";
			var selected_input_el 					= document.getElementById(selected_input_id);
			var selected_previous_input_id  		= FSFileBean_array[t].id+"selected_previuos|";
			var selected_previous_input_el 			= document.getElementById(selected_previous_input_id);
				if (selected_input_el!=null) 
				{
					if (selected_input_el.value 			== 'Y') {ArraySelections[0]=ArraySelections[0]+1;}
				}
				if (selected_previous_input_el!=null) 
				{
					if (selected_previous_input_el.value 	== 'Y') {ArraySelections[1]=ArraySelections[1]+1;}
				}
		}
		return ArraySelections;	
}

function fileBrowserDrawState(FileListContainerIn)
{
	var FSFileBean_array 							= $(FileListContainerIn).find(".ComponentsCustom-FSFileBean");
	
		for(var t = 0;t<FSFileBean_array.length;++t)
		{
			var selected_input_id 					= FSFileBean_array[t].id+"selected|";
			var selected_input_el 					= document.getElementById(selected_input_id);
			var selected_previous_input_id  		= FSFileBean_array[t].id+"selected_previuos|";
			var selected_previous_input_el 			= document.getElementById(selected_previous_input_id);
				if (selected_input_el!=null) 
				{
					var tdparent = getParentSWByType(selected_input_el,"ComponentsBasic-TDElement");
					//alert("selected_input_el.id:  "+selected_input_el.id+" tdparent:"+tdparent.id);
					if ((selected_input_el.value=="Y"))//||(selected_input_el.value=="YTEMP"))
					{
						$(tdparent).find(".ComponentsCustom-FSFileBean").css( "background-color","green");
					}
					else if ((selected_input_el.value=="N"))
					{
						$(tdparent).find(".ComponentsCustom-FSFileBean").css( "background-color","orange");
					} else 	if (selected_input_el.value=="YTEMP")
					{
						$(tdparent).find(".ComponentsCustom-FSFileBean").css( "background-color","lightgreen");
					}
					else if ((selected_input_el.value=="NTEMP"))
					{
						$(tdparent).find(".ComponentsCustom-FSFileBean").css( "background-color","pink");
					}

				}
		}
}

function fileBrowserFileSelection(OwnerOBJIn,eventIn,elementIn,FunctionCallIn)
{
	var myCart = document.getElementById("|filesystem|Cart|");
		if (jQuery(myCart).is('.ui-draggable-dragging'))
		{
			return;
		}
	//console_log("aaaaaaaaaaaaaaaaafileBrowserFileSelectionaaaaaaaaaaaaaaaaaaaaaaaaaa FunctionCallIn:"+FunctionCallIn);
	var StateOut 							 					= "";
	//client_state:
	// 0000 : idle
	// 0050 : box_selection drawing.....
	// 0051 : can drag 
	// 0052 : mouse was moved during 0051 state-> go to 0052. You can drag.
	// 0060 : selecting files. First click occurred.
	// 0061 : selecting files. First click occurred and .
	// 0062 : selecting files - selection rectangle ???
	// 0070---: related to FS tree

	var startX 								 					= 0;
    var startY 								 					= 0;

	var filebrowserenhancedcontainer_element 					= $(".filebrowserenhancedcontainer")[0];
	//alert("fbe id : "+filebrowserenhancedcontainer_element.id);
	//var client_state_element_id 			 = filebrowserenhancedcontainer_element.id+"client_state|";
	//alert("client_state_element_id : "+client_state_element_id);
	var client_state_element 			 	 					= document.getElementById(filebrowserenhancedcontainer_element.id+"client_state|");
	var client_state_element_value 			         			= client_state_element.value;
	var FileListContainer					 					= $(elementIn).parents(".Components-TableManager")[0];
		if (strEndsWith(elementIn.id,"FileList|")) {FileListContainer = elementIn;}
	
	var FileListContainer					 					= jQuery(filebrowserenhancedcontainer_element).find('.filelist_container')[0];
	//if ((typeof FileListContainer === 'undefined')||(FileListContainer==null)) {alert("fssssssssseeeeeeeee");}
	//var Reference_TD_element 		 		 					= null;
	var Reference_FSFileBean_element 		 					= null;
	var FileListContainerRect				 					= FileListContainer.getBoundingClientRect();
	var	ElementEventOrigin										= "";
//	if (FunctionCallIn=='MOVE_NULL')
//	{
//		if (client_state_element.value == '0052')
//		{
//			
//	    	var Mydragging_div_element 				 = document.getElementById(filebrowserenhancedcontainer_element.id+'dragging_div|');
//	    		Mydragging_div_element.style.display = "block";
//	    		Mydragging_div_element.style.left    = MousePosX-filebrowserenhancedcontainer_element.getBoundingClientRect().left+2+"px"; 
//	    		Mydragging_div_element.style.top     = MousePosY-filebrowserenhancedcontainer_element.getBoundingClientRect().top +2+"px";
//	    		Mydragging_div_element.style.width   = "200px";
//	    		Mydragging_div_element.style.height  = "200px";
//			
//		}
//		else
//		{
//			return "";
//		}
//	}

		//console_log(" 0000000000000000000000 >>>>>>>>>> "+OwnerOBJIn_owner_family.id);
	var OwnerOBJIn_owner_family 			 					= OwnerOBJIn.getAttribute("owner_family");
	//console_log("OwnerOBJIn_owner_family:"+OwnerOBJIn_owner_family);
	
	var OwnerOBJIn_id_base					 					=  OwnerOBJIn.id.indexOf("FileList");
	
	//console_log(">>>>> Queue:"+parseInt(OwnerOBJIn.id.length-OwnerOBJIn_id_base-"FileList".length));
	
	if (
			(parseInt(OwnerOBJIn.id.length-OwnerOBJIn_id_base-"FileList".length)>3) 
					&& (OwnerOBJIn.id.indexOf("FileList")>1) 
		)
	{//the call comes from ListFile inner element
		if (OwnerOBJIn_owner_family=='ComponentsCustom-FSFileBean')
		{//Called from FSFileBean
			Reference_TD_element 		 						= $(OwnerOBJIn).parents(".ComponentsBasic-TDElement")[0];
			Reference_FSFileBean_element 						= OwnerOBJIn;
			if (elementIn.id.indexOf("FSFileBody")>-1)
			{			ElementEventOrigin									= "FSFileBean_body";}
			else 
			{			ElementEventOrigin									= "FSFileBean_frame";}
			
		}
		if (OwnerOBJIn_owner_family=='ComponentsBasic-TDElement')
		{//Called from TDElement
			Reference_TD_element 		 						= OwnerOBJIn;
			Reference_FSFileBean_element 						= $(OwnerOBJIn).find(".ComponentsCustom-FSFileBean")[0];
			ElementEventOrigin									= "TD_external";
		}
	} else
	{//the call comes from outside ListFile element
		if (OwnerOBJIn_owner_family.indexOf('Pages')>-1)
		{//Called from External page
			Reference_TD_element 		 						= OwnerOBJIn;
			Reference_FSFileBean_element 						= $(OwnerOBJIn).find(".ComponentsCustom-FSFileBean")[0];
			ElementEventOrigin									= "Page_external";
		}		
	}
	
	// if ((FunctionCallIn=="DOWN")||(FunctionCallIn=="UP"))
	// {
	// 	console_log("client state : "+client_state_element_value+" function call:"+FunctionCallIn+"    \nReference_TD_element:"+Reference_TD_element+"  OwnerOBJIn_owner_family:"+OwnerOBJIn_owner_family +" \nelementIn tag: "+elementIn.tagName+"\n element id:"+elementIn.id+"    ElementEventOrigin:"+ElementEventOrigin);	
	// }
	
	
	//console_log("OwnerOBJIn:"+OwnerOBJIn.id+"  element id:"+elementIn.id+" OwnerOBJIn_owner_family:"+OwnerOBJIn_owner_family+"    Reference_FSFileBean_element:"+Reference_FSFileBean_element+"   id: "+((Reference_FSFileBean_element===undefined||Reference_FSFileBean_element==null)?"":Reference_FSFileBean_element.id)   );
	
	if (FunctionCallIn=='DOWN_FS_TREE_LEAF')
	{// START FunctionCallIn=='DOWN_FS_TREE_LEAF'
		//console_log(" mouse down on tree_leaf state:"+client_state_element.value)
		if (
				(client_state_element.value=="0052")
				||
				(client_state_element.value=="0050")
				||
				(client_state_element.value=="0000")
			)
		{
			if (client_state_element.value=="0050")
			{
						client_state_element.value				= "0000";
			    var 	ResourceConainerList 					= $(FileListContainer).find(".ComponentsCustom-FSFileBean");
					    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
					    {
			    			//inside any FSFileBean element there is an hidden input element "....|selected|" 
			    			//consolidate all of them to selected Y or N
			    			document.getElementById(ResourceConainerList[vvi].id+"selected|").value = "N";
			    			ResourceConainerList[vvi].style.backgroundColor 						= "lightgrey";
			    		}		
			}
			if (client_state_element.value=="0000")
			{
						client_state_element.value 				= "0070";
						//console_log("DOWN button by : "+OwnerOBJIn.id);
				var 	TreeManager 							= $(OwnerOBJIn).parents(".ComponentsCustom-TreeManagerFS_LIST")[0];
				var 	Folders 								= $(TreeManager).find(".ComponentsBasic-ListTreeMenuElement");
						//console_log("TreeManager ID :"+TreeManager.id+" OwnerOBJIn:"+OwnerOBJIn.id);
						for(var g=0;g<Folders.length;++g)
						{
							//console_log("looking for : "+Folders[g].id+"selected|");
							if (document.getElementById(Folders[g].id+"selected|")!= null) {document.getElementById(Folders[g].id+"selected|").value = 'none';}
						}
						document.getElementById(OwnerOBJIn.id+"selected|").value = "Y";
				
//				if (document.getElementById(filebrowserenhancedcontainer_element.id+'dragging_div|')==null)
//				{
//					var elementDragging 						= document.createElement('div');
//						elementDragging.id 						= filebrowserenhancedcontainer_element.id+'dragging_div|';
//						filebrowserenhancedcontainer_element.appendChild(elementDragging);
//						elementDragging.style.position 			= "absolute";
//						elementDragging.className				= "dragging_div"; 
//						elementDragging.style.left				= startX+"px";
//						elementDragging.style.top				= startY+"px";
////						elementDragging.style.height			= "200px";
////						elementDragging.style.width				= "200px";
//						elementDragging.style.backgroundColor 	= "lightblue";
//						elementDragging.style.opacity 			= ".9"; //For real browsers;
//						elementDragging.style.filter 			= "alpha(opacity=90)"; //For IE;
//						elementDragging.style.border			= "1px dotted black";
//						elementDragging.style.zIndex			= "100";
//						elementDragging.style.display			= "block";////
//elementDragging.innerHTML 				= "<div class='dragging_div_content' id = '"+filebrowserenhancedcontainer_element.id+"'dragging_div|content|' style='position:absolute;border:5px solid blue;height:0;width:0;'></div>";
						
//					var elementDragging_content 				= document.createElement('div');
//						elementDragging_content.id				= filebrowserenhancedcontainer_element.id+'dragging_div|content|';
//						elementDragging_content.className		= 'dragging_div_content';
//						elementDragging_content.style.position	= "absolute";
////						elementDragging_content.style.width     = "0px";
////						elementDragging_content.style.height    = "0px";
//						elementDragging_content.style.border	= "5px solid blue";
	//
//						elementDragging.appendChild(elementDragging_content);
//				}	
//				var 	elementDragging 						= document.getElementById(filebrowserenhancedcontainer_element.id+'dragging_div|');
//						elementDragging.style.display			= "hidden";
//
//				
			}
			//alert('mouse down on fs tree....');
		}		
	} // END FunctionCallIn=='DOWN_FS_TREE_LEAF'
	
//	if (FunctionCallIn=='MOVE_FS_TREE_LEAF')
//	{
//		if (
//				(client_state_element.value=='0070')
//			)
//		{
//				client_state_element.value = '0071';
//			//alert('mouse down on fs tree....');
//		}		
//	}

	if (FunctionCallIn=='TARGET_ENTERING')
	{//START - Function Call TARGET_ENTERING
		if (client_state_element.value=="0052")
		{
			if (document.getElementById(Reference_FSFileBean_element.id+"selected|").value.indexOf("Y") ==-1) {Reference_FSFileBean_element.style.backgroundColor = 'yellow';}
		}
	} else //END   - Function Call TARGET_ENTERING	
	if (FunctionCallIn=='TARGET_LEAVING')
	{//START - Function Call TARGET_LEAVING
		if (client_state_element.value=="0052")
		{
			if (document.getElementById(Reference_FSFileBean_element.id+"selected|").value.indexOf("Y") > -1) {Reference_FSFileBean_element.style.backgroundColor = 'lime';}
			if (document.getElementById(Reference_FSFileBean_element.id+"selected|").value.indexOf("Y") ==-1) {Reference_FSFileBean_element.style.backgroundColor = 'lightgrey';}

		}
		
	} else//END   - Function Call TARGET_LEAVING
	if (FunctionCallIn=='DOWN')
	{//START - Function Call DOWN
		//alert('Mouse Down');
		//is triggered inside TD and not FSBean
		//alert("OwnerOBJIn:"+OwnerOBJIn.id);
		//var OwnerOBJIn_element 					= document.getElementById(OwnerOBJIn);
		
//		var Ancestor_l1							= getOwnerSW(OwnerOBJIn);
//		var Ancestor_l2							= getOwnerSW(Ancestor_l1);
		//var Ancestor_l3							= getOwnerSW(Ancestor_l2);
		//alert("Ancestor_l1 : "+Ancestor_l1.id);

		
		//alert('FileListContainer:'+FileListContainer.id);
		//$("#debuggeroutput_content").html("eeeeeeeeeee FileListContainer.id : "+FileListContainer.id);
		
		var ElementLeftTopCoord									= document.getElementById(filebrowserenhancedcontainer_element.id+'boxselection_lefttop_corner|');
			if (ElementLeftTopCoord==null)
			{
			var myElementLeftTopCoord 								= document.createElement("input");
				myElementLeftTopCoord.setAttribute("type","hidden");
				myElementLeftTopCoord.id 							= filebrowserenhancedcontainer_element.id+'boxselection_lefttop_corner|';
				filebrowserenhancedcontainer_element.appendChild(myElementLeftTopCoord);
			}
			ElementLeftTopCoord									= document.getElementById(filebrowserenhancedcontainer_element.id+'boxselection_lefttop_corner|');
		var mouseCoords 										= getCoords(eventIn);
	        startX 												= parseInt(mouseCoords.x) - parseInt(FileListContainerRect.left);
	        startY 												= parseInt(mouseCoords.y) - parseInt(FileListContainerRect.top);
	        ElementLeftTopCoord.value 							= ""+startX+";"+startY;
		
			fileBrowserCreateSelectorDiv(FileListContainer,startX,startY);
			fileBrowserCreateDraggingDiv(FileListContainer,filebrowserenhancedcontainer_element,startX,startY);
			//create anyway eve if is not operated
			
			if (client_state_element!=null)
			{
				//if (Reference_FSFileBean_element!=null) 
				FileListRefreshLastMouseDown(Reference_FSFileBean_element,filebrowserenhancedcontainer_element);
				//var client_state_element_value = client_state_element.value;
				if (client_state_element_value == "0000")
				{
					if (eventIn.ctrlKey)
					{
						if (Reference_FSFileBean_element==null)
						{	//mouse Down under an empty cell
							//Detect if drag starts or not
							//If drag does not start sate is reset
						}else
						{
							var CurStateVal = document.getElementById(Reference_FSFileBean_element.id+"selected|").value;
							if (CurStateVal=="Y")
							{
								document.getElementById(Reference_FSFileBean_element.id+"selected|").value	= "NTEMP";
							} else 
							if (CurStateVal=="N")
							{
								document.getElementById(Reference_FSFileBean_element.id+"selected|").value	= "YTEMP";
							}
							client_state_element.value = "0061";
						}						
					} else
					{//NO CTRL
						if (Reference_FSFileBean_element==null)
						{	//mouse Down under an empty cell
							//fileBrowserResetState(FileListContainerIn);
							client_state_element.value = "0062";
							
							//Drag starts if MouseDown occurs on a selected element
						} else
						{
							if (ElementEventOrigin=='Page_external')
							{
							} else 
							if (ElementEventOrigin=='FSFileBean_body')
							{
								document.getElementById(Reference_FSFileBean_element.id+"selected|").value 			= "Y";
								//console_log("^^^^^^^^^^^^  "+document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value);
								document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value = "Y";								
								client_state_element.value = "0065";
							} else 
							if  (ElementEventOrigin=='FSFileBean_frame')
							{
								document.getElementById(Reference_FSFileBean_element.id+"selected|").value 			= "YTEMP";
								document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value = "N";
								client_state_element.value = "0061";

							} else 
							if  (ElementEventOrigin=='TD_external')
							{
								client_state_element.value = "0061";
							}
						}
					}
				}	else
				if (client_state_element_value == "0060")
				{
					if (eventIn.ctrlKey)
					{
					} else
					{
						fileBrowserResetState(FileListContainer);
//						alert("reset selection");
						if (Reference_FSFileBean_element==null)
						{	//mouse Down under an empty cell
							//Detect if drag starts or not
							//If drag does not start sate is reset
							
							//Drag starts is MouseDown occurs on a selected element
						} else
						{
							document.getElementById(Reference_FSFileBean_element.id+"selected|").value = "Y";
							document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value = "Y";
						}
					}
				}	else
				if (client_state_element_value == "0061")
				{
					
				}	else
				if (client_state_element_value == "0062")
				{
					if (eventIn.ctrlKey)
					{
					} else
					{
						fileBrowserResetState(FileListContainer);
//						alert("reset selection");
						if (Reference_FSFileBean_element==null)
						{	//mouse Down under an empty cell
							//Detect if drag starts or not
							//If drag does not start sate is reset
							
							//Drag starts is MouseDown occurs on a selected element
						} 	else
						{
							document.getElementById(Reference_FSFileBean_element.id+"selected|").value = "Y";
							document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value = "Y";
						}
					}
				} 	else
				if (client_state_element_value == "0050")
				{ //mouse Down 
					if (eventIn.ctrlKey)
					{
						if (Reference_FSFileBean_element==null)
						{	//mouse Down under an empty cell
							//Detect if drag starts or not
							//If drag does not start sate is reset
							client_state_element.value = "0061";
						} 	else
						{
							if (ElementEventOrigin=='Page_external')
							{

							} else 
							if (ElementEventOrigin=='FSFileBean_frame')						
							{
								var CurStateVal = document.getElementById(Reference_FSFileBean_element.id+"selected|").value;
								if (CurStateVal=="Y")
								{
									document.getElementById(Reference_FSFileBean_element.id+"selected|").value	= "NTEMP";
								} else 
								if (CurStateVal=="N")
								{
									document.getElementById(Reference_FSFileBean_element.id+"selected|").value	= "YTEMP";
								}
								client_state_element.value = "0061";
							} else
							if  (ElementEventOrigin=='TD_external')
							{
//									document.getElementById(Reference_FSFileBean_element.id+"selected|").value 			= "YTEMP";
//									document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value = "N";																
									client_state_element.value = "0061";
							} else 
							if (ElementEventOrigin=='FSFileBean_body')						
							{
								var CurStateVal = document.getElementById(Reference_FSFileBean_element.id+"selected|").value;
								if (CurStateVal=="Y")
								{
									document.getElementById(Reference_FSFileBean_element.id+"selected|").value	= "NTEMP";
								} else 
								if (CurStateVal=="N")
								{
									document.getElementById(Reference_FSFileBean_element.id+"selected|").value	= "YTEMP";
								}
								client_state_element.value = "0061";
							}
						}						
					} else
					{////mouse Down  no CTRL
						if (Reference_FSFileBean_element==null)
						{	//mouse Down under an empty cell
							client_state_element.value = "0061";
						} 	else
						{
							//document.getElementById(Reference_FSFileBean_element.id+"selected|").value = "Y";
							//document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value = "N";
							var CurStateVal = document.getElementById(Reference_FSFileBean_element.id+"selected|").value;
							if (ElementEventOrigin=='Page_external')
							{

							} else 							
							if (ElementEventOrigin=='FSFileBean_body')
							{
								///
								if (CurStateVal=="Y")
								{
									client_state_element.value = "0065";//?????
									
								} else
								if (CurStateVal=="N")
								{
									fileBrowserResetState(FileListContainer);
									document.getElementById(Reference_FSFileBean_element.id+"selected|").value 			= "Y";
									document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value = "Y";								
									client_state_element.value = "0061";							
								}
							} else 
							if  (ElementEventOrigin=='TD_external')
							{
//									document.getElementById(Reference_FSFileBean_element.id+"selected|").value 			= "YTEMP";
//									document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value = "N";																
									client_state_element.value = "0061";
							} else 
							if  (ElementEventOrigin=='FSFileBean_frame')
							{
								if (CurStateVal=="Y")
								{
									client_state_element.value = "0065";//?????
									
								} else
								if (CurStateVal=="N")
								{
									fileBrowserResetState(FileListContainer);
									document.getElementById(Reference_FSFileBean_element.id+"selected|").value 			= "YTEMP";
									document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value = "N";																
									client_state_element.value = "0061";							
								}
							}							
						}
					}
				}
			} 
	} else//END   - Function Call DOWN
	if (FunctionCallIn=='MOVE')
	{//START - Function Call MOVE
	
		var 	move_LeftTopCoord_element 							= document.getElementById(filebrowserenhancedcontainer_element.id+'boxselection_lefttop_corner|');		
				move_LeftTopCoord_element.style.display				= '';
				move_LeftTopCoord_element.style.border 				= '3px dotted pink';
		//YG is set only when a FS element is rounded by a selection rectangle
		//var MyState = document.getElementById(BaseId+'state|');
		//var d 		= new Date();
		//var n 		= d.getTime();
		//$("#debuggeroutput_content").html("button state : "+detect_button(eventIn));

	   // $('#debuggeroutput_content').html("fileBrowserFileSelectionMove ............ client_state_element : "+client_state_element.value);
		//console_log("selection moving........"+move_LeftTopCoord_element.value+"    move_LeftTopCoord_element.id:"+move_LeftTopCoord_element.id);

		if (client_state_element!=null)
		{
					// $('#debuggeroutput_content').html("fileBrowserFileSelectionMove inside el id : "+MyState.value);
					//alert('BaseId:'+BaseId);
					//var FileListContainer = document.getElementById(BaseId.replace('Layer|',''));
					var		ElementLeftTopCoord						= document.getElementById(filebrowserenhancedcontainer_element.id+'boxselection_lefttop_corner|');
					var 	MyStartCoords							= ElementLeftTopCoord.value.split(";");
					var		DistanceLastClick						= -1;
							if (MyStartCoords.value!="-1;-1") 		{DistanceLastClick=Math.sqrt(Math.abs(MousePosX-MousePosX_lastDown_event)+Math.abs(MousePosY-MousePosY_lastDown_event)   );}

			    	var 	MySelector_div_element 				 	= document.getElementById(FileListContainer.id+'selector_div|');
							
	    			if (client_state_element_value == "0000")
	    			{
							ElementLeftTopCoord						= document.getElementById(filebrowserenhancedcontainer_element.id+'boxselection_lefttop_corner|');
						var MyStartCoords							= ElementLeftTopCoord.value.split(";");
	    				
	    			} else
	    			if (client_state_element_value == "0060")
	    			{
	    				
	    			} else
	    			if (client_state_element_value == "0061")
	    			{
						if ((Math.abs(MousePosX-MousePosX_lastDown_event)>5)||(Math.abs(MousePosY-MousePosY_lastDown_event)>5)) 
						{
							client_state_element.value = "0062";
						}
	    			} else					
					if (client_state_element_value == "0062")
					{
						 if ( parseInt(MousePosY ) < jQuery(filebrowserenhancedcontainer_element).offset().top ) 
						 {//do not do nothing
						 	//client_state_element.value = "0050";
						 } 
						{

						var bias_x 											= parseInt(MousePosX )-jQuery(FileListContainer).offset().left;
						var bias_y 											= parseInt(MousePosY )-jQuery(FileListContainer).offset().top;

			    			//console_log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! bias_y : "+bias_y+"  mousey: "+parseInt(MousePosY ));

							ElementLeftTopCoord								= document.getElementById(filebrowserenhancedcontainer_element.id+'boxselection_lefttop_corner|');
						var MyStartCoords									= ElementLeftTopCoord.value.split(";");
							//console_log("--------------------->>>>>>>>>>>>>"+elementIn.id+" FileListContainer.id:"+FileListContainer.id);
							//var MySelector_div_element 				 	= document.getElementById(FileListContainer.id+'selector_div|');
							MySelector_div_element.style.display 			= "block";

							MySelector_div_element.style.left    			= -filebrowserenhancedcontainer_element.getBoundingClientRect().left+2+"px"; 
							MySelector_div_element.style.top     			= -filebrowserenhancedcontainer_element.getBoundingClientRect().top +2+"px";

							//MySelector_div_element.style.width   			= parseInt(MousePosX-filebrowserenhancedcontainer_element.getBoundingClientRect().right -MySelector_div_element.getBoundingClientRect().left) +"px";//+"px";
							//MySelector_div_element.style.height  			= 20+"px";//-MySelector_div_element.style.top +MousePosY+"px";
							
							MySelector_div_element.style.width   			= parseInt(MousePosX -MySelector_div_element.getBoundingClientRect().left)+"px";
							MySelector_div_element.style.height  			= parseInt(MousePosY -MySelector_div_element.getBoundingClientRect().top) +"px";

							MySelector_div_element.style.width   			= Math.abs(parseInt(MousePosX )-(parseInt(MyStartCoords[0])+FileListContainer.getBoundingClientRect().left))+"px";
							MySelector_div_element.style.height   			= Math.abs(parseInt(MousePosY )-(parseInt(MyStartCoords[1])+FileListContainer.getBoundingClientRect().top))+"px";
							//$("#debuggeroutput_content").html("W POS NEG : "+parseInt(parseInt(MousePosX )-parseInt(MyStartCoords[0])-parseInt(FileListContainer.getBoundingClientRect().left) ) +"sss");
							
							
							if (parseInt(parseInt(MousePosX )-parseInt(MyStartCoords[0])-parseInt(FileListContainer.getBoundingClientRect().left) )>0)
							{
								MySelector_div_element.style.left   		= parseInt(MyStartCoords[0])+"px";
							}else
							{
								MySelector_div_element.style.left  			= parseInt(parseInt(MousePosX )-parseInt(FileListContainer.getBoundingClientRect().left) )+"px";
							}
							
							if (parseInt(parseInt(MousePosY )-parseInt(MyStartCoords[1])-parseInt(FileListContainer.getBoundingClientRect().top) )>0)
							{
								MySelector_div_element.style.top   			= parseInt(MyStartCoords[1])+"px";
							}else
							{
								MySelector_div_element.style.top  			= parseInt(MyStartCoords[1])+parseInt(parseInt(MousePosY )-parseInt(MyStartCoords[1])-parseInt(FileListContainer.getBoundingClientRect().top) )+"px";
							}

							if (bias_y<0)
							{
								MySelector_div_element.style.top   			= parseInt(bias_y)+"px";
								MySelector_div_element.style.height			= (parseInt(Math.abs(bias_y))+parseInt(MyStartCoords[1]))+"px";

							} else
							{

							}
							/*

							if (parseInt(MousePosY )<jQuery(filebrowserenhancedcontainer_element).offset().top)
							{
								//console_log("yyyyyyyyy .............. OUTBOUNDING TOP");
								//MySelector_div_element.style.top   			= parseInt(MyStartCoords[1])+"px";
								MySelector_div_element.style.top   			= parseInt(FileListContainer.getBoundingClientRect().top);
								MySelector_div_element.style.height   		= (parseInt(MyStartCoords[1])- parseInt(FileListContainer.getBoundingClientRect().top))+"px";
							} else
							{
								MySelector_div_element.style.top   			= parseInt(FileListContainer.getBoundingClientRect().top) + parseInt(MousePosY )-jQuery(filebrowserenhancedcontainer_element).offset().top;
								MySelector_div_element.style.height   		= (parseInt(MyStartCoords[1])-    (  parseInt(MousePosY )-jQuery(filebrowserenhancedcontainer_element).offset().top ) )+"px";
							}*/
/*
							if (parseInt(MousePosX )<jQuery(filebrowserenhancedcontainer_element).offset().left)
							{
								//console_log("yyyyyyyyy .............. OUTBOUNDING TOP");
								//MySelector_div_element.style.top   			= parseInt(MyStartCoords[1])+"px";
								MySelector_div_element.style.left   		= parseInt(FileListContainer.getBoundingClientRect().left);
								MySelector_div_element.style.width   		= (parseInt(MyStartCoords[0])- parseInt(FileListContainer.getBoundingClientRect().left))+"px";
							} */  

					    var ResourceConainerList 						= $(FileListContainer).find(".ComponentsCustom-FSFileBean");

						    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
						    {
						    	var MySelection_elem 					= document.getElementById(ResourceConainerList[vvi].id+"selected|");
						    	var MySelection_previous_elem 			= document.getElementById(ResourceConainerList[vvi].id+"selected_previuos|");
						    	var MySelection_elem_already_selected   = false;
						    	if (MySelection_elem.value.indexOf("Y")>-1) 
						    	{
						    		MySelection_elem_already_selected= true;
						    	}
						    	
						    	if (IsElementIntoSelectionArea(ResourceConainerList[vvi].getBoundingClientRect(),MySelector_div_element.getBoundingClientRect()))
						    	{// ELEMENT OVERLAPS SELECTION AREA
						    		//console_log("intersecting !!!!!!!!!!!!!!!!!!");
						    		//ResourceConainerList[vvi].style.backgroundColor = "lime";
						    		//document.getElementById(ResourceConainerList[vvi].id+"selected|").value="Y";
						    		//if (MySelection_elem_already_selected) {MySelection_elem.value="YG";} else {MySelection_elem.value="G";}
						    		
									if (eventIn.ctrlKey)
									{//CTRL pressed
										var aux_selprev 				= MySelection_previous_elem.value;
										var aux_sel 					= MySelection_elem.value;
										//console_log("  aux_sel :"+aux_sel+"   aux_selprev:"+aux_selprev);
										//if (OwnerOBJIn_owner_family=='ComponentsCustom-FSFileBean')
							    		{
									    	if ((aux_sel=="Y")&&(aux_selprev=="Y"))
									    	{
										    	MySelection_elem.value			= "N";
										    	//MySelection_previous_elem.value = "N";
									    	}
									    	if ((aux_selprev=="N"))
									    	{
										    	MySelection_elem.value			= "Y";
										    	//MySelection_previous_elem.value = "N";
									    	}
							    		}
										//if (OwnerOBJIn_owner_family=='ComponentsBasic-TDElement')
								    	//if ((aux_sel=="N")&&(aux_selprev=="N"))
								    	//{
									    //	MySelection_elem.value			= "Y";
									    //	MySelection_previous_elem.value = "Y";
								    	//} 
									}else
									{//NO CTRL pressed
							    		MySelection_elem.value="Y";
									}
						    	}else
						    	{// ELEMENT NOT OVERLAPS SELECTION AREA
						    		
						    		//console_log(" not intersecting@@@@@@@@@@@@@@@@@@@@");
						    		//ResourceConainerList[vvi].style.backgroundColor = "lightgrey";
						    		//document.getElementById(ResourceConainerList[vvi].id+"selected|").value="N";
						    		
						    		//if (MySelection_elem_already_selected) {MySelection_elem.value="Y";} else {MySelection_elem.value="N";ResourceConainerList[vvi].style.backgroundColor = "lightgrey";}
									if (eventIn.ctrlKey)
									{
										//if (OwnerOBJIn_owner_family=='ComponentsBasic-TDElement')
										{
											var aux_selprev = MySelection_previous_elem.value;
											var aux_sel 	= MySelection_elem.value;
									    	if ((aux_sel=="N")&&(aux_selprev=="Y"))
									    	{
										    	MySelection_elem.value			= "Y";
										    	//alert("lllll");
										    	//MySelection_previous_elem.value = "N";
									    	} 
									    	if ((aux_selprev=="N"))
									    	{
										    	MySelection_elem.value			= "N";
										    	//MySelection_previous_elem.value = "N";
									    	}
										}
									} else
									{
								    	MySelection_elem.value			= "N";
									}
						    	}
							}//Loop FileBeans
						}
					}	else					
					if ((client_state_element_value == "0051")||(client_state_element_value == "0052"))
					{//alert('moving');		
						if (ElementEventOrigin=='Page_external')
						{

						} else 
					    if (ElementEventOrigin=='TD_external')
					    {
					    			if (client_state_element.value=="0051") {FileDraggingDIV_loadContent(FileListContainer,$(".dragging_div")[0]);}
					    		//	client_state_element.value = "0052";
					    }
					    
					    if (ElementEventOrigin=='FSFileBean_body')
					    {
			    					if (client_state_element.value=="0051") {FileDraggingDIV_loadContent(FileListContainer,$(".dragging_div")[0]);}
						    		//	client_state_element.value = "0052";
					    }//OwnerOBJIn_owner_family=='ComponentsCustom-FSFileBean'
					    
					    if (client_state_element_value=="0052")
					    {
					    	
					    	var Mydragging_div_element 				 			= document.getElementById(filebrowserenhancedcontainer_element.id+'dragging_div|');
					    		Mydragging_div_element.style.display 			= "block";
					    		Mydragging_div_element.style.left    			= MousePosX-filebrowserenhancedcontainer_element.getBoundingClientRect().left+10+"px"; 
					    		Mydragging_div_element.style.top     			= MousePosY-filebrowserenhancedcontainer_element.getBoundingClientRect().top +10+"px";
					    		//Mydragging_div_element.style.width   = "200px";
					    		//Mydragging_div_element.style.height  = "200px";
					    }

					    
					} else
					if (client_state_element_value == "0065")
					{
						if ((Math.abs(MousePosX-MousePosX_lastDown_event)>5)||(Math.abs(MousePosY-MousePosY_lastDown_event)>5)) 
						{
							FileDraggingDIV_loadContent(FileListContainer,$(".dragging_div")[0]);
							$(".dragging_div").css('display','block');
							client_state_element.value = "0072";
						}
					} else
					if (client_state_element_value == "0070")
					{
						if (
								(client_state_element_value == "0070")
								&&
								((Math.abs(MousePosX-MousePosX_lastDown_event)>5)||(Math.abs(MousePosY-MousePosY_lastDown_event)>5))
							)
						{
							setFileBrowserEnhancesInfo('fsbean_core_selected','true');	
							client_state_element.value = "0072";
						}
					} else
					if(client_state_element_value == "0072")
					{
					    	var Mydragging_div_element 				 			= document.getElementById(filebrowserenhancedcontainer_element.id+'dragging_div|');
					    		Mydragging_div_element.style.display 			= "block";
					    		Mydragging_div_element.style.left    			= MousePosX-filebrowserenhancedcontainer_element.getBoundingClientRect().left+10+"px"; 
					    		Mydragging_div_element.style.top     			= MousePosY-filebrowserenhancedcontainer_element.getBoundingClientRect().top +10+"px";
					    		Mydragging_div_element.style.width   			= "200px";
					    		Mydragging_div_element.style.height  			= "200px";
					    		Mydragging_div_element.style.backgroundColor	= "red";
					}
		
		}//client_state_element is not null
	} else //END - Function Call MOVE
	if (FunctionCallIn=='UP')
	{//START - Function Call UP
		//console_log("\\\\\\\\\\\\\\\\\\\\\\\ client_state_element_value:::::::"+client_state_element_value+"   ElementEventOrigin:"+ElementEventOrigin);
		if (client_state_element_value=="0070")	
		{//"0070" Mouse Up 
								StateOut										= "SENDDATA";
								client_state_element.value						= "0000";
		} else
		if (client_state_element_value=="0072")	
		{//"0072" Mouse Up 
			//					client_state_element.value 						= "0000";
								$(".dragging_div").css('display','none');
			if (
				(Reference_FSFileBean_element==null)
				||
				(document.getElementById(Reference_FSFileBean_element.id)==null)
				|| 
				(ElementEventOrigin=='Page_external')						
			)
			{
								alert("td Destinazione non consentita.");
						    	var SelectedElements 							= fileBrowserCountSelected(FileListContainer);
					    		if (SelectedElements[0]>0) {client_state_element.value = "0050";} else {client_state_element.value = "0000";}
			} else
			{
						if (ElementEventOrigin=='Page_external')
						{
							
						} else 
						if (ElementEventOrigin=='TD_external')
						{
							var FSfile_FOLDER_FILE_SWITCH 						= document.getElementById(Reference_FSFileBean_element.id+"FSFileBody|FSfile_FOLDER_FILE_SWITCH|").value;
							var is_folder_selected          					= document.getElementById(Reference_FSFileBean_element.id+"selected|").value;
							//alert("is_folder_selected : "+is_folder_selected);
							if (((is_folder_selected=='N')||(is_folder_selected=='null'))&&(FSfile_FOLDER_FILE_SWITCH=='FOLDER'))
							{
						    	var SelectedElements 												= fileBrowserCountSelected(FileListContainer);
					    		if (SelectedElements[0]>0) {client_state_element.value = "0050";} else {client_state_element.value = "0000";}
								var files_drop_point_result = confirm("td OwnerOBJIn:"+OwnerOBJIn.id+"   elementIn:"+elementIn.id+" spostare qui i file?");
							}	else
							{
						    	var SelectedElements 												= fileBrowserCountSelected(FileListContainer);
					    		if (SelectedElements[0]>0) {client_state_element.value = "0050";} else {client_state_element.value = "0000";}
								//alert("td Destinazione non consentita.");
							}
						} else
						if (ElementEventOrigin=='FSFileBean_body')
						{
							var FSfile_FOLDER_FILE_SWITCH 						= document.getElementById(Reference_FSFileBean_element.id+"FSFileBody|FSfile_FOLDER_FILE_SWITCH|").value;
							var is_folder_selected 								= document.getElementById(Reference_FSFileBean_element.id+"selected|").value;
							if (((is_folder_selected=='N')||(is_folder_selected=='null'))&&(FSfile_FOLDER_FILE_SWITCH=='FOLDER'))
							{
						    	var SelectedElements 												= fileBrowserCountSelected(FileListContainer);
					    		if (SelectedElements[0]>0) {client_state_element.value = "0050";} else {client_state_element.value = "0000";}
								var files_drop_point_result 					= confirm("fs spostare qui i file?");
							}  else
							{
						    	var SelectedElements 												= fileBrowserCountSelected(FileListContainer);
					    		if (SelectedElements[0]>0) {client_state_element.value = "0050";} else {client_state_element.value = "0000";}
								alert("fs Destinazione non consentita.");
							}
						} else
						if (ElementEventOrigin=='FSFileBean_frame')
						{
							var FSfile_FOLDER_FILE_SWITCH 						= document.getElementById(Reference_FSFileBean_element.id+"FSFileBody|FSfile_FOLDER_FILE_SWITCH|").value;
							var is_folder_selected 								= document.getElementById(Reference_FSFileBean_element.id+"selected|").value;
							if (((is_folder_selected=='N')||(is_folder_selected=='null'))&&(FSfile_FOLDER_FILE_SWITCH=='FOLDER'))
							{
						    	var SelectedElements 												= fileBrowserCountSelected(FileListContainer);
					    		if (SelectedElements[0]>0) {client_state_element.value = "0050";} else {client_state_element.value = "0000";}
								var files_drop_point_result 					= confirm("fs spostare qui i file?");
							} else
							{
						    	var SelectedElements 												= fileBrowserCountSelected(FileListContainer);
					    		if (SelectedElements[0]>0) {client_state_element.value = "0050";} else {client_state_element.value = "0000";}
								alert("fs Destinazione non consentita.");
							}
							
						}
			}
		} else
		if (client_state_element_value=="0065")	
		{//"0065" Mouse Up 
			if (Reference_FSFileBean_element!=null)
			{
		    	$(".selector_div").css("display","none");
				var SelectedElements 											= fileBrowserCountSelected(FileListContainer);
				if (ElementEventOrigin=='Page_external')
				{
							
				} else 
				if (ElementEventOrigin=='TD_external')						
				{//Switch now
						var  	selected_el 									= document.getElementById(Reference_FSFileBean_element.id+"selected|");
						var  	selected_el_val									= selected_el.value;
						var  	selected_previuos_el 							= document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|");
						var  	selected_previuos_el_value 						= selected_el.value;
				} else 
				if (ElementEventOrigin=='FSFileBean_frame')						
				{//Switch now
						var  	selected_el 									= document.getElementById(Reference_FSFileBean_element.id+"selected|");
						var  	selected_el_val									= selected_el.value;
						var  	selected_previuos_el 							= document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|");
						var  	selected_previuos_el_value 						= selected_el.value;
				} else
				if (ElementEventOrigin=='FSFileBean_body')						
				{//Switch now
						var  	selected_el 									= document.getElementById(Reference_FSFileBean_element.id+"selected|");
						var  	selected_el_val									= selected_el.value;
						var  	selected_previuos_el 							= document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|");
						var  	selected_previuos_el_value 						= selected_el.value;
								
								fileBrowserResetState(FileListContainer);
								if (selected_el_val=="Y") 
								{selected_el.value="Y";selected_previuos_el.value="Y";}
				}
		    	var SelectedElements 												= fileBrowserCountSelected(FileListContainer);
		    		if (SelectedElements[0]>0) {client_state_element.value = "0050";} else {client_state_element.value = "0000";}
			} else
			{
				
			}
		}	else
		if (client_state_element_value=="0062")	
		{//"0062" Mouse Up 
			var SelectedElements 												= fileBrowserCountSelected(FileListContainer);
			var MyDivs 															= $(".selector_div");
			//for(var i = 0; i<MyDivs.length;++i)
				//{
				//MyDivs[i].style.display = 'none';
				//MyDivs[i].style.backgroundColor = "red";
				//alert('MyDivs[i].id : '+MyDivs[i].id);
			      //}
			
			
			//var ResourceConainerList 											= $(FileListContainer).find(".ComponentsCustom-FSFileBean");
		    //for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
		    	//{
		    	
		    	//var MyFSBean_selection_element 									= document.getElementById(ResourceConainerList[vvi].id+"selected|");
		    	//if (MyFSBean_selection_element.value.indexOf("N")>-1)
		    		//{
		    		//MyFSBean_selection_element.value 			    			= "N";
		    		//			    	//ResourceConainerList[vvi].style.backgroundColor 			= "lightgrey";

		    		//}
		    	//else
		    		//{
		    		//	MyFSBean_selection_element.value 							= "Y";
			    	//ResourceConainerList[vvi].style.backgroundColor 			= "lime";

		    		//}
		    	//		    }

		    if (SelectedElements[0]==0)
		    {
		    	
		    	$(".selector_div").css("display","none");
				client_state_element.value											= "0000";		    	
		    } else
		    if (SelectedElements[0]>0)
		    {
		    	$(".selector_div").css("display","none");
				client_state_element.value											= "0050";		    	
		    }
		} else
		if (client_state_element_value=="0061")
		{//"0061" Mouse Up 
			if (eventIn.ctrlKey)
			{//Mouse UP when selecting elements....
				if (ElementEventOrigin=='Page_external')
				{
							
				} else 
				if (ElementEventOrigin=='FSFileBean_body')
				{// Selection. Mouse UP inside FSFileBean
				 //alter Selection State of the element	
					//$(Reference_TD_element).find(".ComponentsCustom-FSFileBean");
					
					if (Reference_FSFileBean_element!=null)
					{
						var  	selected_el 									= document.getElementById(Reference_FSFileBean_element.id+"selected|");
						var  	selected_el_value 								= selected_el.value;
						

						var  	selected_previuos_el 							= document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|");
						var  	selected_previuos_el_value 						= selected_el.value;
						//alert("sel el val:"+selected_el_value);
								if (selected_el_value == "Y" )
								{
									selected_el.value = "N";
								} else //?
								if (selected_el_value == "N" ) 
								{
									selected_el.value = "Y";
								} else //?
								if (selected_el_value == "YTEMP" ) 
								{
									selected_el.value = "Y";
									selected_previuos_el.value = "Y";
								} else 
								if (selected_el_value == "NTEMP" ) 
								{
									selected_el.value = "N";
									selected_previuos_el.value = "N";
								}
					}
				}
				
				if (ElementEventOrigin=='FSFileBean_frame')
				{// Selection. Mouse UP inside FSFileBean
				 //alter Selection State of the element	
					//$(Reference_TD_element).find(".ComponentsCustom-FSFileBean");
					
					if (Reference_FSFileBean_element!=null)
					{
						var  	selected_el 									= document.getElementById(Reference_FSFileBean_element.id+"selected|");
						var  	selected_el_value 								= selected_el.value;
						var  	selected_previuos_el 							= document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|");
						var  	selected_previuos_el_value 						= selected_el.value;
						//alert("sel el val:"+selected_el_value);
								if (selected_el_value == "Y" )
								{
									selected_el.value = "N";
								} else //?
								if (selected_el_value == "N" ) 
								{
									selected_el.value = "Y";
								} else //?
								if (selected_el_value == "YTEMP" ) 
								{
									selected_el.value = "Y";
									selected_previuos_el.value = "Y";
								} else 
								if (selected_el_value == "NTEMP" ) 
								{
									selected_el.value = "N";
									selected_previuos_el.value = "N";
								}
					}
				}
				
				
		    	var SelectedElements 												= fileBrowserCountSelected(FileListContainer);
		    	//alert('SelectedElements:');
		    		if (SelectedElements[0]>0) {client_state_element.value = "0050";} else {client_state_element.value = "0000";}
			}	else
			{
				if (Reference_FSFileBean_element!=null)
				{					
					$(".selector_div").css("display","none");
					if (ElementEventOrigin=='Page_external')
					{
							
					} else 
					if (ElementEventOrigin=='TD_external')						
					{//Switch now
						
						
						var  	selected_el 									= document.getElementById(Reference_FSFileBean_element.id+"selected|");
						var  	selected_el_val									= selected_el.value;
						var  	selected_previuos_el 							= document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|");
						var  	selected_previuos_el_value 						= selected_el.value;
								
								fileBrowserResetState(FileListContainer);
								if (selected_el_val=="YTEMP") 
								{
									selected_el.value="Y";
									selected_previuos_el.value="Y";
								}						
					} else 
					if (ElementEventOrigin=='FSFileBean_frame')						
					{//Switch now
							var  	selected_el 									= document.getElementById(Reference_FSFileBean_element.id+"selected|");
							var  	selected_el_val									= selected_el.value;
							var  	selected_previuos_el 							= document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|");
							var  	selected_previuos_el_value 						= selected_el.value;
									
									fileBrowserResetState(FileListContainer);
									if (selected_el_val=="YTEMP") {selected_el.value="Y";selected_previuos_el.value="Y";}
					} else
					if (ElementEventOrigin=='FSFileBean_body')						
					{//Switch now
							var  	selected_el 									= document.getElementById(Reference_FSFileBean_element.id+"selected|");
							var  	selected_el_val									= selected_el.value;
							var  	selected_previuos_el 							= document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|");
							var  	selected_previuos_el_value 						= selected_el.value;
									
									fileBrowserResetState(FileListContainer);
									if (selected_el_val=="Y") 
									{selected_el.value="Y";selected_previuos_el.value="Y";}
					}
					
			    	var SelectedElements 												= fileBrowserCountSelected(FileListContainer);
					if (SelectedElements[0]==0){client_state_element.value = "0000";}else{client_state_element.value = "0050";}							
				} else
				{
					fileBrowserResetState(FileListContainer);
					client_state_element.value = "0000";							
				}
				
			}
		} else
		if (client_state_element_value=="0060")
		{//"0060" Mouse Up
			if (eventIn.ctrlKey)
			{//Mouse UP when selecting elements....
						var  	selected_el 									= document.getElementById(Reference_FSFileBean_element.id+"selected|");
						var  	selected_el_value 								= selected_el.value;
								if (selected_el_value == "N" ){selected_el.value = "Y";} else if (selected_el_value == "Y" ) {selected_el.value="N";}
			} else
			{
				
			}
		}	else
		if (client_state_element_value=="0050")
		{//"0050" Mouse Up
			if (eventIn.ctrlKey)
			{//Mouse UP when selecting elements....
				
			} else
			{
					if (ElementEventOrigin=='Page_external')						
					{
					} else
					{
						client_state_element.value = "0061";
					}
			}
		}	else
		if (client_state_element_value=="0000")	
		{//"0000" Mouse Up 
								StateOut										= "SENDDATA";
								client_state_element.value						= "0000";
		} 

		/*
		else
		{
			if (client_state_element.value=="0061")
			{
				//alert("dddddssss");
				
			    if (OwnerOBJIn_owner_family=='ComponentsBasic-TDElement')
			    {
			    	client_state_element.value									= "0050";

			    	
				    var ResourceConainerList 									= $(FileListContainer).find(".ComponentsCustom-FSFileBean");
				    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
				    {

				    
				    	var MyFSBean_selection_element 							= document.getElementById(ResourceConainerList[vvi].id+"selected|");
				    	if (MyFSBean_selection_element.value == "GY") 
				    	{
				    		//MyFSBean_selection_element.value="Y";
				    	//ResourceConainerList[vvi].style.backgroundColor = "lime";
				    	}
				    	if (MyFSBean_selection_element.value == "G")  {
				    	//MyFSBean_selection_element.value="Y";
				    	//ResourceConainerList[vvi].style.backgroundColor = "lime";
				    	}
				    	//if (MyFSBean_selection_element.value == "Y")  {                                     ResourceConainerList[vvi].style.backgroundColor = "lime";}
				    	//if (MyFSBean_selection_element.value == "N")  {                                     ResourceConainerList[vvi].style.backgroundColor = "lightgrey";}

				    }

			    	
			    	/////
			    	
			    }
			}
		
			if ((client_state_element.value=="0050")	||(client_state_element.value=="0051")||(client_state_element.value=="0052"))
			{
						//client_state_element.value = "0000";
						//var element_State						= document.getElementById(BaseId+'state|');
							//element_State.value 				= "0000";
						//$(element_State).remove();
						
						//var element_Lefttop_corner				= document.getElementById(BaseId+'lefttop_corner|');
						//element_Lefttop_corner.style.display='none';
						//$(element_Lefttop_corner).remove();
					
						//var element_selector_div				= document.getElementById(BaseId+'selector_div|');
						//element_selector_div.style.display='none';
					
						//alert('mmm');
				
		    		    //alert('Reference_FSFileBean_element.id:'+Reference_FSFileBean_element.id+'   ... UP 1 prev : '+document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value);
	
						var MyDivs = $(".selector_div");
						for(var i =0; i<MyDivs.length;++i)
						{
							MyDivs[i].style.display = 'none';
							//alert('MyDivs[i].id : '+MyDivs[i].id);
						}
						var MyDivs = $(".dragging_div");
						for(var i =0; i<MyDivs.length;++i)
						{
							MyDivs[i].style.display = 'none';
							//alert('MyDivs[i].id : '+MyDivs[i].id);
						}
						
	//					if (document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value == "Y-CRTL")
	//					{
	//						
	//						/////////
	//						
	//						
	//					}
					    if (OwnerOBJIn_owner_family=='FSFileBean_body')
					    {
					    	if (client_state_element.value!="0052")
					    	{
									
					    						client_state_element.value = "0050";
						
										    	//alert('UP 1 prev : '+document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value);
												if (document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value == "Y-NOCRTL")
												{
											    	//alert('UP 2');
						
													///////
						//							var selected_array 				= $(FileListContainer).find("input[name='selected']");
						//							if (selected_array.length>0) {for(var ff=0;ff<selected_array.length;++ff){selected_array[ff].value='N';}}
							
												    var ResourceConainerList 		= $(FileListContainer).find(".ComponentsCustom-FSFileBean");
												    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
												    {
												    	//ResourceConainerList[vvi].style.backgroundColor = "lightgrey";
												    	var MyFSBean_selection_element 					= document.getElementById(ResourceConainerList[vvi].id+"selected|");
												    		//MyFSBean_selection_element.value 			= "N";
												    }
												    document.getElementById(Reference_FSFileBean_element.id+"selected|").value 	= "Y";
												//    Reference_FSFileBean_element.style.backgroundColor 							= "lime";
												}
					    	}
						    if (client_state_element.value=="0052")
						    {
						    	//drop on folder or on file?
								var FSfile_FOLDER_FILE_SWITCH 											= document.getElementById(Reference_FSFileBean_element.id+"FSFileBody|FSfile_FOLDER_FILE_SWITCH|").value;
								var is_folder_selected 													= document.getElementById(Reference_FSFileBean_element.id+"selected|").value;
								
								//alert("FSfile_FOLDER_FILE_SWITCH:"+FSfile_FOLDER_FILE_SWITCH+ "   is_folder_selected : "+is_folder_selected);
								if ((FSfile_FOLDER_FILE_SWITCH=='FOLDER')&&(is_folder_selected=='N'))
								{
									client_state_element.value											= "0050";
									var files_drop_point_result 										= confirm("spostare qui i file?");
								}
								else
								{
									client_state_element.value="0050";

									alert("Destinazione non consentita.");
								}

 
						    }
					    }
					    
					    if (OwnerOBJIn_owner_family=='ComponentsBasic-ListTreeMenuElement')
					    {
						    if (client_state_element.value == "0052")
						    {
						    		client_state_element.value 	= "0000";
								var files_drop_point_result 	= confirm("spostare qui i file?");

								
						    }
					    }
					    if (OwnerOBJIn_owner_family=='ComponentsBasic-TDElement')
					    {
					    	console_log("kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk");
						    if (client_state_element.value == "0052")
						    {
									    	client_state_element.value = "0050";
									    	if (Reference_FSFileBean_element!= null)
									    	{
				
												var FSfile_FOLDER_FILE_SWITCH 					= document.getElementById(Reference_FSFileBean_element.id+"FSFileBody|FSfile_FOLDER_FILE_SWITCH|").value;
												var is_folder_selected 							= document.getElementById(Reference_FSFileBean_element.id+"selected|").value;
												
												//alert("FSfile_FOLDER_FILE_SWITCH:"+FSfile_FOLDER_FILE_SWITCH+ "   is_folder_selected : "+is_folder_selected);
												if ((FSfile_FOLDER_FILE_SWITCH=='FOLDER')&&(is_folder_selected=='N'))
												{
													client_state_element.value					= "0050";
													var files_drop_point_result = confirm("spostare qui i file?");
												}
												else
												{
													client_state_element.value					= "0050";
				
													alert("Destinazione non consentita.");
												}
									    	}
						    	
						    }
						    else
						    {//not 0052
							    if (client_state_element.value != "0052")
							    {
							    	console_log("******************************************eeeee******");
							    		
							    	if ((Reference_FSFileBean_element===undefined )||(Reference_FSFileBean_element==null))
							    	{
							    		client_state_element.value = "0000";
									    var 	ResourceConainerList 							= $(FileListContainer).find(".ComponentsCustom-FSFileBean");
									    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
									    {
									    	//ResourceConainerList[vvi].style.backgroundColor 	= "lightgrey";
									    var 	MyFSBean_selection_element 						= document.getElementById(ResourceConainerList[vvi].id+"selected|");
									    		//MyFSBean_selection_element.value 				= "N";
									    }
							    			
							    	}
							    	else
							    	{
							    		client_state_element.value 								= "0050";
				
										if (document.getElementById(Reference_FSFileBean_element.id+"selected_previuos|").value == "Y-NOCRTL")
										{
										    var 	ResourceConainerList 						= $(FileListContainer).find(".ComponentsCustom-FSFileBean");
										    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
										    {
										    	//ResourceConainerList[vvi].style.backgroundColor = "lightgrey";
										    var 	MyFSBean_selection_element 					= document.getElementById(ResourceConainerList[vvi].id+"selected|");
										    		//MyFSBean_selection_element.value 			= "N";
										    }
										    document.getElementById(Reference_FSFileBean_element.id+"selected|").value 	= "Y";
										    //Reference_FSFileBean_element.style.backgroundColor 							= "lime";
				
										}
							    	}
								}						    	
						    }								    
					    }
					    //////////////////////////////////////////////
					    ////////////////////////////////////////////
					    
					    
					    
			}
		}*/
		
	}// END - Function Call UP

	fileBrowserDrawState(FileListContainer);

	return StateOut;
}

function fileBrowserFileSelectionReset()
{
    var ResourceConainerList 		= $(".ComponentsCustom-FSFileBean");
	    //alert('found : '+ResourceConainerList.length);
	    //$('#debuggeroutput_content').html("found   :"+ResourceConainerList.length);
	    for(var vvi=0;vvi<ResourceConainerList.length;++vvi)
	    {
	    		ResourceConainerList[vvi].style.backgroundColor = "lightgrey";
	    		document.getElementById(ResourceConainerList[vvi].id+"selected|").value="N";
	    }
}

function FileBrowserEnhancedMoveSelection(elementIn,FunctionCallIn,parameter_1,parameter_2,parameter_3)
{
	if (elementIn!=null)
	{
		if (FunctionCallIn=='cccmoving_start')
		{
					var FileBrowserEnhanced_element =  $(elementIn).parents(".filebrowserenhancedcontainer");
					var FileBrowserEnhanced_zIndex  = FileBrowserEnhanced_element[0].style.zIndex;
					
					var movement_dock   					= document.createElement("div");
						movement_dock.style.position    	= 'absolute';
						movement_dock.id 					= FileBrowserEnhanced_element[0].id + "movement_dock|";
						movement_dock.className             = "FileBrowserEnhanced_moving_layer";
						movement_dock.style.border			= '3px solid red';
						movement_dock.style.top         	= '0px';
						movement_dock.style.left        	= '0px';
						movement_dock.style.width			= '200px';
						movement_dock.style.height			= '100px';
						//movement_dock.style.right       	= '0px';
						//movement_dock.style.bottom      	= '0px';
						movement_dock.style.opacity			= '0.4';
						movement_dock.style.backgroundColor = 'yellow';
						
						//movement_dock.innerHTML = "<div class ='FileBrowserEnhanced_moving_layer' id = '"+FileBrowserEnhanced_element[0].id + "moving_layer|' style='position:absolute;height:500px;width:500px;border:2px solid red;'> Moving Content!</div>";
						
					FileBrowserEnhanced_element[0].appendChild(movement_dock);
		}
		if (FunctionCallIn=='cccmoving_go')
		{
			var moving_layer_element 				= $(".FileBrowserEnhanced_moving_layer")[0];
				//console_log("moving_layer_element #"+moving_layer_element.length+"  moving_layer_element[0]:"+moving_layer_element[0]);
			var movement_dock_left 					= moving_layer_element.parentNode.getBoundingClientRect().left;
			var movement_dock_top    				= moving_layer_element.parentNode.getBoundingClientRect().top;
				moving_layer_element.style.left    	= parseInt(MouseClientPosX-movement_dock_left+8)+"px";
				moving_layer_element.style.top    	= parseInt(MouseClientPosY-movement_dock_top+8) +"px";
				moving_layer_element.style.border 	= '5px solid blue';
			
			//$("#debuggeroutput_content").html("\n moving_layer_element id : "+moving_layer_element.id+"\nUUUUUUUUUUUUU\n MousePosX:"+parseInt(MouseClientPosX-movement_dock_left)+" \n MousePosY:"+parseInt(MouseClientPosY-movement_dock_top));
			//$("#debuggeroutput_content").html(">>>>>>>>>MousePosX:"+MouseClientPosX+" \n MousePosY: "+MouseClientPosY +" \n movement_dock_left : "+movement_dock_left+"\n movement_dock_top : "+movement_dock_top);
		}
		if (FunctionCallIn=='cccmoving_abort')
		{
			var moving_layer_element 			= $(".FileBrowserEnhanced_moving_layer")[0];
			//alert("aborting....");
			$(moving_layer_element).remove();
		}
					
					//alert("main container..... "+FileBrowserEnhanced_element[0].id+" zIndex : "+FileBrowserEnhanced_zIndex);
	}
}

function getFileBrowserEnhancesInfo(InfoCode)
{
										if (isValidElement($(".filebrowserenhancedcontainer")[0]))
										{
										var filebrowserenhancedcontainer_element = $(".filebrowserenhancedcontainer")[0];
										var filebrowserenhancedcontainer_id 	 = filebrowserenhancedcontainer_element.id ;
											if (InfoCode=='fsbean_core_selected')
											{
											var fsbean_core_selected_id 		=  filebrowserenhancedcontainer_id+"fsbean_core_selected|";
											var fsbean_core_selected 			=  document.getElementById(fsbean_core_selected_id);
												return fsbean_core_selected.value;
											}
											if (InfoCode=='client_state')
											{
											var fsbean_core_selected_id 		=  filebrowserenhancedcontainer_id+"client_state|";
											var fsbean_core_selected 			=  document.getElementById(fsbean_core_selected_id);
												return fsbean_core_selected.value;
											}
										}
}

function setFileBrowserEnhancesInfo(InfoCode,InfoValue)
{
									var filebrowserenhancedcontainer_element 																= $(".filebrowserenhancedcontainer")[0];
									var filebrowserenhancedcontainer_id 	 																= filebrowserenhancedcontainer_element.id ;
										if (InfoCode=='fsbean_core_selected')
										{
										var fsbean_core_selected_id 																		= filebrowserenhancedcontainer_id+"fsbean_core_selected|";
										var fsbean_core_selected 																			= document.getElementById(fsbean_core_selected_id);
											fsbean_core_selected.value																		= InfoValue;
										}
										if (InfoCode=='client_state')
										{
										var fsbean_core_selected_id 																		= filebrowserenhancedcontainer_id+"client_state|";
										var fsbean_core_selected 																			= document.getElementById(fsbean_core_selected_id);
											fsbean_core_selected.value																		= InfoValue;
										}
}
////////////END - FILEBROWSER ENHANCED

function TimerListTreeMenuElementExpand(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn,ScopeIn)
{	
	//Attention......!!!!!
	//item_select should be removed from ListTreeMenuElement. Is stille largly used ......selected| hidden id element to track selection status
	var TimerListTreeMenuElementExpand_position 				= getTimerPositionByHandler('TimerListTreeMenuElementExpand');
	//alert('TimerListTreeMenuElementExpand_position : '+TimerListTreeMenuElementExpand_position);
	//$("#debuggeroutput_content").html(" TimerListTreeMenuElementExpand_position : "+TimerListTreeMenuElementExpand_position);
	if (TimerListTreeMenuElementExpand_position>-1)
	{
		arrayTimers[TimerListTreeMenuElementExpand_position].Step = arrayTimers[TimerListTreeMenuElementExpand_position].Step+1;
		if (arrayTimers[TimerListTreeMenuElementExpand_position].Step <3)
		{
			removeTimerByArrayPosition(TimerListTreeMenuElementExpand_position);
			//var sending_element_id 	= elementIn.id.replace("item_select","open_close_folder_switch");
		var sending_element_id 			= elementIn.id.replace("item_select","CollapseExpandCommand");
			
			//alert("expanding......node "+IdentifierIn+"elementIn.id : "+elementIn.id);
		var sending_element 			= document.getElementById(sending_element_id);
			//alert("sending_element id : "+sending_element.id);
			//FileBrowserEnhancedMoveSelection(elementIn,'moving_abort',null,null,null);
			
		var expanding_status_element_id =  elementIn.id.replace("item_select","switch_exp_col");
		var expanding_status_element	=  document.getElementById(expanding_status_element_id);
			if (expanding_status_element.value == 'false')
			{
				sendData(IdentifierIn,sending_element,SWTypeIn);
			}
		}
	}
}

/*function manageEnhancedInput(IdentifierIn)
{
	var Input_OBJ_el 				= document.getElementById(IdentifierIn); 
	var Input_DataIn_el 			= document.getElementById(IdentifierIn+"DataIn|"); 
	var Input_OriginalContent_el 	= document.getElementById(IdentifierIn+"OriginalContent|"); 
	var Input_IsModified_el 		= document.getElementById(IdentifierIn+"IsModified|"); 
		$(Input_OBJ_el).removeClass('originalcontent');
		$(Input_OBJ_el).removeClass('modifiedcontent');
		if (Input_DataIn_el.value==Input_OriginalContent_el.value)
		{
			Input_IsModified_el.value='N';
			$(Input_OBJ_el).addClass('originalcontent');
			//Input_DataIn_el.style.backgroundColor= 'lightgreen';
		} else
		{
			Input_IsModified_el.value='Y';		
			$(Input_OBJ_el).addClass('modifiedcontent');
			//Input_DataIn_el.style.backgroundColor= 'red';
		}
}
*/
/*function manageEnhancedTextarea(IdentifierIn)
{
	var 												Textarea_OBJ_el 																	= document.getElementById(IdentifierIn); 
	var 												Textarea_DataIn_el 																	= document.getElementById(IdentifierIn+"DataIn|"); 
	var 												Textarea_OriginalContent_el 														= document.getElementById(IdentifierIn+"OriginalContent|"); 
	var 												Textarea_IsModified_el 																= document.getElementById(IdentifierIn+"IsModified|"); 
														$(Textarea_OBJ_el).removeClass('originalcontent');
														$(Textarea_OBJ_el).removeClass('modifiedcontent');
														if (Textarea_DataIn_el.value==Textarea_OriginalContent_el.value)
														{
															Textarea_IsModified_el.value	= 'N';
															$(Textarea_OBJ_el).addClass('originalcontent');
															//Input_DataIn_el.style.backgroundColor= 'lightgreen';
														} else
														{
															Textarea_IsModified_el.value	= 'Y';		
															$(Textarea_OBJ_el).addClass('modifiedcontent');
															//Input_DataIn_el.style.backgroundColor= 'red';
														}
}
*/
function initMap( idin) 
{
		if (isValidElement(idin)&&(idin=='')) {console_log('idin:'+idin);}
		//alert('idin:'+idin);  
		//var myLatLng = {lat: -25.363, lng: 131.044};
	var map = new google.maps.Map
	  	(
			  document.getElementById('zzzzz'), 
			  {
			    center: {lat: -34.397, lng: 150.644},
			    zoom: 1
			  }
		);
		/*
	    var marker = new google.maps.Marker({
	        position: myLatLng,
	        map: map,
	        title: 'Hello World!'
	      });*/
	    
	
	  	MapFillParent('zzzzz');
		addMarker(map);
	
	  	//alert('map type:'+getObjectType(map));
	  	//if (MapsList==null)
	  	//{  alert(' map list null');
	  	//	MapsList = new GenericObjectsList(getObjectType(map));
	  	//	MapsList.addElement('zzzzz',map,false);
	  	//}
	  	//addMarker(MapsList.getElementByIdentifier('zzzzz'));
	
	  	//alert('MapsList el:'+MapsList.getElementByIdentifier('zzzzz'));
}

function findMapInList(IdentifierIn)
{
	var MapOut = null;
		if(MapsList)
		{
			MapOut = MapsList.getElementByIdentifier(IdentifierIn); 
		}
		return MapOut;
		//= new GenericObjectsList(getObjectType(map));
}

function addMapToList(IdentifierIn,mapIn,forceIn)
{
		if(MapsList)
		{
			
		} else
		{
			MapsList = new GenericObjectsList(getObjectType(mapIn));
		}
		MapsList.addElement(IdentifierIn,mapIn,forceIn);
}

function MapFillParent(MapIdIn)
{
	//alert("map : "+MapIdIn);
	var MapElement = document.getElementById(MapIdIn);
					fill_parent(MapElement);
}

function findMarkerInList(IdentifierIn)
{
	var MarkerOut = null;
		if(MarkersList)
		{
			MarkerOut = MarkersList.getElementByIdentifier(IdentifierIn); 
		}
		return MarkerOut;
		//= new GenericObjectsList(getObjectType(map));
}

function addMarkerToList(IdentifierIn,MarkerIn,forceIn)
{
		//console_log("adding_marker:"+MarkerIn);
		if(MarkersList)
		{
			
		} else
		{
			MarkersList = new GenericObjectsList(getObjectType(MarkerIn));
		}	
		MarkersList.addElement(IdentifierIn,MarkerIn,forceIn);
}

function MapFillParent(MapIdIn)
{
	//alert("map : "+MapIdIn);
	var MapElement = document.getElementById(MapIdIn);
					fill_parent(MapElement);
}

function addMarker(MapIdIn,MarkerIdIn,LatIn,LngIn,TitleIn,IconIn)
{
	//var MyMap 		= new google.maps.Map(document.getElementById("zzzzz"), myOptions);
	//var MapElement 	= document.getElementById(MapIdIn);
	
	var MapElement 		= findMapInList(MapIdIn);
	var myLatLng 		= {lat: LatIn, lng: LngIn};
	 /*
	var marker = new google.maps.Marker
	(
			{
				map: MapElement,
				position: myLatLng
			}
	);*/
		//console_log(" adding marker......MarkerIdIn:"+MarkerIdIn+"     MapIdIn:"+MapIdIn);
	
	var found_marker 	= 	findMarkerInList(MapIdIn+"_MARKER_"+MarkerIdIn);
	// if a markes exists, overwrite it.
		if (found_marker!=null)
		{
			found_marker.setMap(null);
			MarkersList.removeElementByIdentifier(MapIdIn+"_MARKER_"+MarkerIdIn);
		}
	var marker 			= new google.maps.Marker(
			{
				position	: myLatLng,
				map			: MapElement,
				title		: TitleIn,
				customInfo	: MarkerIdIn,
				icon		: IconIn,
				mapid		: MapIdIn
			}
		);
	//console_log("  >>>>>>>>>>> "+marker.mapid);
//	if (IconIn.length>2)
//	{
//		marker 			= new google.maps.Marker(
//				{
//					position	: myLatLng,
//					map			: MapElement,
//					title		: TitleIn,
//					custominfo	: MarkerIdIn,
//					icon		: IconIn
//				}
//			);
//		
//	} else
//	{
//		marker 		= new google.maps.Marker(
//												{
//													position: myLatLng,
//													map		: MapElement,
//													title	: TitleIn,
//													custominfo:MarkerIdIn
//												}
//											);
//	}
		addMarkerToList(MapIdIn+"_MARKER_"+MarkerIdIn,marker,false);
}

function manageCHKEDITOR(element_id,container_element_id)
{
	var MyCHKEDITOR = CKEDITOR.instances[element_id];
	var container_element = document.getElementById(container_element_id);
	var container_element_width =  $(container_element).width();
	var container_element_height =  $(container_element).height();
		//alert("element id:"+element_id+" container_element_height:"+container_element_height+"  container_element_width:"+container_element_width);
		MyCHKEDITOR.resize(container_element_width,container_element_height);
}

function searchModuleNew(eventIn,SearchModule_id)
{
		//alert('searchModuleNew ....'+SearchModule_id+'     nmknmk:'+(SearchModule_id+"HTMLFieldSearchers|second_table|"));
	var SearchModule_el 	= document.getElementById(SearchModule_id+"HTMLFieldSearchers|second_table|");
	var InputFindContentEls = $(SearchModule_el).find("input");
		//alert("InputFindContentEls size: "+InputFindContentEls.length);
		if (InputFindContentEls.length>0 )
		{
			//console.log("InputFindContentEls size: "+InputFindContentEls.length);
			for(var hn=0;hn<InputFindContentEls.length;++hn)
			{
				//console.log("checking input id:"+InputFindContentEls[hn].id);
				if (InputFindContentEls[hn].getAttribute("name"))				
				{
				var CurrInputName = InputFindContentEls[hn].getAttribute("name");
					if (CurrInputName.indexOf('findL')>-1)
					{
						$(InputFindContentEls[hn]).val('');
					}
					if (CurrInputName.indexOf('findH')>-1)
					{
						$(InputFindContentEls[hn]).val('');
					}
				}
			}
		} else
		{
			console.log(" searchModuleNew error, not enougth input tags");
		}	
		//	alert("--->"+SearchModule_el.id);
}

const autoNumericOptions_integer = 
{
		decimalPlaces: 0,
		digitGroupSeparator        : '',
		mDec: '0'
};

const autoNumericOptionsEuro_b = 
{
		digitGroupSeparator        : '.',
		decimalCharacter           : ',',
		//decimalCharacterAlternative: '.',
		//currencySymbol             : '\u202f€',
		decimalPlaces: 2//,
		
		//currencySymbolPlacement    : AutoNumeric.options.currencySymbolPlacement.suffix,
		//roundingMethod             : AutoNumeric.options.roundingMethod.halfUpSymmetric
};

const autoNumericOptionsEuro_c = 
{
		digitGroupSeparator        : '.',
		decimalCharacter           : ',',
		//decimalCharacterAlternative: '.',
		//currencySymbol             : '\u202f€',
		decimalPlaces: 2,//,
		allowDecimalPadding:true
		
		//currencySymbolPlacement    : AutoNumeric.options.currencySymbolPlacement.suffix,
		//roundingMethod             : AutoNumeric.options.roundingMethod.halfUpSymmetric
};

const autoNumericOptionsEuro_d = 
{
		digitGroupSeparator        : '.',
		decimalCharacter           : ',',
		decimalCharacterAlternative: '.',
		//currencySymbol             : '\u202f€',
		decimalPlaces: 2,//,
		decimalPlacesOverride: 2, 
		
		allowDecimalPadding:true,
		decimalPlacesShownOnFocus:2,
		decimalPlacesShownOnBlur:2,
		decimalPlacesShownOnFocus:2,
		alwaysAllowDecimalCharacter:true
		
		//currencySymbolPlacement    : AutoNumeric.options.currencySymbolPlacement.suffix,
		//roundingMethod             : AutoNumeric.options.roundingMethod.halfUpSymmetric
};

function manageTimeFields(SWIdentifierIn)
{
	var 								SW_el 																								= document.getElementById(SWIdentifierIn);
	var 								time_inline_mask_els  																				= jQuery(SW_el).find(".time_inline_mask");
	//alert("found:"+currency_cell_els.length);
	//currency_cell_els
										if (time_inline_mask_els.length>0)
										{
	var 								im 																									= new Inputmask( { alias: "datetime", inputFormat: "HH:MM"});
											for(var m=0;m<time_inline_mask_els.length;++m)
											{
												im.mask(time_inline_mask_els[m]);
											}
										}
}

function manageCurrencyFields(SWIdentifierIn)
{
		dynamicallyLoadLibrary(ContextPath+'/js/inputmask/dist/inputmask.js');
	var SW_el 						= document.getElementById(SWIdentifierIn);
	var currency_cell_els  			= jQuery(SW_el).find(".currency_cell");
		//alert("found:"+currency_cell_els.length);
		//currency_cell_els
		for(var m=0;m<currency_cell_els.length;++m)
		{
			var current_el 				= currency_cell_els[m];
				//jQuery(current_el).val("kkk");
			var current_el_value_ori 	= jQuery(current_el).attr("value_ori");
				current_el.value 		= AutoNumeric.format(current_el_value_ori,  autoNumericOptionsEuro_b );
	
		}
	
//	new AutoNumeric('.currency_cell.currency_modify', {
	//	    currencySymbol : ' €',
	//	    decimalCharacter : ',',
	//    digitGroupSeparator : '.',
	//	});

	var currency_cell_els  			= jQuery(SW_el).find(".currency_cell.currency_modify");
		for(var m=0;m<currency_cell_els.length;++m)
		{
			//alert("element id:"+currency_cell_els[m].id);
			var current_el = currency_cell_els[m];
			new AutoNumeric(current_el, {
						altDec: '.',
					    //currencySymbol : ' €',
					    decimalCharacter : ',',
				    digitGroupSeparator : '.',
					});
		}	
}

function BasiCControlInputCurrencyControlKeyup(elementIn,SWIdIn)
{
	var 								SourceElementId 	= SWIdIn+"Data|";
	var 								SourceElement 		= document.getElementById(SourceElementId);
										console_log(" >>>>>>> "+SourceElement.id);
	var 								TargetElementId 	= SWIdIn+"DataUnformattedRetrieve|";
	var 								TargetElement 		= document.getElementById(TargetElementId);
	
	var 								anElement 			= AutoNumeric.getAutoNumericElement(SourceElement);
										TargetElement.value = anElement.getNumericString();
										//console_log(" data unformatted:"+anElement.getNumericString());
}

function removeCKEditorFromList(IdentifierIn)
{
										if(CKEditorsList)
										{
											CKEditorsList.removeElementByIdentifier(IdentifierIn);
										}
}

function findCKEditorByTEId(IdentifierIn)
{
								var		out 							= null;
								var 	myTE							= document.getElementById(IdentifierIn);
										if(isValidElement(myTE))
										{
										var textarea_el =	jQuery(myTE).find('textarea')[0];
											if(isValidElement(textarea_el))
											{
												out = findCKEditorInList(textarea_el.id);
											}
										} 
										return out;
}

function findCKEditorInList(IdentifierIn)
{
	var 								CKEditorsListOut = null;
										if(CKEditorsList)
										{
											CKEditorsListOut = CKEditorsList.getElementByIdentifier(IdentifierIn); 
										} else
									    {
											//console_log(" No CKEditorsList found!!!");
										}
										return CKEditorsListOut;
										//= new GenericObjectsList(getObjectType(map));
}

function findCKEditorInListByTEId(IdentifierIn)
{
	var 								CKEditorsListOut = null;
										if(CKEditorsList)
										{
										var	id_aux = IdentifierIn+"EditArea|";
										var id = id_aux.replaceAll("|","_");
											CKEditorsListOut = CKEditorsList.getElementByIdentifier(id);
										} else
										{
											console_log(" No CKEditorsList found!!!");
										}
										return CKEditorsListOut;
										//= new GenericObjectsList(getObjectType(map));
}


function addCKEditorToList(IdentifierIn,ckeditorIn,forceIn)
{
										if(CKEditorsList)
										{
											//console_log(" ADDING CKEditor to list ....found list");
										}else
										{
											//console_log(" ADDING CKEditor to list ....generating and adding element");
											CKEditorsList = new GenericObjectsList(getObjectType(ckeditorIn));
										}
										CKEditorsList.addElement(IdentifierIn,ckeditorIn,forceIn);	
}

function getCKEditorSize()
{
										return CKEditorsList.getSize();
}

function setClientData(TE_idIn,ContentIn)
{
								var 	TE_el 																								= document.getElementById(TE_idIn);
										if (jQuery(TE_el).hasClass("ComponentsTagExtenders-EnhancedInput"))
										{
									var 	TE_datain_el 																					= document.getElementById(TE_idIn+"DataIn|");
											jQuery(TE_datain_el).val(ContentIn);
										}	
}

/*
	passing by
	after manageEnhancedInput() control goes to CaClient chain
 */
function EnhancedInputKeyup(evt)
{
								var my_TE																								= getTEOwner(evt.target);
								var my_SW																								= getSWOwner(evt.target);
									manageEnhancedInput(my_TE.id);

									CAclient(my_SW.id,evt.target,evt,'applicationModel.HTMLEnhancedTagExtension','!@@PPFEEDBACKACTION@@! !@@VVSENDDATA@@! ',false);
}

function manageEnhancedInput(IdentifierIn)
{
									if (isValidElement(document.getElementById(IdentifierIn)))
									{
		var								Input_OBJ_el																							= document.getElementById(IdentifierIn);
		var								Input_DataIn_el																							= document.getElementById(IdentifierIn+"DataIn|");
		var								Input_OriginalContent_el																				= document.getElementById(IdentifierIn+"OriginalContent|"); 
		var								Input_IsModified_el																						= document.getElementById(IdentifierIn+"IsModified|"); 
										$(Input_OBJ_el).removeClass('originalcontent');
										$(Input_OBJ_el).removeClass('modifiedcontent');
										if (Input_DataIn_el.value==Input_OriginalContent_el.value)
										{
											Input_IsModified_el.value='N';
											$(Input_OBJ_el).addClass('originalcontent');
											//Input_DataIn_el.style.backgroundColor= 'lightgreen';
										} else
										{
											Input_IsModified_el.value='Y';
											$(Input_OBJ_el).addClass('modifiedcontent');
											//Input_DataIn_el.style.backgroundColor= 'red';
										}
										/*
		var								Input_DataResetter_el																					= document.getElementById(IdentifierIn+"DataResetter|"); 
										if (isValidElement(Input_DataResetter_el))
										{
											jQuery(Input_DataResetter_el).css('background-image','none');
											//jQuery(Input_DataResetter_el).css('border','1px solid red');
											jQuery(Input_DataResetter_el).css('position','absolute');
											jQuery(Input_DataResetter_el).css('top','0');
											jQuery(Input_DataResetter_el).css('bottom','0');
											jQuery(Input_DataResetter_el).css('right','0');
											jQuery(Input_DataResetter_el).css('width','24px');
											if 
											(
												(!jQuery(Input_OBJ_el).hasClass('disabled'))
												&&
												(!jQuery(Input_OBJ_el).hasClass('readonly'))
											)
											{
												jQuery(Input_DataResetter_el).before("<i class='fa-solid fa-xmark' style='position:absolute;top:0;bottom:0;right:0;width:20px;color:red;font-size:28px;line-height:85%;'></i>");
											}
										}*/
									}
}

function manageEnhancedTextEditor(IdentifierIn,evtIn,maxLengthIn,editorIn)
{
	var													TE_el																				= document.getElementById(IdentifierIn);
														jQuery(TE_el).find(".ck.ck-word-count").find("div").css("background-color","transparent");
														if(maxLengthIn>1)
														{
															//jQuery(TE_el).find(".chk-wordraw-count").css("background-color","white");
															jQuery(TE_el).attr("chars_overbound","N");
															jQuery(TE_el).removeClass("chars_overbound");
															jQuery(TE_el).removeClass("chars_overbound_critical");
															if (editorIn.getData().length>maxLengthIn)
															{
																jQuery(TE_el).find(".chk-wordraw-count").css("background-color","red");
																jQuery(TE_el).attr("chars_overbound","Y");
																jQuery(TE_el).addClass("chars_overbound");
															} else
															if (editorIn.getData().length>maxLengthIn*0.9)
															{
																jQuery(TE_el).find(".chk-wordraw-count").css("background-color","orange");
																jQuery(TE_el).addClass("chars_overbound_critical");
															}
															
														var content_autofit								= jQuery(TE_el).attr("content_autofit");
															//jQuery(TE_el).css('border','1px solid red');
															
															if(content_autofit=='Y')
															{
															var docker_el 								= document.getElementById(TE_el.id+"docker|");	
															var ck_editor_block_el 						= jQuery(TE_el).find(".ck.ck-reset.ck-editor.ck-rounded-corners");
															var ck_editor__top_el 						= jQuery(TE_el).find(".ck.ck-editor__top.ck-reset_all");
															var ck_editor__main_el 						= jQuery(TE_el).find(".ck.ck-editor__main");
															var ck_restricted_editing_mode_standard_el 	= jQuery(TE_el).find(".ck.ck-restricted-editing_mode_standard");
																if (isValidElement(ck_editor_block_el[0]))
																{																	
																var ck_editor_block_height				= jQuery(ck_editor_block_el[0]).height(); 
																var ck_editor_block_top					= jQuery(ck_editor_block_el[0]).position().top;
																
																var ck_editor__top_height				= jQuery(ck_editor__top_el[0]).height(); 
																var ck_editor__top_top					= jQuery(ck_editor__top_el[0]).position().top;

																
																var ck_editor_block_height				= jQuery(ck_editor_block_el[0]).height(); 
																
																
																var ck_docker_height					= jQuery(docker_el).height(); 
																var ck_docker_top						= jQuery(docker_el).position().top;
																
																var ck_TEel_height						= jQuery(TE_el).height(); 
																var ck_TEel_top							= jQuery(TE_el).position().top;
																/*
																	console_log(" TTTTTTTTTTTTTTTTTT valid block \nck_editor_block_top:"+ck_editor_block_top
																	+"\n ck_editor_block_height:"+ck_editor_block_height+"\n ck_TEel_height:"+ck_TEel_height+"\n ck_TEel_top:"+ck_TEel_top+
																	"\n docker top:"+ck_docker_top+
																	"\n ck_docker_height:"+ck_docker_height);*/	
																var OBJ_classes 						= TE_el.classList;
																
																	for (var e=0;e<OBJ_classes.length;++e)
																	{
																		//console_log("class:"+OBJ_classes[e]);
																		if (OBJ_classes[e].startsWith("id__"))
																		{
																var 		wordcount_el 				= jQuery(TE_el).find(".wordcount_wrapper");
																var 		wordcount_height 			= jQuery(wordcount_el[0]).height();
																		var target_height 				= ck_docker_height-ck_editor__top_height-wordcount_height;
																			jQuery(ck_editor__main_el[0]).css("height",target_height+"px");
																			jQuery(ck_restricted_editing_mode_standard_el[0]).css("height",target_height+"px");

																			if (jQuery(TE_el).find('.ETE_style').length==0)
																			{
																				jQuery(TE_el).append(
																					
																					"<style class='ETE_style' >"
																					+ " ."+OBJ_classes[e]+" .ck.ck-editor__editable"
																					+ "{"
																					+"	height:"+target_height+"px !important;"
																					+ "}"
																					+"</style>"																		
																				);
																			}
																		}
																	}																	
																}															
															}
														} else
														{
														var content_autofit								= jQuery(TE_el).attr("content_autofit");
															//jQuery(TE_el).css('border','1px solid red');
															
															if(content_autofit=='Y')
															{
															var docker_el 								= document.getElementById(TE_el.id+"docker|");	
															var ck_editor_block_el 						= jQuery(TE_el).find(".ck.ck-reset.ck-editor.ck-rounded-corners");
															var ck_editor__top_el 						= jQuery(TE_el).find(".ck.ck-editor__top.ck-reset_all");
															var ck_editor__main_el 						= jQuery(TE_el).find(".ck.ck-editor__main");
															var ck_restricted_editing_mode_standard_el 	= jQuery(TE_el).find(".ck.ck-restricted-editing_mode_standard");
																if (isValidElement(ck_editor_block_el[0]))
																{																	
																
																var ck_editor__top_height				= jQuery(ck_editor__top_el[0]).height(); 

																
																
																
																var ck_docker_height					= jQuery(docker_el).height(); 
																
																/*
																	console_log(" TTTTTTTTTTTTTTTTTT valid block \nck_editor_block_top:"+ck_editor_block_top
																	+"\n ck_editor_block_height:"+ck_editor_block_height+"\n ck_TEel_height:"+ck_TEel_height+"\n ck_TEel_top:"+ck_TEel_top+
																	"\n docker top:"+ck_docker_top+
																	"\n ck_docker_height:"+ck_docker_height);*/	
																var OBJ_classes 						= TE_el.classList;
																
																	for (var e=0;e<OBJ_classes.length;++e)
																	{
																		//console_log("class:"+OBJ_classes[e]);
																		if (OBJ_classes[e].startsWith("id__"))
																		{
																var 		wordcount_el 				= jQuery(TE_el).find(".wordcount_wrapper");
																var 		wordcount_height 			= 0;
																		var target_height 				= ck_docker_height-ck_editor__top_height-wordcount_height;
																			jQuery(ck_editor__main_el[0]).css("height",target_height+"px");
																			jQuery(ck_restricted_editing_mode_standard_el[0]).css("height",target_height+"px");

																			if (jQuery(TE_el).find('.ETE_style').length==0)
																			{
																				jQuery(TE_el).append(
																					
																					"<style class='ETE_style' >"
																					+ " ."+OBJ_classes[e]+" .ck.ck-editor__editable"
																					+ "{"
																					+"	height:"+target_height+"px !important;"
																					+ "}"
																					+"</style>"																		
																				);
																			}
																		}
																	}																	
																}															
															}
														}
}

function EnhancedTextAreaKeyup(evt)
{
									var					my_TE																				= getTEOwner(evt.target);
									var					my_SW																				= getSWOwner(evt.target);
														manageEnhancedTextArea(my_TE.id);
														CAclient(my_SW.id,evt.target,evt,'applicationModel.HTMLEnhancedTagExtension','!@@PPFEEDBACKACTION@@! !@@VVSENDDATA@@! ',false);
}

function manageEnhancedTextArea(IdentifierIn)
{
	var													Textarea_OBJ_el																		= document.getElementById(IdentifierIn); 
	var													Textarea_DataIn_el																	= document.getElementById(IdentifierIn+"DataIn|"); 
	var													Textarea_OriginalContent_el 														= document.getElementById(IdentifierIn+"OriginalContent|"); 
	var													Textarea_IsModified_el 																= document.getElementById(IdentifierIn+"IsModified|"); 
														$(Textarea_OBJ_el).removeClass('originalcontent');
														$(Textarea_OBJ_el).removeClass('modifiedcontent');
														
														if (isValidElement(Textarea_DataIn_el)&&isValidElement(Textarea_OriginalContent_el))
														{
															if (Textarea_DataIn_el.value==Textarea_OriginalContent_el.value)
															{
																Textarea_IsModified_el.value	= 'N';
																$(Textarea_OBJ_el).addClass('originalcontent');
																//Input_DataIn_el.style.backgroundColor= 'lightgreen';
															} else
															{
																Textarea_IsModified_el.value	= 'Y';
																$(Textarea_OBJ_el).addClass('modifiedcontent');
																//Input_DataIn_el.style.backgroundColor= 'red';
															}
														}
}

function EnhancedInputCurrencykeyUp(elIn)
{
				var 							datain_el																					= document.getElementById(elIn.id+"DataIn|");
				var								MoreDataToServer_el																			= document.getElementById(elIn.id+"MoreDataToServer|");

												jQuery(elIn).removeClass("is_ok");
												jQuery(elIn).removeClass("is_ko");
												jQuery(MoreDataToServer_el).val("0");
												if (jQuery(datain_el).val().length>0)
												{
											var		an_local																			=	AutoNumeric.getAutoNumericElement(datain_el);
													jQuery(MoreDataToServer_el).val(an_local.getNumber());
											var		data_in	= jQuery(datain_el).val();
													data_in = data_in.replace(".","");
													data_in = data_in.replace(",",".");
											var 	data_in_n = Number(data_in);
													if ((an_local.getNumber()>=0)&&(data_in_n==an_local.getNumber()))
													{
														jQuery(elIn).addClass("is_ok");
													} else
													{
														jQuery(elIn).addClass("is_ko");
													}
												} else
												{
													jQuery(elIn).addClass("is_ko");
												}
}

function InlineAuthenticatorSetup(SWIdIn)
{
										var 	MyTimerId 																					= setInterval(function(){InlineAuthenticatorSetupTicker(SWIdIn);}, 100);
												addTimer(MyTimerId, 0, 'LoginCleaner',100);
}

function InlineAuthenticatorSetupTicker(SWIdIn)
{
									var 		SW_el 																						= document.getElementById(SWIdIn);
									var 		password_el 																				= document.getElementById(SWIdIn+"password|");									
									var 		uname_el 																					= document.getElementById(SWIdIn+"ameun|");									
									var 		domain_el 																					= document.getElementById(SWIdIn+"inadom|");									
									var 		usermod_password 																			= jQuery(password_el).attr('usermod');
									var 		usermod_uname 																				= jQuery(uname_el).attr('usermod');
									var 		usermod_domain 																				= jQuery(domain_el).attr('usermod');
												if ((usermod_password=='N'))
												{
													jQuery(password_el).val(jQuery(password_el).attr("value_ori"));
												}
												if ((usermod_uname=='N'))
												{
													jQuery(uname_el).val(jQuery(uname_el).attr("value_ori"));
												}
												if ((usermod_domain=='N'))
												{
													jQuery(domain_el).val(jQuery(domain_el).attr("value_ori"));
												}
												if ((usermod_password=='Y')&&(usermod_uname=='Y')&&(usermod_domain=='Y'))
												{//stop timer
													removeTimerByHandler('LoginCleaner');				
												}
}

function SetupPageNavigator(SWIdentifier)
{
						var 				SW_el 		= document.getElementById(SWIdentifier);
											if (isValidElement(SW_el))
											{
						var 					SWType 		= jQuery(SW_el).attr('owner_family').replaceAll('-','.');
						var 					Message 	= '!@@PPFEEDBACKACTION@@! !@@VVSENDDATA@@!';

												jQuery(SW_el).find('.btnnavigator').each(
													function()
													{
														//jQuery(this).on( "mousedown", function() {  alert( "Handler for `mousedown` called." );} );
														if (jQuery(this).val()=='layout')
														{
															addCLIENTEVENTCustom(SWIdentifier,this.id,'mousedown',SWType,Message,false,'TableSorter',SW_el.id,'','','');
														} else
														{
															addCLIENTEVENT(SWIdentifier,this.id,'mousedown',SWType,Message,false);
														}
													}
												);
												
								var 			currentpage_el = 	document.getElementById(SW_el.id+"TableForm|CurrentPage|");
												jQuery(currentpage_el).off();											
												jQuery(currentpage_el).on("keypress",function(event){
														validateNumberInsert(event,event.target);
													}
												);	
												jQuery(currentpage_el).on("keyup",function(event){
														PageChangeControl(event.target);
													}
												);	
												jQuery(SW_el).find('select[name="layout_select"]').each(
													function()
													{
														//jQuery(this).on( "mousedown", function() {  alert( "Handler for `mousedown` called." );} );
														addCLIENTEVENT(SWIdentifier,this.id,'change',SWType,Message,false);
													}
												);

											var searchbuttonsgroup_find_el 		= 	document.getElementById(SWIdentifier+"find|");
												if(isValidElement(searchbuttonsgroup_find_el)) addCLIENTEVENT(SWIdentifier,searchbuttonsgroup_find_el.id,'mousedown',SWType,Message,false);
												
											var searchbuttonsgroup_find_any_el 	= 	document.getElementById(SWIdentifier+"find_any|");
												if(isValidElement(searchbuttonsgroup_find_any_el)) addCLIENTEVENT(SWIdentifier,searchbuttonsgroup_find_any_el.id,'mousedown',SWType,Message,false);
												 
											var searchbuttonsgroup_clear_el 	= 	document.getElementById(SWIdentifier+"clear|");
												if(isValidElement(searchbuttonsgroup_clear_el)) addCLIENTEVENTCustom(SWIdentifier,searchbuttonsgroup_clear_el.id,'mousedown',SWType,Message,false,'searchModuleNew',SWIdentifier,'','','');
												
											var searchbuttonsgroup_recopadd_el 		= 	document.getElementById(SWIdentifier+"recop|add|");
												if(isValidElement(searchbuttonsgroup_recopadd_el))		addCLIENTEVENT(SWIdentifier,searchbuttonsgroup_recopadd_el.id,'mousedown',SWType,Message,false);

											var searchbuttonsgroup_recopsave_el 		= 	document.getElementById(SWIdentifier+"recop|save|");
												if(isValidElement(searchbuttonsgroup_recopsave_el)) 	addCLIENTEVENT(SWIdentifier,searchbuttonsgroup_recopsave_el.id,'mousedown',SWType,Message,false);

											var searchbuttonsgroup_recopcopy_el 		= 	document.getElementById(SWIdentifier+"recop|copy|");
												if(isValidElement(searchbuttonsgroup_recopcopy_el))  	addCLIENTEVENT(SWIdentifier,searchbuttonsgroup_recopcopy_el.id,'mousedown',SWType,Message,false);
												
											var searchbuttonsgroup_recopquit_el 		= 	document.getElementById(SWIdentifier+"recop|quit|");
												if(isValidElement(searchbuttonsgroup_recopquit_el))		addCLIENTEVENT(SWIdentifier,searchbuttonsgroup_recopquit_el.id,'mousedown',SWType,Message,false);
												
												jQuery(SW_el).find('.FieldServiceTableCell').find('input[type="button"]').off();
												jQuery(SW_el).find('.FieldServiceTableCell').find('input[type="button"]').on(
													'mousedown',
													function (event)
													{
														event.preventDefault();
													var target_id = SW_el.id+"FieldService|FISE|"+jQuery(event.target).val();
														jQuery(event.target).attr('id',target_id); 
														CAclient(SW_el.id,event.target,event,SWType,'!@@PPFEEDBACKACTION@@! !@@VVSENDDATA@@!',true);
													}
												);

												
												Message = '';
												 
												jQuery(SW_el).find('.button_search_wrapper').find("input").each(
													function()
													{
													var innerSW_el =	getOwnerSW(this);
													//console_log("rrrrrrrrrrrreeeeeee33:"+innerSW_el.id);
														//this.addEventListener("mousedown", myyhandler);
														//addCLIENTEVENTCustom(SWIdentifier,this.id,'mousedown',SWType,Message,false,'clickInputChild','','','');
														addCLIENTEVENT(innerSW_el.id,this.id,'mousedown',SWType,'!@@PPFEEDBACKACTION@@! !@@VVSENDDATA@@!',false,'')
													}
												);
												
												
												jQuery(SW_el).find('.button_search_wrapper').off("mousedown");
												jQuery(SW_el).find('.button_search_wrapper').on("mousedown",
													function(event)
													{
														
														//this.addEventListener("mousedown", myyhandler);
														//addCLIENTEVENTCustom(SWIdentifier,this.id,'mousedown',SWType,Message,false,'clickInputChild','','','');
														if (event.target.tagName.toLowerCase()=="span")
														{
													var myInput = 	jQuery(event.target.parentNode).find("input")[0]; 
														//alert("myInput.id:"+myInput.id+"");
											
											
								var 						dummyMouseDown					= new  customEventGenerate('mousedown',myInput);
															dummyMouseDown.stopPropagation();
															myyhandler(dummyMouseDown);
														}
													}
												);
												
												jQuery(SW_el).find('.SearchFieldsSelect').off();
												jQuery(SW_el).find('.SearchFieldsSelect').on(
													'change',
													function(event)
													{
														SearchSegments(event.target);
													}
												);

												
												jQuery(SW_el).find('input[name="mimmodel"]').off();
												jQuery(SW_el).find('input[name="mimmodel"]').on(
													'mousedown',
													function(){
													var parentTD 	= 	this.parentElement;
													var toCleanEl 	= 	parentTD.firstChild;
													var Flag		= 	'Y';
														if (jQuery(toCleanEl).prop('disabled')) {Flag		= 	'N';}
														SearchModuleFieldReset(toCleanEl.id,this,Flag);
													}
												);
												
												jQuery(SW_el).find('.filed_1').off();
												jQuery(SW_el).find('.filed_1').on(
													'keydown',
													function(event)
													{
													let key = (event.keyCode ? event.keyCode : event.which);
														if (key==13)
														{
								var 						find_el 						= document.getElementById(SW_el.id+'find|');
								var 						dummyMouseDown					= new  customEventGenerate('mousedown',find_el);
															dummyMouseDown.stopPropagation();
															myyhandler(dummyMouseDown);
														}
													}
												);
												
												jQuery(SW_el).find('.FieldContentTable').find('select').off();
												jQuery(SW_el).find('.FieldContentTable').find('select').on(
													'change',
													function(event)
													{
													var	i 						= findSELECTDROPBOXS(SW_el.id,event.target.id);
													var myTargetFields 			= SELECTDROPBOXS[i].getTargetFields;
													var myTargetFieldsContent 	= SELECTDROPBOXS[i].getTargetFieldsContent;
														showComboRow(myTargetFields,myTargetFieldsContent,event.target);
													}
												);
											}

}

function clickInputChild(eventIn,elIn)
{
												//jQuery(elIn).find("input").click();
					var 						dummyMouseDown					= new  customEventGenerate(eventIn.type,jQuery(elIn).find("input")[0]);
												//dummyMouseDown.preventDefault();
												//dummyMouseDown.bubbles = false;
												
												dummyMouseDown.stopPropagation();
												//dummyMouseDown.currentTarget = jQuery(elIn).find("input")[0];
												//dummyMouseDown.target = jQuery(elIn).find("input")[0];
												//jQuery(elIn).find("input")[0].dispatchEvent(dummyMouseDown);
												
												myyhandler(dummyMouseDown);
												//console.log(dummyMouseDown);
}

function SearchSegments(ElIn)
{
	var 				ElementContent  = $(ElIn).closest("td").next();
						//var TDWidth			 = $(ElIn).closest("td").width()+"px";
	var 				TDWidth 		= $(ElementContent).width()+"px";
						//alert("SearchSegments You entered: "+ElIn.value+"id:"+ElIn.id+". name:"+ElIn.name+"  TDWidth:"+TDWidth );
	var 				BaseId			= "|";
	var 				IdSplitResult 	= ElIn.id.split("|");
	var 				LastChunkValue 	= IdSplitResult[IdSplitResult.length-1];
						for(var i=1;i<IdSplitResult.length-2;++i){BaseId=BaseId+IdSplitResult[i]+"|";}
						//alert('SearchSegments BaseId:'+BaseId+'   LastChunkValue:'+LastChunkValue);
						//alert('ElIn.id:'+ElIn.id+'   IdSplitResult:'+IdSplitResult.length+' dddd:'+dddd);


						//var IdSplitResult = ElIn.id.split("|");
						//alert("Id Number Code:"+IdSplitResult[1]);
						if((ElIn.value == "4")||(ElIn.value == "24"))
						{
							document.getElementById(BaseId+"findH"+LastChunkValue+"|").disabled = false;
							//document.getElementById("findH"+IdSplitResult[1]).value = "";// .attributes.Delete('value');
							//document.getElementById(BaseId+"findH"+LastChunkValue+"|").setAttribute('style', 'position:absolute;left:0;top:0;width:40mm;background-color:white;border:none;margin:0;padding:0;');
							document.getElementById(BaseId+"findH"+LastChunkValue+"|").setAttribute('style', 'position:absolute;left:0;right:0;top:0;background-color:white;border:none;margin:0;padding:0;width:'+TDWidth+';');
							document.getElementById(BaseId+"findH"+LastChunkValue+"|").removeAttribute('readonly');// .setAttribute('readonly', 'false');
							if (ElIn.value == "24")
							{
								document.getElementById(BaseId+"findH"+LastChunkValue+"|").setAttribute('readonly', 'readonly');
								try
								{
									document.getElementById(BaseId+"trigger.calendar.H"+LastChunkValue+"|").disabled=false;
								}
								catch(e){}
								//document.getElementById(BaseId+"findH"+LastChunkValue+"|").setAttribute('style', 'position:absolute;left:0;top:0;background-color:white;border:none;margin:0;padding:0;width:40mm;');
								document.getElementById(BaseId+"findH"+LastChunkValue+"|").setAttribute('style', 'position:absolute;left:0;top:0;right:0;background-color:white;border:none;margin:0;padding:0;width:'+TDWidth+';');
								//document.getElementById("findH"+IdSplitResult[1]).disabled = true;
							}
							//if (ElIn.value == "4")  document.getElementById("findH"+IdSplitResult[1]).removeAttribute('readonly');
						}else
						{
							//alert("ciao! ->"+IdSplitResult[1]);
							//alert("Disabling Higher Hand. elin.value:"+ElIn.value);
							try
							{
								document.getElementById(BaseId+"trigger.calendar.H"+LastChunkValue+"|").disabled=true;
							}catch(e)
							{
								
							}
							//alert("hi");
							//alert("upper finder id:"+"findH"+IdSplitResult[1]);
							//alert('>>>>>'+BaseId+"findH"+LastChunkValue);

							document.getElementById(BaseId+"findH"+LastChunkValue+"|").disabled = true;
							document.getElementById(BaseId+"findH"+LastChunkValue+"|").value = "";// .attributes.Delete('value');
							//document.getElementById(BaseId+"findH"+LastChunkValue+"|").setAttribute('style', 'position:absolute;left:0;top:0;width:40mm;background-color:rgb(220,220,220);border:none;margin:0;padding:0');
							document.getElementById(BaseId+"findH"+LastChunkValue+"|").setAttribute('style', 'position:absolute;left:0;right:0;top:0;background-color:rgb(220,220,220);border:none;margin:0;padding:0;width:'+TDWidth+';');
							if ((ElIn.value == "21")||(ElIn.value == "22")||(ElIn.value == "23")||(ElIn.value == "25"))
							{
								//document.getElementById(BaseId+"findH"+LastChunkValue+"|").setAttribute('style', 'position:absolute;left:0;top:0;width:40mm;background-color:rgb(220,220,220);border:none;margin:0;padding:0;');
								document.getElementById(BaseId+"findH"+LastChunkValue+"|").setAttribute('style', 'position:absolute;left:0;right:0;top:0;background-color:rgb(220,220,220);border:none;margin:0;padding:0;width:'+TDWidth+';');
								
							}
					
							document.getElementById(BaseId+"findH"+LastChunkValue+"|").setAttribute('readonly', 'readonly');

							//document.getElementById("findL"+IdSplitResult[1]).value = "";// .attributes.Delete('value');
							//	document.getElementById("findL"+IdSplitResult[1]).setAttribute('style', 'background-color:rgb(210,210,210);border:none;');
							//	document.getElementById("findL"+IdSplitResult[1]).setAttribute('readonly', 'readonly');
						}
}	

function SearchSegments_old(ElIn)
{
		//alert('hi');
		//alert("You entered: "+ElIn.value+"id:"+ElIn.id+". name:"+ElIn.name);
	var IdSplitResult = ElIn.id.split("|");
		//alert("Id Number Code:"+IdSplitResult[1]);
		if((ElIn.value == "4")||(ElIn.value == "24"))
		{
			document.getElementById("findH"+IdSplitResult[1]).disabled = false;
			//document.getElementById("findH"+IdSplitResult[1]).value = "";// .attributes.Delete('value');
			document.getElementById("findH"+IdSplitResult[1]).setAttribute('style', 'position:absolute;left:0;top:0;width:40mm;background-color:white;border:none;margin:0;padding:0;');
			document.getElementById("findH"+IdSplitResult[1]).removeAttribute('readonly');// .setAttribute('readonly', 'false');
			if (ElIn.value == "24")
			{
				document.getElementById("findH"+IdSplitResult[1]).setAttribute('readonly', 'readonly');
				try
				{
					document.getElementById("trigger.select.H"+IdSplitResult[1]).disabled=false;
				}catch(e)
				{
					
				}
				document.getElementById("findH"+IdSplitResult[1]).setAttribute('style', 'position:absolute;left:0;top:0;width:40mm;background-color:white;border:none;margin:0;padding:0;width:40mm;');
				//document.getElementById("findH"+IdSplitResult[1]).disabled = true;
			}
			//if (ElIn.value == "4")  document.getElementById("findH"+IdSplitResult[1]).removeAttribute('readonly');
			
		}	else
		{
			//alert("ciao! ->"+IdSplitResult[1]);
			//alert("Disabling Higher Hand. elin.value:"+ElIn.value);
			try
			{
				document.getElementById("trigger.select.H"+IdSplitResult[1]).disabled=true;
			}catch(e)
			{
				
			}
			//alert("hi");
			//alert("upper finder id:"+"findH"+IdSplitResult[1]);
			document.getElementById("findH"+IdSplitResult[1]).disabled = true;
			document.getElementById("findH"+IdSplitResult[1]).value = "";// .attributes.Delete('value');
			document.getElementById("findH"+IdSplitResult[1]).setAttribute('style', 'position:absolute;left:0;top:0;width:40mm;background-color:rgb(220,220,220);border:none;margin:0;padding:0');
			if ((ElIn.value == "21")||(ElIn.value == "22")||(ElIn.value == "23")||(ElIn.value == "25"))
				document.getElementById("findH"+IdSplitResult[1]).setAttribute('style', 'position:absolute;left:0;top:0;width:40mm;background-color:rgb(220,220,220);border:none;margin:0;padding:0;');
	
			document.getElementById("findH"+IdSplitResult[1]).setAttribute('readonly', 'readonly');
			//document.getElementById("findL"+IdSplitResult[1]).value = "";// .attributes.Delete('value');
			//document.getElementById("findL"+IdSplitResult[1]).setAttribute('style', 'background-color:rgb(210,210,210);border:none;');
			//document.getElementById("findL"+IdSplitResult[1]).setAttribute('readonly', 'readonly');
		}
}	

//function SearchModuleFieldReset('findL"+i+"',this)
function SearchModuleFieldReset(TargetChunkId,callerElem,FlagResetSelect)
{
	var InputSN					= getLastToken(TargetChunkId).replace('findR','').replace('findL','');
	var OwnerSW					= getOwnerSW(callerElem);
	var HTMLFieldSearchersId 	= OwnerSW.id+'HTMLFieldSearchers|';
	var HTMLFieldSearchers      = document.getElementById(HTMLFieldSearchersId);
	var TargetSelectId			= HTMLFieldSearchersId+'select|'+InputSN;
		//alert('kkkkkkkkkk InputSN:'+InputSN+'       TargetSelectId:'+TargetSelectId);
	var InputElems              = $(HTMLFieldSearchers).find('input');
		//alert('kkkkkkkkkk'+InputElems.length+'        HTMLFieldSearchersId:'+HTMLFieldSearchersId);
		for (var i=0;i<InputElems.length;++i)
		{
			//alert('my el id:'+InputElems[i].id);
			if (InputElems[i].id!=null)
			{
				//alert('InputElems[i].id:'+InputElems[i].id+'  TargetChunkId:'+TargetChunkId);
				if (InputElems[i].id==TargetChunkId)
				{
					InputElems[i].value = '';
				}
			}
		}
	
		if (FlagResetSelect=='Y')
		{
		var SelectElems              = $(HTMLFieldSearchers).find('select');
			//alert('kkkkkkkkkk'+SelectElems.length+'        HTMLFieldSearchersId:'+HTMLFieldSearchersId);
			for (var i=0;i<SelectElems.length;++i)
			{
				//alert('my select el id:'+SelectElems[i].id);
				if (SelectElems[i].id!=null)
				{
					if (SelectElems[i].id==TargetSelectId)
					{
						SelectElems[i].options[0].selected = true;
					}
				}
			}
			SearchSegments(document.getElementById(TargetSelectId));
		}
}

function loadFlatpickr()
{
		dynamicallyLoadLibrary(ContextPath   + '/js/flatpickr/flatpickr.js');
		dynamicallyLoadLibrary(ContextPath   + '/js/flatpickr/plugins/monthSelect/index.js');
		dynamicallyLoadLibrary(ContextPath   + '/js/flatpickr/l10n/it.js');
		dynamicallyLoadStyleSheet(ContextPath+ '/js/flatpickr/flatpickr.min.css');
		dynamicallyLoadStyleSheet(ContextPath+ '/js/flatpickr/plugins/monthSelect/style.css');
}/*
 * 
 */
function dateDDMMYYYY_to_Italian(DateIn)
{
										if (DateIn.length==8)
										{
											return DateIn.substring(0,2)+"/"+DateIn.substring(2,4)+"/"+DateIn.substring(4,8);
										} else
										{
											return null;
										}
}

function dateItalian_to_DDMMYYYY(DateIn)
{
										if (DateIn.length==10)
										{
									var		selected_time																	=	DateIn.split("/");
											return selected_time;
										} else
										{
											return null;
										}
}

function dateDDMMYYYY_to_Array(DateIn)
{
				var						out 																								= [];
										if (DateIn.length==8)
										{
											out.push(DateIn.substring(0,2));
											out.push(DateIn.substring(2,4));
											out.push(DateIn.substring(4,8)); 
										} 
										return out;
}

function dateDiffInDays(begin, end) 
{
			const					_MS_PER_DAY																								= 1000 * 60 * 60 * 24;
									// Discard the time and time-zone information.
/*									console_log("dateDiffInDays============================================")
									console_log(" being: Y:"+begin.getFullYear()+"	M:"+begin.getMonth()+"	D:"+begin.getDate());
									console_log(" end: Y:"+end.getFullYear()	+"	M:"+end.getMonth()+"	D:"+end.getDate());
									console_log("==========================================================")
*/
			const					utc1																									= Date.UTC(begin.getFullYear(), begin.getMonth(), begin.getDate());
			const					utc2																									= Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());

									return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

function dateDDMMYYYY_To_Date(DateIn)
{
								try
								{
			var						arr																										=  dateDDMMYYYY_to_Array(DateIn);
					var				mydate																									= new Date(arr[2], Number(arr[1])-1, arr[0]); 
									return mydate;
								} catch(e)
								{
									return null;
								}
}var arrayClientEvents								= []; //old to merge into CLIENTEVENTS
var arrayEvents										= [];/////?????? Necessary to let work TabManager.
var CLIENTEVENTS 									= [];


var dblckick_discriminating_element 				= null;
//var dblckick_discriminating_first_mouseup 			= null;//likely to remove
var clk_dblck_timer_interval 						= 25;
var dblckick_discriminating_state 					= null;
//var isDoubleClick									= false;

var touch_start 									= {x:-1,y:-1};
var touch_now 										= {x:0,y:0};

/* This is high-level function; REPLACE IT WITH YOUR CODE.
 * It must react to delta being more/less than zero.
 */

////CLIENTEVENT FUNCTION START
///////////////////////////////////////////////////////////////////////////////////////////////////////




class ClientEventBean {
  constructor(SWIdentifier,TargetId,Name,SWType,Message,AllowBubbling,CustomFunct,CustomFunctPar1,CustomFunctPar2,CustomFunctPar3,Disabled) 
  {
    this.TargetId 			= TargetId;
    this.Name 				= Name;
    this.SWIdentifier 		= SWIdentifier;
    this.SWType 			= SWType;
    this.Message 			= Message;
    this.AllowBubbling 		= AllowBubbling;
    this.CustomFunctPar1 	= CustomFunctPar1;
    this.CustomFunctPar2 	= CustomFunctPar2;
    this.CustomFunctPar3 	= CustomFunctPar3;
    this.CustomFunct 		= CustomFunct;
    this.Disabled			= Disabled;
  }
  // Getter
  get getTargetId() 
  {
    return this.TargetId;
  }
  
  get getName() 
  {
    return this.Name;
  }
  
  get getSWIdentifier() 
  {
    return this.SWIdentifier;
  }
  
  get getSWType() 
  {
    return this.SWType;
  }

  get getMessage() 
  {
    return this.Message;
  }

  get getAllowBubbling() 
  {
    return this.AllowBubbling;
  }

  get getCustomFunct() 
  {
    return this.CustomFunct;
  }
  
  get getCustomFunctPar1() 
  {
    return this.CustomFunctPar1;
  }
  
  get getCustomFunctPar2() 
  {
    return this.CustomFunctPar2;
  }

  get getCustomFunctPar3() 
  {
    return this.CustomFunctPar3;
  }
  
  get getDisabled() 
  {
    return this.Disabled;
  }
}

function findCLIENTEVENT(TargetId, Name)
{
		var found = -1;
			for(var i=0;i<CLIENTEVENTS.length;++i)
			{
				if ((CLIENTEVENTS[i].getTargetId==TargetId) && (CLIENTEVENTS[i].getName==Name))
				{
					found=i;
				}
			}	
			return found;
}

function addCLIENTEVENT(SWIdentifier,TargetId,EventName,SWType,Message,AllowBubbling,Disabled)
{		
	var 	evtprogr = findCLIENTEVENT(TargetId, EventName);
			if(evtprogr==-1)
			{
				//console_log('adding standard event to:'+TargetId);
				CLIENTEVENTS.push(new ClientEventBean (SWIdentifier,TargetId,EventName,SWType,Message,AllowBubbling,'','','','',Disabled));
			} else 
			{
				CLIENTEVENTS[evtprogr] = new ClientEventBean (SWIdentifier,TargetId,EventName,SWType,Message,AllowBubbling,'','','','',Disabled);
			}
}

/**
 * Custom Functions called by addCLIENTEVENTCustom must have the form myfunction(event,par1,par2,par3)
 * 11 elements
 */
function addCLIENTEVENTCustom(SWIdentifier,TargetId,EventName,SWType,Message,AllowBubbling,CustomFunct,CustomFunctPar1,CustomFunctPar2,CustomFunctPar3,Disabled)
{		
	var 	evtprogr = findCLIENTEVENT(TargetId, EventName);
			//console.log('addCLIENTEVENTCustom  CustomFunct:'+CustomFunct);
			if(evtprogr==-1)
			{
				//console_log('adding custom event a to:'+TargetId+' Disabled:'+Disabled);
				CLIENTEVENTS.push(new ClientEventBean (SWIdentifier,TargetId,EventName,SWType,Message,AllowBubbling,CustomFunct,CustomFunctPar1,CustomFunctPar2,CustomFunctPar3,Disabled));
			} else
			{
				//console_log('adding custom event b to:'+TargetId+' Disabled:'+Disabled);
				CLIENTEVENTS[evtprogr] =new ClientEventBean (SWIdentifier,TargetId,EventName,SWType,Message,AllowBubbling,CustomFunct,CustomFunctPar1,CustomFunctPar2,CustomFunctPar3,Disabled);
			}
}

function ClientEventsImplement()
{
								//jQuery(document.body).find('.servercallback_htmlblock').remove();
								//console.log(CLIENTEVENTS);
								//console.log("******************************************************************");
								for(var o = 0;o<CLIENTEVENTS.length;++o)
								{
									//console.log('gyu:'+CLIENTEVENTS[o].getTargetId);
								//var	Message 		= CLIENTEVENTS[o].getMessage;
								//var	SWIdentifier 	= CLIENTEVENTS[o].getSWIdentifier;
								
								var action_el 			= document.getElementById(CLIENTEVENTS[o].getTargetId);
								//var SW_el 			= document.getElementById(SWIdentifier);
								var evt_name 			= CLIENTEVENTS[o].getName;
								
								var disabled 			= CLIENTEVENTS[o].getDisabled;
									//console.log(" lll sw id:"+SWIdentifier);
								//var	SWType 			= jQuery(SW_el).attr('owner_family').replaceAll('-','.');
								/*
									console.log(
										"  poi poi poi target id :"+CLIENTEVENTS[o].getTargetId+
										"  evtname:"+CLIENTEVENTS[o].getName+
										"  swtype:"+SWType+
										"  SWIdentifier:"+CLIENTEVENTS[o].getSWIdentifier+
										"  Message:"+CLIENTEVENTS[o].getMessage
										);
								*/	
									//console_log("MMMK o:"+o+" "+CLIENTEVENTS[o].getTargetId+"  action_el.id:"+action_el.id+" evt_name:"+evt_name);
									if (
										(isValidElement(action_el))
										//&&(action_el.id.indexOf('|concorsi|MainMenu|')===-1)
									)
									{
										if (evt_name == 'keydown')
										{
											//console.log('___adding keydown event      evt_target_id:'+action_el.id);
											jQuery(action_el).off('keydown');
											action_el.removeEventListener('keydown', myyhandler);
											if (disabled!='DISABLED') action_el.addEventListener('keydown', myyhandler);
										} else
										if (evt_name == 'keyup')
										{
											//console.log('___adding keyup event      evt_target_id:'+action_el.id);
											jQuery(action_el).off('keyup');
											action_el.removeEventListener('keyup', myyhandler);
											if (disabled!='DISABLED') action_el.addEventListener('keyup', myyhandler);
										} else
										if (evt_name == 'mouseover')
										{
											//console.log('___adding mouseover event      evt_target_id:'+action_el.id);
											jQuery(action_el).off('mouseover');
											action_el.removeEventListener('mouseover', myyhandler);
											if (disabled!='DISABLED') action_el.addEventListener('mouseover', myyhandler);
										} else
										if (evt_name == 'change')
										{
											//console.log('___adding change event      evt_target_id:'+action_el.id);
											jQuery(action_el).off('change');
											action_el.removeEventListener('change', myyhandler);
											if (disabled!='DISABLED') action_el.addEventListener('change', myyhandler);
										} else
										if (evt_name == 'mousedown')
										{
											jQuery(action_el).off('mousedown');
											action_el.removeEventListener('mousedown', myyhandler);
											if (disabled!='DISABLED') action_el.addEventListener('mousedown', myyhandler);
											
											//console.log('___adding mousedown event      evt_target_id:'+action_el.id);
											//console.log(' iopiopiop :'+CLIENTEVENTS[o].getTargetId);
											//console_log("MMMK 2:"+CLIENTEVENTS[o].getTargetId+"  evt_target_el.id:"+evt_target_el.id);
											//jQuery(action_el).off('mousedown',myyhandler);
											
											//console.log('___adding mousedown      evt_target_id:'+action_el.id);
											//console.log(evt_target_el);
											//action_el.removeEventListener('mousedown',myyhandler);
											//action_el.addEventListener('mousedown',myyhandler);
											
											//$(action_el).unbind("mousedown",myyhandler);
											//if (disabled!='DISABLED') $(action_el).bind("mousedown",myyhandler);
											
											
											/*
											//jQuery(action_el).off('mousedown');
											jQuery(action_el).on('mousedown',
												function(event) 
												{
													console.log('nnnnn:'+event.target.id+' mmmm:'+event.type);
												var evi = findCLIENTEVENT(event.target.id,event.type);
												console.log(' CLIENTEVENT_i:'+evi);
												var SWIdentifier_evt 	= CLIENTEVENTS[evi].getSWIdentifier;
												var SW_el_evt 			= document.getElementById(SWIdentifier_evt);
												var Message_evt 		= CLIENTEVENTS[evi].getMessage;
												var	SWType_evt 			= jQuery(SW_el_evt).attr('owner_family').replaceAll('-','.');


												//var SW_el = getSWOwner(event.target.id);
												//var SWType = jQuery(SW_el).attr('owner_family').replaceAll('-','.');
													console.log("ttttttttt target id: "+event.target.id+" type:"+event.target.type+' SWIdentifier:'+SW_el_evt.id+' SWType:'+SWType_evt+' message:'+SWType_evt);
													CAclient(SWIdentifier_evt,event.target,event,SWType_evt,Message_evt,true);
													event.stopPropagation();
												}
											);*/
										} else
										if (evt_name == 'mouseleave')
										{
											//console.log('___adding mouseleave      evt_target_id:'+action_el.id);
											jQuery(action_el).off('mouseleave');
											action_el.removeEventListener('mouseleave', myyhandler);
											if (disabled!='DISABLED') action_el.addEventListener('mouseleave', myyhandler);
										} else
										if (evt_name == 'mouseup')
										{
											//console.log('___adding mouseup      evt_target_id:'+action_el.id);
											jQuery(action_el).off('mouseup');
											action_el.removeEventListener('mouseup', myyhandler);
											if (disabled!='DISABLED') action_el.addEventListener('mouseup', myyhandler);
										} else
										if (evt_name == 'click')
										{
											//console.log('___adding mouseup      evt_target_id:'+action_el.id);
											jQuery(action_el).off('click');
											action_el.removeEventListener('click', myyhandler);
											if (disabled!='DISABLED') action_el.addEventListener('click', myyhandler);
										} else
										{
											//console.log(' _-_-_!adding '+evt_name+' not valid event:'+CLIENTEVENTS[o].getTargetId);
										}
									} else
									{
										//console.log(' ___!adding mousedown not valid element:'+CLIENTEVENTS[o].getTargetId);
									}
								}//loop list
								
								/*
							var myel = document.getElementById('|concorsi|MainMenu|Submit|');
								if (isValidElement(myel))
								{
									console.log('pokpokpokpok');
									myel.removeEventListener("click", myyhandler);
									myel.addEventListener("click", myyhandler);
								} else
								{
									console.log('invalid myel');
								}*/
}

function myyhandler(e) 
{
										//alert( 'Thanks! target id:'+e.currentTarget.id + ' ' +e.type);
									  	//console.log(this.className); // logs the className of my_element
									  	//console.log(e.currentTarget === this); // logs `true`
								  		//console.log('myyhandler function event target:'+e.currentTarget.id+' type:'+e.type);
									var evi = findCLIENTEVENT(e.currentTarget.id,e.type);
										if (evi>-1)
										{
										var SWIdentifier_evt 	= CLIENTEVENTS[evi].getSWIdentifier;
										//var SW_el_evt 			= document.getElementById(SWIdentifier_evt);
										var Message_evt 		= CLIENTEVENTS[evi].getMessage;
										//var	SWType_evt 			= jQuery(SW_el_evt).attr('owner_family').replaceAll('-','.');
										var	SWType_evt 			= CLIENTEVENTS[evi].getSWType;
										var	AllowBubbling 		= CLIENTEVENTS[evi].getAllowBubbling;
										var CustomFunct 		= CLIENTEVENTS[evi].getCustomFunct;
										var CustomFunctPar1 	= CLIENTEVENTS[evi].getCustomFunctPar1;
										var CustomFunctPar2 	= CLIENTEVENTS[evi].getCustomFunctPar2;
										var CustomFunctPar3 	= CLIENTEVENTS[evi].getCustomFunctPar3;

											//console.log(' happened CLIENTEVENT_i:'+evi+' message:'+Message_evt+' current tarteg:'+e.currenttarget+' target:'+e.target);
	
											//var SW_el = getSWOwner(event.target.id);
											//var SWType = jQuery(SW_el).attr('owner_family').replaceAll('-','.');
											if (!AllowBubbling) 
											{
												e.stopPropagation(); 
												//console.log('unbubbling '+SWIdentifier_evt);
											}
											if (CustomFunct=='')
											{
												CAclient(SWIdentifier_evt,e.currentTarget,e,SWType_evt,Message_evt,true);
												//e.stopPropagation();
											} else
											{
												window[CustomFunct](e,CustomFunctPar1,CustomFunctPar2,CustomFunctPar3);
											}
										}
}

function generateClientEventElement(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn) 
{
	    this.Identifier 								= IdentifierIn;
	    this.element									= elementIn;
	    this.event 										= eventIn; 
	    this.SWType										= SWTypeIn;
	    this.Message									= MessageIn;
	    this.AllowBubbling								= AllowBubblingIn;
}

function removeClientEventByArrayPosition(PositionIn)
{
		arrayClientEvents.splice(PositionIn,1);		
}

function clear_arrayClientEvents()
{
	while((arrayClientEvents!=null)&&(arrayClientEvents.length>0))
	{
		arrayClientEvents.splice(0,1);				
	}
}

function addClientEventOldToMerge(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn)
{
	
	var my_arrayClientEventsElement 					= new generateClientEventElement(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn);
		arrayClientEvents.push(my_arrayClientEventsElement);
}

////CLIENTEVENT FUNCTION END
///////////////////////////////////////////////////////////////////////////////////////////////////////


function handle(delta) 
{
	if (delta < 0)
	{
		/* something. */
		$("#debuggeroutput_content").html(" wheel negative delta : "+delta+" type : "+event.type);
	}else
	{
		/* something. */
		$("#debuggeroutput_content").html(" wheel positive delta : "+delta+" type : "+event.type);
	}
}

function MouseScroll(event)
{
		//console_log("mouse scrolling.....");
	var rolled												= 0;
		if ('wheelDelta' in event) 
		{
			rolled 											= event.wheelDelta;
		}else 
		{	// Firefox
	    	// The measurement units of the detail and wheelDelta properties are different.
			rolled 											= -40 * event.detail;
		}
//    return rolled; 
//    var info = document.getElementById ("info");
//    info.innerHTML = rolled;

		//$("#debuggeroutput_content").html(" wheel positive delta : "+rolled+" type : "+event.type);
	    //CAclient_params(document.body.id,document.body,event,"","",null);
		CAclient_params(null,null,event,null,null,null);
//		if ((Active_Slider_H!=null)&&((key_code == 37)||(key_code == 39)))
//		{
//			sliderScrollKey_div(Active_Slider_H,key_code);
//		}

	var ShiftModifier 									= false;
		if (event.shiftKey) 
		{
			   //console_log("shift is down");
			ShiftModifier 									= true;
		}else
		{
			   //console_log("shift is up");
		}

		if ((Active_Slider_V!=null)&&(Active_Slider_H==null))//((key_code == 38)||(key_code == 40)||(key_code == 33)||(key_code == 34)))
		{
		var key_code 									= null;
			if (rolled>0) {key_code = 33;}
			if (rolled<0) {key_code = 34;}
			//alert("keydown");
			sliderScrollKey_div(Active_Slider_V,key_code);
		} else
		if ((Active_Slider_H!=null)&&(Active_Slider_V==null))
		{
		var key_code 								= null;
			if (rolled>0) {key_code = 37;}
			if (rolled<0) {key_code = 39;}
			//alert("keydown");
			sliderScrollKey_div(Active_Slider_H,key_code);
		} else 
		if ((Active_Slider_H!=null)&&(Active_Slider_V!=null))
		{
			if (ShiftModifier)
			{//Wheel Now controls Hori slider because of modifier
			var key_code 							= null;
				if (rolled>0) {key_code = 37;}
				if (rolled<0) {key_code = 39;}
				//alert("keydown");
				sliderScrollKey_div(Active_Slider_H,key_code);
			} else
			{//Wheel Now controls Vert slider because of NO modifier
			var key_code 							= null;
				if (rolled>0) {key_code = 33;}
				if (rolled<0) {key_code = 34;}
				//alert("keydown");
				sliderScrollKey_div(Active_Slider_V,key_code);
			}
		}
		/// TO refine//////
		///1 Active_Slider_H = null, Active_Slider_V = null,

		//alert('Active_Slider_TABLE:'+Active_Slider_TABLE);
		//if ((Active_Slider_TABLE!=null)&&((key_code == 37)||(key_code == 39)))
		if ((Active_Slider_TABLE!=null)&&(rolled!=0))
		{
			if (rolled>0) {key_code = 37;}
			if (rolled<0) {key_code = 39;}

			sliderScrollKey_table(Active_Slider_TABLE,key_code);
		}
}

function wheel(event)
{
var delta 			= 0;
	if (!event) event 	= window.event;
	if (event.wheelDelta) 
	{
		delta = event.wheelDelta/120; 
	} 
		else 	if (event.detail) 
				{
					delta = -event.detail/3;
				}
	if (delta)
	{
		handle(delta);
		if (event.preventDefault) event.preventDefault();
		event.returnValue = false;
	}
}




/* Initialization code. */
///////////////////////////EVENTS QUEUE////////////////////////////////

function generateEventElement(EventNameIn, EventSubNameIn,leftIn, topIn,containerIDin,isActiveIn,YCursorRaceIn,XCursorStartIn,YCursorStartIn,XContentIn,YContentIn,CursorElementIdIn) 
{
										this.EventName 								= EventNameIn;
										this.EventSubName 							= EventSubNameIn;
										this.left 									= leftIn;
										this.top 									= topIn; 
										this.containerID 							= containerIDin; 
										this.isActive 								= isActiveIn; 
										this.XContent 								= XContentIn;		//Table width
										this.YCursorStart 							= YCursorStartIn; 
										this.YCursorRace 							= YCursorRaceIn; 
										this.YContent 								= YContentIn;
										this.CursorElementId						= CursorElementIdIn; 
}

function retrieveActiveEvents()
{
									var activeEvents = 0;
										if(typeof arrayEvents != "undefined" && arrayEvents != null && arrayEvents.length > 0)
										{
											for(var f=0;f<arrayEvents.length;++f)
											{
												if (arrayEvents[f].isActive == 'true') {activeEvents=activeEvents+1;}
											}
										}
										return activeEvents;
}

function resetEventsList()
{
	while(arrayEvents.length > 0) 
	{
		arrayEvents.pop();
	}
}

function retrieveEventElementById(EventNameIn,EventSubNameIn,containerIDin)
{
	if(typeof arrayEvents != "undefined" && arrayEvents != null && arrayEvents.length > 0)
	{
		for(var ffi=0;ffi<arrayEvents.length;++ffi)
		{
			if ((arrayEvents[ffi].EventName== EventNameIn)&&(arrayEvents[ffi].EventSubName==EventSubNameIn)&&(arrayEvents[ffi].containerID==containerIDin))
			{
				return ffi;
			}
		}
		return -1;
	}else
	{
		return -1;
	}
}

function removeEventElementById(EventNameIn,EventSubNameIn,containerIDin)
{
	var foundElement = -1;
		if(typeof arrayEvents != "undefined" && arrayEvents != null && arrayEvents.length > 0)
		{
			for(var ffi=0;ffi<arrayEvents.length;++ffi)
			{
				//alert('remove looping.....ffi:'+ffi+' IN : '+EventNameIn+' '+EventSubNameIn+' '+containerIDin+' RESIDENT : '+arrayEvents[ffi].EventName+' '+arrayEvents[ffi].EventSubName+' '+arrayEvents[ffi].containerID);
				if ((arrayEvents[ffi].EventName== EventNameIn)&&(arrayEvents[ffi].EventSubName==EventSubNameIn)&&(arrayEvents[ffi].containerID==containerIDin))
				{
					foundElement = ffi;
				}
			}
		}
		if (foundElement>-1)
		{
			arrayEvents.splice(foundElement,1);
		}
}

function printEventElementList()
{
	var ListOut = "";
		if(typeof arrayEvents != "undefined" && arrayEvents != null && arrayEvents.length > 0)
		{
			for(var ffi=0;ffi<arrayEvents.length;++ffi)
			{
					ListOut+= "\n"+arrayEvents[ffi].EventName+' '+arrayEvents[ffi].EventSubName+arrayEvents[ffi].containerID;
			}
		}
		//alert("Events List : "+ListOut);
}

function setEventElement(EventNameIn, EventSubNameIn,leftIn, topIn,containerIDin,isActiveIn,YCursorRaceIn,XCursorStartIn,YCursorStartIn,XContentIn,YContentIn,CursorElementIdIn)
{
	var arrayEventsi = retrieveEventElementById(EventNameIn,EventSubNameIn);
		//alert('found # : '+arrayEventsi);
		if (arrayEventsi>=0)
		{
			arrayEvents[arrayEventsi].left 		= parseInt(leftIn);
			arrayEvents[arrayEventsi].top  		= parseInt(topIn);
			//to remove
			
			arrayEvents[arrayEventsi].isActive	= 'true';  
		}else
		{
			arrayEvents.push(new generateEventElement(EventNameIn, EventSubNameIn,leftIn, topIn,containerIDin,isActiveIn,YCursorRaceIn,XCursorStartIn,YCursorStartIn,XContentIn,YContentIn,CursorElementIdIn));
			addTimerEventsAvoid('EventAvoid');
		}
}

function addTimerEventsAvoid(TimerHandlerIn)
{
	//$('#debuggeroutput_content').html('B 4 shiftX : '+shiftX);
	//var loopi		= 0;
	var MyTimerId 	= setInterval(function(){TimerEventsAvoid(TimerHandlerIn);}, 10);
		addTimer(MyTimerId, 0, TimerHandlerIn,10);
	//$('#debuggeroutput_content').html('B 5');
}

function TimerEventsAvoid(TimerHandlerIn)
{
	var timerPos =  getTimerPositionByHandler(TimerHandlerIn);
		$(debuggeroutput_content).html("timer Envents Avoid step : "+arrayTimers[timerPos].Step);
		arrayTimers[timerPos].Step = arrayTimers[timerPos].Step+1;
		if (arrayTimers[timerPos].Step>10)
		{
			removeTimerByArrayPosition(timerPos);
			resetEventsList();
		}
}

///////////////////////////EVENTS QUEUE////////////////////////////////
function cancelBubble(e) 
{
	 var evt = e ? e:window.event;
		 //alert('evt:'+evt+' type : '+evt.type);
		 if (evt.stopPropagation)    evt.stopPropagation();
		 if (evt.cancelBubble!=null) evt.cancelBubble = true;
}

function detect_button(e)
{
	e = e || window.event;

	if (e.which == null)
	{
		button = (e.button < 2) ? 'left' :
			((e.button == 4) ? 'middle' : 'right');
	}else
	{
		button = (e.which < 2) ? 'left' :
			((e.which == 2) ? 'middle' : 'right');
	}

	//alert(button);
	return button;
}

function CAExec(EventNameIn,EventSubNameIn,EventOBJId,EnableDisableCommandIn)
{
	//event avoidance based on a tail and a time filter
	//alert('performing : '+EventNameIn+' EventSubNameIn : '+EventSubNameIn);
	if (retrieveActiveEvents()==0)
	{
		if (EnableDisableCommandIn=='true')
		{
				setEventElement(EventNameIn, EventSubNameIn,0, 0,EventOBJId,'true',0,0,0,0,0,'');

				if ((EventNameIn=="temp_show")&&(EventSubNameIn=="remove"))
				{
//					alert('dummy elem click ');

				var temp_actives = $(".temp_show");
					//alert('# temp active:'+temp_actives.length);
					for(var i=0;i<temp_actives.length;++i)
					{
						temp_actives[i].style.display		='none';
						//console_log("temp_actives:"+temp_actives[i].id);
					var commander_identifierElem 			= document.getElementById(temp_actives[i].id+"commander_identifier|");
					var commander_identifierValue 			= commander_identifierElem.value; 
					var commander_OBJ_StateListElem 		= document.getElementById(commander_identifierValue+"stateList|");
						commander_OBJ_StateListElem.value 	= 'hidden';
					}
				}
		}
	}
	//printEventElementList();

	/*
	if (EnableDisableCommandIn=='false')
	{
			removeEventElementById(EventNameIn, EventSubNameIn,EventOBJId);
			alert('removec....still active events : '+retrieveActiveEvents());
			
	}*/

	//alert('active events # :'+retrieveActiveEvents());
}

function LayerStackManager(OBJId,elemIn,OBJTypeIn)
{
	erase_temp_show();
	CAExec("temp_show","remove","","true");
}


function ProcessEventTraversing (event, eventName, elementName, stopPropagate) 
{
    //WriteInfo ("The " + elementName + " element got an " + eventName + " event.");	
    if (stopPropagate) 
    {
        if ('bubbles' in event) 
        {   // all browsers except IE before version 9
            if (event.bubbles) 
            {
                event.stopPropagation ();
                //console_log("The propagation of the " + eventName + " event is stopped. target:"+event.target);
            }else 
            {
                //WriteInfo ("The " + eventName + " event cannot propagate up the DOM hierarchy.");
            }
        }else 
        {  // Internet Explorer before version 9
                // always cancel bubbling
            event.cancelBubble = true;
            //WriteInfo ("The propagation of the " + eventName + " event is stopped.");
        }
    }
}

function CAclient_params(IdentifierIn,element,event,SWType,MessageIn,AllowBubbling)
{
		//console_log("CAclient_params.....event type = "+event.type);
	var eventLocal 					= event||window.event;
		//events came from different places and different elements
	//var d 	  					= new Date(); 
	//var t 	  					= d.getTime();
	var t      						= Date.now();
	
//	if 	( (event.type!='touchmove')&&(event.type.indexOf("SCROLL_")==-1 ) )
//	{
//		//console_log("touchstart reset_______________type:"+event.type);
//		touch_start.x 				= -1;
//		touch_start.y 				= -1;
//	}
	
		if ((eventLocal.type=="mousewheel")||(eventLocal.type=="DOMMouseScroll"))
		{
			t_last_wheel_event = t;
		}
		
		if ((eventLocal.type=="mousedown")||(eventLocal.type=="click"))
		{
			MousePosX_lastDown_event    = eventLocal.pageX;
			MousePosY_lastDown_event  	= eventLocal.pageY;
		}	
		
		if (eventLocal.type=="touchstart")
		{
			t_last_mouse_movement   	= t;
			overflow_control_selection(IdentifierIn,true);
		}
	
//	if (eventLocal.type=="touchmove")
//	{
//		console_log("touchmove_______________");
//		t_last_mouse_movement   	= t;
//		
//		if (touch_start.x == -1){touch_start.x=event.touches[0].pageX;}
//		if (touch_start.y == -1){touch_start.y=event.touches[0].pageY;}
//		touch_now.x 				= event.touches[0].pageX;
//		touch_now.y 				= event.touches[0].pageY;
//	var delta_x 					= parseInt(touch_now.x-touch_start.x);
//	var delta_y 					= parseInt(touch_now.y-touch_start.y);
//	
//	var focused_el 					= focused_elements_find()[0];
//	
//	var moved_el 					= document.getElementById(focused_el.id+'frame|');
//		
//		//console_log(" delta x:"+(touch_now.x-touch_start.x));
//		//console_log("  moved_el.id:"+moved_el.id);
//		
//		//console_log(" delta y:"+delta_y+"\n focused_el.id:"+focused_el.id+"IdentifierIn:"+IdentifierIn);
//		//jQuery(moved_el).scrollTop(jQuery(moved_el).scrollTop()-delta_y);
//		
//		if (focused_el.id == IdentifierIn)
//		{
//			sliderScrollContentByDelta(delta_x,IdentifierIn,"overflow_H");	
//			sliderScrollContentByDelta(delta_y,IdentifierIn,"overflow_V");	
//		}
//		
//	}
	
		if (eventLocal.type=="mousemove")
		{
			MousePosX  			  		= eventLocal.pageX;
			MousePosY  			  		= eventLocal.pageY;
			////////////////^^^^^^^^^^^^^^Why this function? Let's optimize......even the grid-like mouse reading MouseClientPosX,MouseClientPosY 		 		
		
			//Is passed the original event Object and not the 
			// customized eventLocal
		var MouseClientCoords 			= getMouseClientCoords(event);
			if 	(
					(Math.abs(MouseClientCoords.x-MouseClientPosX)>2)
					||
					(Math.abs(MouseClientCoords.y-MouseClientPosY)>2)
				)
			{
				t_last_mouse_movement   	= t;
				MouseClientPosX 			= MouseClientCoords.x;
				MouseClientPosY 			= MouseClientCoords.y;
				//$("#debuggeroutput_content").html("MouseClientPosX:"+MouseClientPosX+"\n MouseClientPosY:"+MouseClientPosY+"\n last movement :"+t_last_mouse_movement+"\n element.id : "+IdentifierIn);
			}
		}
	/*
	if (event.type=="mouseover")
	{

	}*/
	//alert("event.type : "+event.type);
		if (eventLocal.type=="keydown")
		{
		var MyKeyCode 					= getKeyCodeOnKeyDown(event);
			if (MyKeyCode==13) 
			{
			(eventLocal.preventDefault) ? eventLocal.preventDefault() : eventLocal.returnValue = false; 
					//Enter key press.....verify if some automated functions are to be checked
			}
			t_last_key_event 			= t;
		}	
	    //$("#debuggeroutput_content").html("\nlast_mouse_event:"+t_last_mouse_movement+"\nt_last_wheel_event:"+t_last_wheel_event+"\nt_last_key_event :"+t_last_key_event);
}

function CAclient_SequenceStart(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn,CAclient_StateIn)
{
		CAclient_StateIn							+="GOPROCEDURE";
	var MessageInVerified 	 						= replaceAll(MessageIn,"#", "!" );
		//Precondition ...... e.g. for standard components (FileUpload, Menu, Tree, .....)
	if ((MessageInVerified!=null)&&(MessageInVerified.length>1))
	{
	var FUNCTION_VALUE 								= getValueByParName(MessageInVerified,'FUNCTION');
		if (FUNCTION_VALUE == 'FILEUPLOAD_COMPLETE')
		{
			//alert(">>>>>>>>>IdentifierIn : "+document.getElementById(IdentifierIn).id);
		var generalizedFormElement 				= getAssociatedFormElement(document.getElementById(IdentifierIn));
		var dataelement 						= provideSubmitHiddenInputByName(generalizedFormElement,IdentifierIn,"fileupload_message","fileupload_message");
			if (dataelement!=null){dataelement.value='FILEUPLOAD_COMPLETE';}
			//alert("fileupload message <<<<<<<<<<<<: "+dataelement.value+" type : "+dataelement.tagName+" id : "+dataelement.id+" name : "+dataelement.getAttribute("name"));
			//alert("file upload complete...... IdentifierIn : "+IdentifierIn+"\n MessageInVerified : "+MessageInVerified);
		}
		
	var MODIFIER_DBLCLK_VALUE 					= getValueByParName(MessageInVerified,'MODIFIER_DBLCLK');
		if ((MODIFIER_DBLCLK_VALUE == 'SINGLE_DBL_CLK_SWITCH')||(elementIn.id==dblckick_discriminating_element))
		{
			if ((eventIn.type=='mousedown')||(eventIn.type=='mouseup'))
			{
//			var click_dblck_discriminator_out =  click_dblck_discriminator(IdentifierIn,element,event,SWType,MessageIn,AllowBubbling);
//				if (click_dblck_discriminator_out == "WAITING_SECOND_CLICK" ) {if (ParsOut == null) {ParsOut = "BREAK";                } else {ParsOut += "BREAK";                }}
//				if (click_dblck_discriminator_out == "SECOND_CLICK_OCCURRED") {if (ParsOut == null) {ParsOut = "SECOND_CLICK_OCCURRED";} else {ParsOut += "SECOND_CLICK_OCCURRED";}}

				CAclient_StateIn 					= CAclient_StateIn.replace("GOPROCEDURE","");
			var click_dblck_discriminator_out 		= CLK_DBLCLK_discriminator(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn);

					//ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
					//CAclient_StateIn+=click_dblck_discriminator_out;
			}
//			if(event.type=='mouseup')
//			{
//				if (element.id==dblckick_discriminating_element)
//				{//starts a second timer to delay "mouseup"
//					
//				}
//			}
		}
//		if (MODIFIER_DBLCLK_VALUE == 'SINGLE_CLK_SECOND_LOOP')
//		{// do not do nothing ..... regular execution
//			//alert("performing second loop............");	
//		}
		
//		if (dblckick_discriminating_element!=null)
//		{
//			if (event.type=='mouseup')
//			{//
//			//	console_log("_________mouseup");
//				if (dblckick_discriminating_first_mouseup==null)
//				{
//					dblckick_discriminating_first_mouseup = "SHORT_CLICK";
//				}
//			}
//		}
	}
var Timer_clk_dblclk_position 					= getTimerPositionByHandler('clk_dblck_timer_handler');
	if (Timer_clk_dblclk_position>-1)           {  CAclient_StateIn = CAclient_StateIn.replace("GOPROCEDURE","");}
	
	//if ((eventIn.type=='mousedown')||(eventIn.type=='mouseup')) {console_log(">>> CAclient_StateIn :"+CAclient_StateIn+" event : "+eventIn.type+"\n el id:"+dblckick_discriminating_element +" el id in:"+elementIn.id+" Timer_clk_dblclk_position : "+Timer_clk_dblclk_position);}

	return CAclient_StateIn;
}

function CAclient_SequenceEnd(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn,CAclient_State)
{
/*										if (eventIn.type!='mousemove')
										{
											console_log("99999999999999999999999999999999999999999999999999999999999999999999999999999999999");
											console_log("IdentifierIn : "+IdentifierIn+" elementIn.id: "+elementIn.id+" eventIn : "+eventIn.type+"  CAclient_State:"+CAclient_State);
											console_log("44444444444444444444444444444444444444444444444444444444444444444444444444444444444");
										}
*/									var isDoubleClick 																						= false;
									var isClick 	  																						= false;
									var isChange 	  																						= false;
									var isKeyDown 	  																						= false;
									var pushedMouseButton 																					= detect_button(eventIn);
									
										if (CAclient_State.indexOf("DBLCLK")>-1)	{isDoubleClick	= true;}
										if (eventIn.type=='mousedown')				{isClick		= true;}
										if (eventIn.type=='click')					{isClick		= true;}
										if (eventIn.type=='keydown')				{isKeyDown		= true;}
										if (eventIn.type=='change')					{isChange		= true;}

									var MessageInVerified 	 																				= replaceAll(MessageIn,"#", "!" );
										//console_log("vvvvvvvvvvvvvvv..................CAclient_SequenceEnd  msg:"+MessageIn+"   CAclient_State:"+CAclient_State);
										if (CAclient_State.indexOf('0000')>-1)
										{//no modification into the normal flow
											//console_log("CAclient_SequenceEnd->.GEN isKeyDown:"+isKeyDown);

										var par_FEEDBACKACTION_MOUSE_UP 		   															= getValueByParName(MessageInVerified,'FEEDBACKACTION_MOUSE_UP');
										var par_FEEDBACKACTION 		   																		= getValueByParName(MessageInVerified,'FEEDBACKACTION');
										var par_FEEDBACKACTION_CLICK_LEFT 		    														= getValueByParName(MessageInVerified,'FEEDBACKACTION_CLICK_LEFT');
										var par_FEEDBACKACTION_CLICK_RIGHT 		   															= getValueByParName(MessageInVerified,'FEEDBACKACTION_CLICK_RIGHT');
										var par_FEEDBACKACTION_DBLCLICK 		   															= getValueByParName(MessageInVerified,'FEEDBACKACTION_DBLCLICK');
											//console_log("par_FEEDBACKACTION_CLICK_RIGHT:"+par_FEEDBACKACTION_CLICK_RIGHT);
											//console_log(" MessageInVerified :"+MessageInVerified+" par_FEEDBACKACTION_CLICK_LEFT : "+par_FEEDBACKACTION_CLICK_LEFT+"   par_FEEDBACKACTION : "+par_FEEDBACKACTION);
											//ADD ELEMENT to the generalized form to discriminate LEFT_CLICK,RIGHT_CLICK, CLICK (generic), DBLCKICK		
											if (par_FEEDBACKACTION_MOUSE_UP=='SENDDATA')
											{
												//console_log("CAclient_SequenceEnd->..Z");
												sendData(IdentifierIn,elementIn,SWTypeIn);
											}
											if ((par_FEEDBACKACTION=='SENDDATA')&&(isClick))
											{
												//alert("CAclient_SequenceEnd->..A  SWTypeIn:"+SWTypeIn+' elementIn.id:'+elementIn.id);
												sendData(IdentifierIn,elementIn,SWTypeIn);
											}
											if ((par_FEEDBACKACTION_CLICK_LEFT =='SENDDATA'  )&&(isClick)&&(pushedMouseButton=='left')  )
											{
												//console_log("CAclient_SequenceEnd->..B");
												//console_log("IdentifierIn : "+IdentifierIn+"\n elementIn.id:"+elementIn.id+"\n SWTypeIn:"+SWTypeIn);
												sendData(IdentifierIn,elementIn,SWTypeIn);
											}
											if ((par_FEEDBACKACTION_CLICK_RIGHT=='SENDDATA'   )&&(isClick)&&(pushedMouseButton=='right'))
											{
												//console_log("CAclient_SequenceEnd->..C");
												sendData(IdentifierIn,elementIn,SWTypeIn);
											}
											if ((par_FEEDBACKACTION_DBLCLICK   =='SENDDATA'   )&&(isDoubleClick)&&(isClick)				)
											{
												//console_log("CAclient_SequenceEnd->..D");
												sendData(IdentifierIn,elementIn,SWTypeIn);
											}
											if ((par_FEEDBACKACTION   =='SENDDATA'   )&&(isKeyDown)										)
											{
												//console_log("CAclient_SequenceEnd->..D");
												sendData(IdentifierIn,elementIn,SWTypeIn);
											}
											if ((par_FEEDBACKACTION=='SENDDATA')&&(isChange))
											{
												//console_log("CAclient_SequenceEnd->..A  SWTypeIn:"+SWTypeIn);
												sendData(IdentifierIn,elementIn,SWTypeIn);
											}
										}else
										{
											//console_log("CAclient_SequenceEnd->.QQ");											
											if (CAclient_State.indexOf("FORCESENDDATA")>-1)
											{
												//console_log("CAclient_SequenceEnd->..QQ2");
												sendData(IdentifierIn,elementIn,SWTypeIn);
											}
										}
}

function click_dblck_discriminator(IdentifierIn,element,event,SWType,MessageIn,AllowBubbling)
{
										//alert("click_dblck_discriminator");
	var 								OutString 																							= null;
										if (element!=null)
										{
											if ((typeof element.id === 'undefined')||(element.id == null)||(element.id.length <2))
											{
												element.id 																					= createUUID();
												OutString 																					= "WAITING_SECOND_CLICK";
											}else
											{
												if (element.id == dblckick_discriminating_element)
												{//SECOND CLICK OCCURRED
													OutString 																				= "SECOND_CLICK_OCCURRED";
													dblckick_discriminating_element = null;
												}else
												{
													OutString 																				= "WAITING_SECOND_CLICK";
												}
											}
											//alert("fffffffffffff OutString:"+OutString);
											//console_log("________________ OutString:"+OutString);
											if (OutString == "WAITING_SECOND_CLICK")
											{
												//handler is fixed for all the application
											var MyTimerId 																					= setInterval(function(){clck_delayed_execution_after_dblck_discrimination(IdentifierIn,element,event,SWType,MessageIn,AllowBubbling);}, clk_dblck_timer_interval);
												addTimer(MyTimerId, 0, 'clk_dblck_timer_handler',clk_dblck_timer_interval);
												dblckick_discriminating_element 															= element.id;
												dblckick_discriminating_first_mouseup   													= null;
											}
											
											if (OutString == "SECOND_CLICK_OCCURRED")
											{
												//timer between two clicks on same element is cleared
											var Timer_clk_dblclk_position 																	= getTimerPositionByHandler('clk_dblck_timer_handler');
												removeTimerByArrayPosition(Timer_clk_dblclk_position);
											}
										}else
										{
											//If element is nul-CLICKl discrimination is not possible
											OutString == "DOULE_CLICK_NOT_ALLOWED";
										}
										return OutString;	
}

function clck_delayed_execution_after_dblck_discrimination(IdentifierIn,element,event,SWType,MessageIn,AllowBubbling)
{
									var Timer_clk_dblclk_position 																			= getTimerPositionByHandler('clk_dblck_timer_handler');
										//clk_dblck_timer_handler : this is the handler of the timer
										//alert("Timer_clk_dblclk_position : "+Timer_clk_dblclk_position+" step : "+arrayTimers[Timer_clk_dblclk_position].Step);
										if (Timer_clk_dblclk_position>-1)
										{
											arrayTimers[Timer_clk_dblclk_position].Step 													= arrayTimers[Timer_clk_dblclk_position].Step+1;
											
											if (arrayTimers[Timer_clk_dblclk_position].Step>5)
											{
												dblckick_discriminating_element 															= null;
												removeTimerByArrayPosition(Timer_clk_dblclk_position);
												MessageIn 																					= MessageIn.replace('SINGLE_DBL_CLK_SWITCH','SINGLE_CLK_SECOND_LOOP');
												CAclient(IdentifierIn,element,event,SWType,MessageIn,AllowBubbling);
											}	
										}
	
	var 								Timer_clk_dblclk_position 																			= getTimerPositionByHandler('clk_dblck_timer_handler');
	
										//if (Timer_clk_dblclk_position>-1) {$("#debuggeroutput_content").html("dbl_clck_handler step : "+arrayTimers[Timer_clk_dblclk_position].Step+"\n dblckick_discriminating_element : "+dblckick_discriminating_element);}
}

function click_dblck_discriminator_mouseup(IdentifierIn,element,event,SWType,MessageIn,AllowBubbling)
{
	if (dblckick_discriminating_element!=null)
	{
	//handler is fixed for all the application
	var MyTimerId 								= setInterval(function(){click_dblck_discriminator_mouseup_scheduled(IdentifierIn,element,event,SWType,MessageIn,AllowBubbling);}, clk_dblck_timer_interval);
		addTimer(MyTimerId, 0, 'clk_dblck_mouseup_timer_handler',clk_dblck_timer_interval);
		dblckick_discriminating_element 		= element.id;
		dblckick_discriminating_first_mouseup   = null;
	}
}

function click_dblck_discriminator_mouseup_scheduled(IdentifierIn,element,event,SWType,MessageIn,AllowBubbling)
{
	//This scheduler delays first mouseup event and executes it after the first event execution
	//If the processing event is a CLICK the currrent "mouseup" event will be executed
	//If the processing event is a DOUBLE CLICK the current "mouseup" event will not be executed
	//The second "mouseup" event of DOUBLE CLICK will be executed
	
var Timer_clk_dblclk_mouseup_position 					= getTimerPositionByHandler('clk_dblck_mouseup_timer_handler');
	//clk_dblck_timer_handler : this is the handler of the timer
	//alert("Timer_clk_dblclk_position : "+Timer_clk_dblclk_position+" step : "+arrayTimers[Timer_clk_dblclk_position].Step);
	if (Timer_clk_dblclk_mouseup_position>-1)
	{
		arrayTimers[Timer_clk_dblclk_mouseup_position].Step = arrayTimers[Timer_clk_dblclk_mouseup_position].Step+1;

		if ((arrayTimers[Timer_clk_dblclk_mouseup_position].Step>5)||(1==1))
		{
			dblckick_discriminating_element = null;
			removeTimerByArrayPosition(Timer_clk_dblclk_mouseup_position);
			//MessageIn = MessageIn.replace('SINGLE_DBL_CLK_SWITCH','SINGLE_CLK_SECOND_LOOP');
			CAclient(IdentifierIn,element,event,SWType,MessageIn,AllowBubbling);
		}
	}	
}

function CLK_DBLCLK_discriminator(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn)
{
	var 								StringOut 																							= null;
	var 								Timer_clk_dblclk_position 																			= getTimerPositionByHandler('clk_dblck_timer_handler');
										if (Timer_clk_dblclk_position==-1)
										{//no discrimination loop active
											if ((eventIn!=null)&&(eventIn.type='mousedown'))
											{//discrimination can start on "mousedown" event only
												if ((typeof elementIn.id === 'undefined')||(elementIn.id == null)||(elementIn.id.length <2)){elementIn.id 	= createUUID();}
												//element must have an ID
												dblckick_discriminating_element = elementIn.id;
												//element ID is stored
												
												addClientEventOldToMerge(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn);
												//first event is sent to stack
												
											var MyTimerId 							= setInterval(function(){CLK_DBLCLK_discriminator_iterator(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn);}, clk_dblck_timer_interval);
												addTimer(MyTimerId, 0, 'clk_dblck_timer_handler',clk_dblck_timer_interval);
												//scheduled procedure starts
											}
										}else
										{//discrimination loop active
											addClientEventOldToMerge(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn);
											//Along loop events are stored in the stack
										}
										//console_log("adding event : "+eventIn.type);
}

function CLK_DBLCLK_discriminator_iterator(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn)
{
	var 								Timer_clk_dblclk_position 				= getTimerPositionByHandler('clk_dblck_timer_handler');
										//clk_dblck_timer_handler : this is the handler of the timer
										//alert("Timer_clk_dblclk_position : "+Timer_clk_dblclk_position+" step : "+arrayTimers[Timer_clk_dblclk_position].Step);
										if (Timer_clk_dblclk_position>-1)
										{
											arrayTimers[Timer_clk_dblclk_position].Step = arrayTimers[Timer_clk_dblclk_position].Step+1;
											
									//		if (arrayTimers[Timer_clk_dblclk_position].Step>5)
									//		{
									//			dblckick_discriminating_element = null;
									//			removeTimerByArrayPosition(Timer_clk_dblclk_position);
									//			MessageIn = MessageIn.replace('SINGLE_DBL_CLK_SWITCH','SINGLE_CLK_SECOND_LOOP');
									//			CAclient(IdentifierIn,element,event,SWType,MessageIn,AllowBubbling);
									//		}
											
											if (arrayTimers[Timer_clk_dblclk_position].Step<=10)
											{
												dblckick_discriminating_state = "WAITING";
											}
											if (arrayTimers[Timer_clk_dblclk_position].Step>10)
											{
												dblckick_discriminating_state = "DELAIED_EXECUTING";
												
												removeTimerByArrayPosition(Timer_clk_dblclk_position);
									
												if (arrayClientEvents!=null)
												{
												var isDoubleClick 		= "";
									
												var firstMouseUp 		= -1;
												var HowManyMouseDown 	= 0;
									
													for(var i=0;i<arrayClientEvents.length;++i)
													{
														if (arrayClientEvents[i].event.type=='mouseup')
														{
															foundMouseUp = i;	
														}
														if (arrayClientEvents[i].event.type=='mousedown')
														{
															++HowManyMouseDown;
														}
													}
									//				console_log('HowManyMouseDown:'+HowManyMouseDown+' arrayClientEvents length:'+arrayClientEvents.length);
									//				for(var o=0;o<arrayClientEvents.length;++o)
									//				{
									//					console_log("arrayClientEvents : "+arrayClientEvents[o].element.id+" "+arrayClientEvents[o].event.type);
									//				}
													if (HowManyMouseDown>1)
													{//Is a DoubleClick
														isDoubleClick = "DBLCLK";
														/*
														if (foundMouseUp > -1 )
														{//First MouseUP is removed
															
															arrayClientEvents.splice(foundMouseUp,1);				
														}*/
														arrayClientEvents.splice(0,1);				
														arrayClientEvents.splice(0,1);				
													}
												}
												///////////////////////////////
												
												while((arrayClientEvents!=null)&&(arrayClientEvents.length>0))
												{
													//MyIdentifier,Myelement,Myevent,MySWType,MyMessage,MyAllowBubbling,CAclient_State
												var MyIdentifier 	= arrayClientEvents[0].Identifier;
												var Myelement 		= arrayClientEvents[0].element;
												var Myevent 		= arrayClientEvents[0].event;
												var MySWType 		= arrayClientEvents[0].SWType;
												var MyMessage 		= arrayClientEvents[0].Message;
												var MyAllowBubbling = arrayClientEvents[0].AllowBubbling;
												
													arrayClientEvents.splice(0,1);	
												
												//CAclient_State = CAclient_procedure(arrayClientEvents[0].Identifier,arrayClientEvents[0].element,arrayClientEvents[0].event,arrayClientEvents[0].SWType,arrayClientEvents[0].Message,arrayClientEvents[0].AllowBubbling,"0000"+isDoubleClick+"DELAYED");
												
												var CAclient_State = CAclient_procedure(MyIdentifier,Myelement,Myevent,MySWType,MyMessage,MyAllowBubbling,"0000"+isDoubleClick+"DELAYED");
													//CAclient_State = CAclient_procedure(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn,CAclient_State);
													//console_log("ffffffffffffffffffffffffffffff  event:"+event.type+"  "+CAclient_State+"    "+MessageIn);
													if (CAclient_State.indexOf("GOSEQUENCEEND")>-1) {CAclient_State = CAclient_SequenceEnd(MyIdentifier,Myelement,Myevent,MySWType,MyMessage,MyAllowBubbling,CAclient_State);}
												}
												isDoubleClick = false;
											}
										}
			var 						Timer_clk_dblclk_position 				= getTimerPositionByHandler('clk_dblck_timer_handler');
	//if (Timer_clk_dblclk_position>-1) {$("#debuggeroutput_content").html("dbl_clck_handler step : "+arrayTimers[Timer_clk_dblclk_position].Step+"\n dblckick_discriminating_element : "+dblckick_discriminating_element);}
}function CAclient(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn)
{
		var 							MessageInVerified 	 																				= replaceAll(MessageIn,"#", "!" );
										if (!isValidElement(MessageInVerified)) {console_log(" No verified Message");}
										//console_log("SWTypeIn:"+SWTypeIn+"   IdentifierIn:"+IdentifierIn+" elementIn:"+elementIn.id+"  eventIn.type:"+(isValidElement(eventIn)?eventIn.type:" type undefined ")+"  eventIn.target.id:"+(isValidElement(eventIn.target)?eventIn.target.id:" eventIn.target.id undefined ")+"  eventIn.target.tagName:"+(isValidElement(eventIn.target)?eventIn.target.tagName:" eventIn.target.tagName undefined "));

										 //console.trace();
										// if (isValidElement(elementIn)&&isValidElement(eventIn)&&isValidElement(eventIn.target))
										// {
										// console_log("     |||| elementIn:"+elementIn.id+"      event target:"+eventIn.target.id);
										// } else
										// {
										// 	console_log("     ||||NO");
										// }
										 //console_log("CACLIENT procedure start . event:"+eventIn.type+" SWType:"+SWTypeIn+" elementIn.id:"+elementIn.id+" elementIn.tagName:"+elementIn.tagName+" IdentifierIn : "+IdentifierIn+"   MessageInVerified:"+MessageInVerified);

										/*
										console_log("---------- elementIn "+elementIn.tagName);
										if ((eventIn.type!="mousemove")&& (eventIn.type!="mouseleave")&& (eventIn.type!="mouseenter")&&(eventIn.type!="mouseover")&&(eventIn.type.indexOf('SCROLL')<0) ) 
										{
										 	console_log("CACLIENT procedure start . event:"+eventIn.type+" SWType:"+SWTypeIn+" elementIn.id:"+elementIn.id+" elementIn.tagName:"+elementIn.tagName+" IdentifierIn : "+IdentifierIn+"   MessageInVerified:"+MessageInVerified);
										}*/

	var 								MessageIn																							= replaceAll(MessageIn,"#", "!" );

										ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);

										CAclient_params(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn);
	
										//check if the SW is locked or not
										if (retrieveArrayPositionLockedSWByIdentifier(IdentifierIn)==-1)
										{
											//IdentifierIn has to be removed
											//the OBJ caller is retrieved by the search of the OBJ class
										
											//alert('event.....'+event.type);
											//if ((eventIn.type=='mousedown')||(eventIn.type=='mouseup'))
											//{console_log(":::::::::>>>SWTypeIn:"+SWTypeIn+" event : "+eventIn.type+"\n el id:"+dblckick_discriminating_element +" el id in:"+elementIn.id);}
										
											//console_log(":::::::::>>>SWTypeIn:"+SWTypeIn+" event : "+eventIn.type+"\n SW in id:"+IdentifierIn+" el id in:"+elementIn.id);
											
											//$('#debuggeroutput_content').html('event:'+event.type);
											//event.stopPropagation();
											//event.preventDefault(); 
											//	console_log(" element.id:"+element.id+" SWType:"+SWType+" MessageIn:"+MessageIn+" IdentifierIn:"+IdentifierIn);
											//	var isSecondClick			= false;
											//	var isShortClick			= false;//this parameter represents the kind of click that is performed in the CLICK case 
											//										//is effective only on the CLICK and not on DOUBLE CLICK
											//									    //If the click is short the "mouseup" was performed before to discriminate CLICK vs DOUBLE CLICK
											//										//If the click is not short the "mouseup" was not still performed and will be peformed later.
		
			var 							CAclient_State 																					= "0000";
			
			var 							CAclient_State     																				= CAclient_SequenceStart(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn,CAclient_State);
											//if ((SequenceStartOutput!=null) &&(SequenceStartOutput=='BREAK')) 					{return null;}
											//if ((SequenceStartOutput!=null) &&(SequenceStartOutput=='SECOND_CLICK_OCCURRED')) 	{isSecondClick = true;}else{if (dblckick_discriminating_first_mouseup=='SHORT_CLICK'){isShortClick=true;}}
											//console_log("  nnnnnnnnn event :    CAclient_State : "+CAclient_State+" Id In:"+IdentifierIn);
											if (eventIn.type=='mousedown')
											{
												if (CAclient_State.indexOf("DBLCLK")>-1 )   {$("#debuggeroutput_content").html(" SWType : "+SWTypeIn+" double click. ");}
												if (CAclient_State.indexOf("DBLCLK")==-1)   {$("#debuggeroutput_content").html(" SWType : "+SWTypeIn+" single click. ");}
												//console_log("mousedown....CAclient_State:"+CAclient_State);
											}
											//console_log("SWType:"+SWTypeIn+" event.type : "+eventIn.type+" IdentifierIn : "+IdentifierIn+"CAclient_State : "+CAclient_State);
			
											if (CAclient_State.indexOf("GOPROCEDURE")>-1)   
											{
												//if (isValidElement(elementIn)&&isValidElement(eventIn)&&isValidElement(eventIn.target))
												//console_log("##########eventIn.target.id ......................... 0000 "+event.target.id+" 8888 "+eventIn.target.id+" type:"+eventIn.type);
												CAclient_State 																				= CAclient_procedure(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn,CAclient_State);
												//console_log("return value CAclient_State:"+CAclient_State);
												if (CAclient_State.indexOf("GOSEQUENCEEND")>-1) {CAclient_State = CAclient_SequenceEnd(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn,CAclient_State);}
											}
										}
}

function CAclient_procedure_SWs(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn,CAclient_StateIn)
{
										//console_log("ooooooooooooooo "+IdentifierIn+"   eventIn.type:"+eventIn.type+"   elementIn.id:"+elementIn.id);
	var 								CAclient_State_aux 																					= CAclient_StateIn;
	var									foundObjectJSEmbedded																				= jQuery('head').find('.jsembedded.caclient');
										//console.log('found methods#'+foundObjectJSEmbedded.length);
										for(var i=0;i<foundObjectJSEmbedded.length;++i)
										//for(var i=0;i<JSEMBEDDED_ARRAY.length;++i)
										{
											//var current_method  			= arrayObjectJSEmbedded[i];
										var current_method  																				= jQuery(foundObjectJSEmbedded[i]).attr('method_name');
												//console_log("i:"+i+"  current_method:"+current_method+" \nhtml:"+jQuery(foundObjectJSEmbedded[i]).html());
												//console_log("___event type : "+eventIn.type);
												//console_log("i:"+i+"  current_method:"+current_method+"   CAclient_State_aux:"+CAclient_State_aux);
											CAclient_State_aux 																				= window[current_method](IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn,CAclient_State_aux);
												//console_log("\nCAclient_State_chunk:"+CAclient_State_aux+" current_method:"+current_method);
												//CAclient_StateIn 			= CAclient_StateIn +CAclient_State_chunk;
												//console_log("CAclient_State_aux:"+CAclient_State_aux+" current_method:"+current_method);
										}
										return CAclient_State_aux;
}

//function CAclient(IdentifierIn,element,event,SWType,MessageIn,AllowBubbling)
function CAclient_procedure(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn,CAclient_StateIn)
{
										//IdentifierIn has to be removed
										//console_log("ALBOESPERTI >>>>>>>>>>>>>>>>>>"+IdentifierIn+"   elementIn.id:"+elementIn.id);
										//the OBJ caller is retrieved by the search of the OBJ class
										//alert('event.....');
										//$('#debuggeroutput_content').html('event:'+event.type);
										//event.stopPropagation();
										//event.preventDefault(); 
	var 								MessageInVerified 	 																				= replaceAll(MessageIn,"#", "!" );
										CAclient_StateIn 																					= CAclient_procedure_SWs(IdentifierIn,elementIn,eventIn,SWTypeIn,MessageIn,AllowBubblingIn,CAclient_StateIn);
	//var 								elementId 																							= elementIn.id;
	var 								CallingSW_el 																						= document.getElementById(IdentifierIn);
										if (eventIn!=null)
										{
											if (eventIn.type!=null)
											{
												if (eventIn.type=="mouseover")
												{//mouseover
													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
													overflow_control_selection(IdentifierIn,true);
												}else//mouseover END
												if (eventIn.type=="pagedrawend")
												{//drawend
												var dropareas 																				= jQuery(".Components-ContainerDropArea");
													for(var f=0;f<dropareas.length;++f)
													{
														
													var is_draw_complete 																	= jQuery(dropareas[f]).attr('draw_complete');
													var is_disabled																			= jQuery(dropareas[f]).hasClass("disabled");
													//console_log(" looking:");
													var bkimage_el 																			= document.getElementById(dropareas[f].id+"bkimage|");
													var caption_el 																			= document.getElementById(dropareas[f].id+"caption|");
														if ((is_draw_complete=='ON')&&(!is_disabled))
														{//do not do nothing
														} else
														if ((is_draw_complete=='OFF')&&(is_disabled))
														{//do not do nothing
														} else
														if (is_disabled)
														{
															if (dropareas[f].id.indexOf("|DDA")>-1)
															{
																//if (isValidElement(bkimage_el)) console_log("1  found bkimage_el:"+bkimage_el.id);
																//if (isValidElement(caption_el)) console_log("1  found caption_el:"+caption_el.id);
																jQuery(bkimage_el).remove();
																jQuery(caption_el).remove();

														var  	dropzone_droparea_contentarea_el 											= document.getElementById(dropareas[f].id+"ContentArea|");
														var 	dropzone_droparea_el														= document.getElementById(replaceAll(dropareas[f].id+"dropzone_droparea|","\\|","__"));
																$(dropzone_droparea_el).css('background-repeat','no repeat');
																$(dropzone_droparea_el).css('background-size','50%');
																$(dropzone_droparea_el).css('opacity','0.0');
																$(dropzone_droparea_el).css('filter','50');
																$(dropzone_droparea_el).css('background-color','white');
																if (jQuery(dropareas[f]).hasClass("readonly_attachments"))
																{
																	$(dropzone_droparea_contentarea_el).after("<img alt='cannot upload' width='96' height = '60' id ='"+dropareas[f].id+"bkimage|' style='position:absolute;display:block;left:20px;margin-left:0;' src='images/image_upload_locked.png'  >");
																	centerElementInParent(dropareas[f].id+'bkimage|','V');
																	$(dropzone_droparea_contentarea_el).after("<span id ='"+dropareas[f].id+"caption|' style='position:absolute;display:block;width:280px;font-family:arial;font-size:22px;font-weight:600;color:blue;font-style:italic;left:120px;margin-left:0;text-align:center;'>Allegati in sola consultazione!</span>");
																	centerElementInParent(dropareas[f].id+'caption|','V');
																} else
																{
																	$(dropzone_droparea_contentarea_el).after("<img alt='cannot upload'  width='96' height = '60' id ='"+dropareas[f].id+"bkimage|' style='position:absolute;display:block;left:20px;margin-left:0;' src='images/image_upload_locked.png'  >");
																	centerElementInParent(dropareas[f].id+'bkimage|','V');
																	$(dropzone_droparea_contentarea_el).after("<span id ='"+dropareas[f].id+"caption|' style='position:absolute;display:block;width:280px;font-family:arial;font-size:22px;font-weight:600;color:blue;font-style:italic;left:120px;margin-left:0;text-align:center;'>Per gli allegati Pulsante Modifica a sinistra!</span>");
																	centerElementInParent(dropareas[f].id+'caption|','V');
																}
															}
															jQuery(dropareas[f]).attr('draw_complete','ON');
														} else
														if (!is_disabled)
														{
															if (dropareas[f].id.indexOf("|DDA")>-1)
															{
																//if (isValidElement(bkimage_el)) console_log("2  found bkimage_el:"+bkimage_el.id);
																//if (isValidElement(caption_el)) console_log("2  found caption_el:"+caption_el.id);
																jQuery(bkimage_el).remove();
																jQuery(caption_el).remove();
														var  	dropzone_droparea_contentarea_el 											= document.getElementById(dropareas[f].id+"ContentArea|");
														var 	dropzone_droparea_el														= document.getElementById(replaceAll(dropareas[f].id+"dropzone_droparea|","\\|","__"));
																$(dropzone_droparea_el).css('background-repeat','no repeat');
																$(dropzone_droparea_el).css('background-size','50%');
																$(dropzone_droparea_el).css('opacity','0.0');
																$(dropzone_droparea_el).css('filter','50');
																$(dropzone_droparea_el).css('background-color','white');
																$(dropzone_droparea_contentarea_el).after("<img alt='uploasd icon' width='96' height = '60' id ='"+dropareas[f].id+"bkimage|' style='position:absolute;display:block;left:20px;margin-left:0;' src='images/image_upload_files.png'  >");
																centerElementInParent(dropareas[f].id+'bkimage|','V');
																$(dropzone_droparea_contentarea_el).after("<span id ='"+dropareas[f].id+"caption|' style='position:absolute;display:block;width:280px;font-family:arial;font-size:22px;font-weight:600;color:blue;font-style:italic;left:120px;margin-left:0;'>Click or Drop to Upload!!</span>");
																centerElementInParent(dropareas[f].id+'caption|','V');
															}
															jQuery(dropareas[f]).attr('draw_complete','ON');
														}
													}//dropareas loop
												}//drawend END
											}
										}

										//	if (eventIn!=null)
										//	{
										//		if (eventIn.type!=null)
										//		{
										//			if (eventIn.type=="mouseover")
										//			{
										//										ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
										//										overflow_control_selection(IdentifierIn,true);
										//				
										//			}else
										//			if (eventIn.type=="onpagedrawend")
										//			{
										//				// var dropareas = jQuery(".Components-ContainerDropArea");
										//				// for(var f=0;f<dropareas.length;++f)
										//				// {
										//				// 	var is_draw_complete = jQuery(dropareas[f]).attr('draw_complete');
										//				// 	//alert("checking : "+dropareas[f].id);
										//				// 	if (is_draw_complete!='Y')
										//				// 	{
										//				// 		//alert("checking : "+dropareas[f].id);
										//				// 		if (dropareas[f].id=="|creaquake|PropertyContainer|PropertyCurrent|Work|Attachments|DDA|")
										//				// 		{
										//				// 			//alert('done....');
										//				// 			jQuery(dropareas[f]).find('.backgrounder').css("background-color","orange");
										//				// 			jQuery(dropareas[f]).find('.dropzone.dz-clickable').css("background-color","transparent");
										//							
										//				// 		}
										//				// 		jQuery(dropareas[f]).attr('draw_complete','Y');
										//				// 	}
										//					
										//				// }
										//				
										//				var dropareas = jQuery(".Components-ContainerDropArea");
										//				for(var f=0;f<dropareas.length;++f)
										//				{
										//					var is_draw_complete = jQuery(dropareas[f]).attr('draw_complete');
										//					//alert("checking : "+dropareas[f].id);
										//					if (is_draw_complete!='Y')
										//					{
										//						//alert("checking : "+dropareas[f].id);
										//						if (dropareas[f].id=="|creaquake|PropertyContainer|PropertyCurrent|Work|Attachments|DDA|")
										//						{
										//							var  dropzone_droparea_contentarea_el = document.getElementById(dropareas[f].id+"ContentArea|");
										//							var dropzone_droparea_el	= document.getElementById(replaceAll(dropareas[f].id+"dropzone_droparea|","\\|","__"));
										//								$(Myelement).find("div").css('background-color','none');
										//								//$(dropzone_droparea_el).css('background-image','url(images/image_upload_files.png)');
										//								$(dropzone_droparea_el).css('background-repeat','no repeat');
										//								$(dropzone_droparea_el).css('background-size','50%');			
										//								$(dropzone_droparea_el).css('opacity','0.0');	
										//								$(dropzone_droparea_el).css('filter','50');
										//								$(dropzone_droparea_el).css('background-color','white');
										//								$(dropzone_droparea_contentarea_el).after("<img width='96' height = '60' id ='"+dropareas[f].id+"bkimage|' style='position:absolute;display:block;left:20px;margin-left:0;' src='images/image_upload_files.png'  >");
										//								centerElementInParent(dropareas[f].id+'bkimage|','V');
										//								$(dropzone_droparea_contentarea_el).after("<span id ='"+dropareas[f].id+"caption|' style='position:absolute;display:block;width:280px;font-family:arial;font-size:22px;font-weight:600;color:blue;font-style:italic;left:120px;margin-left:0;'>Click or Drop to Upload!!</span>");
										//								$(Myelement).find('.dz-message').css('background','none');
										//								$(Myelement).find(".dz-default.dz-message").css("visibility","hidden");
										//								$(Myelement).find(".dz-default.dz-message").css("display","none");
										//								centerElementInParent(dropareas[f].id+'caption|','V');
										//						}
										//						jQuery(dropareas[f]).attr('draw_complete','Y');
										//					}
										//				}
										//			} else
										//			if ((eventIn.type!='mousemove')&&(eventIn.type!='mouseover'))
										//			{
										//				//console_log("__IdentifierIn:"+IdentifierIn+" element.id:"+element.id+" event.type:"+event.type);			
										//			}
										//		}		
										//	}
										if (IdentifierIn=='|alboesperti|ContainerWarning|')
										{
											//if (SWTypeIn=='applicationModel.HTMLEnhancedTagExtension')
											{
												if	((eventIn.type=="click")||(eventIn.type=="mousedown"))
												{
													if (elementIn.id.indexOf('show_idana')>0)
													{
														CAclient_StateIn 																	+= "GOSEQUENCEEND";
														ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
													} 
												}
											} 
										} else
										if (IdentifierIn=='|alboesperti|authshield|quickmenu|')
										{
											if	((eventIn.type=="click")||(eventIn.type=="mousedown"))
											{
												if (elementIn.id.indexOf('ask_teach')>0)
												{
													CAclient_StateIn 																		+= "GOSEQUENCEEND";
													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
												} else
												if (elementIn.id.indexOf('home')>0)
												{
													CAclient_StateIn 																		+= "GOSEQUENCEEND";
													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
												} 
											}
										} else
//										if (IdentifierIn.indexOf('|alboesperti|LC_TeachAsk|Curr|FunctMenu|')>-1)
//										{	
//											if (eventIn.type== 'mouseover')
//											{
//												FunctMenuHover(IdentifierIn,eventIn);
//											} else
//											if (eventIn.type== 'mouseout')
//											{
//												FunctMenuHover(IdentifierIn,eventIn);
//											} else
//											if ((eventIn.type== 'mousedown')||(eventIn.type== 'click'))
//											{
//												CAclient_StateIn 																		+= "GOSEQUENCEEND";
//												ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
//											}
//										} else
										if (IdentifierIn=='|alboesperti|MainMenu|Domande|')
										{	
											if (eventIn.type== 'mouseover')
											{
												MainMenuHover(IdentifierIn,eventIn);
											} else
											if (eventIn.type== 'mouseout')
											{
												MainMenuHover(IdentifierIn,eventIn);
											} else
											if ((eventIn.type== 'mousedown')||(eventIn.type== 'click'))
											{
												if (!jQuery (CallingSW_el).hasClass("selected"))
												{
													CAclient_StateIn 																		+= "GOSEQUENCEEND";
													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
												} 
											}
										} else
										if (IdentifierIn=='|alboesperti|MainMenu|CorsiEventi|')
										{	
											if (eventIn.type== 'mouseover')
											{
												MainMenuHover(IdentifierIn,eventIn);
											} else
											if (eventIn.type== 'mouseout')
											{
												MainMenuHover(IdentifierIn,eventIn);
											} else
											if ((eventIn.type== 'mousedown')||(eventIn.type== 'click'))
											{
												if (!jQuery (CallingSW_el).hasClass("selected"))
												{
													CAclient_StateIn 																		+= "GOSEQUENCEEND";
													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
												} 
											}
										} else
										if (IdentifierIn=='|alboesperti|MainMenu|Settings|')
										{	
											if (eventIn.type== 'mouseover')
											{
												MainMenuHover(IdentifierIn,eventIn);
											} else
											if (eventIn.type== 'mouseout')
											{
												MainMenuHover(IdentifierIn,eventIn);
											} else
											if ((eventIn.type== 'mousedown')||(eventIn.type== 'click'))
											{
												if (!jQuery (CallingSW_el).hasClass("selected"))
												{
													CAclient_StateIn 																		+= "GOSEQUENCEEND";
													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
												} 
											}
										} else
										if (IdentifierIn=='|alboesperti|MainMenu|Esperti|')
										{	
											if (eventIn.type== 'mouseover')
											{
												MainMenuHover(IdentifierIn,eventIn);
											} else
											if (eventIn.type== 'mouseout')
											{
												MainMenuHover(IdentifierIn,eventIn);
											} else
											if ((eventIn.type== 'mousedown')||(eventIn.type== 'click'))
											{
												if (!jQuery (CallingSW_el).hasClass("selected"))
												{
													CAclient_StateIn 																		+= "GOSEQUENCEEND";
													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
												} 
											}
										} else
										if (IdentifierIn=='|alboesperti|MainMenu|Offerta|')
										{	
											if (eventIn.type== 'mouseout')
											{
												MainMenuHover(IdentifierIn,eventIn);
											} 
											if (strEndsWith(eventIn.target.id,'|Offerta|ContentArea|') )
											{
												if (eventIn.type== 'mouseout')
												{
													MainMenuHover(IdentifierIn,eventIn);
												} else
												if (eventIn.type== 'mouseover')
												{
													MainMenuHover(IdentifierIn,eventIn);
													if (MessageInVerified.indexOf('NodeHoveringContainer')>-1)
													{
														ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, true);
													var SW_el 																				= document.getElementById(IdentifierIn);
													var linkedSubmenu_el 																	= document.getElementById('|alboesperti|MainMenu|MenuChunksContainer|2|');
														jQuery(linkedSubmenu_el).css("visibility","visible");
														jQuery(linkedSubmenu_el).css("display","block");
														//jQuery(linkedSubmenu_el).css("width","300px");
														//jQuery(linkedSubmenu_el).css("height","300px");
														//jQuery(linkedSubmenu_el).css("border","2px solid red");
														//jQuery(SW_el).find('.listtreemenuelement_commander_wrapper').addClass("userexpanded");
														//jQuery(SW_el).find('.listtreemenuelement_commander').css('visibility','visible');
														jQuery(SW_el).find('.listtreemenuelement_commander_wrapper img').attr("src","icons/16x16/arrow_node_expansion_up_16x16.png");
														jQuery(SW_el).find('.listtreemenuelement_commander_wrapper').addClass('allow_show');
														//jQuery(linkedSubmenu_el).find('.ComponentsBasic-ListTreeMenuElement').css("visibility","visible");
														//jQuery(linkedSubmenu_el).find('.ComponentsBasic-ListTreeMenuElement').css("display","block");
														//jQuery(linkedSubmenu_el).find('.ComponentsBasic-ListTreeMenuElement').css("background-color","orange");
														jQuery(linkedSubmenu_el).parentsUntil(".Components-MenuManager").css("overflow","visible");
													}
												}
											} else
											if (strEndsWith(elementIn.id,'|Commander|') )
											{
												if (eventIn.type== 'mouseover')
												{
													eventIn.preventDefault();
													MainMenuHover(IdentifierIn,eventIn);
												} else
												if (eventIn.type== 'mousedown')
												{
													if (MessageInVerified.indexOf('Switching')>-1)
													{
														ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, true);
													var SW_el 																				= document.getElementById(IdentifierIn);
													var linkedSubmenu_el 																	= document.getElementById('|alboesperti|MainMenu|MenuChunksContainer|2|');
														jQuery(linkedSubmenu_el).css("visibility","hidden");
														jQuery(linkedSubmenu_el).css("display","block");
														jQuery(SW_el).find('.listtreemenuelement_commander_wrapper img').attr("src","icons/16x16/arrow_node_expansion_right_16x16.png");
														jQuery(SW_el).find('.listtreemenuelement_commander_wrapper').removeClass('allow_show');
														//jQuery(SW_el).find('.listtreemenuelement_commander').css('visibility','hidden');
													} else
													{
														CAclient_StateIn 																	+= "GOSEQUENCEEND";
														ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
													}
												}
											} 
										} else
										if (IdentifierIn.indexOf('|alboesperti|MainMenu|Offerta|')>-1)
										{///remove?
											if (eventIn.type== 'mouseout')
											{
												MainMenuHover(IdentifierIn,eventIn);
											} else
											if (eventIn.type== 'mouseover')
											{
												eventIn.preventDefault();
												MainMenuHover(IdentifierIn,eventIn);
											} 
										} else
										if (IdentifierIn=='|alboesperti|MainMenu|')
										{
											if	((eventIn.type=="click")||(eventIn.type=="mousedown")) {alert("I");}

										} else
										if (IdentifierIn.indexOf('|alboesperti|ContainerWork|TreeStructure|')>-1)
										{
											if (SWTypeIn=='applicationModel.HTMLEnhancedTagExtension')
											{
												if ((eventIn.type=="click")||(eventIn.type=="mousedown"))
												{
													if (elementIn.id.indexOf('TagExtension_folder_select')>0)
													{
														CAclient_StateIn 																	= "GOSEQUENCEENDFORCESENDDATA";
													} 
												}			
											} else
											if (SWTypeIn=='ComponentsBasic.ListTreeMenuElement')
											{
												if(eventIn.type=="mouseover")
												{

												} else
												if	((eventIn.type=="click")||(eventIn.type=="mousedown"))
												{
												var MODIFIER 																				= getValueByParName(MessageInVerified ,'MODIFIER');
													//console_log("MODIFIER:"+MODIFIER);
													if (MODIFIER=="NodeSelection")
													{
														//console_log("node selection...."+SWType);
														//CAclient_State = "FORCESENDDATA GOSEQUENCEEND";
														CAclient_StateIn 																	+= "GOSEQUENCEEND";
														ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
													} else
													{
														ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
															//sendData(IdentifierIn,element,SWType);
														CAclient_StateIn 																	+= "GOSEQUENCEEND";
													}
												}
											}
										} else
										if (IdentifierIn=='|alboesperti|ContainerWork|SubmitFooter|')
										{
											//alert("SubmitFooter !!!!");
											if	((eventIn.type=="click")||(eventIn.type=="mousedown"))
											{
												if (elementIn.id.indexOf('AskSubmit')>0)
												{
													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
													CAclient_StateIn 																			+= "GOSEQUENCEEND";
												}
											}
										} else
//										if ((IdentifierIn.indexOf("|alboesperti|LC_TeachAsk|Curr|CurrEls|baseSW|")>-1)&& (IdentifierIn.indexOf("CurriculumElement")>-1))
//										{
//											if	((eventIn.type=="click")||(eventIn.type=="mousedown"))
//											{
//												ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
//												CAclient_StateIn 																			+= "GOSEQUENCEEND";
//											}
//										} else
//										if ( IdentifierIn=="|alboesperti|LC_TeachAsk|Curr|LC_TeachElementEdit|ElEdit|")
//										{
//											if ((elementIn.id.indexOf("_save")>-1)||(elementIn.id.indexOf("_back")>-1))
//											{
//												if	((eventIn.type=="click")||(eventIn.type=="mousedown"))
//												{
//													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
//													CAclient_StateIn 																		+= "GOSEQUENCEEND";
//												}
//											} else
//											if (elementIn.id.indexOf("DESCR_ext")>-1)
//											{
//												if	((eventIn.type=="changedata"))
//												{
//													checkCurriculumElementGoOn(IdentifierIn);
//												}
//											}
//										} else
//										if ( IdentifierIn.indexOf("|alboesperti|LC_TeachAsk|Curr|Attach|")>-1)
//										{
//
////											if (elementIn.id.indexOf("ttach")>-1)
////											{
////												if	((eventIn.type=="click")||(eventIn.type=="mousedown"))
////												{
////													//alert("yyy!!");
////													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
////													CAclient_StateIn 																		+= "GOSEQUENCEEND";
////												}
////											}
//										} else
//										if (IdentifierIn.indexOf("|alboesperti|LC_TeachAsk|Curr|LC_TeachElementEdit|ElEdit|event_types|")>-1) 
//										{
//											if (SWTypeIn == "ComponentsBasic.ListTreeMenuElement")
//											{
//												if (eventIn.type=="mouseover")
//												{
//														ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
//													var managerElement 			= getParentSWByType(elementIn,"Components-ListRichChoiceManager");
//
//												//	var found_els 			= jQuery(managerElement).find(".ComponentsBasic-ListTreeMenuElement");
//														jQuery(managerElement).find(".ComponentsBasic-ListTreeMenuElement").removeClass("hovered");
//													 
//													 	jQuery(elementIn).addClass("hovered");
//												}
//												if (eventIn.type=="mousedown")
//												{
//													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
//													CAclient_StateIn 																		+= "GOSEQUENCEEND";
//												}
//											}
//										} else
										if (IdentifierIn.indexOf("|alboesperti|LC_Anagraphic|AnaForm|")>-1) 
										{
											if (SWTypeIn == "applicationModel.HTMLEnhancedTagExtension")
											{
												if (eventIn.type=="mousedown")
												{
													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
													CAclient_StateIn 																		+= "GOSEQUENCEEND";
												}
											}
										} else
										{
											
										}
//										if (IdentifierIn.indexOf('|alboesperti|LC_TeachAsk|Curr|LearningsInfo|TreeStructure|')>-1)
//										{
//											if (SWTypeIn=='applicationModel.HTMLEnhancedTagExtension')
//											{
//												if	((eventIn.type=="click")||(eventIn.type=="mousedown"))
//												{
//													if (elementIn.id.indexOf('TagExtension_folder_select')>0)
//													{
//														CAclient_StateIn 																	= "GOSEQUENCEENDFORCESENDDATA";
//													} else
//													if (elementIn.id.indexOf('TagExtension_more_teachs')>0)
//													{
//														CAclient_StateIn 																	+= "GOSEQUENCEEND";
//														ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
//													} else
//													if (elementIn.id.indexOf('TagExtension_edit_teachs')>0)
//													{
//														CAclient_StateIn 																	+= "GOSEQUENCEEND";
//														ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
//													} else
//													if (elementIn.id.indexOf('TagExtension_view_teachs')>0)
//													{
//														CAclient_StateIn 																	+= "GOSEQUENCEEND";
//														ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
//													}	
//												}			
//											} else
//											if (SWTypeIn=='ComponentsBasic.ListTreeMenuElement')
//											{
//												if(eventIn.type=="mouseover")
//												{
//
//												} else
//												if	((eventIn.type=="click")||(eventIn.type=="mousedown"))
//												{
//												var MODIFIER 																				= getValueByParName(MessageInVerified ,'MODIFIER');
//													//console_log("MODIFIER:"+MODIFIER);
//													if (MODIFIER=="NodeSelection")
//													{
//														//console_log("node selection...."+SWType);
//														//CAclient_State = "FORCESENDDATA GOSEQUENCEEND";
//														CAclient_StateIn 																	+= "GOSEQUENCEEND";
//														ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
//													} else
//													{
//														ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);
//															//sendData(IdentifierIn,element,SWType);
//														CAclient_StateIn 																	+= "GOSEQUENCEEND";
//													}
//												}
//											}
//										} else
//										if (IdentifierIn=="|alboesperti|LC_TeachAsk|Curr|CurrFList|")
//										{
//											if ((eventIn.type=="click")||(eventIn.type=="mousedown"))
//											{ 
//												if (jQuery(elementIn).hasClass('show_file'))
//												{//////////////////may be delete this usecase (embedded show tool)
//											var 	more_data_to_server_el 																			= document.getElementById("|concorsi|LC_concorso|ObjConcorso|ContainerWork|TagExtension_ShowMediaDataSender|MoreDataToServer|");
//											var 	file_bean 																						= jQuery(elementIn).attr('file_bean');
//											var 	myel 																							= document.getElementById("|concorsi|LC_concorso|ObjConcorso|ContainerWork|TagExtension_ShowMediaDataSender|DataIn|");
//													jQuery(myel).val(file_bean);
//		
//											var 	element_sender 																					= document.getElementById("|concorsi|LC_concorso|ObjConcorso|ContainerWork|TagExtension_ShowMediaDataSender|");
//													if (jQuery(elementIn).hasClass("show_file"))
//													{
//														jQuery(more_data_to_server_el).val("show_file");
//													} else
//													if (jQuery(elementIn).hasClass("link_file"))
//													{
//														jQuery(more_data_to_server_el).val("link_file");
//													}
//													CAclient('|alboesperti|LC_TeachAsk|Curr|CurrFList|',element_sender,eventIn,'applicationModel.HTMLEnhancedTagExtension','#@@PPFEEDBACKACTION@@# #@@VVSENDDATA@@# ',false);  		  
//												} else
//												if (jQuery(elementIn).hasClass('othertab_file'))
//												{
//												var file_bean 																				= jQuery(elementIn).attr('file_bean').split("|");
//												var fileServerIdentifier 																	= file_bean[1];
//												var outputFileName 																			= file_bean[0];
//												var Mypageobjtoken																			= $(document.body).attr('pageobjtoken');
//												var Mypagename																				= $(document.body).attr('pagename');
//												var SessionPageFullName																		= Mypageobjtoken+"_"+Mypagename;
//
//												var	data_pagechunk																			= 'sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+Mypagename;
//												// fileSource : DB,FS,ONTHEFLY
//												// fileServerIdentifier : Identifier Of file on Source. i.e. UUID code in DB list
//												var QueryString 																			= '?Identifier='+IdentifierIn+'&'+'fileServerIdentifier='+fileServerIdentifier+'&'+'outputFileName='+outputFileName+'&'+'fileSource=DB&'+data_pagechunk;
//													if (outputFileName.indexOf(".pdf")>-1)
//													{
//												var 	URL 																				= encodeURI("pdfviewer/viewer.html"+QueryString);
//														window.open(URL);
//													} else
//													{
//													var URL 																				= encodeURI("imageviewer/viewer.html"+QueryString);
//														window.open(URL);
//													}
//												}
//											}
//										} else
//										if (IdentifierIn=="|alboesperti|LC_TeachAsk|Curr|LC_TeachElementEdit|ElEdit|UFList|")
//										{
//											if ((eventIn.type=="click")||(eventIn.type=="mousedown"))
//											{ 
//												if (jQuery(elementIn).hasClass('show_file'))
//												{//////////////////may be delete this usecase (embedded show tool)
//											var 	more_data_to_server_el 																	= document.getElementById("|concorsi|LC_concorso|ObjConcorso|ContainerWork|TagExtension_ShowMediaDataSender|MoreDataToServer|");
//											var 	file_bean 																				= jQuery(elementIn).attr('file_bean');
//											var 	myel 																					= document.getElementById("|concorsi|LC_concorso|ObjConcorso|ContainerWork|TagExtension_ShowMediaDataSender|DataIn|");
//													jQuery(myel).val(file_bean);
//		
//											var 	element_sender 																			= document.getElementById("|concorsi|LC_concorso|ObjConcorso|ContainerWork|TagExtension_ShowMediaDataSender|");
//													if (jQuery(elementIn).hasClass("show_file"))
//													{
//														jQuery(more_data_to_server_el).val("show_file");
//													} else
//													if (jQuery(elementIn).hasClass("link_file"))
//													{
//														jQuery(more_data_to_server_el).val("link_file");
//													}
//													CAclient('|alboesperti|LC_TeachAsk|Curr|LC_TeachElementEdit|ElEdit|UFList|',element_sender,eventIn,'applicationModel.HTMLEnhancedTagExtension','#@@PPFEEDBACKACTION@@# #@@VVSENDDATA@@# ',false);  		  
//												} else
//												if (jQuery(elementIn).hasClass('othertab_file'))
//												{
//												var file_bean 																				= jQuery(elementIn).attr('file_bean').split("|");
//												var fileServerIdentifier 																	= file_bean[1];
//												var outputFileName 																			= file_bean[0];
//												//	alert('fileServerIdentifier:'+fileServerIdentifier+" outputFileName:"+outputFileName)
//												var Mypageobjtoken																			= $(document.body).attr('pageobjtoken');
//												var Mypagename																				= $(document.body).attr('pagename');
//												var SessionPageFullName																		= Mypageobjtoken+"_"+Mypagename;
//
//												var	data_pagechunk																			= 'sessionpagefullname='+SessionPageFullName+'&pageobjtoken='+Mypageobjtoken+'&pagename='+Mypagename;
//												// fileSource : DB,FS,ONTHEFLY
//												// fileServerIdentifier : Identifier Of file on Source. i.e. UUID code in DB list
//												var QueryString 																			= '?Identifier='+IdentifierIn+'&'+'fileServerIdentifier='+fileServerIdentifier+'&'+'outputFileName='+outputFileName+'&'+'fileSource=DB&'+data_pagechunk;
//													//var QueryString 					= '?Identifier=ddd&'+'fileServerIdentifier='+fileServerIdentifier+'&'+'outputFileName='+outputFileName+'&'+'fileSource=DB&'+data_pagechunk;
//													//alert('QueryString:'+QueryString);
//													//QueryString = replaceAll(QueryString,"\\|", "qqq" );
//													if (outputFileName.indexOf(".pdf")>-1)
//													{
//													var URL 																				= encodeURI("pdfviewer/viewer.html"+QueryString);
//														window.open(URL);
//													} else
//													{
//													var URL 																				= encodeURI("imageviewer/viewer.html"+QueryString);
//														window.open(URL);
//													}
//												}
//											}
//										} else
//										if (IdentifierIn.indexOf("|alboesperti|LC_TeachAsk|Curr|GeneralInfo|lprofile_types|")>-1)
//										{
//											//console_log("ffffffffffffffffff ...................");
//										var container_list 																					= document.getElementById("|alboesperti|LC_TeachAsk|Curr|GeneralInfo|lprofile_types|");
//											//jQuery(container_list).attr('formmore','|creaquake|PropertyContainer|PropertyCurrent|Work|DATA|ContainerCatasto|');
//											
//											if ((event.type=="mouseover"))
//											{
//												jQuery(container_list).find(".backgrounder").css("background-color","white")
//												jQuery(elementIn).find(".backgrounder").css("background-color","lightyellow")
//											}
//											
//											if ((eventIn.type=="mouseout"))
//											{
//												jQuery(container_list).find(".backgrounder").css("background-color","white")
//												
//											}
//											if	((eventIn.type=="click")||(event.type=="mousedown"))
//											{
//													CAclient_StateIn += "GOSEQUENCEEND";
//													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);;
//											}
//										} else
//										if (IdentifierIn.indexOf("|alboesperti|LC_TeachAsk|Curr|GeneralInfo|service_branch|")>-1)
//										{
//											//console_log("ffffffffffffffffff ...................");
//										var container_list 																					= document.getElementById("|alboesperti|LC_TeachAsk|Curr|GeneralInfo|service_branch|");
//											//jQuery(container_list).attr('formmore','|creaquake|PropertyContainer|PropertyCurrent|Work|DATA|ContainerCatasto|');
//											
//											if ((event.type=="mouseover"))
//											{
//												jQuery(container_list).find(".backgrounder").css("background-color","white")
//												jQuery(elementIn).find(".backgrounder").css("background-color","lightyellow")
//											}
//											
//											if ((eventIn.type=="mouseout"))
//											{
//												jQuery(container_list).find(".backgrounder").css("background-color","white")
//												
//											}
//											if	((eventIn.type=="click")||(event.type=="mousedown"))
//											{
//													CAclient_StateIn += "GOSEQUENCEEND";
//													ProcessEventTraversing (eventIn, eventIn.type, elementIn.tagName, !AllowBubblingIn);;
//											}
//										} else
//										else
//										{
//											//if	((eventIn.type=="click")||(eventIn.type=="mousedown")) {alert("U");}
//											//console_log("NOT MANAGED USECASE IdentifierIn------------------------------------"+IdentifierIn);
//										}

										//console_log(":::::::::::::: "+CAclient_StateIn);
										
										return CAclient_StateIn;
}//CAclientProcedure END

/*function checkCurriculumElementGoOn(IdentifierIn,TE_el_In)
{
	var 								SW_start_el 																						= document.getElementById(IdentifierIn+"TagExtension_ACTIVITY_start|DataIn|");
	var 								SW_end_el 																							= document.getElementById(IdentifierIn+"TagExtension_ACTIVITY_end|DataIn|");
										//console.log(jQuery(SW_start_el).inputmask('unmaskedvalue'));
											
										//var input = document.getElementById(selector);
										//	if (SW_start_el.inputmask)
										//	var SW_start_val=	SW_start_el.inputmask.unmaskedvalue();
										//	var unformattedDate = Inputmask.unmask(SW_start_val, { alias: "mm/yyyy"}); //23031973
var 									SW_start_val 																						= jQuery(SW_start_el).val();
var 									unformattedDate 																					= Inputmask.unmask(SW_start_val, {alias: "mm/yyyy", inputFormat: "mm/yyyy"}); //23031973
										console_log(">>>>>>>>>>>>>>>>>>>>>>____________________start:"+SW_start_val+"    unformattedDate:"+unformattedDate);
}
*/
function MainMenuHover(IdentifierIn,eventIn)
{
				var 					MySWEl 																								= document.getElementById(IdentifierIn);
				var 					MyMenuManagerSWEl 																					= jQuery(MySWEl).parentsUntil(".Components-MenuManager");
										jQuery(MyMenuManagerSWEl).find('.ComponentsBasic-ListTreeMenuElement').removeClass("unhovering");
										jQuery(MyMenuManagerSWEl).find('.ComponentsBasic-ListTreeMenuElement').removeClass("hovering");
										//console_log('eventIn.type:'+eventIn.type);
										if (eventIn.type=='mouseover') jQuery(MySWEl).addClass("hovering");
}

//function FunctMenuHover(IdentifierIn,eventIn)
//{
//				var 					MySWEl 																								= document.getElementById(IdentifierIn);
//				var 					MyMenuManagerSWEl 																					= jQuery(MySWEl).parentsUntil(".Components-MenuManager");
//										jQuery(MyMenuManagerSWEl).find('.ComponentsBasic-ListTreeMenuElement').removeClass("unhovering");
//										jQuery(MyMenuManagerSWEl).find('.ComponentsBasic-ListTreeMenuElement').removeClass("hovering");
//										//console_log('eventIn.type:'+eventIn.type);
//										if (eventIn.type=='mouseover') jQuery(MySWEl).addClass("hovering");
//}

function TeachAsk(elementIn)
{
				//alert("TeachAsk!!!!");
				var 					MySW 																								= getOwnerSW(elementIn);
				var 					myTE_UUID_id 																						= MySW.id+"TagExtension_submission_file_uuid|";
										//alert("myTE_UUID_id:"+myTE_UUID_id);
				var 					myTE_UUID 																							= document.getElementById(myTE_UUID_id);
				var 					myTE_UUID_datain_el 																				= document.getElementById(myTE_UUID.id+"DataIn|");
				var 					myTE_UUID_val 																						= jQuery(myTE_UUID_datain_el).val();
										managefileDownloadServletSubmit(MySW,myTE_UUID_val,'anteprima.pdf','DB');
										/*alert(" TeachAsk :"+elementIn.id+" MySW.id:"+MySW.id+"  myTE_UUID_datain_el:"+myTE_UUID_datain_el.id+"   >>>  "+jQuery(myTE_UUID_datain_el).val());*/
}

function setup_esperti_background()
{
	var 								authshield_bck_el = document.getElementById("|alboesperti|authshield|ContentArea|");	
	var 								myBckImg	= 								jQuery(authshield_bck_el).find("img")[0];
										//jQuery(myBckImg).attr("src","images/home_formazione.jpg?ff=ddd");

										jQuery(myBckImg).css("width","1250px");
										jQuery(myBckImg).css("height","820px");
										jQuery(myBckImg).css("left","0");
										jQuery(myBckImg).css("top","0");
										jQuery(myBckImg).css("width","0px");
										jQuery(myBckImg).css("height","0px");

}

function FunctMenuHover(IdentifierIn,eventIn)
{
				var 					MySWEl 																								= document.getElementById(IdentifierIn);
				var 					MyMenuManagerSWEl 																					= jQuery(MySWEl).parentsUntil(".Components-MenuManager");
										jQuery(MyMenuManagerSWEl).find('.ComponentsBasic-ListTreeMenuElement').removeClass("unhovering");
										jQuery(MyMenuManagerSWEl).find('.ComponentsBasic-ListTreeMenuElement').removeClass("hovering");
										//console_log('eventIn.type:'+eventIn.type);
										if (eventIn.type=='mouseover') jQuery(MySWEl).addClass("hovering");
}

function FunctMenuHoverGridEval(IdentifierIn,eventIn,elementIn)
{
				var 					MySWEl 																								= document.getElementById(IdentifierIn);
				var 					MyTEEl 																								= getTEOwner(elementIn);
				var 					MyMenuManagerSWEl 																					= jQuery(MySWEl).parentsUntil(".Components-Container");
										jQuery(MyMenuManagerSWEl).find('.IsTE').removeClass("unhovering");
										jQuery(MyMenuManagerSWEl).find('.IsTE').removeClass("hovering");
										//console_log('eventIn.type:'+eventIn.type+' IdentifierIn:'+IdentifierIn);
										if (eventIn.type=='mouseover') jQuery(MyTEEl).addClass("hovering");
//										jQuery(MySWEl).css("height","500px");
//										jQuery(MySWEl).find(".relative_stub").css("height","500px");
//										jQuery(MySWEl).find(".backgrounder").css("height","500px");
//										jQuery(MySWEl).find(".frame").css("height","500px");
//										jQuery(".id____concorsi__LC_submit__Curr__FunctMenu__").css("height","500px");
//										jQuery(".id____concorsi__LC_submit__Curr__FunctMenu__").find(".relative_stub").css("height","500px");
//										jQuery(".id____concorsi__LC_submit__Curr__FunctMenu__").find(".backgrounder").css("height","500px");
//										jQuery(".id____concorsi__LC_submit__Curr__FunctMenu__").find(".frame").css("height","500px");
//										
//										jQuery(".id____concorsi__LC_submit__Curr__CurrFList__").css("visibility","hidden");
//										jQuery(".id____concorsi__LC_submit__Curr__DDACurriculum__").css("visibility","hidden");
//										jQuery(".id____concorsi__LC_submit__Curr__Attach__").css("visibility","hidden");
//										
//										scrollManagement();
}
